function copyText(e) {
  $("#myInput").val(e);
  var t = document.getElementById("myInput");
  t.select(),
    t.setSelectionRange(0, 99999),
    document.execCommand("copy"),
    alert("Copied!");
}
(function () {
  var e =
      typeof globalThis < "u"
        ? globalThis
        : typeof self < "u"
        ? self
        : typeof window < "u"
        ? window
        : typeof global < "u"
        ? global
        : {},
    t = {},
    i = {},
    n = e.parcelRequire3852;
  n == null &&
    (((n = function (e2) {
      if (e2 in t) return t[e2].exports;
      if (e2 in i) {
        var n2 = i[e2];
        delete i[e2];
        var s2 = { id: e2, exports: {} };
        return (t[e2] = s2), n2.call(s2.exports, s2, s2.exports), s2.exports;
      }
      var a2 = new Error("Cannot find module '" + e2 + "'");
      throw ((a2.code = "MODULE_NOT_FOUND"), a2);
    }).register = function (e2, t2) {
      i[e2] = t2;
    }),
    (e.parcelRequire3852 = n)),
    n.register("gCGxJ", function (e2, t2) {
      var i2, n2;
      (n2 = (function (e3, t3, i3) {
        "use strict";
        var n3, s2;
        if (
          ((function () {
            var t4,
              i4 = {
                lazyClass: "lazyload",
                loadedClass: "lazyloaded",
                loadingClass: "lazyloading",
                preloadClass: "lazypreload",
                errorClass: "lazyerror",
                autosizesClass: "lazyautosizes",
                fastLoadedClass: "ls-is-cached",
                iframeLoadMode: 0,
                srcAttr: "data-src",
                srcsetAttr: "data-srcset",
                sizesAttr: "data-sizes",
                minSize: 40,
                customMedia: {},
                init: !0,
                expFactor: 1.5,
                hFac: 0.8,
                loadMode: 2,
                loadHidden: !0,
                ricTimeout: 0,
                throttleDelay: 125,
              };
            for (t4 in ((s2 = e3.lazySizesConfig || e3.lazysizesConfig || {}),
            i4))
              t4 in s2 || (s2[t4] = i4[t4]);
          })(),
          !t3 || !t3.getElementsByClassName)
        )
          return { init: function () {}, cfg: s2, noSupport: !0 };
        var a2,
          r2,
          o2,
          l2,
          c2,
          u2,
          d2,
          h2,
          p2,
          f2,
          v2,
          m2,
          g2,
          y2,
          b2,
          w2,
          S2,
          x2,
          C2,
          k2,
          E2,
          T2,
          _2,
          M2,
          L2,
          P2,
          I2,
          D2,
          A2,
          z2,
          O2,
          B2,
          N2,
          q2,
          $3,
          H2,
          F2,
          V2,
          R2,
          j2,
          X2,
          G2,
          W2,
          Y2,
          U2 = t3.documentElement,
          K2 = e3.HTMLPictureElement,
          Q2 = "addEventListener",
          Z2 = "getAttribute",
          J2 = e3[Q2].bind(e3),
          ee2 = e3.setTimeout,
          te2 = e3.requestAnimationFrame || ee2,
          ie2 = e3.requestIdleCallback,
          ne2 = /^picture$/i,
          se2 = ["load", "error", "lazyincluded", "_lazyloaded"],
          ae2 = {},
          re2 = Array.prototype.forEach,
          oe2 = function (e4, t4) {
            return (
              ae2[t4] || (ae2[t4] = new RegExp("(\\s|^)" + t4 + "(\\s|$)")),
              ae2[t4].test(e4[Z2]("class") || "") && ae2[t4]
            );
          },
          le2 = function (e4, t4) {
            oe2(e4, t4) ||
              e4.setAttribute(
                "class",
                (e4[Z2]("class") || "").trim() + " " + t4
              );
          },
          ce2 = function (e4, t4) {
            var i4;
            (i4 = oe2(e4, t4)) &&
              e4.setAttribute(
                "class",
                (e4[Z2]("class") || "").replace(i4, " ")
              );
          },
          ue2 = function (e4, t4, i4) {
            var n4 = i4 ? Q2 : "removeEventListener";
            i4 && ue2(e4, t4),
              se2.forEach(function (i5) {
                e4[n4](i5, t4);
              });
          },
          de2 = function (e4, i4, s3, a3, r3) {
            var o3 = t3.createEvent("Event");
            return (
              s3 || (s3 = {}),
              (s3.instance = n3),
              o3.initEvent(i4, !a3, !r3),
              (o3.detail = s3),
              e4.dispatchEvent(o3),
              o3
            );
          },
          he2 = function (t4, i4) {
            var n4;
            !K2 && (n4 = e3.picturefill || s2.pf)
              ? (i4 &&
                  i4.src &&
                  !t4[Z2]("srcset") &&
                  t4.setAttribute("srcset", i4.src),
                n4({ reevaluate: !0, elements: [t4] }))
              : i4 && i4.src && (t4.src = i4.src);
          },
          pe2 = function (e4, t4) {
            return (getComputedStyle(e4, null) || {})[t4];
          },
          fe2 = function (e4, t4, i4) {
            for (
              i4 = i4 || e4.offsetWidth;
              i4 < s2.minSize && t4 && !e4._lazysizesWidth;

            )
              (i4 = t4.offsetWidth), (t4 = t4.parentNode);
            return i4;
          },
          ve2 =
            ((X2 = []),
            (G2 = j2 = []),
            (W2 = function () {
              var e4 = G2;
              for (G2 = j2.length ? X2 : j2, V2 = !0, R2 = !1; e4.length; )
                e4.shift()();
              V2 = !1;
            }),
            (Y2 = function (e4, i4) {
              V2 && !i4
                ? e4.apply(this, arguments)
                : (G2.push(e4), R2 || ((R2 = !0), (t3.hidden ? ee2 : te2)(W2)));
            }),
            (Y2._lsFlush = W2),
            Y2),
          me2 = function (e4, t4) {
            return t4
              ? function () {
                  ve2(e4);
                }
              : function () {
                  var t5 = this,
                    i4 = arguments;
                  ve2(function () {
                    e4.apply(t5, i4);
                  });
                };
          },
          ge2 = function (e4) {
            var t4,
              n4,
              s3 = function () {
                (t4 = null), e4();
              },
              a3 = function () {
                var e5 = i3.now() - n4;
                e5 < 99 ? ee2(a3, 99 - e5) : (ie2 || s3)(s3);
              };
            return function () {
              (n4 = i3.now()), t4 || (t4 = ee2(a3, 99));
            };
          },
          ye2 =
            ((S2 = /^img$/i),
            (x2 = /^iframe$/i),
            (C2 =
              "onscroll" in e3 && !/(gle|ing)bot/.test(navigator.userAgent)),
            (k2 = 0),
            (E2 = 0),
            (T2 = -1),
            (_2 = function (e4) {
              E2--, (!e4 || E2 < 0 || !e4.target) && (E2 = 0);
            }),
            (M2 = function (e4) {
              return (
                w2 == null && (w2 = pe2(t3.body, "visibility") == "hidden"),
                w2 ||
                  !(
                    pe2(e4.parentNode, "visibility") == "hidden" &&
                    pe2(e4, "visibility") == "hidden"
                  )
              );
            }),
            (L2 = function (e4, i4) {
              var n4,
                s3 = e4,
                a3 = M2(e4);
              for (
                m2 -= i4, b2 += i4, g2 -= i4, y2 += i4;
                a3 && (s3 = s3.offsetParent) && s3 != t3.body && s3 != U2;

              )
                (a3 = (pe2(s3, "opacity") || 1) > 0) &&
                  pe2(s3, "overflow") != "visible" &&
                  ((n4 = s3.getBoundingClientRect()),
                  (a3 =
                    y2 > n4.left &&
                    g2 < n4.right &&
                    b2 > n4.top - 1 &&
                    m2 < n4.bottom + 1));
              return a3;
            }),
            (I2 = (function (e4) {
              var t4,
                n4 = 0,
                a3 = s2.throttleDelay,
                r3 = s2.ricTimeout,
                o3 = function () {
                  (t4 = !1), (n4 = i3.now()), e4();
                },
                l3 =
                  ie2 && r3 > 49
                    ? function () {
                        ie2(o3, { timeout: r3 }),
                          r3 !== s2.ricTimeout && (r3 = s2.ricTimeout);
                      }
                    : me2(function () {
                        ee2(o3);
                      }, !0);
              return function (e5) {
                var s3;
                (e5 = e5 === !0) && (r3 = 33),
                  t4 ||
                    ((t4 = !0),
                    (s3 = a3 - (i3.now() - n4)) < 0 && (s3 = 0),
                    e5 || s3 < 9 ? l3() : ee2(l3, s3));
              };
            })(
              (P2 = function () {
                var e4,
                  i4,
                  a3,
                  r3,
                  o3,
                  l3,
                  d3,
                  p3,
                  S3,
                  x3,
                  _3,
                  P3,
                  I3 = n3.elements;
                if ((h2 = s2.loadMode) && E2 < 8 && (e4 = I3.length)) {
                  for (i4 = 0, T2++; i4 < e4; i4++)
                    if (I3[i4] && !I3[i4]._lazyRace)
                      if (
                        !C2 ||
                        (n3.prematureUnveil && n3.prematureUnveil(I3[i4]))
                      )
                        q2(I3[i4]);
                      else if (
                        (((p3 = I3[i4][Z2]("data-expand")) && (l3 = 1 * p3)) ||
                          (l3 = k2),
                        x3 ||
                          ((x3 =
                            !s2.expand || s2.expand < 1
                              ? U2.clientHeight > 500 && U2.clientWidth > 500
                                ? 500
                                : 370
                              : s2.expand),
                          (n3._defEx = x3),
                          (_3 = x3 * s2.expFactor),
                          (P3 = s2.hFac),
                          (w2 = null),
                          k2 < _3 && E2 < 1 && T2 > 2 && h2 > 2 && !t3.hidden
                            ? ((k2 = _3), (T2 = 0))
                            : (k2 = h2 > 1 && T2 > 1 && E2 < 6 ? x3 : 0)),
                        S3 !== l3 &&
                          ((f2 = innerWidth + l3 * P3),
                          (v2 = innerHeight + l3),
                          (d3 = -1 * l3),
                          (S3 = l3)),
                        (a3 = I3[i4].getBoundingClientRect()),
                        (b2 = a3.bottom) >= d3 &&
                          (m2 = a3.top) <= v2 &&
                          (y2 = a3.right) >= d3 * P3 &&
                          (g2 = a3.left) <= f2 &&
                          (b2 || y2 || g2 || m2) &&
                          (s2.loadHidden || M2(I3[i4])) &&
                          ((u2 && E2 < 3 && !p3 && (h2 < 3 || T2 < 4)) ||
                            L2(I3[i4], l3)))
                      ) {
                        if ((q2(I3[i4]), (o3 = !0), E2 > 9)) break;
                      } else
                        !o3 &&
                          u2 &&
                          !r3 &&
                          E2 < 4 &&
                          T2 < 4 &&
                          h2 > 2 &&
                          (c2[0] || s2.preloadAfterLoad) &&
                          (c2[0] ||
                            (!p3 &&
                              (b2 ||
                                y2 ||
                                g2 ||
                                m2 ||
                                I3[i4][Z2](s2.sizesAttr) != "auto"))) &&
                          (r3 = c2[0] || I3[i4]);
                  r3 && !o3 && q2(r3);
                }
              })
            )),
            (A2 = me2(
              (D2 = function (e4) {
                var t4 = e4.target;
                t4._lazyCache
                  ? delete t4._lazyCache
                  : (_2(e4),
                    le2(t4, s2.loadedClass),
                    ce2(t4, s2.loadingClass),
                    ue2(t4, z2),
                    de2(t4, "lazyloaded"));
              })
            )),
            (z2 = function (e4) {
              A2({ target: e4.target });
            }),
            (O2 = function (e4, t4) {
              var i4 = e4.getAttribute("data-load-mode") || s2.iframeLoadMode;
              i4 == 0
                ? e4.contentWindow.location.replace(t4)
                : i4 == 1 && (e4.src = t4);
            }),
            (B2 = function (e4) {
              var t4,
                i4 = e4[Z2](s2.srcsetAttr);
              (t4 = s2.customMedia[e4[Z2]("data-media") || e4[Z2]("media")]) &&
                e4.setAttribute("media", t4),
                i4 && e4.setAttribute("srcset", i4);
            }),
            (N2 = me2(function (e4, t4, i4, n4, a3) {
              var r3, o3, l3, c3, u3, h3;
              (u3 = de2(e4, "lazybeforeunveil", t4)).defaultPrevented ||
                (n4 &&
                  (i4
                    ? le2(e4, s2.autosizesClass)
                    : e4.setAttribute("sizes", n4)),
                (o3 = e4[Z2](s2.srcsetAttr)),
                (r3 = e4[Z2](s2.srcAttr)),
                a3 &&
                  (c3 = (l3 = e4.parentNode) && ne2.test(l3.nodeName || "")),
                (h3 = t4.firesLoad || ("src" in e4 && (o3 || r3 || c3))),
                (u3 = { target: e4 }),
                le2(e4, s2.loadingClass),
                h3 && (clearTimeout(d2), (d2 = ee2(_2, 2500)), ue2(e4, z2, !0)),
                c3 && re2.call(l3.getElementsByTagName("source"), B2),
                o3
                  ? e4.setAttribute("srcset", o3)
                  : r3 &&
                    !c3 &&
                    (x2.test(e4.nodeName) ? O2(e4, r3) : (e4.src = r3)),
                a3 && (o3 || c3) && he2(e4, { src: r3 })),
                e4._lazyRace && delete e4._lazyRace,
                ce2(e4, s2.lazyClass),
                ve2(function () {
                  var t5 = e4.complete && e4.naturalWidth > 1;
                  (h3 && !t5) ||
                    (t5 && le2(e4, s2.fastLoadedClass),
                    D2(u3),
                    (e4._lazyCache = !0),
                    ee2(function () {
                      "_lazyCache" in e4 && delete e4._lazyCache;
                    }, 9)),
                    e4.loading == "lazy" && E2--;
                }, !0);
            })),
            (q2 = function (e4) {
              if (!e4._lazyRace) {
                var t4,
                  i4 = S2.test(e4.nodeName),
                  n4 = i4 && (e4[Z2](s2.sizesAttr) || e4[Z2]("sizes")),
                  a3 = n4 == "auto";
                ((!a3 && u2) ||
                  !i4 ||
                  (!e4[Z2]("src") && !e4.srcset) ||
                  e4.complete ||
                  oe2(e4, s2.errorClass) ||
                  !oe2(e4, s2.lazyClass)) &&
                  ((t4 = de2(e4, "lazyunveilread").detail),
                  a3 && be2.updateElem(e4, !0, e4.offsetWidth),
                  (e4._lazyRace = !0),
                  E2++,
                  N2(e4, t4, a3, n4, i4));
              }
            }),
            ($3 = ge2(function () {
              (s2.loadMode = 3), I2();
            })),
            (F2 = function () {
              u2 ||
                (i3.now() - p2 < 999
                  ? ee2(F2, 999)
                  : ((u2 = !0), (s2.loadMode = 3), I2(), J2("scroll", H2, !0)));
            }),
            {
              _: function () {
                (p2 = i3.now()),
                  (n3.elements = t3.getElementsByClassName(s2.lazyClass)),
                  (c2 = t3.getElementsByClassName(
                    s2.lazyClass + " " + s2.preloadClass
                  )),
                  J2("scroll", I2, !0),
                  J2("resize", I2, !0),
                  J2("pageshow", function (e4) {
                    if (e4.persisted) {
                      var i4 = t3.querySelectorAll("." + s2.loadingClass);
                      i4.length &&
                        i4.forEach &&
                        te2(function () {
                          i4.forEach(function (e5) {
                            e5.complete && q2(e5);
                          });
                        });
                    }
                  }),
                  e3.MutationObserver
                    ? new MutationObserver(I2).observe(U2, {
                        childList: !0,
                        subtree: !0,
                        attributes: !0,
                      })
                    : (U2[Q2]("DOMNodeInserted", I2, !0),
                      U2[Q2]("DOMAttrModified", I2, !0),
                      setInterval(I2, 999)),
                  J2("hashchange", I2, !0),
                  [
                    "focus",
                    "mouseover",
                    "click",
                    "load",
                    "transitionend",
                    "animationend",
                  ].forEach(function (e4) {
                    t3[Q2](e4, I2, !0);
                  }),
                  /d$|^c/.test(t3.readyState)
                    ? F2()
                    : (J2("load", F2),
                      t3[Q2]("DOMContentLoaded", I2),
                      ee2(F2, 2e4)),
                  n3.elements.length ? (P2(), ve2._lsFlush()) : I2();
              },
              checkElems: I2,
              unveil: q2,
              _aLSL: (H2 = function () {
                s2.loadMode == 3 && (s2.loadMode = 2), $3();
              }),
            }),
          be2 =
            ((r2 = me2(function (e4, t4, i4, n4) {
              var s3, a3, r3;
              if (
                ((e4._lazysizesWidth = n4),
                (n4 += "px"),
                e4.setAttribute("sizes", n4),
                ne2.test(t4.nodeName || ""))
              )
                for (
                  a3 = 0, r3 = (s3 = t4.getElementsByTagName("source")).length;
                  a3 < r3;
                  a3++
                )
                  s3[a3].setAttribute("sizes", n4);
              i4.detail.dataAttr || he2(e4, i4.detail);
            })),
            (o2 = function (e4, t4, i4) {
              var n4,
                s3 = e4.parentNode;
              s3 &&
                ((i4 = fe2(e4, s3, i4)),
                (n4 = de2(e4, "lazybeforesizes", { width: i4, dataAttr: !!t4 }))
                  .defaultPrevented ||
                  ((i4 = n4.detail.width) &&
                    i4 !== e4._lazysizesWidth &&
                    r2(e4, s3, n4, i4)));
            }),
            {
              _: function () {
                (a2 = t3.getElementsByClassName(s2.autosizesClass)),
                  J2("resize", l2);
              },
              checkElems: (l2 = ge2(function () {
                var e4,
                  t4 = a2.length;
                if (t4) for (e4 = 0; e4 < t4; e4++) o2(a2[e4]);
              })),
              updateElem: o2,
            }),
          we2 = function () {
            !we2.i &&
              t3.getElementsByClassName &&
              ((we2.i = !0), be2._(), ye2._());
          };
        return (
          ee2(function () {
            s2.init && we2();
          }),
          (n3 = {
            cfg: s2,
            autoSizer: be2,
            loader: ye2,
            init: we2,
            uP: he2,
            aC: le2,
            rC: ce2,
            hC: oe2,
            fire: de2,
            gW: fe2,
            rAF: ve2,
          })
        );
      })((i2 = typeof window < "u" ? window : {}), i2.document, Date)),
        (i2.lazySizes = n2),
        e2.exports && (e2.exports = n2);
    }),
    n("gCGxJ");
  var s = {};
  function a(e2, t2) {
    for (var i2 in t2) {
      var n2 = t2[i2];
      e2.addEventListener(i2, n2.listener || n2, n2.options || void 0);
    }
  }
  (function (e2, t2) {
    if (e2) {
      var i2 = function () {
        t2(e2.lazySizes), e2.removeEventListener("lazyunveilread", i2, !0);
      };
      (t2 = t2.bind(null, e2, e2.document)),
        s
          ? t2(n("gCGxJ"))
          : typeof define == "function" && define.amd
          ? define(["lazysizes"], t2)
          : e2.lazySizes
          ? i2()
          : e2.addEventListener("lazyunveilread", i2, !0);
    }
  })(typeof window < "u" ? window : 0, function (e2, t2, i2) {
    "use strict";
    if (e2.addEventListener) {
      var n2 = /\s+(\d+)(w|h)\s+(\d+)(w|h)/,
        s2 = /parent-fit["']*\s*:\s*["']*(contain|cover|width)/,
        a2 = /parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/,
        r2 = /^picture$/i,
        o2 = i2.cfg,
        l2 = {
          getParent: function (t3, i3) {
            var n3 = t3,
              s3 = t3.parentNode;
            return (
              (i3 && i3 != "prev") ||
                !s3 ||
                !r2.test(s3.nodeName || "") ||
                (s3 = s3.parentNode),
              i3 != "self" &&
                (n3 =
                  i3 == "prev"
                    ? t3.previousElementSibling
                    : (i3 &&
                        (s3.closest || e2.jQuery) &&
                        (s3.closest
                          ? s3.closest(i3)
                          : jQuery(s3).closest(i3)[0])) ||
                      s3),
              n3
            );
          },
          getFit: function (e3) {
            var t3,
              i3,
              n3 = getComputedStyle(e3, null) || {},
              r3 = n3.content || n3.fontFamily,
              o3 = {
                fit:
                  e3._lazysizesParentFit || e3.getAttribute("data-parent-fit"),
              };
            return (
              !o3.fit && r3 && (t3 = r3.match(s2)) && (o3.fit = t3[1]),
              o3.fit
                ? (!(i3 =
                    e3._lazysizesParentContainer ||
                    e3.getAttribute("data-parent-container")) &&
                    r3 &&
                    (t3 = r3.match(a2)) &&
                    (i3 = t3[1]),
                  (o3.parent = l2.getParent(e3, i3)))
                : (o3.fit = n3.objectFit),
              o3
            );
          },
          getImageRatio: function (t3) {
            var i3,
              s3,
              a3,
              l3,
              c2,
              u2,
              d2,
              h2 = t3.parentNode,
              p2 =
                h2 && r2.test(h2.nodeName || "")
                  ? h2.querySelectorAll("source, img")
                  : [t3];
            for (i3 = 0; i3 < p2.length; i3++)
              if (
                ((s3 =
                  (t3 = p2[i3]).getAttribute(o2.srcsetAttr) ||
                  t3.getAttribute("srcset") ||
                  t3.getAttribute("data-pfsrcset") ||
                  t3.getAttribute("data-risrcset") ||
                  ""),
                (a3 = t3._lsMedia || t3.getAttribute("media")),
                (a3 =
                  o2.customMedia[t3.getAttribute("data-media") || a3] || a3),
                s3 &&
                  (!a3 || ((e2.matchMedia && matchMedia(a3)) || {}).matches))
              ) {
                (l3 = parseFloat(t3.getAttribute("data-aspectratio"))) ||
                  ((c2 = s3.match(n2))
                    ? c2[2] == "w"
                      ? ((u2 = c2[1]), (d2 = c2[3]))
                      : ((u2 = c2[3]), (d2 = c2[1]))
                    : ((u2 = t3.getAttribute("width")),
                      (d2 = t3.getAttribute("height"))),
                  (l3 = u2 / d2));
                break;
              }
            return l3;
          },
          calculateSize: function (e3, t3) {
            var i3,
              n3,
              s3,
              a3 = this.getFit(e3),
              r3 = a3.fit,
              o3 = a3.parent;
            return r3 == "width" ||
              ((r3 == "contain" || r3 == "cover") &&
                (n3 = this.getImageRatio(e3)))
              ? (o3 ? (t3 = o3.clientWidth) : (o3 = e3),
                (s3 = t3),
                r3 == "width"
                  ? (s3 = t3)
                  : (i3 = t3 / o3.clientHeight) &&
                    ((r3 == "cover" && i3 < n3) ||
                      (r3 == "contain" && i3 > n3)) &&
                    (s3 = t3 * (n3 / i3)),
                s3)
              : t3;
          },
        };
      (i2.parentFit = l2),
        t2.addEventListener("lazybeforesizes", function (e3) {
          if (!e3.defaultPrevented && e3.detail.instance == i2) {
            var t3 = e3.target;
            e3.detail.width = l2.calculateSize(t3, e3.detail.width);
          }
        });
    }
  });
  var r =
      "IntersectionObserver" in window &&
      "IntersectionObserverEntry" in window &&
      "intersectionRatio" in window.IntersectionObserverEntry.prototype,
    o = /baidu|(?:google|bing|yandex|duckduck)bot/i.test(navigator.userAgent),
    l = ["src", "poster"];
  function c(e2, t2) {
    var i2 = !0,
      n2 = !1,
      s2 = void 0;
    try {
      for (
        var a2, r2 = l[Symbol.iterator]();
        !(i2 = (a2 = r2.next()).done);
        i2 = !0
      ) {
        var o2 = a2.value;
        o2 in e2.dataset &&
          (e2.setAttribute(o2, e2.dataset[o2]),
          e2.classList.contains(t2) && e2.classList.remove(t2));
      }
    } catch (e3) {
      (n2 = !0), (s2 = e3);
    } finally {
      try {
        i2 || r2.return == null || r2.return();
      } finally {
        if (n2) throw s2;
      }
    }
  }
  function u(e2, t2, i2, n2) {
    if (e2.nodeName == "VIDEO") {
      var s2 = Array.from(e2.querySelectorAll("source")),
        a2 = !0,
        r2 = !1,
        o2 = void 0;
      try {
        for (
          var l2, u2 = s2[Symbol.iterator]();
          !(a2 = (l2 = u2.next()).done);
          a2 = !0
        )
          c(l2.value, t2);
      } catch (e3) {
        (r2 = !0), (o2 = e3);
      } finally {
        try {
          a2 || u2.return == null || u2.return();
        } finally {
          if (r2) throw o2;
        }
      }
      e2.load();
    }
    c(e2, t2);
    var d2 = e2.classList;
    d2.contains(i2) && (d2.remove(i2), d2.add(n2));
  }
  function d(e2, t2) {
    if (!(e2 instanceof t2))
      throw new TypeError("Cannot call a class as a function");
  }
  function h(e2, t2) {
    for (var i2 = 0; i2 < t2.length; i2++) {
      var n2 = t2[i2];
      (n2.enumerable = n2.enumerable || !1),
        (n2.configurable = !0),
        "value" in n2 && (n2.writable = !0),
        Object.defineProperty(e2, n2.key, n2);
    }
  }
  function p(e2, t2, i2) {
    return t2 && h(e2.prototype, t2), i2 && h(e2, i2), e2;
  }
  function f(e2, t2, i2) {
    return (
      t2 in e2
        ? Object.defineProperty(e2, t2, {
            value: i2,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e2[t2] = i2),
      e2
    );
  }
  function v(e2) {
    for (var t2 = 1; t2 < arguments.length; t2++) {
      var i2 = arguments[t2] != null ? arguments[t2] : {},
        n2 = Object.keys(i2);
      typeof Object.getOwnPropertySymbols == "function" &&
        (n2 = n2.concat(
          Object.getOwnPropertySymbols(i2).filter(function (e3) {
            return Object.getOwnPropertyDescriptor(i2, e3).enumerable;
          })
        )),
        n2.forEach(function (t3) {
          f(e2, t3, i2[t3]);
        });
    }
    return e2;
  }
  function m(e2, t2) {
    (t2 == null || t2 > e2.length) && (t2 = e2.length);
    for (var i2 = 0, n2 = new Array(t2); i2 < t2; i2++) n2[i2] = e2[i2];
    return n2;
  }
  function g(e2) {
    if (
      (typeof Symbol < "u" && e2[Symbol.iterator] != null) ||
      e2["@@iterator"] != null
    )
      return Array.from(e2);
  }
  function y(e2, t2) {
    if (e2) {
      if (typeof e2 == "string") return m(e2, t2);
      var i2 = Object.prototype.toString.call(e2).slice(8, -1);
      return (
        i2 === "Object" && e2.constructor && (i2 = e2.constructor.name),
        i2 === "Map" || i2 === "Set"
          ? Array.from(i2)
          : i2 === "Arguments" ||
            /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i2)
          ? m(e2, t2)
          : void 0
      );
    }
  }
  function b(e2) {
    return (
      (function (e3) {
        if (Array.isArray(e3)) return m(e3);
      })(e2) ||
      g(e2) ||
      y(e2) ||
      (function () {
        throw new TypeError(
          "Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
        );
      })()
    );
  }
  var w = (function () {
      "use strict";
      function e2(t2) {
        d(this, e2), (this._notification = t2);
      }
      return (
        p(e2, [
          {
            key: "show",
            value: function (e3, t2) {
              this._notification.show(e3, t2);
            },
          },
        ]),
        e2
      );
    })(),
    S = new ((function () {
      "use strict";
      function e2() {
        var t2 = this;
        d(this, e2),
          f(this, "_handleWindowScroll", function () {
            t2._timeoutScrollId &&
              (clearTimeout(t2._timeoutScrollId), (t2.isScrolling = !0)),
              (t2._timeoutScrollId = setTimeout(function () {
                t2.isScrolling = !1;
              }, 300));
          });
        var i2 = document.querySelector("#GlobalNotification");
        i2 && (this.notification = new w(i2)),
          (this.isScrolling = !1),
          (this.overlaySelector = "#BodyOverlay"),
          window.addEventListener("wheel", this._handleWindowScroll),
          (this.overlayCalls = []);
      }
      return (
        p(e2, [
          {
            key: "showOverlay",
            value: function (e3, t2) {
              var i2 = document.querySelector(this.overlaySelector);
              i2 &&
                ((this.overlayCalls = b(this.overlayCalls).concat([
                  { key: e3, styles: t2 },
                ])),
                this.setBodyOverlayStyles(
                  v(
                    {},
                    { zIndex: 3, backgroundColor: "var(--gsc-black-color-50)" },
                    t2
                  )
                ),
                i2.setAttribute("visible", ""),
                this.setScrollLock());
            },
          },
          {
            key: "hideOverlay",
            value: function (e3) {
              var t2 = document.querySelector(this.overlaySelector);
              if (t2 && t2.hasAttribute("visible")) {
                this.overlayCalls = this.overlayCalls.filter(function (t3) {
                  return t3.key !== e3;
                });
                var i2 = this.overlayCalls[this.overlayCalls.length - 1];
                i2
                  ? this.setBodyOverlayStyles(i2.styles)
                  : (t2.removeAttribute("visible"),
                    t2.setAttribute("style", ""),
                    this.unsetScrollLock());
              }
            },
          },
          {
            key: "setScrollLock",
            value: function () {
              (document.body.style.top = "-".concat(
                window.scrollY ||
                  Math.abs(parseInt(document.body.style.top || "0")),
                "px"
              )),
                document.body.setAttribute("scroll-y-off", "");
            },
          },
          {
            key: "unsetScrollLock",
            value: function () {
              var e3 = document.body.style.top;
              document.body.removeAttribute("scroll-y-off"),
                (document.body.style.top = ""),
                window.scrollTo(0, -1 * parseInt(e3 || "0"));
            },
          },
          {
            key: "setBodyOverlayStyles",
            value: function (e3) {
              var t2 = document.querySelector(this.overlaySelector);
              t2 &&
                e3 &&
                Object.keys(e3).forEach(function (i2) {
                  t2.style[i2] = e3[i2];
                });
            },
          },
        ]),
        e2
      );
    })())();
  function x(e2) {
    if (e2 === void 0)
      throw new ReferenceError(
        "this hasn't been initialised - super() hasn't been called"
      );
    return e2;
  }
  function C(e2, t2) {
    return (
      (C =
        Object.setPrototypeOf ||
        function (e3, t3) {
          return (e3.__proto__ = t3), e3;
        }),
      C(e2, t2)
    );
  }
  function k(e2, t2) {
    return C(e2, t2);
  }
  function E(e2, t2) {
    if (typeof t2 != "function" && t2 !== null)
      throw new TypeError("Super expression must either be null or a function");
    (e2.prototype = Object.create(t2 && t2.prototype, {
      constructor: { value: e2, writable: !0, configurable: !0 },
    })),
      t2 && k(e2, t2);
  }
  function T(e2) {
    return (
      (T = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (e3) {
            return e3.__proto__ || Object.getPrototypeOf(e3);
          }),
      T(e2)
    );
  }
  function _(e2) {
    return T(e2);
  }
  function M(e2, t2) {
    return !t2 ||
      ((function (e3) {
        return e3 && e3.constructor === Symbol ? "symbol" : typeof e3;
      })(t2) !== "object" &&
        typeof t2 != "function")
      ? x(e2)
      : t2;
  }
  function L(e2) {
    var t2 = (function () {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return (
          Boolean.prototype.valueOf.call(
            Reflect.construct(Boolean, [], function () {})
          ),
          !0
        );
      } catch {
        return !1;
      }
    })();
    return function () {
      var i2,
        n2 = _(e2);
      if (t2) {
        var s2 = _(this).constructor;
        i2 = Reflect.construct(n2, arguments, s2);
      } else i2 = n2.apply(this, arguments);
      return M(this, i2);
    };
  }
  function P(e2, t2, i2) {
    return (
      (P = (function () {
        if (
          typeof Reflect > "u" ||
          !Reflect.construct ||
          Reflect.construct.sham
        )
          return !1;
        if (typeof Proxy == "function") return !0;
        try {
          return (
            Date.prototype.toString.call(
              Reflect.construct(Date, [], function () {})
            ),
            !0
          );
        } catch {
          return !1;
        }
      })()
        ? Reflect.construct
        : function (e3, t3, i3) {
            var n2 = [null];
            n2.push.apply(n2, t3);
            var s2 = new (Function.bind.apply(e3, n2))();
            return i3 && k(s2, i3.prototype), s2;
          }),
      P.apply(null, arguments)
    );
  }
  function I(e2) {
    var t2 = typeof Map == "function" ? new Map() : void 0;
    return (
      (I = function (e3) {
        if (
          e3 === null ||
          ((i2 = e3),
          Function.toString.call(i2).indexOf("[native code]") === -1)
        )
          return e3;
        var i2;
        if (typeof e3 != "function")
          throw new TypeError(
            "Super expression must either be null or a function"
          );
        if (t2 !== void 0) {
          if (t2.has(e3)) return t2.get(e3);
          t2.set(e3, n2);
        }
        function n2() {
          return (function (e4, t3, i3) {
            return P.apply(null, arguments);
          })(e3, arguments, _(this).constructor);
        }
        return (
          (n2.prototype = Object.create(e3.prototype, {
            constructor: {
              value: n2,
              enumerable: !1,
              writable: !0,
              configurable: !0,
            },
          })),
          k(n2, e3)
        );
      }),
      I(e2)
    );
  }
  function D(e2) {
    return I(e2);
  }
  var A = {
      SECTION_LOAD: "shopify:section:load",
      SECTION_UNLOAD: "shopify:section:unload",
      SECTION_SELECT: "shopify:section:select",
      SECTION_DESELECT: "shopify:section:deselect",
      SECTION_REORDER: "shopify:section:reorder",
      BLOCK_SELECT: "shopify:block:select",
      BLOCK_DESELECT: "shopify:block:deselect",
    },
    z = "ArrowLeft",
    O = "ArrowRight",
    B = 37,
    N = 39,
    q = "Enter",
    $2 = 13,
    H = "Escape",
    F = 27,
    V = function (e2) {
      return new Promise(function (t2, i2) {
        setTimeout(t2, e2);
      });
    },
    R = function (e2, t2, i2, n2) {
      i2 && e2 && t2 && e2["".concat(n2, "EventListener")](t2, i2);
    },
    j = function (e2, t2, i2) {
      R(e2, t2, i2, "add");
    },
    X = function (e2, t2, i2) {
      R(e2, t2, i2, "remove");
    },
    G = new IntersectionObserver(function (e2, t2) {
      e2.forEach(function (e3) {
        var t3 = e3.isIntersecting,
          i2 = e3.target.closest('[aria-hidden="true"], .hidden');
        e3.target.toggleAttribute("data-is-in-viewport", t3 && !i2);
      });
    }),
    W = function () {
      return ["button", "[href]", "[data-focus-trap-target]", "a", "[tabindex]"]
        .map(function (e2) {
          return "".concat(
            e2,
            ':not([tabindex="-1"]):not([data-color-swatches-hidden-count]:empty)'
          );
        })
        .join(",");
    },
    Y = function (e2) {
      var t2 = document.createElement("div");
      return (
        t2.classList.add("hidden"),
        document.body.appendChild(t2),
        t2.appendChild(e2),
        t2
      );
    },
    U = function (e2) {
      e2.remove();
    },
    K = function (e2) {
      return e2 === $2 || e2 === q;
    },
    Q = function (e2) {
      return e2 === N || e2 === O;
    },
    Z = function (e2) {
      return e2 === B || e2 === z;
    },
    J = (function () {
      "use strict";
      function e2() {
        d(this, e2), (this._listeners = {});
      }
      return (
        p(e2, [
          {
            key: "subscribe",
            value: function (e3, t2) {
              this._listeners[e3] || (this._listeners[e3] = []),
                j(document, A[e3], t2),
                this._listeners[e3].push(t2);
            },
          },
          {
            key: "unsubscribe",
            value: function (e3, t2) {
              this._listeners[e3] &&
                (X(document, A[e3], t2),
                (this._listeners[e3] = this._listeners[e3].filter(function (
                  e4
                ) {
                  return e4 !== t2;
                })));
            },
          },
          {
            key: "destroy",
            value: function () {
              var e3 = this;
              Object.keys(this._listeners).forEach(function (t2) {
                e3._listeners[t2].forEach(function (i2) {
                  e3.unsubscribe(t2, i2);
                });
              }),
                (this._listeners = {});
            },
          },
        ]),
        e2
      );
    })(),
    ee = window.Shopify,
    te = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          ((e3 = t2.call(this))._editor = new J()),
          (e3._isEditorMode = ee.designMode),
          (e3._listeners = {}),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "subscribe",
            value: function (e3, t3) {
              this._listeners[e3] || (this._listeners[e3] = []),
                this._listeners[e3].push(t3);
            },
          },
          {
            key: "unsubscribe",
            value: function (e3, t3) {
              this._listeners[e3] &&
                (this._listeners[e3] = this._listeners[e3].filter(function (
                  e4
                ) {
                  return e4 !== t3;
                }));
            },
          },
          {
            key: "emit",
            value: function (e3, t3) {
              this._listeners[e3] &&
                this._listeners[e3].forEach(function (e4) {
                  return e4(t3);
                });
            },
          },
        ]),
        i2
      );
    })(D(HTMLElement)),
    ie = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "_handleClick", function (t3) {
            var i3 = t3.target;
            if (i3.hasAttribute("data-login-form-button")) {
              var n2 = i3.dataset.loginFormId || "";
              e3.setFormVisibleById(n2), e3.updateFocus();
            }
          }),
          (e3.forms = b(e3.querySelectorAll("[data-login-form]"))),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              this.updateFocus(),
                this.addEventListener("click", this._handleClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeEventListener("click", this._handleClick);
            },
          },
          {
            key: "setFormVisibleById",
            value: function (e3) {
              this.forms.forEach(function (t3) {
                var i3 = t3.getAttribute("data-login-form") === e3;
                t3.classList.toggle("hidden", !i3);
              });
            },
          },
          {
            key: "updateFocus",
            value: function () {
              this.forms.forEach(function (e3) {
                var t3 = e3.classList.contains("hidden"),
                  i3 = e3.querySelector('[type="email"]');
                !t3 && i3 && i3.focus();
              });
            },
          },
        ]),
        i2
      );
    })(te),
    ne = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "_handleWindowScroll", function () {
            e3.updateButtonVisible();
          }),
          f(x(e3), "_handleButtonClick", function () {
            e3.scrollToTop();
          }),
          (e3.button = e3.querySelector("[data-back-to-top-button]")),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              this.button &&
                this.button.addEventListener("click", this._handleButtonClick),
                window.addEventListener("scroll", this._handleWindowScroll);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.button &&
                this.button.removeEventListener(
                  "click",
                  this._handleButtonClick
                ),
                window.removeEventListener("scroll", this._handleWindowScroll);
            },
          },
          {
            key: "updateButtonVisible",
            value: function () {
              if (this.button) {
                var e3 = window.scrollY > window.innerHeight;
                this.button.toggleAttribute("visible", e3);
              }
            },
          },
          {
            key: "scrollToTop",
            value: function () {
              window.scrollTo({ top: 0, behavior: "smooth" });
            },
          },
        ]),
        i2
      );
    })(D(HTMLElement)),
    se = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "_handleWindowScroll", function () {
            var t3 = document.querySelector(
              ".shopify-section.shopify-section-header"
            );
            if (t3 && e3.button) {
              var i3 =
                t3.getBoundingClientRect().bottom + e3.button.offsetHeight < 0;
              e3.button.toggleAttribute("visible", i3);
            }
          }),
          (e3.button = e3.querySelector("[data-cart-sticky-button]")),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              window.addEventListener("scroll", this._handleWindowScroll);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              window.removeEventListener("scroll", this._handleWindowScroll);
            },
          },
        ]),
        i2
      );
    })(D(HTMLElement)),
    ae = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "_handleBlur", function (t3) {
            if (e3.input) {
              var i3 = t3.target.value || "0";
              (e3.input.value = i3),
                e3._updateButtonsDisabled(),
                (e3._prevValue = i3);
            }
          }),
          f(x(e3), "_handleKeydown", function (t3) {
            e3.input &&
              K(t3.key || t3.keyCode) &&
              (t3.preventDefault(), e3.input.blur());
          }),
          f(x(e3), "_handleInput", function (t3) {
            if (e3.input) {
              var i3 = t3.target.value;
              (e3.input.value = e3._isMoreThanStock ? e3._stockValue : i3),
                e3._updateButtonsDisabled(),
                (e3._prevValue = i3);
            }
          }),
          (e3.inputSelector = "[data-quantity-input]"),
          (e3.input = e3.querySelector(e3.inputSelector)),
          (e3._prevValue = e3._value),
          (e3._stockValue = e3.dataset.stock || "0"),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              this._updateButtonsDisabled(),
                j(this.input, "keypress", this._handleKeydown),
                j(this.input, "input", this._handleInput),
                j(this.input, "blur", this._handleBlur);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              X(this.input, "keypress", this._handleKeydown),
                X(this.input, "input", this._handleInput),
                X(this.input, "blur", this._handleBlur);
            },
          },
          {
            key: "inputChange",
            value: function (e3) {
              this.input &&
                (e3 === "minus" ? this.input.stepDown() : this.input.stepUp(),
                +this._prevValue != +this._value &&
                  this.input.dispatchEvent(
                    new Event("change", { bubbles: !0 })
                  ),
                this._updateButtonsDisabled());
            },
          },
          {
            key: "_updateButtonsDisabled",
            value: function () {
              this._updateButtonDisabled("minus", this._isLessThanMin),
                this._updateButtonDisabled("plus", this._isMoreThanStock);
            },
          },
          {
            key: "setDisable",
            value: function (e3) {
              this._updateButtonDisabled("minus", e3),
                this._updateButtonDisabled("plus", e3);
            },
          },
          {
            key: "_updateButtonDisabled",
            value: function (e3, t3) {
              var i3 = this.querySelector(
                'quantity-btn[data-action="'.concat(e3, '"]')
              );
              i3 && i3.toggleAttribute("disabled", t3);
            },
          },
          {
            key: "_value",
            get: function () {
              return this.input ? this.input.value : "0";
            },
          },
          {
            key: "_isLessThanMin",
            get: function () {
              return !!this.input && +this._value <= +this.input.min;
            },
          },
          {
            key: "_isMoreThanStock",
            get: function () {
              return +this._value >= +this._stockValue;
            },
          },
        ]),
        i2
      );
    })(te),
    re = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "_handleButtonClick", function (t3) {
            t3.preventDefault(), e3.update();
          }),
          f(x(e3), "_handleKeyDown", function (t3) {
            var i3 = K(t3.key || t3.keyCode),
              n2 = t3.target;
            i3 &&
              !n2.hasAttribute("disabled") &&
              (t3.preventDefault(), e3.update());
          }),
          (e3._quantity = e3.closest("quantity-component")),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              this.addEventListener("click", this._handleButtonClick),
                this.addEventListener("keydown", this._handleKeyDown);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeEventListener("click", this._handleButtonClick),
                this.removeEventListener("keydown", this._handleKeyDown);
            },
          },
          {
            key: "update",
            value: function () {
              var e3 = this.dataset.action;
              this._quantity &&
                e3 &&
                (this._quantity.inputChange(e3),
                e3 === "minus" && this._setDisabled());
            },
          },
          {
            key: "_setDisabled",
            value: function () {
              if (this._quantity && this._quantity.input) {
                var e3 = this._quantity.input.value === "1";
                this.toggleAttribute("disabled", e3);
              }
            },
          },
        ]),
        i2
      );
    })(te),
    oe = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "_handleClick", function (t3) {
            t3.preventDefault();
            var i3 = t3.target;
            i3.hasAttribute("data-localization-item") &&
              e3.input &&
              e3.form &&
              i3.dataset.value &&
              ((e3.input.value = i3.dataset.value), e3.form.submit());
          }),
          (e3.inputSelector = "[data-localization-input]"),
          (e3.formSelector = "form"),
          (e3.input = e3.querySelector(e3.inputSelector)),
          (e3.form = e3.querySelector(e3.formSelector)),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              j(this, "click", this._handleClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              X(this, "click", this._handleClick);
            },
          },
        ]),
        i2
      );
    })(te),
    le = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "_handleCloseButtonClick", function () {
            e3.hide();
          }),
          (e3._closeBtnSelector = "[data-notification-close-button]"),
          (e3._alertSelector = "[data-notification-alert]"),
          (e3._alertTextSelector = "[data-notification-alert-text]"),
          (e3._closeBtn = e3.querySelector(e3._closeBtnSelector)),
          (e3._alert = e3.querySelector(e3._alertSelector)),
          (e3._alertText = e3.querySelector(e3._alertTextSelector)),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              this._closeBtn &&
                this._closeBtn.addEventListener(
                  "click",
                  this._handleCloseButtonClick
                );
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this._closeBtn &&
                this._closeBtn.removeEventListener(
                  "click",
                  this._handleCloseButtonClick
                );
            },
          },
          {
            key: "show",
            value: function (e3, t3) {
              var i3 = this;
              this._setAlert(e3, t3 || "warning"),
                this.showTimeoutId && clearTimeout(this.showTimeoutId),
                this._setVisible(!0),
                (this.showTimeoutId = setTimeout(function () {
                  i3._setVisible(!1);
                }, 3e3));
            },
          },
          {
            key: "hide",
            value: function () {
              this._setVisible(!1);
            },
          },
          {
            key: "_setVisible",
            value: function (e3) {
              this.toggleAttribute("open", e3);
            },
          },
          {
            key: "_setAlert",
            value: function (e3, t3) {
              this._alert &&
                this._alertText &&
                (this._alert.setAttribute("alert-type", t3),
                (this._alertText.innerHTML = e3));
            },
          },
        ]),
        i2
      );
    })(te);
  function ce(e2, t2) {
    return (
      (t2 = t2 ?? {}),
      Object.getOwnPropertyDescriptors
        ? Object.defineProperties(e2, Object.getOwnPropertyDescriptors(t2))
        : (function (e3, t3) {
            var i2 = Object.keys(e3);
            if (Object.getOwnPropertySymbols) {
              var n2 = Object.getOwnPropertySymbols(e3);
              i2.push.apply(i2, n2);
            }
            return i2;
          })(Object(t2)).forEach(function (i2) {
            Object.defineProperty(
              e2,
              i2,
              Object.getOwnPropertyDescriptor(t2, i2)
            );
          }),
      e2
    );
  }
  var ue = (function () {
      "use strict";
      function e2(t2) {
        d(this, e2), (this.element = t2);
      }
      return (
        p(e2, [
          {
            key: "update",
            value: function (e3) {
              var t2 = e3 === this.element.getAttribute("data-id");
              this.element.classList.toggle("selected", t2);
            },
          },
        ]),
        e2
      );
    })(),
    de = function (e2) {
      e2 && e2.classList.remove("hidden");
    },
    he = function (e2) {
      e2 && e2.classList.add("hidden");
    },
    pe = function (e2, t2) {
      return getComputedStyle(e2)[t2];
    },
    fe = function (e2) {
      return e2.content.cloneNode(!0);
    },
    ve = function (e2) {
      return e2.content.firstElementChild.cloneNode(!0);
    },
    me = function (e2, t2) {
      e2 && e2.classList.toggle("forward-transition", t2);
    },
    ge = function (e2) {
      return new DOMParser().parseFromString(e2, "text/html");
    },
    ye = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "_handleTabNameClick", function (t3) {
            t3.preventDefault();
            var i3 = t3.target;
            i3.dataset.id && e3.selectTab(i3.dataset.id);
          }),
          f(x(e3), "_handleKeyDown", function (t3) {
            var i3 = t3.target;
            i3.dataset.id &&
              K(t3.key || t3.keyCode) &&
              (t3.preventDefault(), e3.selectTab(i3.dataset.id));
          }),
          (e3.containerSelector = "[data-tabs-container]"),
          (e3.templateSelector = "[data-tabs-elements-template]"),
          (e3.tabSelector = "tab-component"),
          (e3.tabNameSelector = "[data-tabs-name]"),
          (e3.container = e3.querySelector(e3.containerSelector)),
          (e3.template = e3.querySelector(e3.templateSelector)),
          (e3.templateContent = fe(e3.template)),
          (e3.tabNames = b(e3.querySelectorAll(e3.tabNameSelector))),
          (e3.tabMap = e3.generateTabMap()),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              var e3 = this;
              this.tabNames.forEach(function (t3) {
                t3.addEventListener("keydown", e3._handleKeyDown),
                  t3.addEventListener("click", e3._handleTabNameClick);
              });
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              var e3 = this;
              this.tabNames.forEach(function (t3) {
                t3.removeEventListener("keydown", e3._handleKeyDown),
                  t3.removeEventListener("click", e3._handleTabNameClick);
              });
            },
          },
          {
            key: "generateTabMap",
            value: function () {
              return [this.querySelector(this.tabSelector)]
                .concat(
                  b(this.templateContent.querySelectorAll(this.tabSelector))
                )
                .reduce(function (e3, t3) {
                  var i3 = t3.dataset.id;
                  return i3 ? ce(v({}, e3), f({}, i3, t3)) : e3;
                }, {});
            },
          },
          {
            key: "selectTab",
            value: function (e3) {
              this._updateNameById(e3),
                this._setTabById(e3),
                this.emit("selectTab", e3);
            },
          },
          {
            key: "_unmountTab",
            value: function (e3) {
              e3.remove();
            },
          },
          {
            key: "_mountTab",
            value: function (e3) {
              this.container && this.container.appendChild(e3);
            },
          },
          {
            key: "_updateNameById",
            value: function (e3) {
              this.tabNames.forEach(function (t3) {
                new ue(t3).update(e3);
              });
            },
          },
          {
            key: "_setTabById",
            value: function (e3) {
              var t3 = this.tabMap[e3],
                i3 = this.tabMap[this.dataset.selectedTabId];
              i3 &&
                t3 &&
                (this.showNextTab(t3), i3 !== t3 && this.hideCurrentTab(i3));
            },
          },
          {
            key: "showNextTab",
            value: function (e3) {
              var t3 = e3.getAttribute("data-id");
              t3 &&
                (this._mountTab(e3),
                e3.show(),
                (this.dataset.selectedTabId = t3));
            },
          },
          {
            key: "hideCurrentTab",
            value: function (e3) {
              var t3 = this;
              e3.hide().then(function () {
                t3._unmountTab(e3);
              });
            },
          },
        ]),
        i2
      );
    })(te),
    be = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "collapse", function () {
            e3._hideItems(), he(e3._collapseBtn), de(e3._expandBtn);
          }),
          f(x(e3), "expand", function () {
            e3._initialHeight || e3._setInitialHeight(),
              e3._showItems(),
              e3._tryHideExpandBtn(),
              de(e3._collapseBtn),
              e3._setMaxHeight();
          }),
          (e3.itemSelector = "[data-list-item]"),
          (e3.expandBtnSelector = 'list-btn[data-trigger="expand"]'),
          (e3.collapseBtnSelector = 'list-btn[data-trigger="collapse"]'),
          (e3.visibleItemSelector = "".concat(
            e3.itemSelector,
            ":not(.hidden)"
          )),
          (e3.hiddenItemSelector = "".concat(e3.itemSelector, ".hidden")),
          (e3._expandBtn = e3.querySelector(e3.expandBtnSelector)),
          (e3._collapseBtn = e3.querySelector(e3.collapseBtnSelector)),
          (e3.styles = getComputedStyle(x(e3))),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "_setInitialHeight",
            value: function () {
              (this._initialHeight = this.offsetHeight),
                (this.style.maxHeight = "".concat(this._initialHeight, "px"));
            },
          },
          {
            key: "_setMaxHeight",
            value: function () {
              (this._maxHeight = this.scrollHeight),
                (this.style.maxHeight = "".concat(this._maxHeight, "px"));
            },
          },
          {
            key: "_hideItems",
            value: function () {
              var e3 = this,
                t3 = this.querySelectorAll(this.visibleItemSelector);
              (this.style.maxHeight = "".concat(this._initialHeight, "px")),
                setTimeout(function () {
                  t3.forEach(function (t4, i3) {
                    i3 + 1 >
                      +(e3.dataset.initialCount
                        ? +e3.dataset.initialCount
                        : 0) && he(t4);
                  });
                }, this._transitionDuration);
            },
          },
          {
            key: "_showItems",
            value: function () {
              var e3 = this;
              this.querySelectorAll(this.hiddenItemSelector).forEach(function (
                t3,
                i3
              ) {
                i3 + 1 < +(e3.dataset.showCount ? e3.dataset.showCount : 0) &&
                  de(t3);
              }),
                (this.style.maxHeight = "".concat(this._maxHeight, "px"));
            },
          },
          {
            key: "_tryHideExpandBtn",
            value: function () {
              this.querySelectorAll(this.hiddenItemSelector).length === 0 &&
                he(this._expandBtn);
            },
          },
          {
            key: "_transitionDuration",
            get: function () {
              return 1e3 * parseFloat(this.styles.transitionDuration);
            },
          },
        ]),
        i2
      );
    })(te),
    we = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(
            x((e3 = t2.apply(this, arguments))),
            "_handleButtonClick",
            function () {
              e3.update();
            }
          ),
          f(x(e3), "_handleKeyDown", function (t3) {
            K(t3.key || t3.keyCode) && (t3.preventDefault(), e3.update());
          }),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              this.addEventListener("keydown", this._handleKeyDown),
                this.addEventListener("click", this._handleButtonClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeEventListener("keydown", this._handleKeyDown),
                this.removeEventListener("click", this._handleButtonClick);
            },
          },
          {
            key: "update",
            value: function () {
              var e3 = this.closest("list-component");
              e3 &&
                (this.dataset.trigger === "collapse"
                  ? e3.collapse()
                  : e3.expand(),
                this.emit("click", e3));
            },
          },
        ]),
        i2
      );
    })(te),
    Se = we;
  function xe(e2, t2, i2, n2, s2, a2, r2) {
    try {
      var o2 = e2[a2](r2),
        l2 = o2.value;
    } catch (e3) {
      return void i2(e3);
    }
    o2.done ? t2(l2) : Promise.resolve(l2).then(n2, s2);
  }
  function Ce(e2) {
    return function () {
      var t2 = this,
        i2 = arguments;
      return new Promise(function (n2, s2) {
        var a2 = e2.apply(t2, i2);
        function r2(e3) {
          xe(a2, n2, s2, r2, o2, "next", e3);
        }
        function o2(e3) {
          xe(a2, n2, s2, r2, o2, "throw", e3);
        }
        r2(void 0);
      });
    };
  }
  function ke(e2, t2) {
    if (e2 == null) return {};
    var i2,
      n2,
      s2 = (function (e3, t3) {
        if (e3 == null) return {};
        var i3,
          n3,
          s3 = {},
          a3 = Object.keys(e3);
        for (n3 = 0; n3 < a3.length; n3++)
          (i3 = a3[n3]), t3.indexOf(i3) >= 0 || (s3[i3] = e3[i3]);
        return s3;
      })(e2, t2);
    if (Object.getOwnPropertySymbols) {
      var a2 = Object.getOwnPropertySymbols(e2);
      for (n2 = 0; n2 < a2.length; n2++)
        (i2 = a2[n2]),
          t2.indexOf(i2) >= 0 ||
            (Object.prototype.propertyIsEnumerable.call(e2, i2) &&
              (s2[i2] = e2[i2]));
    }
    return s2;
  }
  function Ee(e2, t2) {
    var i2,
      n2,
      s2,
      a2,
      r2 = function (e3) {
        return function (t3) {
          return o2([e3, t3]);
        };
      },
      o2 = function (r3) {
        if (i2) throw new TypeError("Generator is already executing.");
        for (; a2 && ((a2 = 0), r3[0] && (l2 = 0)), l2; )
          try {
            if (
              ((i2 = 1),
              n2 &&
                (s2 =
                  2 & r3[0]
                    ? n2.return
                    : r3[0]
                    ? n2.throw || ((s2 = n2.return) && s2.call(n2), 0)
                    : n2.next) &&
                !(s2 = s2.call(n2, r3[1])).done)
            )
              return s2;
            switch (((n2 = 0), s2 && (r3 = [2 & r3[0], s2.value]), r3[0])) {
              case 0:
              case 1:
                s2 = r3;
                break;
              case 4:
                return l2.label++, { value: r3[1], done: !1 };
              case 5:
                l2.label++, (n2 = r3[1]), (r3 = [0]);
                continue;
              case 7:
                (r3 = l2.ops.pop()), l2.trys.pop();
                continue;
              default:
                if (
                  !(
                    (s2 = (s2 = l2.trys).length > 0 && s2[s2.length - 1]) ||
                    (r3[0] !== 6 && r3[0] !== 2)
                  )
                ) {
                  l2 = 0;
                  continue;
                }
                if (r3[0] === 3 && (!s2 || (r3[1] > s2[0] && r3[1] < s2[3]))) {
                  l2.label = r3[1];
                  break;
                }
                if (r3[0] === 6 && l2.label < s2[1]) {
                  (l2.label = s2[1]), (s2 = r3);
                  break;
                }
                if (s2 && l2.label < s2[2]) {
                  (l2.label = s2[2]), l2.ops.push(r3);
                  break;
                }
                s2[2] && l2.ops.pop(), l2.trys.pop();
                continue;
            }
            r3 = t2.call(e2, l2);
          } catch (e3) {
            (r3 = [6, e3]), (n2 = 0);
          } finally {
            i2 = s2 = 0;
          }
        if (5 & r3[0]) throw r3[1];
        return { value: r3[0] ? r3[1] : void 0, done: !0 };
      },
      l2 = {
        label: 0,
        sent: function () {
          if (1 & s2[0]) throw s2[1];
          return s2[1];
        },
        trys: [],
        ops: [],
      };
    return (
      (a2 = { next: r2(0), throw: r2(1), return: r2(2) }),
      typeof Symbol == "function" &&
        (a2[Symbol.iterator] = function () {
          return this;
        }),
      a2
    );
  }
  function Te(e2) {
    return e2.split("-")[1];
  }
  function _e(e2) {
    return e2 === "y" ? "height" : "width";
  }
  function Me(e2) {
    return e2.split("-")[0];
  }
  function Le(e2) {
    return ["top", "bottom"].includes(Me(e2)) ? "x" : "y";
  }
  function Pe(e2, t2, i2) {
    var n2,
      s2 = e2.reference,
      a2 = e2.floating,
      r2 = s2.x + s2.width / 2 - a2.width / 2,
      o2 = s2.y + s2.height / 2 - a2.height / 2,
      l2 = Le(t2),
      c2 = _e(l2),
      u2 = s2[c2] / 2 - a2[c2] / 2,
      d2 = l2 === "x";
    switch (Me(t2)) {
      case "top":
        n2 = { x: r2, y: s2.y - a2.height };
        break;
      case "bottom":
        n2 = { x: r2, y: s2.y + s2.height };
        break;
      case "right":
        n2 = { x: s2.x + s2.width, y: o2 };
        break;
      case "left":
        n2 = { x: s2.x - a2.width, y: o2 };
        break;
      default:
        n2 = { x: s2.x, y: s2.y };
    }
    switch (Te(t2)) {
      case "start":
        n2[l2] -= u2 * (i2 && d2 ? -1 : 1);
        break;
      case "end":
        n2[l2] += u2 * (i2 && d2 ? -1 : 1);
    }
    return n2;
  }
  var Ie,
    De =
      ((Ie = Ce(function (e2, t2, i2) {
        var n2,
          s2,
          a2,
          r2,
          o2,
          l2,
          c2,
          u2,
          d2,
          h2,
          p2,
          m2,
          g2,
          y2,
          b2,
          w2,
          S2,
          x2,
          C2,
          k2,
          E2,
          T2,
          _2,
          M2,
          L2,
          P2;
        return Ee(this, function (I2) {
          switch (I2.label) {
            case 0:
              return (
                (n2 = i2.placement),
                (s2 = n2 === void 0 ? "bottom" : n2),
                (a2 = i2.strategy),
                (r2 = a2 === void 0 ? "absolute" : a2),
                (o2 = i2.middleware),
                (l2 = o2 === void 0 ? [] : o2),
                (c2 = i2.platform),
                (u2 = l2.filter(Boolean)),
                [4, c2.isRTL == null ? void 0 : c2.isRTL(t2)]
              );
            case 1:
              return (
                (d2 = I2.sent()),
                [
                  4,
                  c2.getElementRects({
                    reference: e2,
                    floating: t2,
                    strategy: r2,
                  }),
                ]
              );
            case 2:
              (h2 = I2.sent()),
                (p2 = Pe(h2, s2, d2)),
                (m2 = p2.x),
                (g2 = p2.y),
                (y2 = s2),
                (b2 = {}),
                (w2 = 0),
                (S2 = 0),
                (I2.label = 3);
            case 3:
              return S2 < u2.length
                ? ((x2 = u2[S2]),
                  (C2 = x2.name),
                  [
                    4,
                    (0, x2.fn)({
                      x: m2,
                      y: g2,
                      initialPlacement: s2,
                      placement: y2,
                      strategy: r2,
                      middlewareData: b2,
                      rects: h2,
                      platform: c2,
                      elements: { reference: e2, floating: t2 },
                    }),
                  ])
                : [3, 11];
            case 4:
              return (
                (k2 = I2.sent()),
                (E2 = k2.x),
                (T2 = k2.y),
                (_2 = k2.data),
                (M2 = k2.reset),
                (m2 = E2 ?? m2),
                (g2 = T2 ?? g2),
                (b2 = ce(v({}, b2), f({}, C2, v({}, b2[C2], _2)))),
                M2 && w2 <= 50
                  ? (w2++,
                    typeof M2 != "object"
                      ? [3, 9]
                      : (M2.placement && (y2 = M2.placement),
                        M2.rects
                          ? M2.rects !== !0
                            ? [3, 6]
                            : [
                                4,
                                c2.getElementRects({
                                  reference: e2,
                                  floating: t2,
                                  strategy: r2,
                                }),
                              ]
                          : [3, 8]))
                  : [3, 10]
              );
            case 5:
              return (L2 = I2.sent()), [3, 7];
            case 6:
              (L2 = M2.rects), (I2.label = 7);
            case 7:
              (h2 = L2), (I2.label = 8);
            case 8:
              (P2 = Pe(h2, y2, d2)), (m2 = P2.x), (g2 = P2.y), (I2.label = 9);
            case 9:
              return (S2 = -1), [3, 10];
            case 10:
              return S2++, [3, 3];
            case 11:
              return [
                2,
                {
                  x: m2,
                  y: g2,
                  placement: y2,
                  strategy: r2,
                  middlewareData: b2,
                },
              ];
          }
        });
      })),
      function (e2, t2, i2) {
        return Ie.apply(this, arguments);
      });
  function Ae(e2) {
    return typeof e2 != "number"
      ? (function (e3) {
          return v({ top: 0, right: 0, bottom: 0, left: 0 }, e3);
        })(e2)
      : { top: e2, right: e2, bottom: e2, left: e2 };
  }
  function ze(e2) {
    return ce(v({}, e2), {
      top: e2.y,
      left: e2.x,
      right: e2.x + e2.width,
      bottom: e2.y + e2.height,
    });
  }
  function Oe(e2, t2) {
    return Be.apply(this, arguments);
  }
  function Be() {
    return (Be = Ce(function (e2, t2) {
      var i2,
        n2,
        s2,
        a2,
        r2,
        o2,
        l2,
        c2,
        u2,
        d2,
        h2,
        p2,
        f2,
        m2,
        g2,
        y2,
        b2,
        w2,
        S2,
        x2,
        C2,
        k2,
        E2,
        T2,
        _2,
        M2,
        L2,
        P2,
        I2,
        D2;
      return Ee(this, function (A2) {
        switch (A2.label) {
          case 0:
            return (
              t2 === void 0 && (t2 = {}),
              (n2 = e2.x),
              (s2 = e2.y),
              (a2 = e2.platform),
              (r2 = e2.rects),
              (o2 = e2.elements),
              (l2 = e2.strategy),
              (c2 = t2.boundary),
              (u2 = c2 === void 0 ? "clippingAncestors" : c2),
              (d2 = t2.rootBoundary),
              (h2 = d2 === void 0 ? "viewport" : d2),
              (p2 = t2.elementContext),
              (f2 = p2 === void 0 ? "floating" : p2),
              (m2 = t2.altBoundary),
              (g2 = m2 !== void 0 && m2),
              (y2 = t2.padding),
              (b2 = Ae(y2 === void 0 ? 0 : y2)),
              (w2 = f2 === "floating" ? "reference" : "floating"),
              (S2 = o2[g2 ? w2 : f2]),
              (C2 = a2.getClippingRect),
              (k2 = {}),
              [4, a2.isElement == null ? void 0 : a2.isElement(S2)]
            );
          case 1:
            return (i2 = A2.sent()) == null || i2
              ? ((E2 = S2), [3, 5])
              : [3, 2];
          case 2:
            return (T2 = S2.contextElement)
              ? [3, 4]
              : [
                  4,
                  a2.getDocumentElement == null
                    ? void 0
                    : a2.getDocumentElement(o2.floating),
                ];
          case 3:
            (T2 = A2.sent()), (A2.label = 4);
          case 4:
            (E2 = T2), (A2.label = 5);
          case 5:
            return [
              4,
              C2.apply(a2, [
                ((k2.element = E2),
                (k2.boundary = u2),
                (k2.rootBoundary = h2),
                (k2.strategy = l2),
                k2),
              ]),
            ];
          case 6:
            return (
              (x2 = ze.apply(void 0, [A2.sent()])),
              (_2 =
                f2 === "floating"
                  ? ce(v({}, r2.floating), { x: n2, y: s2 })
                  : r2.reference),
              [
                4,
                a2.getOffsetParent == null
                  ? void 0
                  : a2.getOffsetParent(o2.floating),
              ]
            );
          case 7:
            return (
              (M2 = A2.sent()),
              [4, a2.isElement == null ? void 0 : a2.isElement(M2)]
            );
          case 8:
            return A2.sent()
              ? [4, a2.getScale == null ? void 0 : a2.getScale(M2)]
              : [3, 10];
          case 9:
            return (P2 = A2.sent() || { x: 1, y: 1 }), [3, 11];
          case 10:
            (P2 = { x: 1, y: 1 }), (A2.label = 11);
          case 11:
            return (
              (L2 = P2),
              a2.convertOffsetParentRelativeRectToViewportRelativeRect
                ? [
                    4,
                    a2.convertOffsetParentRelativeRectToViewportRelativeRect({
                      rect: _2,
                      offsetParent: M2,
                      strategy: l2,
                    }),
                  ]
                : [3, 13]
            );
          case 12:
            return (D2 = A2.sent()), [3, 14];
          case 13:
            (D2 = _2), (A2.label = 14);
          case 14:
            return (
              (I2 = ze.apply(void 0, [D2])),
              [
                2,
                {
                  top: (x2.top - I2.top + b2.top) / L2.y,
                  bottom: (I2.bottom - x2.bottom + b2.bottom) / L2.y,
                  left: (x2.left - I2.left + b2.left) / L2.x,
                  right: (I2.right - x2.right + b2.right) / L2.x,
                },
              ]
            );
        }
      });
    })).apply(this, arguments);
  }
  var Ne = Math.min,
    qe = Math.max;
  function $e(e2, t2, i2) {
    return qe(e2, Ne(t2, i2));
  }
  var He = function (e2) {
      return {
        name: "arrow",
        options: e2,
        fn: function (t2) {
          return Ce(function () {
            var i2,
              n2,
              s2,
              a2,
              r2,
              o2,
              l2,
              c2,
              u2,
              d2,
              h2,
              p2,
              v2,
              m2,
              g2,
              y2,
              b2,
              w2,
              S2,
              x2,
              C2,
              k2,
              E2,
              T2,
              _2,
              M2,
              L2,
              P2,
              I2,
              D2,
              A2,
              z2,
              O2;
            return Ee(this, function (B2) {
              switch (B2.label) {
                case 0:
                  return (
                    (n2 = (i2 = e2 || {}).element),
                    (s2 = i2.padding),
                    (a2 = s2 === void 0 ? 0 : s2),
                    (r2 = t2.x),
                    (o2 = t2.y),
                    (l2 = t2.placement),
                    (c2 = t2.rects),
                    (u2 = t2.platform),
                    (d2 = t2.elements),
                    n2 == null
                      ? [2, {}]
                      : ((h2 = Ae(a2)),
                        (p2 = { x: r2, y: o2 }),
                        (v2 = Le(l2)),
                        (m2 = _e(v2)),
                        [4, u2.getDimensions(n2)])
                  );
                case 1:
                  return (
                    (g2 = B2.sent()),
                    (b2 = (y2 = v2 === "y") ? "top" : "left"),
                    (w2 = y2 ? "bottom" : "right"),
                    (S2 = y2 ? "clientHeight" : "clientWidth"),
                    (x2 =
                      c2.reference[m2] +
                      c2.reference[v2] -
                      p2[v2] -
                      c2.floating[m2]),
                    (C2 = p2[v2] - c2.reference[v2]),
                    [
                      4,
                      u2.getOffsetParent == null
                        ? void 0
                        : u2.getOffsetParent(n2),
                    ]
                  );
                case 2:
                  return (
                    (k2 = B2.sent()),
                    (E2 = k2 ? k2[S2] : 0),
                    (T2 = !E2)
                      ? [3, 4]
                      : [4, u2.isElement == null ? void 0 : u2.isElement(k2)]
                  );
                case 3:
                  (T2 = !B2.sent()), (B2.label = 4);
                case 4:
                  return (
                    T2 && (E2 = d2.floating[S2] || c2.floating[m2]),
                    (_2 = x2 / 2 - C2 / 2),
                    (M2 = h2[b2]),
                    (L2 = E2 - g2[m2] - h2[w2]),
                    (P2 = E2 / 2 - g2[m2] / 2 + _2),
                    (I2 = $e(M2, P2, L2)),
                    (D2 =
                      Te(l2) != null &&
                      P2 != I2 &&
                      c2.reference[m2] / 2 -
                        (P2 < M2 ? h2[b2] : h2[w2]) -
                        g2[m2] / 2 <
                        0),
                    (A2 = D2 ? (P2 < M2 ? M2 - P2 : L2 - P2) : 0),
                    [
                      2,
                      ((O2 = {}),
                      f(O2, v2, p2[v2] - A2),
                      f(
                        O2,
                        "data",
                        ((z2 = {}),
                        f(z2, v2, I2),
                        f(z2, "centerOffset", P2 - I2),
                        z2)
                      ),
                      O2),
                    ]
                  );
              }
            });
          })();
        },
      };
    },
    Fe = { left: "right", right: "left", bottom: "top", top: "bottom" };
  function Ve(e2) {
    return e2.replace(/left|right|bottom|top/g, function (e3) {
      return Fe[e3];
    });
  }
  var Re = { start: "end", end: "start" };
  function je(e2) {
    return e2.replace(/start|end/g, function (e3) {
      return Re[e3];
    });
  }
  var Xe = function (e2) {
    return (
      e2 === void 0 && (e2 = {}),
      {
        name: "flip",
        options: e2,
        fn: function (t2) {
          return Ce(function () {
            var i2,
              n2,
              s2,
              a2,
              r2,
              o2,
              l2,
              c2,
              u2,
              d2,
              h2,
              p2,
              f2,
              v2,
              m2,
              g2,
              y2,
              w2,
              S2,
              x2,
              C2,
              k2,
              E2,
              T2,
              _2,
              M2,
              L2,
              P2,
              I2,
              D2,
              A2,
              z2,
              O2,
              B2,
              N2,
              q2,
              $3,
              H2;
            return Ee(this, function (F2) {
              switch (F2.label) {
                case 0:
                  return (
                    (s2 = t2.placement),
                    (a2 = t2.middlewareData),
                    (r2 = t2.rects),
                    (o2 = t2.initialPlacement),
                    (l2 = t2.platform),
                    (c2 = t2.elements),
                    (u2 = e2.mainAxis),
                    (d2 = u2 === void 0 || u2),
                    (h2 = e2.crossAxis),
                    (p2 = h2 === void 0 || h2),
                    (f2 = e2.fallbackPlacements),
                    (v2 = e2.fallbackStrategy),
                    (m2 = v2 === void 0 ? "bestFit" : v2),
                    (g2 = e2.fallbackAxisSideDirection),
                    (y2 = g2 === void 0 ? "none" : g2),
                    (w2 = e2.flipAlignment),
                    (S2 = w2 === void 0 || w2),
                    (x2 = ke(e2, [
                      "mainAxis",
                      "crossAxis",
                      "fallbackPlacements",
                      "fallbackStrategy",
                      "fallbackAxisSideDirection",
                      "flipAlignment",
                    ])),
                    (C2 = Me(s2)),
                    (k2 = Me(o2) === o2),
                    [4, l2.isRTL == null ? void 0 : l2.isRTL(c2.floating)]
                  );
                case 1:
                  return (
                    (E2 = F2.sent()),
                    (T2 =
                      f2 ||
                      (k2 || !S2
                        ? [Ve(o2)]
                        : (function (e3) {
                            var t3 = Ve(e3);
                            return [je(e3), t3, je(t3)];
                          })(o2))),
                    f2 ||
                      y2 === "none" ||
                      (i2 = T2).push.apply(
                        i2,
                        b(
                          (function (e3, t3, i3, n3) {
                            var s3 = Te(e3),
                              a3 = (function (e4, t4, i4) {
                                var n4 = ["left", "right"],
                                  s4 = ["right", "left"];
                                switch (e4) {
                                  case "top":
                                  case "bottom":
                                    return i4 ? (t4 ? s4 : n4) : t4 ? n4 : s4;
                                  case "left":
                                  case "right":
                                    return t4
                                      ? ["top", "bottom"]
                                      : ["bottom", "top"];
                                  default:
                                    return [];
                                }
                              })(Me(e3), i3 === "start", n3);
                            return (
                              s3 &&
                                ((a3 = a3.map(function (e4) {
                                  return e4 + "-" + s3;
                                })),
                                t3 && (a3 = a3.concat(a3.map(je)))),
                              a3
                            );
                          })(o2, S2, y2, E2)
                        )
                      ),
                    (_2 = [o2].concat(b(T2))),
                    [4, Oe(t2, x2)]
                  );
                case 2:
                  if (
                    ((M2 = F2.sent()),
                    (L2 = []),
                    (P2 =
                      ((n2 = a2.flip) == null ? void 0 : n2.overflows) || []),
                    d2 && L2.push(M2[C2]),
                    p2 &&
                      ((I2 = (function (e3, t3, i3) {
                        i3 === void 0 && (i3 = !1);
                        var n3 = Te(e3),
                          s3 = Le(e3),
                          a3 = _e(s3),
                          r3 =
                            s3 === "x"
                              ? n3 === (i3 ? "end" : "start")
                                ? "right"
                                : "left"
                              : n3 === "start"
                              ? "bottom"
                              : "top";
                        return (
                          t3.reference[a3] > t3.floating[a3] && (r3 = Ve(r3)),
                          { main: r3, cross: Ve(r3) }
                        );
                      })(s2, r2, E2)),
                      (D2 = I2.main),
                      (A2 = I2.cross),
                      L2.push(M2[D2], M2[A2])),
                    (P2 = b(P2).concat([{ placement: s2, overflows: L2 }])),
                    !L2.every(function (e3) {
                      return e3 <= 0;
                    }))
                  ) {
                    if (
                      ((B2 =
                        (((z2 = a2.flip) == null ? void 0 : z2.index) || 0) +
                        1),
                      (N2 = _2[B2]))
                    )
                      return [
                        2,
                        {
                          data: { index: B2, overflows: P2 },
                          reset: { placement: N2 },
                        },
                      ];
                    if (
                      !(q2 =
                        (O2 = P2.filter(function (e3) {
                          return e3.overflows[0] <= 0;
                        }).sort(function (e3, t3) {
                          return e3.overflows[1] - t3.overflows[1];
                        })[0]) == null
                          ? void 0
                          : O2.placement)
                    )
                      switch (m2) {
                        case "bestFit":
                          (H2 =
                            ($3 = P2.map(function (e3) {
                              return [
                                e3.placement,
                                e3.overflows
                                  .filter(function (e4) {
                                    return e4 > 0;
                                  })
                                  .reduce(function (e4, t3) {
                                    return e4 + t3;
                                  }, 0),
                              ];
                            }).sort(function (e3, t3) {
                              return e3[1] - t3[1];
                            })[0]) == null
                              ? void 0
                              : $3[0]),
                            H2 && (q2 = H2);
                          break;
                        case "initialPlacement":
                          q2 = o2;
                      }
                    if (s2 !== q2) return [2, { reset: { placement: q2 } }];
                  }
                  return [2, {}];
              }
            });
          })();
        },
      }
    );
  };
  function Ge(e2, t2) {
    return We.apply(this, arguments);
  }
  function We() {
    return (
      (We = Ce(function (e2, t2) {
        var i2, n2, s2, a2, r2, o2, l2, c2, u2, d2, h2, p2, f2, m2;
        return Ee(this, function (g2) {
          switch (g2.label) {
            case 0:
              return (
                (i2 = e2.placement),
                (n2 = e2.platform),
                (s2 = e2.elements),
                [4, n2.isRTL == null ? void 0 : n2.isRTL(s2.floating)]
              );
            case 1:
              return (
                (a2 = g2.sent()),
                (r2 = Me(i2)),
                (o2 = Te(i2)),
                (l2 = Le(i2) === "x"),
                (c2 = ["left", "top"].includes(r2) ? -1 : 1),
                (u2 = a2 && l2 ? -1 : 1),
                (d2 = typeof t2 == "function" ? t2(e2) : t2),
                (h2 =
                  typeof d2 == "number"
                    ? { mainAxis: d2, crossAxis: 0, alignmentAxis: null }
                    : v(
                        { mainAxis: 0, crossAxis: 0, alignmentAxis: null },
                        d2
                      )),
                (p2 = h2.mainAxis),
                (f2 = h2.crossAxis),
                (m2 = h2.alignmentAxis),
                o2 &&
                  typeof m2 == "number" &&
                  (f2 = o2 === "end" ? -1 * m2 : m2),
                [
                  2,
                  l2 ? { x: f2 * u2, y: p2 * c2 } : { x: p2 * c2, y: f2 * u2 },
                ]
              );
          }
        });
      })),
      We.apply(this, arguments)
    );
  }
  var Ye = function (e2) {
      return (
        e2 === void 0 && (e2 = 0),
        {
          name: "offset",
          options: e2,
          fn: function (t2) {
            return Ce(function () {
              var i2, n2, s2;
              return Ee(this, function (a2) {
                switch (a2.label) {
                  case 0:
                    return (i2 = t2.x), (n2 = t2.y), [4, Ge(t2, e2)];
                  case 1:
                    return (
                      (s2 = a2.sent()),
                      [2, { x: i2 + s2.x, y: n2 + s2.y, data: s2 }]
                    );
                }
              });
            })();
          },
        }
      );
    },
    Ue,
    Ke = function (e2) {
      return (
        e2 === void 0 && (e2 = {}),
        {
          name: "shift",
          options: e2,
          fn: function (t2) {
            return Ce(function () {
              var i2,
                n2,
                s2,
                a2,
                r2,
                o2,
                l2,
                c2,
                u2,
                d2,
                h2,
                p2,
                m2,
                g2,
                y2,
                b2,
                w2,
                S2,
                x2,
                C2,
                k2,
                E2,
                T2,
                _2;
              return Ee(this, function (M2) {
                switch (M2.label) {
                  case 0:
                    return (
                      (i2 = t2.x),
                      (n2 = t2.y),
                      (s2 = t2.placement),
                      (a2 = e2.mainAxis),
                      (r2 = a2 === void 0 || a2),
                      (o2 = e2.crossAxis),
                      (l2 = o2 !== void 0 && o2),
                      (c2 = e2.limiter),
                      (u2 =
                        c2 === void 0
                          ? {
                              fn: function (e3) {
                                return { x: e3.x, y: e3.y };
                              },
                            }
                          : c2),
                      (d2 = ke(e2, ["mainAxis", "crossAxis", "limiter"])),
                      (h2 = { x: i2, y: n2 }),
                      [4, Oe(t2, d2)]
                    );
                  case 1:
                    return (
                      (p2 = M2.sent()),
                      (m2 = Le(Me(s2))),
                      (g2 = (function (e3) {
                        return e3 === "x" ? "y" : "x";
                      })(m2)),
                      (y2 = h2[m2]),
                      (b2 = h2[g2]),
                      r2 &&
                        ((w2 = m2 === "y" ? "bottom" : "right"),
                        (S2 = y2 + p2[m2 === "y" ? "top" : "left"]),
                        (x2 = y2 - p2[w2]),
                        (y2 = $e(S2, y2, x2))),
                      l2 &&
                        ((C2 = g2 === "y" ? "bottom" : "right"),
                        (k2 = b2 + p2[g2 === "y" ? "top" : "left"]),
                        (E2 = b2 - p2[C2]),
                        (b2 = $e(k2, b2, E2))),
                      (_2 = u2.fn(
                        ce(v({}, t2), (f((T2 = {}), m2, y2), f(T2, g2, b2), T2))
                      )),
                      [
                        2,
                        ce(v({}, _2), { data: { x: _2.x - i2, y: _2.y - n2 } }),
                      ]
                    );
                }
              });
            })();
          },
        }
      );
    };
  function Qe(e2) {
    var t2;
    return (
      ((t2 = e2.ownerDocument) == null ? void 0 : t2.defaultView) || window
    );
  }
  function Ze(e2) {
    return Qe(e2).getComputedStyle(e2);
  }
  function Je(e2) {
    return e2 instanceof Qe(e2).Node;
  }
  function et(e2) {
    return Je(e2) ? (e2.nodeName || "").toLowerCase() : "";
  }
  function tt() {
    if (Ue) return Ue;
    var e2 = navigator.userAgentData;
    return e2 && Array.isArray(e2.brands)
      ? (Ue = e2.brands
          .map(function (e3) {
            return e3.brand + "/" + e3.version;
          })
          .join(" "))
      : navigator.userAgent;
  }
  function it(e2) {
    return e2 instanceof Qe(e2).HTMLElement;
  }
  function nt(e2) {
    return e2 instanceof Qe(e2).Element;
  }
  function st(e2) {
    return (
      typeof ShadowRoot < "u" &&
      (e2 instanceof Qe(e2).ShadowRoot || e2 instanceof ShadowRoot)
    );
  }
  function at(e2) {
    var t2 = Ze(e2),
      i2 = t2.overflow,
      n2 = t2.overflowX,
      s2 = t2.overflowY,
      a2 = t2.display;
    return (
      /auto|scroll|overlay|hidden|clip/.test(i2 + s2 + n2) &&
      !["inline", "contents"].includes(a2)
    );
  }
  function rt(e2) {
    return ["table", "td", "th"].includes(et(e2));
  }
  function ot(e2) {
    var t2 = /firefox/i.test(tt()),
      i2 = Ze(e2),
      n2 = i2.backdropFilter || i2.WebkitBackdropFilter;
    return (
      i2.transform !== "none" ||
      i2.perspective !== "none" ||
      (!!n2 && n2 !== "none") ||
      (t2 && i2.willChange === "filter") ||
      (t2 && !!i2.filter && i2.filter !== "none") ||
      ["transform", "perspective"].some(function (e3) {
        return i2.willChange.includes(e3);
      }) ||
      ["paint", "layout", "strict", "content"].some(function (e3) {
        var t3 = i2.contain;
        return t3 != null && t3.includes(e3);
      })
    );
  }
  function lt() {
    return /^((?!chrome|android).)*safari/i.test(tt());
  }
  function ct(e2) {
    return ["html", "body", "#document"].includes(et(e2));
  }
  var ut = Math.min,
    dt = Math.max,
    ht = Math.round;
  function pt(e2) {
    var t2 = Ze(e2),
      i2 = parseFloat(t2.width),
      n2 = parseFloat(t2.height),
      s2 = it(e2),
      a2 = s2 ? e2.offsetWidth : i2,
      r2 = s2 ? e2.offsetHeight : n2,
      o2 = ht(i2) !== a2 || ht(n2) !== r2;
    return (
      o2 && ((i2 = a2), (n2 = r2)), { width: i2, height: n2, fallback: o2 }
    );
  }
  function ft(e2) {
    return nt(e2) ? e2 : e2.contextElement;
  }
  var vt = { x: 1, y: 1 };
  function mt(e2) {
    var t2 = ft(e2);
    if (!it(t2)) return vt;
    var i2 = t2.getBoundingClientRect(),
      n2 = pt(t2),
      s2 = n2.width,
      a2 = n2.height,
      r2 = n2.fallback,
      o2 = (r2 ? ht(i2.width) : i2.width) / s2,
      l2 = (r2 ? ht(i2.height) : i2.height) / a2;
    return (
      (o2 && Number.isFinite(o2)) || (o2 = 1),
      (l2 && Number.isFinite(l2)) || (l2 = 1),
      { x: o2, y: l2 }
    );
  }
  function gt(e2, t2, i2, n2) {
    var s2, a2;
    t2 === void 0 && (t2 = !1), i2 === void 0 && (i2 = !1);
    var r2 = e2.getBoundingClientRect(),
      o2 = ft(e2),
      l2 = vt;
    t2 && (n2 ? nt(n2) && (l2 = mt(n2)) : (l2 = mt(e2)));
    var c2 = o2 ? Qe(o2) : window,
      u2 = lt() && i2,
      d2 =
        (r2.left +
          ((u2 &&
            ((s2 = c2.visualViewport) == null ? void 0 : s2.offsetLeft)) ||
            0)) /
        l2.x,
      h2 =
        (r2.top +
          ((u2 && ((a2 = c2.visualViewport) == null ? void 0 : a2.offsetTop)) ||
            0)) /
        l2.y,
      p2 = r2.width / l2.x,
      f2 = r2.height / l2.y;
    if (o2)
      for (
        var v2 = Qe(o2), m2 = n2 && nt(n2) ? Qe(n2) : n2, g2 = v2.frameElement;
        g2 && n2 && m2 !== v2;

      ) {
        var y2 = mt(g2),
          b2 = g2.getBoundingClientRect(),
          w2 = getComputedStyle(g2);
        (b2.x += (g2.clientLeft + parseFloat(w2.paddingLeft)) * y2.x),
          (b2.y += (g2.clientTop + parseFloat(w2.paddingTop)) * y2.y),
          (d2 *= y2.x),
          (h2 *= y2.y),
          (p2 *= y2.x),
          (f2 *= y2.y),
          (d2 += b2.x),
          (h2 += b2.y),
          (g2 = Qe(g2).frameElement);
      }
    return ze({ width: p2, height: f2, x: d2, y: h2 });
  }
  function yt(e2) {
    return ((Je(e2) ? e2.ownerDocument : e2.document) || window.document)
      .documentElement;
  }
  function bt(e2) {
    return nt(e2)
      ? { scrollLeft: e2.scrollLeft, scrollTop: e2.scrollTop }
      : { scrollLeft: e2.pageXOffset, scrollTop: e2.pageYOffset };
  }
  function wt(e2) {
    return gt(yt(e2)).left + bt(e2).scrollLeft;
  }
  function St(e2) {
    if (et(e2) === "html") return e2;
    var t2 = e2.assignedSlot || e2.parentNode || (st(e2) && e2.host) || yt(e2);
    return st(t2) ? t2.host : t2;
  }
  function xt(e2) {
    var t2 = St(e2);
    return ct(t2) ? t2.ownerDocument.body : it(t2) && at(t2) ? t2 : xt(t2);
  }
  function Ct(e2, t2) {
    var i2;
    t2 === void 0 && (t2 = []);
    var n2 = xt(e2),
      s2 = n2 === ((i2 = e2.ownerDocument) == null ? void 0 : i2.body),
      a2 = Qe(n2);
    return s2
      ? t2.concat(a2, a2.visualViewport || [], at(n2) ? n2 : [])
      : t2.concat(n2, Ct(n2));
  }
  function kt(e2, t2, i2) {
    var n2;
    if (t2 === "viewport")
      n2 = (function (e3, t3) {
        var i3 = Qe(e3),
          n3 = yt(e3),
          s3 = i3.visualViewport,
          a3 = n3.clientWidth,
          r3 = n3.clientHeight,
          o3 = 0,
          l2 = 0;
        if (s3) {
          (a3 = s3.width), (r3 = s3.height);
          var c2 = lt();
          (!c2 || (c2 && t3 === "fixed")) &&
            ((o3 = s3.offsetLeft), (l2 = s3.offsetTop));
        }
        return { width: a3, height: r3, x: o3, y: l2 };
      })(e2, i2);
    else if (t2 === "document")
      n2 = (function (e3) {
        var t3 = yt(e3),
          i3 = bt(e3),
          n3 = e3.ownerDocument.body,
          s3 = dt(
            t3.scrollWidth,
            t3.clientWidth,
            n3.scrollWidth,
            n3.clientWidth
          ),
          a3 = dt(
            t3.scrollHeight,
            t3.clientHeight,
            n3.scrollHeight,
            n3.clientHeight
          ),
          r3 = -i3.scrollLeft + wt(e3),
          o3 = -i3.scrollTop;
        return (
          Ze(n3).direction === "rtl" &&
            (r3 += dt(t3.clientWidth, n3.clientWidth) - s3),
          { width: s3, height: a3, x: r3, y: o3 }
        );
      })(yt(e2));
    else if (nt(t2))
      n2 = (function (e3, t3) {
        var i3 = gt(e3, !0, t3 === "fixed"),
          n3 = i3.top + e3.clientTop,
          s3 = i3.left + e3.clientLeft,
          a3 = it(e3) ? mt(e3) : { x: 1, y: 1 };
        return {
          width: e3.clientWidth * a3.x,
          height: e3.clientHeight * a3.y,
          x: s3 * a3.x,
          y: n3 * a3.y,
        };
      })(t2, i2);
    else {
      var s2 = v({}, t2);
      if (lt()) {
        var a2,
          r2,
          o2 = Qe(e2);
        (s2.x -=
          ((a2 = o2.visualViewport) == null ? void 0 : a2.offsetLeft) || 0),
          (s2.y -=
            ((r2 = o2.visualViewport) == null ? void 0 : r2.offsetTop) || 0);
      }
      n2 = s2;
    }
    return ze(n2);
  }
  function Et(e2, t2) {
    var i2 = St(e2);
    return (
      !(i2 === t2 || !nt(i2) || ct(i2)) &&
      (Ze(i2).position === "fixed" || Et(i2, t2))
    );
  }
  function Tt(e2, t2) {
    return it(e2) && Ze(e2).position !== "fixed"
      ? t2
        ? t2(e2)
        : e2.offsetParent
      : null;
  }
  function _t(e2, t2) {
    var i2 = Qe(e2);
    if (!it(e2)) return i2;
    for (var n2 = Tt(e2, t2); n2 && rt(n2) && Ze(n2).position === "static"; )
      n2 = Tt(n2, t2);
    return n2 &&
      (et(n2) === "html" ||
        (et(n2) === "body" && Ze(n2).position === "static" && !ot(n2)))
      ? i2
      : n2 ||
          (function (e3) {
            for (var t3 = St(e3); it(t3) && !ct(t3); ) {
              if (ot(t3)) return t3;
              t3 = St(t3);
            }
            return null;
          })(e2) ||
          i2;
  }
  function Mt(e2, t2, i2) {
    var n2 = it(t2),
      s2 = yt(t2),
      a2 = gt(e2, !0, i2 === "fixed", t2),
      r2 = { scrollLeft: 0, scrollTop: 0 },
      o2 = { x: 0, y: 0 };
    if (n2 || (!n2 && i2 !== "fixed"))
      if (((et(t2) !== "body" || at(s2)) && (r2 = bt(t2)), it(t2))) {
        var l2 = gt(t2, !0);
        (o2.x = l2.x + t2.clientLeft), (o2.y = l2.y + t2.clientTop);
      } else s2 && (o2.x = wt(s2));
    return {
      x: a2.left + r2.scrollLeft - o2.x,
      y: a2.top + r2.scrollTop - o2.y,
      width: a2.width,
      height: a2.height,
    };
  }
  var Lt = {
    getClippingRect: function (e2) {
      var t2 = e2.element,
        i2 = e2.boundary,
        n2 = e2.rootBoundary,
        s2 = e2.strategy,
        a2 = b(
          i2 === "clippingAncestors"
            ? (function (e3, t3) {
                var i3 = t3.get(e3);
                if (i3) return i3;
                for (
                  var n3 = Ct(e3).filter(function (e4) {
                      return nt(e4) && et(e4) !== "body";
                    }),
                    s3 = null,
                    a3 = Ze(e3).position === "fixed",
                    r3 = a3 ? St(e3) : e3;
                  nt(r3) && !ct(r3);

                ) {
                  var o3 = Ze(r3),
                    l2 = ot(r3);
                  l2 || o3.position !== "fixed" || (s3 = null),
                    (
                      a3
                        ? !l2 && !s3
                        : (!l2 &&
                            o3.position === "static" &&
                            s3 &&
                            ["absolute", "fixed"].includes(s3.position)) ||
                          (at(r3) && !l2 && Et(e3, r3))
                    )
                      ? (n3 = n3.filter(function (e4) {
                          return e4 !== r3;
                        }))
                      : (s3 = o3),
                    (r3 = St(r3));
                }
                return t3.set(e3, n3), n3;
              })(t2, this._c)
            : [].concat(i2)
        ).concat([n2]),
        r2 = a2[0],
        o2 = a2.reduce(function (e3, i3) {
          var n3 = kt(t2, i3, s2);
          return (
            (e3.top = dt(n3.top, e3.top)),
            (e3.right = ut(n3.right, e3.right)),
            (e3.bottom = ut(n3.bottom, e3.bottom)),
            (e3.left = dt(n3.left, e3.left)),
            e3
          );
        }, kt(t2, r2, s2));
      return {
        width: o2.right - o2.left,
        height: o2.bottom - o2.top,
        x: o2.left,
        y: o2.top,
      };
    },
    convertOffsetParentRelativeRectToViewportRelativeRect: function (e2) {
      var t2 = e2.rect,
        i2 = e2.offsetParent,
        n2 = e2.strategy,
        s2 = it(i2),
        a2 = yt(i2);
      if (i2 === a2) return t2;
      var r2 = { scrollLeft: 0, scrollTop: 0 },
        o2 = { x: 1, y: 1 },
        l2 = { x: 0, y: 0 };
      if (
        (s2 || (!s2 && n2 !== "fixed")) &&
        ((et(i2) !== "body" || at(a2)) && (r2 = bt(i2)), it(i2))
      ) {
        var c2 = gt(i2);
        (o2 = mt(i2)),
          (l2.x = c2.x + i2.clientLeft),
          (l2.y = c2.y + i2.clientTop);
      }
      return {
        width: t2.width * o2.x,
        height: t2.height * o2.y,
        x: t2.x * o2.x - r2.scrollLeft * o2.x + l2.x,
        y: t2.y * o2.y - r2.scrollTop * o2.y + l2.y,
      };
    },
    isElement: nt,
    getDimensions: function (e2) {
      return pt(e2);
    },
    getOffsetParent: _t,
    getDocumentElement: yt,
    getScale: mt,
    getElementRects: function (e2) {
      return Ce(function () {
        var t2, i2, n2, s2, a2, r2, o2, l2;
        return Ee(this, function (c2) {
          switch (c2.label) {
            case 0:
              return (
                (t2 = e2.reference),
                (i2 = e2.floating),
                (n2 = e2.strategy),
                (s2 = this.getOffsetParent || _t),
                (a2 = this.getDimensions),
                (r2 = {}),
                (o2 = [t2]),
                [4, s2(i2)]
              );
            case 1:
              return (
                (r2.reference = Mt.apply(void 0, o2.concat([c2.sent(), n2]))),
                (l2 = [{ x: 0, y: 0 }]),
                [4, a2(i2)]
              );
            case 2:
              return [
                2,
                ((r2.floating = v.apply(void 0, l2.concat([c2.sent()]))), r2),
              ];
          }
        });
      }).apply(this);
    },
    getClientRects: function (e2) {
      return Array.from(e2.getClientRects());
    },
    isRTL: function (e2) {
      return Ze(e2).direction === "rtl";
    },
  };
  function Pt(e2, t2, i2, n2) {
    n2 === void 0 && (n2 = {});
    var s2 = n2.ancestorScroll,
      a2 = s2 === void 0 || s2,
      r2 = n2.ancestorResize,
      o2 = r2 === void 0 || r2,
      l2 = n2.elementResize,
      c2 = l2 === void 0 || l2,
      u2 = n2.animationFrame,
      d2 = u2 !== void 0 && u2,
      h2 =
        a2 || o2
          ? b(
              nt(e2) ? Ct(e2) : e2.contextElement ? Ct(e2.contextElement) : []
            ).concat(b(Ct(t2)))
          : [];
    h2.forEach(function (e3) {
      var t3 = !nt(e3) && e3.toString().includes("V");
      !a2 || (d2 && !t3) || e3.addEventListener("scroll", i2, { passive: !0 }),
        o2 && e3.addEventListener("resize", i2);
    });
    var p2,
      f2 = null;
    c2 &&
      ((f2 = new ResizeObserver(function () {
        i2();
      })),
      nt(e2) && !d2 && f2.observe(e2),
      nt(e2) || !e2.contextElement || d2 || f2.observe(e2.contextElement),
      f2.observe(t2));
    var v2 = d2 ? gt(e2) : null;
    return (
      d2 &&
        (function t3() {
          var n3 = gt(e2);
          !v2 ||
            (n3.x === v2.x &&
              n3.y === v2.y &&
              n3.width === v2.width &&
              n3.height === v2.height) ||
            i2(),
            (v2 = n3),
            (p2 = requestAnimationFrame(t3));
        })(),
      i2(),
      function () {
        var e3;
        h2.forEach(function (e4) {
          a2 && e4.removeEventListener("scroll", i2),
            o2 && e4.removeEventListener("resize", i2);
        }),
          (e3 = f2) == null || e3.disconnect(),
          (f2 = null),
          d2 && cancelAnimationFrame(p2);
      }
    );
  }
  var It = function (e2, t2, i2) {
      var n2 = new Map(),
        s2 = v({ platform: Lt }, i2),
        a2 = ce(v({}, s2.platform), { _c: n2 });
      return De(e2, t2, ce(v({}, s2), { platform: a2 }));
    },
    Dt = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        d(this, i2),
          f(x((e3 = t2.call(this))), "_handleScroll", function () {
            e3._type === "tooltip" &&
              (e3.hide(), X(window, "wheel", e3._handleScroll));
          }),
          f(x(e3), "_handleBlockSelect", function (t3) {
            e3.dataset.sectionId === t3.detail.sectionId &&
              (e3.element.querySelector(
                '[block-id="'.concat(t3.detail.blockId, '"]')
              ) && e3._btn
                ? e3._btn.trigger()
                : e3.hide());
          }),
          f(x(e3), "_handleBlockDeselect", function (t3) {
            if (e3.dataset.sectionId === t3.detail.sectionId) {
              if (
                !e3.element.querySelector(
                  '[block-id="'.concat(t3.detail.blockId, '"]')
                )
              )
                return;
              e3.hide();
            }
          }),
          f(x(e3), "init", function () {
            var t3 =
              document.querySelector(
                "#".concat(e3.dataset.floatingElementId)
              ) || e3._btn;
            t3 &&
              Pt(t3, x(e3), function () {
                It(t3, e3, e3._getOptions()).then(function (t4) {
                  e3._updatePosition(t4), e3._arrow && e3._updateArrow(t4);
                });
              });
          }),
          f(x(e3), "show", function () {
            (e3._type === "tooltip" && S.isScrolling) ||
              (e3._mount(),
              e3.playVideos(),
              e3._setVisible(!0),
              e3.emit("show", {}),
              j(window, "wheel", e3._handleScroll));
          }),
          f(x(e3), "hide", function () {
            e3._setVisible(!1),
              e3.pauseVideos(),
              e3._unmount(),
              e3.emit("hide", {});
          }),
          (e3._withOverlay = e3.hasAttribute("data-with-overlay"));
        var n2,
          s2,
          a2 = e3.querySelector("template");
        return (
          (e3.element = ve(a2)),
          (e3._arrow = e3.element.querySelector("[data-float-element-arrow]")),
          e3._strategy === "fixed" &&
            ((n2 = x(e3)),
            (s2 = document.getElementById("Portal")).appendChild(n2),
            document.body.appendChild(s2)),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              this.init(),
                this._isEditorMode &&
                  (this._editor.subscribe(
                    "BLOCK_SELECT",
                    this._handleBlockSelect
                  ),
                  this._editor.subscribe(
                    "BLOCK_DESELECT",
                    this._handleBlockDeselect
                  ));
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this._unmount(),
                this._isEditorMode && this._editor.destroy(),
                X(window, "wheel", this._handleScroll);
            },
          },
          {
            key: "_updatePosition",
            value: function (e3) {
              var t3 = e3.x,
                i3 = e3.y;
              Object.assign(this.style, {
                left: "".concat(t3, "px"),
                top: "".concat(i3, "px"),
              });
            },
          },
          {
            key: "_getOptions",
            value: function () {
              return {
                placement: this._placement,
                middleware: this._getMiddleware(),
                strategy: this._strategy,
              };
            },
          },
          {
            key: "_getMiddleware",
            value: function () {
              var e3 = this.dataset.alignmentAxisOffset || 0,
                t3 = this.dataset.mainAxisOffset || 0,
                i3 = [Ye({ alignmentAxis: +e3, mainAxis: +t3 }), Xe(), Ke()];
              return this._arrow && i3.push(He({ element: this._arrow })), i3;
            },
          },
          {
            key: "checkCursorOutside",
            value: function (e3, t3) {
              var i3 = +(this.dataset.mainAxisOffset || 0),
                n2 = this.getBoundingClientRect(),
                s2 = n2.top - (t3 + i3) > 2,
                a2 = t3 - n2.bottom - i3 > 2,
                r2 = n2.left - (e3 + i3) > 2,
                o2 = e3 - n2.right - i3 > 2;
              return s2 || a2 || r2 || o2;
            },
          },
          {
            key: "_updateArrow",
            value: function (e3) {
              var t3 = e3.placement,
                i3 = e3.middlewareData;
              if (this._arrow) {
                var n2 = i3.arrow,
                  s2 = n2.x,
                  a2 = n2.y,
                  r2 = {
                    top: "bottom",
                    right: "left",
                    bottom: "top",
                    left: "right",
                  }[t3.split("-")[0]];
                Object.assign(
                  this._arrow.style,
                  f(
                    {
                      left: s2 != null ? "".concat(s2, "px") : "",
                      top: a2 != null ? "".concat(a2, "px") : "",
                      right: "",
                      bottom: "",
                    },
                    r2,
                    "-5px"
                  )
                );
              }
            },
          },
          {
            key: "_mount",
            value: function () {
              this.contains(this.element) || this.appendChild(this.element);
            },
          },
          {
            key: "_unmount",
            value: function () {
              this.isOpen && this._withOverlay && S.hideOverlay(this.id),
                this.element && this.element.remove();
            },
          },
          {
            key: "playVideos",
            value: function () {
              b(this.element.querySelectorAll("video")).forEach(function (e3) {
                e3.play();
              });
            },
          },
          {
            key: "pauseVideos",
            value: function () {
              b(this.element.querySelectorAll("video")).forEach(function (e3) {
                e3.pause();
              });
            },
          },
          {
            key: "_setVisible",
            value: function (e3) {
              if (
                (this.setAttribute("aria-hidden", e3 ? "false" : "true"),
                this._btn && this._btn.setExpand(e3),
                this._withOverlay)
              ) {
                var t3 = {
                  backdropFilter: this.hasAttribute("data-overlay-with-blur")
                    ? "blur(16.5px)"
                    : "none",
                };
                this.isOpen
                  ? S.showOverlay(this.id, t3)
                  : S.hideOverlay(this.id);
              }
            },
          },
          {
            key: "_btn",
            get: function () {
              return document.querySelector(
                '[data-float-element-id="'
                  .concat(this.id, '"], [data-tooltip-id="')
                  .concat(this.id, '"]')
              );
            },
          },
          {
            key: "isOpen",
            get: function () {
              return this.getAttribute("aria-hidden") === "false";
            },
          },
          {
            key: "_strategy",
            get: function () {
              return this.dataset.strategy || "absolute";
            },
          },
          {
            key: "_type",
            get: function () {
              return this.dataset.type;
            },
          },
          {
            key: "_placement",
            get: function () {
              return this.dataset.placement || "bottom-end";
            },
          },
        ]),
        i2
      );
    })(te),
    At = Dt;
  function zt(e2, t2) {
    return (
      (function (e3) {
        if (Array.isArray(e3)) return e3;
      })(e2) ||
      g(e2) ||
      y(e2, t2) ||
      (function () {
        throw new TypeError(
          "Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
        );
      })()
    );
  }
  var Ot = "http://www.w3.org/2000/svg",
    Bt = function (e2, t2) {
      return !(!e2 || !t2) && e2.contains(t2);
    },
    Nt = function (e2) {
      e2.current && (e2.current.remove(), (e2.current = null));
    },
    qt = function () {
      var e2,
        t2 =
          arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
        i2 = t2.restMs,
        n2 = i2 === void 0 ? 0 : i2,
        s2 = t2.buffer,
        a2 = s2 === void 0 ? 0.5 : s2,
        r2 = t2.blockPointerEvents,
        o2 = r2 === void 0 || r2,
        l2 = !1,
        c2 = !1;
      return function (t3) {
        var i3 = t3.x,
          s3 = t3.y,
          r3 = t3.placement,
          u2 = t3.elements,
          d2 = t3.onClose,
          h2 = t3.polygonRef;
        return function (t4) {
          var p2,
            f2 = function () {
              Nt(h2), clearTimeout(e2), d2();
            };
          if (
            (clearTimeout(e2),
            u2.domReference &&
              u2.floating &&
              r3 != null &&
              i3 != null &&
              s3 != null)
          ) {
            var v2,
              m2 = t4.clientX,
              g2 = t4.clientY,
              y2 = t4.target,
              w2 = t4.type === "mouseleave",
              S2 = Bt(u2.domReference, y2),
              x2 = Bt(u2.floating, y2);
            if (w2 || !S2) {
              if (
                (w2 || !(S2 || (l2 && Bt(h2.current, y2)))) &&
                !(
                  (w2 &&
                    ((v2 = t4.relatedTarget),
                    v2 &&
                      v2 instanceof (document.defaultView || window).Element) &&
                    Bt(u2.floating, t4.relatedTarget)) ||
                  u2.floating.querySelector(
                    'float-element[aria-hidden="false"]'
                  )
                )
              )
                if (
                  (x2 && (c2 = !0),
                  !x2 ||
                    w2 ||
                    ((p2 = h2.current) === null || p2 === void 0
                      ? void 0
                      : p2.dataset.type) === "rect")
                ) {
                  var C2 = u2.domReference.getBoundingClientRect(),
                    k2 = u2.floating.getBoundingClientRect(),
                    E2 = r3.split("-")[0],
                    T2 = i3 > k2.right - k2.width / 2,
                    _2 = s3 > k2.bottom - k2.height / 2;
                  if (
                    (E2 === "top" && s3 >= C2.bottom - 1) ||
                    (E2 === "bottom" && s3 <= C2.top + 1) ||
                    (E2 === "left" && i3 >= C2.right - 1) ||
                    (E2 === "right" && i3 <= C2.left + 1)
                  )
                    return f2();
                  var M2 = [];
                  switch (E2) {
                    case "top":
                      (M2 = [
                        [k2.left, C2.top + 1],
                        [k2.left, k2.bottom - 1],
                        [k2.right, k2.bottom - 1],
                        [k2.right, C2.top + 1],
                      ]),
                        (l2 =
                          m2 >= k2.left &&
                          m2 <= k2.right &&
                          g2 >= k2.top &&
                          g2 <= C2.top + 1);
                      break;
                    case "bottom":
                      (M2 = [
                        [k2.left, k2.top + 1],
                        [k2.left, C2.bottom - 1],
                        [k2.right, C2.bottom - 1],
                        [k2.right, k2.top + 1],
                      ]),
                        (l2 =
                          m2 >= k2.left &&
                          m2 <= k2.right &&
                          g2 >= C2.bottom - 1 &&
                          g2 <= k2.bottom);
                      break;
                    case "left":
                      (M2 = [
                        [k2.right - 1, k2.bottom],
                        [k2.right - 1, k2.top],
                        [C2.left + 1, k2.top],
                        [C2.left + 1, k2.bottom],
                      ]),
                        (l2 =
                          m2 >= k2.left &&
                          m2 <= C2.left + 1 &&
                          g2 >= k2.top &&
                          g2 <= k2.bottom);
                      break;
                    case "right":
                      (M2 = [
                        [C2.right - 1, k2.bottom],
                        [C2.right - 1, k2.top],
                        [k2.left + 1, k2.top],
                        [k2.left + 1, k2.bottom],
                      ]),
                        (l2 =
                          m2 >= C2.right - 1 &&
                          m2 <= k2.right &&
                          g2 >= k2.top &&
                          g2 <= k2.bottom);
                  }
                  var L2 = l2
                    ? M2
                    : (function (e3) {
                        var t5 = zt(e3, 2),
                          i4 = t5[0],
                          n3 = t5[1],
                          s4 = k2.width > C2.width,
                          r4 = k2.height > C2.height;
                        switch (E2) {
                          case "top":
                            var o3 = [
                                s4
                                  ? i4 + a2 / 2
                                  : T2
                                  ? i4 + 4 * a2
                                  : i4 - 4 * a2,
                                n3 + a2 + 1,
                              ],
                              l3 = [
                                s4
                                  ? i4 - a2 / 2
                                  : T2
                                  ? i4 + 4 * a2
                                  : i4 - 4 * a2,
                                n3 + a2 + 1,
                              ],
                              c3 = [
                                [k2.left, T2 || s4 ? k2.bottom - a2 : k2.top],
                                [
                                  k2.right,
                                  T2
                                    ? s4
                                      ? k2.bottom - a2
                                      : k2.top
                                    : k2.bottom - a2,
                                ],
                              ];
                            return [o3, l3].concat(b(c3));
                          case "bottom":
                            var u3 = [
                                s4
                                  ? i4 + a2 / 2
                                  : T2
                                  ? i4 + 4 * a2
                                  : i4 - 4 * a2,
                                n3 - a2,
                              ],
                              d3 = [
                                s4
                                  ? i4 - a2 / 2
                                  : T2
                                  ? i4 + 4 * a2
                                  : i4 - 4 * a2,
                                n3 - a2,
                              ],
                              h3 = [
                                [k2.left, T2 || s4 ? k2.top + a2 : k2.bottom],
                                [
                                  k2.right,
                                  T2
                                    ? s4
                                      ? k2.top + a2
                                      : k2.bottom
                                    : k2.top + a2,
                                ],
                              ];
                            return [u3, d3].concat(b(h3));
                          case "left":
                            var p3 = [
                                i4 + a2 + 1,
                                r4
                                  ? n3 + a2 / 2
                                  : _2
                                  ? n3 + 4 * a2
                                  : n3 - 4 * a2,
                              ],
                              f3 = [
                                i4 + a2 + 1,
                                r4
                                  ? n3 - a2 / 2
                                  : _2
                                  ? n3 + 4 * a2
                                  : n3 - 4 * a2,
                              ];
                            return b([
                              [_2 || r4 ? k2.right - a2 : k2.left, k2.top],
                              [
                                _2
                                  ? r4
                                    ? k2.right - a2
                                    : k2.left
                                  : k2.right - a2,
                                k2.bottom,
                              ],
                            ]).concat([p3, f3]);
                          case "right":
                            var v3 = [
                                i4 - a2,
                                r4
                                  ? n3 + a2 / 2
                                  : _2
                                  ? n3 + 4 * a2
                                  : n3 - 4 * a2,
                              ],
                              m3 = [
                                i4 - a2,
                                r4
                                  ? n3 - a2 / 2
                                  : _2
                                  ? n3 + 4 * a2
                                  : n3 - 4 * a2,
                              ],
                              g3 = [
                                [_2 || r4 ? k2.left + a2 : k2.right, k2.top],
                                [
                                  _2
                                    ? r4
                                      ? k2.left + a2
                                      : k2.right
                                    : k2.left + a2,
                                  k2.bottom,
                                ],
                              ];
                            return [v3, m3].concat(b(g3));
                        }
                      })([i3, s3]);
                  !h2.current &&
                    o2 &&
                    w2 &&
                    ((h2.current = (function (e3, t5) {
                      var i4,
                        n3,
                        s4 = /apple/i.test(navigator.vendor),
                        a3 = document.defaultView || window,
                        r4 = document.createElementNS(Ot, "svg");
                      Object.assign(r4.style, {
                        position: "fixed",
                        left: "".concat(
                          (s4 &&
                            ((i4 = a3.visualViewport) === null || i4 === void 0
                              ? void 0
                              : i4.offsetLeft)) ||
                            0,
                          "px"
                        ),
                        top: "".concat(
                          (s4 &&
                            ((n3 = a3.visualViewport) === null || n3 === void 0
                              ? void 0
                              : n3.offsetTop)) ||
                            0,
                          "px"
                        ),
                        width: "100%",
                        height: "100%",
                        pointerEvents: "none",
                        zIndex: 2147483647,
                      }),
                        r4.setAttribute("data-type", t5 ? "rect" : "triangle");
                      var o3 = document.createElementNS(Ot, "polygon");
                      return (
                        o3.setAttribute(
                          "points",
                          e3
                            .map(function (e4) {
                              var t6 = zt(e4, 2),
                                i5 = t6[0],
                                n4 = t6[1];
                              return "".concat(i5, ",").concat(n4);
                            })
                            .join(" ")
                        ),
                        Object.assign(o3.style, {
                          pointerEvents: "auto",
                          fill: "transparent",
                          opacity: 0,
                        }),
                        r4.appendChild(o3),
                        r4
                      );
                    })(L2, l2)),
                    document.body.appendChild(h2.current)),
                    l2 ||
                      ((function (e3, t5) {
                        for (
                          var i4 = zt(e3, 2),
                            n3 = i4[0],
                            s4 = i4[1],
                            a3 = !1,
                            r4 = t5.length,
                            o3 = 0,
                            l3 = r4 - 1;
                          o3 < r4;
                          l3 = o3++
                        ) {
                          var c3 = zt(t5[o3] || [0, 0], 2),
                            u3 = c3[0],
                            d3 = c3[1],
                            h3 = zt(t5[l3] || [0, 0], 2),
                            p3 = h3[0],
                            f3 = h3[1];
                          d3 >= s4 != f3 >= s4 &&
                            n3 <= ((p3 - u3) * (s4 - d3)) / (f3 - d3) + u3 &&
                            (a3 = !a3);
                        }
                        return a3;
                      })([m2, g2], L2)
                        ? n2 && !c2 && (e2 = setTimeout(d2, n2))
                        : f2());
                } else Nt(h2);
            } else Nt(h2);
          }
        };
      };
    },
    $t = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "_handleBlur", function () {
            e3.blurElementTimeoutId = setTimeout(function () {
              e3._floatElement && e3._floatElement.hide();
            }, 0);
          }),
          f(x(e3), "_handleFocus", function () {
            e3._floatElement.show(), e3.setTargetListeners("add");
          }),
          f(x(e3), "_handleFirstTargetFocus", function () {
            clearTimeout(e3.blurElementTimeoutId);
          }),
          f(x(e3), "_handleTargetFocus", function () {
            clearTimeout(e3.blurLastTargetTimeoutId);
          }),
          f(x(e3), "_handleLastTargetBlur", function () {
            e3.blurLastTargetTimeoutId = setTimeout(function () {
              e3.setTargetListeners("remove"), e3._floatElement.hide();
            }, 0);
          }),
          f(x(e3), "_handleMouseEnter", function () {
            e3.mouseenterTimeout = setTimeout(function () {
              e3.trigger();
            }, 0);
          }),
          f(x(e3), "_handleElementClick", function () {
            e3.trigger();
          }),
          f(x(e3), "_handleWindowClick", function (t3) {
            var i3 = e3._floatElement.checkCursorOutside(
                t3.clientX,
                t3.clientX
              ),
              n2 = e3._isTargetOutsideFloatElements(t3.target);
            i3 &&
              n2 &&
              (X(window, "click", e3._handleWindowClick),
              e3._floatElement.hide());
          }),
          f(x(e3), "_handleMouseLeave", function (t3) {
            clearTimeout(e3.mouseenterTimeout),
              e3.safePolygonFn &&
                window.removeEventListener("mousemove", e3._handleMouseMove),
              (e3.safePolygonFn = qt()({
                x: t3.clientX,
                y: t3.clientY,
                placement: e3._floatElement.dataset.placement,
                onClose: function () {
                  window.removeEventListener("mousemove", e3._handleMouseMove),
                    e3._floatElement && e3._floatElement.hide(),
                    Nt(e3.polygonRef);
                },
                elements: {
                  domReference: e3.element,
                  floating: e3._floatElement,
                },
                polygonRef: e3.polygonRef,
              })),
              e3.safePolygonFn(t3),
              window.addEventListener("mousemove", e3._handleMouseMove);
          }),
          f(x(e3), "_handleMouseMove", function (t3) {
            e3.safePolygonFn(t3);
          }),
          f(x(e3), "trigger", function () {
            e3._trigger === "click"
              ? (e3._floatElement.isOpen
                  ? e3._floatElement.hide()
                  : e3._floatElement.show(),
                j(window, "click", e3._handleWindowClick))
              : (e3._floatElement.show(),
                j(e3.element, "mouseleave", e3._handleMouseLeave));
          }),
          (e3._trigger =
            e3.dataset.trigger === "click" ? "click" : "mouseenter"),
          (e3.element = e3.getElement()),
          (e3.polygonRef = { current: null }),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              j(this.element, "focus", this._handleFocus),
                j(this.element, "blur", this._handleBlur),
                this.dataset.trigger === "click"
                  ? (j(window, "click", this._handleWindowClick),
                    j(this.element, "click", this._handleElementClick))
                  : (j(this.element, "mouseleave", this._handleMouseLeave),
                    j(this.element, "mouseenter", this._handleMouseEnter));
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              X(this.element, "focus", this._handleFocus),
                X(this.element, "blur", this._handleBlur),
                this.dataset.trigger === "click"
                  ? (X(window, "click", this._handleWindowClick),
                    X(this.element, "click", this._handleElementClick))
                  : (X(this.element, "mouseleave", this._handleMouseLeave),
                    X(this.element, "mouseenter", this._handleMouseEnter));
            },
          },
          {
            key: "setTargetListeners",
            value: function (e3) {
              var t3 = this,
                i3 = this.getTargets(),
                n2 = i3.targets,
                s2 = i3.firstTarget,
                a2 = i3.lastTarget,
                r2 = e3 === "add" ? j : X;
              r2(s2, "focus", this._handleFirstTargetFocus),
                n2.forEach(function (e4) {
                  r2(e4, "focus", t3._handleTargetFocus);
                }),
                r2(a2, "blur", this._handleLastTargetBlur),
                r2(window, "click", this._handleWindowClick);
            },
          },
          {
            key: "getElement",
            value: function () {
              var e3 = '[data-float-element-trigger="'.concat(
                this.dataset.floatElementId,
                '"]'
              );
              return this.querySelector(e3) || this;
            },
          },
          {
            key: "getTargets",
            value: function () {
              var e3 = b(this._floatElement.element.querySelectorAll(W()));
              return {
                targets: e3,
                firstTarget: e3[0],
                lastTarget: e3[e3.length - 1],
              };
            },
          },
          {
            key: "_isTargetOutsideFloatElements",
            value: function (e3) {
              var t3 = this._floatElement.contains(e3),
                i3 = this.contains(e3);
              return !t3 && !i3;
            },
          },
          {
            key: "setExpand",
            value: function (e3) {
              this.setAttribute("data-aria-expanded", e3);
            },
          },
          {
            key: "_floatElement",
            get: function () {
              if (this.dataset.floatElementId)
                return document.getElementById(this.dataset.floatElementId);
            },
          },
          {
            key: "isOpen",
            get: function () {
              return this._floatElement.isOpen;
            },
          },
        ]),
        i2
      );
    })(te),
    Ht = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "_handleBlur", function () {
            var t3 = e3.getTargets().targets;
            e3.blurElementTimeoutId = setTimeout(function () {
              if (!t3.includes(document.activeElement)) {
                if (!e3._floatElement) return;
                e3.setTargetListeners("remove"), e3._floatElement.hide();
              }
            }, 0);
          }),
          f(x(e3), "_handleDropdownShow", function () {
            j(window, "keydown", e3._handleDropdownKeyDown);
          }),
          f(x(e3), "_handleDropdownHide", function () {
            X(window, "keydown", e3._handleDropdownKeyDown);
          }),
          f(x(e3), "_handleKeyUp", function (t3) {
            if (e3._floatElement) {
              var i3 = t3.key || t3.keyCode;
              K(i3) &&
                (e3._floatElement.isOpen ||
                  (e3._floatElement.show(), e3.setTargetListeners("add")));
            }
          }),
          f(x(e3), "_handleDropdownKeyDown", function (t3) {
            if (e3._floatElement) {
              var i3 = t3.key || t3.keyCode,
                n2 = i3 === H || i3 === F;
              e3._floatElement.isOpen &&
                n2 &&
                (e3.element.focus(),
                e3.setTargetListeners("remove"),
                e3._floatElement.hide());
            }
          }),
          f(x(e3), "_handleFirstTargetFocus", function () {
            clearTimeout(e3.blurElementTimeoutId);
          }),
          f(x(e3), "_handleTargetFocus", function () {
            clearTimeout(e3.blurLastTargetTimeoutId);
          }),
          f(x(e3), "_handleLastTargetBlur", function () {
            e3.blurLastTargetTimeoutId = setTimeout(function () {
              e3._floatElement &&
                (e3.setTargetListeners("remove"), e3._floatElement.hide());
            }, 0);
          }),
          f(x(e3), "_handleTrigger", function (t3) {
            t3.preventDefault(), e3.trigger();
          }),
          f(x(e3), "_handleUntrigger", function (t3) {
            var i3 = t3.clientX,
              n2 = t3.clientY,
              s2 = t3.target;
            if (e3._floatElement) {
              var a2 = e3._floatElement.checkCursorOutside(i3, n2),
                r2 = e3._isTargetOutsideFloatElements(s2);
              a2 &&
                r2 &&
                (e3._floatElement.hide(),
                X(window, "click", e3._handleUntrigger));
            }
          }),
          f(x(e3), "trigger", function () {
            e3._floatElement &&
              (e3._floatElement.isOpen
                ? e3._floatElement.hide()
                : e3._floatElement.show(),
              j(window, "click", e3._handleUntrigger));
          }),
          (e3.element = e3.getElement()),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              this._floatElement &&
                (customElements.upgrade(this._floatElement),
                this._floatElement.subscribe("show", this._handleDropdownShow),
                this._floatElement.subscribe("hide", this._handleDropdownHide)),
                j(this.element, "blur", this._handleBlur),
                j(this.element, "keyup", this._handleKeyUp),
                j(this.element, "mousedown", this._handleTrigger);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this._floatElement &&
                (this._floatElement.unsubscribe(
                  "show",
                  this._handleDropdownShow
                ),
                this._floatElement.unsubscribe(
                  "hide",
                  this._handleDropdownHide
                )),
                X(this.element, "blur", this._handleBlur),
                X(this.element, "keyup", this._handleKeyUp),
                X(this.element, "mousedown", this._handleTrigger),
                X(window, "click", this._handleUntrigger);
            },
          },
          {
            key: "setTargetListeners",
            value: function (e3) {
              var t3 = this,
                i3 = this.getTargets(),
                n2 = i3.targets,
                s2 = i3.firstTarget,
                a2 = i3.lastTarget,
                r2 = e3 === "add" ? j : X;
              r2(s2, "focus", this._handleFirstTargetFocus),
                n2.forEach(function (e4) {
                  r2(e4, "focus", t3._handleTargetFocus);
                }),
                r2(a2, "blur", this._handleLastTargetBlur),
                r2(window, "click", this._handleUntrigger);
            },
          },
          {
            key: "getTargets",
            value: function () {
              if (this._floatElement) {
                var e3 = b(this._floatElement.element.querySelectorAll(W()));
                return {
                  targets: e3,
                  firstTarget: e3[0],
                  lastTarget: e3[e3.length - 1],
                };
              }
            },
          },
          {
            key: "_isTargetOutsideFloatElements",
            value: function (e3) {
              if (this._floatElement) {
                var t3 = this._floatElement.contains(e3),
                  i3 = this.contains(e3);
                return !t3 && !i3;
              }
            },
          },
          {
            key: "getElement",
            value: function () {
              var e3 = '[data-float-element-trigger="'.concat(
                this.dataset.floatElementId,
                '"]'
              );
              return this.querySelector(e3) || this;
            },
          },
          {
            key: "setExpand",
            value: function (e3) {
              this.setAttribute("data-aria-expanded", e3);
            },
          },
          {
            key: "_floatElement",
            get: function () {
              return document.querySelector(
                "#".concat(this.dataset.floatElementId)
              );
            },
          },
        ]),
        i2
      );
    })(te),
    Ft = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(
            x((e3 = t2.apply(this, arguments))),
            "_handleMouseEnter",
            function () {
              e3._floatElement && e3._floatElement.show();
            }
          ),
          f(x(e3), "_handleMouseLeave", function () {
            e3._floatElement && e3._floatElement.hide();
          }),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              j(this, "mouseenter", this._handleMouseEnter),
                j(this, "mouseleave", this._handleMouseLeave);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              X(this, "mouseenter", this._handleMouseEnter),
                X(this, "mouseleave", this._handleMouseLeave);
            },
          },
          {
            key: "setExpand",
            value: function (e3) {
              this.setAttribute("data-aria-expanded", e3 ? "true" : "false");
            },
          },
          {
            key: "_floatElement",
            get: function () {
              return this.dataset.floatElementId
                ? document.querySelector(
                    "#".concat(this.dataset.floatElementId)
                  )
                : null;
            },
          },
        ]),
        i2
      );
    })(te),
    Vt = Ft,
    Rt = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "_handleContentResize", function () {
            e3.updateMaxHeight();
          }),
          f(x(e3), "_handleBlockSelect", function (t3) {
            var i3 = t3.detail,
              n2 = i3.sectionId,
              s2 = i3.blockId,
              a2 = i3.load,
              r2 = e3.querySelector(e3._contentWrapperSelector),
              o2 = e3.dataset.sectionId === n2,
              l2 = e3.dataset.blockId === s2;
            o2 &&
              l2 &&
              !e3.isExpanded &&
              (me(r2, a2),
              me(x(e3), a2),
              e3.show().then(function () {
                me(r2, !1), me(x(e3), !1);
              }));
          }),
          f(x(e3), "_handleBlockDeselect", function (t3) {
            var i3 = t3.detail,
              n2 = i3.sectionId,
              s2 = i3.blockId;
            e3.dataset.sectionId === n2 &&
              e3.dataset.blockId === s2 &&
              e3.isExpanded &&
              e3.hide();
          }),
          (e3._contentSelector = "[data-accordeon-content]"),
          (e3._contentWrapperSelector = "[data-accordeon-content-wrapper]"),
          (e3._content = e3.querySelector(e3._contentSelector)),
          (e3._resizeObserver = new ResizeObserver(e3._handleContentResize)),
          (e3.styles = getComputedStyle(x(e3))),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              this.updateMaxHeight(),
                this._content && this._resizeObserver.observe(this._content),
                this._isEditorMode &&
                  (this._editor.subscribe(
                    "BLOCK_SELECT",
                    this._handleBlockSelect
                  ),
                  this._editor.subscribe(
                    "BLOCK_DESELECT",
                    this._handleBlockDeselect
                  ));
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this._resizeObserver.disconnect(),
                this._isEditorMode && this._editor.destroy();
            },
          },
          {
            key: "hide",
            value: function () {
              return this._setExpand(!1), V(this._transitionDuration);
            },
          },
          {
            key: "show",
            value: function () {
              return this._setExpand(!0), V(this._transitionDuration);
            },
          },
          {
            key: "toggle",
            value: function () {
              this._setExpand(!this.isExpanded);
            },
          },
          {
            key: "updateMaxHeight",
            value: function () {
              var e3 = this.closest("accordeon-component"),
                t3 = this.querySelector(this._contentSelector),
                i3 = this.querySelector(this._contentWrapperSelector);
              if (e3 && t3 && i3) {
                var n2 = e3.isExpanded ? t3.offsetHeight : 0;
                i3.style.maxHeight = "".concat(n2, "px");
              }
            },
          },
          {
            key: "_setExpand",
            value: function (e3) {
              window.location.href.includes("/products") &&
                (document
                  .querySelectorAll("accordeon-component")
                  .forEach((el) => {
                    el.setAttribute("data-aria-expanded", "false");
                  }),
                document
                  .querySelectorAll(
                    "accordeon-component [data-accordeon-content-wrapper]"
                  )
                  .forEach((el) => {
                    el.setAttribute("style", "max-height: 0px");
                  })),
                this.setAttribute("data-aria-expanded", e3 ? "true" : "false"),
                this.updateMaxHeight();
            },
          },
          {
            key: "isExpanded",
            get: function () {
              return this.getAttribute("data-aria-expanded") === "true";
            },
          },
          {
            key: "_contentWrapper",
            get: function () {
              return this.querySelector(this._contentWrapperSelector);
            },
          },
          {
            key: "_transitionDuration",
            get: function () {
              return 1e3 * parseFloat(this.styles.transitionDuration);
            },
          },
        ]),
        i2
      );
    })(te),
    jt = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(
            x((e3 = t2.apply(this, arguments))),
            "_handleButtonClick",
            function (t3) {
              t3.preventDefault(), e3.update();
            }
          ),
          f(x(e3), "_handleKeyDown", function (t3) {
            K(t3.key || t3.keyCode) && (t3.preventDefault(), e3.update());
          }),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              this.addEventListener("click", this._handleButtonClick),
                this.addEventListener("keydown", this._handleKeyDown);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeEventListener("click", this._handleButtonClick),
                this.removeEventListener("keydown", this._handleKeyDown);
            },
          },
          {
            key: "update",
            value: function () {
              var e3 = this.closest("accordeon-component");
              e3 && e3.toggle();
            },
          },
        ]),
        i2
      );
    })(te),
    Xt = jt,
    Gt = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "_handleMouseEnter", function () {
            j(e3._productCardInner, "mousemove", e3._handleMouseMove);
          }),
          f(x(e3), "_handleMouseLeave", function () {
            if (e3._productCard) {
              var t3 = e3._productCard.querySelector("[data-main-media]");
              t3 &&
                (e3._selected && e3._reset(),
                e3._setImageVisible(t3, !0),
                X(e3._productCardInner, "mousemove", e3._handleMouseMove));
            }
          }),
          f(x(e3), "_handleMouseMove", function (t3) {
            var i3 = e3._getTabByCoords(t3.clientX, t3.clientY);
            if (e3._productCard && i3) {
              var n2 = e3._productCard.querySelector("[data-main-media]"),
                s2 = e3._productCard.querySelector(
                  '[data-id="'.concat(i3.dataset.id, '"]')
                );
              if (!s2 || !n2) return;
              e3._selected && e3._reset(),
                e3._setTabSelect(i3, !0),
                e3._setImageVisible(s2, !0),
                e3._setImageVisible(n2, !1),
                (e3._selected = { tab: i3, img: s2 });
            }
          }),
          (e3._productCard = e3.closest("product-card")),
          (e3._productCardInner = e3.closest(".product-card__inner")),
          (e3._tabs = b(e3.querySelectorAll("product-media-tab"))),
          (e3._selected = null),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              this.update(),
                j(this._productCard, "mouseenter", this._handleMouseEnter),
                j(this._productCard, "mouseleave", this._handleMouseLeave);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              X(this._productCard, "mouseenter", this._handleMouseEnter),
                X(this._productCard, "mouseleave", this._handleMouseLeave);
            },
          },
          {
            key: "_getTabByCoords",
            value: function (e3, t3) {
              return this._tabs.find(function (i3) {
                var n2 = i3.getBoundingClientRect(),
                  s2 = t3 < n2.y,
                  a2 = e3 - n2.x < n2.width;
                return s2 && a2;
              });
            },
          },
          {
            key: "update",
            value: function () {
              this._tabs.forEach(function (e3, t3) {
                e3.style.display = t3 + 1 > 5 ? "none" : "flex";
              });
            },
          },
          {
            key: "_setTabSelect",
            value: function (e3, t3) {
              e3.classList.toggle("selected", t3);
            },
          },
          {
            key: "_setImageVisible",
            value: function (e3, t3) {
              e3.classList.toggle("product-card__img--visible", t3);
            },
          },
          {
            key: "_reset",
            value: function () {
              this._selected &&
                (this._selected.img.classList.remove(
                  "product-card__img--visible"
                ),
                this._selected.tab.classList.remove("selected"),
                (this._selected = null));
            },
          },
        ]),
        i2
      );
    })(te),
    Wt = (function () {
      "use strict";
      function e2(t2) {
        d(this, e2), (this.element = t2);
      }
      return (
        p(e2, [
          {
            key: "update",
            value: function (e3) {
              var t2, i2, n2;
              this.element.innerText = e3
                ? ((i2 = (t2 = e3).slice(0, 1)),
                  (n2 = t2.slice(1)),
                  i2.toUpperCase() + n2)
                : "";
            },
          },
        ]),
        e2
      );
    })(),
    Yt = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "handleSwatchEnter", function (t3) {
            if (e3._productCard) {
              var i3 = t3.target,
                n2 = i3.dataset.variantId,
                s2 = e3._productCard.querySelector(
                  '[data-variant-id="'.concat(n2, '"]')
                ),
                a2 = i3.dataset.color;
              s2 &&
                e3.mainImage &&
                a2 &&
                (e3.updateLabel(a2),
                e3._setImageVisible(s2, !0),
                e3._setImageVisible(e3.mainImage, !1),
                (e3.currentVisibleImage = s2));
            }
          }),
          f(x(e3), "handleSwatchLeave", function () {
            e3.updateLabel(""),
              e3.currentVisibleImage &&
                e3._setImageVisible(e3.currentVisibleImage, !1),
              e3.mainImage && e3._setImageVisible(e3.mainImage, !0);
          }),
          (e3.hiddenCountSelector = "[data-color-swatches-hidden-count]"),
          (e3.hiddenCountLabelSelector =
            "[data-color-swatches-hidden-count-label]"),
          (e3.labelSelector = "[data-color-swatches-label]"),
          (e3.itemSelector = "[data-color-swatches-item]"),
          (e3._hiddenCount = e3.querySelector(e3.hiddenCountSelector)),
          (e3._hiddenCountLabel = e3.querySelector(
            e3.hiddenCountLabelSelector
          )),
          (e3._label = e3.querySelector(e3.labelSelector)),
          (e3._items = b(e3.querySelectorAll(e3.itemSelector))),
          (e3._productCard = e3.closest("product-card")),
          e3._productCard &&
            (e3.mainImage = e3._productCard.querySelector("[data-main-media]")),
          e3._label && (e3._labelComponent = new Wt(e3._label)),
          (e3._hiddenCountLabelStyles = getComputedStyle(e3._hiddenCountLabel)),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              var e3 = this;
              (this.hiddenCountLabelWidth = parseInt(
                this._hiddenCountLabelStyles.width
              )),
                this.update(),
                this._items.forEach(function (t3) {
                  t3.addEventListener("mouseenter", e3.handleSwatchEnter),
                    t3.addEventListener("mouseleave", e3.handleSwatchLeave);
                });
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              var e3 = this;
              this._items.forEach(function (t3) {
                t3.removeEventListener("mouseenter", e3.handleSwatchEnter),
                  t3.removeEventListener("mouseleave", e3.handleSwatchLeave);
              });
            },
          },
          {
            key: "update",
            value: function () {
              this._setSwatchesOffset(),
                this._setSwatches(),
                this._updateCount();
            },
          },
          {
            key: "_setImageVisible",
            value: function (e3, t3) {
              e3.classList.toggle("product-card__img--visible", t3);
            },
          },
          {
            key: "_setSwatchesOffset",
            value: function () {
              var e3 = this;
              this._items.forEach(function (t3) {
                e3._setVisible(t3, !0),
                  (t3.dataset.x = "".concat(t3.offsetLeft + t3.offsetWidth));
              });
            },
          },
          {
            key: "_setSwatches",
            value: function () {
              var e3 = this;
              this._items.forEach(function (t3) {
                var i3 =
                  +(t3.dataset.x || 0) >
                  e3.offsetWidth - e3.hiddenCountLabelWidth - 12;
                t3.toggleAttribute("visible", !i3);
              }),
                this._items.forEach(function (t3) {
                  var i3 = t3.hasAttribute("visible");
                  e3._setVisible(t3, i3);
                });
            },
          },
          {
            key: "_updateCount",
            value: function () {
              if (this._hiddenCount) {
                var e3 = this._items.filter(function (e4) {
                    return !e4.classList.contains("hide");
                  }),
                  t3 = +(this.dataset.count || 0) - e3.length;
                t3 > 0
                  ? (de(this._hiddenCount),
                    (this._hiddenCountLabel.innerText = "+".concat(t3)))
                  : (he(this._hiddenCount),
                    (this._hiddenCountLabel.innerText = ""));
              }
            },
          },
          {
            key: "updateLabel",
            value: function (e3) {
              this._labelComponent && this._labelComponent.update(e3);
            },
          },
          {
            key: "_setVisible",
            value: function (e3, t3) {
              e3.classList.toggle("hide", !t3);
            },
          },
        ]),
        i2
      );
    })(te),
    Ut = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "_handleKeydown", function (t3) {
            var i3 = t3.key || t3.keyCode;
            (i3 === H || i3 === F) && e3.hide();
          }),
          f(x(e3), "_handleOutsideClick", function (t3) {
            var i3 = document.getElementById("BodyOverlay"),
              n2 = parseFloat(pe(i3, "zIndex")),
              s2 = parseFloat(e3.styles.zIndex) - 1;
            t3.target === i3 && n2 <= s2 && e3.isOpen && e3.hide();
          }),
          (e3._template = e3.querySelector("template")),
          (e3.element = ve(e3._template)),
          (e3.styles = getComputedStyle(x(e3))),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "show",
            value: function () {
              var e3 = this;
              this._mount(),
                this.focus(),
                setTimeout(function () {
                  e3._setOpenState(!0);
                }, 0),
                (this.isOpen = !0);
            },
          },
          {
            key: "hide",
            value: function () {
              var e3 = this;
              return (
                this._setOpenState(!1),
                V(this._transitionDuration).then(function () {
                  e3._unmount(), (e3.isOpen = !1);
                })
              );
            },
          },
          {
            key: "toggle",
            value: function () {
              this.isOpen ? this.hide() : this.show();
            },
          },
          {
            key: "_mount",
            value: function () {
              this.element &&
                !this.contains(this.element) &&
                this.appendChild(this.element);
            },
          },
          {
            key: "_unmount",
            value: function () {
              this.element && this.element.remove();
            },
          },
          {
            key: "_setOpenState",
            value: function (e3) {
              var t3 = this,
                i3 = this.hasAttribute("data-overlay-important"),
                n2 = this.getAttribute("data-overlay-opacity") || 50,
                s2 = {
                  zIndex: i3 ? parseFloat(this.styles.zIndex) - 1 : 3,
                  backgroundColor: "var(--gsc-black-color-".concat(n2, ")"),
                };
              e3
                ? S.showOverlay(this.id, s2)
                : V(this._transitionDuration).then(function () {
                    S.hideOverlay(t3.id);
                  }),
                this._setVisible(e3),
                this._setListeners(e3 ? "add" : "remove"),
                this.emit(e3 ? "show" : "hide", {});
            },
          },
          {
            key: "_setVisible",
            value: function (e3) {
              this.toggleAttribute("open", e3);
            },
          },
          {
            key: "_setListeners",
            value: function (e3) {
              var t3 = this.hasAttribute("data-with-close-on-outside"),
                i3 = "".concat(e3, "EventListener");
              t3 && window[i3]("click", this._handleOutsideClick),
                window[i3]("keydown", this._handleKeydown);
            },
          },
          {
            key: "_transitionDuration",
            get: function () {
              return (
                1e3 * parseFloat(this.styles.transitionDuration) +
                1e3 * parseFloat(this.styles.transitionDelay)
              );
            },
          },
        ]),
        i2
      );
    })(te);
  function Kt(e2, t2, i2) {
    return (
      (Kt =
        typeof Reflect < "u" && Reflect.get
          ? Reflect.get
          : function (e3, t3, i3) {
              var n2 = (function (e4, t4) {
                for (
                  ;
                  !Object.prototype.hasOwnProperty.call(e4, t4) &&
                  (e4 = _(e4)) !== null;

                );
                return e4;
              })(e3, t3);
              if (n2) {
                var s2 = Object.getOwnPropertyDescriptor(n2, t3);
                return s2.get ? s2.get.call(i3 || e3) : s2.value;
              }
            }),
      Kt(e2, t2, i2)
    );
  }
  function Qt(e2, t2, i2) {
    return Kt(e2, t2, i2);
  }
  var Zt = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          ((e3 = t2.call(this)).passwordInput = e3.querySelector(
            "[password-modal-input]"
          )),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "show",
            value: function () {
              Qt(_(i2.prototype), "show", this).call(this),
                this.passwordInput && this.passwordInput.focus();
            },
          },
        ]),
        i2
      );
    })(Ut),
    Jt = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        return d(this, i2), t2.apply(this, arguments);
      }
      return (
        p(i2, [
          {
            key: "showProductFromParsedState",
            value: function (e3, t3) {
              var i3 = e3.sections["cart-notification-popup-content"],
                n2 = ge(i3);
              if (this.element) {
                var s2 = n2.querySelector(
                    "#CartNotificationPopupItem-".concat(t3)
                  ),
                  a2 = this.element.querySelector(
                    "[data-cart-notification-popup]"
                  );
                a2 && s2 && ((a2.innerHTML = ""), a2.appendChild(s2)),
                  this._updateCartCountInHeader(e3),
                  this.show();
              }
            },
          },
          {
            key: "_updateCartCountInHeader",
            value: function (e3) {
              var t3 = e3.sections["cart-count"],
                i3 = ge(t3),
                n2 = document.getElementById("CartCount"),
                s2 = document.getElementById("StickyCartCount"),
                a2 = i3.getElementById("CartCount");
              s2 && a2 && (s2.innerHTML = a2.innerHTML),
                n2 && a2 && (n2.innerHTML = a2.innerHTML);
            },
          },
        ]),
        i2
      );
    })(Ut),
    ei = Jt,
    ti = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(
            x((e3 = t2.apply(this, arguments))),
            "_handleButtonClick",
            function () {
              e3.showModal(), e3.emit("click", {});
            }
          ),
          f(x(e3), "_handleKeyDown", function (t3) {
            if (K(t3.key || t3.keyCode) && e3.dataset.modal) {
              t3.preventDefault();
              var i3 = document.querySelector(e3.dataset.modal);
              i3 && i3.toggle();
            }
          }),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              this.addEventListener("keydown", this._handleKeyDown),
                this.addEventListener("click", this._handleButtonClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeEventListener("keydown", this._handleKeyDown),
                this.removeEventListener("click", this._handleButtonClick);
            },
          },
          {
            key: "showModal",
            value: function () {
              if (this.dataset.modal) {
                var e3 = document.querySelector(this.dataset.modal);
                e3 && e3.show();
              }
            },
          },
        ]),
        i2
      );
    })(te),
    ii = ti,
    ni = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        return d(this, i2), t2.apply(this, arguments);
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              Qt(_(i2.prototype), "connectedCallback", this).call(this),
                this.focus();
            },
          },
        ]),
        i2
      );
    })(ii),
    si = ni,
    ai = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(
            x((e3 = t2.apply(this, arguments))),
            "_handleButtonClick",
            function () {
              e3.hide();
            }
          ),
          f(x(e3), "_handleKeyDown", function (t3) {
            K(t3.key || t3.keyCode) && (t3.preventDefault(), e3.hide());
          }),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              this.addEventListener("keydown", this._handleKeyDown),
                this.addEventListener("click", this._handleButtonClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeEventListener("keydown", this._handleKeyDown),
                this.removeEventListener("click", this._handleButtonClick);
            },
          },
          {
            key: "hide",
            value: function () {
              if (this.dataset.modal) {
                var e3 = document.querySelector(this.dataset.modal);
                e3 && e3.hide();
              }
            },
          },
        ]),
        i2
      );
    })(te),
    ri = ai,
    oi = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "_handleButtonClick", function (e4) {
            e4.preventDefault();
          }),
          f(x(e3), "handleButtonMouseDown", function (t3) {
            t3.preventDefault();
            var i3 = e3.closest("carousel-component"),
              n2 = e3.closest("carousel-dots");
            (e3.isDraggingInCarousel = !(!i3 && !n2)),
              e3.isDraggingInCarousel
                ? (e3.setMoveStartPoint(t3.clientX, t3.clientY),
                  (e3.toggleAfterDraggingInCarousel = !0))
                : e3.toggle();
          }),
          f(x(e3), "handleButtonMouseMove", function (t3) {
            if (e3.isDraggingInCarousel) {
              var i3 = Math.abs(e3.startPointX - t3.clientX),
                n2 = Math.abs(e3.startPointY - t3.clientY);
              (i3 > 24 || n2 > 24) && (e3.toggleAfterDraggingInCarousel = !1);
            }
          }),
          f(x(e3), "handleButtonMouseUp", function () {
            e3.isDraggingInCarousel &&
              (e3.toggleAfterDraggingInCarousel && e3.toggle(),
              (e3.isDraggingInCarousel = !1),
              (e3.toggleAfterDraggingInCarousel = !1),
              e3.setMoveStartPoint(0, 0));
          }),
          f(x(e3), "_handleButtonFocus", function () {
            e3.button &&
              e3.button.addEventListener("keydown", e3.handleKeyDown);
          }),
          f(x(e3), "_handleButtonBlur", function () {
            e3.button &&
              e3.button.removeEventListener("keydown", e3.handleKeyDown);
          }),
          f(x(e3), "handleKeyDown", function (t3) {
            K(t3.key || t3.keyCode) && (t3.preventDefault(), e3.toggle());
          }),
          (e3.buttonSelector = "[data-sidebar-button]"),
          (e3.button = e3.querySelector(e3.buttonSelector)),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              this.button &&
                (this.button.addEventListener("click", this._handleButtonClick),
                this.button.addEventListener("focus", this._handleButtonFocus),
                this.button.addEventListener("blur", this._handleButtonBlur),
                this.button.addEventListener(
                  "mousedown",
                  this.handleButtonMouseDown
                ),
                this.button.addEventListener(
                  "mousemove",
                  this.handleButtonMouseMove
                ),
                this.button.addEventListener(
                  "mouseup",
                  this.handleButtonMouseUp
                ));
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.button &&
                (this.button.removeEventListener(
                  "click",
                  this._handleButtonClick
                ),
                this.button.removeEventListener(
                  "focus",
                  this._handleButtonFocus
                ),
                this.button.removeEventListener("blur", this._handleButtonBlur),
                this.button.removeEventListener(
                  "mousedown",
                  this.handleButtonMouseDown
                ),
                this.button.removeEventListener(
                  "mousemove",
                  this.handleButtonMouseMove
                ),
                this.button.removeEventListener(
                  "mouseup",
                  this.handleButtonMouseUp
                ));
            },
          },
          {
            key: "setMoveStartPoint",
            value: function (e3, t3) {
              (this.startPointX = e3), (this.startPointY = t3);
            },
          },
          {
            key: "toggle",
            value: function () {
              if (this.button) {
                var e3 = this.button.dataset.sidebarId || "",
                  t3 = document.querySelector("#".concat(e3));
                t3 && (t3.toggle(), this.update());
              }
            },
          },
          {
            key: "update",
            value: function () {
              if (this.button) {
                var e3 = this.button.dataset.sidebarId || "",
                  t3 = document.querySelector("#".concat(e3));
                t3 &&
                  this.button.setAttribute(
                    "data-aria-expanded",
                    t3.isOpen ? "true" : "false"
                  );
              }
            },
          },
        ]),
        i2
      );
    })(te),
    li = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "_handleSectionLoad", function () {
            e3._isSection || e3.withOpenOnInit || e3.hide();
          }),
          f(x(e3), "_handleSectionSelect", function (t3) {
            var i3 = t3.detail.sectionId;
            e3._isSection && e3.dataset.sectionId === i3 && e3.open();
          }),
          f(x(e3), "_handleSectionDeselect", function (t3) {
            var i3 = t3.detail.sectionId;
            e3._isSection && e3.dataset.sectionId === i3 && e3.hide();
          }),
          f(x(e3), "_handleOutsideClick", function (t3) {
            var i3 = document.getElementById("BodyOverlay"),
              n2 = parseFloat(pe(i3, "zIndex")),
              s2 = parseFloat(e3.styles.zIndex) - 1;
            t3.target === i3 && n2 <= s2 && e3.isOpen && e3.hide();
          }),
          f(x(e3), "_handleTouchStart", function (t3) {
            (e3._touchStartX = t3.targetTouches[0].clientX),
              (e3._touchStartY = t3.targetTouches[0].clientY);
          }),
          f(x(e3), "_handleTouchMove", function (t3) {
            (e3._touchEndX = t3.targetTouches[0].clientX),
              (e3._touchEndY = t3.targetTouches[0].clientY);
          }),
          f(x(e3), "_handleTouchEnd", function (t3) {
            var i3 = Math.abs(e3._touchStartX - e3._touchEndX),
              n2 = Math.abs(e3._touchStartY - e3._touchEndY);
            if (
              !(
                t3.target.closest("[data-carousel-viewport]") ||
                e3._touchEndX === 0 ||
                n2 > 48
              )
            ) {
              var s2 =
                e3.dataset.openDirection === "right"
                  ? e3._touchStartX < e3._touchEndX
                  : e3._touchStartX > e3._touchEndX;
              e3.isOpen && i3 > 96 && s2 && e3.hide(), e3.cleanTouchPoints();
            }
          }),
          f(x(e3), "_handleKeydown", function (t3) {
            var i3 = t3.key || t3.keyCode;
            e3.hasAttribute("data-with-close-on-escape") &&
              (i3 === H || i3 === F) &&
              e3.hide();
          }),
          (e3._template = e3.querySelector("template")),
          (e3.element = ve(e3._template)),
          (e3.buttonSelector = '[data-sidebar-button][data-sidebar-id="'.concat(
            e3.id,
            '"]'
          )),
          (e3.styles = getComputedStyle(x(e3))),
          e3.withOpenOnInit && e3.open(),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              this.addEventListener("touchstart", this._handleTouchStart),
                this.addEventListener("touchmove", this._handleTouchMove),
                this.addEventListener("touchend", this._handleTouchEnd),
                this._isEditorMode &&
                  (this._editor.subscribe(
                    "SECTION_LOAD",
                    this._handleSectionLoad
                  ),
                  this._editor.subscribe(
                    "SECTION_SELECT",
                    this._handleSectionSelect
                  ),
                  this._editor.subscribe(
                    "SECTION_DESELECT",
                    this._handleSectionDeselect
                  ));
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeEventListener("touchstart", this._handleTouchStart),
                this.removeEventListener("touchmove", this._handleTouchMove),
                this.removeEventListener("touchend", this._handleTouchEnd),
                this._isEditorMode && this._editor.destroy();
            },
          },
          {
            key: "cleanTouchPoints",
            value: function () {
              (this._touchStartX = 0),
                (this._touchEndX = 0),
                (this._touchStartY = 0),
                (this._touchEndY = 0);
            },
          },
          {
            key: "open",
            value: function () {
              // handleFloCartBtn();
              var e3 = this;
              return (
                this.classList.contains("sidebar-cart") &&
                  document
                    .querySelector("#pop-club-quick-buy3")
                    ?.classList.add("hidden"),
                this.mount(),
                this.setAttribute("tabindex", "-1"),
                this.focus(),
                setTimeout(function () {
                  e3._setOpenState(!0);
                }, 0),
                V(this._transitionDuration)
              );
            },
          },
          {
            key: "hide",
            value: function (e3) {
              var t3 = this;
              if (
                (this.classList.contains("sidebar-cart") &&
                  document
                    .querySelector("#pop-club-quick-buy3")
                    ?.classList.remove("hidden"),
                this._setOpenState(!1),
                !e3)
              )
                return V(this._transitionDuration).then(function () {
                  t3.unmount();
                });
              this.unmount();
            },
          },
          {
            key: "toggle",
            value: function () {
              this.isOpen ? this.hide() : this.open();
            },
          },
          {
            key: "mount",
            value: function () {
              this.contains(this.element) || this.appendChild(this.element);
            },
          },
          {
            key: "unmount",
            value: function () {
              this.element && this.element.remove();
            },
          },
          {
            key: "updateTemplate",
            value: function (e3) {
              this.element.remove(),
                (this.element = ve(e3)),
                this.appendChild(this.element);
            },
          },
          {
            key: "_setOpenState",
            value: function (e3) {
              var t3 = this,
                i3 = this.hasAttribute("data-with-overlay"),
                n2 = document.querySelectorAll(this.buttonSelector);
              if (
                (this._setVisible(e3),
                this._setListeners(e3 ? "add" : "remove"),
                localStorage.setItem("sidebar-".concat(this.id), "".concat(e3)),
                i3)
              ) {
                var s2 = this.hasAttribute("data-overlay-important"),
                  a2 = this.hasAttribute("data-overlay-with-blur"),
                  r2 = +(this.getAttribute("data-overlay-opacity") || 50),
                  o2 = {
                    zIndex: s2 ? parseFloat(this.styles.zIndex) - 1 : 3,
                    backdropFilter: a2 ? "blur(16.5px)" : "none",
                    backgroundColor: "var(--gsc-black-color-".concat(r2, ")"),
                  };
                e3
                  ? S.showOverlay(this.id, o2)
                  : V(this._transitionDuration).then(function () {
                      S.hideOverlay(t3.id);
                    });
              }
              n2.forEach(function (t4) {
                t4.setAttribute("data-aria-expanded", e3 ? "true" : "false");
              });
            },
          },
          {
            key: "_setVisible",
            value: function (e3) {
              this.setAttribute("data-aria-expanded", e3 ? "true" : "false");
            },
          },
          {
            key: "_setListeners",
            value: function (e3) {
              var t3 = this.hasAttribute("data-with-close-on-outside"),
                i3 = "".concat(e3, "EventListener");
              t3 && window[i3]("click", this._handleOutsideClick),
                window[i3]("keydown", this._handleKeydown);
            },
          },
          {
            key: "_isSection",
            get: function () {
              return this.hasAttribute("data-sidebar-section");
            },
          },
          {
            key: "isOpen",
            get: function () {
              return this.getAttribute("data-aria-expanded") === "true";
            },
          },
          {
            key: "withOpenOnInit",
            get: function () {
              return this.hasAttribute("data-with-open-on-init");
            },
          },
          {
            key: "isOpenBeforeSectionChange",
            get: function () {
              return (
                localStorage.getItem("sidebar-".concat(this.id)) === "true"
              );
            },
          },
          {
            key: "_transitionDuration",
            get: function () {
              return (
                1e3 * parseFloat(this.styles.transitionDuration) +
                1e3 * parseFloat(this.styles.transitionDelay)
              );
            },
          },
        ]),
        i2
      );
    })(te),
    ci = function () {
      return matchMedia("(max-width: 768px)").matches;
    },
    ui = function () {
      return matchMedia("(prefers-reduced-motion: reduce)").matches;
    },
    di = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "_handleClick", function (t3) {
            var i3 = t3.target,
              n2 = ci(),
              s2 = i3 === e3._searchInput,
              a2 = i3.tagName === "A",
              r2 = i3.closest("[data-sidebar-search-query]");
            if (e3._searchInput && r2) {
              var o2 = new Event("input", { bubbles: !0 });
              (e3._searchInput.value = "".concat(
                r2.getAttribute("data-sidebar-search-query")
              )),
                e3._searchInput.dispatchEvent(o2),
                e3._searchInput.focus();
            }
            n2 && s2 && (e3.isInputFocused = !0),
              !s2 &&
                e3.isInputFocused &&
                (a2 && t3.preventDefault(), (e3.isInputFocused = !1));
          }),
          f(x(e3), "_handleInputFocus", function () {
            ci() && (e3.isInputFocused = !0);
          }),
          f(x(e3), "_handleSearchSidebarTouchEnd", function (t3) {
            var i3 = t3.target,
              n2 = Math.abs(e3._touchStartX - e3._touchEndX),
              s2 = Math.abs(e3._touchStartY - e3._touchEndY),
              a2 = n2 > 12 || s2 > 12,
              r2 = i3.tagName === "A";
            e3.isInputFocused &&
              a2 &&
              e3._searchInput &&
              (r2 && t3.preventDefault(),
              e3._searchInput.blur(),
              (e3.isInputFocused = !1)),
              e3.cleanTouchPoints();
          }),
          f(x(e3), "_handleContentResultsResize", function () {
            e3.updateViewport();
          }),
          f(x(e3), "_handleContentScroll", function () {
            if (e3.content) {
              var t3 = e3.checkContentOverflow(),
                i3 = e3.content.scrollTop > 0;
              e3.toggleAttribute("header-shadow-visible", t3 && i3);
            }
          }),
          (e3.searchInputSelector = "[data-sidebar-search-input]"),
          (e3.searchInputComponentSelector =
            "[data-sidebar-search-input-component]"),
          (e3.contentSelector = "[data-sidebar-search-content]"),
          (e3.contentResultsSelector = "[data-sidebar-search-content-results]"),
          (e3.content = e3.element.querySelector(e3.contentSelector)),
          (e3.contentResults = e3.element.querySelector(
            e3.contentResultsSelector
          )),
          (e3._searchInputComponent = e3.element.querySelector(
            e3.searchInputComponentSelector
          )),
          (e3._searchInput = e3.element.querySelector(e3.searchInputSelector)),
          (e3._resizeObserver = new ResizeObserver(
            e3._handleContentResultsResize
          )),
          (e3.defaultStateElement = document),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              Qt(_(i2.prototype), "connectedCallback", this).call(this),
                this.content &&
                  this.content.addEventListener(
                    "scroll",
                    this._handleContentScroll
                  ),
                this.addEventListener("click", this._handleClick),
                this.addEventListener(
                  "touchend",
                  this._handleSearchSidebarTouchEnd
                ),
                this._searchInput &&
                  this._searchInput.addEventListener(
                    "focus",
                    this._handleInputFocus
                  ),
                this.contentResults &&
                  this._resizeObserver.observe(this.contentResults);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              Qt(_(i2.prototype), "disconnectedCallback", this).call(this),
                this.content &&
                  this.content.removeEventListener(
                    "scroll",
                    this._handleContentScroll
                  ),
                this.removeEventListener("click", this._handleClick),
                this.removeEventListener(
                  "touchend",
                  this._handleSearchSidebarTouchEnd
                ),
                this._searchInput &&
                  this._searchInput.removeEventListener(
                    "focus",
                    this._handleInputFocus
                  ),
                this._resizeObserver.disconnect();
            },
          },
          {
            key: "updateViewport",
            value: function () {
              var e3 = this.checkContentOverflow();
              this.toggleAttribute("footer-shadow-visible", e3);
            },
          },
          {
            key: "open",
            value: function () {
              var e3 = this;
              return Qt(_(i2.prototype), "open", this)
                .call(this)
                .then(function () {
                  e3._searchInput &&
                    !e3._isEditorMode &&
                    e3._searchInput.focus();
                });
            },
          },
          {
            key: "checkContentOverflow",
            value: function () {
              return (
                !(!this.contentResults || !this.content) &&
                this.contentResults.offsetHeight > this.content.offsetHeight
              );
            },
          },
        ]),
        i2
      );
    })(li),
    hi = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          ((e3 = t2.call(this)).containers = b(
            e3.querySelectorAll("[recently-viewed-container]")
          )),
          (e3.cardLimit = +e3.dataset.cardLimit),
          (e3.visibleProductCount = 0),
          (e3.sectionSettings = JSON.parse(e3.dataset.sectionSettings)),
          e3
        );
      }
      return (
        p(
          i2,
          [
            {
              key: "connectedCallback",
              value: function () {
                this.setItems();
              },
            },
            {
              key: "setItems",
              value: function () {
                var e3 = localStorage.getItem("AuroraTheme-RecentlyProducts"),
                  t3 = this.createProducts(JSON.parse(e3));
                this.containers.forEach(function (e4) {
                  e4.innerHTML = t3;
                });
              },
            },
            {
              key: "createProducts",
              value: function (e3) {
                var t3 = this,
                  i3 = "";
                return (
                  Object.keys(e3)
                    .reverse()
                    .forEach(function (n2) {
                      var s2 = t3.prepareTemplate(e3[n2]),
                        a2 = t3.createNodeByString(s2);
                      t3.sectionSettings.product_card_align === "center" &&
                        a2.classList.add("product-card--center-alignment");
                      var r2 = t3._visibleProductCount >= t3.cardLimit,
                        o2 = n2 === t3.dataset.productHandle;
                      r2 ||
                        o2 ||
                        ((i3 = "".concat(i3, " ").concat(a2.outerHTML)),
                        (t3._visibleProductCount += 1));
                    }),
                  i3
                );
              },
            },
            {
              key: "prepareTemplate",
              value: function (e3) {
                return e3.replaceAll(
                  /shape--square|shape--landscape|shape--portrait-xl|shape--portrait/gi,
                  "shape--".concat(this.sectionSettings.img_ratio)
                );
              },
            },
            {
              key: "createNodeByString",
              value: function (e3) {
                return new DOMParser()
                  .parseFromString(e3, "text/html")
                  .querySelector("[recently-viewed-item]");
              },
            },
            {
              key: "setVisible",
              value: function (e3) {
                this.classList.toggle("hidden", !e3);
              },
            },
            {
              key: "_visibleProductCount",
              get: function () {
                return this.visibleProductCount;
              },
              set: function (e3) {
                var t3 = e3 > 0;
                (this.visibleProductCount = e3), this.setVisible(t3);
              },
            },
          ],
          [
            {
              key: "updateProductsInLocalStorage",
              value: function (e3, t3) {
                if (e3 && t3) {
                  var i3 = localStorage.getItem("AuroraTheme-RecentlyProducts"),
                    n2 = ce(v({}, JSON.parse(i3)), f({}, t3, e3));
                  localStorage.setItem(
                    "AuroraTheme-RecentlyProducts",
                    JSON.stringify(n2)
                  );
                }
              },
            },
          ]
        ),
        i2
      );
    })(te),
    pi = window.Shopify,
    fi = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "_handleContentScroll", function () {
            var t3 = !!e3.content && e3.content.scrollTop > 0;
            e3.toggleAttribute("header-shadow-visible", t3);
          }),
          f(x(e3), "openAndRenderProductByUrl", function (t3) {
            e3._cache[t3] &&
              e3._cache[t3].then(function (t4) {
                var n2;
                e3.onThisPageRenderedQuickView &&
                  (e3.onThisPageRenderedQuickView.innerHTML = ""),
                  e3.isOpen
                    ? e3.hide().then(function () {
                        e3._setProductFromHTML(t4),
                          Qt((x(e3), _(i2.prototype)), "open", e3).call(e3);
                      })
                    : (e3._setProductFromHTML(t4),
                      Qt((x(e3), _(i2.prototype)), "open", e3).call(e3)),
                  pi == null ||
                    (n2 = pi.PaymentButton) === null ||
                    n2 === void 0 ||
                    n2.init();
              });
          }),
          (e3._cache = {}),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "requestProductFromUrl",
            value: function (e3, t3) {
              var i3 = this;
              this._cache[e3] ||
                ((this.onThisPageRenderedQuickView = document.querySelector(
                  '.shopify-section [data-quick-view-product-id="'.concat(
                    t3,
                    '"]'
                  )
                )),
                this.onThisPageRenderedQuickView &&
                this.onThisPageRenderedQuickView.dataset.quickViewProductUrl ===
                  e3
                  ? (this._cache[e3] = V(0).then(function () {
                      return i3.onThisPageRenderedQuickView;
                    }))
                  : (this._cache[e3] = fetch(e3)
                      .then(function (e4) {
                        return e4.text();
                      })
                      .then(function (e4) {
                        return ge(e4);
                      })));
            },
          },
          { key: "open", value: function () {} },
          {
            key: "_setProductFromHTML",
            value: function (e3) {
              if (this.dataset.targetId) {
                var t3 = e3.getElementById(this.dataset.targetId);
                if (t3) {
                  hi.updateProductsInLocalStorage(
                    t3.dataset.productString,
                    t3.dataset.productHandle
                  );
                  var i3 = t3.getAttribute("class") || "";
                  this.element.setAttribute("class", i3),
                    (this.element.innerHTML = t3.innerHTML),
                    (this.content = this.element.querySelector(
                      "[data-quick-view-content]"
                    )),
                    this.content &&
                      this.content.addEventListener(
                        "scroll",
                        this._handleContentScroll
                      );
                }
              }
            },
          },
          {
            key: "_resetProduct",
            value: function () {
              this.content &&
                (this.content.removeEventListener(
                  "scroll",
                  this._handleContentScroll
                ),
                this.onThisPageRenderedQuickView &&
                  (this.onThisPageRenderedQuickView.innerHTML =
                    this.content.innerHTML),
                (this.content = null)),
                (this.element.innerHTML = "");
            },
          },
        ]),
        i2
      );
    })(li);
  function vi(e2) {
    return typeof e2 == "number";
  }
  function mi(e2) {
    return typeof e2 == "string";
  }
  function gi(e2) {
    return Object.prototype.toString.call(e2) === "[object Object]";
  }
  function yi(e2) {
    return (
      gi(e2) ||
      (function (e3) {
        return Array.isArray(e3);
      })(e2)
    );
  }
  function bi(e2) {
    return Math.abs(e2);
  }
  function wi(e2) {
    return e2 ? e2 / bi(e2) : 0;
  }
  function Si(e2, t2) {
    return bi(e2 - t2);
  }
  function xi(e2) {
    return Ei(e2).map(Number);
  }
  function Ci(e2) {
    return e2[ki(e2)];
  }
  function ki(e2) {
    return Math.max(0, e2.length - 1);
  }
  function Ei(e2) {
    return Object.keys(e2);
  }
  function Ti(e2, t2) {
    return [e2, t2].reduce(function (e3, t3) {
      return (
        Ei(t3).forEach(function (i2) {
          var n2 = e3[i2],
            s2 = t3[i2],
            a2 = gi(n2) && gi(s2);
          e3[i2] = a2 ? Ti(n2, s2) : s2;
        }),
        e3
      );
    }, {});
  }
  function _i(e2, t2) {
    var i2 = Ei(e2),
      n2 = Ei(t2);
    return (
      i2.length === n2.length &&
      i2.every(function (i3) {
        var n3 = e2[i3],
          s2 = t2[i3];
        return typeof n3 == "function"
          ? "".concat(n3) === "".concat(s2)
          : yi(n3) && yi(s2)
          ? _i(n3, s2)
          : n3 === s2;
      })
    );
  }
  function Mi(e2, t2) {
    var i2 = function (t3) {
        return t3 < e2;
      },
      n2 = function (e3) {
        return e3 > t2;
      },
      s2 = function (e3) {
        return i2(e3) || n2(e3);
      },
      a2 = bi(e2 - t2);
    return {
      length: a2,
      max: t2,
      min: e2,
      constrain: function (n3) {
        return s2(n3) ? (i2(n3) ? e2 : t2) : n3;
      },
      reachedAny: s2,
      reachedMax: n2,
      reachedMin: i2,
      removeOffset: function (e3) {
        return a2 ? e3 - a2 * Math.ceil((e3 - t2) / a2) : e3;
      },
    };
  }
  function Li(e2, t2, i2) {
    var n2 = function (e3) {
        return i2 ? bi((c2 + e3) % c2) : l2(e3);
      },
      s2 = function () {
        return u2;
      },
      a2 = function (e3) {
        return (u2 = n2(e3)), d2;
      },
      r2 = Mi(0, e2),
      o2 = r2.min,
      l2 = r2.constrain,
      c2 = e2 + 1,
      u2 = n2(t2),
      d2 = {
        add: function (e3) {
          return a2(s2() + e3);
        },
        clone: function () {
          return Li(e2, s2(), i2);
        },
        get: s2,
        set: a2,
        min: o2,
        max: e2,
      };
    return d2;
  }
  function Pi() {
    var e2 = [],
      t2 = {
        add: function (i2, n2, s2, a2) {
          return (
            a2 === void 0 && (a2 = { passive: !0 }),
            i2.addEventListener(n2, s2, a2),
            e2.push(function () {
              return i2.removeEventListener(n2, s2, a2);
            }),
            t2
          );
        },
        removeAll: function () {
          return (
            (e2 = e2.filter(function (e3) {
              return e3();
            })),
            t2
          );
        },
      };
    return t2;
  }
  function Ii(e2) {
    var t2 = function (e3) {
        return (n2 /= e3), s2;
      },
      i2 = function (e3) {
        return vi(e3) ? e3 : e3.get();
      },
      n2 = e2,
      s2 = {
        add: function (e3) {
          return (n2 += i2(e3)), s2;
        },
        divide: t2,
        get: function () {
          return n2;
        },
        multiply: function (e3) {
          return (n2 *= e3), s2;
        },
        normalize: function () {
          return n2 !== 0 && t2(n2), s2;
        },
        set: function (e3) {
          return (n2 = i2(e3)), s2;
        },
        subtract: function (e3) {
          return (n2 -= i2(e3)), s2;
        },
      };
    return s2;
  }
  function Di(e2, t2, i2, n2, s2) {
    var a2 = s2.measure(10),
      r2 = s2.measure(50),
      o2 = !1;
    return {
      constrain: function (s3) {
        if (!o2 && e2.reachedAny(i2.get()) && e2.reachedAny(t2.get())) {
          var l2 = e2.reachedMin(t2.get()) ? "min" : "max",
            c2 = bi(e2[l2] - t2.get()),
            u2 = i2.get() - t2.get(),
            d2 = Math.min(c2 / r2, 0.85);
          i2.subtract(u2 * d2),
            !s3 &&
              bi(u2) < a2 &&
              (i2.set(e2.constrain(i2.get())), n2.useSpeed(10).useMass(3));
        }
      },
      toggleActive: function (e3) {
        o2 = !e3;
      },
    };
  }
  function Ai(e2, t2, i2, n2) {
    var s2 = Mi(t2.min + 0.1, t2.max + 0.1),
      a2 = s2.reachedMin,
      r2 = s2.reachedMax;
    return {
      loop: function (t3) {
        if (
          (function (e3) {
            return e3 === 1 ? r2(i2.get()) : e3 === -1 && a2(i2.get());
          })(t3)
        ) {
          var s3 = e2 * (-1 * t3);
          n2.forEach(function (e3) {
            return e3.add(s3);
          });
        }
      },
    };
  }
  function zi(e2) {
    var t2 = e2.max,
      i2 = e2.length;
    return {
      get: function (e3) {
        return (e3 - t2) / -i2;
      },
    };
  }
  function Oi(e2, t2, i2) {
    var n2 =
        e2.scroll === "x"
          ? function (e3) {
              return "translate3d(".concat(e3, "px,0px,0px)");
            }
          : function (e3) {
              return "translate3d(0px,".concat(e3, "px,0px)");
            },
      s2 = i2.style,
      a2 = !1;
    return {
      clear: function () {
        a2 ||
          ((s2.transform = ""),
          i2.getAttribute("style") || i2.removeAttribute("style"));
      },
      to: function (e3) {
        a2 || (s2.transform = n2(t2.apply(e3.get())));
      },
      toggleActive: function (e3) {
        a2 = !e3;
      },
    };
  }
  function Bi(e2, t2, i2, n2, s2, a2, r2, o2, l2) {
    var c2,
      u2,
      d2 = function (e3, t3) {
        return e3.reduce(function (e4, t4) {
          return e4 - s2[t4];
        }, t3);
      },
      h2 = function (e3, t3) {
        return e3.reduce(function (e4, i3) {
          return d2(e4, t3) > 0 ? e4.concat([i3]) : e4;
        }, []);
      },
      p2 = function (i3, s3) {
        var a3 = s3 === "start",
          c3 = a3 ? -n2 : n2,
          u3 = r2.findSlideBounds([c3]);
        return i3.map(function (i4) {
          var s4 = a3 ? 0 : -n2,
            r3 = a3 ? n2 : 0,
            c4 = u3.filter(function (e3) {
              return e3.index === i4;
            })[0][a3 ? "end" : "start"],
            d3 = Ii(-1),
            h3 = Ii(-1),
            p3 = Oi(e2, t2, l2[i4]);
          return {
            index: i4,
            location: h3,
            translate: p3,
            target: function () {
              return d3.set(o2.get() > c4 ? s4 : r3);
            },
          };
        });
      },
      f2 = xi(s2),
      v2 = xi(s2).reverse(),
      m2 = ((c2 = a2[0] - 1), (u2 = h2(v2, c2)), p2(u2, "end")).concat(
        (function () {
          var e3 = i2 - a2[0] - 1,
            t3 = h2(f2, e3);
          return p2(t3, "start");
        })()
      );
    return {
      canLoop: function () {
        return m2.every(function (e3) {
          var t3 = e3.index,
            n3 = f2.filter(function (e4) {
              return e4 !== t3;
            });
          return d2(n3, i2) <= 0.1;
        });
      },
      clear: function () {
        m2.forEach(function (e3) {
          return e3.translate.clear();
        });
      },
      loop: function () {
        m2.forEach(function (e3) {
          var t3 = e3.target,
            i3 = e3.translate,
            n3 = e3.location,
            s3 = t3();
          s3.get() !== n3.get() &&
            (s3.get() === 0 ? i3.clear() : i3.to(s3), n3.set(s3));
        });
      },
      loopPoints: m2,
    };
  }
  function Ni(e2, t2, i2, n2, s2) {
    var a2,
      r2,
      o2,
      l2,
      c2 = n2.align,
      u2 = n2.axis,
      d2 = n2.direction,
      h2 = n2.startIndex,
      p2 = n2.inViewThreshold,
      f2 = n2.loop,
      v2 = n2.speed,
      m2 = n2.dragFree,
      g2 = n2.slidesToScroll,
      y2 = n2.skipSnaps,
      b2 = n2.containScroll,
      w2 = t2.getBoundingClientRect(),
      S2 = i2.map(function (e3) {
        return e3.getBoundingClientRect();
      }),
      x2 = (function (e3) {
        var t3 = e3 === "rtl" ? -1 : 1;
        return {
          apply: function (e4) {
            return e4 * t3;
          },
        };
      })(d2),
      C2 = (function (e3, t3) {
        var i3 = e3 === "y" ? "y" : "x";
        return {
          scroll: i3,
          cross: e3 === "y" ? "x" : "y",
          startEdge: i3 === "y" ? "top" : t3 === "rtl" ? "right" : "left",
          endEdge: i3 === "y" ? "bottom" : t3 === "rtl" ? "left" : "right",
          measureSize: function (e4) {
            var t4 = e4.width,
              n3 = e4.height;
            return i3 === "x" ? t4 : n3;
          },
        };
      })(u2, d2),
      k2 = C2.measureSize(w2),
      E2 = (function (e3) {
        return {
          measure: function (t3) {
            return e3 * (t3 / 100);
          },
        };
      })(k2),
      T2 = (function (e3, t3) {
        var i3 = function (e4) {
            return t3 - e4;
          },
          n3 = {
            start: function () {
              return 0;
            },
            center: function (e4) {
              return i3(e4) / 2;
            },
            end: i3,
          };
        return {
          measure: function (i4) {
            return vi(e3) ? t3 * Number(e3) : n3[e3](i4);
          },
        };
      })(c2, k2),
      _2 = !f2 && b2 !== "",
      M2 = (function (e3, t3, i3, n3, s3) {
        var a3 = e3.measureSize,
          r3 = e3.startEdge,
          o3 = e3.endEdge,
          l3 = i3[0] && s3,
          c3 = (function () {
            if (!l3) return 0;
            var e4 = i3[0];
            return bi(t3[r3] - e4[r3]);
          })(),
          u3 = (function () {
            if (!l3) return 0;
            var e4 = window.getComputedStyle(Ci(n3));
            return parseFloat(e4.getPropertyValue("margin-".concat(o3)));
          })(),
          d3 = i3.map(a3),
          h3 = i3
            .map(function (e4, t4, i4) {
              var n4 = !t4,
                s4 = t4 === ki(i4);
              return n4
                ? d3[t4] + c3
                : s4
                ? d3[t4] + u3
                : i4[t4 + 1][r3] - e4[r3];
            })
            .map(bi);
        return { slideSizes: d3, slideSizesWithGaps: h3 };
      })(C2, w2, S2, i2, f2 || b2 !== ""),
      L2 = M2.slideSizes,
      P2 = M2.slideSizesWithGaps,
      I2 = (function (e3, t3, i3) {
        var n3 = vi(i3);
        return {
          groupSlides: function (s3) {
            return n3
              ? (function (e4, t4) {
                  return xi(e4)
                    .filter(function (e5) {
                      return e5 % t4 == 0;
                    })
                    .map(function (i4) {
                      return e4.slice(i4, i4 + t4);
                    });
                })(s3, i3)
              : (function (i4) {
                  return xi(i4)
                    .reduce(function (i5, n4) {
                      var s4 = t3
                        .slice(Ci(i5), n4 + 1)
                        .reduce(function (e4, t4) {
                          return e4 + t4;
                        }, 0);
                      return !n4 || s4 > e3 ? i5.concat(n4) : i5;
                    }, [])
                    .map(function (e4, t4, n4) {
                      return i4.slice(e4, n4[t4 + 1]);
                    });
                })(s3);
          },
        };
      })(k2, P2, g2),
      D2 = (function (e3, t3, i3, n3, s3, a3, r3) {
        var o3,
          l3 = e3.startEdge,
          c3 = e3.endEdge,
          u3 = a3.groupSlides,
          d3 = u3(n3)
            .map(function (e4) {
              return Ci(e4)[c3] - e4[0][l3];
            })
            .map(bi)
            .map(t3.measure),
          h3 = n3
            .map(function (e4) {
              return i3[l3] - e4[l3];
            })
            .map(function (e4) {
              return -bi(e4);
            }),
          p3 =
            ((o3 = Ci(h3) - Ci(s3)),
            u3(h3)
              .map(function (e4) {
                return e4[0];
              })
              .map(function (e4, t4, i4) {
                var n4 = !t4,
                  s4 = t4 === ki(i4);
                return r3 && n4 ? 0 : r3 && s4 ? o3 : e4 + d3[t4];
              }));
        return { snaps: h3, snapsAligned: p3 };
      })(C2, T2, w2, S2, P2, I2, _2),
      A2 = D2.snaps,
      z2 = D2.snapsAligned,
      O2 = -Ci(A2) + Ci(P2),
      B2 = (function (e3, t3, i3, n3) {
        var s3 = Mi(-t3 + e3, i3[0]),
          a3 = i3.map(s3.constrain);
        return {
          snapsContained: (function () {
            if (t3 <= e3) return [s3.max];
            if (n3 === "keepSnaps") return a3;
            var i4,
              r3,
              o3 =
                ((i4 = a3[0]),
                (r3 = Ci(a3)),
                Mi(a3.lastIndexOf(i4), a3.indexOf(r3) + 1)),
              l3 = o3.min,
              c3 = o3.max;
            return a3.slice(l3, c3);
          })(),
        };
      })(k2, O2, z2, b2).snapsContained,
      N2 = _2 ? B2 : z2,
      q2 = (function (e3, t3, i3) {
        var n3, s3;
        return {
          limit: ((n3 = t3[0]), (s3 = Ci(t3)), Mi(i3 ? n3 - e3 : s3, n3)),
        };
      })(O2, N2, f2).limit,
      $3 = Li(ki(N2), h2, f2),
      H2 = $3.clone(),
      F2 = xi(i2),
      V2 =
        ((a2 = function () {
          f2 || Q2.scrollBounds.constrain(Q2.dragHandler.pointerDown()),
            Q2.scrollBody.seek(X2).update();
          var e3 = Q2.scrollBody.settle(X2);
          e3 &&
            !Q2.dragHandler.pointerDown() &&
            (Q2.animation.stop(), s2.emit("settle")),
            e3 || s2.emit("scroll"),
            f2 &&
              (Q2.scrollLooper.loop(Q2.scrollBody.direction()),
              Q2.slideLooper.loop()),
            Q2.translate.to(j2),
            Q2.animation.proceed();
        }),
        (r2 = function (e3, t3) {
          return function () {
            e3 === !!l2 && t3();
          };
        }),
        (o2 = function () {
          l2 = window.requestAnimationFrame(a2);
        }),
        (l2 = 0),
        {
          proceed: r2(!0, o2),
          start: r2(!1, o2),
          stop: r2(!0, function () {
            window.cancelAnimationFrame(l2), (l2 = 0);
          }),
        }),
      R2 = N2[$3.get()],
      j2 = Ii(R2),
      X2 = Ii(R2),
      G2 = (function (e3, t3, i3) {
        var n3,
          s3 = function (e4) {
            return (d3 = e4), p3;
          },
          a3 = function (e4) {
            return (h3 = e4), p3;
          },
          r3 =
            ((n3 = Math.pow(10, 2)),
            function (e4) {
              return Math.round(e4 * n3) / n3;
            }),
          o3 = Ii(0),
          l3 = Ii(0),
          c3 = Ii(0),
          u3 = 0,
          d3 = t3,
          h3 = i3,
          p3 = {
            direction: function () {
              return u3;
            },
            seek: function (t4) {
              c3.set(t4).subtract(e3);
              var i4,
                n4 = 0 + ((c3.get() - 0) / 100) * (d3 - 0);
              return (
                (u3 = wi(c3.get())),
                c3.normalize().multiply(n4).subtract(o3),
                (i4 = c3).divide(h3),
                l3.add(i4),
                p3
              );
            },
            settle: function (t4) {
              var i4 = t4.get() - e3.get(),
                n4 = !r3(i4);
              return n4 && e3.set(t4), n4;
            },
            update: function () {
              o3.add(l3), e3.add(o3), l3.multiply(0);
            },
            useBaseMass: function () {
              return a3(i3);
            },
            useBaseSpeed: function () {
              return s3(t3);
            },
            useMass: a3,
            useSpeed: s3,
          };
        return p3;
      })(j2, v2, 1),
      W2 = (function (e3, t3, i3, n3, s3) {
        var a3 = function (e4) {
            return e4.concat().sort(function (e5, t4) {
              return bi(e5) - bi(t4);
            })[0];
          },
          r3 = function (t4, n4) {
            var s4 = [t4, t4 + i3, t4 - i3];
            if (!e3) return s4[0];
            if (!n4) return a3(s4);
            var r4 = s4.filter(function (e4) {
              return wi(e4) === n4;
            });
            return a3(r4);
          },
          o3 = n3.reachedAny,
          l3 = n3.removeOffset,
          c3 = n3.constrain;
        return {
          byDistance: function (i4, n4) {
            var a4 = s3.get() + i4,
              u3 = (function (i5) {
                var n5 = e3 ? l3(i5) : c3(i5);
                return {
                  index: t3
                    .map(function (e4) {
                      return e4 - n5;
                    })
                    .map(function (e4) {
                      return r3(e4, 0);
                    })
                    .map(function (e4, t4) {
                      return { diff: e4, index: t4 };
                    })
                    .sort(function (e4, t4) {
                      return bi(e4.diff) - bi(t4.diff);
                    })[0].index,
                  distance: n5,
                };
              })(a4),
              d3 = u3.index,
              h3 = u3.distance,
              p3 = !e3 && o3(a4);
            if (!n4 || p3) return { index: d3, distance: i4 };
            var f3 = t3[d3] - h3;
            return { index: d3, distance: i4 + r3(f3, 0) };
          },
          byIndex: function (e4, i4) {
            var n4 = t3[e4] - s3.get();
            return { index: e4, distance: r3(n4, i4) };
          },
          shortcut: r3,
        };
      })(f2, N2, O2, q2, X2),
      Y2 = (function (e3, t3, i3, n3, s3, a3) {
        var r3 = function (n4) {
          var r4 = n4.distance,
            o3 = n4.index !== t3.get();
          r4 && (e3.start(), s3.add(r4)),
            o3 && (i3.set(t3.get()), t3.set(n4.index), a3.emit("select"));
        };
        return {
          distance: function (e4, t4) {
            var i4 = n3.byDistance(e4, t4);
            r3(i4);
          },
          index: function (e4, i4) {
            var s4 = t3.clone().set(e4),
              a4 = n3.byIndex(s4.get(), i4);
            r3(a4);
          },
        };
      })(V2, $3, H2, W2, X2, s2),
      U2 = (function (e3, t3, i3, n3, s3, a3, r3) {
        var o3 = function (t4, s4) {
            var a4 = t4 || d3,
              r4 = (function (e4) {
                var t5 = e4 || 0;
                return i3.map(function (e5) {
                  return Mi(u3, e5 - u3).constrain(e5 * t5);
                });
              })(s4);
            return a4.reduce(function (t5, s5) {
              var a5 = n3.map(function (t6, n4) {
                return {
                  start: t6 - i3[n4] + r4[n4] + s5,
                  end: t6 + e3 - r4[n4] + s5,
                  index: n4,
                };
              });
              return t5.concat(a5);
            }, []);
          },
          l3 = s3.removeOffset,
          c3 = s3.constrain,
          u3 = 0.5,
          d3 = a3 ? [0, t3, -t3] : [0],
          h3 = o3(d3, r3);
        return {
          check: function (e4, t4) {
            var i4 = a3 ? l3(e4) : c3(e4);
            return (t4 || h3).reduce(function (e5, t5) {
              var n4 = t5.index,
                s4 = t5.start,
                a4 = t5.end;
              return e5.indexOf(n4) === -1 && s4 < i4 && a4 > i4
                ? e5.concat([n4])
                : e5;
            }, []);
          },
          findSlideBounds: o3,
        };
      })(k2, O2, L2, A2, q2, f2, p2),
      K2 = (function (
        e3,
        t3,
        i3,
        n3,
        s3,
        a3,
        r3,
        o3,
        l3,
        c3,
        u3,
        d3,
        h3,
        p3,
        f3,
        v3
      ) {
        var m3 = function (e4) {
            if (
              !(
                ((B3 = !s3.isTouchEvent(e4)) && e4.button !== 0) ||
                ((t4 = e4.target),
                (r4 = t4.nodeName || ""),
                S3.indexOf(r4) > -1)
              )
            ) {
              var t4,
                r4,
                o4 = Si(n3.get(), a3.get()) >= 2,
                c4 = B3 || !o4;
              (A3 = !0),
                s3.pointerDown(e4),
                C3.set(n3),
                n3.set(a3),
                l3.useBaseMass().useSpeed(80),
                (function () {
                  var e5 = B3 ? document : i3;
                  E3.add(e5, "touchmove", g3, x3)
                    .add(e5, "touchend", y3)
                    .add(e5, "mousemove", g3, x3)
                    .add(e5, "mouseup", y3);
                })(),
                (I3 = s3.readPoint(e4)),
                (D3 = s3.readPoint(e4, w3)),
                d3.emit("pointerDown"),
                c4 && (O3 = !1);
            }
          },
          g3 = function (e4) {
            if (!z3 && !B3) {
              if (!e4.cancelable) return y3(e4);
              var i4 = s3.readPoint(e4),
                a4 = s3.readPoint(e4, w3),
                o4 = Si(i4, I3),
                l4 = Si(a4, D3);
              if (!(z3 = o4 > l4) && !O3) return y3(e4);
            }
            var c4 = s3.pointerMove(e4);
            !O3 && c4 && (O3 = !0),
              r3.start(),
              n3.add(t3.apply(c4)),
              e4.preventDefault();
          },
          y3 = function (e4) {
            var i4 = c3.byDistance(0, !1).index !== u3.get(),
              a4 = s3.pointerUp(e4) * (f3 ? M3 : _3)[B3 ? "mouse" : "touch"],
              r4 = (function (e5, t4) {
                var i5 = u3.clone().add(-1 * wi(e5)),
                  n4 = i5.get() === u3.min || i5.get() === u3.max,
                  s4 = c3.byDistance(e5, !f3).distance;
                return f3 || bi(e5) < T3
                  ? s4
                  : !p3 && n4
                  ? 0.4 * s4
                  : v3 && t4
                  ? 0.5 * s4
                  : c3.byIndex(i5.get(), 0).distance;
              })(t3.apply(a4), i4),
              h4 = (function (e5, t4) {
                if (e5 === 0 || t4 === 0 || bi(e5) <= bi(t4)) return 0;
                var i5 = Si(bi(e5), bi(t4));
                return bi(i5 / e5);
              })(a4, r4),
              m4 = Si(n3.get(), C3.get()) >= 0.5,
              g4 = i4 && h4 > 0.75,
              y4 = bi(a4) < T3,
              b4 = g4 ? 10 : L3,
              w4 = g4 ? P3 + 2.5 * h4 : P3;
            m4 && !B3 && (O3 = !0),
              (z3 = !1),
              (A3 = !1),
              E3.removeAll(),
              l3.useSpeed(y4 ? 9 : b4).useMass(w4),
              o3.distance(r4, !f3),
              (B3 = !1),
              d3.emit("pointerUp");
          },
          b3 = function (e4) {
            O3 && (e4.stopPropagation(), e4.preventDefault());
          },
          w3 = e3.cross,
          S3 = ["INPUT", "SELECT", "TEXTAREA"],
          x3 = { passive: !1 },
          C3 = Ii(0),
          k3 = Pi(),
          E3 = Pi(),
          T3 = h3.measure(20),
          _3 = { mouse: 300, touch: 400 },
          M3 = { mouse: 500, touch: 600 },
          L3 = f3 ? 5 : 16,
          P3 = 1,
          I3 = 0,
          D3 = 0,
          A3 = !1,
          z3 = !1,
          O3 = !1,
          B3 = !1;
        return {
          addActivationEvents: function () {
            var e4 = i3;
            k3.add(
              e4,
              "dragstart",
              function (e5) {
                return e5.preventDefault();
              },
              x3
            )
              .add(e4, "touchmove", function () {}, x3)
              .add(e4, "touchend", function () {})
              .add(e4, "touchstart", m3)
              .add(e4, "mousedown", m3)
              .add(e4, "touchcancel", y3)
              .add(e4, "contextmenu", y3)
              .add(e4, "click", b3, !0);
          },
          clickAllowed: function () {
            return !O3;
          },
          pointerDown: function () {
            return A3;
          },
          removeAllEvents: function () {
            k3.removeAll(), E3.removeAll();
          },
        };
      })(
        C2,
        x2,
        e2,
        X2,
        (function (e3) {
          var t3,
            i3,
            n3 = function (e4) {
              return typeof TouchEvent < "u" && e4 instanceof TouchEvent;
            },
            s3 = function (e4) {
              return e4.timeStamp;
            },
            a3 = function (t4, i4) {
              var s4 = i4 || e3.scroll,
                a4 = "client".concat(s4 === "x" ? "X" : "Y");
              return (n3(t4) ? t4.touches[0] : t4)[a4];
            };
          return {
            isTouchEvent: n3,
            pointerDown: function (e4) {
              return (t3 = e4), (i3 = e4), a3(e4);
            },
            pointerMove: function (e4) {
              var n4 = a3(e4) - a3(i3),
                r3 = s3(e4) - s3(t3) > 170;
              return (i3 = e4), r3 && (t3 = e4), n4;
            },
            pointerUp: function (e4) {
              if (!t3 || !i3) return 0;
              var n4 = a3(i3) - a3(t3),
                r3 = s3(e4) - s3(t3),
                o3 = s3(e4) - s3(i3) > 170,
                l3 = n4 / r3;
              return r3 && !o3 && bi(l3) > 0.1 ? l3 : 0;
            },
            readPoint: a3,
          };
        })(C2),
        j2,
        V2,
        Y2,
        G2,
        W2,
        $3,
        s2,
        E2,
        f2,
        m2,
        y2
      ),
      Q2 = {
        containerRect: w2,
        slideRects: S2,
        animation: V2,
        axis: C2,
        direction: x2,
        dragHandler: K2,
        eventStore: Pi(),
        percentOfView: E2,
        index: $3,
        indexPrevious: H2,
        limit: q2,
        location: j2,
        options: n2,
        scrollBody: G2,
        scrollBounds: Di(q2, j2, X2, G2, E2),
        scrollLooper: Ai(O2, q2, j2, [j2, X2]),
        scrollProgress: zi(q2),
        scrollSnaps: N2,
        scrollTarget: W2,
        scrollTo: Y2,
        slideLooper: Bi(C2, x2, k2, O2, P2, N2, U2, j2, i2),
        slidesToScroll: I2,
        slidesInView: U2,
        slideIndexes: F2,
        target: X2,
        translate: Oi(C2, x2, t2),
      };
    return Q2;
  }
  var qi = {
    align: "center",
    axis: "x",
    container: null,
    slides: null,
    containScroll: "",
    direction: "ltr",
    slidesToScroll: 1,
    breakpoints: {},
    dragFree: !1,
    draggable: !0,
    inViewThreshold: 0,
    loop: !1,
    skipSnaps: !1,
    speed: 10,
    startIndex: 0,
    active: !0,
  };
  function $i() {
    var e2 = function (e3, t2) {
      return Ti(e3, t2 || {});
    };
    return {
      merge: e2,
      areEqual: function (e3, t2) {
        return (
          JSON.stringify(Ei(e3.breakpoints || {})) ===
            JSON.stringify(Ei(t2.breakpoints || {})) && _i(e3, t2)
        );
      },
      atMedia: function (t2) {
        var i2 = t2.breakpoints || {},
          n2 = Ei(i2)
            .filter(function (e3) {
              return window.matchMedia(e3).matches;
            })
            .map(function (e3) {
              return i2[e3];
            })
            .reduce(function (t3, i3) {
              return e2(t3, i3);
            }, {});
        return e2(t2, n2);
      },
    };
  }
  function Hi(e2, t2, i2) {
    var n2,
      s2,
      a2,
      r2,
      o2 = function (e3, t3) {
        var i3 = d2();
        l2(), k2(p2.merge({ startIndex: i3 }, e3), t3), v2.emit("reInit");
      },
      l2 = function () {
        n2.dragHandler.removeAllEvents(),
          n2.animation.stop(),
          n2.eventStore.removeAll(),
          n2.translate.clear(),
          n2.slideLooper.clear(),
          f2.destroy();
      },
      c2 = function (e3) {
        var t3 = n2[e3 ? "target" : "location"].get(),
          i3 = S2.loop ? "removeOffset" : "constrain";
        return n2.slidesInView.check(n2.limit[i3](t3));
      },
      u2 = function (e3, t3, i3) {
        S2.active &&
          !b2 &&
          (n2.scrollBody.useBaseMass().useSpeed(t3 ? 100 : S2.speed),
          n2.scrollTo.index(e3, i3 || 0));
      },
      d2 = function () {
        return n2.index.get();
      },
      h2 = Pi(),
      p2 = $i(),
      f2 = (function () {
        var e3 = function (e4) {
            var t4 = i3(e4.options);
            return function () {
              return !n3(t4, i3(e4.options));
            };
          },
          t3 = $i(),
          i3 = t3.atMedia,
          n3 = t3.areEqual,
          s3 = [],
          a3 = [],
          r3 = {
            init: function (t4, n4) {
              return (
                (a3 = t4.map(e3)),
                (s3 = t4.filter(function (e4) {
                  return i3(e4.options).active;
                })).forEach(function (e4) {
                  return e4.init(n4);
                }),
                t4.reduce(function (e4, t5) {
                  var i4;
                  return Object.assign(e4, (((i4 = {})[t5.name] = t5), i4));
                }, {})
              );
            },
            destroy: function () {
              s3 = s3.filter(function (e4) {
                return e4.destroy();
              });
            },
            haveChanged: function () {
              return a3.some(function (e4) {
                return e4();
              });
            },
          };
        return r3;
      })(),
      v2 = (function () {
        var e3 = function (e4) {
            return t3[e4] || [];
          },
          t3 = {},
          i3 = {
            emit: function (t4) {
              return (
                e3(t4).forEach(function (e4) {
                  return e4(t4);
                }),
                i3
              );
            },
            off: function (n3, s3) {
              return (
                (t3[n3] = e3(n3).filter(function (e4) {
                  return e4 !== s3;
                })),
                i3
              );
            },
            on: function (n3, s3) {
              return (t3[n3] = e3(n3).concat([s3])), i3;
            },
          };
        return i3;
      })(),
      m2 = v2.on,
      g2 = v2.off,
      y2 = o2,
      b2 = !1,
      w2 = p2.merge(qi, Hi.globalOptions),
      S2 = p2.merge(w2),
      x2 = [],
      C2 = 0;
    function k2(t3, i3) {
      if (!b2) {
        if (
          ((w2 = p2.merge(w2, t3)),
          (S2 = p2.atMedia(w2)),
          (function () {
            var t4 = S2.container,
              i4 = S2.slides,
              n3 = mi(t4) ? e2.querySelector(t4) : t4;
            a2 = n3 || e2.children[0];
            var s3 = mi(i4) ? a2.querySelectorAll(i4) : i4;
            r2 = [].slice.call(s3 || a2.children);
          })(),
          (n2 = Ni(e2, a2, r2, S2, v2)),
          (C2 = n2.axis.measureSize(e2.getBoundingClientRect())),
          !S2.active)
        )
          return l2();
        if (
          (n2.translate.to(n2.location),
          (x2 = i3 || x2),
          (s2 = f2.init(x2, E2)),
          S2.loop)
        ) {
          if (!n2.slideLooper.canLoop())
            return (
              l2(), k2({ loop: !1 }, i3), void (w2 = p2.merge(w2, { loop: !0 }))
            );
          n2.slideLooper.loop();
        }
        S2.draggable &&
          a2.offsetParent &&
          r2.length &&
          n2.dragHandler.addActivationEvents();
      }
    }
    var E2 = {
      canScrollNext: function () {
        return n2.index.clone().add(1).get() !== d2();
      },
      canScrollPrev: function () {
        return n2.index.clone().add(-1).get() !== d2();
      },
      clickAllowed: function () {
        return n2.dragHandler.clickAllowed();
      },
      containerNode: function () {
        return a2;
      },
      internalEngine: function () {
        return n2;
      },
      destroy: function () {
        b2 || ((b2 = !0), h2.removeAll(), l2(), v2.emit("destroy"));
      },
      off: g2,
      on: m2,
      plugins: function () {
        return s2;
      },
      previousScrollSnap: function () {
        return n2.indexPrevious.get();
      },
      reInit: y2,
      rootNode: function () {
        return e2;
      },
      scrollNext: function (e3) {
        var t3 = n2.index.clone().add(1);
        u2(t3.get(), e3 === !0, -1);
      },
      scrollPrev: function (e3) {
        var t3 = n2.index.clone().add(-1);
        u2(t3.get(), e3 === !0, 1);
      },
      scrollProgress: function () {
        return n2.scrollProgress.get(n2.location.get());
      },
      scrollSnapList: function () {
        return n2.scrollSnaps.map(n2.scrollProgress.get);
      },
      scrollTo: u2,
      selectedScrollSnap: d2,
      slideNodes: function () {
        return r2;
      },
      slidesInView: c2,
      slidesNotInView: function (e3) {
        var t3 = c2(e3);
        return n2.slideIndexes.filter(function (e4) {
          return t3.indexOf(e4) === -1;
        });
      },
    };
    return (
      k2(t2, i2),
      h2.add(window, "resize", function () {
        var t3 = p2.atMedia(w2),
          i3 = !p2.areEqual(t3, S2),
          s3 = n2.axis.measureSize(e2.getBoundingClientRect()),
          a3 = C2 !== s3,
          r3 = f2.haveChanged();
        (a3 || i3 || r3) && o2(), v2.emit("resize");
      }),
      setTimeout(function () {
        return v2.emit("init");
      }, 0),
      E2
    );
  }
  (Hi.globalOptions = void 0), (Hi.optionsHandler = $i);
  var Fi = {
    active: !0,
    breakpoints: {},
    selected: "is-selected",
    draggable: "is-draggable",
    dragging: "is-dragging",
  };
  function Vi(e2, t2) {
    var i2 = e2.classList;
    t2 && i2.contains(t2) && i2.remove(t2);
  }
  function Ri(e2, t2) {
    var i2 = e2.classList;
    t2 && !i2.contains(t2) && i2.add(t2);
  }
  function ji(e2) {
    var t2,
      i2,
      n2,
      s2,
      a2 = function (e3) {
        e3 === "pointerDown" ? Ri(n2, t2.dragging) : Vi(n2, t2.dragging);
      },
      r2 = function () {
        var e3 = i2.slidesInView(!0);
        i2.slidesNotInView(!0).forEach(function (e4) {
          return Vi(s2[e4], t2.selected);
        }),
          e3.forEach(function (e4) {
            return Ri(s2[e4], t2.selected);
          });
      },
      o2 = Hi.optionsHandler(),
      l2 = o2.merge(Fi, ji.globalOptions),
      c2 = ["select", "pointerUp"],
      u2 = ["pointerDown", "pointerUp"],
      d2 = {
        name: "classNames",
        options: o2.merge(l2, e2),
        init: function (e3) {
          (i2 = e3),
            (t2 = o2.atMedia(d2.options)),
            (n2 = i2.rootNode()),
            (s2 = i2.slideNodes()),
            i2.internalEngine().options.draggable && Ri(n2, t2.draggable),
            t2.dragging &&
              u2.forEach(function (e4) {
                return i2.on(e4, a2);
              }),
            t2.selected &&
              (c2.forEach(function (e4) {
                return i2.on(e4, r2);
              }),
              r2());
        },
        destroy: function () {
          Vi(n2, t2.draggable),
            u2.forEach(function (e3) {
              return i2.off(e3, a2);
            }),
            c2.forEach(function (e3) {
              return i2.off(e3, r2);
            }),
            s2.forEach(function (e3) {
              return Vi(e3, t2.selected);
            });
        },
      };
    return d2;
  }
  ji.globalOptions = void 0;
  var Xi,
    Gi,
    Wi,
    Yi = "idle",
    Ui = "running",
    Ki = "paused",
    Qi = "resumed",
    Zi = (function () {
      "use strict";
      function e2(t2, i2) {
        d(this, e2),
          (this.interval = i2),
          (this.callback = t2),
          (this.state = Yi),
          (this.pausedTime = 0),
          (this.remainingTime = 0);
      }
      return (
        p(e2, [
          {
            key: "proxyCallback",
            value: function () {
              (this.lastFireTime = new Date()), this.callback();
            },
          },
          {
            key: "start",
            value: function () {
              var e3 = this;
              (this.timerId = setInterval(function () {
                return e3.proxyCallback();
              }, this.interval)),
                (this.lastFireTime = new Date()),
                (this.state = Ui);
            },
          },
          {
            key: "pause",
            value: function () {
              (this.state !== Ui && this.state !== Qi) ||
                ((this.remainingTime =
                  this.interval -
                  (new Date() - this.lastFireTime) +
                  this.pausedTime),
                (this.lastPauseTime = new Date()),
                clearInterval(this.timerId),
                clearTimeout(this.resumeId),
                (this.state = Ki));
            },
          },
          {
            key: "resume",
            value: function () {
              var e3 = this;
              this.state === Ki &&
                ((this.pausedTime += new Date() - this.lastPauseTime),
                (this.state = Qi),
                (this.resumeId = setTimeout(function () {
                  return e3.timeoutCallback();
                }, this.remainingTime)));
            },
          },
          {
            key: "timeoutCallback",
            value: function () {
              this.state === Qi &&
                ((this.pausedTime = 0), this.proxyCallback(), this.start());
            },
          },
          {
            key: "stop",
            value: function () {
              this.state !== Yi &&
                (clearInterval(this.timerId),
                clearTimeout(this.resumeId),
                (this.state = Yi));
            },
          },
          {
            key: "setInterval",
            value: function (e3) {
              this.state === Ui
                ? (this.pause(), (this.interval = e3), this.resume())
                : (this.interval = e3);
            },
          },
        ]),
        e2
      );
    })(),
    Ji = {};
  (Xi = Ji),
    (Gi = function () {
      return en;
    }),
    (Wi = function (e2) {
      return (en = e2);
    }),
    Object.defineProperty(Xi, "debounce", {
      get: Gi,
      set: Wi,
      enumerable: !0,
      configurable: !0,
    });
  var en = function (e2, t2) {
      var i2;
      return function () {
        for (
          var n2 = arguments.length, s2 = new Array(n2), a2 = 0;
          a2 < n2;
          a2++
        )
          s2[a2] = arguments[a2];
        clearTimeout(i2),
          (i2 = setTimeout(function () {
            return e2.apply(void 0, s2);
          }, t2));
      };
    },
    tn = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        d(this, i2),
          f(
            x((e3 = t2.call(this))),
            "attributeChangedCallback",
            function (t3, i3, n3) {
              i3 !== n3 && e3.reInit();
            }
          ),
          f(x(e3), "_handleCarouselTargetKeyDown", function (t3) {
            t3.preventDefault();
            var i3 = e3.focusableTargets.findIndex(function (e4) {
                return e4 === t3.target;
              }),
              n3 = e3.focusableTargets[i3],
              s2 = e3.focusableTargets[i3 + 1],
              a2 = e3.focusableTargets[i3 - 1];
            t3.keyCode === 9 &&
              (t3.preventDefault(),
              document.activeElement === n3 && e3.focusScroll(n3),
              t3.shiftKey ||
                (s2 ? e3.focusScroll(s2) : document.activeElement.blur()),
              t3.shiftKey &&
                (a2 ? e3.focusScroll(a2) : document.activeElement.blur()));
          }),
          f(
            x(e3),
            "_handleCarouselResize",
            (0, Ji.debounce)(function () {
              if (e3._isEditorMode) {
                var t3 = ci() ? "mobile" : "desktop";
                e3.lastViewModeIsMobile !== t3 &&
                  e3.forceStopped &&
                  (e3.forcePlay(), e3.changePlayState(!0)),
                  (e3.lastViewModeIsMobile = t3);
              }
              e3.reInit();
            }, 100)
          ),
          f(x(e3), "focusScroll", function (t3) {
            var i3 = e3.slides.findIndex(function (e4) {
              return e4.contains(t3);
            });
            i3 !== -1 && (e3.embla.scrollTo(i3, !0), e3.forceStop()),
              t3.focus();
          }),
          f(x(e3), "_handleCarouselEnter", function () {
            ci() || e3.changePlayState(!1);
          }),
          f(x(e3), "_handleCarouselSelect", function () {
            e3.isTouchOnCarousel && e3.forceStop();
          }),
          f(x(e3), "_handleCarouselPointerUp", function () {
            e3.isTouchOnCarousel = !1;
          }),
          f(x(e3), "_handleCarouselPointerDown", function () {
            e3.isTouchOnCarousel = !0;
          }),
          f(x(e3), "_handleCarouselLeave", function () {
            ci() || e3.changePlayState(!0);
          }),
          f(x(e3), "_handleKeydown", function (t3) {
            var i3 = t3.key || t3.keyCode,
              n3 = Z(i3),
              s2 = Q(i3);
            n3 && e3.embla.scrollPrev(), s2 && e3.embla.scrollNext();
          }),
          f(x(e3), "_handleBlockSelect", function (t3) {
            var i3 = t3.detail,
              n3 = i3.sectionId,
              s2 = i3.blockId,
              a2 = i3.load;
            if (e3.dataset.sectionId === n3) {
              var r2 = e3.embla.slideNodes().findIndex(function (e4) {
                var t4;
                return (
                  ((t4 = e4.attributes["block-id"]) === null || t4 === void 0
                    ? void 0
                    : t4.value) === s2
                );
              });
              r2 !== -1 && (e3.embla.scrollTo(r2, a2), e3.forceStop());
            }
          }),
          f(x(e3), "_handleSectionLoad", function (t3) {
            var i3 = t3.detail.sectionId;
            e3.dataset.sectionId === i3 && e3.reInit();
          }),
          f(x(e3), "_getOptions", function () {
            return {
              loop: e3.dataset.loop === "infinite",
              dragFree: e3.dataset.dragFree,
              draggable:
                !e3.hasAttribute("data-draggable") ||
                e3.dataset.draggable === "true",
              skipSnaps: e3.dataset.skipSnaps || !0,
              align: e3.dataset.align || "start",
              inViewThreshold: +(e3.dataset.inViewThreshhold || 0) || 0.75,
              containScroll: e3.hasAttribute("data-contain-scroll")
                ? e3.dataset.containScroll
                : "trimSnaps",
              axis: e3.dataset.axis === "vertical" ? "y" : "x",
              speed: e3._getSpeed(),
            };
          }),
          f(x(e3), "_getPlugins", function () {
            return [e3._getClassNamesPlugin()];
          }),
          f(x(e3), "changePlayState", function (t3) {
            e3.withAutoplay &&
              (e3.forceStopped ||
                ((e3.isPlay = t3),
                t3 ? e3.autoplay.play() : e3.autoplay.pause(),
                e3.emit("changePlayState", {})));
          }),
          f(x(e3), "reInit", function () {
            var t3 =
                arguments.length > 0 && arguments[0] !== void 0
                  ? arguments[0]
                  : {},
              i3 = v({}, e3._getOptions(), t3),
              n3 = e3._getPlugins();
            e3.embla.reInit(i3, n3);
          }),
          f(x(e3), "scrollNext", function () {
            e3.embla.scrollNext();
          }),
          f(x(e3), "scrollPrev", function () {
            e3.embla.scrollPrev();
          }),
          f(x(e3), "canScrollNext", function () {
            return e3.embla.canScrollNext();
          }),
          f(x(e3), "canScrollPrev", function () {
            return e3.embla.canScrollPrev();
          });
        var n2 = +(e3.dataset.autoplayInterval || 0);
        return (
          (e3.withAutoplay = n2 > 0),
          (e3.isPlay = n2 > 0),
          (e3.forceStopped = !1),
          (e3.resizeObserver = new ResizeObserver(e3._handleCarouselResize)),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              var e3 = this;
              this._setCarousel(),
                (this.focusableTargets = b(this.querySelectorAll(W()))),
                this.focusableTargets.forEach(function (t3) {
                  t3.addEventListener(
                    "keydown",
                    e3._handleCarouselTargetKeyDown
                  );
                }),
                this.withStopOnHover &&
                  (j(this, "mouseenter", this._handleCarouselEnter),
                  j(this, "mouseleave", this._handleCarouselLeave)),
                j(this, "keydown", this._handleKeydown),
                this.resizeObserver.observe(this),
                this.embla.on("select", this._handleCarouselSelect),
                this.embla.on("pointerUp", this._handleCarouselPointerUp),
                this.embla.on("pointerDown", this._handleCarouselPointerDown),
                this._isEditorMode &&
                  (this._editor.subscribe(
                    "BLOCK_SELECT",
                    this._handleBlockSelect
                  ),
                  this._editor.subscribe(
                    "SECTION_LOAD",
                    this._handleSectionLoad
                  ));
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              var e3 = this;
              this.focusableTargets.forEach(function (t3) {
                t3.removeEventListener(
                  "keydown",
                  e3._handleCarouselTargetKeyDown
                );
              }),
                this.resizeObserver.disconnect(),
                this.withStopOnHover &&
                  (X(this, "mouseenter", this._handleCarouselEnter),
                  X(this, "mouseleave", this._handleCarouselLeave)),
                X(this, "keydown", this._handleKeydown),
                this.embla.off("select", this._handleCarouselSelect),
                this.embla.off("pointerUp", this._handleCarouselPointerUp),
                this.embla.off("pointerDown", this._handleCarouselPointerDown),
                this._isEditorMode && this._editor.destroy(),
                this.embla.destroy();
            },
          },
          {
            key: "_setCarousel",
            value: function () {
              var e3,
                t3,
                i3,
                n2 = this.querySelector("[data-carousel-viewport]");
              n2 &&
                ((this.embla = Hi(n2, this._getOptions(), this._getPlugins())),
                this.withAutoplay &&
                  ((this.autoplay =
                    ((e3 = this.embla),
                    (t3 = 1e3 * this.autoplayInterval),
                    (i3 = new Zi(function () {
                      var t4 = e3.scrollSnapList().length - 1;
                      e3.selectedScrollSnap() === t4
                        ? e3.scrollTo(0)
                        : e3.scrollNext();
                    }, t3)),
                    {
                      play: function () {
                        i3.resume();
                      },
                      stop: function () {
                        i3.stop();
                      },
                      start: function () {
                        i3.start();
                      },
                      pause: function () {
                        i3.pause();
                      },
                    })),
                  this.autoplay.start()));
            },
          },
          {
            key: "_getClassNamesPlugin",
            value: function () {
              return ji();
            },
          },
          {
            key: "_getSpeed",
            value: function () {
              return ui() || this.dataset.animation === "fade" ? 100 : 10;
            },
          },
          {
            key: "forceStop",
            value: function () {
              this.withAutoplay &&
                (this.autoplay.stop(),
                (this.isPlay = !1),
                (this.forceStopped = !0),
                this.emit("forceChangePlayState", {}));
            },
          },
          {
            key: "forcePlay",
            value: function () {
              this.withAutoplay &&
                ((this.forceStopped = !1),
                (this.isPlay = !0),
                this.autoplay.start(),
                this.changePlayState(!1),
                this.emit("forceChangePlayState", {}));
            },
          },
          {
            key: "withStopOnHover",
            get: function () {
              return this.hasAttribute("with-stop-on-hover");
            },
          },
          {
            key: "autoplayInterval",
            get: function () {
              return +(this.dataset.autoplayInterval || 0);
            },
          },
          {
            key: "slides",
            get: function () {
              return b(this.embla.slideNodes());
            },
          },
        ]),
        i2
      );
    })(te),
    nn = tn,
    sn = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(
            x((e3 = t2.call(this))),
            "_handleCarouselChangePlayState",
            function () {
              e3.updatePlayState();
            }
          ),
          f(x(e3), "_handleButtonClick", function (t3) {
            t3.stopPropagation(),
              e3._carousel &&
                (e3._carousel.forceStopped
                  ? e3._carousel.forcePlay()
                  : e3._carousel.forceStop());
          }),
          (e3.button = e3.querySelector("[data-carousel-play-button]")),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              this.updatePlayState(),
                this.button &&
                  this.button.addEventListener(
                    "click",
                    this._handleButtonClick
                  ),
                this._carousel &&
                  (customElements.upgrade(this._carousel),
                  this._carousel.subscribe(
                    "forceChangePlayState",
                    this._handleCarouselChangePlayState
                  ));
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.button &&
                this.button.removeEventListener(
                  "click",
                  this._handleButtonClick
                ),
                this._carousel &&
                  this._carousel.unsubscribe(
                    "forceChangePlayState",
                    this._handleCarouselChangePlayState
                  );
            },
          },
          {
            key: "updatePlayState",
            value: function () {
              if (this._carousel && this.button) {
                var e3 = this._carousel.forceStopped;
                this.button.setAttribute(
                  "data-autoplay-stopped",
                  e3 ? "true" : "false"
                );
              }
            },
          },
          {
            key: "_carousel",
            get: function () {
              return this.closest("carousel-component");
            },
          },
        ]),
        i2
      );
    })(te);
  function an() {
    return (
      (an =
        Object.assign ||
        function (e2) {
          for (var t2 = 1; t2 < arguments.length; t2++) {
            var i2 = arguments[t2];
            for (var n2 in i2)
              Object.prototype.hasOwnProperty.call(i2, n2) && (e2[n2] = i2[n2]);
          }
          return e2;
        }),
      an.apply(this, arguments)
    );
  }
  function rn(e2, t2) {
    if (e2.length !== t2.length) throw new Error("vectors must be same length");
    return e2.map(function (e3, i2) {
      return e3 + t2[i2];
    });
  }
  function on(e2) {
    return Math.max.apply(Math, e2.map(Math.abs));
  }
  function ln(e2) {
    return (
      Object.freeze(e2),
      Object.values(e2).forEach(function (e3) {
        e3 === null || typeof e3 != "object" || Object.isFrozen(e3) || ln(e3);
      }),
      e2
    );
  }
  var cn = [1, 18, (typeof window < "u" && window.innerHeight) || 800],
    un = [-1, -1, -1],
    dn = ln({ preventWheelAction: !0, reverseSign: [!0, !0, !1] }),
    hn = function (e2) {
      e2 === void 0 && (e2 = {});
      var t2,
        i2,
        n2,
        s2 = (function () {
          var e3 = function (e4, i3) {
              t3[e4] = (t3[e4] || []).filter(function (e5) {
                return e5 !== i3;
              });
            },
            t3 = {};
          return ln({
            on: function (i3, n3) {
              return (
                (t3[i3] = (t3[i3] || []).concat(n3)),
                function () {
                  return e3(i3, n3);
                }
              );
            },
            off: e3,
            dispatch: function (e4, i3) {
              e4 in t3 &&
                t3[e4].forEach(function (e5) {
                  return e5(i3);
                });
            },
          });
        })(),
        a2 = s2.on,
        r2 = s2.off,
        o2 = s2.dispatch,
        l2 = dn,
        c2 = {
          isStarted: !1,
          isStartPublished: !1,
          isMomentum: !1,
          startTime: 0,
          lastAbsDelta: 1 / 0,
          axisMovement: [0, 0, 0],
          axisVelocity: [0, 0, 0],
          accelerationFactors: [],
          scrollPoints: [],
          scrollPointsToMerge: [],
          willEndTimeout: 400,
        },
        u2 = !1,
        d2 = function (e3) {
          Array.isArray(e3)
            ? e3.forEach(function (e4) {
                return f2(e4);
              })
            : f2(e3);
        },
        h2 = function (e3) {
          return (
            e3 === void 0 && (e3 = {}),
            Object.values(e3).some(function (e4) {
              return e4 == null;
            })
              ? l2
              : (l2 = ln(an({}, dn, l2, e3)))
          );
        },
        p2 = function (e3) {
          var n3 = an(
            {
              event: t2,
              isStart: !1,
              isEnding: !1,
              isMomentumCancel: !1,
              isMomentum: c2.isMomentum,
              axisDelta: [0, 0, 0],
              axisVelocity: c2.axisVelocity,
              axisMovement: c2.axisMovement,
              get axisMovementProjection() {
                return rn(
                  n3.axisMovement,
                  n3.axisVelocity.map(function (e4) {
                    return t3 === void 0 && (t3 = 0.996), (e4 * t3) / (1 - t3);
                    var t3;
                  })
                );
              },
            },
            e3
          );
          o2("wheel", an({}, n3, { previous: i2 })), (i2 = n3);
        },
        f2 = function (e3) {
          var i3 = (function (e4) {
              return an({}, e4, {
                axisDelta: e4.axisDelta.map(function (e5) {
                  return (t3 = e5), Math.min(Math.max(-700, t3), 700);
                  var t3;
                }),
              });
            })(
              (function (e4, t3) {
                if (!t3) return e4;
                var i4 =
                  t3 === !0
                    ? un
                    : t3.map(function (e5) {
                        return e5 ? -1 : 1;
                      });
                return an({}, e4, {
                  axisDelta: e4.axisDelta.map(function (e5, t4) {
                    return e5 * i4[t4];
                  }),
                });
              })(
                (function (e4) {
                  var t3 = e4.deltaX * cn[e4.deltaMode],
                    i4 = e4.deltaY * cn[e4.deltaMode],
                    n4 = (e4.deltaZ || 0) * cn[e4.deltaMode];
                  return { timeStamp: e4.timeStamp, axisDelta: [t3, i4, n4] };
                })(e3),
                l2.reverseSign
              )
            ),
            n3 = i3.axisDelta,
            s3 = i3.timeStamp,
            a3 = on(n3);
          e3.preventDefault &&
            (function (e4, t3) {
              var i4 = l2.preventWheelAction,
                n4 = t3[0],
                s4 = t3[1],
                a4 = t3[2];
              if (typeof i4 == "boolean") return i4;
              switch (i4) {
                case "x":
                  return Math.abs(n4) >= e4;
                case "y":
                  return Math.abs(s4) >= e4;
                case "z":
                  return Math.abs(a4) >= e4;
                default:
                  return !1;
              }
            })(a3, n3) &&
            e3.preventDefault(),
            c2.isStarted
              ? c2.isMomentum &&
                a3 > Math.max(2, 2 * c2.lastAbsDelta) &&
                (k2(!0), x2())
              : x2(),
            a3 === 0 && Object.is && Object.is(e3.deltaX, -0)
              ? (u2 = !0)
              : ((t2 = e3),
                (c2.axisMovement = rn(c2.axisMovement, n3)),
                (c2.lastAbsDelta = a3),
                c2.scrollPointsToMerge.push({ axisDelta: n3, timeStamp: s3 }),
                v2(),
                p2({ axisDelta: n3, isStart: !c2.isStartPublished }),
                (c2.isStartPublished = !0),
                C2());
        },
        v2 = function () {
          var e3;
          c2.scrollPointsToMerge.length === 2
            ? (c2.scrollPoints.unshift({
                axisDeltaSum: c2.scrollPointsToMerge
                  .map(function (e4) {
                    return e4.axisDelta;
                  })
                  .reduce(rn),
                timeStamp:
                  ((e3 = c2.scrollPointsToMerge.map(function (e4) {
                    return e4.timeStamp;
                  })),
                  e3.reduce(function (e4, t3) {
                    return e4 + t3;
                  }) / e3.length),
              }),
              g2(),
              (c2.scrollPointsToMerge.length = 0),
              (c2.scrollPoints.length = 1),
              c2.isMomentum || w2())
            : c2.isStartPublished || m2();
        },
        m2 = function () {
          var e3;
          c2.axisVelocity = ((e3 = c2.scrollPointsToMerge),
          e3[e3.length - 1]).axisDelta.map(function (e4) {
            return e4 / c2.willEndTimeout;
          });
        },
        g2 = function () {
          var e3 = c2.scrollPoints,
            t3 = e3[0],
            i3 = e3[1];
          if (i3 && t3) {
            var n3 = t3.timeStamp - i3.timeStamp;
            if (!(n3 <= 0)) {
              var s3 = t3.axisDeltaSum.map(function (e4) {
                  return e4 / n3;
                }),
                a3 = s3.map(function (e4, t4) {
                  return e4 / (c2.axisVelocity[t4] || 1);
                });
              (c2.axisVelocity = s3), c2.accelerationFactors.push(a3), y2(n3);
            }
          }
        },
        y2 = function (e3) {
          var t3 = 12 * Math.ceil(e3 / 10);
          c2.isMomentum || (t3 = Math.max(100, 2 * t3)),
            (c2.willEndTimeout = Math.min(1e3, Math.round(t3)));
        },
        b2 = function (e3) {
          return e3 === 0 || (e3 <= 0.96 && e3 >= 0.6);
        },
        w2 = function () {
          if (c2.accelerationFactors.length >= 5) {
            if (u2 && ((u2 = !1), on(c2.axisVelocity) >= 0.2)) return void S2();
            var e3 = c2.accelerationFactors.slice(-5);
            e3.every(function (e4) {
              var t3 = !!e4.reduce(function (e5, t4) {
                  return e5 && e5 < 1 && e5 === t4 ? 1 : 0;
                }),
                i3 = e4.filter(b2).length === e4.length;
              return t3 || i3;
            }) && S2(),
              (c2.accelerationFactors = e3);
          }
        },
        S2 = function () {
          c2.isMomentum = !0;
        },
        x2 = function () {
          ((c2 = {
            isStarted: !1,
            isStartPublished: !1,
            isMomentum: !1,
            startTime: 0,
            lastAbsDelta: 1 / 0,
            axisMovement: [0, 0, 0],
            axisVelocity: [0, 0, 0],
            accelerationFactors: [],
            scrollPoints: [],
            scrollPointsToMerge: [],
            willEndTimeout: 400,
          }).isStarted = !0),
            (c2.startTime = Date.now()),
            (i2 = void 0),
            (u2 = !1);
        },
        C2 = function () {
          clearTimeout(n2), (n2 = setTimeout(k2, c2.willEndTimeout));
        },
        k2 = function (e3) {
          e3 === void 0 && (e3 = !1),
            c2.isStarted &&
              (c2.isMomentum && e3
                ? p2({ isEnding: !0, isMomentumCancel: !0 })
                : p2({ isEnding: !0 }),
              (c2.isMomentum = !1),
              (c2.isStarted = !1));
        },
        E2 = (function (e3) {
          var t3 = [],
            i3 = function (i4) {
              i4.removeEventListener("wheel", e3),
                (t3 = t3.filter(function (e4) {
                  return e4 !== i4;
                }));
            };
          return ln({
            observe: function (n3) {
              return (
                n3.addEventListener("wheel", e3, { passive: !1 }),
                t3.push(n3),
                function () {
                  return i3(n3);
                }
              );
            },
            unobserve: i3,
            disconnect: function () {
              t3.forEach(i3);
            },
          });
        })(d2),
        T2 = E2.observe,
        _2 = E2.unobserve,
        M2 = E2.disconnect;
      return (
        h2(e2),
        ln({
          on: a2,
          off: r2,
          observe: T2,
          unobserve: _2,
          disconnect: M2,
          feedWheel: d2,
          updateOptions: h2,
        })
      );
    },
    pn = {
      active: !0,
      breakpoints: {},
      wheelDraggingClass: "is-wheel-dragging",
      forceWheelAxis: void 0,
      target: void 0,
    };
  vn.globalOptions = void 0;
  var fn = !1;
  function vn(e2) {
    var t2,
      i2 = Hi.optionsHandler(),
      n2 = i2.merge(pn, vn.globalOptions),
      s2 = function () {},
      a2 = {
        name: "wheelGestures",
        options: i2.merge(n2, e2),
        init: function (e3) {
          var n3, r2;
          t2 = i2.atMedia(a2.options);
          var o2,
            l2 = e3.internalEngine(),
            c2 = (n3 = t2.target) != null ? n3 : e3.containerNode().parentNode,
            u2 = (r2 = t2.forceWheelAxis) != null ? r2 : l2.options.axis,
            d2 = hn({ preventWheelAction: u2, reverseSign: [!0, !0, !1] }),
            h2 = d2.observe(c2),
            p2 = d2.on("wheel", function (e4) {
              var i3 = e4.axisDelta,
                n4 = i3[0],
                a3 = i3[1],
                r3 = u2 === "x" ? n4 : a3,
                l3 = u2 === "x" ? a3 : n4,
                d3 = e4.isMomentum && e4.previous && !e4.previous.isMomentum,
                h3 = (e4.isEnding && !e4.isMomentum) || d3;
              Math.abs(r3) > Math.abs(l3) &&
                !f2 &&
                !e4.isMomentum &&
                (function (e5) {
                  try {
                    y2((o2 = new MouseEvent("mousedown", e5.event)));
                  } catch {
                    return (
                      fn &&
                        console.warn(
                          "Legacy browser requires events-polyfill (https://github.com/xiel/embla-carousel-wheel-gestures#legacy-browsers)"
                        ),
                      s2()
                    );
                  }
                  (f2 = !0),
                    document.documentElement.addEventListener(
                      "mousemove",
                      m2,
                      !0
                    ),
                    document.documentElement.addEventListener(
                      "mouseup",
                      m2,
                      !0
                    ),
                    document.documentElement.addEventListener(
                      "mousedown",
                      m2,
                      !0
                    ),
                    t2.wheelDraggingClass &&
                      c2.classList.add(t2.wheelDraggingClass);
                })(e4),
                f2 &&
                  (h3
                    ? (function (e5) {
                        (f2 = !1),
                          y2(g2("mouseup", e5)),
                          v2(),
                          t2.wheelDraggingClass &&
                            c2.classList.remove(t2.wheelDraggingClass);
                      })(e4)
                    : y2(g2("mousemove", e4)));
            }),
            f2 = !1;
          function v2() {
            document.documentElement.removeEventListener("mousemove", m2, !0),
              document.documentElement.removeEventListener("mouseup", m2, !0),
              document.documentElement.removeEventListener("mousedown", m2, !0);
          }
          function m2(e4) {
            f2 && e4.isTrusted && e4.stopImmediatePropagation();
          }
          function g2(e4, t3) {
            var i3, n4;
            if (u2 === l2.options.axis) {
              var s3 = t3.axisMovement;
              (i3 = s3[0]), (n4 = s3[1]);
            } else {
              var a3 = t3.axisMovement;
              (n4 = a3[0]), (i3 = a3[1]);
            }
            return new MouseEvent(e4, {
              clientX: o2.clientX + i3,
              clientY: o2.clientY + n4,
              screenX: o2.screenX + i3,
              screenY: o2.screenY + n4,
              movementX: i3,
              movementY: n4,
              button: 0,
              bubbles: !0,
              cancelable: !0,
              composed: !0,
            });
          }
          function y2(t3) {
            e3.containerNode().dispatchEvent(t3);
          }
          s2 = function () {
            h2(), p2(), v2();
          };
        },
        destroy: function () {
          return s2();
        },
      };
    return a2;
  }
  var mn = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "_handleDotCarouselSettle", function () {
            e3.updateDots();
          }),
          f(x(e3), "_handleCarouselReInit", function () {
            e3.embla.reInit(e3._getOptions(), e3._getPlugins());
          }),
          f(
            x(e3),
            "_handleCarouselResize",
            (0, Ji.debounce)(function () {
              e3.embla.reInit(e3._getOptions(), e3._getPlugins()),
                e3.updateDots();
            }, 100)
          ),
          f(x(e3), "_handleCarouselSelect", function () {
            if (e3._carousel) {
              var t3 = b(e3.embla.slideNodes()),
                i3 = e3._carousel.embla.selectedScrollSnap();
              t3.forEach(function (e4) {
                var t4 = +e4.dataset.dotIndex === i3;
                e4.classList.toggle("is-primary", t4);
              }),
                e3.embla.scrollTo(i3);
            }
          }),
          f(x(e3), "_getOptions", function () {
            return {
              inViewThreshold: +(e3.dataset.inViewThreshhold || 0) || 0.5,
              containScroll: e3.hasAttribute("data-contain-scroll")
                ? e3.dataset.containScroll
                : "keepSnaps",
              align: e3.dataset.align || "center",
              speed: e3._getSpeed(),
              skipSnaps: e3.hasAttribute("data-skip-snaps"),
              draggable: e3.hasAttribute("is-draggable"),
              axis: e3._axis,
            };
          }),
          f(x(e3), "_getPlugins", function () {
            var t3 = [],
              i3 = ji();
            if ((t3.push(i3), e3.hasAttribute("data-with-wheel-gestures"))) {
              var n2 = vn({ forceWheelAxis: e3._axis });
              t3.push(n2);
            }
            return t3;
          }),
          f(x(e3), "scrollNext", function () {
            e3._carousel && e3._carousel.embla.scrollNext();
          }),
          f(x(e3), "scrollPrev", function () {
            e3._carousel && e3._carousel.embla.scrollPrev();
          }),
          f(x(e3), "canScrollNext", function () {
            return !!e3._carousel && e3._carousel.embla.canScrollNext();
          }),
          f(x(e3), "canScrollPrev", function () {
            return !!e3._carousel && e3._carousel.embla.canScrollPrev();
          }),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              this._init(),
                this.updateDots(),
                this._carousel &&
                  (this._carousel.embla.on(
                    "reInit",
                    this._handleCarouselReInit
                  ),
                  this._carousel.embla.on(
                    "select",
                    this._handleCarouselSelect
                  )),
                this.embla.on("resize", this._handleCarouselResize),
                this.embla.on("settle", this._handleDotCarouselSettle);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this._carousel &&
                (this._carousel.embla.off("reInit", this._handleCarouselReInit),
                this._carousel.embla.off("select", this._handleCarouselSelect)),
                this.embla.off("settle", this._handleDotCarouselSettle),
                this.embla.off("resize", this._handleCarouselResize),
                this.embla.destroy();
            },
          },
          {
            key: "_getSpeed",
            value: function () {
              return ui() ? 100 : 80;
            },
          },
          {
            key: "_init",
            value: function () {
              var e3 = this.querySelector("[data-carousel-viewport]");
              e3 &&
                (this.embla = Hi(e3, this._getOptions(), this._getPlugins()));
            },
          },
          {
            key: "updateDots",
            value: function () {
              var e3 = b(this.embla.slideNodes()),
                t3 = e3.map(function (e4, t4) {
                  return t4;
                }),
                i3 = this.embla.slidesInView();
              e3.forEach(function (e4, n2) {
                e4.classList.remove("is-prev-prev");
                var s2 = i3[0],
                  a2 = i3[i3.length - 1],
                  r2 = t3[0],
                  o2 = t3[t3.length - 1];
                (n2 !== s2 && n2 !== a2) ||
                  n2 === o2 ||
                  n2 === r2 ||
                  e4.classList.add("is-prev-prev");
              });
            },
          },
          {
            key: "_carousel",
            get: function () {
              return this.closest("carousel-component");
            },
          },
          {
            key: "_axis",
            get: function () {
              return this.dataset.axis === "vertical" ? "y" : "x";
            },
          },
        ]),
        i2
      );
    })(te),
    gn = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(
            x((e3 = t2.call(this))),
            "_handleCarouselForceChangePlayState",
            function () {
              if (e3._autoplayLoader && e3._carousel) {
                var t3 = e3._carousel.forceStopped;
                e3._autoplayLoader.setAttribute(
                  "data-autoplay-stopped",
                  t3 ? "true" : "false"
                );
              }
            }
          ),
          f(x(e3), "_handleCarouselChangePlayState", function () {
            e3._updateAutoplayIndicator();
          }),
          f(x(e3), "_handleDotClick", function () {
            e3.scroll();
          }),
          f(x(e3), "_handleKeyDown", function (t3) {
            K(t3.key || t3.keyCode) && (t3.preventDefault(), e3.scroll());
          }),
          (e3._autoplayLoader = e3.querySelector("[data-autoplay-indicator]")),
          (e3._dotsCarousel = e3.closest("carousel-dots")),
          (e3.dotIndex = +e3.dataset.dotIndex),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              this._updateAutoplayIndicator(),
                this._carousel &&
                  (customElements.upgrade(this._carousel),
                  this._carousel.subscribe(
                    "changePlayState",
                    this._handleCarouselChangePlayState
                  ),
                  this._carousel.subscribe(
                    "forceChangePlayState",
                    this._handleCarouselForceChangePlayState
                  )),
                this.addEventListener("keydown", this._handleKeyDown),
                this.addEventListener("click", this._handleDotClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this._carousel &&
                (this._carousel.unsubscribe(
                  "changePlayState",
                  this._handleCarouselChangePlayState
                ),
                this._carousel.unsubscribe(
                  "forceChangePlayState",
                  this._handleCarouselForceChangePlayState
                )),
                this.removeEventListener("keydown", this._handleKeyDown),
                this.removeEventListener("click", this._handleDotClick);
            },
          },
          {
            key: "_updateAutoplayIndicator",
            value: function () {
              if (this._carousel) {
                var e3 = this._carousel.isPlay;
                this._autoplayLoader &&
                  this._autoplayLoader.setAttribute(
                    "data-play-state",
                    e3 ? "true" : "false"
                  );
              }
            },
          },
          {
            key: "scroll",
            value: function () {
              this._carousel &&
                (this._carousel.embla.scrollTo(this.dotIndex),
                this._carousel.forceStop());
            },
          },
          {
            key: "_carousel",
            get: function () {
              return this.closest("carousel-component");
            },
          },
        ]),
        i2
      );
    })(te),
    yn = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(
            x((e3 = t2.apply(this, arguments))),
            "_handleButtonClick",
            function () {
              e3.trigger();
            }
          ),
          f(x(e3), "_handleCarouselReInit", function () {
            e3._update();
          }),
          f(x(e3), "_handleCarouselSelect", function () {
            e3._update();
          }),
          f(
            x(e3),
            "_handleCarouselScroll",
            (0, Ji.debounce)(function () {
              e3._update();
            }, 100)
          ),
          f(x(e3), "_handleKeyDown", function (t3) {
            K(t3.key || t3.keyCode) && (t3.preventDefault(), e3.trigger());
          }),
          f(x(e3), "_updateDisabled", function () {
            e3.toggleAttribute("disabled", !e3._canScroll());
          }),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              this._update(),
                this._carousel &&
                  (this._carousel.embla.on(
                    "reInit",
                    this._handleCarouselReInit
                  ),
                  this._carousel.embla.on("select", this._handleCarouselSelect),
                  this._carousel.embla.on(
                    "scroll",
                    this._handleCarouselScroll
                  )),
                this.addEventListener("keydown", this._handleKeyDown),
                this.addEventListener("click", this._handleButtonClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this._carousel &&
                (this._carousel.embla.off("reInit", this._handleCarouselReInit),
                this._carousel.embla.off("select", this._handleCarouselSelect),
                this._carousel.embla.off("scroll", this._handleCarouselScroll)),
                this.removeEventListener("keydown", this._handleKeyDown),
                this.removeEventListener("click", this._handleButtonClick);
            },
          },
          {
            key: "_update",
            value: function () {
              this._updateDisabled(), this._updateVisible();
            },
          },
          {
            key: "_updateVisible",
            value: function () {
              if (this._carousel) {
                var e3 =
                    b(Array(this._carousel.embla.slideNodes().length).keys())
                      .length - 1,
                  t3 = this._carousel.embla.slidesInView(),
                  i3 =
                    this.dataset.scrollDirection === "next"
                      ? t3.includes(e3)
                      : t3.includes(0);
                this.toggleAttribute("has-not-slides-not-in-view", i3);
              }
            },
          },
          {
            key: "_canScroll",
            value: function () {
              return (
                !!this._carousel &&
                (this.dataset.scrollDirection === "next"
                  ? this._carousel.canScrollNext()
                  : this._carousel.canScrollPrev())
              );
            },
          },
          {
            key: "trigger",
            value: function () {
              if (this._carousel) {
                var e3 = this._carousel,
                  t3 = e3.scrollNext,
                  i3 = e3.scrollPrev;
                this.dataset.scrollDirection === "next" ? t3() : i3();
              }
            },
          },
          {
            key: "_carousel",
            get: function () {
              var e3 = this.closest("carousel-dots"),
                t3 = this.closest("carousel-component");
              return e3 || t3;
            },
          },
        ]),
        i2
      );
    })(te),
    bn = yn,
    wn = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "_handleProgress", function () {
            e3.updateProgressBar();
          }),
          f(x(e3), "_handleCarouselReInit", function () {
            e3.updateProgressBar();
          }),
          (e3._eventSetProgress =
            e3.dataset.target === "scroll" ? "scroll" : "settle"),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              this.updateProgressBar(),
                this._carousel &&
                  (this._carousel.embla.on(
                    this._eventSetProgress,
                    this._handleProgress
                  ),
                  this._carousel.embla.on(
                    "reInit",
                    this._handleCarouselReInit
                  ));
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this._carousel &&
                (this._carousel.embla.off(
                  this._eventSetProgress,
                  this._handleProgress
                ),
                this._carousel.embla.off("reInit", this._handleCarouselReInit));
            },
          },
          {
            key: "updateProgressBar",
            value: function () {
              var e3 = this.querySelector("[data-carousel-progress-indicator]");
              if (e3) {
                var t3 = this.getProgress(),
                  i3 = this.dataset.axis === "vertical";
                e3.style.transform = i3
                  ? "translate3d(0, ".concat(t3, "%, 0)")
                  : "translate3d(".concat(t3, "%, 0, 0)");
              }
            },
          },
          {
            key: "getProgress",
            value: function () {
              return this.dataset.target === "scroll"
                ? this.getProgressByScroll()
                : this.getProgressBySlideInView();
            },
          },
          {
            key: "getProgressBySlideInView",
            value: function () {
              if (!this._carousel) return 0;
              var e3 = this._carousel.embla.slideNodes().length,
                t3 = this._carousel.embla.slidesInView(),
                i3 = t3[t3.length - 1] + 1,
                n2 = 100 / e3;
              return Math.ceil(n2 * i3);
            },
          },
          {
            key: "getProgressByScroll",
            value: function () {
              if (!this._carousel) return 0;
              var e3 = this._carousel.embla.scrollProgress();
              return 100 * Math.max(0, Math.min(1, e3));
            },
          },
          {
            key: "_carousel",
            get: function () {
              return this.closest("carousel-component");
            },
          },
        ]),
        i2
      );
    })(te),
    Sn = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(
            x((e3 = t2.call(this))),
            "_handleResize",
            (0, Ji.debounce)(function () {
              e3._setHidden(!1), e3.updatePosition();
              var t3 = e3._headerSection.getBoundingClientRect();
              e3.headerSectionBottom = t3.bottom;
            }, 100)
          ),
          f(x(e3), "_handleScroll", function () {
            ci() && e3._updateVisibleAfterScroll(), e3._setScrollStatus();
          }),
          f(x(e3), "_handleDrodpownHide", function () {
            e3.classList.remove("header--light-bordered");
          }),
          f(x(e3), "_handleDropdownShow", function () {
            e3.classList.add("header--light-bordered");
          }),
          (e3._lastScrollPosition = 0),
          (e3._resizeObserver = new ResizeObserver(e3._handleResize)),
          (e3._dropdowns = b(e3.querySelectorAll("[data-header-dropdown]"))),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              var e3 = this;
              this._setSticky(),
                this.updatePosition(),
                j(window, "scroll", this._handleScroll),
                this._dropdowns.forEach(function (t3) {
                  customElements.upgrade(t3),
                    t3.subscribe("show", e3._handleDropdownShow),
                    t3.subscribe("hide", e3._handleDrodpownHide);
                }),
                this._resizeObserver.observe(this);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              var e3 = this;
              X(window, "scroll", this._handleScroll),
                this._dropdowns.forEach(function (t3) {
                  t3.unsubscribe("show", e3._handleDropdownShow),
                    t3.unsubscribe("hide", e3._handleDrodpownHide);
                }),
                this._resizeObserver.disconnect();
            },
          },
          {
            key: "_setScrollStatus",
            value: function () {
              if (this._headerSection) {
                var e3 = Math.abs(parseInt(document.body.style.top || "0")),
                  t3 = (window.scrollY || e3) > this.headerSectionBottom;
                this._headerSection.toggleAttribute("scrolled", t3);
              }
            },
          },
          {
            key: "_updateVisibleAfterScroll",
            value: function () {
              if (this._headerSection) {
                var e3 = window.scrollY,
                  t3 = this._lastScrollPosition < e3,
                  i3 = e3 > this.headerSectionBottom,
                  n2 = t3 && i3;
                this._setHidden(n2),
                  e3 !== 0 && (this._lastScrollPosition = e3);
              }
            },
          },
          {
            key: "_setHidden",
            value: function (e3) {
              this._headerSection &&
                this._headerSection.setAttribute(
                  "aria-hidden",
                  e3 ? "true" : "false"
                );
            },
          },
          {
            key: "_setSticky",
            value: function () {
              this._headerSection &&
                (this._headerSection.setAttribute("mobile-sticky", ""),
                this._headerSection.toggleAttribute(
                  "desktop-sticky",
                  this._isSticky
                ));
            },
          },
          {
            key: "updatePosition",
            value: function () {
              if (this._headerSection) {
                var e3,
                  t3 = this.getBoundingClientRect();
                (e3 = "".concat(t3.bottom, "px")),
                  document.documentElement.style.setProperty(
                    "--gsc-".concat("header-bottom-side"),
                    e3
                  );
              }
            },
          },
          {
            key: "_isSticky",
            get: function () {
              return this.hasAttribute("is-sticky");
            },
          },
          {
            key: "_headerSection",
            get: function () {
              return document.querySelector(".shopify-section-header");
            },
          },
        ]),
        i2
      );
    })(te),
    xn = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "_handleSectionLoad", function () {}),
          f(x(e3), "_handleSectionSelect", function (t3) {
            var i3 = t3.detail.sectionId;
            e3.isVisible &&
              e3.dataset.sectionId === i3 &&
              (e3.mount(), e3.reset());
          }),
          f(x(e3), "_handleSectionDeselect", function (t3) {
            var i3 = t3.detail.sectionId;
            e3.isVisible &&
              e3.dataset.sectionId === i3 &&
              (e3.reset(), e3.hide(!0));
          }),
          f(x(e3), "_handleBlockSelect", function (t3) {
            var i3 = t3.detail,
              n2 = i3.blockId,
              s2 = i3.sectionId;
            if (e3.dataset.sectionId === s2) {
              var a2 = e3.pages.find(function (e4) {
                return e4.getAttribute("block-id") === n2;
              });
              if (!a2) return;
              e3.open(), e3.setPage(a2);
            }
          }),
          f(x(e3), "_handleBlockDeselect", function (t3) {
            var i3 = t3.detail,
              n2 = i3.blockId,
              s2 = i3.sectionId;
            if (e3.dataset.sectionId === s2) {
              if (
                !e3.pages.find(function (e4) {
                  return e4.getAttribute("block-id") === n2;
                })
              )
                return;
              e3.hide(!0);
            }
          }),
          f(x(e3), "handlePageKeydown", function (t3) {
            var i3 = t3.target,
              n2 = i3.closest("drawer-menu-page");
            if (n2) {
              var s2 = n2.querySelectorAll(W()),
                a2 = i3 === s2[s2.length - 1],
                r2 = i3 === s2[0],
                o2 = t3.shiftKey;
              t3.keyCode === 9 &&
                ((o2 && r2) || (!o2 && a2)) &&
                (t3.preventDefault(), e3.focusOnToggler());
            }
          }),
          (e3.header = document.querySelector("header-component")),
          (e3.pages = b(e3.element.querySelectorAll("drawer-menu-page"))),
          (e3.pageMap = e3.generatePageMap()),
          (e3.homePage = e3.pageMap.Menu),
          (e3.toggler = document.getElementById("DrawerMenuToggler")),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              var e3 = this;
              Qt(_(i2.prototype), "connectedCallback", this).call(this),
                this.mountBlocks(),
                this.pages.forEach(function (t3) {
                  t3.addEventListener("keydown", e3.handlePageKeydown);
                }),
                this._isEditorMode &&
                  (this._editor.subscribe(
                    "BLOCK_SELECT",
                    this._handleBlockSelect
                  ),
                  this._editor.subscribe(
                    "BLOCK_DESELECT",
                    this._handleBlockDeselect
                  ),
                  this._editor.subscribe(
                    "SECTION_SELECT",
                    this._handleSectionSelect
                  ),
                  this._editor.subscribe(
                    "SECTION_DESELECT",
                    this._handleSectionDeselect
                  ));
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              var e3 = this;
              Qt(_(i2.prototype), "disconnectedCallback", this).call(this),
                this.pages.forEach(function (t3) {
                  t3.removeEventListener("keydown", e3.handlePageKeydown);
                }),
                this._isEditorMode && this._editor.destroy();
            },
          },
          {
            key: "focusOnToggler",
            value: function () {
              this.toggler && (this.toggler.focus(), this.hide());
            },
          },
          {
            key: "generatePageMap",
            value: function () {
              return this.pages.reduce(function (e3, t3) {
                var i3 = t3.dataset.pageId;
                return i3 ? ce(v({}, e3), f({}, i3, t3)) : e3;
              }, {});
            },
          },
          {
            key: "setPage",
            value: function (e3) {
              var t3,
                i3 =
                  e3.dataset.pageId ===
                  ((t3 = this.openedPage) === null || t3 === void 0
                    ? void 0
                    : t3.dataset.prevPageId),
                n2 = e3.hasAttribute("data-empty-menu");
              this.openedPage &&
                (i3 || n2) &&
                this.setPageVisible(this.openedPage, !1);
              var s2 = e3.querySelector(W());
              s2 && s2.focus(),
                this.setPageVisible(e3, !0),
                (this.openedPage = e3);
            },
          },
          {
            key: "reset",
            value: function () {
              var e3 = this;
              this.pages.forEach(function (t3) {
                e3.setPageVisible(t3, !1);
              }),
                this.setPageVisible(this.homePage, !0),
                (this.openedPage = this.homePage);
            },
          },
          {
            key: "setPageVisible",
            value: function (e3, t3) {
              e3.setAttribute("aria-hidden", t3 ? "false" : "true");
            },
          },
          {
            key: "open",
            value: function () {
              return (
                this.header && this.header.updatePosition(),
                Qt(_(i2.prototype), "open", this).call(this)
              );
            },
          },
          {
            key: "hide",
            value: function (e3) {
              return (
                this.reset(), Qt(_(i2.prototype), "hide", this).call(this, e3)
              );
            },
          },
          {
            key: "mountBlocks",
            value: function () {
              var e3 = this.element.querySelectorAll(
                  "[data-drawer-menu-target-block-id]"
                ),
                t3 = this.element.querySelector("#drawer-menu-blocks-template"),
                i3 = fe(t3);
              e3.forEach(function (e4) {
                var t4 = e4.getAttribute("data-drawer-menu-target-block-id"),
                  n2 = i3.querySelector(
                    '[data-drawer-menu-block-id="'.concat(t4, '"]')
                  );
                n2 &&
                  ((e4.className = ""
                    .concat(e4.className, " ")
                    .concat(n2.className)),
                  (e4.innerHTML = n2.innerHTML));
              });
            },
          },
          {
            key: "getPage",
            value: function (e3) {
              return this.pageMap[e3];
            },
          },
          {
            key: "isVisible",
            get: function () {
              var e3 = matchMedia("(max-width: 1016px)").matches;
              return this.hasAttribute("data-drawer-menu-is-section") || e3;
            },
          },
        ]),
        i2
      );
    })(li),
    Cn = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "_handleBlockScroll", function () {
            if (e3.block) {
              var t3 = e3.block.scrollTop > 0;
              e3.toggleAttribute("header-shadow-visible", t3);
            }
          }),
          (e3.block = e3.querySelector("[data-drawer-menu-content]")),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              this.block &&
                this.block.addEventListener("scroll", this._handleBlockScroll);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.block &&
                this.block.removeEventListener(
                  "scroll",
                  this._handleBlockScroll
                );
            },
          },
        ]),
        i2
      );
    })(te),
    kn = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(
            x((e3 = t2.apply(this, arguments))),
            "_handlePageLinkClick",
            function (t3) {
              t3.preventDefault(), e3.setPage();
            }
          ),
          f(x(e3), "_handleKeyUp", function (t3) {
            t3.preventDefault();
            var i3 = t3.key || t3.keyCode;
            K(i3) && e3.setPage();
          }),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              j(this, "click", this._handlePageLinkClick),
                j(this, "keyup", this._handleKeyUp);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              X(this, "click", this._handlePageLinkClick),
                X(this, "keyup", this._handleKeyUp);
            },
          },
          {
            key: "setPage",
            value: function () {
              var e3 = this.closest("drawer-menu"),
                t3 = this.dataset.pageId;
              if (t3 && e3) {
                var i3 = e3.getPage(t3);
                i3 && e3.setPage(i3);
              }
            },
          },
        ]),
        i2
      );
    })(te),
    En = kn,
    Tn = (function () {
      "use strict";
      function e2(t2) {
        d(this, e2), (this._element = t2);
      }
      return (
        p(e2, [
          {
            key: "show",
            value: function () {
              this._element.classList.remove("hidden");
            },
          },
          {
            key: "hide",
            value: function () {
              this._element.classList.add("hidden");
            },
          },
        ]),
        e2
      );
    })(),
    _n = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return d(this, i2), ((e3 = t2.call(this)).cache = {}), e3;
      }
      return (
        p(i2, [
          {
            key: "updateTargetsFromHTML",
            value: function (e3) {
              if (this.dataset.containerId) {
                var t3 = e3.getElementById(this.dataset.containerId),
                  i3 = document.getElementById(this.dataset.containerId);
                t3 &&
                  i3 &&
                  t3
                    .querySelectorAll(".".concat(this.dataset.target))
                    .forEach(function (e4) {
                      return i3.appendChild(e4);
                    });
              }
            },
          },
          {
            key: "updateResultsFromHTML",
            value: function (e3) {
              if (this.dataset.containerId) {
                var t3 = e3.getElementById(this.dataset.containerId),
                  i3 = document.getElementById(this.dataset.containerId);
                t3 &&
                  i3 &&
                  ((i3.innerHTML = t3.innerHTML),
                  i3.scrollIntoView({ behavior: "smooth" }));
              }
            },
          },
          {
            key: "updateFromHTML",
            value: function (e3) {
              var t3 = e3.querySelector("pagination-component");
              t3 && (this.innerHTML = t3.innerHTML);
            },
          },
          {
            key: "loadingOverlay",
            get: function () {
              var e3 = document.getElementById(this.dataset.overlayId || "");
              return new Tn(e3);
            },
          },
        ]),
        i2
      );
    })(te),
    Mn = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(
            x((e3 = t2.apply(this, arguments))),
            "_handleButtonClick",
            function () {
              e3._fetchResults();
            }
          ),
          f(x(e3), "_handleKeyDown", function (t3) {
            K(t3.key || t3.keyCode) &&
              (t3.preventDefault(), e3._fetchResults());
          }),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              this.addEventListener("keydown", this._handleKeyDown),
                this.addEventListener("click", this._handleButtonClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeEventListener("keydown", this._handleKeyDown),
                this.removeEventListener("click", this._handleButtonClick);
            },
          },
          {
            key: "_fetchResults",
            value: function () {
              var e3 = this,
                t3 = this.dataset.url;
              t3 &&
                (this._setLoadingStatus(!0),
                fetch(t3)
                  .then(function (e4) {
                    return e4.text();
                  })
                  .then(function (t4) {
                    var i3 = ge(t4);
                    e3._setLoadingStatus(!1),
                      e3._updateFromHTML(i3),
                      e3._updatePaginationFromHTML(i3);
                  })
                  .catch(function () {
                    S.notification &&
                      S.notification.show(
                        "Error in pagination load button component",
                        "warning"
                      );
                  }));
            },
          },
          {
            key: "_updatePaginationFromHTML",
            value: function (e3) {
              var t3 = this.closest("pagination-component");
              t3 && (t3.updateTargetsFromHTML(e3), t3.updateFromHTML(e3));
            },
          },
          {
            key: "_setPaginationUrl",
            value: function (e3) {
              this.dataset.url = e3.dataset.url;
            },
          },
          {
            key: "_removePagination",
            value: function () {
              var e3 = this.closest("pagination-component");
              e3 && e3.remove();
            },
          },
          {
            key: "_updateFromHTML",
            value: function (e3) {
              var t3 = e3.querySelector("pagination-load-button");
              t3 ? this._setPaginationUrl(t3) : this._removePagination();
            },
          },
          {
            key: "_setLoadingStatus",
            value: function (e3) {
              this.toggleAttribute("disabled", e3),
                this.classList.toggle("loading", e3);
            },
          },
        ]),
        i2
      );
    })(te),
    Ln = Mn,
    Pn = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(
            x((e3 = t2.apply(this, arguments))),
            "_handleLinkClick",
            function () {
              e3._fetchResults();
            }
          ),
          f(x(e3), "_handleKeyDown", function (t3) {
            K(t3.key || t3.keyCode) &&
              (t3.preventDefault(), e3._fetchResults());
          }),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              this.addEventListener("keydown", this._handleKeyDown),
                this.addEventListener("click", this._handleLinkClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeEventListener("keydown", this._handleKeyDown),
                this.removeEventListener("click", this._handleLinkClick);
            },
          },
          {
            key: "_fetchResults",
            value: function () {
              var e3 = this.closest("pagination-component"),
                t3 = this.dataset.url;
              e3 &&
                t3 &&
                (e3.cache[t3]
                  ? this._updatePaginationFromHTML(e3.cache[t3])
                  : this._getFromUrl(t3));
            },
          },
          {
            key: "_getFromUrl",
            value: function (e3) {
              var t3 = this,
                i3 = this.closest("pagination-component");
              i3 &&
                (i3.loadingOverlay.show(),
                fetch(e3)
                  .then(function (e4) {
                    return e4.text();
                  })
                  .then(function (n2) {
                    var s2 = ge(n2);
                    i3.loadingOverlay.hide(),
                      (i3.cache[e3] = s2),
                      t3._updatePaginationFromHTML(s2);
                  })
                  .catch(function () {
                    S.notification &&
                      S.notification.show(
                        "Error in pagination link component",
                        "warning"
                      );
                  }));
            },
          },
          {
            key: "_updatePaginationFromHTML",
            value: function (e3) {
              var t3 = this.closest("pagination-component");
              t3 && (t3.updateResultsFromHTML(e3), t3.updateFromHTML(e3));
            },
          },
        ]),
        i2
      );
    })(te),
    In = Pn,
    Dn = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(
            x((e3 = t2.call(this))),
            "_handleIntersectionObserve",
            function (t3) {
              var i3 = e3.dataset.url;
              if (i3) {
                if (!t3[0].isIntersecting) return;
                e3._intersectionObserver.unobserve(x(e3)),
                  e3._preloaderComponent.show(),
                  fetch(i3)
                    .then(function (e4) {
                      return e4.text();
                    })
                    .then(function (t4) {
                      var i4 = ge(t4),
                        n2 = e3.closest("pagination-component");
                      e3._preloaderComponent.hide(),
                        e3._updateFromHTML(i4),
                        n2 && n2.updateTargetsFromHTML(i4);
                    })
                    .catch(function () {
                      S.notification &&
                        S.notification.show(
                          "Error in infinite scroll component",
                          "warning"
                        );
                    });
              }
            }
          ),
          (e3._observerOptions = {
            root: null,
            rootMargin: "0px 0px 200px 0px",
          }),
          (e3._preloaderSelector = ".loading-spinner"),
          (e3._preloader = e3.querySelector(e3._preloaderSelector)),
          (e3._preloaderComponent = new Tn(e3._preloader)),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              (this._intersectionObserver = new IntersectionObserver(
                this._handleIntersectionObserve,
                this._observerOptions
              )),
                this._intersectionObserver.observe(this);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this._intersectionObserver.disconnect();
            },
          },
          {
            key: "_updateFromHTML",
            value: function (e3) {
              var t3 = e3.querySelector("pagination-infinite-scroll"),
                i3 = t3?.dataset.url;
              t3 && i3
                ? (this._setPaginationUrl(i3),
                  this._intersectionObserver.observe(this))
                : this.removeAttribute("data-url");
            },
          },
          {
            key: "_setPaginationUrl",
            value: function (e3) {
              this.dataset.url = e3;
            },
          },
        ]),
        i2
      );
    })(te),
    An = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "_handleCarouselSelect", function () {
            e3._removeVideo();
          }),
          f(x(e3), "_handlePosterClick", function () {
            e3.loadContent();
          }),
          (e3._poster = e3.querySelector('[id^="Deferred-Poster-"]')),
          (e3._carousel = e3.closest("carousel-component")),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              this.hasAttribute("data-autoplay") && this.loadContent(),
                j(this._poster, "click", this._handlePosterClick),
                this._carousel &&
                  this._carousel.embla.on("select", this._handleCarouselSelect);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              X(this._poster, "click", this._handlePosterClick),
                this._carousel &&
                  this._carousel.embla.off(
                    "select",
                    this._handleCarouselSelect
                  );
            },
          },
          {
            key: "loadContent",
            value: function () {
              this.getAttribute("loaded") ||
                (this._addVideo(), this.setAttribute("loaded", "true"));
            },
          },
          {
            key: "_removeVideo",
            value: function () {
              var e3 = this.querySelector("video,  iframe");
              e3 && (e3.remove(), this.removeAttribute("loaded"));
            },
          },
          {
            key: "_addVideo",
            value: function () {
              var e3 = document.createElement("div"),
                t3 = this.querySelector("template"),
                i3 = t3?.content;
              if (i3 && i3.firstElementChild) {
                var n2 = i3.firstElementChild.cloneNode(!0);
                e3.appendChild(n2);
                var s2 = e3.querySelector("video, model-viewer, iframe");
                s2 &&
                  (this.appendChild(s2), s2.tagName === "VIDEO" && s2.play());
              }
            },
          },
        ]),
        i2
      );
    })(te),
    zn = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        return d(this, i2), t2.apply(this, arguments);
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              this.fetchAvailability();
            },
          },
          {
            key: "fetchAvailability",
            value: function () {
              var e3 = this,
                t3 = ""
                  .concat(this.dataset.baseUrl, "variants/")
                  .concat(
                    this.dataset.variantId,
                    "/?section_id=pickup-availability"
                  );
              fetch(t3)
                .then(function (e4) {
                  return e4.text();
                })
                .then(function (t4) {
                  var i3 = ge(t4).querySelector(".shopify-section");
                  e3.updateSidebarFromHTML(i3), e3.updateContentFromHTML(i3);
                })
                .catch(function () {
                  S.notification &&
                    S.notification.show(
                      "Error in pickup availability component",
                      "warning"
                    );
                });
            },
          },
          {
            key: "updateVariantId",
            value: function (e3) {
              this.dataset.variantId = e3;
            },
          },
          {
            key: "updateContentFromHTML",
            value: function (e3) {
              var t3 = this.querySelector("pickup-availability-content"),
                i3 = e3.querySelector("pickup-availability-content");
              t3 && i3 && (t3.innerHTML = i3.innerHTML);
            },
          },
          {
            key: "updateSidebarFromHTML",
            value: function (e3) {
              var t3 = document.querySelector("#pickup-availability-sidebar"),
                i3 = e3.querySelector("#pickup-availability-sidebar template");
              t3 && i3 && t3.updateTemplate(i3);
            },
          },
        ]),
        i2
      );
    })(te),
    On = zn,
    Bn = (function () {
      "use strict";
      function e2(t2) {
        d(this, e2),
          (this._element = t2),
          (this._text = this._element.querySelector("[data-button-text]"));
      }
      return (
        p(e2, [
          {
            key: "setDisable",
            value: function (e3) {
              this._element.toggleAttribute("disabled", e3);
            },
          },
          {
            key: "setLoading",
            value: function (e3) {
              this._element.classList.toggle("loading", e3);
            },
          },
          {
            key: "setText",
            value: function (e3) {
              this._text && (this._text.textContent = e3);
            },
          },
        ]),
        e2
      );
    })(),
    Nn = window.routes,
    qn = (function () {
      "use strict";
      function e2() {
        d(this, e2);
      }
      return (
        p(e2, [
          {
            key: "change",
            value: function (e3) {
              return fetch(Nn.cart_change_url, e3).then(function (e4) {
                return e4.text();
              });
            },
          },
          {
            key: "add",
            value: function (e3) {
              return fetch(Nn.cart_add_url, e3).then(function (e4) {
                return e4.text();
              });
            },
          },
          {
            key: "update",
            value: function (e3) {
              return fetch("".concat(Nn.cart_update_url), e3);
            },
          },
          {
            key: "get",
            value: function () {
              return fetch(Nn.cart_url).then(function (e3) {
                return e3.text();
              });
            },
          },
        ]),
        e2
      );
    })(),
    $n = function () {
      return {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/".concat(
            arguments.length > 0 && arguments[0] !== void 0
              ? arguments[0]
              : "json"
          ),
        },
      };
    },
    Hn = new ((function () {
      "use strict";
      function e2(t2) {
        var i2 = this;
        d(this, e2),
          f(this, "requestProductFromUrl", function (e3, t3) {
            i2._element && i2._element.requestProductFromUrl(e3, t3);
          }),
          f(this, "openAndRenderProductByUrl", function (e3) {
            i2._element && i2._element.openAndRenderProductByUrl(e3);
          }),
          (this._element = document.querySelector("#".concat(t2)));
      }
      return (
        p(e2, [
          {
            key: "hide",
            value: function () {
              return this._element ? this._element.hide() : V();
            },
          },
          {
            key: "isOpen",
            get: function () {
              return !!this._element && this._element.isOpen;
            },
          },
        ]),
        e2
      );
    })())("Quick-view"),
    Fn = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "_handleFormSubmit", function (t3) {
            t3.preventDefault();
            var i3 = e3._getQueryConfig();
            e3.setDisable(!0),
              e3.setLoading(!0),
              e3._cartApi
                .add(i3)
                .then(function (t4) {
                  var i4 = JSON.parse(t4);
                  if ((e3.setDisable(!1), e3.setLoading(!1), i4.description)) {
                    if (!S.notification) return;
                    var n2 = Object.keys(i4.description)
                      .map(function (e4) {
                        return "".concat(e4, ": ").concat(i4.description[e4]);
                      })
                      .join(" , ");
                    S.notification.show(n2, "warning");
                  } else {
                    if (e3.cart) return e3._cartApi.get();
                    e3.sidebar
                      ? e3.updateSidebarCartByParsedState(i4)
                      : e3.updatePopupByParsedState(i4);
                  }
                })
                .then(function (t4) {
                  if (e3.cart && t4) {
                    var i4 = ge(t4);
                    e3.updateCartByHTML(i4);
                  }
                })
                .catch(function () {
                  S.notification &&
                    S.notification.show(
                      "Error in product form component",
                      "warning"
                    );
                });
          }),
          (e3.sidebar = document.querySelector("#sidebar-component-for-cart")),
          (e3.cart = document.querySelector("#cart-page-component")),
          (e3.cartNotificationPopup = document.querySelector(
            "#CartNotificationPopup"
          )),
          (e3.formSelector = "form"),
          (e3.variantInputSelector = "[data-product-form-variant]"),
          (e3.form = e3.querySelector(e3.formSelector)),
          e3.form &&
            (e3.variantInput = e3.form.querySelector(e3.variantInputSelector)),
          (e3._cartApi = new qn()),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              j(this.form, "submit", this._handleFormSubmit);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              X(this.form, "submit", this._handleFormSubmit);
            },
          },
          {
            key: "updateCartByHTML",
            value: function (e3) {
              this.cart &&
                (this.cart.updateByHTML(e3),
                this.cart.updateEmptyStatus(!1),
                this.showCallbackAfterCloseDialogWindow(function () {}));
            },
          },
          {
            key: "updateSidebarCartByParsedState",
           value: function (e3) {
              var t3 = this;
              // this.sidebar &&
              //   (this.sidebar.upd
              //   this.showCallbackAfterCloseDialogWindow(function () {
              //     t3.sidebar && t3.sidebar.purchaseHandler(e3);
              //   }));
              handleFloCartBtn();
            },
          },
          {
            key: "updatePopupByParsedState",
            value: function (e3) {
              var t3 = this;
              this.showCallbackAfterCloseDialogWindow(function () {
                t3.cartNotificationPopup &&
                  t3.cartNotificationPopup.showProductFromParsedState(
                    e3,
                    e3.id
                  );
              });
            },
          },
          {
            key: "showCallbackAfterCloseDialogWindow",
            value: function (e3) {
              return V(0).then(function () {
                Hn.isOpen || e3(), Hn.isOpen && Hn.hide().then(e3);
              });
            },
          },
          {
            key: "_getFormData",
            value: function () {
              return JSON.parse(
                (function (e3) {
                  var t3 = {},
                    i3 = new FormData(e3),
                    n2 = !0,
                    s2 = !1,
                    a2 = void 0;
                  try {
                    for (
                      var r2, o2 = i3.keys()[Symbol.iterator]();
                      !(n2 = (r2 = o2.next()).done);
                      n2 = !0
                    ) {
                      var l2 = r2.value,
                        c2 = /(?:^(properties\[))(.*?)(?:\]$)/;
                      c2.test(l2)
                        ? ((t3.properties = t3.properties || {}),
                          (t3.properties[c2.exec(l2)[2]] = i3.get(l2)))
                        : (t3[l2] = i3.get(l2));
                    }
                  } catch (e4) {
                    (s2 = !0), (a2 = e4);
                  } finally {
                    try {
                      n2 || o2.return == null || o2.return();
                    } finally {
                      if (s2) throw a2;
                    }
                  }
                  return JSON.stringify(t3);
                })(this.form)
              );
            },
          },
          {
            key: "_getQueryConfig",
            value: function () {
              var e3 = $n("javascript"),
                t3 = [
                  "cart-count",
                  this.sidebar ? this.sidebar.sectionId : "cart-drawer",
                  "cart-notification-popup-content",
                ];
              return (
                (e3.headers["X-Requested-With"] = "XMLHttpRequest"),
                (e3.body = JSON.stringify(
                  ce(v({}, this._getFormData()), {
                    sections: t3,
                    sections_url: window.location.pathname,
                  })
                )),
                e3
              );
            },
          },
          {
            key: "setLoading",
            value: function (e3) {
              this.querySelectorAll('button[type="submit"]').forEach(function (
                t3
              ) {
                new Bn(t3).setLoading(e3);
              });
            },
          },
          {
            key: "setDisable",
            value: function (e3) {
              this.querySelectorAll('button[type="submit"]').forEach(function (
                t3
              ) {
                new Bn(t3).setDisable(e3);
              });
            },
          },
          {
            key: "setButtonText",
            value: function (e3) {
              this.querySelectorAll('button[type="submit"]').forEach(function (
                t3
              ) {
                new Bn(t3).setText(e3);
              });
            },
          },
        ]),
        i2
      );
    })(te),
    Vn = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "_handleWindowScroll", function () {
            if (e3.button && e3.form) {
              var t3 = window.scrollY,
                i3 = e3.form.offsetTop + e3.form.offsetHeight,
                n2 = e3.footer ? e3.footer.offsetTop : 0,
                s2 = window.innerHeight + t3 < n2 && t3 > i3;
              e3.toggleAttribute("visible", s2),
                document.body.toggleAttribute(
                  "is-product-form-button-fixed",
                  s2
                );
            }
          }),
          (e3.button = e3.querySelector("[data-product-form-button]")),
          (e3.footer = document.querySelector(
            ".shopify-section.shopify-section-footer"
          )),
          (e3.form = e3.closest("product-form")),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              window.addEventListener("scroll", this._handleWindowScroll);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              window.removeEventListener("scroll", this._handleWindowScroll);
            },
          },
        ]),
        i2
      );
    })(te),
    Rn = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          ((e3 = t2.call(this)).blockSelector = "[data-product-block-item]"),
          (e3.containerSelector = "[data-product-block-container]"),
          (e3.activeTemplate = e3.querySelector(e3.blockSelector)),
          (e3.activeTemplateContainer = e3.querySelector(e3.containerSelector)),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "updateByVariantId",
            value: function (e3) {
              var t3 = this.querySelector(
                '[data-product-block-template="'.concat(e3, '"]')
              );
              if (this.activeTemplate && this.activeTemplateContainer) {
                var i3 = ve(t3);
                i3 &&
                  (this.activeTemplate.remove(),
                  (this.activeTemplate = i3),
                  this.activeTemplateContainer.appendChild(i3));
              }
            },
          },
        ]),
        i2
      );
    })(te),
    jn = window.Shopify,
    Xn = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "_handlePosterClick", function () {
            e3._loadContent();
          }),
          f(x(e3), "_handleCarouselSelect", function () {
            e3._carousel && e3._setCarouselDraggable(!0);
          }),
          (e3._poster = e3.querySelector('[id^="Deferred-Poster-"]')),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              j(this._poster, "click", this._handlePosterClick),
                this._carousel &&
                  this._carousel.embla.on("select", this._handleCarouselSelect);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              X(this._poster, "click", this._handlePosterClick),
                this._carousel &&
                  this._carousel.embla.off(
                    "select",
                    this._handleCarouselSelect
                  );
            },
          },
          {
            key: "_loadContent",
            value: function () {
              this.getAttribute("loaded") ||
                (this._addModel(),
                this.setAttribute("loaded", !0),
                this._carousel && this._setCarouselDraggable(!1)),
                jn.loadFeatures([
                  {
                    name: "model-viewer-ui",
                    version: "1.0",
                    onLoad: this.setupModelViewerUI.bind(this),
                  },
                ]);
            },
          },
          {
            key: "_addModel",
            value: function () {
              var e3 = this.querySelector("template");
              if (e3 && e3.content) {
                var t3 = e3.content,
                  i3 = document.createElement("div");
                i3.appendChild(t3.firstElementChild.cloneNode(!0));
                var n2 = i3.querySelector("model-viewer");
                this.appendChild(n2);
              }
            },
          },
          {
            key: "setupModelViewerUI",
            value: function (e3) {
              e3 ||
                (this.modelViewerUI = new jn.ModelViewerUI(
                  this.querySelector("model-viewer")
                ));
            },
          },
          {
            key: "_setCarouselDraggable",
            value: function (e3) {
              var t3 = this.querySelector(".shopify-model-viewer-ui");
              (this._carousel.dataset.draggable = e3 ? "true" : "false"),
                this._carousel.reInit(),
                e3 && t3 && (t3.remove(), this.removeAttribute("loaded"));
            },
          },
          {
            key: "_carousel",
            get: function () {
              return this.closest("carousel-component");
            },
          },
        ]),
        i2
      );
    })(te);
  (window.ProductModel = {
    loadShopifyXR: function () {
      jn.loadFeatures([
        {
          name: "shopify-xr",
          version: "1.0",
          onLoad: this.setupShopifyXR.bind(this),
        },
      ]);
    },
    setupShopifyXR: function (e2) {
      var t2 = this;
      e2 ||
        (window.ShopifyXR
          ? (document
              .querySelectorAll('[id^="ProductJSON-"]')
              .forEach(function (e3) {
                window.ShopifyXR.addModels(JSON.parse(e3.textContent)),
                  e3.remove();
              }),
            window.ShopifyXR.setupXRElements())
          : document.addEventListener("shopify_xr_initialized", function () {
              return t2.setupShopifyXR();
            }));
    },
  }),
    window.addEventListener("DOMContentLoaded", function () {
      jn.designMode &&
        document
          .querySelectorAll("[data-shopify-xr-hidden]")
          .forEach(function (e2) {
            return e2.classList.add("hidden");
          }),
        window.ProductModel && window.ProductModel.loadShopifyXR();
    });
  var Gn = (function () {
      "use strict";
      function e2(t2) {
        d(this, e2), (this.element = t2);
      }
      return (
        p(e2, [
          {
            key: "show",
            value: function () {
              var e3 = this;
              this.element.classList.remove("hidden"),
                V(2500).then(function () {
                  e3.element.classList.add("hidden");
                });
            },
          },
        ]),
        e2
      );
    })(),
    Wn = (function () {
      "use strict";
      function e2(t2) {
        d(this, e2), (this.element = t2);
      }
      return (
        p(e2, [
          {
            key: "setDisable",
            value: function (e3) {
              this.element.setDisable(e3);
            },
          },
        ]),
        e2
      );
    })(),
    Yn = (function () {
      "use strict";
      function e2(t2) {
        d(this, e2), (this.element = t2);
      }
      return (
        p(e2, [
          {
            key: "setLoading",
            value: function (e3) {
              this.element.toggleAttribute("is-loading", e3);
            },
          },
        ]),
        e2
      );
    })(),
    Un = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "removeFromCart", function () {
            e3.expand()
              .then(function () {
                return e3.collapse();
              })
              .then(function () {
                return e3.remove();
              });
          }),
          f(x(e3), "expand", function () {
            return e3._setMaxHeight(e3.scrollHeight), V(e3._transitionDuration);
          }),
          f(x(e3), "collapse", function () {
            return e3._setMaxHeight(0), V(e3._transitionDuration);
          }),
          f(x(e3), "showCheckmark", function () {
            var t3 = e3.querySelector(e3._checkmarkSelector);
            t3 && new Gn(t3).show();
          }),
          f(x(e3), "setLoading", function (t3) {
            var i3 = e3.querySelector(e3._totalsSelector);
            i3 && new Yn(i3).setLoading(t3);
          }),
          f(x(e3), "_handleCartItemResize", function () {
            e3._setMaxHeight(e3.scrollHeight);
          }),
          (e3._checkmarkSelector = "[data-cart-item-checkmark]"),
          (e3._bodySelector = "[data-cart-item-body]"),
          (e3._totalsSelector = "[data-cart-item-totals]"),
          (e3._quantitySelector = "[data-cart-item-quantity]"),
          (e3.styles = getComputedStyle(x(e3))),
          (e3.resizeObserver = new ResizeObserver(e3._handleCartItemResize)),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              var e3 = this.querySelector(this._bodySelector);
              e3 && this.resizeObserver.observe(e3);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.resizeObserver.disconnect();
            },
          },
          {
            key: "_setMaxHeight",
            value: function (e3) {
              this.style.maxHeight = "".concat(e3, "px");
            },
          },
          {
            key: "setQuantityDisabled",
            value: function (e3) {
              var t3 = this.querySelector(this._quantitySelector);
              t3 && new Wn(t3).setDisable(e3);
            },
          },
          {
            key: "_transitionDuration",
            get: function () {
              return 1e3 * parseFloat(this.styles.transitionDuration);
            },
          },
        ]),
        i2
      );
    })(te),
    Kn = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "_handleCartItemChange", function (t3) {
            var i3 = e3.querySelector(
              "#CartItem-".concat(+t3.target.dataset.index)
            );
            i3 && i3.setLoading(!0);
          }),
          f(
            x(e3),
            "_handleCartChange",
            (0, Ji.debounce)(function (t3) {
              e3.updateItem(+t3.target.dataset.index, t3.target.value);
            }, 500)
          ),
          (e3._cartApi = new qn()),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              j(this, "change", this._handleCartChange),
                j(this, "change", this._handleCartItemChange);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              X(this, "change", this._handleCartChange),
                X(this, "change", this._handleCartItemChange);
            },
          },
          {
            key: "getConfigByItemIndexAndQuantity",
            value: function (e3, t3) {
              return ce(v({}, $n()), {
                body: JSON.stringify({ line: e3 + 1, quantity: t3 }),
              });
            },
          },
          {
            key: "updateItem",
            value: function (e3, t3) {
              var i3 = this,
                n2 = this.getConfigByItemIndexAndQuantity(e3, t3),
                s2 = this.querySelector("#CartItem-".concat(e3));
              if (s2) {
                var a2 = +t3;
                +(s2.dataset.quantity || 0) !== a2
                  ? (a2 === 0 &&
                      (this.updateEmptyStatus(this._cartItemCount === 1),
                      s2.removeFromCart()),
                    this.setButtonLoading(!0),
                    s2.setQuantityDisabled(!0),
                    this._cartApi
                      .change(n2)
                      .then(function () {
                        return i3._cartApi.get();
                      })
                      .then(function (e4) {
                        var t4 = ge(e4);
                        i3.setButtonLoading(!1),
                          s2.setQuantityDisabled(!1),
                          s2.setLoading(!1),
                          i3.updateByHTML(t4);
                      })
                      .catch(function () {
                        i3._showError();
                      }))
                  : s2.setLoading(!1);
              }
            },
          },
          {
            key: "_showError",
            value: function () {
              if (S.notification) {
                var e3 = window.cartStrings;
                S.notification.show(e3.error, "warning");
              }
            },
          },
          {
            key: "updateEmptyStatus",
            value: function (e3) {
              this._updateCartEmptyStatus(e3),
                this._updateSubtotalEmptyStatus(e3);
            },
          },
          {
            key: "_updateCartEmptyStatus",
            value: function (e3) {
              this.classList.toggle("is-empty", e3);
            },
          },
          {
            key: "_updateSubtotalEmptyStatus",
            value: function (e3) {
              var t3 = document.getElementById(this.sectionIds.local.subtotal);
              t3 && t3.classList.toggle("is-empty", e3);
            },
          },
          {
            key: "updateByHTML",
            value: function (e3) {
              this.updateFreeShippingBarByHTML(e3),
                [
                  "#".concat(
                    this.sectionIds.local.cartItems,
                    " [data-cart-page-items]"
                  ),
                  "#CartCount",
                  "#StickyCartCount",
                  "#".concat(
                    this.sectionIds.local.subtotal,
                    " [data-cart-page-subtotal-price]"
                  ),
                ].forEach(function (t3) {
                  var i3 = document.querySelector(t3),
                    n2 = e3.querySelector(t3);
                  i3 && n2 && (i3.innerHTML = n2.innerHTML);
                });
            },
          },
          {
            key: "updateFreeShippingBarByHTML",
            value: function (e3) {
              var t3 = "#".concat(
                  this.sectionIds.local.cartItems,
                  " [data-cart-page-free-shipping-bar] cart-free-shipping-bar"
                ),
                i3 = document.querySelector(t3),
                n2 = e3.querySelector(t3);
              if (i3 && n2) {
                var s2 = Y(n2),
                  a2 = n2.dataset.cartTotal || 0;
                i3.updateProgressByCartTotal(+a2), U(s2);
              }
            },
          },
          {
            key: "setButtonLoading",
            value: function (e3) {
              var t3 = document.getElementById(this.sectionIds.local.subtotal);
              if (t3) {
                var i3 = t3.querySelector("[data-cart-page-checkout-button]");
                i3 &&
                  (i3.toggleAttribute("disabled", e3),
                  i3.classList.toggle("loading", e3));
              }
            },
          },
          {
            key: "_cartItemCount",
            get: function () {
              return this.querySelectorAll("cart-item").length;
            },
          },
          {
            key: "sectionIds",
            get: function () {
              return {
                local: {
                  subtotal: "CartPage-SubtotalSection",
                  cartItems: "CartPage-CartItemsSection",
                },
              };
            },
          },
        ]),
        i2
      );
    })(te),
    Qn = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "_handleCartItemChange", function (t3) {
            var i3 = e3.querySelector(
              "#CartItem-".concat(+t3.target.dataset.index)
            );
            i3 && i3.setLoading(!0);
          }),
          f(
            x(e3),
            "_handleCartChange",
            (0, Ji.debounce)(function (t3) {
              e3.updateItem(+t3.target.dataset.index, t3.target.value);
            }, 500)
          ),
          f(x(e3), "_handleViewportScroll", function () {
            if (e3.viewport) {
              var t3 = e3.checkContentOverflow(),
                i3 = e3.viewport.scrollTop > 0;
              e3.toggleAttribute("header-shadow-visible", t3 && i3);
            }
          }),
          f(x(e3), "_handleContentResultsResize", function () {
            e3.updateViewport();
          }),
          (e3.sectionId = e3.dataset.sectionId || "cart-drawer"),
          (e3._sections = ["cart-count", e3.sectionId]),
          (e3.resultsSelector = "[data-sidebar-cart-results]"),
          (e3.viewportSelector = "[data-sidebar-cart-viewport]"),
          (e3.headerSelector = "[data-sidebar-cart-header]"),
          (e3.footerSelector = "[data-sidebar-cart-footer]"),
          (e3.viewport = e3.element.querySelector(e3.viewportSelector)),
          (e3.results = e3.element.querySelector(e3.resultsSelector)),
          (e3.header = e3.element.querySelector(e3.headerSelector)),
          (e3.footer = e3.element.querySelector(e3.footerSelector)),
          (e3._cartApi = new qn()),
          (e3._resizeObserver = new ResizeObserver(
            e3._handleContentResultsResize
          )),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              Qt(_(i2.prototype), "connectedCallback", this).call(this),
                j(this, "change", this._handleCartChange),
                j(this, "change", this._handleCartItemChange),
                this.viewport &&
                  this.viewport.addEventListener(
                    "scroll",
                    this._handleViewportScroll
                  ),
                this.results && this._resizeObserver.observe(this.results);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              Qt(_(i2.prototype), "disconnectedCallback", this).call(this),
                X(this, "change", this._handleCartChange),
                X(this, "change", this._handleCartItemChange),
                this.viewport &&
                  this.viewport.removeEventListener(
                    "scroll",
                    this._handleViewportScroll
                  ),
                this._resizeObserver.disconnect();
            },
          },
          {
            key: "updateItem",
            value: function (e3, t3) {
              var i3 = this,
                n2 = this.querySelector("#CartItem-".concat(e3)),
                s2 = this.element.querySelector("[data-cart-checkout-button]");
              if (n2 && s2) {
                var a2 = this._getQueryConfig(e3, t3),
                  r2 = new Bn(s2),
                  o2 = +t3;
                +(n2.dataset.quantity || 0) !== o2
                  ? (r2.setLoading(!0),
                    r2.setDisable(!0),
                    n2.setQuantityDisabled(!0),
                    o2 === 0 &&
                      (this.updateEmptyStatus(this._cartItemCount === 1),
                      n2.removeFromCart()),
                    this._cartApi
                      .change(a2)
                      .then(function (e4) {
                        var t4 = JSON.parse(e4);
                        r2.setLoading(!1),
                          r2.setDisable(!1),
                          n2.setLoading(!1),
                          n2.setQuantityDisabled(!1),
                          i3.updateByParsedState(t4);
                      })
                      .catch(function () {
                        i3._showError();
                      }))
                  : n2.setLoading(!1);
              }
            },
          },
          {
            key: "updateViewport",
            value: function () {
              var e3 = this.checkContentOverflow();
              this.toggleAttribute("footer-shadow-visible", e3);
            },
          },
          {
            key: "checkContentOverflow",
            value: function () {
              return (
                !(!this.results || !this.viewport) &&
                this.results.offsetHeight > this.viewport.offsetHeight
              );
            },
          },
          {
            key: "_showError",
            value: function () {
              var e3 = this.querySelector("#SidebarCartNotification");
              if (e3) {
                var t3 = new w(e3),
                  i3 = window.cartStrings;
                t3.show(i3.error, "warning");
              }
            },
          },
          {
            key: "updateByParsedState",
            value: function (e3) {
              var t3 = ge(e3.sections[this.sectionId]).querySelector(
                  "#CartInSidebar"
                ),
                i3 = ve(t3),
                n2 = Y(i3);
              this.mount(),
                this.updateHeaderFromNode(i3),
                this.updateFreeShippingBarFromNode(i3),
                this.updateCartItemsFromNode(i3),
                this.updateFooterFromNode(i3),
                this._updateCartCountInHeader(e3),
                U(n2);
            },
          },
          {
            key: "purchaseHandler",
            value: function (e3) {
              var t3 = this,
                i3 = ge(e3.sections[this.sectionId]).querySelector(
                  "#CartInSidebar"
                ),
                n2 = ve(i3),
                s2 = Y(n2);
              this.mount(),
                this.updateHeaderFromNode(n2),
                this.updateCartItemsFromNode(n2),
                this.updateFooterFromNode(n2),
                this._updateCartCountInHeader(e3),
                U(s2);
              var a2 = this.element.querySelector(
                'cart-item[data-variant-id="'.concat(e3.id, '"]')
              );
              a2 &&
                (e3.quantity === 1
                  ? a2
                      .collapse()
                      .then(function () {
                        return t3.open();
                      })
                      .then(function () {
                        return a2.expand();
                      })
                      .then(function () {
                        t3.updateFreeShippingBarFromNode(n2),
                          a2.showCheckmark();
                      })
                  : this.open().then(function () {
                      t3.updateFreeShippingBarFromNode(n2), a2.showCheckmark();
                    }));
            },
          },
          {
            key: "updateHeaderFromNode",
            value: function (e3) {
              this.updateElementBySelectorFromNode(
                "[data-sidebar-cart-header]",
                e3
              );
            },
          },
          {
            key: "updateEmptyStatus",
            value: function (e3) {
              this.toggleAttribute("is-empty", e3);
            },
          },
          {
            key: "updateFooterFromNode",
            value: function (e3) {
              this.updateElementBySelectorFromNode(
                "[data-sidebar-cart-footer]",
                e3
              );
            },
          },
          {
            key: "updateCartItemsFromNode",
            value: function (e3) {
              this.updateElementBySelectorFromNode(
                "[data-sidebar-cart-items]",
                e3
              );
            },
          },
          {
            key: "updateFreeShippingBarFromNode",
            value: function (e3) {
              var t3 =
                  "[data-sidebar-cart-free-shipping-bar] cart-free-shipping-bar",
                i3 = this.element.querySelector(t3),
                n2 = e3.querySelector(t3);
              if (i3 && n2) {
                var s2 = n2.dataset.cartTotal || 0;
                i3.updateProgressByCartTotal(+s2);
              }
            },
          },
          {
            key: "updateElementBySelectorFromNode",
            value: function (e3, t3) {
              var i3 = t3.querySelector(e3),
                n2 = this.element.querySelector(e3);
              n2 && i3 && (n2.innerHTML = i3.innerHTML);
            },
          },
          {
            key: "_updateCartCountInHeader",
            value: function (e3) {
              var t3 = ge(e3.sections["cart-count"]),
                i3 = document.getElementById("CartCount"),
                n2 = document.getElementById("StickyCartCount"),
                s2 = t3.querySelector("#CartCount");
              n2 && s2 && (n2.innerHTML = s2.innerHTML),
                i3 && s2 && (i3.innerHTML = s2.innerHTML);
            },
          },
          {
            key: "_getQueryConfig",
            value: function (e3, t3) {
              return ce(v({}, $n()), {
                body: JSON.stringify({
                  line: e3 + 1,
                  quantity: t3,
                  sections: this._sections,
                  sections_url: window.location.pathname,
                }),
              });
            },
          },
          {
            key: "_cartItemCount",
            get: function () {
              return this.element.querySelectorAll("cart-item").length;
            },
          },
        ]),
        i2
      );
    })(li),
    Zn = window.Shopify,
    Jn = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "setProgress", function (t3) {
            e3.style.setProperty(
              "--gsc-free-shipping-progress",
              "".concat(t3, "%")
            );
          }),
          f(x(e3), "setMessage", function (t3) {
            var i3 = e3.querySelector(e3.messageNodeSelector);
            i3 && (i3.innerHTML = t3);
          }),
          (e3.messageNodeSelector = "[data-cart-free-shipping-bar-message]"),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              var e3 = this.dataset.cartTotal || 0;
              this.updateProgressByCartTotal(+e3);
            },
          },
          {
            key: "updateProgressByCartTotal",
            value: function (e3) {
              var t3 = this.dataset.currencyFormat || "",
                i3 = +(this.dataset.threshold || 0),
                n2 = +Zn.currency.rate,
                s2 = this.dataset.progressMessage || "",
                a2 = this.dataset.achievedMessage || "",
                r2 = i3 * n2,
                o2 = +(r2 - e3).toFixed(2),
                l2 = r2 / 100;
              if (o2 > 0) {
                var c2 = t3.replace(/{{.+?}}/g, "".concat(o2));
                this.setMessage(s2.replace("[value]", c2)),
                  this.setProgress(e3 / l2);
              } else this.setMessage(a2), this.setProgress(100);
            },
          },
        ]),
        i2
      );
    })(te),
    es = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        return d(this, i2), t2.apply(this, arguments);
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              this.setReady();
            },
          },
          {
            key: "updateFirstMediaByVariant",
            value: function (e3) {
              var t3 =
                arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
              if (e3 && e3.featured_media) {
                var i3 = this.querySelector(
                  '[data-media-id="'.concat(e3.featured_media.id, '"]')
                );
                i3 && i3.scrollIntoView({ behavior: t3 ? "auto" : "smooth" });
              }
            },
          },
          {
            key: "setReady",
            value: function () {
              this.setAttribute("ready", "");
            },
          },
        ]),
        i2
      );
    })(te),
    ts = es,
    is = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          ((e3 = t2.call(this)).carouselSelector =
            "[data-product-media-carousel-component]"),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              this.setReady();
            },
          },
          {
            key: "updateFirstMediaByVariant",
            value: function (e3) {
              var t3 =
                  arguments.length > 1 &&
                  arguments[1] !== void 0 &&
                  arguments[1],
                i3 = this.querySelector(this.carouselSelector);
              if (e3 && e3.featured_media && i3) {
                var n2 = i3.embla.slideNodes().findIndex(function (t4) {
                  return (
                    !!t4.dataset.mediaId &&
                    +t4.dataset.mediaId == +e3.featured_media.id
                  );
                });
                i3.embla.scrollTo(n2, t3);
              }
            },
          },
          {
            key: "setReady",
            value: function () {
              this.setAttribute("ready", "");
            },
          },
        ]),
        i2
      );
    })(te),
    ns = is,
    ss = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "_handleVariantChange", function () {
            e3._updateForm(),
              e3._setInventoryStatusAvailable(e3.variant),
              e3.variant
                ? (e3._form.setDisable(!0),
                  e3._form.setLoading(!0),
                  e3._pickupAvailability && e3._updatePickupAvailability(),
                  e3._updateURL(),
                  e3._updateVariantInput(),
                  e3._updateProduct(),
                  e3._updateFirstMediaByVariant(e3.variant))
                : e3._setButtonsUnavailable();
          }),
          f(x(e3), "_handleLabelFocus", function (t3) {
            var i3 = t3.target.getAttribute("for");
            e3
              .querySelector('input[id="'.concat(i3, '"]'))
              .dispatchEvent(new MouseEvent("click", { button: 0, which: 1 })),
              document.addEventListener("keydown", e3._handleLabelKeydown);
          }),
          f(x(e3), "_handleLabelKeydown", function (t3) {
            var i3 = t3.target.closest("[data-variant-picker-option-labels]");
            if (
              t3.key === "ArrowLeft" ||
              t3.key === "ArrowRight" ||
              t3.key === "ArrowUp" ||
              t3.key === "ArrowDown"
            )
              if (i3) {
                var n2 = b(i3.querySelectorAll("label")),
                  s2 = n2.findIndex(function (e4) {
                    return e4 === t3.target;
                  }),
                  a2 = n2[s2],
                  r2 = n2[0],
                  o2 = n2[n2.length - 1],
                  l2 = n2[s2 + 1],
                  c2 = n2[s2 - 1];
                n2.length !== 1 && t3.preventDefault();
                var u2 = function (e4) {
                    a2.removeAttribute("tabindex"),
                      e4.setAttribute("tabindex", 0),
                      e4.focus();
                  },
                  d2 = function () {
                    u2(l2 || r2);
                  },
                  h2 = function () {
                    u2(c2 || o2);
                  };
                (0,
                { ArrowLeft: h2, ArrowRight: d2, ArrowUp: h2, ArrowDown: d2 }[
                  t3.key
                ])();
              } else
                document.removeEventListener("keydown", e3._handleLabelKeydown);
          }),
          (e3._pickupAvailability = document.getElementById(
            "product-pickup-availability-"
              .concat(e3.dataset.productId, "-")
              .concat(e3.dataset.section)
          )),
          (e3._elements = [
            "sticky-product-buy-btn",
            "product-buy-btn",
            "product-quantity",
          ]),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              var e3 = this;
              this._updateVariant(),
                setTimeout(function () {
                  e3._updateOptionsAvailable(), e3.setFocusListeners();
                }, 100),
                this.dataset.selectedVariantId &&
                  this._updateFirstMediaByVariant(this.variant, !0),
                j(this, "change", this._handleVariantChange);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              X(this, "change", this._handleVariantChange);
            },
          },
          {
            key: "_updateLabels",
            value: function () {
              var e3 = this,
                t3 = this.querySelectorAll(
                  "[data-variant-picker-option-inputs]"
                ),
                i3 = this.querySelectorAll(
                  "[data-variant-picker-option-labels]"
                );
              t3.forEach(function (t4, n2) {
                var s2 = b(i3[n2].querySelectorAll("label")),
                  a2 = b(t4.querySelectorAll("input")),
                  r2 = e3.getCheckedInput(a2),
                  o2 = i3[n2].querySelector(
                    "[data-dropdown-variant-picker-label]"
                  );
                o2 && o2.toggleAttribute("no-available", !e3.variant.available),
                  s2.forEach(function (e4) {
                    var t5 = e4.getAttribute("for") === r2.id;
                    if (o2 && t5) {
                      var i4 = o2.closest("dropdown-opener");
                      (o2.innerHTML = e4.innerHTML), i4.trigger();
                    }
                    e4.classList.toggle("selected", t5);
                  });
              });
            },
          },
          {
            key: "_setInventoryStatusAvailable",
            value: function (e3) {
              var t3 = document.getElementById(
                "product-stock-inner-"
                  .concat(this.dataset.productId, "-")
                  .concat(this.dataset.section)
              );
              t3 && t3.classList.toggle("hidden", !e3);
            },
          },
          {
            key: "_setButtonsUnavailable",
            value: function () {
              this._form.setDisable(!0),
                this._form.setText(window.variantStrings.unavailable);
            },
          },
          {
            key: "_updateVariant",
            value: function () {
              var e3 = this,
                t3 = this.querySelectorAll(
                  "[data-variant-picker-option-inputs]"
                ),
                i3 = this._getVariants(),
                n2 = b(t3).map(function (t4) {
                  var i4 = b(t4.querySelectorAll("input"));
                  return e3.getCheckedInput(i4).value;
                });
              this.variant = i3.find(function (e4) {
                return !e4.options
                  .map(function (e5, t4) {
                    return n2[t4] === e5;
                  })
                  .includes(!1);
              });
            },
          },
          {
            key: "setFocusListeners",
            value: function () {
              if (this.dataset.type === "dropdown") {
                var e3 = b(this.querySelectorAll("float-element"))
                  .map(function (e4) {
                    return b(e4.element.querySelectorAll("label"));
                  })
                  .reduce(function (e4, t4) {
                    return b(e4).concat(b(t4));
                  }, []);
                this.setListenersForLabels(e3);
              } else {
                var t3 = b(this.querySelectorAll("label"));
                this.setListenersForLabels(t3);
              }
            },
          },
          {
            key: "setListenersForLabels",
            value: function (e3) {
              var t3 = this;
              e3.forEach(function (e4) {
                e4.addEventListener("focus", t3._handleLabelFocus);
              });
            },
          },
          {
            key: "removeListenersForLabels",
            value: function (e3) {
              var t3 = this;
              e3.forEach(function (e4) {
                e4.addEventListener("focus", t3._handleLabelFocus);
              });
            },
          },
          {
            key: "_updateOptionsAvailable",
            value: function () {
              var e3 = this,
                t3 = this.querySelectorAll(
                  "[data-variant-picker-option-inputs]"
                ),
                i3 = function (e4) {
                  return t3[e4] ? b(t3[e4].querySelectorAll("input")) : null;
                },
                n2 = i3(0),
                s2 = i3(1),
                a2 = i3(2),
                r2 = this._getVariants(),
                o2 = function () {
                  for (
                    var e4 = arguments.length, t4 = new Array(e4), i4 = 0;
                    i4 < e4;
                    i4++
                  )
                    t4[i4] = arguments[i4];
                  return r2.reduce(function (e5, i5) {
                    var n3 =
                      !t4 ||
                      t4.every(function (e6) {
                        return i5.options.includes(e6.value);
                      });
                    return i5.available && n3 ? b(e5).concat([i5.options]) : e5;
                  }, []);
                },
                l2 = function (t4, i4) {
                  var n3 = !0,
                    s3 = !1,
                    a3 = void 0;
                  try {
                    for (
                      var r3,
                        o3 = function () {
                          var t5 = r3.value,
                            n4 = t5.value,
                            s4 = !1;
                          i4.forEach(function (e4) {
                            e4.includes(n4) && (s4 = !0);
                          });
                          var a4,
                            o4 = 'label[for="'.concat(t5.id, '"]');
                          (e3.querySelector(o4)
                            ? e3.querySelector(o4)
                            : ((a4 = o4),
                              b(e3.querySelectorAll("float-element"))
                                .find(function (e4) {
                                  return e4.element.querySelector(a4);
                                })
                                .element.querySelector(a4))
                          ).toggleAttribute("no-available", !s4);
                        },
                        l3 = t4[Symbol.iterator]();
                      !(n3 = (r3 = l3.next()).done);
                      n3 = !0
                    )
                      o3();
                  } catch (e4) {
                    (s3 = !0), (a3 = e4);
                  } finally {
                    try {
                      n3 || l3.return == null || l3.return();
                    } finally {
                      if (s3) throw a3;
                    }
                  }
                };
              l2(n2, o2()),
                s2 && l2(s2, o2(this.getCheckedInput(n2))),
                a2 &&
                  l2(
                    a2,
                    o2(this.getCheckedInput(n2), this.getCheckedInput(s2))
                  );
            },
          },
          {
            key: "_getVariants",
            value: function () {
              var e3 = this.querySelector("[data-variant-picker-variants]");
              return JSON.parse(e3.textContent);
            },
          },
          {
            key: "_updateFirstMediaByVariant",
            value: function (e3, t3) {
              document
                .querySelectorAll(
                  "#product-media-"
                    .concat(this.dataset.productId, "-")
                    .concat(this.dataset.section)
                )
                .forEach(function (i3) {
                  return i3.updateFirstMediaByVariant(e3, t3);
                });
            },
          },
          {
            key: "_updateForm",
            value: function () {
              this._updateVariant(),
                this._updateLabels(),
                this._updateOptionsAvailable();
            },
          },
          {
            key: "_updateURL",
            value: function () {
              if (this.variant && this.dataset.updateUrl === "true") {
                var e3 = ""
                  .concat(this.dataset.url, "?variant=")
                  .concat(this.variant.id);
                window.history.replaceState({}, "", e3);
              }
            },
          },
          {
            key: "_updateVariantInput",
            value: function () {
              var e3 = this._form.variantInput;
              (e3.value = this.variant.id),
                e3.dispatchEvent(new Event("change", { bubbles: !0 }));
            },
          },
          {
            key: "_updatePickupAvailability",
            value: function () {
              this._pickupAvailability.updateVariantId(this.variant.id),
                this._pickupAvailability.fetchAvailability();
            },
          },
          {
            key: "_updateProduct",
            value: function () {
              var e3 = this,
                t3 = ""
                  .concat(this.dataset.url, "?variant=")
                  .concat(this.variant.id, "&section_id=")
                  .concat(this.dataset.sectionIdWithoutPrefix);
              this._updateBlocksByVariantId(this.variant.id),
                typeof updatePdpPrice == "function" &&
                  updatePdpPrice(
                    this.variant.price,
                    this.variant.id,
                    this.variant.available
                  ),
                fetch(t3)
                  .then(function (e4) {
                    return e4.text();
                  })
                  .then(function (t4) {
                    var i3 = ge(t4),
                      n2 = e3.variant.available;
                    e3._form.setDisable(!n2),
                      e3._form.setLoading(!1),
                      e3._updateElements(i3);
                  })
                  .catch(function () {
                    S.notification &&
                      S.notification.show(
                        "Error in variant picker component",
                        "warning"
                      );
                  })
                  .finally(function () {});
            },
          },
          {
            key: "_updateElements",
            value: function (e3) {
              var t3 = this;
              this._elements.forEach(function (i3) {
                var n2 = ""
                    .concat(i3, "-")
                    .concat(t3.dataset.productId, "-")
                    .concat(t3.dataset.section),
                  s2 = document.getElementById(n2);
                s2 && (s2.innerHTML = e3.getElementById(n2).innerHTML);
              });
            },
          },
          {
            key: "_updateBlocksByVariantId",
            value: function (e3) {
              var t3 = this;
              ["product-price", "product-sku", "product-stock"].forEach(
                function (i3) {
                  var n2 = document.getElementById(
                    ""
                      .concat(i3, "-")
                      .concat(t3.dataset.productId, "-")
                      .concat(t3.dataset.section)
                  );
                  n2 && n2.updateByVariantId(e3);
                }
              );
            },
          },
          {
            key: "getCheckedInput",
            value: function (e3) {
              return e3.find(function (e4) {
                return e4.checked;
              });
            },
          },
          {
            key: "_form",
            get: function () {
              return document.getElementById(
                "product-form-component-"
                  .concat(this.dataset.productId, "-")
                  .concat(this.dataset.section)
              );
            },
          },
        ]),
        i2
      );
    })(te),
    as = ss,
    rs = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "_handleClick", function () {
            e3.updateSelected();
          }),
          f(x(e3), "_handleMouseEnter", function (t3) {
            e3.updateActiveValue(t3.target.dataset.value);
          }),
          f(x(e3), "_handleMouseLeave", function () {
            e3.updateSelected();
          }),
          (e3.activeValueSelector =
            "[data-color-swatches-picker-active-value]"),
          (e3.activeValue = e3.querySelector(e3.activeValueSelector)),
          (e3.labelSelector = "[data-color-swatches-picker-label]"),
          (e3.labels = b(e3.querySelectorAll(e3.labelSelector))),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              var e3 = this;
              this.addEventListener("click", this._handleClick),
                this.labels.forEach(function (t3) {
                  t3.addEventListener("mouseenter", e3._handleMouseEnter),
                    t3.addEventListener("mouseleave", e3._handleMouseLeave);
                });
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              var e3 = this;
              this.removeEventListener("click", this._handleClick),
                this.labels.forEach(function (t3) {
                  t3.removeEventListener("mouseenter", e3._handleMouseEnter),
                    t3.removeEventListener("mouseleave", e3._handleMouseLeave);
                });
            },
          },
          {
            key: "updateSelected",
            value: function () {
              var e3 = this.querySelector(
                "".concat(this.labelSelector, ".selected")
              );
              if (e3) {
                var t3 = e3.getAttribute("data-value") || "";
                this.updateActiveValue(t3);
              }
            },
          },
          {
            key: "updateActiveValue",
            value: function (e3) {
              this.activeValue && (this.activeValue.innerHTML = e3);
            },
          },
        ]),
        i2
      );
    })(te),
    os = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "_handleKeydown", function (t3) {
            var i3 = t3.key || t3.keyCode;
            (i3 === H || i3 === F) &&
              (e3.isZoomed ? e3.zoomedImage.reset() : e3.hide());
          }),
          f(x(e3), "_handleCarouselInit", function () {
            e3._updateCarouselDraggableState();
          }),
          f(x(e3), "_handleCarouselSelect", function () {
            e3.updateSelectedSlideNumber();
          }),
          (e3.selectors = {
            carousel: "[data-product-modal-carousel]",
            carouselButtons: "[data-product-modal-carousel-button]",
            carouselSlide: "[data-product-modal-slide]",
            carouselSelectedSlideNumber:
              "[data-product-modal-selected-slide-number]",
            carouselSlideNumber: "[data-product-modal-slide-number]",
            zoomCursor: "zoom-cursor",
          }),
          e3.element &&
            ((e3.carousel = e3.element.querySelector(e3.selectors.carousel)),
            (e3.carouselButtons = e3.carousel.querySelectorAll(
              e3.selectors.carouselButtons
            )),
            (e3._slides = b(
              e3.element.querySelectorAll(e3.selectors.carouselSlide)
            )),
            (e3._selectedSlideNumber = e3.element.querySelector(
              e3.selectors.carouselSelectedSlideNumber
            )),
            (e3._slideNumber = e3.element.querySelector(
              e3.selectors.carouselSlideNumber
            ))),
          (e3._zoomCursor = document.querySelector(e3.selectors.zoomCursor)),
          (e3.mediaIndexMap = e3._createMediaIndexMap()),
          (e3.isZoomed = !1),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "openAndShowMediaById",
            value: function (e3) {
              if ((this.show(), this.carousel)) {
                var t3 = this.mediaIndexMap[e3];
                this.carousel.embla.scrollTo(t3, !0),
                  this.carouselButtons[0] && this.carouselButtons[0].focus(),
                  this.updateSelectedSlideNumber();
              }
            },
          },
          {
            key: "_initCarousel",
            value: function () {
              this.carousel &&
                (this.carousel.embla.on("select", this._handleCarouselSelect),
                this.carousel.embla.on("init", this._handleCarouselInit));
            },
          },
          {
            key: "_resetCarousel",
            value: function () {
              this.carousel &&
                (this.carousel.embla.off("select", this._handleCarouselSelect),
                this.carousel.embla.off("init", this._handleCarouselInit));
            },
          },
          {
            key: "hide",
            value: function () {
              this._resetCarousel(),
                Qt(_(i2.prototype), "hide", this).call(this),
                (this.isZoomed = !1),
                this.updateModal(),
                this.emit("hide", {});
            },
          },
          {
            key: "show",
            value: function () {
              Qt(_(i2.prototype), "show", this).call(this),
                this._initCarousel();
            },
          },
          {
            key: "updateSelectedSlideNumber",
            value: function () {
              if (this._selectedSlideNumber && this.carousel) {
                var e3 = this.carousel.embla.selectedScrollSnap() + 1;
                this._selectedSlideNumber.innerHTML = "".concat(e3);
              }
            },
          },
          {
            key: "updateModal",
            value: function () {
              this._updateCarouselDraggableState(),
                this._updateZoomCursorState(),
                this._updateZoomState();
            },
          },
          {
            key: "_createMediaIndexMap",
            value: function () {
              return this._slides.reduce(function (e3, t3, i3) {
                return t3.dataset.mediaId
                  ? ce(v({}, e3), f({}, t3.dataset.mediaId, i3))
                  : e3;
              }, {});
            },
          },
          {
            key: "_updateCarouselDraggableState",
            value: function () {
              this.carousel &&
                (ci()
                  ? this.carousel.reInit({ draggable: !this.isZoomed })
                  : this.carousel.reInit({ draggable: !1 }));
            },
          },
          {
            key: "_updateZoomCursorState",
            value: function () {
              this._zoomCursor && this._zoomCursor.updateState(this.isZoomed);
            },
          },
          {
            key: "_updateZoomState",
            value: function () {
              this.toggleAttribute("zoom-enabled", this.isZoomed);
            },
          },
        ]),
        i2
      );
    })(Ut),
    ls = os,
    cs = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "_handleImageLoad", function () {
            e3.setPreloaderVisible(!1);
          }),
          f(x(e3), "_handleModalHide", function () {
            e3.reset();
          }),
          f(x(e3), "_handleCarouselSelect", function () {
            e3.reset();
          }),
          f(x(e3), "_handleTouchStart", function (t3) {
            t3.preventDefault(),
              (e3.fingers = t3.touches.length),
              (e3.firstMove = !0),
              e3.detectDoubleTap(t3);
          }),
          f(x(e3), "_handleTouchMove", function (t3) {
            if ((t3.preventDefault(), !e3._isDoubleTapped)) {
              if (e3.firstMove)
                e3.updateGesture(t3), (e3.startMoveTouches = t3.touches.length);
              else if (e3._lastGesture)
                switch (e3._lastGesture) {
                  case "zoom":
                    e3.startMoveTouches === 2 &&
                      t3.touches.length === 2 &&
                      e3.pinch(t3);
                    break;
                  case "drag":
                    if (e3.startMoveTouches === 1 && t3.touches.length === 1) {
                      var i3 = t3.targetTouches[0],
                        n2 = i3.clientX,
                        s2 = i3.clientY;
                      e3.drag(n2, s2);
                    }
                }
              else e3.setGesture("none", t3);
              e3.firstMove = !1;
            }
          }),
          f(x(e3), "_handleTouchEnd", function (t3) {
            t3.preventDefault(),
              (e3.fingers = t3.touches.length),
              e3.updateGesture(t3);
          }),
          f(x(e3), "_handleMouseDown", function (t3) {
            t3.preventDefault(),
              e3.startDrag(t3.clientX, t3.clientY),
              e3.setDragging(!0);
          }),
          f(x(e3), "_handleMouseUp", function (t3) {
            e3.setDragging(!1);
            var i3 = e3._modal.isZoomed ? 75 : 0;
            e3.zoomTimeoutId = setTimeout(function () {
              e3.touchZoom(t3.clientX, t3.clientY);
            }, i3);
          }),
          f(x(e3), "_handleMouseMove", function (t3) {
            if (
              (t3.preventDefault(),
              clearTimeout(e3.zoomTimeoutId),
              e3._isDragging && e3._modal.isZoomed)
            ) {
              var i3 = t3.clientX,
                n2 = t3.clientY;
              e3.drag(i3, n2);
            }
          }),
          (e3._image = e3.querySelector("img")),
          (e3._modal = e3.closest("product-modal")),
          (e3._carousel = e3._modal.carousel),
          (e3._preloader = e3.querySelector(
            "[data-product-modal-image-preloader]"
          )),
          (e3._currentScale = 1),
          (e3._isDragging = !1),
          (e3._offsetX = 0),
          (e3._offsetY = 0),
          (e3._startDragPoint = { x: 0, y: 0 }),
          (e3._maxScale = 3),
          (e3._minScale = 1),
          (e3._isTapped = !1),
          (e3._tapTimeout = 300),
          (e3._lastGesture = null),
          e3.setZoomCursorVisible(!0),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              G.observe(this._preloader),
                this._image.addEventListener(
                  "mousedown",
                  this._handleMouseDown
                ),
                this._image.addEventListener("mouseup", this._handleMouseUp),
                this._image.addEventListener(
                  "mousemove",
                  this._handleMouseMove
                ),
                this._image.addEventListener(
                  "touchstart",
                  this._handleTouchStart
                ),
                this._image.addEventListener("touchend", this._handleTouchEnd),
                this._image.addEventListener(
                  "touchmove",
                  this._handleTouchMove
                ),
                this._image.addEventListener("load", this._handleImageLoad),
                customElements.upgrade(this._modal),
                this._modal.subscribe("hide", this._handleModalHide),
                this._carousel.embla.on("select", this._handleCarouselSelect);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              G.unobserve(this._preloader),
                this._image.removeEventListener(
                  "mousedown",
                  this._handleMouseDown
                ),
                this._image.removeEventListener("mouseup", this._handleMouseUp),
                this._image.removeEventListener(
                  "mousemove",
                  this._handleMouseMove
                ),
                this._image.removeEventListener(
                  "touchstart",
                  this._handleTouchStart
                ),
                this._image.removeEventListener(
                  "touchend",
                  this._handleTouchEnd
                ),
                this._image.removeEventListener(
                  "touchmove",
                  this._handleTouchMove
                ),
                this._image.removeEventListener("load", this._handleImageLoad),
                this._modal.unsubscribe("hide", this._handleModalHide),
                this._carousel.embla.off("select", this._handleCarouselSelect);
            },
          },
          {
            key: "detectDoubleTap",
            value: function (e3) {
              var t3 = this;
              if (this._isTappedTimeout && this.fingers === 1)
                switch (
                  (clearTimeout(this._isTappedTimeout),
                  (this._isTappedTimeout = null),
                  (this._isDoubleTapped = !0),
                  this.touchZoom(
                    e3.changedTouches[0].clientX,
                    e3.changedTouches[0].clientY
                  ),
                  this._lastGesture)
                ) {
                  case "zoom":
                    this.setPinchScaling(!1);
                    break;
                  case "drag":
                    this.setDragging(!1);
                }
              else
                this._isTappedTimeout = setTimeout(function () {
                  (t3._isTappedTimeout = null), (t3._isDoubleTapped = !1);
                }, this._tapTimeout);
            },
          },
          {
            key: "updateGesture",
            value: function (e3) {
              this.fingers === 2
                ? this.setGesture("zoom")
                : this.fingers === 1
                ? this.setGesture("drag", e3)
                : this.setGesture("none", e3);
            },
          },
          {
            key: "setGesture",
            value: function (e3, t3) {
              if (this._lastGesture !== e3) {
                if (this._lastGesture && !e3)
                  switch (this._lastGesture) {
                    case "zoom":
                      this.setPinchScaling(!1);
                      break;
                    case "drag":
                      this.setDragging(!1);
                  }
                switch (e3) {
                  case "zoom":
                    this.setPinchScaling(!0);
                    break;
                  case "drag":
                    this.startDrag(
                      t3.changedTouches[0].clientX,
                      t3.changedTouches[0].clientY
                    ),
                      this.setDragging(!0);
                    break;
                  case "none":
                    this.setDragging(!1), this.setPinchScaling(!1);
                }
              }
              this._lastGesture = e3;
            },
          },
          {
            key: "pinch",
            value: function (e3) {
              var t3 = this.getDistanceBetweenTouches(e3),
                i3 = t3 > this.lastDistanceBetweenTouches,
                n2 = i3 ? 0.125 : -0.125,
                s2 = this.getNewScale(this.currentScale + n2),
                a2 = this.getTouchCenter(e3),
                r2 = (a2.x - this._offsetX) / this.currentScale,
                o2 = (a2.y - this._offsetY) / this.currentScale;
              (this.lastDistanceBetweenTouches = t3),
                i3 || s2 !== 1
                  ? this.setTransform({
                      scale: s2,
                      offsetX: a2.x - r2 * s2,
                      offsetY: a2.y - o2 * s2,
                    })
                  : this.reset();
            },
          },
          {
            key: "getDistanceBetweenTouches",
            value: function (e3) {
              return Math.hypot(
                e3.touches[0].pageX - e3.touches[1].pageX,
                e3.touches[0].pageY - e3.touches[1].pageY
              );
            },
          },
          {
            key: "startDrag",
            value: function (e3, t3) {
              (this._startDragPoint = {
                x: e3 - this._offsetX,
                y: t3 - this._offsetY,
              }),
                (this.dragStartPointX = e3),
                (this.dragStartPointY = t3);
            },
          },
          {
            key: "drag",
            value: function (e3, t3) {
              var i3 = this.dragStartPointX > e3,
                n2 = this.dragStartPointY > t3,
                s2 = this.getNewScale(this.currentScale),
                a2 = e3 - this._startDragPoint.x,
                r2 = t3 - this._startDragPoint.y,
                o2 = this.getIntersectBounds({
                  isRightDrag: i3,
                  isBottomDrag: n2,
                });
              (o2.right || o2.left) && (a2 = this._offsetX),
                (o2.bottom || o2.top) && (r2 = this._offsetY),
                this.setTransform({ scale: s2, offsetX: a2, offsetY: r2 });
            },
          },
          {
            key: "getIntersectBounds",
            value: function (e3) {
              var t3 = e3.isRightDrag,
                i3 = e3.isBottomDrag,
                n2 = this._image.getBoundingClientRect(),
                s2 = t3 ? -8 : 8,
                a2 = i3 ? -8 : 8;
              return {
                right: t3 && n2.right + s2 < window.innerWidth,
                left: !t3 && n2.left + s2 > 0,
                bottom: i3 && n2.bottom + a2 < window.innerHeight,
                top: !i3 && n2.top + a2 > 0,
              };
            },
          },
          {
            key: "getTouchCenter",
            value: function (e3) {
              var t3 = function (e4, t4) {
                  return e4 + t4;
                },
                i3 = b(e3.touches),
                n2 = i3.length;
              return {
                x:
                  i3
                    .map(function (e4) {
                      return e4.pageX;
                    })
                    .reduce(t3) / n2,
                y:
                  i3
                    .map(function (e4) {
                      return e4.pageY;
                    })
                    .reduce(t3) / n2,
              };
            },
          },
          {
            key: "setTransform",
            value: function (e3) {
              var t3 = e3.offsetX,
                i3 = e3.offsetY,
                n2 = e3.scale;
              (this.style.transform = "translate3d("
                .concat(t3, "px, ")
                .concat(i3, "px, 0) scale3d(")
                .concat(n2, ", ")
                .concat(n2, ", 1)")),
                (this._offsetX = t3),
                (this._offsetY = i3),
                (this.currentScale = n2);
            },
          },
          {
            key: "touchZoom",
            value: function (e3, t3) {
              var i3,
                n2,
                s2,
                a2 = (e3 - this._offsetX) / this.currentScale,
                r2 = (t3 - this._offsetY) / this.currentScale;
              this._modal.isZoomed
                ? ((i3 = this.getNewScale(1)), (n2 = 0), (s2 = 0))
                : ((n2 = e3 - a2 * (i3 = this.getNewScale(3))),
                  (s2 = t3 - r2 * i3)),
                (this.style.cursor = this._modal.isZoomed ? "" : "grab"),
                this.setZoomCursorVisible(this._modal.isZoomed),
                this.setTransform({ scale: i3, offsetX: n2, offsetY: s2 });
            },
          },
          {
            key: "reset",
            value: function () {
              this.setTransform({ scale: 1, offsetX: 0, offsetY: 0 });
            },
          },
          {
            key: "getNewScale",
            value: function (e3) {
              return Math.max(this._minScale, Math.min(this._maxScale, e3));
            },
          },
          {
            key: "setPinchScaling",
            value: function (e3) {
              this.toggleAttribute("is-pinch-scaling", e3),
                (this._isPinchScaling = e3);
            },
          },
          {
            key: "setDragging",
            value: function (e3) {
              this.toggleAttribute("is-dragging", e3), (this._isDragging = e3);
            },
          },
          {
            key: "setZoomCursorVisible",
            value: function (e3) {
              this._image.toggleAttribute("data-zoom-cursor-target", e3);
            },
          },
          {
            key: "setModalZoom",
            value: function (e3) {
              (this._modal.isZoomed = e3),
                this._modal.isZoomed && (this._modal.zoomedImage = this),
                this._modal.updateModal();
            },
          },
          {
            key: "setPreloaderVisible",
            value: function (e3) {
              this._preloader.classList.toggle("hidden", !e3),
                this._image.toggleAttribute("is-loaded", !e3);
            },
          },
          {
            key: "currentScale",
            get: function () {
              return this._currentScale;
            },
            set: function (e3) {
              this._currentScale !== e3 &&
                (this.setModalZoom(e3 > 1), (this._currentScale = e3));
            },
          },
        ]),
        i2
      );
    })(te),
    us = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        return d(this, i2), t2.apply(this, arguments);
      }
      return (
        p(i2, [
          {
            key: "showModal",
            value: function () {
              if (this.dataset.modal) {
                var e3 = document.querySelector(this.dataset.modal);
                e3 && e3.openAndShowMediaById(this.dataset.mediaId);
              }
            },
          },
        ]),
        i2
      );
    })(ii),
    ds = us,
    hs = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(
            x((e3 = t2.call(this))),
            "_handleIntersectionObserve",
            function (t3, i3) {
              if (t3[0].isIntersecting) {
                i3.unobserve(x(e3));
                var n2 = e3.dataset.url;
                n2 &&
                  fetch(n2)
                    .then(function (e4) {
                      return e4.text();
                    })
                    .then(function (t4) {
                      var i4 = ge(t4);
                      e3._updateByHTML(i4);
                    })
                    .catch(function () {
                      S.notification &&
                        S.notification.show(
                          "Error in product recommendations component",
                          "warning"
                        );
                    });
              }
            }
          ),
          (e3._intersectionObserver = new IntersectionObserver(
            e3._handleIntersectionObserve,
            { rootMargin: "0px 0px 200px 0px" }
          )),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              this._intersectionObserver.observe(this);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this._intersectionObserver.disconnect();
            },
          },
          {
            key: "_updateByHTML",
            value: function (e3) {
              var t3 = e3.querySelector("product-recommendations");
              t3 && (this.innerHTML = t3.innerHTML);
            },
          },
        ]),
        i2
      );
    })(te),
    ps = window.routes,
    fs = (function () {
      "use strict";
      function e2() {
        d(this, e2);
      }
      return (
        p(e2, [
          {
            key: "get",
            value: function (e3) {
              var t2 = this._prepareQuery(e3);
              return fetch(t2).then(function (e4) {
                return e4.text();
              });
            },
          },
          {
            key: "_prepareQuery",
            value: function (e3) {
              var t2 = e3.searchQuery,
                i2 = e3.sectionId,
                n2 = ps.predictive_search_url,
                s2 = "section_id=".concat(i2);
              return ""
                .concat(n2, "?q=")
                .concat(t2, "&")
                .concat("resources[limit]=999", "&")
                .concat(s2);
            },
          },
        ]),
        e2
      );
    })(),
    vs = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(
            x((e3 = t2.call(this))),
            "_handleInputChange",
            (0, Ji.debounce)(function () {
              e3._searchQuery ? e3._renderResults() : e3._resetResults();
            }, 500)
          ),
          (e3._cache = {}),
          (e3.sidebar = e3.closest("#SearchSidebar")),
          (e3.inputComponentSelector = "[data-sidebar-search-input-component]"),
          (e3.contentResults = "[data-sidebar-search-content-results]"),
          (e3.footerSelector = "[data-sidebar-search-footer]"),
          (e3.itemSelector = "[data-sidebar-search-item]"),
          e3.sidebar &&
            (e3._results = e3.sidebar.element.querySelector(e3.contentResults)),
          (e3._predictiveSearchAPI = new fs()),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              j(this._inputComponent, "input", this._handleInputChange);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              X(this._inputComponent, "input", this._handleInputChange);
            },
          },
          {
            key: "_renderResults",
            value: function () {
              this._cache[this._searchQuery]
                ? this._renderFromCache(this._searchQuery)
                : this._renderFromUrl(this._searchQuery);
            },
          },
          {
            key: "_resetResults",
            value: function () {
              this.sidebar &&
                this._updateResultsFromHTML(this.sidebar.defaultStateElement);
            },
          },
          {
            key: "_renderFromCache",
            value: function (e3) {
              try {
                this._updateResultsFromHTML(this._cache[e3]);
              } catch {
                if (!S.notification) return;
                S.notification.show(
                  "Error in search component when try update from cache",
                  "warning"
                );
              }
            },
          },
          {
            key: "_renderFromUrl",
            value: function (e3) {
              var t3,
                i3 = this,
                n2 =
                  ((t3 = this.sidebar) === null || t3 === void 0
                    ? void 0
                    : t3.dataset.sectionId) || "search-sidebar";
              this._predictiveSearchAPI
                .get({ searchQuery: this._searchQuery, sectionId: n2 })
                .then(function (t4) {
                  var n3 = ge(t4);
                  (i3._cache[e3] = n3), i3._updateResultsFromHTML(n3);
                })
                .catch(function () {
                  S.notification &&
                    S.notification.show("Error in search component", "warning");
                });
            },
          },
          {
            key: "_updateResultsFromHTML",
            value: function (e3) {
              var t3 = e3.getElementById("SearchSidebar");
              if (t3) {
                var i3 = t3.querySelector("template"),
                  n2 = ve(i3).querySelector(this.contentResults);
                this.updateResultsHTML(n2.innerHTML),
                  this.updateFooterVisible();
              }
            },
          },
          {
            key: "updateResultsHTML",
            value: function (e3) {
              this._results && (this._results.innerHTML = e3);
            },
          },
          {
            key: "updateFooterVisible",
            value: function () {
              if (this.sidebar) {
                var e3 = this.sidebar.element.querySelector(
                    this.footerSelector
                  ),
                  t3 = this.sidebar.element.querySelectorAll(this.itemSelector);
                e3 && e3.classList.toggle("hidden", t3.length === 0);
              }
            },
          },
          {
            key: "_searchQuery",
            get: function () {
              return this._inputComponent
                ? this._inputComponent.value.trim()
                : "";
            },
          },
          {
            key: "_inputComponent",
            get: function () {
              return this.sidebar
                ? this.sidebar.querySelector(this.inputComponentSelector)
                : null;
            },
          },
        ]),
        i2
      );
    })(te),
    ms = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(
            x((e3 = t2.apply(this, arguments))),
            "_handleButtonClick",
            function () {
              e3.update();
            }
          ),
          f(x(e3), "_handleKeyDown", function (t3) {
            K(t3.key || t3.keyCode) && (t3.preventDefault(), e3.update());
          }),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              this.addEventListener("keydown", this._handleKeyDown),
                this.addEventListener("click", this._handleButtonClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeEventListener("keydown", this._handleKeyDown),
                this.removeEventListener("click", this._handleButtonClick);
            },
          },
          {
            key: "update",
            value: function () {
              var e3 = this.closest("cart-component, sidebar-cart"),
                t3 = this.dataset.index;
              e3 && t3 && e3.updateItem(+t3, 0);
            },
          },
        ]),
        i2
      );
    })(te),
    gs = ms,
    ys = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(
            x((e3 = t2.apply(this, arguments))),
            "_handleButtonClick",
            function () {
              e3._copy();
            }
          ),
          f(x(e3), "_copy", function () {
            var t3 = e3.dataset.value;
            t3 &&
              navigator.clipboard &&
              navigator.clipboard.writeText(t3).then(function () {
                e3._showTooltip();
              });
          }),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              j(this, "click", this._handleButtonClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              X(this, "click", this._handleButtonClick);
            },
          },
          {
            key: "_showTooltip",
            value: function () {
              var e3 = this.dataset.tooltipId;
              if (e3) {
                var t3 = document.querySelector("#".concat(e3));
                t3 &&
                  (t3.show(),
                  V(1e3).then(function () {
                    t3.hide();
                  }));
              }
            },
          },
        ]),
        i2
      );
    })(te),
    bs = ys,
    ws = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        d(this, i2),
          f(x((e3 = t2.call(this))), "_init", function () {
            e3._target &&
              Pt(e3._target, x(e3), function () {
                It(e3._target, e3, e3._getOptions()).then(function (t3) {
                  e3._updatePosition(t3), e3._updateArrow(t3);
                });
              });
          }),
          f(x(e3), "show", function () {
            e3._mount(), e3._setVisible(!0), e3.emit("show", {});
          }),
          f(x(e3), "hide", function () {
            e3._setVisible(!1), e3._unmount(), e3.emit("hide", {});
          });
        var n2 = e3.querySelector("template");
        return (
          (e3.element = ve(n2)),
          (e3._arrow = e3.element.querySelector("[data-float-element-arrow]")),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              this._init();
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this._unmount();
            },
          },
          {
            key: "_updatePosition",
            value: function (e3) {
              var t3 = e3.x,
                i3 = e3.y;
              Object.assign(this.style, {
                left: "".concat(t3, "px"),
                top: "".concat(i3, "px"),
              });
            },
          },
          {
            key: "_getOptions",
            value: function () {
              return {
                placement: this._placement,
                middleware: this._getMiddleware(),
                strategy: "absolute",
              };
            },
          },
          {
            key: "_getMiddleware",
            value: function () {
              var e3 = this.dataset.alignmentAxisOffset || 0,
                t3 = this.dataset.mainAxisOffset || 0,
                i3 = [Ye({ alignmentAxis: +e3, mainAxis: +t3 }), Xe(), Ke()];
              return this._arrow && i3.push(He({ element: this._arrow })), i3;
            },
          },
          {
            key: "_updateArrow",
            value: function (e3) {
              var t3 = e3.placement,
                i3 = e3.middlewareData;
              if (this._arrow) {
                var n2 = i3.arrow,
                  s2 = n2.x,
                  a2 = n2.y,
                  r2 = {
                    top: "bottom",
                    right: "left",
                    bottom: "top",
                    left: "right",
                  }[t3.split("-")[0]];
                Object.assign(
                  this._arrow.style,
                  f(
                    {
                      left: s2 != null ? "".concat(s2, "px") : "",
                      top: a2 != null ? "".concat(a2, "px") : "",
                      right: "",
                      bottom: "",
                    },
                    r2,
                    "-5px"
                  )
                );
              }
            },
          },
          {
            key: "_mount",
            value: function () {
              this.contains(this.element) || this.appendChild(this.element);
            },
          },
          {
            key: "_unmount",
            value: function () {
              this.element && this.element.remove();
            },
          },
          {
            key: "_setVisible",
            value: function (e3) {
              this.setAttribute("aria-hidden", e3 ? "false" : "true");
            },
          },
          {
            key: "_target",
            get: function () {
              return document.querySelector(
                '[data-clipboard-button-tooltip-target-id="'.concat(
                  this.id,
                  '"]'
                )
              );
            },
          },
          {
            key: "_placement",
            get: function () {
              return this.dataset.placement || "bottom-end";
            },
          },
        ]),
        i2
      );
    })(te),
    Ss = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        return d(this, i2), t2.apply(this, arguments);
      }
      return (
        p(i2, [
          {
            key: "setImagesAttributes",
            value: function () {
              var e3 = this.querySelectorAll("img"),
                t3 = [80, 160, 300, 400, 500, 680, 900];
              e3.forEach(function (e4) {
                var i3 = t3
                  .map(function (t4) {
                    return ""
                      .concat(e4.dataset.imageUrl, "&width=")
                      .concat(t4, " ")
                      .concat(t4, "w");
                  })
                  .join(",");
                e4.dataset.srcset = i3;
              });
            },
          },
        ]),
        i2
      );
    })(te),
    xs = Ss,
    Cs = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "handleMouseEnter", function () {
            var t3 = e3.dataset.url,
              i3 = e3.dataset.id;
            t3 && i3 && Hn.requestProductFromUrl(t3, i3);
          }),
          f(x(e3), "handleQuickViewBtnClick", function () {
            var t3 = e3.dataset.url;
            t3 && Hn.openAndRenderProductByUrl(t3);
          }),
          f(x(e3), "handleResize", function () {
            e3.buttons && e3.setButtonsOverflow(),
              e3.mediaTabs && e3.mediaTabs.update(),
              e3.colorSwatches && e3.colorSwatches.update();
          }),
          f(x(e3), "handleImageLoad", function () {
            var t3;
            (e3.loadedImageCount += 1),
              e3.loadedImageCount ===
                ((t3 = e3.images) === null || t3 === void 0
                  ? void 0
                  : t3.length) && (e3.removePreloader(), e3.showImages());
          }),
          (e3.resizeObserver = new ResizeObserver(e3.handleResize)),
          (e3.lastButtonsWidth = 0),
          (e3.quickViewBtnSelector = "[data-product-card-quick-view-button]"),
          (e3.preloaderSelector = "[data-product-card-preloader]"),
          (e3.imagesContainerSelector = "[data-product-card-media-container]"),
          (e3.buttonsSelector = "[data-product-card-buttons]"),
          (e3.imagesSelector = "[data-product-card-featured-image]"),
          (e3.mediaTabsSelector = "[data-product-card-media-tabs]"),
          (e3.colorSwatchesSelector = "[data-product-card-color-swatches]"),
          (e3.quickViewBtn = e3.querySelector(e3.quickViewBtnSelector)),
          (e3.preloader = e3.querySelector(e3.preloaderSelector)),
          (e3.imagesContainer = e3.querySelector(e3.imagesContainerSelector)),
          (e3.buttons = e3.querySelector(e3.buttonsSelector)),
          (e3.buttonList = b(
            e3.querySelectorAll("[data-product-card-button]")
          )),
          (e3.images = b(e3.querySelectorAll(e3.imagesSelector))),
          (e3.mediaTabs = e3.querySelector(e3.mediaTabsSelector)),
          (e3.colorSwatches = e3.querySelector(e3.colorSwatchesSelector)),
          (e3.loadedImageCount = 0),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              var e3 = this;
              this.setImagesAttributes(),
                this.images.forEach(function (t3) {
                  t3.addEventListener("load", e3.handleImageLoad);
                }),
                this.resizeObserver.observe(this),
                G.observe(this),
                this.addEventListener("mouseenter", this.handleMouseEnter),
                this.quickViewBtn &&
                  this.quickViewBtn.addEventListener(
                    "click",
                    this.handleQuickViewBtnClick
                  );
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              var e3 = this;
              this.images.forEach(function (t3) {
                t3.removeEventListener("load", e3.handleImageLoad);
              }),
                this.resizeObserver.disconnect(),
                G.unobserve(this),
                this.removeEventListener("mouseenter", this.handleMouseEnter),
                this.quickViewBtn &&
                  this.quickViewBtn.removeEventListener(
                    "click",
                    this.handleQuickViewBtnClick
                  );
            },
          },
          {
            key: "setButtonsOverflow",
            value: function () {
              if (this.buttons) {
                var e3 = this.getButtonsWidth(),
                  t3 = this.buttons.offsetWidth < e3;
                t3 && (this.lastButtonsWidth = this.buttons.offsetWidth),
                  this.buttons.classList.toggle(
                    "product-card__btns--overflowed",
                    t3
                  );
              }
            },
          },
          {
            key: "getButtonsWidth",
            value: function () {
              return this.buttonList.reduce(
                function (e3, t3) {
                  var i3 = t3.querySelector("[data-product-card-button-text]");
                  return e3 + (20 + ((i3 ? i3.offsetWidth : 0) + 8) + 10) + 8;
                },
                this.buttonList.length > 1 ? 8 : 0
              );
            },
          },
          {
            key: "removePreloader",
            value: function () {
              this.preloader && (this.preloader.remove(), G.unobserve(this));
            },
          },
          {
            key: "showImages",
            value: function () {
              this.imagesContainer &&
                this.imagesContainer.setAttribute("visible", "");
            },
          },
        ]),
        i2
      );
    })(xs),
    ks = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(
            x((e3 = t2.call(this))),
            "_handleResize",
            (0, Ji.debounce)(function () {
              e3._setMaxLines();
            }, 100)
          ),
          (e3._resizeObserver = new ResizeObserver(e3._handleResize)),
          (e3.targetSelector = "[data-quote-line-clamp-target]"),
          (e3.lineClampSelector = "[data-quote-line-clamp]"),
          (e3._lineClamp = e3.querySelector(e3.lineClampSelector)),
          (e3._target = e3.querySelector(e3.targetSelector)),
          (e3.styles = getComputedStyle(e3._target)),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              this._resizeObserver.observe(this);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this._resizeObserver.disconnect();
            },
          },
          {
            key: "_setMaxLines",
            value: function () {
              var e3 = this._getMaxLines();
              e3 &&
                this._target &&
                (this._target.style.setProperty(
                  "--gsc-max-lines",
                  "".concat(e3)
                ),
                this.setAttribute("data-line-clamp-setter-is-ready", ""));
            },
          },
          {
            key: "_getMaxLines",
            value: function () {
              if (!this._lineClamp || !this._target) return 0;
              var e3 = this.styles.lineHeight,
                t3 = this._lineClamp.offsetHeight;
              return Math.floor(t3 / parseFloat(e3));
            },
          },
        ]),
        i2
      );
    })(te),
    Es = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "_handleItemClick", function (t3) {
            e3._input &&
              e3._dropdownBtnLabel &&
              e3._dropdown &&
              (e3._input.setAttribute("value", t3.target.dataset.value),
              e3._setActiveItem(t3.target.dataset.value),
              (e3._dropdownBtnLabel.innerHTML = t3.target.dataset.value),
              e3._dropdown.hide());
          }),
          (e3._input = e3.querySelector("input")),
          (e3._dropdown = e3.querySelector("float-element")),
          (e3._dropdownBtnLabel = e3.querySelector(".dropdown__toggle-label")),
          e3._createItems(),
          (e3._items = b(e3.querySelectorAll(".dropdown__item"))),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              var e3 = this;
              this._items.forEach(function (t3) {
                j(t3, "click", e3._handleItemClick);
              });
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              var e3 = this;
              this._items.forEach(function (t3) {
                X(t3, "click", e3._handleItemClick);
              });
            },
          },
          {
            key: "_setActiveItem",
            value: function (e3) {
              this._items.forEach(function (t3) {
                t3.classList.toggle("active", t3.dataset.value === e3);
              });
            },
          },
          {
            key: "_createItems",
            value: function () {
              var e3 = this;
              this.querySelectorAll("option").forEach(function (t3) {
                if (e3._dropdown) {
                  var i3 = document.createElement("div");
                  i3.classList.add("dropdown__item"),
                    (i3.dataset.value = t3.value),
                    (i3.dataset.provinces = t3.dataset.provinces),
                    (i3.innerHTML = t3.innerHTML),
                    e3._dropdown.appendChild(i3);
                }
              });
            },
          },
        ]),
        i2
      );
    })(te),
    Ts = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "_handleWindowClick", function (t3) {
            var i3 = t3.target,
              n2 = i3.closest("search-input");
            e3._input !== i3 && !n2 && e3._updateResetButtonVisible();
          }),
          f(x(e3), "_handleInputChange", function () {
            e3._updateResetButtonVisible();
          }),
          f(x(e3), "_handleResetBtnClick", function (t3) {
            t3.preventDefault(), e3.reset();
          }),
          (e3._inputSelector = "[data-search-field-input]"),
          (e3._resetBtnSelector = "[data-search-field-reset-button]"),
          (e3._input = e3.querySelector(e3._inputSelector)),
          (e3._resetBtn = e3.querySelector(e3._resetBtnSelector)),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              j(this._input, "input", this._handleInputChange),
                j(window, "click", this._handleWindowClick),
                j(this._resetBtn, "click", this._handleResetBtnClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              X(this._input, "input", this._handleInputChange),
                X(window, "click", this._handleWindowClick),
                X(this._resetBtn, "click", this._handleResetBtnClick);
            },
          },
          {
            key: "reset",
            value: function () {
              if (this._input) {
                var e3 = new Event("input", { bubbles: !0 });
                (this._input.value = ""),
                  this._input.dispatchEvent(e3),
                  this._input.focus();
              }
            },
          },
          {
            key: "_updateResetButtonVisible",
            value: function () {
              if (this._resetBtn) {
                var e3 = this._hasInputValue();
                this._resetBtn.classList.toggle("hidden", !e3);
              }
            },
          },
          {
            key: "_hasInputValue",
            value: function () {
              return !!this._input && this._input.value.trim().length > 0;
            },
          },
          {
            key: "value",
            get: function () {
              return this._input ? this._input.value : "";
            },
          },
        ]),
        i2
      );
    })(te),
    _s = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "_handleButtonClick", function () {
            e3._togglePasswordVisible();
          }),
          (e3._inputSelector = "[data-password-field-input]"),
          (e3._buttonSelector = "[data-password-field-button]"),
          (e3._input = e3.querySelector(e3._inputSelector)),
          (e3._button = e3.querySelector(e3._buttonSelector)),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              j(this._button, "click", this._handleButtonClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              X(this._button, "click", this._handleButtonClick);
            },
          },
          {
            key: "_togglePasswordVisible",
            value: function () {
              if (this._input) {
                var e3 = this._input.getAttribute("type") === "password",
                  t3 = e3 ? "text" : "password";
                this._input.setAttribute("type", t3), this._setButton(e3);
              }
            },
          },
          {
            key: "_setButton",
            value: function (e3) {
              this._button &&
                this._button.toggleAttribute("password-visible", e3);
            },
          },
        ]),
        i2
      );
    })(te),
    Ms = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "_handleMutations", function (t3) {
            t3.forEach(function (t4) {
              if (t4.type === "attributes") {
                var i3 = t4.target.matches(e3.zoomTargetSelector);
                e3._setVisible(i3);
              }
            });
          }),
          f(x(e3), "_handleMouseMove", function (t3) {
            var i3 = t3.target,
              n2 = !!i3.closest(e3.zoomTargetSelector),
              s2 = ci();
            e3._isVisible &&
              ((e3.style.top = "".concat(t3.clientY, "px")),
              (e3.style.left = "".concat(t3.clientX, "px"))),
              s2 ||
                (e3._setVisible(n2),
                n2 && e3.mutationObserver.observe(i3, { attributes: !0 }));
          }),
          (e3.zoomTargetSelector = "[data-zoom-cursor-target]"),
          (e3.mutationObserver = new MutationObserver(e3._handleMutations)),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              this._autoCheckTargets();
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              X(window, "mousemove", this._handleMouseMove),
                this.mutationObserver.disconnect(),
                clearInterval(this.checkTargetsIntervalID);
            },
          },
          {
            key: "_setVisible",
            value: function (e3) {
              this.toggleAttribute("visible", e3),
                (document.body.style.cursor = e3 ? "none" : "");
            },
          },
          {
            key: "updateState",
            value: function (e3) {
              this.toggleAttribute("zoomed", e3);
            },
          },
          {
            key: "_autoCheckTargets",
            value: function () {
              var e3 = this;
              this.checkTargetsIntervalID = setInterval(function () {
                document.querySelectorAll(e3.zoomTargetSelector).length &&
                  !e3.isHandlerSetted &&
                  (j(window, "mousemove", e3._handleMouseMove),
                  (e3.isHandlerSetted = !0));
              }, 1e3);
            },
          },
          {
            key: "_isVisible",
            get: function () {
              return this.hasAttribute("visible");
            },
          },
        ]),
        i2
      );
    })(te),
    Ls = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "_handleHistoryChange", function (t3) {
            var i3 = t3.state.searchParams || e3._searchParamsInitial;
            i3 !== e3._searchParamsPrev && e3.updateBySearchParams(i3);
          }),
          (e3._cache = {}),
          (e3._searchParamsInitial = window.location.search.slice(1)),
          (e3._searchParamsPrev = window.location.search.slice(1)),
          (e3.sortQuery = ""),
          (e3.filterQuery = ""),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              j(window, "popstate", this._handleHistoryChange);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              X(window, "popstate", this._handleHistoryChange);
            },
          },
          {
            key: "_formatParams",
            value: function (e3) {
              this._searchParamsPrev = e3;
              var t3 = this.dataset.baseParams || "";
              return "".concat(t3).concat(e3);
            },
          },
          {
            key: "updateBySearchParams",
            value: function (e3) {
              this.updateShopBySearchParams(e3),
                this.updateFiltersBySearchParams(e3);
            },
          },
          {
            key: "updateShopBySearchParams",
            value: function (e3) {
              var t3 = this,
                i3 = this._createUrl(e3);
              this._cache[i3]
                ? this._updateElements(this._cache[i3])
                : this._getFromUrl(i3).then(function (e4) {
                    return t3._updateElements(e4);
                  }),
                this._updateURL(e3, i3);
            },
          },
          {
            key: "updateFiltersBySearchParams",
            value: function (e3) {
              var t3 = this._createUrl(e3),
                i3 = document.querySelector("#SidebarFiltersMobile"),
                n2 = document.querySelector("#SidebarFiltersDesktop");
              if (i3 && n2) {
                var s2 = [i3, n2];
                s2.forEach(function (e4) {
                  e4.loadingOverlay.show();
                });
                var a2 = function (e4) {
                  s2.forEach(function (t4) {
                    t4.updateHTML(e4), t4.loadingOverlay.hide();
                  });
                };
                this._cache[t3]
                  ? a2(this._cache[t3])
                  : this._getFromUrl(t3).then(function (e4) {
                      return a2(e4);
                    });
              }
            },
          },
          {
            key: "_getFromUrl",
            value: function (e3) {
              var t3 = this,
                i3 = this.querySelector("#ShopProductsOverlay"),
                n2 = i3 ? new Tn(i3) : null;
              n2 && n2.show();
              var s2 = ""
                .concat(e3, "&section_id=")
                .concat(this.dataset.sectionId);
              return fetch(s2)
                .then(function (e4) {
                  return e4.text();
                })
                .then(function (i4) {
                  var s3 = ge(i4);
                  return (t3._cache[e3] = s3), n2 && n2.hide(), s3;
                })
                .catch(function () {
                  S.notification &&
                    S.notification.show("Error in shop component", "warning");
                });
            },
          },
          {
            key: "_updateURL",
            value: function (e3, t3) {
              history.pushState({ searchParams: e3 }, "", t3);
            },
          },
          {
            key: "_createUrl",
            value: function (e3) {
              var t3 = this._formatParams(e3) || "";
              return "".concat(window.location.pathname, "?").concat(t3);
            },
          },
          {
            key: "_updateElements",
            value: function (e3) {
              [
                "ShopProducts",
                "ShopProductCount",
                "ShopSortList",
                "ShopActiveFilters",
              ].forEach(function (t3) {
                var i3 = document.getElementById(t3),
                  n2 = e3.getElementById(t3);
                i3 && n2 && (i3.innerHTML = n2.innerHTML);
              });
            },
          },
          {
            key: "resetQueries",
            value: function () {
              (this.sortQuery = ""), (this.filterQuery = "");
            },
          },
        ]),
        i2
      );
    })(te),
    Ps = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          ((e3 = t2.call(this)).optionsSelector =
            "[data-shop-active-filters-options]"),
          (e3.removeBtnSelector = "[data-shop-active-filters-remove-btn]"),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "reset",
            value: function () {
              this.innerHTML = "";
            },
          },
          {
            key: "setDisable",
            value: function () {
              this.options && this.options.setAttribute("disabled", "");
            },
          },
          {
            key: "options",
            get: function () {
              return this.querySelector(this.optionsSelector);
            },
          },
          {
            key: "buttons",
            get: function () {
              return b(this.querySelectorAll(this.removeBtnSelector));
            },
          },
        ]),
        i2
      );
    })(te),
    Is = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "_handleFormScroll", function () {
            if (e3.form) {
              var t3 = e3.form.scrollTop > 0;
              e3.toggleAttribute("header-shadow-visible", t3);
            }
          }),
          f(x(e3), "_handleClick", function (e4) {
            var t3 = e4.target.closest("[data-filters-checkbox]");
            t3 && t3.setAttribute("selected", "");
          }),
          f(x(e3), "_handleInputChange", function (t3) {
            t3.target.tagName === "INPUT" && e3._change();
          }),
          (e3.form = e3.element.querySelector("[data-filters-form]")),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              Qt(_(i2.prototype), "connectedCallback", this).call(this),
                j(this.form, "scroll", this._handleFormScroll),
                j(this, "change", this._handleInputChange),
                j(this, "click", this._handleClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              Qt(_(i2.prototype), "disconnectedCallback", this).call(this),
                X(this.form, "scroll", this._handleFormScroll),
                X(this, "change", this._handleInputChange),
                X(this, "click", this._handleClick);
            },
          },
          { key: "_change", value: function () {} },
          {
            key: "_createFilterQuery",
            value: function () {
              if (this._form && this._shop) {
                var e3 = new FormData(this._form),
                  t3 = new URLSearchParams(e3).toString();
                this._shop.filterQuery = t3;
              }
            },
          },
          {
            key: "updateHTML",
            value: function (e3) {
              var t3 = this.getAttribute("id"),
                i3 = t3 ? e3.getElementById(t3) : null,
                n2 = i3 ? i3.querySelector("template") : null;
              if (n2) {
                var s2 = ve(n2);
                this.updateFormFromElement(s2),
                  this.updateHeaderFromElement(s2);
              }
            },
          },
          {
            key: "updateHeaderFromElement",
            value: function (e3) {
              var t3 = this.element.querySelector("[data-filters-header]"),
                i3 = e3.querySelector("[data-filters-header]");
              t3 && i3 && (t3.innerHTML = i3.innerHTML);
            },
          },
          {
            key: "updateFormFromElement",
            value: function (e3) {
              var t3 = this.element.querySelector("[data-filters-form]"),
                i3 = e3.querySelector("[data-filters-form]");
              t3 && i3 && (t3.innerHTML = i3.innerHTML);
            },
          },
          {
            key: "_form",
            get: function () {
              return this.element.querySelector("form");
            },
          },
          {
            key: "_shop",
            get: function () {
              return this.element.closest("shop-component");
            },
          },
          {
            key: "_searchParams",
            get: function () {
              return this._shop
                ? [this._shop.filterQuery, this._shop.sortQuery].join("&")
                : "";
            },
          },
          {
            key: "loadingOverlay",
            get: function () {
              var e3 = this.element.querySelector(
                "[data-filters-loading-overlay]"
              );
              return e3 ? new Tn(e3) : null;
            },
          },
        ]),
        i2
      );
    })(li),
    Ds = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        return d(this, i2), t2.apply(this, arguments);
      }
      return (
        p(i2, [
          {
            key: "_change",
            value: function () {
              this._shop &&
                (this._createFilterQuery(),
                this._shop.updateBySearchParams(this._searchParams));
            },
          },
        ]),
        i2
      );
    })(Is),
    As = Ds,
    zs = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        return d(this, i2), t2.apply(this, arguments);
      }
      return (
        p(i2, [
          {
            key: "_change",
            value: function () {
              this._shop &&
                (this._createFilterQuery(),
                this._shop.updateFiltersBySearchParams(this._searchParams),
                this._setButtonForReset());
            },
          },
          {
            key: "_setButtonForReset",
            value: function () {
              var e3 = this.element.querySelector("filter-remove-btn");
              e3 && e3.classList.contains("hidden") && de(e3);
            },
          },
        ]),
        i2
      );
    })(Is),
    Os = zs,
    Bs = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(
            x((e3 = t2.apply(this, arguments))),
            "_handleButtonClick",
            function () {
              e3.update();
            }
          ),
          f(x(e3), "_handleKeyDown", function (t3) {
            K(t3.key || t3.keyCode) && (t3.preventDefault(), e3.update());
          }),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              this.addEventListener("keydown", this._handleKeyDown),
                this.addEventListener("click", this._handleButtonClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeEventListener("keydown", this._handleKeyDown),
                this.removeEventListener("click", this._handleButtonClick);
            },
          },
          {
            key: "update",
            value: function () {
              var e3 = this.closest("shop-active-filters"),
                t3 = this.closest("shop-component"),
                i3 = this.dataset.url;
              if (e3) {
                var n2 = this.hasAttribute(
                  "data-shop-active-filters-remove-btn"
                );
                this.hasAttribute("data-shop-active-filters-reset") &&
                  e3.reset(),
                  n2 &&
                    (e3.buttons.length === 1
                      ? e3.reset()
                      : (e3.setDisable(), this.remove()));
              }
              if (i3 && t3) {
                var s2 =
                  i3.indexOf("?") === -1 ? "" : i3.slice(i3.indexOf("?") + 1);
                t3.resetQueries(), t3.updateBySearchParams(s2);
              }
            },
          },
        ]),
        i2
      );
    })(te),
    Ns = Bs,
    qs = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(
            x((e3 = t2.call(this))),
            "_handleFormSubmit",
            (0, Ji.debounce)(function (t3) {
              t3.preventDefault();
              var i3 = e3.closest("shop-component"),
                n2 = e3.closest("sidebar-component"),
                s2 = t3.target;
              if ((n2 && n2.hide(), i3 && s2)) {
                var a2 = e3._getSortQuery(s2),
                  r2 = [i3.filterQuery, a2].join("&");
                (i3.sortQuery = a2), i3.updateBySearchParams(r2);
              }
            }, 250)
          ),
          f(x(e3), "_handleLabelKeyDown", function (e4) {
            if (K(e4.key || e4.keyCode)) {
              e4.preventDefault();
              var t3 = e4.target.querySelector("input");
              if (t3) {
                var i3 = new MouseEvent("click", { button: 0, which: 1 });
                t3.dispatchEvent(i3);
              }
            }
          }),
          (e3.labelSelector = "[data-sort-list-label]"),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              this.setListenersForLabels(),
                j(this._form, "input", this._handleFormSubmit);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeListenersForLabels(),
                X(this._form, "input", this._handleFormSubmit);
            },
          },
          {
            key: "_getSortQuery",
            value: function (e3) {
              var t3 = e3.closest("form");
              if (t3) {
                var i3 = new FormData(t3);
                return new URLSearchParams(i3).toString();
              }
              return "";
            },
          },
          {
            key: "setListenersForLabels",
            value: function () {
              var e3 = this;
              b(this.querySelectorAll(this.labelSelector)).forEach(function (
                t3
              ) {
                t3.addEventListener("keydown", e3._handleLabelKeyDown);
              });
            },
          },
          {
            key: "removeListenersForLabels",
            value: function () {
              var e3 = this;
              b(this.querySelectorAll(this.labelSelector)).forEach(function (
                t3
              ) {
                t3.removeEventListener("keydown", e3._handleLabelKeyDown);
              });
            },
          },
          {
            key: "_form",
            get: function () {
              return this.querySelector("form");
            },
          },
        ]),
        i2
      );
    })(te),
    $s = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "_handleRangeInput", function (t3) {
            var i3 = e3.querySelector("[data-price-range-max-input]"),
              n2 = e3.querySelector("[data-price-range-min-input]");
            if (e3._progress && n2 && i3) {
              var s2 = e3._progress.offsetLeft + e3._progress.offsetWidth / 2,
                a2 = t3.offsetX < s2;
              n2.toggleAttribute("targeted", a2),
                i3.toggleAttribute("targeted", !a2);
            }
          }),
          f(x(e3), "_handleNumberChange", function () {
            if (e3._minNumberInput && e3._maxNumberInput) {
              var t3 = parseInt(e3._minNumberInput.value),
                i3 = parseInt(e3._maxNumberInput.value);
              e3._updateMinRangeInput(t3), e3._updateMaxRangeInput(i3);
            }
          }),
          f(x(e3), "_handleRangeChange", function () {
            if (e3._minRangeInput && e3._maxRangeInput) {
              var t3 = parseInt(e3._minRangeInput.value),
                i3 = parseInt(e3._maxRangeInput.value);
              e3._updateMaxPriceInput(i3),
                e3._updateMaxRangeInput(i3),
                e3._updateMinPriceInput(t3),
                e3._updateMinRangeInput(t3);
            }
          }),
          (e3._minNumberInput = e3.querySelector(
            "[data-price-min-range-number]"
          )),
          (e3._maxNumberInput = e3.querySelector(
            "[data-price-max-range-number]"
          )),
          (e3._rangeWrapper = e3.querySelector(
            "[data-price-range-inputs-wrapper]"
          )),
          (e3._minRangeInput = e3.querySelector(
            "[data-price-min-range-input]"
          )),
          (e3._maxRangeInput = e3.querySelector(
            "[data-price-max-range-input]"
          )),
          (e3._progress = e3.querySelector("[data-price-range-progress]")),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              this._minRangeInput &&
                this._updateMinRangeInput(+this._minRangeInput.value),
                this._maxRangeInput &&
                  this._updateMaxRangeInput(+this._maxRangeInput.value),
                j(this._minNumberInput, "input", this._handleNumberChange),
                j(this._maxNumberInput, "input", this._handleNumberChange),
                j(this._minRangeInput, "input", this._handleRangeChange),
                j(this._maxRangeInput, "input", this._handleRangeChange),
                j(this._rangeWrapper, "mouseenter", this._handleRangeInput),
                j(this._rangeWrapper, "mousemove", this._handleRangeInput);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              X(this._minNumberInput, "input", this._handleNumberChange),
                X(this._maxNumberInput, "input", this._handleNumberChange),
                X(this._minRangeInput, "input", this._handleRangeChange),
                X(this._maxRangeInput, "input", this._handleRangeChange),
                X(this._rangeWrapper, "mouseenter", this._handleRangeInput),
                X(this._rangeWrapper, "mousemove", this._handleRangeInput);
            },
          },
          {
            key: "_updateMaxRangeInput",
            value: function (e3) {
              if (this._maxRangeInput && this._progress) {
                var t3 = 100 - (e3 / +this._maxRangeInput.max) * 100;
                (this._maxRangeInput.value = "".concat(e3)),
                  (this._progress.style.right = "".concat(t3, "%"));
              }
            },
          },
          {
            key: "_updateMinRangeInput",
            value: function (e3) {
              if (this._minRangeInput && this._progress) {
                var t3 = (e3 / +this._minRangeInput.max) * 100;
                (this._minRangeInput.value = "".concat(e3)),
                  (this._progress.style.left = "".concat(t3, "%"));
              }
            },
          },
          {
            key: "_updateMaxPriceInput",
            value: function (e3) {
              this._maxNumberInput &&
                (this._maxNumberInput.value = e3.toFixed(2));
            },
          },
          {
            key: "_updateMinPriceInput",
            value: function (e3) {
              this._minNumberInput &&
                (this._minNumberInput.value = e3.toFixed(2));
            },
          },
        ]),
        i2
      );
    })(te),
    Hs = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "_handleSectionLoad", function (t3) {
            e3.dataset.sectionId === t3.detail.sectionId && e3.reset();
          }),
          f(x(e3), "_handleItemClick", function (t3) {
            var i3 = t3.target.closest(e3.itemSelector);
            if (i3) {
              var n2 = +(i3.dataset.value || 1);
              e3._switch(n2);
            }
          }),
          f(x(e3), "_handleKeyDown", function (t3) {
            if (K(t3.key || t3.keyCode)) {
              t3.preventDefault();
              var i3 = t3.target.closest(e3.itemSelector);
              if (i3) {
                var n2 = +(i3.dataset.value || 1);
                e3._switch(n2);
              }
            }
          }),
          (e3.itemSelector = "[data-column-switcher-item]"),
          (e3.targetSelector = "[data-column-switcher-target]"),
          (e3.items = b(e3.querySelectorAll(e3.itemSelector))),
          (e3._cssVariable = e3.dataset.columnSwitcherCssVariable || ""),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              var e3 = this;
              this._init(),
                this.items.forEach(function (t3) {
                  j(t3, "keydown", e3._handleKeyDown),
                    j(t3, "click", e3._handleItemClick);
                }),
                this._isEditorMode &&
                  this._editor.subscribe(
                    "SECTION_LOAD",
                    this._handleSectionLoad
                  );
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              var e3 = this;
              this.items.forEach(function (t3) {
                X(t3, "keydown", e3._handleKeyDown),
                  X(t3, "click", e3._handleItemClick);
              }),
                this._isEditorMode && this._editor.destroy();
            },
          },
          {
            key: "updateByColumnCount",
            value: function (e3) {
              this._selectSwitch(e3), this._updateColumnCount(e3);
            },
          },
          {
            key: "_selectSwitch",
            value: function (e3) {
              this.items.forEach(function (t3) {
                var i3 = +(t3.getAttribute("data-value") || 1);
                t3.classList.toggle("selected", i3 === e3);
              });
            },
          },
          {
            key: "_updateColumnCount",
            value: function (e3) {
              var t3 = this.closest(this.targetSelector);
              t3 &&
                (t3.style.setProperty(
                  "--gsc-".concat(this._cssVariable),
                  e3.toString()
                ),
                localStorage.setItem(
                  "products-".concat(this._cssVariable),
                  e3.toString()
                ));
            },
          },
          {
            key: "_init",
            value: function () {
              var e3 = localStorage.getItem(
                "products-".concat(this._cssVariable)
              );
              if (e3 && e3 !== "null") {
                var t3 = Number(e3);
                t3 > 0 && this.updateByColumnCount(t3);
              }
            },
          },
          {
            key: "_switch",
            value: function (e3) {
              this.updateByColumnCount(e3);
            },
          },
          {
            key: "reset",
            value: function () {
              this.dataset.default &&
                this._switch(Number(this.dataset.default));
            },
          },
        ]),
        i2
      );
    })(te),
    Fs = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(
            x((e3 = t2.apply(this, arguments))),
            "_handleButtonClick",
            function () {
              var t3 = e3.closest("shop-component"),
                i3 = e3.closest("#SidebarFiltersMobile");
              if (t3) {
                var n2 = [t3.filterQuery, t3.sortQuery].join("&");
                t3.updateShopBySearchParams(n2);
              }
              i3 && i3.hide();
            }
          ),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              j(this, "click", this._handleButtonClick);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              X(this, "click", this._handleButtonClick);
            },
          },
        ]),
        i2
      );
    })(te),
    Vs = Fs,
    Rs = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "_handleButtonMouseDown", function (t3) {
            t3.preventDefault(), e3.startMove();
          }),
          f(x(e3), "_handleButtonMouseUp", function () {
            e3.endMove();
          }),
          f(x(e3), "_handleMouseMove", function (t3) {
            e3._isMoved && e3.moveSeparator(t3.pageX);
          }),
          f(x(e3), "_handleButtonKeyUp", function (t3) {
            if (e3._btn) {
              var i3 = t3.key || t3.keyCode,
                n2 = Z(i3),
                s2 = Q(i3);
              if (n2 || s2) {
                var a2 = e3._btn.getBoundingClientRect(),
                  r2 = a2.right - a2.width / 2,
                  o2 = n2 ? r2 - e3._movingStep : r2 + e3._movingStep;
                e3.moveSeparator(o2);
              }
            }
          }),
          f(x(e3), "_handleTouchStart", function () {
            e3.startMove();
          }),
          f(x(e3), "_handleTouchEnd", function () {
            e3.endMove();
          }),
          f(x(e3), "_handleTouchMove", function (t3) {
            e3._isMoved &&
              (t3.preventDefault(),
              e3.moveSeparator(t3.targetTouches[0].clientX));
          }),
          (e3._btnSelector = "[data-before-after-images-button]"),
          (e3._btn = e3.querySelector(e3._btnSelector)),
          (e3._isMoved = !1),
          (e3._movingStep = 20),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              this.setSeparatorPosition(
                Number(this.dataset.initialDragPosition)
              ),
                j(this._btn, "keyup", this._handleButtonKeyUp),
                j(this._btn, "mousedown", this._handleButtonMouseDown),
                j(document, "mouseup", this._handleButtonMouseUp),
                j(document, "mousemove", this._handleMouseMove),
                j(this._btn, "touchstart", this._handleTouchStart),
                j(this, "touchmove", this._handleTouchMove),
                j(document, "touchend", this._handleTouchEnd);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              X(this._btn, "keyup", this._handleButtonKeyUp),
                X(this._btn, "mousedown", this._handleButtonMouseDown),
                X(document, "mouseup", this._handleButtonMouseUp),
                X(document, "mousemove", this._handleMouseMove),
                X(this._btn, "touchstart", this._handleTouchStart),
                X(this, "touchmove", this._handleTouchMove),
                X(document, "touchend", this._handleTouchEnd);
            },
          },
          {
            key: "startMove",
            value: function () {
              this._isMoved = !0;
            },
          },
          {
            key: "endMove",
            value: function () {
              this._isMoved = !1;
            },
          },
          {
            key: "setSeparatorPosition",
            value: function (e3) {
              this.style.setProperty("--gsc-drag-position", "".concat(e3, "%"));
            },
          },
          {
            key: "moveSeparator",
            value: function (e3) {
              var t3 = this.getBoundingClientRect();
              if (e3 <= t3.left) this.setSeparatorPosition(0);
              else if (e3 >= t3.right) this.setSeparatorPosition(100);
              else {
                var i3 =
                  Math.floor(((e3 - t3.left) / this.offsetWidth) * 1e3) / 10;
                this.setSeparatorPosition(i3);
              }
            },
          },
        ]),
        i2
      );
    })(te),
    js = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "_handleFormScroll", function () {
            if (e3.viewport) {
              var t3 = e3.viewport.scrollTop > 0;
              e3.toggleAttribute("header-shadow-visible", t3);
            }
          }),
          (e3.viewport = e3.element.querySelector(
            "[data-product-information-drawer-viewport]"
          )),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              Qt(_(i2.prototype), "connectedCallback", this).call(this),
                j(this.viewport, "scroll", this._handleFormScroll);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              Qt(_(i2.prototype), "disconnectedCallback", this).call(this),
                X(this.viewport, "scroll", this._handleFormScroll);
            },
          },
        ]),
        i2
      );
    })(li),
    Xs = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          ((e3 = t2.call(this)).content = e3.querySelector(
            "[data-tabs-element-content]"
          )),
          (e3.styles = getComputedStyle(x(e3))),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              this.updateMaxHeight(this.isVisible);
            },
          },
          {
            key: "show",
            value: function () {
              return this.setVisible(!0), V(this.transitionDuration);
            },
          },
          {
            key: "hide",
            value: function () {
              return this.setVisible(!1), V(this.transitionDuration);
            },
          },
          {
            key: "setVisible",
            value: function (e3) {
              this.setAttribute("aria-hidden", e3 ? "false" : "true"),
                this.updateMaxHeight(e3);
            },
          },
          {
            key: "updateMaxHeight",
            value: function (e3) {
              if (this.content) {
                var t3 = e3 ? this.content.offsetHeight : 0;
                this.style.maxHeight = "".concat(t3, "px");
              }
            },
          },
          {
            key: "isVisible",
            get: function () {
              return this.getAttribute("aria-hidden") === "false";
            },
          },
          {
            key: "transitionDuration",
            get: function () {
              return 1e3 * parseFloat(this.styles.transitionDuration);
            },
          },
        ]),
        i2
      );
    })(te),
    Gs = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "_handleWindowScroll", function () {
            e3._lastScrollPosition || (e3._lastScrollPosition = window.scrollY),
              e3.updateVisibleStatus(),
              e3.updateExtendStatus();
          }),
          f(
            x(e3),
            "updateExtendStatus",
            (0, Ji.debounce)(function () {
              if (Math.abs(window.scrollY - e3._lastScrollPosition) > 24) {
                var t3 = e3._lastScrollPosition > window.scrollY;
                e3.toggleAttribute("is-extended", t3);
              }
              e3._lastScrollPosition = 0;
            }, 50)
          ),
          (e3.products = document.getElementById("ShopProducts")),
          (e3.footer = document.querySelector(".shopify-section-footer")),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              Qt(_(i2.prototype), "connectedCallback", this).call(this),
                window.addEventListener("scroll", this._handleWindowScroll);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              Qt(_(i2.prototype), "disconnectedCallback", this).call(this),
                window.removeEventListener("scroll", this._handleWindowScroll);
            },
          },
          {
            key: "updateVisibleStatus",
            value: function () {
              var e3 = this.footer ? this.footer.offsetTop : 0,
                t3 = this.products.getBoundingClientRect(),
                i3 = window.innerHeight + window.scrollY < e3,
                n2 = t3.top < 0,
                s2 = i3 && n2;
              this.toggleAttribute("is-visible", s2),
                document.body.toggleAttribute("is-filters-button-fixed", s2);
            },
          },
        ]),
        i2
      );
    })(oi),
    Ws = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          ((e3 = t2.call(this)).checkbox = e3.querySelector(
            "[data-recipient-form-checkbox]"
          )),
          (e3.timezoneInput = e3.querySelector(
            "[data-recipient-form-timezone-input]"
          )),
          (e3.inputs = e3.querySelectorAll(
            "[data-recipient-form-input], [data-recipient-form-timezone-input]"
          )),
          (e3.fields = e3.querySelector("[data-recipient-form-fields]")),
          (e3.timezoneInput.value = new Date().getTimezoneOffset()),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              this.addEventListener("change", this.handleChange);
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeEventListener("change", this.handleChange);
            },
          },
          {
            key: "handleChange",
            value: function () {
              var e3 = this.checkbox.checked;
              this.updateMaxHeight(e3),
                this.updateInputDisable(!e3),
                e3 || this.clearInputs();
            },
          },
          {
            key: "clearInputs",
            value: function () {
              this.inputs.forEach(function (e3) {
                e3.value = "";
              });
            },
          },
          {
            key: "updateInputDisable",
            value: function (e3) {
              this.inputs.forEach(function (t3) {
                t3.disabled = e3;
              });
            },
          },
          {
            key: "reset",
            value: function () {
              (this.checkbox.checked = !1), this.clearInputs();
            },
          },
          {
            key: "updateMaxHeight",
            value: function (e3) {
              if (this.fields) {
                var t3 = e3 ? this.fields.scrollHeight : 0;
                this.fields.style.maxHeight = "".concat(t3, "px");
              }
            },
          },
        ]),
        i2
      );
    })(te),
    Ys = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        return d(this, i2), t2.apply(this, arguments);
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              this.setImagesAttributes();
            },
          },
        ]),
        i2
      );
    })(xs),
    Us = Ys,
    Ks = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        return d(this, i2), t2.apply(this, arguments);
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              this.setImagesAttributes();
            },
          },
        ]),
        i2
      );
    })(xs),
    Qs = Ks,
    Zs = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          ((e3 = t2.call(this)).element =
            e3.querySelector(".color-swatch") || x(e3)),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              this.setValue();
            },
          },
          { key: "disconnectedCallback", value: function () {} },
          {
            key: "setValue",
            value: function () {
              var e3 = this;
              if (!this.hasAttribute("is-image")) {
                var t3 = this.dataset.color.toLowerCase().trim(),
                  i3 = this.dataset.colorsPatterns.split(`
`);
                this.isColor(t3) || this.element.setAttribute("not-valid", ""),
                  this.setPropertyValue(t3),
                  i3.forEach(function (i4) {
                    var n2 = i4.split("::"),
                      s2 = n2[0],
                      a2 = n2[1];
                    s2.toLowerCase().trim() !== t3 || e3.setPropertyValue(a2);
                  });
              }
            },
          },
          {
            key: "getGradientValue",
            value: function (e3) {
              var t3 = "90deg, ";
              return (
                e3.forEach(function (i3, n2) {
                  var s2 = 100 / e3.length,
                    a2 = "".concat(s2 * n2, "%"),
                    r2 = "".concat(s2 * (n2 + 1), "%"),
                    o2 = ""
                      .concat(i3, " ")
                      .concat(a2, ", ")
                      .concat(i3, " ")
                      .concat(r2);
                  (t3 = "".concat(t3, " ").concat(o2)),
                    n2 !== e3.length - 1 && (t3 = "".concat(t3, ", "));
                }),
                "linear-gradient(".concat(t3, ")")
              );
            },
          },
          {
            key: "setPropertyValue",
            value: function (e3) {
              var t3 = this.isImage(e3),
                i3 = this.isUrl(e3),
                n2 = this.isGradient(e3),
                s2 = this.isColor(e3);
              if (i3)
                this.element.removeAttribute("not-valid"),
                  this.element.style.setProperty(
                    "--gsc-color-swatch-value",
                    "url(".concat(e3, ")")
                  );
              else if (!t3)
                if (n2) {
                  var a2 = e3.split("/"),
                    r2 = this.getGradientValue(a2);
                  this.element.removeAttribute("not-valid"),
                    this.element.style.setProperty(
                      "--gsc-color-swatch-value",
                      r2
                    );
                } else
                  s2 && this.element.removeAttribute("not-valid"),
                    this.element.style.setProperty(
                      "--gsc-color-swatch-value",
                      e3
                    );
            },
          },
          {
            key: "isColor",
            value: function (e3) {
              var t3 = new Option().style;
              return (t3.color = e3), t3.color !== "";
            },
          },
          {
            key: "isImage",
            value: function (e3) {
              return e3.includes(".png") || e3.includes(".jp");
            },
          },
          {
            key: "isUrl",
            value: function (e3) {
              return e3.includes("http");
            },
          },
          {
            key: "isGradient",
            value: function (e3) {
              return e3.includes("/");
            },
          },
        ]),
        i2
      );
    })(te),
    Js = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "handleMouseEnter", function () {
            var t3 = e3.dataset.url,
              i3 = e3.dataset.id;
            t3 && i3 && Hn.requestProductFromUrl(t3, i3);
          }),
          f(x(e3), "handleQuickViewBtnClick", function () {
            var t3 = e3.dataset.url;
            t3 && Hn.openAndRenderProductByUrl(t3);
          }),
          (e3.quickViewBtnSelector = "[data-product-card-quick-view-button]"),
          (e3.quickViewBtn = e3.querySelector(e3.quickViewBtnSelector)),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              this.setImagesAttributes(),
                this.addEventListener("mouseenter", this.handleMouseEnter),
                this.quickViewBtn &&
                  this.quickViewBtn.addEventListener(
                    "click",
                    this.handleQuickViewBtnClick
                  );
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeEventListener("mouseenter", this.handleMouseEnter),
                this.quickViewBtn &&
                  this.quickViewBtn.removeEventListener(
                    "click",
                    this.handleQuickViewBtnClick
                  );
            },
          },
        ]),
        i2
      );
    })(xs),
    ea = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        var e3;
        return (
          d(this, i2),
          f(x((e3 = t2.call(this))), "handleMouseEnter", function () {
            var t3 = e3.dataset.url,
              i3 = e3.dataset.id;
            t3 && i3 && Hn.requestProductFromUrl(t3, i3);
          }),
          f(x(e3), "handleQuickViewBtnClick", function () {
            var t3 = e3.dataset.url;
            t3 && Hn.openAndRenderProductByUrl(t3);
          }),
          (e3.quickViewBtnSelector = "[data-product-card-quick-view-button]"),
          (e3.quickViewBtn = e3.querySelector(e3.quickViewBtnSelector)),
          e3
        );
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              this.setImagesAttributes(),
                this.addEventListener("mouseenter", this.handleMouseEnter),
                this.quickViewBtn &&
                  this.quickViewBtn.addEventListener(
                    "click",
                    this.handleQuickViewBtnClick
                  );
            },
          },
          {
            key: "disconnectedCallback",
            value: function () {
              this.removeEventListener("mouseenter", this.handleMouseEnter),
                this.quickViewBtn &&
                  this.quickViewBtn.removeEventListener(
                    "click",
                    this.handleQuickViewBtnClick
                  );
            },
          },
        ]),
        i2
      );
    })(xs),
    ta = (function (e2) {
      "use strict";
      E(i2, e2);
      var t2 = L(i2);
      function i2() {
        return d(this, i2), t2.apply(this, arguments);
      }
      return (
        p(i2, [
          {
            key: "connectedCallback",
            value: function () {
              this.loadProducts();
            },
          },
          {
            key: "loadProducts",
            value: function () {
              var e3 = this;
              fetch(this.dataset.url)
                .then(function (e4) {
                  return e4.text();
                })
                .then(function (t3) {
                  var i3 = ge(t3);
                  e3._updateByHTML(i3);
                })
                .catch(function () {
                  S.notification &&
                    S.notification.show(
                      "Error in product recommendations component",
                      "warning"
                    );
                });
            },
          },
          {
            key: "_updateByHTML",
            value: function (e3) {
              var t3 = e3.querySelector("#".concat(this.id));
              t3 &&
                ((this.innerHTML = t3.innerHTML),
                this.toggleAttribute("is-ready", this.hasChildNodes()));
            },
          },
        ]),
        i2
      );
    })(te),
    ia = [
      { tag: "login-component", component: ie },
      { tag: "back-to-top-button", component: ne },
      { tag: "sticky-cart-button", component: se },
      { tag: "quantity-component", component: ae },
      { tag: "quantity-btn", component: re },
      { tag: "localization-selector", component: oe },
      { tag: "notification-component", component: le },
      { tag: "tabs-component", component: ye },
      { tag: "tab-component", component: Xs },
      { tag: "list-component", component: be },
      { tag: "list-btn", component: Se },
      { tag: "float-element", component: At },
      { tag: "float-element-btn", component: $t },
      { tag: "dropdown-opener", component: Ht },
      { tag: "tooltip-trigger", component: Vt },
      { tag: "accordeon-component", component: Rt },
      { tag: "accordeon-btn", component: Xt },
      { tag: "product-media-tabs", component: Gt },
      { tag: "color-swatches", component: Yt },
      { tag: "modal-component", component: Ut },
      { tag: "password-modal", component: Zt },
      { tag: "cart-notification-popup", component: ei },
      { tag: "modal-opener", component: ii },
      { tag: "password-modal-opener", component: si },
      { tag: "modal-close-btn", component: ri },
      { tag: "sidebar-button", component: oi },
      { tag: "sidebar-component", component: li },
      { tag: "search-sidebar", component: di },
      { tag: "quick-view", component: fi },
      { tag: "carousel-component", component: nn },
      { tag: "carousel-play-button", component: sn },
      { tag: "carousel-dots", component: mn },
      { tag: "carousel-dot", component: gn },
      { tag: "carousel-btn", component: bn },
      { tag: "carousel-progress", component: wn },
      { tag: "header-component", component: Sn },
      { tag: "drawer-menu", component: xn },
      { tag: "drawer-menu-page", component: Cn },
      { tag: "drawer-menu-page-link", component: En },
      { tag: "pagination-component", component: _n },
      { tag: "pagination-load-button", component: Ln },
      { tag: "pagination-link", component: In },
      { tag: "pagination-infinite-scroll", component: Dn },
      { tag: "deferred-media", component: An },
      { tag: "pickup-availability", component: On },
      { tag: "product-form", component: Fn },
      { tag: "product-form-button", component: Vn },
      { tag: "product-block", component: Rn },
      { tag: "product-model", component: Xn },
      { tag: "cart-item", component: Un },
      { tag: "cart-component", component: Kn },
      { tag: "sidebar-cart", component: Qn },
      { tag: "cart-free-shipping-bar", component: Jn },
      { tag: "product-media", component: ts },
      { tag: "product-media-carousel", component: ns },
      { tag: "variant-picker", component: as },
      { tag: "color-swatches-picker", component: rs },
      { tag: "product-modal", component: ls },
      { tag: "product-modal-image-wrap", component: cs },
      { tag: "product-modal-opener", component: ds },
      { tag: "product-recommendations", component: hs },
      { tag: "product-related-block", component: ta },
      { tag: "recently-viewed", component: hi },
      { tag: "search-sidebar-form-wrapper", component: vs },
      { tag: "cart-remove-button", component: gs },
      { tag: "clipboard-button", component: bs },
      { tag: "clipboard-button-tooltip", component: ws },
      { tag: "product-card", component: Cs },
      { tag: "horizontal-product-card", component: Js },
      { tag: "vertical-product-card", component: ea },
      { tag: "max-lines-component", component: ks },
      { tag: "country-selector", component: Es },
      { tag: "search-field", component: Ts },
      { tag: "password-field", component: _s },
      { tag: "zoom-cursor", component: Ms },
      { tag: "shop-component", component: Ls },
      { tag: "shop-active-filters", component: Ps },
      { tag: "sidebar-filters-desktop", component: As },
      { tag: "sidebar-filters-mobile", component: Os },
      { tag: "filter-remove-btn", component: Ns },
      { tag: "sort-list", component: qs },
      { tag: "price-range", component: $s },
      { tag: "column-switcher", component: Hs },
      { tag: "filters-submit-btn", component: Vs },
      { tag: "before-after-images", component: Rs },
      { tag: "product-information-drawer", component: js },
      { tag: "sidebar-filters-sticky-mobile-button", component: Gs },
      { tag: "recipient-form", component: Ws },
      { tag: "collection-card", component: Us },
      { tag: "article-card", component: Qs },
      { tag: "shape-swatch", component: Zs },
    ];
  (window.recentlyViewed = hi),
    ia.forEach(function (e2) {
      var t2 = e2.tag,
        i2 = e2.component;
      customElements.define(t2, i2);
    }),
    (window.bodyElement = S),
    window.addEventListener("load", function () {
      (function (e2) {
        var t2 = e2?.lazyClass || "lazy",
          i2 = e2?.lazyBackgroundClass || "lazy-bg",
          n2 = e2?.lazyBackgroundLoaded || "lazy-bg-loaded",
          s2 = e2?.threshold || 200,
          l2 = e2?.events || {},
          c2 = e2?.observeChanges || !1,
          d2 = e2?.observeRootSelector || "body",
          h2 = e2?.mutationObserverOptions || { childList: !0, subtree: !0 },
          p2 = "video.".concat(t2, ",.").concat(i2),
          f2 = Array.from(document.querySelectorAll(p2)),
          v2 = !0,
          m2 = !1,
          g2 = void 0;
        try {
          for (
            var y2, b2 = f2[Symbol.iterator]();
            !(v2 = (y2 = b2.next()).done);
            v2 = !0
          )
            a(y2.value, l2);
        } catch (e3) {
          (m2 = !0), (g2 = e3);
        } finally {
          try {
            v2 || b2.return == null || b2.return();
          } finally {
            if (m2) throw g2;
          }
        }
        var w2 = !0,
          S2 = !1,
          x2 = void 0;
        if (r === !0 && o === !1) {
          var C2 = new IntersectionObserver(
              function (e3) {
                var s3 = !0,
                  a2 = !1,
                  r2 = void 0;
                try {
                  for (
                    var o2,
                      l3 = function () {
                        var e4 = o2.value;
                        if (e4.isIntersecting || e4.intersectionRatio) {
                          var s4 = e4.target;
                          u(s4, t2, i2, n2),
                            C2.unobserve(s4),
                            (f2 = f2.filter(function (e5) {
                              return e5 != s4;
                            })),
                            f2.length === 0 && c2 === !1 && C2.disconnect();
                        }
                      },
                      d3 = e3[Symbol.iterator]();
                    !(s3 = (o2 = d3.next()).done);
                    s3 = !0
                  )
                    l3();
                } catch (e4) {
                  (a2 = !0), (r2 = e4);
                } finally {
                  try {
                    s3 || d3.return == null || d3.return();
                  } finally {
                    if (a2) throw r2;
                  }
                }
              },
              { rootMargin: "".concat(s2, "px 0%") }
            ),
            k2 = !0,
            E2 = !1,
            T2 = void 0;
          try {
            for (
              var _2, M2 = f2[Symbol.iterator]();
              !(k2 = (_2 = M2.next()).done);
              k2 = !0
            ) {
              var L2 = _2.value;
              C2.observe(L2);
            }
          } catch (e3) {
            (E2 = !0), (T2 = e3);
          } finally {
            try {
              k2 || M2.return == null || M2.return();
            } finally {
              if (E2) throw T2;
            }
          }
          c2 &&
            new MutationObserver(function () {
              var e3 = document.querySelectorAll(p2),
                t3 = !0,
                i3 = !1,
                n3 = void 0;
              try {
                for (
                  var s3, c3 = e3[Symbol.iterator]();
                  !(t3 = (s3 = c3.next()).done);
                  t3 = !0
                ) {
                  var u2 = s3.value;
                  f2.includes(u2) === !1 &&
                    (f2.push(u2),
                    a(u2, l2),
                    r === !0 && o === !1 && C2.observe(u2));
                }
              } catch (e4) {
                (i3 = !0), (n3 = e4);
              } finally {
                try {
                  t3 || c3.return == null || c3.return();
                } finally {
                  if (i3) throw n3;
                }
              }
            }).observe(document.querySelector(d2), h2);
        } else if (o)
          try {
            for (
              var P2, I2 = f2[Symbol.iterator]();
              !(w2 = (P2 = I2.next()).done);
              w2 = !0
            )
              u(P2.value, t2, i2, n2);
          } catch (e3) {
            (S2 = !0), (x2 = e3);
          } finally {
            try {
              w2 || I2.return == null || I2.return();
            } finally {
              if (S2) throw x2;
            }
          }
      })({ lazyClass: "yall-video-lazy", threshold: 0, observeChanges: !0 });
    });
})(),
  (function (e, t) {
    typeof module == "object" && typeof module.exports == "object"
      ? (module.exports = e.document
          ? t(e, !0)
          : function (e2) {
              if (!e2.document)
                throw new Error("jQuery requires a window with a document");
              return t(e2);
            })
      : t(e);
  })(typeof window < "u" ? window : this, function (e, t) {
    var i = [],
      n = i.slice,
      s = i.concat,
      a = i.push,
      r = i.indexOf,
      o = {},
      l = o.toString,
      c = o.hasOwnProperty,
      u = {},
      d = e.document,
      h = "2.1.3",
      p = function (e2, t2) {
        return new p.fn.init(e2, t2);
      },
      f = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
      v = /^-ms-/,
      m = /-([\da-z])/gi,
      g = function (e2, t2) {
        return t2.toUpperCase();
      };
    function y(e2) {
      var t2 = e2.length,
        i2 = p.type(e2);
      return (
        i2 !== "function" &&
        !p.isWindow(e2) &&
        (!(e2.nodeType !== 1 || !t2) ||
          i2 === "array" ||
          t2 === 0 ||
          (typeof t2 == "number" && t2 > 0 && t2 - 1 in e2))
      );
    }
    (p.fn = p.prototype =
      {
        jquery: h,
        constructor: p,
        selector: "",
        length: 0,
        toArray: function () {
          return n.call(this);
        },
        get: function (e2) {
          return e2 != null
            ? e2 < 0
              ? this[e2 + this.length]
              : this[e2]
            : n.call(this);
        },
        pushStack: function (e2) {
          var t2 = p.merge(this.constructor(), e2);
          return (t2.prevObject = this), (t2.context = this.context), t2;
        },
        each: function (e2, t2) {
          return p.each(this, e2, t2);
        },
        map: function (e2) {
          return this.pushStack(
            p.map(this, function (t2, i2) {
              return e2.call(t2, i2, t2);
            })
          );
        },
        slice: function () {
          return this.pushStack(n.apply(this, arguments));
        },
        first: function () {
          return this.eq(0);
        },
        last: function () {
          return this.eq(-1);
        },
        eq: function (e2) {
          var t2 = this.length,
            i2 = +e2 + (e2 < 0 ? t2 : 0);
          return this.pushStack(i2 >= 0 && i2 < t2 ? [this[i2]] : []);
        },
        end: function () {
          return this.prevObject || this.constructor(null);
        },
        push: a,
        sort: i.sort,
        splice: i.splice,
      }),
      (p.extend = p.fn.extend =
        function () {
          var e2,
            t2,
            i2,
            n2,
            s2,
            a2,
            r2 = arguments[0] || {},
            o2 = 1,
            l2 = arguments.length,
            c2 = !1;
          for (
            typeof r2 == "boolean" &&
              ((c2 = r2), (r2 = arguments[o2] || {}), o2++),
              typeof r2 == "object" || p.isFunction(r2) || (r2 = {}),
              o2 === l2 && ((r2 = this), o2--);
            o2 < l2;
            o2++
          )
            if ((e2 = arguments[o2]) != null)
              for (t2 in e2)
                (i2 = r2[t2]),
                  r2 !== (n2 = e2[t2]) &&
                    (c2 && n2 && (p.isPlainObject(n2) || (s2 = p.isArray(n2)))
                      ? (s2
                          ? ((s2 = !1), (a2 = i2 && p.isArray(i2) ? i2 : []))
                          : (a2 = i2 && p.isPlainObject(i2) ? i2 : {}),
                        (r2[t2] = p.extend(c2, a2, n2)))
                      : n2 !== void 0 && (r2[t2] = n2));
          return r2;
        }),
      p.extend({
        expando: "jQuery" + (h + Math.random()).replace(/\D/g, ""),
        isReady: !0,
        error: function (e2) {
          throw new Error(e2);
        },
        noop: function () {},
        isFunction: function (e2) {
          return p.type(e2) === "function";
        },
        isArray: Array.isArray,
        isWindow: function (e2) {
          return e2 != null && e2 === e2.window;
        },
        isNumeric: function (e2) {
          return !p.isArray(e2) && e2 - parseFloat(e2) + 1 >= 0;
        },
        isPlainObject: function (e2) {
          return (
            p.type(e2) === "object" &&
            !e2.nodeType &&
            !p.isWindow(e2) &&
            !(
              e2.constructor &&
              !c.call(e2.constructor.prototype, "isPrototypeOf")
            )
          );
        },
        isEmptyObject: function (e2) {
          var t2;
          for (t2 in e2) return !1;
          return !0;
        },
        type: function (e2) {
          return e2 == null
            ? e2 + ""
            : typeof e2 == "object" || typeof e2 == "function"
            ? o[l.call(e2)] || "object"
            : typeof e2;
        },
        globalEval: function (e2) {
          var t2,
            i2 = eval;
          (e2 = p.trim(e2)) &&
            (e2.indexOf("use strict") === 1
              ? (((t2 = d.createElement("script")).text = e2),
                d.head.appendChild(t2).parentNode.removeChild(t2))
              : i2(e2));
        },
        camelCase: function (e2) {
          return e2.replace(v, "ms-").replace(m, g);
        },
        nodeName: function (e2, t2) {
          return e2.nodeName && e2.nodeName.toLowerCase() === t2.toLowerCase();
        },
        each: function (e2, t2, i2) {
          var n2 = 0,
            s2 = e2.length,
            a2 = y(e2);
          if (i2) {
            if (a2) for (; n2 < s2 && t2.apply(e2[n2], i2) !== !1; n2++);
            else for (n2 in e2) if (t2.apply(e2[n2], i2) === !1) break;
          } else if (a2)
            for (; n2 < s2 && t2.call(e2[n2], n2, e2[n2]) !== !1; n2++);
          else for (n2 in e2) if (t2.call(e2[n2], n2, e2[n2]) === !1) break;
          return e2;
        },
        trim: function (e2) {
          return e2 == null ? "" : (e2 + "").replace(f, "");
        },
        makeArray: function (e2, t2) {
          var i2 = t2 || [];
          return (
            e2 != null &&
              (y(Object(e2))
                ? p.merge(i2, typeof e2 == "string" ? [e2] : e2)
                : a.call(i2, e2)),
            i2
          );
        },
        inArray: function (e2, t2, i2) {
          return t2 == null ? -1 : r.call(t2, e2, i2);
        },
        merge: function (e2, t2) {
          for (var i2 = +t2.length, n2 = 0, s2 = e2.length; n2 < i2; n2++)
            e2[s2++] = t2[n2];
          return (e2.length = s2), e2;
        },
        grep: function (e2, t2, i2) {
          for (var n2 = [], s2 = 0, a2 = e2.length, r2 = !i2; s2 < a2; s2++)
            !t2(e2[s2], s2) !== r2 && n2.push(e2[s2]);
          return n2;
        },
        map: function (e2, t2, i2) {
          var n2,
            a2 = 0,
            r2 = e2.length,
            o2 = [];
          if (y(e2))
            for (; a2 < r2; a2++)
              (n2 = t2(e2[a2], a2, i2)) != null && o2.push(n2);
          else for (a2 in e2) (n2 = t2(e2[a2], a2, i2)) != null && o2.push(n2);
          return s.apply([], o2);
        },
        guid: 1,
        proxy: function (e2, t2) {
          var i2, s2, a2;
          if (
            (typeof t2 == "string" && ((i2 = e2[t2]), (t2 = e2), (e2 = i2)),
            p.isFunction(e2))
          )
            return (
              (s2 = n.call(arguments, 2)),
              (a2 = function () {
                return e2.apply(t2 || this, s2.concat(n.call(arguments)));
              }),
              (a2.guid = e2.guid = e2.guid || p.guid++),
              a2
            );
        },
        now: Date.now,
        support: u,
      }),
      p.each(
        "Boolean Number String Function Array Date RegExp Object Error".split(
          " "
        ),
        function (e2, t2) {
          o["[object " + t2 + "]"] = t2.toLowerCase();
        }
      );
    var b = (function (e2) {
      var t2,
        i2,
        n2,
        s2,
        a2,
        r2,
        o2,
        l2,
        c2,
        u2,
        d2,
        h2,
        p2,
        f2,
        v2,
        m2,
        g2,
        y2,
        b2,
        w2 = "sizzle" + 1 * new Date(),
        S2 = e2.document,
        x2 = 0,
        C2 = 0,
        k2 = re2(),
        E2 = re2(),
        T2 = re2(),
        _2 = function (e3, t3) {
          return e3 === t3 && (d2 = !0), 0;
        },
        M2 = 1 << 31,
        L2 = {}.hasOwnProperty,
        P2 = [],
        I2 = P2.pop,
        D2 = P2.push,
        A2 = P2.push,
        z2 = P2.slice,
        O2 = function (e3, t3) {
          for (var i3 = 0, n3 = e3.length; i3 < n3; i3++)
            if (e3[i3] === t3) return i3;
          return -1;
        },
        B2 =
          "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
        N2 = "[\\x20\\t\\r\\n\\f]",
        q2 = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
        $3 = q2.replace("w", "w#"),
        H2 =
          "\\[" +
          N2 +
          "*(" +
          q2 +
          ")(?:" +
          N2 +
          "*([*^$|!~]?=)" +
          N2 +
          `*(?:'((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)"|(` +
          $3 +
          "))|)" +
          N2 +
          "*\\]",
        F2 =
          ":(" +
          q2 +
          `)(?:\\((('((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)")|((?:\\\\.|[^\\\\()[\\]]|` +
          H2 +
          ")*)|.*)\\)|)",
        V2 = new RegExp(N2 + "+", "g"),
        R2 = new RegExp(
          "^" + N2 + "+|((?:^|[^\\\\])(?:\\\\.)*)" + N2 + "+$",
          "g"
        ),
        j2 = new RegExp("^" + N2 + "*," + N2 + "*"),
        X2 = new RegExp("^" + N2 + "*([>+~]|" + N2 + ")" + N2 + "*"),
        G2 = new RegExp("=" + N2 + `*([^\\]'"]*?)` + N2 + "*\\]", "g"),
        W2 = new RegExp(F2),
        Y2 = new RegExp("^" + $3 + "$"),
        U2 = {
          ID: new RegExp("^#(" + q2 + ")"),
          CLASS: new RegExp("^\\.(" + q2 + ")"),
          TAG: new RegExp("^(" + q2.replace("w", "w*") + ")"),
          ATTR: new RegExp("^" + H2),
          PSEUDO: new RegExp("^" + F2),
          CHILD: new RegExp(
            "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
              N2 +
              "*(even|odd|(([+-]|)(\\d*)n|)" +
              N2 +
              "*(?:([+-]|)" +
              N2 +
              "*(\\d+)|))" +
              N2 +
              "*\\)|)",
            "i"
          ),
          bool: new RegExp("^(?:" + B2 + ")$", "i"),
          needsContext: new RegExp(
            "^" +
              N2 +
              "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
              N2 +
              "*((?:-\\d)?\\d*)" +
              N2 +
              "*\\)|)(?=[^-]|$)",
            "i"
          ),
        },
        K2 = /^(?:input|select|textarea|button)$/i,
        Q2 = /^h\d$/i,
        Z2 = /^[^{]+\{\s*\[native \w/,
        J2 = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
        ee2 = /[+~]/,
        te2 = /'|\\/g,
        ie2 = new RegExp("\\\\([\\da-f]{1,6}" + N2 + "?|(" + N2 + ")|.)", "ig"),
        ne2 = function (e3, t3, i3) {
          var n3 = "0x" + t3 - 65536;
          return n3 != n3 || i3
            ? t3
            : n3 < 0
            ? String.fromCharCode(n3 + 65536)
            : String.fromCharCode((n3 >> 10) | 55296, (1023 & n3) | 56320);
        },
        se2 = function () {
          h2();
        };
      try {
        A2.apply((P2 = z2.call(S2.childNodes)), S2.childNodes),
          P2[S2.childNodes.length].nodeType;
      } catch {
        A2 = {
          apply: P2.length
            ? function (e4, t3) {
                D2.apply(e4, z2.call(t3));
              }
            : function (e4, t3) {
                for (var i3 = e4.length, n3 = 0; (e4[i3++] = t3[n3++]); );
                e4.length = i3 - 1;
              },
        };
      }
      function ae2(e3, t3, n3, s3) {
        var a3, o3, c3, u3, d3, f3, g3, y3, x3, C3;
        if (
          ((t3 ? t3.ownerDocument || t3 : S2) !== p2 && h2(t3),
          (n3 = n3 || []),
          (u3 = (t3 = t3 || p2).nodeType),
          typeof e3 != "string" || !e3 || (u3 !== 1 && u3 !== 9 && u3 !== 11))
        )
          return n3;
        if (!s3 && v2) {
          if (u3 !== 11 && (a3 = J2.exec(e3)))
            if ((c3 = a3[1])) {
              if (u3 === 9) {
                if (!(o3 = t3.getElementById(c3)) || !o3.parentNode) return n3;
                if (o3.id === c3) return n3.push(o3), n3;
              } else if (
                t3.ownerDocument &&
                (o3 = t3.ownerDocument.getElementById(c3)) &&
                b2(t3, o3) &&
                o3.id === c3
              )
                return n3.push(o3), n3;
            } else {
              if (a3[2]) return A2.apply(n3, t3.getElementsByTagName(e3)), n3;
              if ((c3 = a3[3]) && i2.getElementsByClassName)
                return A2.apply(n3, t3.getElementsByClassName(c3)), n3;
            }
          if (i2.qsa && (!m2 || !m2.test(e3))) {
            if (
              ((y3 = g3 = w2),
              (x3 = t3),
              (C3 = u3 !== 1 && e3),
              u3 === 1 && t3.nodeName.toLowerCase() !== "object")
            ) {
              for (
                f3 = r2(e3),
                  (g3 = t3.getAttribute("id"))
                    ? (y3 = g3.replace(te2, "\\$&"))
                    : t3.setAttribute("id", y3),
                  y3 = "[id='" + y3 + "'] ",
                  d3 = f3.length;
                d3--;

              )
                f3[d3] = y3 + me2(f3[d3]);
              (x3 = (ee2.test(e3) && fe2(t3.parentNode)) || t3),
                (C3 = f3.join(","));
            }
            if (C3)
              try {
                return A2.apply(n3, x3.querySelectorAll(C3)), n3;
              } catch {
              } finally {
                g3 || t3.removeAttribute("id");
              }
          }
        }
        return l2(e3.replace(R2, "$1"), t3, n3, s3);
      }
      function re2() {
        var e3 = [];
        return function t3(i3, s3) {
          return (
            e3.push(i3 + " ") > n2.cacheLength && delete t3[e3.shift()],
            (t3[i3 + " "] = s3)
          );
        };
      }
      function oe2(e3) {
        return (e3[w2] = !0), e3;
      }
      function le2(e3) {
        var t3 = p2.createElement("div");
        try {
          return !!e3(t3);
        } catch {
          return !1;
        } finally {
          t3.parentNode && t3.parentNode.removeChild(t3), (t3 = null);
        }
      }
      function ce2(e3, t3) {
        for (var i3 = e3.split("|"), s3 = e3.length; s3--; )
          n2.attrHandle[i3[s3]] = t3;
      }
      function ue2(e3, t3) {
        var i3 = t3 && e3,
          n3 =
            i3 &&
            e3.nodeType === 1 &&
            t3.nodeType === 1 &&
            (~t3.sourceIndex || M2) - (~e3.sourceIndex || M2);
        if (n3) return n3;
        if (i3) {
          for (; (i3 = i3.nextSibling); ) if (i3 === t3) return -1;
        }
        return e3 ? 1 : -1;
      }
      function de2(e3) {
        return function (t3) {
          return t3.nodeName.toLowerCase() === "input" && t3.type === e3;
        };
      }
      function he2(e3) {
        return function (t3) {
          var i3 = t3.nodeName.toLowerCase();
          return (i3 === "input" || i3 === "button") && t3.type === e3;
        };
      }
      function pe2(e3) {
        return oe2(function (t3) {
          return (
            (t3 = +t3),
            oe2(function (i3, n3) {
              for (var s3, a3 = e3([], i3.length, t3), r3 = a3.length; r3--; )
                i3[(s3 = a3[r3])] && (i3[s3] = !(n3[s3] = i3[s3]));
            })
          );
        });
      }
      function fe2(e3) {
        return e3 && e3.getElementsByTagName !== void 0 && e3;
      }
      for (t2 in ((i2 = ae2.support = {}),
      (a2 = ae2.isXML =
        function (e3) {
          var t3 = e3 && (e3.ownerDocument || e3).documentElement;
          return !!t3 && t3.nodeName !== "HTML";
        }),
      (h2 = ae2.setDocument =
        function (e3) {
          var t3,
            s3,
            r3 = e3 ? e3.ownerDocument || e3 : S2;
          return r3 !== p2 && r3.nodeType === 9 && r3.documentElement
            ? ((p2 = r3),
              (f2 = r3.documentElement),
              (s3 = r3.defaultView) &&
                s3 !== s3.top &&
                (s3.addEventListener
                  ? s3.addEventListener("unload", se2, !1)
                  : s3.attachEvent && s3.attachEvent("onunload", se2)),
              (v2 = !a2(r3)),
              (i2.attributes = le2(function (e4) {
                return (e4.className = "i"), !e4.getAttribute("className");
              })),
              (i2.getElementsByTagName = le2(function (e4) {
                return (
                  e4.appendChild(r3.createComment("")),
                  !e4.getElementsByTagName("*").length
                );
              })),
              (i2.getElementsByClassName = Z2.test(r3.getElementsByClassName)),
              (i2.getById = le2(function (e4) {
                return (
                  (f2.appendChild(e4).id = w2),
                  !r3.getElementsByName || !r3.getElementsByName(w2).length
                );
              })),
              i2.getById
                ? ((n2.find.ID = function (e4, t4) {
                    if (t4.getElementById !== void 0 && v2) {
                      var i3 = t4.getElementById(e4);
                      return i3 && i3.parentNode ? [i3] : [];
                    }
                  }),
                  (n2.filter.ID = function (e4) {
                    var t4 = e4.replace(ie2, ne2);
                    return function (e5) {
                      return e5.getAttribute("id") === t4;
                    };
                  }))
                : (delete n2.find.ID,
                  (n2.filter.ID = function (e4) {
                    var t4 = e4.replace(ie2, ne2);
                    return function (e5) {
                      var i3 =
                        e5.getAttributeNode !== void 0 &&
                        e5.getAttributeNode("id");
                      return i3 && i3.value === t4;
                    };
                  })),
              (n2.find.TAG = i2.getElementsByTagName
                ? function (e4, t4) {
                    return t4.getElementsByTagName !== void 0
                      ? t4.getElementsByTagName(e4)
                      : i2.qsa
                      ? t4.querySelectorAll(e4)
                      : void 0;
                  }
                : function (e4, t4) {
                    var i3,
                      n3 = [],
                      s4 = 0,
                      a3 = t4.getElementsByTagName(e4);
                    if (e4 === "*") {
                      for (; (i3 = a3[s4++]); )
                        i3.nodeType === 1 && n3.push(i3);
                      return n3;
                    }
                    return a3;
                  }),
              (n2.find.CLASS =
                i2.getElementsByClassName &&
                function (e4, t4) {
                  if (v2) return t4.getElementsByClassName(e4);
                }),
              (g2 = []),
              (m2 = []),
              (i2.qsa = Z2.test(r3.querySelectorAll)) &&
                (le2(function (e4) {
                  (f2.appendChild(e4).innerHTML =
                    "<a id='" +
                    w2 +
                    "'></a><select id='" +
                    w2 +
                    "-\f]' msallowcapture=''><option selected=''></option></select>"),
                    e4.querySelectorAll("[msallowcapture^='']").length &&
                      m2.push("[*^$]=" + N2 + `*(?:''|"")`),
                    e4.querySelectorAll("[selected]").length ||
                      m2.push("\\[" + N2 + "*(?:value|" + B2 + ")"),
                    e4.querySelectorAll("[id~=" + w2 + "-]").length ||
                      m2.push("~="),
                    e4.querySelectorAll(":checked").length ||
                      m2.push(":checked"),
                    e4.querySelectorAll("a#" + w2 + "+*").length ||
                      m2.push(".#.+[+~]");
                }),
                le2(function (e4) {
                  var t4 = r3.createElement("input");
                  t4.setAttribute("type", "hidden"),
                    e4.appendChild(t4).setAttribute("name", "D"),
                    e4.querySelectorAll("[name=d]").length &&
                      m2.push("name" + N2 + "*[*^$|!~]?="),
                    e4.querySelectorAll(":enabled").length ||
                      m2.push(":enabled", ":disabled"),
                    e4.querySelectorAll("*,:x"),
                    m2.push(",.*:");
                })),
              (i2.matchesSelector = Z2.test(
                (y2 =
                  f2.matches ||
                  f2.webkitMatchesSelector ||
                  f2.mozMatchesSelector ||
                  f2.oMatchesSelector ||
                  f2.msMatchesSelector)
              )) &&
                le2(function (e4) {
                  (i2.disconnectedMatch = y2.call(e4, "div")),
                    y2.call(e4, "[s!='']:x"),
                    g2.push("!=", F2);
                }),
              (m2 = m2.length && new RegExp(m2.join("|"))),
              (g2 = g2.length && new RegExp(g2.join("|"))),
              (t3 = Z2.test(f2.compareDocumentPosition)),
              (b2 =
                t3 || Z2.test(f2.contains)
                  ? function (e4, t4) {
                      var i3 = e4.nodeType === 9 ? e4.documentElement : e4,
                        n3 = t4 && t4.parentNode;
                      return (
                        e4 === n3 ||
                        !(
                          !n3 ||
                          n3.nodeType !== 1 ||
                          !(i3.contains
                            ? i3.contains(n3)
                            : e4.compareDocumentPosition &&
                              16 & e4.compareDocumentPosition(n3))
                        )
                      );
                    }
                  : function (e4, t4) {
                      if (t4) {
                        for (; (t4 = t4.parentNode); ) if (t4 === e4) return !0;
                      }
                      return !1;
                    }),
              (_2 = t3
                ? function (e4, t4) {
                    if (e4 === t4) return (d2 = !0), 0;
                    var n3 =
                      !e4.compareDocumentPosition - !t4.compareDocumentPosition;
                    return (
                      n3 ||
                      (1 &
                        (n3 =
                          (e4.ownerDocument || e4) === (t4.ownerDocument || t4)
                            ? e4.compareDocumentPosition(t4)
                            : 1) ||
                      (!i2.sortDetached &&
                        t4.compareDocumentPosition(e4) === n3)
                        ? e4 === r3 || (e4.ownerDocument === S2 && b2(S2, e4))
                          ? -1
                          : t4 === r3 || (t4.ownerDocument === S2 && b2(S2, t4))
                          ? 1
                          : u2
                          ? O2(u2, e4) - O2(u2, t4)
                          : 0
                        : 4 & n3
                        ? -1
                        : 1)
                    );
                  }
                : function (e4, t4) {
                    if (e4 === t4) return (d2 = !0), 0;
                    var i3,
                      n3 = 0,
                      s4 = e4.parentNode,
                      a3 = t4.parentNode,
                      o3 = [e4],
                      l3 = [t4];
                    if (!s4 || !a3)
                      return e4 === r3
                        ? -1
                        : t4 === r3
                        ? 1
                        : s4
                        ? -1
                        : a3
                        ? 1
                        : u2
                        ? O2(u2, e4) - O2(u2, t4)
                        : 0;
                    if (s4 === a3) return ue2(e4, t4);
                    for (i3 = e4; (i3 = i3.parentNode); ) o3.unshift(i3);
                    for (i3 = t4; (i3 = i3.parentNode); ) l3.unshift(i3);
                    for (; o3[n3] === l3[n3]; ) n3++;
                    return n3
                      ? ue2(o3[n3], l3[n3])
                      : o3[n3] === S2
                      ? -1
                      : l3[n3] === S2
                      ? 1
                      : 0;
                  }),
              r3)
            : p2;
        }),
      (ae2.matches = function (e3, t3) {
        return ae2(e3, null, null, t3);
      }),
      (ae2.matchesSelector = function (e3, t3) {
        if (
          ((e3.ownerDocument || e3) !== p2 && h2(e3),
          (t3 = t3.replace(G2, "='$1']")),
          i2.matchesSelector &&
            v2 &&
            (!g2 || !g2.test(t3)) &&
            (!m2 || !m2.test(t3)))
        )
          try {
            var n3 = y2.call(e3, t3);
            if (
              n3 ||
              i2.disconnectedMatch ||
              (e3.document && e3.document.nodeType !== 11)
            )
              return n3;
          } catch {}
        return ae2(t3, p2, null, [e3]).length > 0;
      }),
      (ae2.contains = function (e3, t3) {
        return (e3.ownerDocument || e3) !== p2 && h2(e3), b2(e3, t3);
      }),
      (ae2.attr = function (e3, t3) {
        (e3.ownerDocument || e3) !== p2 && h2(e3);
        var s3 = n2.attrHandle[t3.toLowerCase()],
          a3 =
            s3 && L2.call(n2.attrHandle, t3.toLowerCase())
              ? s3(e3, t3, !v2)
              : void 0;
        return a3 !== void 0
          ? a3
          : i2.attributes || !v2
          ? e3.getAttribute(t3)
          : (a3 = e3.getAttributeNode(t3)) && a3.specified
          ? a3.value
          : null;
      }),
      (ae2.error = function (e3) {
        throw new Error("Syntax error, unrecognized expression: " + e3);
      }),
      (ae2.uniqueSort = function (e3) {
        var t3,
          n3 = [],
          s3 = 0,
          a3 = 0;
        if (
          ((d2 = !i2.detectDuplicates),
          (u2 = !i2.sortStable && e3.slice(0)),
          e3.sort(_2),
          d2)
        ) {
          for (; (t3 = e3[a3++]); ) t3 === e3[a3] && (s3 = n3.push(a3));
          for (; s3--; ) e3.splice(n3[s3], 1);
        }
        return (u2 = null), e3;
      }),
      (s2 = ae2.getText =
        function (e3) {
          var t3,
            i3 = "",
            n3 = 0,
            a3 = e3.nodeType;
          if (a3) {
            if (a3 === 1 || a3 === 9 || a3 === 11) {
              if (typeof e3.textContent == "string") return e3.textContent;
              for (e3 = e3.firstChild; e3; e3 = e3.nextSibling) i3 += s2(e3);
            } else if (a3 === 3 || a3 === 4) return e3.nodeValue;
          } else for (; (t3 = e3[n3++]); ) i3 += s2(t3);
          return i3;
        }),
      (n2 = ae2.selectors =
        {
          cacheLength: 50,
          createPseudo: oe2,
          match: U2,
          attrHandle: {},
          find: {},
          relative: {
            ">": { dir: "parentNode", first: !0 },
            " ": { dir: "parentNode" },
            "+": { dir: "previousSibling", first: !0 },
            "~": { dir: "previousSibling" },
          },
          preFilter: {
            ATTR: function (e3) {
              return (
                (e3[1] = e3[1].replace(ie2, ne2)),
                (e3[3] = (e3[3] || e3[4] || e3[5] || "").replace(ie2, ne2)),
                e3[2] === "~=" && (e3[3] = " " + e3[3] + " "),
                e3.slice(0, 4)
              );
            },
            CHILD: function (e3) {
              return (
                (e3[1] = e3[1].toLowerCase()),
                e3[1].slice(0, 3) === "nth"
                  ? (e3[3] || ae2.error(e3[0]),
                    (e3[4] = +(e3[4]
                      ? e3[5] + (e3[6] || 1)
                      : 2 * (e3[3] === "even" || e3[3] === "odd"))),
                    (e3[5] = +(e3[7] + e3[8] || e3[3] === "odd")))
                  : e3[3] && ae2.error(e3[0]),
                e3
              );
            },
            PSEUDO: function (e3) {
              var t3,
                i3 = !e3[6] && e3[2];
              return U2.CHILD.test(e3[0])
                ? null
                : (e3[3]
                    ? (e3[2] = e3[4] || e3[5] || "")
                    : i3 &&
                      W2.test(i3) &&
                      (t3 = r2(i3, !0)) &&
                      (t3 = i3.indexOf(")", i3.length - t3) - i3.length) &&
                      ((e3[0] = e3[0].slice(0, t3)), (e3[2] = i3.slice(0, t3))),
                  e3.slice(0, 3));
            },
          },
          filter: {
            TAG: function (e3) {
              var t3 = e3.replace(ie2, ne2).toLowerCase();
              return e3 === "*"
                ? function () {
                    return !0;
                  }
                : function (e4) {
                    return e4.nodeName && e4.nodeName.toLowerCase() === t3;
                  };
            },
            CLASS: function (e3) {
              var t3 = k2[e3 + " "];
              return (
                t3 ||
                ((t3 = new RegExp("(^|" + N2 + ")" + e3 + "(" + N2 + "|$)")) &&
                  k2(e3, function (e4) {
                    return t3.test(
                      (typeof e4.className == "string" && e4.className) ||
                        (e4.getAttribute !== void 0 &&
                          e4.getAttribute("class")) ||
                        ""
                    );
                  }))
              );
            },
            ATTR: function (e3, t3, i3) {
              return function (n3) {
                var s3 = ae2.attr(n3, e3);
                return s3 == null
                  ? t3 === "!="
                  : !t3 ||
                      ((s3 += ""),
                      t3 === "="
                        ? s3 === i3
                        : t3 === "!="
                        ? s3 !== i3
                        : t3 === "^="
                        ? i3 && s3.indexOf(i3) === 0
                        : t3 === "*="
                        ? i3 && s3.indexOf(i3) > -1
                        : t3 === "$="
                        ? i3 && s3.slice(-i3.length) === i3
                        : t3 === "~="
                        ? (" " + s3.replace(V2, " ") + " ").indexOf(i3) > -1
                        : t3 === "|=" &&
                          (s3 === i3 ||
                            s3.slice(0, i3.length + 1) === i3 + "-"));
              };
            },
            CHILD: function (e3, t3, i3, n3, s3) {
              var a3 = e3.slice(0, 3) !== "nth",
                r3 = e3.slice(-4) !== "last",
                o3 = t3 === "of-type";
              return n3 === 1 && s3 === 0
                ? function (e4) {
                    return !!e4.parentNode;
                  }
                : function (t4, i4, l3) {
                    var c3,
                      u3,
                      d3,
                      h3,
                      p3,
                      f3,
                      v3 = a3 !== r3 ? "nextSibling" : "previousSibling",
                      m3 = t4.parentNode,
                      g3 = o3 && t4.nodeName.toLowerCase(),
                      y3 = !l3 && !o3;
                    if (m3) {
                      if (a3) {
                        for (; v3; ) {
                          for (d3 = t4; (d3 = d3[v3]); )
                            if (
                              o3
                                ? d3.nodeName.toLowerCase() === g3
                                : d3.nodeType === 1
                            )
                              return !1;
                          f3 = v3 = e3 === "only" && !f3 && "nextSibling";
                        }
                        return !0;
                      }
                      if (
                        ((f3 = [r3 ? m3.firstChild : m3.lastChild]), r3 && y3)
                      ) {
                        for (
                          p3 =
                            (c3 =
                              (u3 = m3[w2] || (m3[w2] = {}))[e3] || [])[0] ===
                              x2 && c3[1],
                            h3 = c3[0] === x2 && c3[2],
                            d3 = p3 && m3.childNodes[p3];
                          (d3 =
                            (++p3 && d3 && d3[v3]) ||
                            (h3 = p3 = 0) ||
                            f3.pop());

                        )
                          if (d3.nodeType === 1 && ++h3 && d3 === t4) {
                            u3[e3] = [x2, p3, h3];
                            break;
                          }
                      } else if (
                        y3 &&
                        (c3 = (t4[w2] || (t4[w2] = {}))[e3]) &&
                        c3[0] === x2
                      )
                        h3 = c3[1];
                      else
                        for (
                          ;
                          (d3 =
                            (++p3 && d3 && d3[v3]) ||
                            (h3 = p3 = 0) ||
                            f3.pop()) &&
                          ((o3
                            ? d3.nodeName.toLowerCase() !== g3
                            : d3.nodeType !== 1) ||
                            !++h3 ||
                            (y3 && ((d3[w2] || (d3[w2] = {}))[e3] = [x2, h3]),
                            d3 !== t4));

                        );
                      return (
                        (h3 -= s3) === n3 || (h3 % n3 == 0 && h3 / n3 >= 0)
                      );
                    }
                  };
            },
            PSEUDO: function (e3, t3) {
              var i3,
                s3 =
                  n2.pseudos[e3] ||
                  n2.setFilters[e3.toLowerCase()] ||
                  ae2.error("unsupported pseudo: " + e3);
              return s3[w2]
                ? s3(t3)
                : s3.length > 1
                ? ((i3 = [e3, e3, "", t3]),
                  n2.setFilters.hasOwnProperty(e3.toLowerCase())
                    ? oe2(function (e4, i4) {
                        for (var n3, a3 = s3(e4, t3), r3 = a3.length; r3--; )
                          e4[(n3 = O2(e4, a3[r3]))] = !(i4[n3] = a3[r3]);
                      })
                    : function (e4) {
                        return s3(e4, 0, i3);
                      })
                : s3;
            },
          },
          pseudos: {
            not: oe2(function (e3) {
              var t3 = [],
                i3 = [],
                n3 = o2(e3.replace(R2, "$1"));
              return n3[w2]
                ? oe2(function (e4, t4, i4, s3) {
                    for (
                      var a3, r3 = n3(e4, null, s3, []), o3 = e4.length;
                      o3--;

                    )
                      (a3 = r3[o3]) && (e4[o3] = !(t4[o3] = a3));
                  })
                : function (e4, s3, a3) {
                    return (
                      (t3[0] = e4),
                      n3(t3, null, a3, i3),
                      (t3[0] = null),
                      !i3.pop()
                    );
                  };
            }),
            has: oe2(function (e3) {
              return function (t3) {
                return ae2(e3, t3).length > 0;
              };
            }),
            contains: oe2(function (e3) {
              return (
                (e3 = e3.replace(ie2, ne2)),
                function (t3) {
                  return (
                    (t3.textContent || t3.innerText || s2(t3)).indexOf(e3) > -1
                  );
                }
              );
            }),
            lang: oe2(function (e3) {
              return (
                Y2.test(e3 || "") || ae2.error("unsupported lang: " + e3),
                (e3 = e3.replace(ie2, ne2).toLowerCase()),
                function (t3) {
                  var i3;
                  do
                    if (
                      (i3 = v2
                        ? t3.lang
                        : t3.getAttribute("xml:lang") ||
                          t3.getAttribute("lang"))
                    )
                      return (
                        (i3 = i3.toLowerCase()) === e3 ||
                        i3.indexOf(e3 + "-") === 0
                      );
                  while ((t3 = t3.parentNode) && t3.nodeType === 1);
                  return !1;
                }
              );
            }),
            target: function (t3) {
              var i3 = e2.location && e2.location.hash;
              return i3 && i3.slice(1) === t3.id;
            },
            root: function (e3) {
              return e3 === f2;
            },
            focus: function (e3) {
              return (
                e3 === p2.activeElement &&
                (!p2.hasFocus || p2.hasFocus()) &&
                !!(e3.type || e3.href || ~e3.tabIndex)
              );
            },
            enabled: function (e3) {
              return e3.disabled === !1;
            },
            disabled: function (e3) {
              return e3.disabled === !0;
            },
            checked: function (e3) {
              var t3 = e3.nodeName.toLowerCase();
              return (
                (t3 === "input" && !!e3.checked) ||
                (t3 === "option" && !!e3.selected)
              );
            },
            selected: function (e3) {
              return (
                e3.parentNode && e3.parentNode.selectedIndex, e3.selected === !0
              );
            },
            empty: function (e3) {
              for (e3 = e3.firstChild; e3; e3 = e3.nextSibling)
                if (e3.nodeType < 6) return !1;
              return !0;
            },
            parent: function (e3) {
              return !n2.pseudos.empty(e3);
            },
            header: function (e3) {
              return Q2.test(e3.nodeName);
            },
            input: function (e3) {
              return K2.test(e3.nodeName);
            },
            button: function (e3) {
              var t3 = e3.nodeName.toLowerCase();
              return (
                (t3 === "input" && e3.type === "button") || t3 === "button"
              );
            },
            text: function (e3) {
              var t3;
              return (
                e3.nodeName.toLowerCase() === "input" &&
                e3.type === "text" &&
                ((t3 = e3.getAttribute("type")) == null ||
                  t3.toLowerCase() === "text")
              );
            },
            first: pe2(function () {
              return [0];
            }),
            last: pe2(function (e3, t3) {
              return [t3 - 1];
            }),
            eq: pe2(function (e3, t3, i3) {
              return [i3 < 0 ? i3 + t3 : i3];
            }),
            even: pe2(function (e3, t3) {
              for (var i3 = 0; i3 < t3; i3 += 2) e3.push(i3);
              return e3;
            }),
            odd: pe2(function (e3, t3) {
              for (var i3 = 1; i3 < t3; i3 += 2) e3.push(i3);
              return e3;
            }),
            lt: pe2(function (e3, t3, i3) {
              for (var n3 = i3 < 0 ? i3 + t3 : i3; --n3 >= 0; ) e3.push(n3);
              return e3;
            }),
            gt: pe2(function (e3, t3, i3) {
              for (var n3 = i3 < 0 ? i3 + t3 : i3; ++n3 < t3; ) e3.push(n3);
              return e3;
            }),
          },
        }),
      (n2.pseudos.nth = n2.pseudos.eq),
      { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
        n2.pseudos[t2] = de2(t2);
      for (t2 in { submit: !0, reset: !0 }) n2.pseudos[t2] = he2(t2);
      function ve2() {}
      function me2(e3) {
        for (var t3 = 0, i3 = e3.length, n3 = ""; t3 < i3; t3++)
          n3 += e3[t3].value;
        return n3;
      }
      function ge2(e3, t3, i3) {
        var n3 = t3.dir,
          s3 = i3 && n3 === "parentNode",
          a3 = C2++;
        return t3.first
          ? function (t4, i4, a4) {
              for (; (t4 = t4[n3]); )
                if (t4.nodeType === 1 || s3) return e3(t4, i4, a4);
            }
          : function (t4, i4, r3) {
              var o3,
                l3,
                c3 = [x2, a3];
              if (r3) {
                for (; (t4 = t4[n3]); )
                  if ((t4.nodeType === 1 || s3) && e3(t4, i4, r3)) return !0;
              } else
                for (; (t4 = t4[n3]); )
                  if (t4.nodeType === 1 || s3) {
                    if (
                      (o3 = (l3 = t4[w2] || (t4[w2] = {}))[n3]) &&
                      o3[0] === x2 &&
                      o3[1] === a3
                    )
                      return (c3[2] = o3[2]);
                    if (((l3[n3] = c3), (c3[2] = e3(t4, i4, r3)))) return !0;
                  }
            };
      }
      function ye2(e3) {
        return e3.length > 1
          ? function (t3, i3, n3) {
              for (var s3 = e3.length; s3--; )
                if (!e3[s3](t3, i3, n3)) return !1;
              return !0;
            }
          : e3[0];
      }
      function be2(e3, t3, i3, n3, s3) {
        for (
          var a3, r3 = [], o3 = 0, l3 = e3.length, c3 = t3 != null;
          o3 < l3;
          o3++
        )
          (a3 = e3[o3]) &&
            ((i3 && !i3(a3, n3, s3)) || (r3.push(a3), c3 && t3.push(o3)));
        return r3;
      }
      function we2(e3, t3, i3, n3, s3, a3) {
        return (
          n3 && !n3[w2] && (n3 = we2(n3)),
          s3 && !s3[w2] && (s3 = we2(s3, a3)),
          oe2(function (a4, r3, o3, l3) {
            var c3,
              u3,
              d3,
              h3 = [],
              p3 = [],
              f3 = r3.length,
              v3 =
                a4 ||
                (function (e4, t4, i4) {
                  for (var n4 = 0, s4 = t4.length; n4 < s4; n4++)
                    ae2(e4, t4[n4], i4);
                  return i4;
                })(t3 || "*", o3.nodeType ? [o3] : o3, []),
              m3 = !e3 || (!a4 && t3) ? v3 : be2(v3, h3, e3, o3, l3),
              g3 = i3 ? (s3 || (a4 ? e3 : f3 || n3) ? [] : r3) : m3;
            if ((i3 && i3(m3, g3, o3, l3), n3))
              for (c3 = be2(g3, p3), n3(c3, [], o3, l3), u3 = c3.length; u3--; )
                (d3 = c3[u3]) && (g3[p3[u3]] = !(m3[p3[u3]] = d3));
            if (a4) {
              if (s3 || e3) {
                if (s3) {
                  for (c3 = [], u3 = g3.length; u3--; )
                    (d3 = g3[u3]) && c3.push((m3[u3] = d3));
                  s3(null, (g3 = []), c3, l3);
                }
                for (u3 = g3.length; u3--; )
                  (d3 = g3[u3]) &&
                    (c3 = s3 ? O2(a4, d3) : h3[u3]) > -1 &&
                    (a4[c3] = !(r3[c3] = d3));
              }
            } else (g3 = be2(g3 === r3 ? g3.splice(f3, g3.length) : g3)), s3 ? s3(null, r3, g3, l3) : A2.apply(r3, g3);
          })
        );
      }
      function Se2(e3) {
        for (
          var t3,
            i3,
            s3,
            a3 = e3.length,
            r3 = n2.relative[e3[0].type],
            o3 = r3 || n2.relative[" "],
            l3 = r3 ? 1 : 0,
            u3 = ge2(
              function (e4) {
                return e4 === t3;
              },
              o3,
              !0
            ),
            d3 = ge2(
              function (e4) {
                return O2(t3, e4) > -1;
              },
              o3,
              !0
            ),
            h3 = [
              function (e4, i4, n3) {
                var s4 =
                  (!r3 && (n3 || i4 !== c2)) ||
                  ((t3 = i4).nodeType ? u3(e4, i4, n3) : d3(e4, i4, n3));
                return (t3 = null), s4;
              },
            ];
          l3 < a3;
          l3++
        )
          if ((i3 = n2.relative[e3[l3].type])) h3 = [ge2(ye2(h3), i3)];
          else {
            if ((i3 = n2.filter[e3[l3].type].apply(null, e3[l3].matches))[w2]) {
              for (s3 = ++l3; s3 < a3 && !n2.relative[e3[s3].type]; s3++);
              return we2(
                l3 > 1 && ye2(h3),
                l3 > 1 &&
                  me2(
                    e3
                      .slice(0, l3 - 1)
                      .concat({ value: e3[l3 - 2].type === " " ? "*" : "" })
                  ).replace(R2, "$1"),
                i3,
                l3 < s3 && Se2(e3.slice(l3, s3)),
                s3 < a3 && Se2((e3 = e3.slice(s3))),
                s3 < a3 && me2(e3)
              );
            }
            h3.push(i3);
          }
        return ye2(h3);
      }
      return (
        (ve2.prototype = n2.filters = n2.pseudos),
        (n2.setFilters = new ve2()),
        (r2 = ae2.tokenize =
          function (e3, t3) {
            var i3,
              s3,
              a3,
              r3,
              o3,
              l3,
              c3,
              u3 = E2[e3 + " "];
            if (u3) return t3 ? 0 : u3.slice(0);
            for (o3 = e3, l3 = [], c3 = n2.preFilter; o3; ) {
              for (r3 in ((i3 && !(s3 = j2.exec(o3))) ||
                (s3 && (o3 = o3.slice(s3[0].length) || o3), l3.push((a3 = []))),
              (i3 = !1),
              (s3 = X2.exec(o3)) &&
                ((i3 = s3.shift()),
                a3.push({ value: i3, type: s3[0].replace(R2, " ") }),
                (o3 = o3.slice(i3.length))),
              n2.filter))
                !(s3 = U2[r3].exec(o3)) ||
                  (c3[r3] && !(s3 = c3[r3](s3))) ||
                  ((i3 = s3.shift()),
                  a3.push({ value: i3, type: r3, matches: s3 }),
                  (o3 = o3.slice(i3.length)));
              if (!i3) break;
            }
            return t3 ? o3.length : o3 ? ae2.error(e3) : E2(e3, l3).slice(0);
          }),
        (o2 = ae2.compile =
          function (e3, t3) {
            var i3,
              s3 = [],
              a3 = [],
              o3 = T2[e3 + " "];
            if (!o3) {
              for (t3 || (t3 = r2(e3)), i3 = t3.length; i3--; )
                (o3 = Se2(t3[i3]))[w2] ? s3.push(o3) : a3.push(o3);
              (o3 = T2(
                e3,
                (function (e4, t4) {
                  var i4 = t4.length > 0,
                    s4 = e4.length > 0,
                    a4 = function (a5, r3, o4, l3, u3) {
                      var d3,
                        h3,
                        f3,
                        v3 = 0,
                        m3 = "0",
                        g3 = a5 && [],
                        y3 = [],
                        b3 = c2,
                        w3 = a5 || (s4 && n2.find.TAG("*", u3)),
                        S3 = (x2 += b3 == null ? 1 : Math.random() || 0.1),
                        C3 = w3.length;
                      for (
                        u3 && (c2 = r3 !== p2 && r3);
                        m3 !== C3 && (d3 = w3[m3]) != null;
                        m3++
                      ) {
                        if (s4 && d3) {
                          for (h3 = 0; (f3 = e4[h3++]); )
                            if (f3(d3, r3, o4)) {
                              l3.push(d3);
                              break;
                            }
                          u3 && (x2 = S3);
                        }
                        i4 && ((d3 = !f3 && d3) && v3--, a5 && g3.push(d3));
                      }
                      if (((v3 += m3), i4 && m3 !== v3)) {
                        for (h3 = 0; (f3 = t4[h3++]); ) f3(g3, y3, r3, o4);
                        if (a5) {
                          if (v3 > 0)
                            for (; m3--; )
                              g3[m3] || y3[m3] || (y3[m3] = I2.call(l3));
                          y3 = be2(y3);
                        }
                        A2.apply(l3, y3),
                          u3 &&
                            !a5 &&
                            y3.length > 0 &&
                            v3 + t4.length > 1 &&
                            ae2.uniqueSort(l3);
                      }
                      return u3 && ((x2 = S3), (c2 = b3)), g3;
                    };
                  return i4 ? oe2(a4) : a4;
                })(a3, s3)
              )),
                (o3.selector = e3);
            }
            return o3;
          }),
        (l2 = ae2.select =
          function (e3, t3, s3, a3) {
            var l3,
              c3,
              u3,
              d3,
              h3,
              p3 = typeof e3 == "function" && e3,
              f3 = !a3 && r2((e3 = p3.selector || e3));
            if (((s3 = s3 || []), f3.length === 1)) {
              if (
                (c3 = f3[0] = f3[0].slice(0)).length > 2 &&
                (u3 = c3[0]).type === "ID" &&
                i2.getById &&
                t3.nodeType === 9 &&
                v2 &&
                n2.relative[c3[1].type]
              ) {
                if (
                  !(t3 = (n2.find.ID(u3.matches[0].replace(ie2, ne2), t3) ||
                    [])[0])
                )
                  return s3;
                p3 && (t3 = t3.parentNode),
                  (e3 = e3.slice(c3.shift().value.length));
              }
              for (
                l3 = U2.needsContext.test(e3) ? 0 : c3.length;
                l3-- && ((u3 = c3[l3]), !n2.relative[(d3 = u3.type)]);

              )
                if (
                  (h3 = n2.find[d3]) &&
                  (a3 = h3(
                    u3.matches[0].replace(ie2, ne2),
                    (ee2.test(c3[0].type) && fe2(t3.parentNode)) || t3
                  ))
                ) {
                  if ((c3.splice(l3, 1), !(e3 = a3.length && me2(c3))))
                    return A2.apply(s3, a3), s3;
                  break;
                }
            }
            return (
              (p3 || o2(e3, f3))(
                a3,
                t3,
                !v2,
                s3,
                (ee2.test(e3) && fe2(t3.parentNode)) || t3
              ),
              s3
            );
          }),
        (i2.sortStable = w2.split("").sort(_2).join("") === w2),
        (i2.detectDuplicates = !!d2),
        h2(),
        (i2.sortDetached = le2(function (e3) {
          return 1 & e3.compareDocumentPosition(p2.createElement("div"));
        })),
        le2(function (e3) {
          return (
            (e3.innerHTML = "<a href='#'></a>"),
            e3.firstChild.getAttribute("href") === "#"
          );
        }) ||
          ce2("type|href|height|width", function (e3, t3, i3) {
            if (!i3)
              return e3.getAttribute(t3, t3.toLowerCase() === "type" ? 1 : 2);
          }),
        (i2.attributes &&
          le2(function (e3) {
            return (
              (e3.innerHTML = "<input/>"),
              e3.firstChild.setAttribute("value", ""),
              e3.firstChild.getAttribute("value") === ""
            );
          })) ||
          ce2("value", function (e3, t3, i3) {
            if (!i3 && e3.nodeName.toLowerCase() === "input")
              return e3.defaultValue;
          }),
        le2(function (e3) {
          return e3.getAttribute("disabled") == null;
        }) ||
          ce2(B2, function (e3, t3, i3) {
            var n3;
            if (!i3)
              return e3[t3] === !0
                ? t3.toLowerCase()
                : (n3 = e3.getAttributeNode(t3)) && n3.specified
                ? n3.value
                : null;
          }),
        ae2
      );
    })(e);
    (p.find = b),
      (p.expr = b.selectors),
      (p.expr[":"] = p.expr.pseudos),
      (p.unique = b.uniqueSort),
      (p.text = b.getText),
      (p.isXMLDoc = b.isXML),
      (p.contains = b.contains);
    var w = p.expr.match.needsContext,
      S = /^<(\w+)\s*\/?>(?:<\/\1>|)$/,
      x = /^.[^:#\[\.,]*$/;
    function C(e2, t2, i2) {
      if (p.isFunction(t2))
        return p.grep(e2, function (e3, n2) {
          return !!t2.call(e3, n2, e3) !== i2;
        });
      if (t2.nodeType)
        return p.grep(e2, function (e3) {
          return (e3 === t2) !== i2;
        });
      if (typeof t2 == "string") {
        if (x.test(t2)) return p.filter(t2, e2, i2);
        t2 = p.filter(t2, e2);
      }
      return p.grep(e2, function (e3) {
        return r.call(t2, e3) >= 0 !== i2;
      });
    }
    (p.filter = function (e2, t2, i2) {
      var n2 = t2[0];
      return (
        i2 && (e2 = ":not(" + e2 + ")"),
        t2.length === 1 && n2.nodeType === 1
          ? p.find.matchesSelector(n2, e2)
            ? [n2]
            : []
          : p.find.matches(
              e2,
              p.grep(t2, function (e3) {
                return e3.nodeType === 1;
              })
            )
      );
    }),
      p.fn.extend({
        find: function (e2) {
          var t2,
            i2 = this.length,
            n2 = [],
            s2 = this;
          if (typeof e2 != "string")
            return this.pushStack(
              p(e2).filter(function () {
                for (t2 = 0; t2 < i2; t2++)
                  if (p.contains(s2[t2], this)) return !0;
              })
            );
          for (t2 = 0; t2 < i2; t2++) p.find(e2, s2[t2], n2);
          return (
            ((n2 = this.pushStack(i2 > 1 ? p.unique(n2) : n2)).selector = this
              .selector
              ? this.selector + " " + e2
              : e2),
            n2
          );
        },
        filter: function (e2) {
          return this.pushStack(C(this, e2 || [], !1));
        },
        not: function (e2) {
          return this.pushStack(C(this, e2 || [], !0));
        },
        is: function (e2) {
          return !!C(
            this,
            typeof e2 == "string" && w.test(e2) ? p(e2) : e2 || [],
            !1
          ).length;
        },
      });
    var k,
      E = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/;
    ((p.fn.init = function (e2, t2) {
      var i2, n2;
      if (!e2) return this;
      if (typeof e2 == "string") {
        if (
          !(i2 =
            e2[0] === "<" && e2[e2.length - 1] === ">" && e2.length >= 3
              ? [null, e2, null]
              : E.exec(e2)) ||
          (!i2[1] && t2)
        )
          return !t2 || t2.jquery
            ? (t2 || k).find(e2)
            : this.constructor(t2).find(e2);
        if (i2[1]) {
          if (
            ((t2 = t2 instanceof p ? t2[0] : t2),
            p.merge(
              this,
              p.parseHTML(
                i2[1],
                t2 && t2.nodeType ? t2.ownerDocument || t2 : d,
                !0
              )
            ),
            S.test(i2[1]) && p.isPlainObject(t2))
          )
            for (i2 in t2)
              p.isFunction(this[i2]) ? this[i2](t2[i2]) : this.attr(i2, t2[i2]);
          return this;
        }
        return (
          (n2 = d.getElementById(i2[2])) &&
            n2.parentNode &&
            ((this.length = 1), (this[0] = n2)),
          (this.context = d),
          (this.selector = e2),
          this
        );
      }
      return e2.nodeType
        ? ((this.context = this[0] = e2), (this.length = 1), this)
        : p.isFunction(e2)
        ? k.ready !== void 0
          ? k.ready(e2)
          : e2(p)
        : (e2.selector !== void 0 &&
            ((this.selector = e2.selector), (this.context = e2.context)),
          p.makeArray(e2, this));
    }).prototype = p.fn),
      (k = p(d));
    var T = /^(?:parents|prev(?:Until|All))/,
      _ = { children: !0, contents: !0, next: !0, prev: !0 };
    function M(e2, t2) {
      for (; (e2 = e2[t2]) && e2.nodeType !== 1; );
      return e2;
    }
    p.extend({
      dir: function (e2, t2, i2) {
        for (
          var n2 = [], s2 = i2 !== void 0;
          (e2 = e2[t2]) && e2.nodeType !== 9;

        )
          if (e2.nodeType === 1) {
            if (s2 && p(e2).is(i2)) break;
            n2.push(e2);
          }
        return n2;
      },
      sibling: function (e2, t2) {
        for (var i2 = []; e2; e2 = e2.nextSibling)
          e2.nodeType === 1 && e2 !== t2 && i2.push(e2);
        return i2;
      },
    }),
      p.fn.extend({
        has: function (e2) {
          var t2 = p(e2, this),
            i2 = t2.length;
          return this.filter(function () {
            for (var e3 = 0; e3 < i2; e3++)
              if (p.contains(this, t2[e3])) return !0;
          });
        },
        closest: function (e2, t2) {
          for (
            var i2,
              n2 = 0,
              s2 = this.length,
              a2 = [],
              r2 =
                w.test(e2) || typeof e2 != "string"
                  ? p(e2, t2 || this.context)
                  : 0;
            n2 < s2;
            n2++
          )
            for (i2 = this[n2]; i2 && i2 !== t2; i2 = i2.parentNode)
              if (
                i2.nodeType < 11 &&
                (r2
                  ? r2.index(i2) > -1
                  : i2.nodeType === 1 && p.find.matchesSelector(i2, e2))
              ) {
                a2.push(i2);
                break;
              }
          return this.pushStack(a2.length > 1 ? p.unique(a2) : a2);
        },
        index: function (e2) {
          return e2
            ? typeof e2 == "string"
              ? r.call(p(e2), this[0])
              : r.call(this, e2.jquery ? e2[0] : e2)
            : this[0] && this[0].parentNode
            ? this.first().prevAll().length
            : -1;
        },
        add: function (e2, t2) {
          return this.pushStack(p.unique(p.merge(this.get(), p(e2, t2))));
        },
        addBack: function (e2) {
          return this.add(
            e2 == null ? this.prevObject : this.prevObject.filter(e2)
          );
        },
      }),
      p.each(
        {
          parent: function (e2) {
            var t2 = e2.parentNode;
            return t2 && t2.nodeType !== 11 ? t2 : null;
          },
          parents: function (e2) {
            return p.dir(e2, "parentNode");
          },
          parentsUntil: function (e2, t2, i2) {
            return p.dir(e2, "parentNode", i2);
          },
          next: function (e2) {
            return M(e2, "nextSibling");
          },
          prev: function (e2) {
            return M(e2, "previousSibling");
          },
          nextAll: function (e2) {
            return p.dir(e2, "nextSibling");
          },
          prevAll: function (e2) {
            return p.dir(e2, "previousSibling");
          },
          nextUntil: function (e2, t2, i2) {
            return p.dir(e2, "nextSibling", i2);
          },
          prevUntil: function (e2, t2, i2) {
            return p.dir(e2, "previousSibling", i2);
          },
          siblings: function (e2) {
            return p.sibling((e2.parentNode || {}).firstChild, e2);
          },
          children: function (e2) {
            return p.sibling(e2.firstChild);
          },
          contents: function (e2) {
            return e2.contentDocument || p.merge([], e2.childNodes);
          },
        },
        function (e2, t2) {
          p.fn[e2] = function (i2, n2) {
            var s2 = p.map(this, t2, i2);
            return (
              e2.slice(-5) !== "Until" && (n2 = i2),
              n2 && typeof n2 == "string" && (s2 = p.filter(n2, s2)),
              this.length > 1 &&
                (_[e2] || p.unique(s2), T.test(e2) && s2.reverse()),
              this.pushStack(s2)
            );
          };
        }
      );
    var L,
      P = /\S+/g,
      I = {};
    function D() {
      d.removeEventListener("DOMContentLoaded", D, !1),
        e.removeEventListener("load", D, !1),
        p.ready();
    }
    (p.Callbacks = function (e2) {
      e2 =
        typeof e2 == "string"
          ? I[e2] ||
            (function (e3) {
              var t3 = (I[e3] = {});
              return (
                p.each(e3.match(P) || [], function (e4, i3) {
                  t3[i3] = !0;
                }),
                t3
              );
            })(e2)
          : p.extend({}, e2);
      var t2,
        i2,
        n2,
        s2,
        a2,
        r2,
        o2 = [],
        l2 = !e2.once && [],
        c2 = function (d2) {
          for (
            t2 = e2.memory && d2,
              i2 = !0,
              r2 = s2 || 0,
              s2 = 0,
              a2 = o2.length,
              n2 = !0;
            o2 && r2 < a2;
            r2++
          )
            if (o2[r2].apply(d2[0], d2[1]) === !1 && e2.stopOnFalse) {
              t2 = !1;
              break;
            }
          (n2 = !1),
            o2 &&
              (l2
                ? l2.length && c2(l2.shift())
                : t2
                ? (o2 = [])
                : u2.disable());
        },
        u2 = {
          add: function () {
            if (o2) {
              var i3 = o2.length;
              (function t3(i4) {
                p.each(i4, function (i5, n3) {
                  var s3 = p.type(n3);
                  s3 === "function"
                    ? (e2.unique && u2.has(n3)) || o2.push(n3)
                    : n3 && n3.length && s3 !== "string" && t3(n3);
                });
              })(arguments),
                n2 ? (a2 = o2.length) : t2 && ((s2 = i3), c2(t2));
            }
            return this;
          },
          remove: function () {
            return (
              o2 &&
                p.each(arguments, function (e3, t3) {
                  for (var i3; (i3 = p.inArray(t3, o2, i3)) > -1; )
                    o2.splice(i3, 1),
                      n2 && (i3 <= a2 && a2--, i3 <= r2 && r2--);
                }),
              this
            );
          },
          has: function (e3) {
            return e3 ? p.inArray(e3, o2) > -1 : !(!o2 || !o2.length);
          },
          empty: function () {
            return (o2 = []), (a2 = 0), this;
          },
          disable: function () {
            return (o2 = l2 = t2 = void 0), this;
          },
          disabled: function () {
            return !o2;
          },
          lock: function () {
            return (l2 = void 0), t2 || u2.disable(), this;
          },
          locked: function () {
            return !l2;
          },
          fireWith: function (e3, t3) {
            return (
              !o2 ||
                (i2 && !l2) ||
                ((t3 = [e3, (t3 = t3 || []).slice ? t3.slice() : t3]),
                n2 ? l2.push(t3) : c2(t3)),
              this
            );
          },
          fire: function () {
            return u2.fireWith(this, arguments), this;
          },
          fired: function () {
            return !!i2;
          },
        };
      return u2;
    }),
      p.extend({
        Deferred: function (e2) {
          var t2 = [
              ["resolve", "done", p.Callbacks("once memory"), "resolved"],
              ["reject", "fail", p.Callbacks("once memory"), "rejected"],
              ["notify", "progress", p.Callbacks("memory")],
            ],
            i2 = "pending",
            n2 = {
              state: function () {
                return i2;
              },
              always: function () {
                return s2.done(arguments).fail(arguments), this;
              },
              then: function () {
                var e3 = arguments;
                return p
                  .Deferred(function (i3) {
                    p.each(t2, function (t3, a2) {
                      var r2 = p.isFunction(e3[t3]) && e3[t3];
                      s2[a2[1]](function () {
                        var e4 = r2 && r2.apply(this, arguments);
                        e4 && p.isFunction(e4.promise)
                          ? e4
                              .promise()
                              .done(i3.resolve)
                              .fail(i3.reject)
                              .progress(i3.notify)
                          : i3[a2[0] + "With"](
                              this === n2 ? i3.promise() : this,
                              r2 ? [e4] : arguments
                            );
                      });
                    }),
                      (e3 = null);
                  })
                  .promise();
              },
              promise: function (e3) {
                return e3 != null ? p.extend(e3, n2) : n2;
              },
            },
            s2 = {};
          return (
            (n2.pipe = n2.then),
            p.each(t2, function (e3, a2) {
              var r2 = a2[2],
                o2 = a2[3];
              (n2[a2[1]] = r2.add),
                o2 &&
                  r2.add(
                    function () {
                      i2 = o2;
                    },
                    t2[1 ^ e3][2].disable,
                    t2[2][2].lock
                  ),
                (s2[a2[0]] = function () {
                  return (
                    s2[a2[0] + "With"](this === s2 ? n2 : this, arguments), this
                  );
                }),
                (s2[a2[0] + "With"] = r2.fireWith);
            }),
            n2.promise(s2),
            e2 && e2.call(s2, s2),
            s2
          );
        },
        when: function (e2) {
          var t2,
            i2,
            s2,
            a2 = 0,
            r2 = n.call(arguments),
            o2 = r2.length,
            l2 = o2 !== 1 || (e2 && p.isFunction(e2.promise)) ? o2 : 0,
            c2 = l2 === 1 ? e2 : p.Deferred(),
            u2 = function (e3, i3, s3) {
              return function (a3) {
                (i3[e3] = this),
                  (s3[e3] = arguments.length > 1 ? n.call(arguments) : a3),
                  s3 === t2
                    ? c2.notifyWith(i3, s3)
                    : --l2 || c2.resolveWith(i3, s3);
              };
            };
          if (o2 > 1)
            for (
              t2 = new Array(o2), i2 = new Array(o2), s2 = new Array(o2);
              a2 < o2;
              a2++
            )
              r2[a2] && p.isFunction(r2[a2].promise)
                ? r2[a2]
                    .promise()
                    .done(u2(a2, s2, r2))
                    .fail(c2.reject)
                    .progress(u2(a2, i2, t2))
                : --l2;
          return l2 || c2.resolveWith(s2, r2), c2.promise();
        },
      }),
      (p.fn.ready = function (e2) {
        return p.ready.promise().done(e2), this;
      }),
      p.extend({
        isReady: !1,
        readyWait: 1,
        holdReady: function (e2) {
          e2 ? p.readyWait++ : p.ready(!0);
        },
        ready: function (e2) {
          (e2 === !0 ? --p.readyWait : p.isReady) ||
            ((p.isReady = !0),
            (e2 !== !0 && --p.readyWait > 0) ||
              (L.resolveWith(d, [p]),
              p.fn.triggerHandler &&
                (p(d).triggerHandler("ready"), p(d).off("ready"))));
        },
      }),
      (p.ready.promise = function (t2) {
        return (
          L ||
            ((L = p.Deferred()),
            d.readyState === "complete"
              ? setTimeout(p.ready)
              : (d.addEventListener("DOMContentLoaded", D, !1),
                e.addEventListener("load", D, !1))),
          L.promise(t2)
        );
      }),
      p.ready.promise();
    var A = (p.access = function (e2, t2, i2, n2, s2, a2, r2) {
      var o2 = 0,
        l2 = e2.length,
        c2 = i2 == null;
      if (p.type(i2) === "object")
        for (o2 in ((s2 = !0), i2)) p.access(e2, t2, o2, i2[o2], !0, a2, r2);
      else if (
        n2 !== void 0 &&
        ((s2 = !0),
        p.isFunction(n2) || (r2 = !0),
        c2 &&
          (r2
            ? (t2.call(e2, n2), (t2 = null))
            : ((c2 = t2),
              (t2 = function (e3, t3, i3) {
                return c2.call(p(e3), i3);
              }))),
        t2)
      )
        for (; o2 < l2; o2++)
          t2(e2[o2], i2, r2 ? n2 : n2.call(e2[o2], o2, t2(e2[o2], i2)));
      return s2 ? e2 : c2 ? t2.call(e2) : l2 ? t2(e2[0], i2) : a2;
    });
    function z() {
      Object.defineProperty((this.cache = {}), 0, {
        get: function () {
          return {};
        },
      }),
        (this.expando = p.expando + z.uid++);
    }
    (p.acceptData = function (e2) {
      return e2.nodeType === 1 || e2.nodeType === 9 || !+e2.nodeType;
    }),
      (z.uid = 1),
      (z.accepts = p.acceptData),
      (z.prototype = {
        key: function (e2) {
          if (!z.accepts(e2)) return 0;
          var t2 = {},
            i2 = e2[this.expando];
          if (!i2) {
            i2 = z.uid++;
            try {
              (t2[this.expando] = { value: i2 }),
                Object.defineProperties(e2, t2);
            } catch {
              (t2[this.expando] = i2), p.extend(e2, t2);
            }
          }
          return this.cache[i2] || (this.cache[i2] = {}), i2;
        },
        set: function (e2, t2, i2) {
          var n2,
            s2 = this.key(e2),
            a2 = this.cache[s2];
          if (typeof t2 == "string") a2[t2] = i2;
          else if (p.isEmptyObject(a2)) p.extend(this.cache[s2], t2);
          else for (n2 in t2) a2[n2] = t2[n2];
          return a2;
        },
        get: function (e2, t2) {
          var i2 = this.cache[this.key(e2)];
          return t2 === void 0 ? i2 : i2[t2];
        },
        access: function (e2, t2, i2) {
          var n2;
          return t2 === void 0 || (t2 && typeof t2 == "string" && i2 === void 0)
            ? (n2 = this.get(e2, t2)) !== void 0
              ? n2
              : this.get(e2, p.camelCase(t2))
            : (this.set(e2, t2, i2), i2 !== void 0 ? i2 : t2);
        },
        remove: function (e2, t2) {
          var i2,
            n2,
            s2,
            a2 = this.key(e2),
            r2 = this.cache[a2];
          if (t2 === void 0) this.cache[a2] = {};
          else
            for (
              p.isArray(t2)
                ? (n2 = t2.concat(t2.map(p.camelCase)))
                : ((s2 = p.camelCase(t2)),
                  (n2 =
                    (t2 in r2)
                      ? [t2, s2]
                      : ((n2 = s2) in r2)
                      ? [n2]
                      : n2.match(P) || [])),
                i2 = n2.length;
              i2--;

            )
              delete r2[n2[i2]];
        },
        hasData: function (e2) {
          return !p.isEmptyObject(this.cache[e2[this.expando]] || {});
        },
        discard: function (e2) {
          e2[this.expando] && delete this.cache[e2[this.expando]];
        },
      });
    var O = new z(),
      B = new z(),
      N = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
      q = /([A-Z])/g;
    function $2(e2, t2, i2) {
      var n2;
      if (i2 === void 0 && e2.nodeType === 1)
        if (
          ((n2 = "data-" + t2.replace(q, "-$1").toLowerCase()),
          typeof (i2 = e2.getAttribute(n2)) == "string")
        ) {
          try {
            i2 =
              i2 === "true" ||
              (i2 !== "false" &&
                (i2 === "null"
                  ? null
                  : +i2 + "" === i2
                  ? +i2
                  : N.test(i2)
                  ? p.parseJSON(i2)
                  : i2));
          } catch {}
          B.set(e2, t2, i2);
        } else i2 = void 0;
      return i2;
    }
    p.extend({
      hasData: function (e2) {
        return B.hasData(e2) || O.hasData(e2);
      },
      data: function (e2, t2, i2) {
        return B.access(e2, t2, i2);
      },
      removeData: function (e2, t2) {
        B.remove(e2, t2);
      },
      _data: function (e2, t2, i2) {
        return O.access(e2, t2, i2);
      },
      _removeData: function (e2, t2) {
        O.remove(e2, t2);
      },
    }),
      p.fn.extend({
        data: function (e2, t2) {
          var i2,
            n2,
            s2,
            a2 = this[0],
            r2 = a2 && a2.attributes;
          if (e2 === void 0) {
            if (
              this.length &&
              ((s2 = B.get(a2)),
              a2.nodeType === 1 && !O.get(a2, "hasDataAttrs"))
            ) {
              for (i2 = r2.length; i2--; )
                r2[i2] &&
                  (n2 = r2[i2].name).indexOf("data-") === 0 &&
                  ((n2 = p.camelCase(n2.slice(5))), $2(a2, n2, s2[n2]));
              O.set(a2, "hasDataAttrs", !0);
            }
            return s2;
          }
          return typeof e2 == "object"
            ? this.each(function () {
                B.set(this, e2);
              })
            : A(
                this,
                function (t3) {
                  var i3,
                    n3 = p.camelCase(e2);
                  if (a2 && t3 === void 0)
                    return (i3 = B.get(a2, e2)) !== void 0 ||
                      (i3 = B.get(a2, n3)) !== void 0 ||
                      (i3 = $2(a2, n3, void 0)) !== void 0
                      ? i3
                      : void 0;
                  this.each(function () {
                    var i4 = B.get(this, n3);
                    B.set(this, n3, t3),
                      e2.indexOf("-") !== -1 &&
                        i4 !== void 0 &&
                        B.set(this, e2, t3);
                  });
                },
                null,
                t2,
                arguments.length > 1,
                null,
                !0
              );
        },
        removeData: function (e2) {
          return this.each(function () {
            B.remove(this, e2);
          });
        },
      }),
      p.extend({
        queue: function (e2, t2, i2) {
          var n2;
          if (e2)
            return (
              (t2 = (t2 || "fx") + "queue"),
              (n2 = O.get(e2, t2)),
              i2 &&
                (!n2 || p.isArray(i2)
                  ? (n2 = O.access(e2, t2, p.makeArray(i2)))
                  : n2.push(i2)),
              n2 || []
            );
        },
        dequeue: function (e2, t2) {
          t2 = t2 || "fx";
          var i2 = p.queue(e2, t2),
            n2 = i2.length,
            s2 = i2.shift(),
            a2 = p._queueHooks(e2, t2);
          s2 === "inprogress" && ((s2 = i2.shift()), n2--),
            s2 &&
              (t2 === "fx" && i2.unshift("inprogress"),
              delete a2.stop,
              s2.call(
                e2,
                function () {
                  p.dequeue(e2, t2);
                },
                a2
              )),
            !n2 && a2 && a2.empty.fire();
        },
        _queueHooks: function (e2, t2) {
          var i2 = t2 + "queueHooks";
          return (
            O.get(e2, i2) ||
            O.access(e2, i2, {
              empty: p.Callbacks("once memory").add(function () {
                O.remove(e2, [t2 + "queue", i2]);
              }),
            })
          );
        },
      }),
      p.fn.extend({
        queue: function (e2, t2) {
          var i2 = 2;
          return (
            typeof e2 != "string" && ((t2 = e2), (e2 = "fx"), i2--),
            arguments.length < i2
              ? p.queue(this[0], e2)
              : t2 === void 0
              ? this
              : this.each(function () {
                  var i3 = p.queue(this, e2, t2);
                  p._queueHooks(this, e2),
                    e2 === "fx" &&
                      i3[0] !== "inprogress" &&
                      p.dequeue(this, e2);
                })
          );
        },
        dequeue: function (e2) {
          return this.each(function () {
            p.dequeue(this, e2);
          });
        },
        clearQueue: function (e2) {
          return this.queue(e2 || "fx", []);
        },
        promise: function (e2, t2) {
          var i2,
            n2 = 1,
            s2 = p.Deferred(),
            a2 = this,
            r2 = this.length,
            o2 = function () {
              --n2 || s2.resolveWith(a2, [a2]);
            };
          for (
            typeof e2 != "string" && ((t2 = e2), (e2 = void 0)),
              e2 = e2 || "fx";
            r2--;

          )
            (i2 = O.get(a2[r2], e2 + "queueHooks")) &&
              i2.empty &&
              (n2++, i2.empty.add(o2));
          return o2(), s2.promise(t2);
        },
      });
    var H,
      F,
      V = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
      R = ["Top", "Right", "Bottom", "Left"],
      j = function (e2, t2) {
        return (
          (e2 = t2 || e2),
          p.css(e2, "display") === "none" || !p.contains(e2.ownerDocument, e2)
        );
      },
      X = /^(?:checkbox|radio)$/i;
    (H = d.createDocumentFragment().appendChild(d.createElement("div"))),
      (F = d.createElement("input")).setAttribute("type", "radio"),
      F.setAttribute("checked", "checked"),
      F.setAttribute("name", "t"),
      H.appendChild(F),
      (u.checkClone = H.cloneNode(!0).cloneNode(!0).lastChild.checked),
      (H.innerHTML = "<textarea>x</textarea>"),
      (u.noCloneChecked = !!H.cloneNode(!0).lastChild.defaultValue);
    var G = "undefined";
    u.focusinBubbles = "onfocusin" in e;
    var W = /^key/,
      Y = /^(?:mouse|pointer|contextmenu)|click/,
      U = /^(?:focusinfocus|focusoutblur)$/,
      K = /^([^.]*)(?:\.(.+)|)$/;
    function Q() {
      return !0;
    }
    function Z() {
      return !1;
    }
    function J() {
      try {
        return d.activeElement;
      } catch {}
    }
    (p.event = {
      global: {},
      add: function (e2, t2, i2, n2, s2) {
        var a2,
          r2,
          o2,
          l2,
          c2,
          u2,
          d2,
          h2,
          f2,
          v2,
          m2,
          g2 = O.get(e2);
        if (g2)
          for (
            i2.handler && ((i2 = (a2 = i2).handler), (s2 = a2.selector)),
              i2.guid || (i2.guid = p.guid++),
              (l2 = g2.events) || (l2 = g2.events = {}),
              (r2 = g2.handle) ||
                (r2 = g2.handle =
                  function (t3) {
                    return typeof p !== G && p.event.triggered !== t3.type
                      ? p.event.dispatch.apply(e2, arguments)
                      : void 0;
                  }),
              c2 = (t2 = (t2 || "").match(P) || [""]).length;
            c2--;

          )
            (f2 = m2 = (o2 = K.exec(t2[c2]) || [])[1]),
              (v2 = (o2[2] || "").split(".").sort()),
              f2 &&
                ((d2 = p.event.special[f2] || {}),
                (f2 = (s2 ? d2.delegateType : d2.bindType) || f2),
                (d2 = p.event.special[f2] || {}),
                (u2 = p.extend(
                  {
                    type: f2,
                    origType: m2,
                    data: n2,
                    handler: i2,
                    guid: i2.guid,
                    selector: s2,
                    needsContext: s2 && p.expr.match.needsContext.test(s2),
                    namespace: v2.join("."),
                  },
                  a2
                )),
                (h2 = l2[f2]) ||
                  (((h2 = l2[f2] = []).delegateCount = 0),
                  (d2.setup && d2.setup.call(e2, n2, v2, r2) !== !1) ||
                    (e2.addEventListener && e2.addEventListener(f2, r2, !1))),
                d2.add &&
                  (d2.add.call(e2, u2),
                  u2.handler.guid || (u2.handler.guid = i2.guid)),
                s2 ? h2.splice(h2.delegateCount++, 0, u2) : h2.push(u2),
                (p.event.global[f2] = !0));
      },
      remove: function (e2, t2, i2, n2, s2) {
        var a2,
          r2,
          o2,
          l2,
          c2,
          u2,
          d2,
          h2,
          f2,
          v2,
          m2,
          g2 = O.hasData(e2) && O.get(e2);
        if (g2 && (l2 = g2.events)) {
          for (c2 = (t2 = (t2 || "").match(P) || [""]).length; c2--; )
            if (
              ((f2 = m2 = (o2 = K.exec(t2[c2]) || [])[1]),
              (v2 = (o2[2] || "").split(".").sort()),
              f2)
            ) {
              for (
                d2 = p.event.special[f2] || {},
                  h2 =
                    l2[(f2 = (n2 ? d2.delegateType : d2.bindType) || f2)] || [],
                  o2 =
                    o2[2] &&
                    new RegExp(
                      "(^|\\.)" + v2.join("\\.(?:.*\\.|)") + "(\\.|$)"
                    ),
                  r2 = a2 = h2.length;
                a2--;

              )
                (u2 = h2[a2]),
                  (!s2 && m2 !== u2.origType) ||
                    (i2 && i2.guid !== u2.guid) ||
                    (o2 && !o2.test(u2.namespace)) ||
                    (n2 &&
                      n2 !== u2.selector &&
                      (n2 !== "**" || !u2.selector)) ||
                    (h2.splice(a2, 1),
                    u2.selector && h2.delegateCount--,
                    d2.remove && d2.remove.call(e2, u2));
              r2 &&
                !h2.length &&
                ((d2.teardown && d2.teardown.call(e2, v2, g2.handle) !== !1) ||
                  p.removeEvent(e2, f2, g2.handle),
                delete l2[f2]);
            } else for (f2 in l2) p.event.remove(e2, f2 + t2[c2], i2, n2, !0);
          p.isEmptyObject(l2) && (delete g2.handle, O.remove(e2, "events"));
        }
      },
      trigger: function (t2, i2, n2, s2) {
        var a2,
          r2,
          o2,
          l2,
          u2,
          h2,
          f2,
          v2 = [n2 || d],
          m2 = c.call(t2, "type") ? t2.type : t2,
          g2 = c.call(t2, "namespace") ? t2.namespace.split(".") : [];
        if (
          ((r2 = o2 = n2 = n2 || d),
          n2.nodeType !== 3 &&
            n2.nodeType !== 8 &&
            !U.test(m2 + p.event.triggered) &&
            (m2.indexOf(".") >= 0 &&
              ((g2 = m2.split(".")), (m2 = g2.shift()), g2.sort()),
            (u2 = m2.indexOf(":") < 0 && "on" + m2),
            ((t2 = t2[p.expando]
              ? t2
              : new p.Event(m2, typeof t2 == "object" && t2)).isTrigger = s2
              ? 2
              : 3),
            (t2.namespace = g2.join(".")),
            (t2.namespace_re = t2.namespace
              ? new RegExp("(^|\\.)" + g2.join("\\.(?:.*\\.|)") + "(\\.|$)")
              : null),
            (t2.result = void 0),
            t2.target || (t2.target = n2),
            (i2 = i2 == null ? [t2] : p.makeArray(i2, [t2])),
            (f2 = p.event.special[m2] || {}),
            s2 || !f2.trigger || f2.trigger.apply(n2, i2) !== !1))
        ) {
          if (!s2 && !f2.noBubble && !p.isWindow(n2)) {
            for (
              l2 = f2.delegateType || m2,
                U.test(l2 + m2) || (r2 = r2.parentNode);
              r2;
              r2 = r2.parentNode
            )
              v2.push(r2), (o2 = r2);
            o2 === (n2.ownerDocument || d) &&
              v2.push(o2.defaultView || o2.parentWindow || e);
          }
          for (a2 = 0; (r2 = v2[a2++]) && !t2.isPropagationStopped(); )
            (t2.type = a2 > 1 ? l2 : f2.bindType || m2),
              (h2 =
                (O.get(r2, "events") || {})[t2.type] && O.get(r2, "handle")) &&
                h2.apply(r2, i2),
              (h2 = u2 && r2[u2]) &&
                h2.apply &&
                p.acceptData(r2) &&
                ((t2.result = h2.apply(r2, i2)),
                t2.result === !1 && t2.preventDefault());
          return (
            (t2.type = m2),
            s2 ||
              t2.isDefaultPrevented() ||
              (f2._default && f2._default.apply(v2.pop(), i2) !== !1) ||
              !p.acceptData(n2) ||
              (u2 &&
                p.isFunction(n2[m2]) &&
                !p.isWindow(n2) &&
                ((o2 = n2[u2]) && (n2[u2] = null),
                (p.event.triggered = m2),
                n2[m2](),
                (p.event.triggered = void 0),
                o2 && (n2[u2] = o2))),
            t2.result
          );
        }
      },
      dispatch: function (e2) {
        e2 = p.event.fix(e2);
        var t2,
          i2,
          s2,
          a2,
          r2,
          o2,
          l2 = n.call(arguments),
          c2 = (O.get(this, "events") || {})[e2.type] || [],
          u2 = p.event.special[e2.type] || {};
        if (
          ((l2[0] = e2),
          (e2.delegateTarget = this),
          !u2.preDispatch || u2.preDispatch.call(this, e2) !== !1)
        ) {
          for (
            o2 = p.event.handlers.call(this, e2, c2), t2 = 0;
            (a2 = o2[t2++]) && !e2.isPropagationStopped();

          )
            for (
              e2.currentTarget = a2.elem, i2 = 0;
              (r2 = a2.handlers[i2++]) && !e2.isImmediatePropagationStopped();

            )
              (e2.namespace_re && !e2.namespace_re.test(r2.namespace)) ||
                ((e2.handleObj = r2),
                (e2.data = r2.data),
                (s2 = (
                  (p.event.special[r2.origType] || {}).handle || r2.handler
                ).apply(a2.elem, l2)) !== void 0 &&
                  (e2.result = s2) === !1 &&
                  (e2.preventDefault(), e2.stopPropagation()));
          return u2.postDispatch && u2.postDispatch.call(this, e2), e2.result;
        }
      },
      handlers: function (e2, t2) {
        var i2,
          n2,
          s2,
          a2,
          r2 = [],
          o2 = t2.delegateCount,
          l2 = e2.target;
        if (o2 && l2.nodeType && (!e2.button || e2.type !== "click")) {
          for (; l2 !== this; l2 = l2.parentNode || this)
            if (l2.disabled !== !0 || e2.type !== "click") {
              for (n2 = [], i2 = 0; i2 < o2; i2++)
                n2[(s2 = (a2 = t2[i2]).selector + " ")] === void 0 &&
                  (n2[s2] = a2.needsContext
                    ? p(s2, this).index(l2) >= 0
                    : p.find(s2, this, null, [l2]).length),
                  n2[s2] && n2.push(a2);
              n2.length && r2.push({ elem: l2, handlers: n2 });
            }
        }
        return (
          o2 < t2.length && r2.push({ elem: this, handlers: t2.slice(o2) }), r2
        );
      },
      props:
        "altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(
          " "
        ),
      fixHooks: {},
      keyHooks: {
        props: "char charCode key keyCode".split(" "),
        filter: function (e2, t2) {
          return (
            e2.which == null &&
              (e2.which = t2.charCode != null ? t2.charCode : t2.keyCode),
            e2
          );
        },
      },
      mouseHooks: {
        props:
          "button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(
            " "
          ),
        filter: function (e2, t2) {
          var i2,
            n2,
            s2,
            a2 = t2.button;
          return (
            e2.pageX == null &&
              t2.clientX != null &&
              ((n2 = (i2 = e2.target.ownerDocument || d).documentElement),
              (s2 = i2.body),
              (e2.pageX =
                t2.clientX +
                ((n2 && n2.scrollLeft) || (s2 && s2.scrollLeft) || 0) -
                ((n2 && n2.clientLeft) || (s2 && s2.clientLeft) || 0)),
              (e2.pageY =
                t2.clientY +
                ((n2 && n2.scrollTop) || (s2 && s2.scrollTop) || 0) -
                ((n2 && n2.clientTop) || (s2 && s2.clientTop) || 0))),
            e2.which ||
              a2 === void 0 ||
              (e2.which = 1 & a2 ? 1 : 2 & a2 ? 3 : 4 & a2 ? 2 : 0),
            e2
          );
        },
      },
      fix: function (e2) {
        if (e2[p.expando]) return e2;
        var t2,
          i2,
          n2,
          s2 = e2.type,
          a2 = e2,
          r2 = this.fixHooks[s2];
        for (
          r2 ||
            (this.fixHooks[s2] = r2 =
              Y.test(s2) ? this.mouseHooks : W.test(s2) ? this.keyHooks : {}),
            n2 = r2.props ? this.props.concat(r2.props) : this.props,
            e2 = new p.Event(a2),
            t2 = n2.length;
          t2--;

        )
          e2[(i2 = n2[t2])] = a2[i2];
        return (
          e2.target || (e2.target = d),
          e2.target.nodeType === 3 && (e2.target = e2.target.parentNode),
          r2.filter ? r2.filter(e2, a2) : e2
        );
      },
      special: {
        load: { noBubble: !0 },
        focus: {
          trigger: function () {
            if (this !== J() && this.focus) return this.focus(), !1;
          },
          delegateType: "focusin",
        },
        blur: {
          trigger: function () {
            if (this === J() && this.blur) return this.blur(), !1;
          },
          delegateType: "focusout",
        },
        click: {
          trigger: function () {
            if (
              this.type === "checkbox" &&
              this.click &&
              p.nodeName(this, "input")
            )
              return this.click(), !1;
          },
          _default: function (e2) {
            return p.nodeName(e2.target, "a");
          },
        },
        beforeunload: {
          postDispatch: function (e2) {
            e2.result !== void 0 &&
              e2.originalEvent &&
              (e2.originalEvent.returnValue = e2.result);
          },
        },
      },
      simulate: function (e2, t2, i2, n2) {
        var s2 = p.extend(new p.Event(), i2, {
          type: e2,
          isSimulated: !0,
          originalEvent: {},
        });
        n2 ? p.event.trigger(s2, null, t2) : p.event.dispatch.call(t2, s2),
          s2.isDefaultPrevented() && i2.preventDefault();
      },
    }),
      (p.removeEvent = function (e2, t2, i2) {
        e2.removeEventListener && e2.removeEventListener(t2, i2, !1);
      }),
      (p.Event = function (e2, t2) {
        if (!(this instanceof p.Event)) return new p.Event(e2, t2);
        e2 && e2.type
          ? ((this.originalEvent = e2),
            (this.type = e2.type),
            (this.isDefaultPrevented =
              e2.defaultPrevented ||
              (e2.defaultPrevented === void 0 && e2.returnValue === !1)
                ? Q
                : Z))
          : (this.type = e2),
          t2 && p.extend(this, t2),
          (this.timeStamp = (e2 && e2.timeStamp) || p.now()),
          (this[p.expando] = !0);
      }),
      (p.Event.prototype = {
        isDefaultPrevented: Z,
        isPropagationStopped: Z,
        isImmediatePropagationStopped: Z,
        preventDefault: function () {
          var e2 = this.originalEvent;
          (this.isDefaultPrevented = Q),
            e2 && e2.preventDefault && e2.preventDefault();
        },
        stopPropagation: function () {
          var e2 = this.originalEvent;
          (this.isPropagationStopped = Q),
            e2 && e2.stopPropagation && e2.stopPropagation();
        },
        stopImmediatePropagation: function () {
          var e2 = this.originalEvent;
          (this.isImmediatePropagationStopped = Q),
            e2 && e2.stopImmediatePropagation && e2.stopImmediatePropagation(),
            this.stopPropagation();
        },
      }),
      p.each(
        {
          mouseenter: "mouseover",
          mouseleave: "mouseout",
          pointerenter: "pointerover",
          pointerleave: "pointerout",
        },
        function (e2, t2) {
          p.event.special[e2] = {
            delegateType: t2,
            bindType: t2,
            handle: function (e3) {
              var i2,
                n2 = e3.relatedTarget,
                s2 = e3.handleObj;
              return (
                (n2 && (n2 === this || p.contains(this, n2))) ||
                  ((e3.type = s2.origType),
                  (i2 = s2.handler.apply(this, arguments)),
                  (e3.type = t2)),
                i2
              );
            },
          };
        }
      ),
      u.focusinBubbles ||
        p.each({ focus: "focusin", blur: "focusout" }, function (e2, t2) {
          var i2 = function (e3) {
            p.event.simulate(t2, e3.target, p.event.fix(e3), !0);
          };
          p.event.special[t2] = {
            setup: function () {
              var n2 = this.ownerDocument || this,
                s2 = O.access(n2, t2);
              s2 || n2.addEventListener(e2, i2, !0),
                O.access(n2, t2, (s2 || 0) + 1);
            },
            teardown: function () {
              var n2 = this.ownerDocument || this,
                s2 = O.access(n2, t2) - 1;
              s2
                ? O.access(n2, t2, s2)
                : (n2.removeEventListener(e2, i2, !0), O.remove(n2, t2));
            },
          };
        }),
      p.fn.extend({
        on: function (e2, t2, i2, n2, s2) {
          var a2, r2;
          if (typeof e2 == "object") {
            for (r2 in (typeof t2 != "string" &&
              ((i2 = i2 || t2), (t2 = void 0)),
            e2))
              this.on(r2, t2, i2, e2[r2], s2);
            return this;
          }
          if (
            (i2 == null && n2 == null
              ? ((n2 = t2), (i2 = t2 = void 0))
              : n2 == null &&
                (typeof t2 == "string"
                  ? ((n2 = i2), (i2 = void 0))
                  : ((n2 = i2), (i2 = t2), (t2 = void 0))),
            n2 === !1)
          )
            n2 = Z;
          else if (!n2) return this;
          return (
            s2 === 1 &&
              ((a2 = n2),
              (n2 = function (e3) {
                return p().off(e3), a2.apply(this, arguments);
              }),
              (n2.guid = a2.guid || (a2.guid = p.guid++))),
            this.each(function () {
              p.event.add(this, e2, n2, i2, t2);
            })
          );
        },
        one: function (e2, t2, i2, n2) {
          return this.on(e2, t2, i2, n2, 1);
        },
        off: function (e2, t2, i2) {
          var n2, s2;
          if (e2 && e2.preventDefault && e2.handleObj)
            return (
              (n2 = e2.handleObj),
              p(e2.delegateTarget).off(
                n2.namespace ? n2.origType + "." + n2.namespace : n2.origType,
                n2.selector,
                n2.handler
              ),
              this
            );
          if (typeof e2 == "object") {
            for (s2 in e2) this.off(s2, t2, e2[s2]);
            return this;
          }
          return (
            (t2 !== !1 && typeof t2 != "function") ||
              ((i2 = t2), (t2 = void 0)),
            i2 === !1 && (i2 = Z),
            this.each(function () {
              p.event.remove(this, e2, i2, t2);
            })
          );
        },
        trigger: function (e2, t2) {
          return this.each(function () {
            p.event.trigger(e2, t2, this);
          });
        },
        triggerHandler: function (e2, t2) {
          var i2 = this[0];
          if (i2) return p.event.trigger(e2, t2, i2, !0);
        },
      });
    var ee =
        /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,
      te = /<([\w:]+)/,
      ie = /<|&#?\w+;/,
      ne = /<(?:script|style|link)/i,
      se = /checked\s*(?:[^=]|=\s*.checked.)/i,
      ae = /^$|\/(?:java|ecma)script/i,
      re = /^true\/(.*)/,
      oe = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,
      le = {
        option: [1, "<select multiple='multiple'>", "</select>"],
        thead: [1, "<table>", "</table>"],
        col: [2, "<table><colgroup>", "</colgroup></table>"],
        tr: [2, "<table><tbody>", "</tbody></table>"],
        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
        _default: [0, "", ""],
      };
    function ce(e2, t2) {
      return p.nodeName(e2, "table") &&
        p.nodeName(t2.nodeType !== 11 ? t2 : t2.firstChild, "tr")
        ? e2.getElementsByTagName("tbody")[0] ||
            e2.appendChild(e2.ownerDocument.createElement("tbody"))
        : e2;
    }
    function ue(e2) {
      return (e2.type = (e2.getAttribute("type") !== null) + "/" + e2.type), e2;
    }
    function de(e2) {
      var t2 = re.exec(e2.type);
      return t2 ? (e2.type = t2[1]) : e2.removeAttribute("type"), e2;
    }
    function he(e2, t2) {
      for (var i2 = 0, n2 = e2.length; i2 < n2; i2++)
        O.set(e2[i2], "globalEval", !t2 || O.get(t2[i2], "globalEval"));
    }
    function pe(e2, t2) {
      var i2, n2, s2, a2, r2, o2, l2, c2;
      if (t2.nodeType === 1) {
        if (
          O.hasData(e2) &&
          ((a2 = O.access(e2)), (r2 = O.set(t2, a2)), (c2 = a2.events))
        )
          for (s2 in (delete r2.handle, (r2.events = {}), c2))
            for (i2 = 0, n2 = c2[s2].length; i2 < n2; i2++)
              p.event.add(t2, s2, c2[s2][i2]);
        B.hasData(e2) &&
          ((o2 = B.access(e2)), (l2 = p.extend({}, o2)), B.set(t2, l2));
      }
    }
    function fe(e2, t2) {
      var i2 = e2.getElementsByTagName
        ? e2.getElementsByTagName(t2 || "*")
        : e2.querySelectorAll
        ? e2.querySelectorAll(t2 || "*")
        : [];
      return t2 === void 0 || (t2 && p.nodeName(e2, t2))
        ? p.merge([e2], i2)
        : i2;
    }
    (le.optgroup = le.option),
      (le.tbody = le.tfoot = le.colgroup = le.caption = le.thead),
      (le.th = le.td),
      p.extend({
        clone: function (e2, t2, i2) {
          var n2,
            s2,
            a2,
            r2,
            o2,
            l2,
            c2,
            d2 = e2.cloneNode(!0),
            h2 = p.contains(e2.ownerDocument, e2);
          if (
            !(
              u.noCloneChecked ||
              (e2.nodeType !== 1 && e2.nodeType !== 11) ||
              p.isXMLDoc(e2)
            )
          )
            for (r2 = fe(d2), n2 = 0, s2 = (a2 = fe(e2)).length; n2 < s2; n2++)
              (o2 = a2[n2]),
                (l2 = r2[n2]),
                (c2 = void 0),
                (c2 = l2.nodeName.toLowerCase()) === "input" && X.test(o2.type)
                  ? (l2.checked = o2.checked)
                  : (c2 !== "input" && c2 !== "textarea") ||
                    (l2.defaultValue = o2.defaultValue);
          if (t2)
            if (i2)
              for (
                a2 = a2 || fe(e2), r2 = r2 || fe(d2), n2 = 0, s2 = a2.length;
                n2 < s2;
                n2++
              )
                pe(a2[n2], r2[n2]);
            else pe(e2, d2);
          return (
            (r2 = fe(d2, "script")).length > 0 &&
              he(r2, !h2 && fe(e2, "script")),
            d2
          );
        },
        buildFragment: function (e2, t2, i2, n2) {
          for (
            var s2,
              a2,
              r2,
              o2,
              l2,
              c2,
              u2 = t2.createDocumentFragment(),
              d2 = [],
              h2 = 0,
              f2 = e2.length;
            h2 < f2;
            h2++
          )
            if ((s2 = e2[h2]) || s2 === 0)
              if (p.type(s2) === "object") p.merge(d2, s2.nodeType ? [s2] : s2);
              else if (ie.test(s2)) {
                for (
                  a2 = a2 || u2.appendChild(t2.createElement("div")),
                    r2 = (te.exec(s2) || ["", ""])[1].toLowerCase(),
                    o2 = le[r2] || le._default,
                    a2.innerHTML = o2[1] + s2.replace(ee, "<$1></$2>") + o2[2],
                    c2 = o2[0];
                  c2--;

                )
                  a2 = a2.lastChild;
                p.merge(d2, a2.childNodes),
                  ((a2 = u2.firstChild).textContent = "");
              } else d2.push(t2.createTextNode(s2));
          for (u2.textContent = "", h2 = 0; (s2 = d2[h2++]); )
            if (
              (!n2 || p.inArray(s2, n2) === -1) &&
              ((l2 = p.contains(s2.ownerDocument, s2)),
              (a2 = fe(u2.appendChild(s2), "script")),
              l2 && he(a2),
              i2)
            )
              for (c2 = 0; (s2 = a2[c2++]); )
                ae.test(s2.type || "") && i2.push(s2);
          return u2;
        },
        cleanData: function (e2) {
          for (
            var t2, i2, n2, s2, a2 = p.event.special, r2 = 0;
            (i2 = e2[r2]) !== void 0;
            r2++
          ) {
            if (
              p.acceptData(i2) &&
              (s2 = i2[O.expando]) &&
              (t2 = O.cache[s2])
            ) {
              if (t2.events)
                for (n2 in t2.events)
                  a2[n2]
                    ? p.event.remove(i2, n2)
                    : p.removeEvent(i2, n2, t2.handle);
              O.cache[s2] && delete O.cache[s2];
            }
            delete B.cache[i2[B.expando]];
          }
        },
      }),
      p.fn.extend({
        text: function (e2) {
          return A(
            this,
            function (e3) {
              return e3 === void 0
                ? p.text(this)
                : this.empty().each(function () {
                    (this.nodeType !== 1 &&
                      this.nodeType !== 11 &&
                      this.nodeType !== 9) ||
                      (this.textContent = e3);
                  });
            },
            null,
            e2,
            arguments.length
          );
        },
        append: function () {
          return this.domManip(arguments, function (e2) {
            (this.nodeType !== 1 &&
              this.nodeType !== 11 &&
              this.nodeType !== 9) ||
              ce(this, e2).appendChild(e2);
          });
        },
        prepend: function () {
          return this.domManip(arguments, function (e2) {
            if (
              this.nodeType === 1 ||
              this.nodeType === 11 ||
              this.nodeType === 9
            ) {
              var t2 = ce(this, e2);
              t2.insertBefore(e2, t2.firstChild);
            }
          });
        },
        before: function () {
          return this.domManip(arguments, function (e2) {
            this.parentNode && this.parentNode.insertBefore(e2, this);
          });
        },
        after: function () {
          return this.domManip(arguments, function (e2) {
            this.parentNode &&
              this.parentNode.insertBefore(e2, this.nextSibling);
          });
        },
        remove: function (e2, t2) {
          for (
            var i2, n2 = e2 ? p.filter(e2, this) : this, s2 = 0;
            (i2 = n2[s2]) != null;
            s2++
          )
            t2 || i2.nodeType !== 1 || p.cleanData(fe(i2)),
              i2.parentNode &&
                (t2 && p.contains(i2.ownerDocument, i2) && he(fe(i2, "script")),
                i2.parentNode.removeChild(i2));
          return this;
        },
        empty: function () {
          for (var e2, t2 = 0; (e2 = this[t2]) != null; t2++)
            e2.nodeType === 1 &&
              (p.cleanData(fe(e2, !1)), (e2.textContent = ""));
          return this;
        },
        clone: function (e2, t2) {
          return (
            (e2 = e2 != null && e2),
            (t2 = t2 ?? e2),
            this.map(function () {
              return p.clone(this, e2, t2);
            })
          );
        },
        html: function (e2) {
          return A(
            this,
            function (e3) {
              var t2 = this[0] || {},
                i2 = 0,
                n2 = this.length;
              if (e3 === void 0 && t2.nodeType === 1) return t2.innerHTML;
              if (
                typeof e3 == "string" &&
                !ne.test(e3) &&
                !le[(te.exec(e3) || ["", ""])[1].toLowerCase()]
              ) {
                e3 = e3.replace(ee, "<$1></$2>");
                try {
                  for (; i2 < n2; i2++)
                    (t2 = this[i2] || {}).nodeType === 1 &&
                      (p.cleanData(fe(t2, !1)), (t2.innerHTML = e3));
                  t2 = 0;
                } catch {}
              }
              t2 && this.empty().append(e3);
            },
            null,
            e2,
            arguments.length
          );
        },
        replaceWith: function () {
          var e2 = arguments[0];
          return (
            this.domManip(arguments, function (t2) {
              (e2 = this.parentNode),
                p.cleanData(fe(this)),
                e2 && e2.replaceChild(t2, this);
            }),
            e2 && (e2.length || e2.nodeType) ? this : this.remove()
          );
        },
        detach: function (e2) {
          return this.remove(e2, !0);
        },
        domManip: function (e2, t2) {
          e2 = s.apply([], e2);
          var i2,
            n2,
            a2,
            r2,
            o2,
            l2,
            c2 = 0,
            d2 = this.length,
            h2 = this,
            f2 = d2 - 1,
            v2 = e2[0],
            m2 = p.isFunction(v2);
          if (
            m2 ||
            (d2 > 1 && typeof v2 == "string" && !u.checkClone && se.test(v2))
          )
            return this.each(function (i3) {
              var n3 = h2.eq(i3);
              m2 && (e2[0] = v2.call(this, i3, n3.html())), n3.domManip(e2, t2);
            });
          if (
            d2 &&
            ((n2 = (i2 = p.buildFragment(e2, this[0].ownerDocument, !1, this))
              .firstChild),
            i2.childNodes.length === 1 && (i2 = n2),
            n2)
          ) {
            for (r2 = (a2 = p.map(fe(i2, "script"), ue)).length; c2 < d2; c2++)
              (o2 = i2),
                c2 !== f2 &&
                  ((o2 = p.clone(o2, !0, !0)),
                  r2 && p.merge(a2, fe(o2, "script"))),
                t2.call(this[c2], o2, c2);
            if (r2)
              for (
                l2 = a2[a2.length - 1].ownerDocument, p.map(a2, de), c2 = 0;
                c2 < r2;
                c2++
              )
                (o2 = a2[c2]),
                  ae.test(o2.type || "") &&
                    !O.access(o2, "globalEval") &&
                    p.contains(l2, o2) &&
                    (o2.src
                      ? p._evalUrl && p._evalUrl(o2.src)
                      : p.globalEval(o2.textContent.replace(oe, "")));
          }
          return this;
        },
      }),
      p.each(
        {
          appendTo: "append",
          prependTo: "prepend",
          insertBefore: "before",
          insertAfter: "after",
          replaceAll: "replaceWith",
        },
        function (e2, t2) {
          p.fn[e2] = function (e3) {
            for (
              var i2, n2 = [], s2 = p(e3), r2 = s2.length - 1, o2 = 0;
              o2 <= r2;
              o2++
            )
              (i2 = o2 === r2 ? this : this.clone(!0)),
                p(s2[o2])[t2](i2),
                a.apply(n2, i2.get());
            return this.pushStack(n2);
          };
        }
      );
    var ve,
      me = {};
    function ge(t2, i2) {
      var n2,
        s2 = p(i2.createElement(t2)).appendTo(i2.body),
        a2 =
          e.getDefaultComputedStyle && (n2 = e.getDefaultComputedStyle(s2[0]))
            ? n2.display
            : p.css(s2[0], "display");
      return s2.detach(), a2;
    }
    function ye(e2) {
      var t2 = d,
        i2 = me[e2];
      return (
        i2 ||
          (((i2 = ge(e2, t2)) !== "none" && i2) ||
            ((t2 = (ve = (
              ve || p("<iframe frameborder='0' width='0' height='0'/>")
            ).appendTo(t2.documentElement))[0].contentDocument).write(),
            t2.close(),
            (i2 = ge(e2, t2)),
            ve.detach()),
          (me[e2] = i2)),
        i2
      );
    }
    var be = /^margin/,
      we = new RegExp("^(" + V + ")(?!px)[a-z%]+$", "i"),
      Se = function (t2) {
        return t2.ownerDocument.defaultView.opener
          ? t2.ownerDocument.defaultView.getComputedStyle(t2, null)
          : e.getComputedStyle(t2, null);
      };
    function xe(e2, t2, i2) {
      var n2,
        s2,
        a2,
        r2,
        o2 = e2.style;
      return (
        (i2 = i2 || Se(e2)) && (r2 = i2.getPropertyValue(t2) || i2[t2]),
        i2 &&
          (r2 !== "" ||
            p.contains(e2.ownerDocument, e2) ||
            (r2 = p.style(e2, t2)),
          we.test(r2) &&
            be.test(t2) &&
            ((n2 = o2.width),
            (s2 = o2.minWidth),
            (a2 = o2.maxWidth),
            (o2.minWidth = o2.maxWidth = o2.width = r2),
            (r2 = i2.width),
            (o2.width = n2),
            (o2.minWidth = s2),
            (o2.maxWidth = a2))),
        r2 !== void 0 ? r2 + "" : r2
      );
    }
    function Ce(e2, t2) {
      return {
        get: function () {
          if (!e2()) return (this.get = t2).apply(this, arguments);
          delete this.get;
        },
      };
    }
    (function () {
      var t2,
        i2,
        n2 = d.documentElement,
        s2 = d.createElement("div"),
        a2 = d.createElement("div");
      function r2() {
        (a2.style.cssText =
          "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;display:block;margin-top:1%;top:1%;border:1px;padding:1px;width:4px;position:absolute"),
          (a2.innerHTML = ""),
          n2.appendChild(s2);
        var r3 = e.getComputedStyle(a2, null);
        (t2 = r3.top !== "1%"), (i2 = r3.width === "4px"), n2.removeChild(s2);
      }
      a2.style &&
        ((a2.style.backgroundClip = "content-box"),
        (a2.cloneNode(!0).style.backgroundClip = ""),
        (u.clearCloneStyle = a2.style.backgroundClip === "content-box"),
        (s2.style.cssText =
          "border:0;width:0;height:0;top:0;left:-9999px;margin-top:1px;position:absolute"),
        s2.appendChild(a2),
        e.getComputedStyle &&
          p.extend(u, {
            pixelPosition: function () {
              return r2(), t2;
            },
            boxSizingReliable: function () {
              return i2 == null && r2(), i2;
            },
            reliableMarginRight: function () {
              var t3,
                i3 = a2.appendChild(d.createElement("div"));
              return (
                (i3.style.cssText = a2.style.cssText =
                  "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0"),
                (i3.style.marginRight = i3.style.width = "0"),
                (a2.style.width = "1px"),
                n2.appendChild(s2),
                (t3 = !parseFloat(e.getComputedStyle(i3, null).marginRight)),
                n2.removeChild(s2),
                a2.removeChild(i3),
                t3
              );
            },
          }));
    })(),
      (p.swap = function (e2, t2, i2, n2) {
        var s2,
          a2,
          r2 = {};
        for (a2 in t2) (r2[a2] = e2.style[a2]), (e2.style[a2] = t2[a2]);
        for (a2 in ((s2 = i2.apply(e2, n2 || [])), t2)) e2.style[a2] = r2[a2];
        return s2;
      });
    var ke = /^(none|table(?!-c[ea]).+)/,
      Ee = new RegExp("^(" + V + ")(.*)$", "i"),
      Te = new RegExp("^([+-])=(" + V + ")", "i"),
      _e = { position: "absolute", visibility: "hidden", display: "block" },
      Me = { letterSpacing: "0", fontWeight: "400" },
      Le = ["Webkit", "O", "Moz", "ms"];
    function Pe(e2, t2) {
      if (t2 in e2) return t2;
      for (
        var i2 = t2[0].toUpperCase() + t2.slice(1), n2 = t2, s2 = Le.length;
        s2--;

      )
        if ((t2 = Le[s2] + i2) in e2) return t2;
      return n2;
    }
    function Ie(e2, t2, i2) {
      var n2 = Ee.exec(t2);
      return n2 ? Math.max(0, n2[1] - (i2 || 0)) + (n2[2] || "px") : t2;
    }
    function De(e2, t2, i2, n2, s2) {
      for (
        var a2 =
            i2 === (n2 ? "border" : "content") ? 4 : t2 === "width" ? 1 : 0,
          r2 = 0;
        a2 < 4;
        a2 += 2
      )
        i2 === "margin" && (r2 += p.css(e2, i2 + R[a2], !0, s2)),
          n2
            ? (i2 === "content" && (r2 -= p.css(e2, "padding" + R[a2], !0, s2)),
              i2 !== "margin" &&
                (r2 -= p.css(e2, "border" + R[a2] + "Width", !0, s2)))
            : ((r2 += p.css(e2, "padding" + R[a2], !0, s2)),
              i2 !== "padding" &&
                (r2 += p.css(e2, "border" + R[a2] + "Width", !0, s2)));
      return r2;
    }
    function Ae(e2, t2, i2) {
      var n2 = !0,
        s2 = t2 === "width" ? e2.offsetWidth : e2.offsetHeight,
        a2 = Se(e2),
        r2 = p.css(e2, "boxSizing", !1, a2) === "border-box";
      if (s2 <= 0 || s2 == null) {
        if (
          (((s2 = xe(e2, t2, a2)) < 0 || s2 == null) && (s2 = e2.style[t2]),
          we.test(s2))
        )
          return s2;
        (n2 = r2 && (u.boxSizingReliable() || s2 === e2.style[t2])),
          (s2 = parseFloat(s2) || 0);
      }
      return s2 + De(e2, t2, i2 || (r2 ? "border" : "content"), n2, a2) + "px";
    }
    function ze(e2, t2) {
      for (var i2, n2, s2, a2 = [], r2 = 0, o2 = e2.length; r2 < o2; r2++)
        (n2 = e2[r2]).style &&
          ((a2[r2] = O.get(n2, "olddisplay")),
          (i2 = n2.style.display),
          t2
            ? (a2[r2] || i2 !== "none" || (n2.style.display = ""),
              n2.style.display === "" &&
                j(n2) &&
                (a2[r2] = O.access(n2, "olddisplay", ye(n2.nodeName))))
            : ((s2 = j(n2)),
              (i2 === "none" && s2) ||
                O.set(n2, "olddisplay", s2 ? i2 : p.css(n2, "display"))));
      for (r2 = 0; r2 < o2; r2++)
        (n2 = e2[r2]).style &&
          ((t2 && n2.style.display !== "none" && n2.style.display !== "") ||
            (n2.style.display = t2 ? a2[r2] || "" : "none"));
      return e2;
    }
    function Oe(e2, t2, i2, n2, s2) {
      return new Oe.prototype.init(e2, t2, i2, n2, s2);
    }
    p.extend({
      cssHooks: {
        opacity: {
          get: function (e2, t2) {
            if (t2) {
              var i2 = xe(e2, "opacity");
              return i2 === "" ? "1" : i2;
            }
          },
        },
      },
      cssNumber: {
        columnCount: !0,
        fillOpacity: !0,
        flexGrow: !0,
        flexShrink: !0,
        fontWeight: !0,
        lineHeight: !0,
        opacity: !0,
        order: !0,
        orphans: !0,
        widows: !0,
        zIndex: !0,
        zoom: !0,
      },
      cssProps: { float: "cssFloat" },
      style: function (e2, t2, i2, n2) {
        if (e2 && e2.nodeType !== 3 && e2.nodeType !== 8 && e2.style) {
          var s2,
            a2,
            r2,
            o2 = p.camelCase(t2),
            l2 = e2.style;
          if (
            ((t2 = p.cssProps[o2] || (p.cssProps[o2] = Pe(l2, o2))),
            (r2 = p.cssHooks[t2] || p.cssHooks[o2]),
            i2 === void 0)
          )
            return r2 && "get" in r2 && (s2 = r2.get(e2, !1, n2)) !== void 0
              ? s2
              : l2[t2];
          (a2 = typeof i2) == "string" &&
            (s2 = Te.exec(i2)) &&
            ((i2 = (s2[1] + 1) * s2[2] + parseFloat(p.css(e2, t2))),
            (a2 = "number")),
            i2 != null &&
              i2 == i2 &&
              (a2 !== "number" || p.cssNumber[o2] || (i2 += "px"),
              u.clearCloneStyle ||
                i2 !== "" ||
                t2.indexOf("background") !== 0 ||
                (l2[t2] = "inherit"),
              (r2 && "set" in r2 && (i2 = r2.set(e2, i2, n2)) === void 0) ||
                (l2[t2] = i2));
        }
      },
      css: function (e2, t2, i2, n2) {
        var s2,
          a2,
          r2,
          o2 = p.camelCase(t2);
        return (
          (t2 = p.cssProps[o2] || (p.cssProps[o2] = Pe(e2.style, o2))),
          (r2 = p.cssHooks[t2] || p.cssHooks[o2]) &&
            "get" in r2 &&
            (s2 = r2.get(e2, !0, i2)),
          s2 === void 0 && (s2 = xe(e2, t2, n2)),
          s2 === "normal" && t2 in Me && (s2 = Me[t2]),
          i2 === "" || i2
            ? ((a2 = parseFloat(s2)),
              i2 === !0 || p.isNumeric(a2) ? a2 || 0 : s2)
            : s2
        );
      },
    }),
      p.each(["height", "width"], function (e2, t2) {
        p.cssHooks[t2] = {
          get: function (e3, i2, n2) {
            if (i2)
              return ke.test(p.css(e3, "display")) && e3.offsetWidth === 0
                ? p.swap(e3, _e, function () {
                    return Ae(e3, t2, n2);
                  })
                : Ae(e3, t2, n2);
          },
          set: function (e3, i2, n2) {
            var s2 = n2 && Se(e3);
            return Ie(
              0,
              i2,
              n2
                ? De(
                    e3,
                    t2,
                    n2,
                    p.css(e3, "boxSizing", !1, s2) === "border-box",
                    s2
                  )
                : 0
            );
          },
        };
      }),
      (p.cssHooks.marginRight = Ce(u.reliableMarginRight, function (e2, t2) {
        if (t2)
          return p.swap(e2, { display: "inline-block" }, xe, [
            e2,
            "marginRight",
          ]);
      })),
      p.each({ margin: "", padding: "", border: "Width" }, function (e2, t2) {
        (p.cssHooks[e2 + t2] = {
          expand: function (i2) {
            for (
              var n2 = 0,
                s2 = {},
                a2 = typeof i2 == "string" ? i2.split(" ") : [i2];
              n2 < 4;
              n2++
            )
              s2[e2 + R[n2] + t2] = a2[n2] || a2[n2 - 2] || a2[0];
            return s2;
          },
        }),
          be.test(e2) || (p.cssHooks[e2 + t2].set = Ie);
      }),
      p.fn.extend({
        css: function (e2, t2) {
          return A(
            this,
            function (e3, t3, i2) {
              var n2,
                s2,
                a2 = {},
                r2 = 0;
              if (p.isArray(t3)) {
                for (n2 = Se(e3), s2 = t3.length; r2 < s2; r2++)
                  a2[t3[r2]] = p.css(e3, t3[r2], !1, n2);
                return a2;
              }
              return i2 !== void 0 ? p.style(e3, t3, i2) : p.css(e3, t3);
            },
            e2,
            t2,
            arguments.length > 1
          );
        },
        show: function () {
          return ze(this, !0);
        },
        hide: function () {
          return ze(this);
        },
        toggle: function (e2) {
          return typeof e2 == "boolean"
            ? e2
              ? this.show()
              : this.hide()
            : this.each(function () {
                j(this) ? p(this).show() : p(this).hide();
              });
        },
      }),
      (p.Tween = Oe),
      (Oe.prototype = {
        constructor: Oe,
        init: function (e2, t2, i2, n2, s2, a2) {
          (this.elem = e2),
            (this.prop = i2),
            (this.easing = s2 || "swing"),
            (this.options = t2),
            (this.start = this.now = this.cur()),
            (this.end = n2),
            (this.unit = a2 || (p.cssNumber[i2] ? "" : "px"));
        },
        cur: function () {
          var e2 = Oe.propHooks[this.prop];
          return e2 && e2.get ? e2.get(this) : Oe.propHooks._default.get(this);
        },
        run: function (e2) {
          var t2,
            i2 = Oe.propHooks[this.prop];
          return (
            this.options.duration
              ? (this.pos = t2 =
                  p.easing[this.easing](
                    e2,
                    this.options.duration * e2,
                    0,
                    1,
                    this.options.duration
                  ))
              : (this.pos = t2 = e2),
            (this.now = (this.end - this.start) * t2 + this.start),
            this.options.step &&
              this.options.step.call(this.elem, this.now, this),
            i2 && i2.set ? i2.set(this) : Oe.propHooks._default.set(this),
            this
          );
        },
      }),
      (Oe.prototype.init.prototype = Oe.prototype),
      (Oe.propHooks = {
        _default: {
          get: function (e2) {
            var t2;
            return e2.elem[e2.prop] == null ||
              (e2.elem.style && e2.elem.style[e2.prop] != null)
              ? (t2 = p.css(e2.elem, e2.prop, "")) && t2 !== "auto"
                ? t2
                : 0
              : e2.elem[e2.prop];
          },
          set: function (e2) {
            p.fx.step[e2.prop]
              ? p.fx.step[e2.prop](e2)
              : e2.elem.style &&
                (e2.elem.style[p.cssProps[e2.prop]] != null ||
                  p.cssHooks[e2.prop])
              ? p.style(e2.elem, e2.prop, e2.now + e2.unit)
              : (e2.elem[e2.prop] = e2.now);
          },
        },
      }),
      (Oe.propHooks.scrollTop = Oe.propHooks.scrollLeft =
        {
          set: function (e2) {
            e2.elem.nodeType &&
              e2.elem.parentNode &&
              (e2.elem[e2.prop] = e2.now);
          },
        }),
      (p.easing = {
        linear: function (e2) {
          return e2;
        },
        swing: function (e2) {
          return 0.5 - Math.cos(e2 * Math.PI) / 2;
        },
      }),
      (p.fx = Oe.prototype.init),
      (p.fx.step = {});
    var Be,
      Ne,
      qe = /^(?:toggle|show|hide)$/,
      $e = new RegExp("^(?:([+-])=|)(" + V + ")([a-z%]*)$", "i"),
      He = /queueHooks$/,
      Fe = [
        function (e2, t2, i2) {
          var n2,
            s2,
            a2,
            r2,
            o2,
            l2,
            c2,
            u2 = this,
            d2 = {},
            h2 = e2.style,
            f2 = e2.nodeType && j(e2),
            v2 = O.get(e2, "fxshow");
          i2.queue ||
            ((o2 = p._queueHooks(e2, "fx")).unqueued == null &&
              ((o2.unqueued = 0),
              (l2 = o2.empty.fire),
              (o2.empty.fire = function () {
                o2.unqueued || l2();
              })),
            o2.unqueued++,
            u2.always(function () {
              u2.always(function () {
                o2.unqueued--, p.queue(e2, "fx").length || o2.empty.fire();
              });
            })),
            e2.nodeType === 1 &&
              ("height" in t2 || "width" in t2) &&
              ((i2.overflow = [h2.overflow, h2.overflowX, h2.overflowY]),
              ((c2 = p.css(e2, "display")) === "none"
                ? O.get(e2, "olddisplay") || ye(e2.nodeName)
                : c2) === "inline" &&
                p.css(e2, "float") === "none" &&
                (h2.display = "inline-block")),
            i2.overflow &&
              ((h2.overflow = "hidden"),
              u2.always(function () {
                (h2.overflow = i2.overflow[0]),
                  (h2.overflowX = i2.overflow[1]),
                  (h2.overflowY = i2.overflow[2]);
              }));
          for (n2 in t2)
            if (((s2 = t2[n2]), qe.exec(s2))) {
              if (
                (delete t2[n2],
                (a2 = a2 || s2 === "toggle"),
                s2 === (f2 ? "hide" : "show"))
              ) {
                if (s2 !== "show" || !v2 || v2[n2] === void 0) continue;
                f2 = !0;
              }
              d2[n2] = (v2 && v2[n2]) || p.style(e2, n2);
            } else c2 = void 0;
          if (p.isEmptyObject(d2))
            (c2 === "none" ? ye(e2.nodeName) : c2) === "inline" &&
              (h2.display = c2);
          else
            for (n2 in (v2
              ? "hidden" in v2 && (f2 = v2.hidden)
              : (v2 = O.access(e2, "fxshow", {})),
            a2 && (v2.hidden = !f2),
            f2
              ? p(e2).show()
              : u2.done(function () {
                  p(e2).hide();
                }),
            u2.done(function () {
              var t3;
              for (t3 in (O.remove(e2, "fxshow"), d2)) p.style(e2, t3, d2[t3]);
            }),
            d2))
              (r2 = Xe(f2 ? v2[n2] : 0, n2, u2)),
                n2 in v2 ||
                  ((v2[n2] = r2.start),
                  f2 &&
                    ((r2.end = r2.start),
                    (r2.start = n2 === "width" || n2 === "height" ? 1 : 0)));
        },
      ],
      Ve = {
        "*": [
          function (e2, t2) {
            var i2 = this.createTween(e2, t2),
              n2 = i2.cur(),
              s2 = $e.exec(t2),
              a2 = (s2 && s2[3]) || (p.cssNumber[e2] ? "" : "px"),
              r2 =
                (p.cssNumber[e2] || (a2 !== "px" && +n2)) &&
                $e.exec(p.css(i2.elem, e2)),
              o2 = 1,
              l2 = 20;
            if (r2 && r2[3] !== a2) {
              (a2 = a2 || r2[3]), (s2 = s2 || []), (r2 = +n2 || 1);
              do (r2 /= o2 = o2 || ".5"), p.style(i2.elem, e2, r2 + a2);
              while (o2 !== (o2 = i2.cur() / n2) && o2 !== 1 && --l2);
            }
            return (
              s2 &&
                ((r2 = i2.start = +r2 || +n2 || 0),
                (i2.unit = a2),
                (i2.end = s2[1] ? r2 + (s2[1] + 1) * s2[2] : +s2[2])),
              i2
            );
          },
        ],
      };
    function Re() {
      return (
        setTimeout(function () {
          Be = void 0;
        }),
        (Be = p.now())
      );
    }
    function je(e2, t2) {
      var i2,
        n2 = 0,
        s2 = { height: e2 };
      for (t2 = t2 ? 1 : 0; n2 < 4; n2 += 2 - t2)
        s2["margin" + (i2 = R[n2])] = s2["padding" + i2] = e2;
      return t2 && (s2.opacity = s2.width = e2), s2;
    }
    function Xe(e2, t2, i2) {
      for (
        var n2, s2 = (Ve[t2] || []).concat(Ve["*"]), a2 = 0, r2 = s2.length;
        a2 < r2;
        a2++
      )
        if ((n2 = s2[a2].call(i2, t2, e2))) return n2;
    }
    function Ge(e2, t2, i2) {
      var n2,
        s2,
        a2 = 0,
        r2 = Fe.length,
        o2 = p.Deferred().always(function () {
          delete l2.elem;
        }),
        l2 = function () {
          if (s2) return !1;
          for (
            var t3 = Be || Re(),
              i3 = Math.max(0, c2.startTime + c2.duration - t3),
              n3 = 1 - (i3 / c2.duration || 0),
              a3 = 0,
              r3 = c2.tweens.length;
            a3 < r3;
            a3++
          )
            c2.tweens[a3].run(n3);
          return (
            o2.notifyWith(e2, [c2, n3, i3]),
            n3 < 1 && r3 ? i3 : (o2.resolveWith(e2, [c2]), !1)
          );
        },
        c2 = o2.promise({
          elem: e2,
          props: p.extend({}, t2),
          opts: p.extend(!0, { specialEasing: {} }, i2),
          originalProperties: t2,
          originalOptions: i2,
          startTime: Be || Re(),
          duration: i2.duration,
          tweens: [],
          createTween: function (t3, i3) {
            var n3 = p.Tween(
              e2,
              c2.opts,
              t3,
              i3,
              c2.opts.specialEasing[t3] || c2.opts.easing
            );
            return c2.tweens.push(n3), n3;
          },
          stop: function (t3) {
            var i3 = 0,
              n3 = t3 ? c2.tweens.length : 0;
            if (s2) return this;
            for (s2 = !0; i3 < n3; i3++) c2.tweens[i3].run(1);
            return (
              t3 ? o2.resolveWith(e2, [c2, t3]) : o2.rejectWith(e2, [c2, t3]),
              this
            );
          },
        }),
        u2 = c2.props;
      for (
        !(function (e3, t3) {
          var i3, n3, s3, a3, r3;
          for (i3 in e3)
            if (
              ((s3 = t3[(n3 = p.camelCase(i3))]),
              (a3 = e3[i3]),
              p.isArray(a3) && ((s3 = a3[1]), (a3 = e3[i3] = a3[0])),
              i3 !== n3 && ((e3[n3] = a3), delete e3[i3]),
              (r3 = p.cssHooks[n3]) && ("expand" in r3))
            )
              for (i3 in ((a3 = r3.expand(a3)), delete e3[n3], a3))
                (i3 in e3) || ((e3[i3] = a3[i3]), (t3[i3] = s3));
            else t3[n3] = s3;
        })(u2, c2.opts.specialEasing);
        a2 < r2;
        a2++
      )
        if ((n2 = Fe[a2].call(c2, e2, u2, c2.opts))) return n2;
      return (
        p.map(u2, Xe, c2),
        p.isFunction(c2.opts.start) && c2.opts.start.call(e2, c2),
        p.fx.timer(p.extend(l2, { elem: e2, anim: c2, queue: c2.opts.queue })),
        c2
          .progress(c2.opts.progress)
          .done(c2.opts.done, c2.opts.complete)
          .fail(c2.opts.fail)
          .always(c2.opts.always)
      );
    }
    (p.Animation = p.extend(Ge, {
      tweener: function (e2, t2) {
        p.isFunction(e2) ? ((t2 = e2), (e2 = ["*"])) : (e2 = e2.split(" "));
        for (var i2, n2 = 0, s2 = e2.length; n2 < s2; n2++)
          (i2 = e2[n2]), (Ve[i2] = Ve[i2] || []), Ve[i2].unshift(t2);
      },
      prefilter: function (e2, t2) {
        t2 ? Fe.unshift(e2) : Fe.push(e2);
      },
    })),
      (p.speed = function (e2, t2, i2) {
        var n2 =
          e2 && typeof e2 == "object"
            ? p.extend({}, e2)
            : {
                complete: i2 || (!i2 && t2) || (p.isFunction(e2) && e2),
                duration: e2,
                easing: (i2 && t2) || (t2 && !p.isFunction(t2) && t2),
              };
        return (
          (n2.duration = p.fx.off
            ? 0
            : typeof n2.duration == "number"
            ? n2.duration
            : n2.duration in p.fx.speeds
            ? p.fx.speeds[n2.duration]
            : p.fx.speeds._default),
          (n2.queue != null && n2.queue !== !0) || (n2.queue = "fx"),
          (n2.old = n2.complete),
          (n2.complete = function () {
            p.isFunction(n2.old) && n2.old.call(this),
              n2.queue && p.dequeue(this, n2.queue);
          }),
          n2
        );
      }),
      p.fn.extend({
        fadeTo: function (e2, t2, i2, n2) {
          return this.filter(j)
            .css("opacity", 0)
            .show()
            .end()
            .animate({ opacity: t2 }, e2, i2, n2);
        },
        animate: function (e2, t2, i2, n2) {
          var s2 = p.isEmptyObject(e2),
            a2 = p.speed(t2, i2, n2),
            r2 = function () {
              var t3 = Ge(this, p.extend({}, e2), a2);
              (s2 || O.get(this, "finish")) && t3.stop(!0);
            };
          return (
            (r2.finish = r2),
            s2 || a2.queue === !1 ? this.each(r2) : this.queue(a2.queue, r2)
          );
        },
        stop: function (e2, t2, i2) {
          var n2 = function (e3) {
            var t3 = e3.stop;
            delete e3.stop, t3(i2);
          };
          return (
            typeof e2 != "string" && ((i2 = t2), (t2 = e2), (e2 = void 0)),
            t2 && e2 !== !1 && this.queue(e2 || "fx", []),
            this.each(function () {
              var t3 = !0,
                s2 = e2 != null && e2 + "queueHooks",
                a2 = p.timers,
                r2 = O.get(this);
              if (s2) r2[s2] && r2[s2].stop && n2(r2[s2]);
              else
                for (s2 in r2)
                  r2[s2] && r2[s2].stop && He.test(s2) && n2(r2[s2]);
              for (s2 = a2.length; s2--; )
                a2[s2].elem !== this ||
                  (e2 != null && a2[s2].queue !== e2) ||
                  (a2[s2].anim.stop(i2), (t3 = !1), a2.splice(s2, 1));
              (!t3 && i2) || p.dequeue(this, e2);
            })
          );
        },
        finish: function (e2) {
          return (
            e2 !== !1 && (e2 = e2 || "fx"),
            this.each(function () {
              var t2,
                i2 = O.get(this),
                n2 = i2[e2 + "queue"],
                s2 = i2[e2 + "queueHooks"],
                a2 = p.timers,
                r2 = n2 ? n2.length : 0;
              for (
                i2.finish = !0,
                  p.queue(this, e2, []),
                  s2 && s2.stop && s2.stop.call(this, !0),
                  t2 = a2.length;
                t2--;

              )
                a2[t2].elem === this &&
                  a2[t2].queue === e2 &&
                  (a2[t2].anim.stop(!0), a2.splice(t2, 1));
              for (t2 = 0; t2 < r2; t2++)
                n2[t2] && n2[t2].finish && n2[t2].finish.call(this);
              delete i2.finish;
            })
          );
        },
      }),
      p.each(["toggle", "show", "hide"], function (e2, t2) {
        var i2 = p.fn[t2];
        p.fn[t2] = function (e3, n2, s2) {
          return e3 == null || typeof e3 == "boolean"
            ? i2.apply(this, arguments)
            : this.animate(je(t2, !0), e3, n2, s2);
        };
      }),
      p.each(
        {
          slideDown: je("show"),
          slideUp: je("hide"),
          slideToggle: je("toggle"),
          fadeIn: { opacity: "show" },
          fadeOut: { opacity: "hide" },
          fadeToggle: { opacity: "toggle" },
        },
        function (e2, t2) {
          p.fn[e2] = function (e3, i2, n2) {
            return this.animate(t2, e3, i2, n2);
          };
        }
      ),
      (p.timers = []),
      (p.fx.tick = function () {
        var e2,
          t2 = 0,
          i2 = p.timers;
        for (Be = p.now(); t2 < i2.length; t2++)
          (e2 = i2[t2])() || i2[t2] !== e2 || i2.splice(t2--, 1);
        i2.length || p.fx.stop(), (Be = void 0);
      }),
      (p.fx.timer = function (e2) {
        p.timers.push(e2), e2() ? p.fx.start() : p.timers.pop();
      }),
      (p.fx.interval = 13),
      (p.fx.start = function () {
        Ne || (Ne = setInterval(p.fx.tick, p.fx.interval));
      }),
      (p.fx.stop = function () {
        clearInterval(Ne), (Ne = null);
      }),
      (p.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
      (p.fn.delay = function (e2, t2) {
        return (
          (e2 = (p.fx && p.fx.speeds[e2]) || e2),
          (t2 = t2 || "fx"),
          this.queue(t2, function (t3, i2) {
            var n2 = setTimeout(t3, e2);
            i2.stop = function () {
              clearTimeout(n2);
            };
          })
        );
      }),
      (function () {
        var e2 = d.createElement("input"),
          t2 = d.createElement("select"),
          i2 = t2.appendChild(d.createElement("option"));
        (e2.type = "checkbox"),
          (u.checkOn = e2.value !== ""),
          (u.optSelected = i2.selected),
          (t2.disabled = !0),
          (u.optDisabled = !i2.disabled),
          ((e2 = d.createElement("input")).value = "t"),
          (e2.type = "radio"),
          (u.radioValue = e2.value === "t");
      })();
    var We,
      Ye = p.expr.attrHandle;
    p.fn.extend({
      attr: function (e2, t2) {
        return A(this, p.attr, e2, t2, arguments.length > 1);
      },
      removeAttr: function (e2) {
        return this.each(function () {
          p.removeAttr(this, e2);
        });
      },
    }),
      p.extend({
        attr: function (e2, t2, i2) {
          var n2,
            s2,
            a2 = e2.nodeType;
          if (e2 && a2 !== 3 && a2 !== 8 && a2 !== 2)
            return typeof e2.getAttribute === G
              ? p.prop(e2, t2, i2)
              : ((a2 === 1 && p.isXMLDoc(e2)) ||
                  ((t2 = t2.toLowerCase()),
                  (n2 =
                    p.attrHooks[t2] ||
                    (p.expr.match.bool.test(t2) ? We : void 0))),
                i2 === void 0
                  ? n2 && "get" in n2 && (s2 = n2.get(e2, t2)) !== null
                    ? s2
                    : (s2 = p.find.attr(e2, t2)) == null
                    ? void 0
                    : s2
                  : i2 !== null
                  ? n2 && "set" in n2 && (s2 = n2.set(e2, i2, t2)) !== void 0
                    ? s2
                    : (e2.setAttribute(t2, i2 + ""), i2)
                  : void p.removeAttr(e2, t2));
        },
        removeAttr: function (e2, t2) {
          var i2,
            n2,
            s2 = 0,
            a2 = t2 && t2.match(P);
          if (a2 && e2.nodeType === 1)
            for (; (i2 = a2[s2++]); )
              (n2 = p.propFix[i2] || i2),
                p.expr.match.bool.test(i2) && (e2[n2] = !1),
                e2.removeAttribute(i2);
        },
        attrHooks: {
          type: {
            set: function (e2, t2) {
              if (!u.radioValue && t2 === "radio" && p.nodeName(e2, "input")) {
                var i2 = e2.value;
                return e2.setAttribute("type", t2), i2 && (e2.value = i2), t2;
              }
            },
          },
        },
      }),
      (We = {
        set: function (e2, t2, i2) {
          return t2 === !1 ? p.removeAttr(e2, i2) : e2.setAttribute(i2, i2), i2;
        },
      }),
      p.each(p.expr.match.bool.source.match(/\w+/g), function (e2, t2) {
        var i2 = Ye[t2] || p.find.attr;
        Ye[t2] = function (e3, t3, n2) {
          var s2, a2;
          return (
            n2 ||
              ((a2 = Ye[t3]),
              (Ye[t3] = s2),
              (s2 = i2(e3, t3, n2) != null ? t3.toLowerCase() : null),
              (Ye[t3] = a2)),
            s2
          );
        };
      });
    var Ue = /^(?:input|select|textarea|button)$/i;
    p.fn.extend({
      prop: function (e2, t2) {
        return A(this, p.prop, e2, t2, arguments.length > 1);
      },
      removeProp: function (e2) {
        return this.each(function () {
          delete this[p.propFix[e2] || e2];
        });
      },
    }),
      p.extend({
        propFix: { for: "htmlFor", class: "className" },
        prop: function (e2, t2, i2) {
          var n2,
            s2,
            a2 = e2.nodeType;
          if (e2 && a2 !== 3 && a2 !== 8 && a2 !== 2)
            return (
              (a2 !== 1 || !p.isXMLDoc(e2)) &&
                ((t2 = p.propFix[t2] || t2), (s2 = p.propHooks[t2])),
              i2 !== void 0
                ? s2 && "set" in s2 && (n2 = s2.set(e2, i2, t2)) !== void 0
                  ? n2
                  : (e2[t2] = i2)
                : s2 && "get" in s2 && (n2 = s2.get(e2, t2)) !== null
                ? n2
                : e2[t2]
            );
        },
        propHooks: {
          tabIndex: {
            get: function (e2) {
              return e2.hasAttribute("tabindex") ||
                Ue.test(e2.nodeName) ||
                e2.href
                ? e2.tabIndex
                : -1;
            },
          },
        },
      }),
      u.optSelected ||
        (p.propHooks.selected = {
          get: function (e2) {
            var t2 = e2.parentNode;
            return t2 && t2.parentNode && t2.parentNode.selectedIndex, null;
          },
        }),
      p.each(
        [
          "tabIndex",
          "readOnly",
          "maxLength",
          "cellSpacing",
          "cellPadding",
          "rowSpan",
          "colSpan",
          "useMap",
          "frameBorder",
          "contentEditable",
        ],
        function () {
          p.propFix[this.toLowerCase()] = this;
        }
      );
    var Ke = /[\t\r\n\f]/g;
    p.fn.extend({
      addClass: function (e2) {
        var t2,
          i2,
          n2,
          s2,
          a2,
          r2,
          o2 = typeof e2 == "string" && e2,
          l2 = 0,
          c2 = this.length;
        if (p.isFunction(e2))
          return this.each(function (t3) {
            p(this).addClass(e2.call(this, t3, this.className));
          });
        if (o2) {
          for (t2 = (e2 || "").match(P) || []; l2 < c2; l2++)
            if (
              (n2 =
                (i2 = this[l2]).nodeType === 1 &&
                (i2.className
                  ? (" " + i2.className + " ").replace(Ke, " ")
                  : " "))
            ) {
              for (a2 = 0; (s2 = t2[a2++]); )
                n2.indexOf(" " + s2 + " ") < 0 && (n2 += s2 + " ");
              (r2 = p.trim(n2)), i2.className !== r2 && (i2.className = r2);
            }
        }
        return this;
      },
      removeClass: function (e2) {
        var t2,
          i2,
          n2,
          s2,
          a2,
          r2,
          o2 = arguments.length === 0 || (typeof e2 == "string" && e2),
          l2 = 0,
          c2 = this.length;
        if (p.isFunction(e2))
          return this.each(function (t3) {
            p(this).removeClass(e2.call(this, t3, this.className));
          });
        if (o2) {
          for (t2 = (e2 || "").match(P) || []; l2 < c2; l2++)
            if (
              (n2 =
                (i2 = this[l2]).nodeType === 1 &&
                (i2.className
                  ? (" " + i2.className + " ").replace(Ke, " ")
                  : ""))
            ) {
              for (a2 = 0; (s2 = t2[a2++]); )
                for (; n2.indexOf(" " + s2 + " ") >= 0; )
                  n2 = n2.replace(" " + s2 + " ", " ");
              (r2 = e2 ? p.trim(n2) : ""),
                i2.className !== r2 && (i2.className = r2);
            }
        }
        return this;
      },
      toggleClass: function (e2, t2) {
        var i2 = typeof e2;
        return typeof t2 == "boolean" && i2 === "string"
          ? t2
            ? this.addClass(e2)
            : this.removeClass(e2)
          : p.isFunction(e2)
          ? this.each(function (i3) {
              p(this).toggleClass(e2.call(this, i3, this.className, t2), t2);
            })
          : this.each(function () {
              if (i2 === "string")
                for (
                  var t3, n2 = 0, s2 = p(this), a2 = e2.match(P) || [];
                  (t3 = a2[n2++]);

                )
                  s2.hasClass(t3) ? s2.removeClass(t3) : s2.addClass(t3);
              else
                (i2 !== G && i2 !== "boolean") ||
                  (this.className &&
                    O.set(this, "__className__", this.className),
                  (this.className =
                    this.className || e2 === !1
                      ? ""
                      : O.get(this, "__className__") || ""));
            });
      },
      hasClass: function (e2) {
        for (var t2 = " " + e2 + " ", i2 = 0, n2 = this.length; i2 < n2; i2++)
          if (
            this[i2].nodeType === 1 &&
            (" " + this[i2].className + " ").replace(Ke, " ").indexOf(t2) >= 0
          )
            return !0;
        return !1;
      },
    });
    var Qe = /\r/g;
    p.fn.extend({
      val: function (e2) {
        var t2,
          i2,
          n2,
          s2 = this[0];
        return arguments.length
          ? ((n2 = p.isFunction(e2)),
            this.each(function (i3) {
              var s3;
              this.nodeType === 1 &&
                ((s3 = n2 ? e2.call(this, i3, p(this).val()) : e2) == null
                  ? (s3 = "")
                  : typeof s3 == "number"
                  ? (s3 += "")
                  : p.isArray(s3) &&
                    (s3 = p.map(s3, function (e3) {
                      return e3 == null ? "" : e3 + "";
                    })),
                ((t2 =
                  p.valHooks[this.type] ||
                  p.valHooks[this.nodeName.toLowerCase()]) &&
                  "set" in t2 &&
                  t2.set(this, s3, "value") !== void 0) ||
                  (this.value = s3));
            }))
          : s2
          ? (t2 =
              p.valHooks[s2.type] || p.valHooks[s2.nodeName.toLowerCase()]) &&
            "get" in t2 &&
            (i2 = t2.get(s2, "value")) !== void 0
            ? i2
            : typeof (i2 = s2.value) == "string"
            ? i2.replace(Qe, "")
            : i2 ?? ""
          : void 0;
      },
    }),
      p.extend({
        valHooks: {
          option: {
            get: function (e2) {
              var t2 = p.find.attr(e2, "value");
              return t2 ?? p.trim(p.text(e2));
            },
          },
          select: {
            get: function (e2) {
              for (
                var t2,
                  i2,
                  n2 = e2.options,
                  s2 = e2.selectedIndex,
                  a2 = e2.type === "select-one" || s2 < 0,
                  r2 = a2 ? null : [],
                  o2 = a2 ? s2 + 1 : n2.length,
                  l2 = s2 < 0 ? o2 : a2 ? s2 : 0;
                l2 < o2;
                l2++
              )
                if (
                  ((i2 = n2[l2]).selected || l2 === s2) &&
                  (u.optDisabled
                    ? !i2.disabled
                    : i2.getAttribute("disabled") === null) &&
                  (!i2.parentNode.disabled ||
                    !p.nodeName(i2.parentNode, "optgroup"))
                ) {
                  if (((t2 = p(i2).val()), a2)) return t2;
                  r2.push(t2);
                }
              return r2;
            },
            set: function (e2, t2) {
              for (
                var i2,
                  n2,
                  s2 = e2.options,
                  a2 = p.makeArray(t2),
                  r2 = s2.length;
                r2--;

              )
                ((n2 = s2[r2]).selected = p.inArray(n2.value, a2) >= 0) &&
                  (i2 = !0);
              return i2 || (e2.selectedIndex = -1), a2;
            },
          },
        },
      }),
      p.each(["radio", "checkbox"], function () {
        (p.valHooks[this] = {
          set: function (e2, t2) {
            if (p.isArray(t2))
              return (e2.checked = p.inArray(p(e2).val(), t2) >= 0);
          },
        }),
          u.checkOn ||
            (p.valHooks[this].get = function (e2) {
              return e2.getAttribute("value") === null ? "on" : e2.value;
            });
      }),
      p.each(
        "blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(
          " "
        ),
        function (e2, t2) {
          p.fn[t2] = function (e3, i2) {
            return arguments.length > 0
              ? this.on(t2, null, e3, i2)
              : this.trigger(t2);
          };
        }
      ),
      p.fn.extend({
        hover: function (e2, t2) {
          return this.mouseenter(e2).mouseleave(t2 || e2);
        },
        bind: function (e2, t2, i2) {
          return this.on(e2, null, t2, i2);
        },
        unbind: function (e2, t2) {
          return this.off(e2, null, t2);
        },
        delegate: function (e2, t2, i2, n2) {
          return this.on(t2, e2, i2, n2);
        },
        undelegate: function (e2, t2, i2) {
          return arguments.length === 1
            ? this.off(e2, "**")
            : this.off(t2, e2 || "**", i2);
        },
      });
    var Ze = p.now(),
      Je = /\?/;
    (p.parseJSON = function (e2) {
      return JSON.parse(e2 + "");
    }),
      (p.parseXML = function (e2) {
        var t2;
        if (!e2 || typeof e2 != "string") return null;
        try {
          t2 = new DOMParser().parseFromString(e2, "text/xml");
        } catch {
          t2 = void 0;
        }
        return (
          (t2 && !t2.getElementsByTagName("parsererror").length) ||
            p.error("Invalid XML: " + e2),
          t2
        );
      });
    var et = /#.*$/,
      tt = /([?&])_=[^&]*/,
      it = /^(.*?):[ \t]*([^\r\n]*)$/gm,
      nt = /^(?:GET|HEAD)$/,
      st = /^\/\//,
      at = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,
      rt = {},
      ot = {},
      lt = "*/".concat("*"),
      ct = e.location.href,
      ut = at.exec(ct.toLowerCase()) || [];
    function dt(e2) {
      return function (t2, i2) {
        typeof t2 != "string" && ((i2 = t2), (t2 = "*"));
        var n2,
          s2 = 0,
          a2 = t2.toLowerCase().match(P) || [];
        if (p.isFunction(i2))
          for (; (n2 = a2[s2++]); )
            n2[0] === "+"
              ? ((n2 = n2.slice(1) || "*"), (e2[n2] = e2[n2] || []).unshift(i2))
              : (e2[n2] = e2[n2] || []).push(i2);
      };
    }
    function ht(e2, t2, i2, n2) {
      var s2 = {},
        a2 = e2 === ot;
      function r2(o2) {
        var l2;
        return (
          (s2[o2] = !0),
          p.each(e2[o2] || [], function (e3, o3) {
            var c2 = o3(t2, i2, n2);
            return typeof c2 != "string" || a2 || s2[c2]
              ? a2
                ? !(l2 = c2)
                : void 0
              : (t2.dataTypes.unshift(c2), r2(c2), !1);
          }),
          l2
        );
      }
      return r2(t2.dataTypes[0]) || (!s2["*"] && r2("*"));
    }
    function pt(e2, t2) {
      var i2,
        n2,
        s2 = p.ajaxSettings.flatOptions || {};
      for (i2 in t2)
        t2[i2] !== void 0 && ((s2[i2] ? e2 : n2 || (n2 = {}))[i2] = t2[i2]);
      return n2 && p.extend(!0, e2, n2), e2;
    }
    p.extend({
      active: 0,
      lastModified: {},
      etag: {},
      ajaxSettings: {
        url: ct,
        type: "GET",
        isLocal:
          /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(
            ut[1]
          ),
        global: !0,
        processData: !0,
        async: !0,
        contentType: "application/x-www-form-urlencoded; charset=UTF-8",
        accepts: {
          "*": lt,
          text: "text/plain",
          html: "text/html",
          xml: "application/xml, text/xml",
          json: "application/json, text/javascript",
        },
        contents: { xml: /xml/, html: /html/, json: /json/ },
        responseFields: {
          xml: "responseXML",
          text: "responseText",
          json: "responseJSON",
        },
        converters: {
          "* text": String,
          "text html": !0,
          "text json": p.parseJSON,
          "text xml": p.parseXML,
        },
        flatOptions: { url: !0, context: !0 },
      },
      ajaxSetup: function (e2, t2) {
        return t2 ? pt(pt(e2, p.ajaxSettings), t2) : pt(p.ajaxSettings, e2);
      },
      ajaxPrefilter: dt(rt),
      ajaxTransport: dt(ot),
      ajax: function (e2, t2) {
        typeof e2 == "object" && ((t2 = e2), (e2 = void 0)), (t2 = t2 || {});
        var i2,
          n2,
          s2,
          a2,
          r2,
          o2,
          l2,
          c2,
          u2 = p.ajaxSetup({}, t2),
          d2 = u2.context || u2,
          h2 = u2.context && (d2.nodeType || d2.jquery) ? p(d2) : p.event,
          f2 = p.Deferred(),
          v2 = p.Callbacks("once memory"),
          m2 = u2.statusCode || {},
          g2 = {},
          y2 = {},
          b2 = 0,
          w2 = "canceled",
          S2 = {
            readyState: 0,
            getResponseHeader: function (e3) {
              var t3;
              if (b2 === 2) {
                if (!a2)
                  for (a2 = {}; (t3 = it.exec(s2)); )
                    a2[t3[1].toLowerCase()] = t3[2];
                t3 = a2[e3.toLowerCase()];
              }
              return t3 ?? null;
            },
            getAllResponseHeaders: function () {
              return b2 === 2 ? s2 : null;
            },
            setRequestHeader: function (e3, t3) {
              var i3 = e3.toLowerCase();
              return b2 || ((e3 = y2[i3] = y2[i3] || e3), (g2[e3] = t3)), this;
            },
            overrideMimeType: function (e3) {
              return b2 || (u2.mimeType = e3), this;
            },
            statusCode: function (e3) {
              var t3;
              if (e3)
                if (b2 < 2) for (t3 in e3) m2[t3] = [m2[t3], e3[t3]];
                else S2.always(e3[S2.status]);
              return this;
            },
            abort: function (e3) {
              var t3 = e3 || w2;
              return i2 && i2.abort(t3), x2(0, t3), this;
            },
          };
        if (
          ((f2.promise(S2).complete = v2.add),
          (S2.success = S2.done),
          (S2.error = S2.fail),
          (u2.url = ((e2 || u2.url || ct) + "")
            .replace(et, "")
            .replace(st, ut[1] + "//")),
          (u2.type = t2.method || t2.type || u2.method || u2.type),
          (u2.dataTypes = p
            .trim(u2.dataType || "*")
            .toLowerCase()
            .match(P) || [""]),
          u2.crossDomain == null &&
            ((o2 = at.exec(u2.url.toLowerCase())),
            (u2.crossDomain = !(
              !o2 ||
              (o2[1] === ut[1] &&
                o2[2] === ut[2] &&
                (o2[3] || (o2[1] === "http:" ? "80" : "443")) ===
                  (ut[3] || (ut[1] === "http:" ? "80" : "443")))
            ))),
          u2.data &&
            u2.processData &&
            typeof u2.data != "string" &&
            (u2.data = p.param(u2.data, u2.traditional)),
          ht(rt, u2, t2, S2),
          b2 === 2)
        )
          return S2;
        for (c2 in ((l2 = p.event && u2.global) &&
          p.active++ == 0 &&
          p.event.trigger("ajaxStart"),
        (u2.type = u2.type.toUpperCase()),
        (u2.hasContent = !nt.test(u2.type)),
        (n2 = u2.url),
        u2.hasContent ||
          (u2.data &&
            ((n2 = u2.url += (Je.test(n2) ? "&" : "?") + u2.data),
            delete u2.data),
          u2.cache === !1 &&
            (u2.url = tt.test(n2)
              ? n2.replace(tt, "$1_=" + Ze++)
              : n2 + (Je.test(n2) ? "&" : "?") + "_=" + Ze++)),
        u2.ifModified &&
          (p.lastModified[n2] &&
            S2.setRequestHeader("If-Modified-Since", p.lastModified[n2]),
          p.etag[n2] && S2.setRequestHeader("If-None-Match", p.etag[n2])),
        ((u2.data && u2.hasContent && u2.contentType !== !1) ||
          t2.contentType) &&
          S2.setRequestHeader("Content-Type", u2.contentType),
        S2.setRequestHeader(
          "Accept",
          u2.dataTypes[0] && u2.accepts[u2.dataTypes[0]]
            ? u2.accepts[u2.dataTypes[0]] +
                (u2.dataTypes[0] !== "*" ? ", " + lt + "; q=0.01" : "")
            : u2.accepts["*"]
        ),
        u2.headers))
          S2.setRequestHeader(c2, u2.headers[c2]);
        if (
          u2.beforeSend &&
          (u2.beforeSend.call(d2, S2, u2) === !1 || b2 === 2)
        )
          return S2.abort();
        for (c2 in ((w2 = "abort"), { success: 1, error: 1, complete: 1 }))
          S2[c2](u2[c2]);
        if ((i2 = ht(ot, u2, t2, S2))) {
          (S2.readyState = 1),
            l2 && h2.trigger("ajaxSend", [S2, u2]),
            u2.async &&
              u2.timeout > 0 &&
              (r2 = setTimeout(function () {
                S2.abort("timeout");
              }, u2.timeout));
          try {
            (b2 = 1), i2.send(g2, x2);
          } catch (e3) {
            if (!(b2 < 2)) throw e3;
            x2(-1, e3);
          }
        } else x2(-1, "No Transport");
        function x2(e3, t3, a3, o3) {
          var c3,
            g3,
            y3,
            w3,
            x3,
            C2 = t3;
          b2 !== 2 &&
            ((b2 = 2),
            r2 && clearTimeout(r2),
            (i2 = void 0),
            (s2 = o3 || ""),
            (S2.readyState = e3 > 0 ? 4 : 0),
            (c3 = (e3 >= 200 && e3 < 300) || e3 === 304),
            a3 &&
              (w3 = (function (e4, t4, i3) {
                for (
                  var n3, s3, a4, r3, o4 = e4.contents, l3 = e4.dataTypes;
                  l3[0] === "*";

                )
                  l3.shift(),
                    n3 === void 0 &&
                      (n3 =
                        e4.mimeType || t4.getResponseHeader("Content-Type"));
                if (n3) {
                  for (s3 in o4)
                    if (o4[s3] && o4[s3].test(n3)) {
                      l3.unshift(s3);
                      break;
                    }
                }
                if (l3[0] in i3) a4 = l3[0];
                else {
                  for (s3 in i3) {
                    if (!l3[0] || e4.converters[s3 + " " + l3[0]]) {
                      a4 = s3;
                      break;
                    }
                    r3 || (r3 = s3);
                  }
                  a4 = a4 || r3;
                }
                if (a4) return a4 !== l3[0] && l3.unshift(a4), i3[a4];
              })(u2, S2, a3)),
            (w3 = (function (e4, t4, i3, n3) {
              var s3,
                a4,
                r3,
                o4,
                l3,
                c4 = {},
                u3 = e4.dataTypes.slice();
              if (u3[1])
                for (r3 in e4.converters)
                  c4[r3.toLowerCase()] = e4.converters[r3];
              for (a4 = u3.shift(); a4; )
                if (
                  (e4.responseFields[a4] && (i3[e4.responseFields[a4]] = t4),
                  !l3 &&
                    n3 &&
                    e4.dataFilter &&
                    (t4 = e4.dataFilter(t4, e4.dataType)),
                  (l3 = a4),
                  (a4 = u3.shift()))
                ) {
                  if (a4 === "*") a4 = l3;
                  else if (l3 !== "*" && l3 !== a4) {
                    if (!(r3 = c4[l3 + " " + a4] || c4["* " + a4])) {
                      for (s3 in c4)
                        if (
                          (o4 = s3.split(" "))[1] === a4 &&
                          (r3 = c4[l3 + " " + o4[0]] || c4["* " + o4[0]])
                        ) {
                          r3 === !0
                            ? (r3 = c4[s3])
                            : c4[s3] !== !0 &&
                              ((a4 = o4[0]), u3.unshift(o4[1]));
                          break;
                        }
                    }
                    if (r3 !== !0)
                      if (r3 && e4.throws) t4 = r3(t4);
                      else
                        try {
                          t4 = r3(t4);
                        } catch (e5) {
                          return {
                            state: "parsererror",
                            error: r3
                              ? e5
                              : "No conversion from " + l3 + " to " + a4,
                          };
                        }
                  }
                }
              return { state: "success", data: t4 };
            })(u2, w3, S2, c3)),
            c3
              ? (u2.ifModified &&
                  ((x3 = S2.getResponseHeader("Last-Modified")) &&
                    (p.lastModified[n2] = x3),
                  (x3 = S2.getResponseHeader("etag")) && (p.etag[n2] = x3)),
                e3 === 204 || u2.type === "HEAD"
                  ? (C2 = "nocontent")
                  : e3 === 304
                  ? (C2 = "notmodified")
                  : ((C2 = w3.state), (g3 = w3.data), (c3 = !(y3 = w3.error))))
              : ((y3 = C2),
                (!e3 && C2) || ((C2 = "error"), e3 < 0 && (e3 = 0))),
            (S2.status = e3),
            (S2.statusText = (t3 || C2) + ""),
            c3
              ? f2.resolveWith(d2, [g3, C2, S2])
              : f2.rejectWith(d2, [S2, C2, y3]),
            S2.statusCode(m2),
            (m2 = void 0),
            l2 &&
              h2.trigger(c3 ? "ajaxSuccess" : "ajaxError", [
                S2,
                u2,
                c3 ? g3 : y3,
              ]),
            v2.fireWith(d2, [S2, C2]),
            l2 &&
              (h2.trigger("ajaxComplete", [S2, u2]),
              --p.active || p.event.trigger("ajaxStop")));
        }
        return S2;
      },
      getJSON: function (e2, t2, i2) {
        return p.get(e2, t2, i2, "json");
      },
      getScript: function (e2, t2) {
        return p.get(e2, void 0, t2, "script");
      },
    }),
      p.each(["get", "post"], function (e2, t2) {
        p[t2] = function (e3, i2, n2, s2) {
          return (
            p.isFunction(i2) && ((s2 = s2 || n2), (n2 = i2), (i2 = void 0)),
            p.ajax({ url: e3, type: t2, dataType: s2, data: i2, success: n2 })
          );
        };
      }),
      (p._evalUrl = function (e2) {
        return p.ajax({
          url: e2,
          type: "GET",
          dataType: "script",
          async: !1,
          global: !1,
          throws: !0,
        });
      }),
      p.fn.extend({
        wrapAll: function (e2) {
          var t2;
          return p.isFunction(e2)
            ? this.each(function (t3) {
                p(this).wrapAll(e2.call(this, t3));
              })
            : (this[0] &&
                ((t2 = p(e2, this[0].ownerDocument).eq(0).clone(!0)),
                this[0].parentNode && t2.insertBefore(this[0]),
                t2
                  .map(function () {
                    for (var e3 = this; e3.firstElementChild; )
                      e3 = e3.firstElementChild;
                    return e3;
                  })
                  .append(this)),
              this);
        },
        wrapInner: function (e2) {
          return p.isFunction(e2)
            ? this.each(function (t2) {
                p(this).wrapInner(e2.call(this, t2));
              })
            : this.each(function () {
                var t2 = p(this),
                  i2 = t2.contents();
                i2.length ? i2.wrapAll(e2) : t2.append(e2);
              });
        },
        wrap: function (e2) {
          var t2 = p.isFunction(e2);
          return this.each(function (i2) {
            p(this).wrapAll(t2 ? e2.call(this, i2) : e2);
          });
        },
        unwrap: function () {
          return this.parent()
            .each(function () {
              p.nodeName(this, "body") || p(this).replaceWith(this.childNodes);
            })
            .end();
        },
      }),
      (p.expr.filters.hidden = function (e2) {
        return e2.offsetWidth <= 0 && e2.offsetHeight <= 0;
      }),
      (p.expr.filters.visible = function (e2) {
        return !p.expr.filters.hidden(e2);
      });
    var ft = /%20/g,
      vt = /\[\]$/,
      mt = /\r?\n/g,
      gt = /^(?:submit|button|image|reset|file)$/i,
      yt = /^(?:input|select|textarea|keygen)/i;
    function bt(e2, t2, i2, n2) {
      var s2;
      if (p.isArray(t2))
        p.each(t2, function (t3, s3) {
          i2 || vt.test(e2)
            ? n2(e2, s3)
            : bt(
                e2 + "[" + (typeof s3 == "object" ? t3 : "") + "]",
                s3,
                i2,
                n2
              );
        });
      else if (i2 || p.type(t2) !== "object") n2(e2, t2);
      else for (s2 in t2) bt(e2 + "[" + s2 + "]", t2[s2], i2, n2);
    }
    (p.param = function (e2, t2) {
      var i2,
        n2 = [],
        s2 = function (e3, t3) {
          (t3 = p.isFunction(t3) ? t3() : t3 ?? ""),
            (n2[n2.length] =
              encodeURIComponent(e3) + "=" + encodeURIComponent(t3));
        };
      if (
        (t2 === void 0 && (t2 = p.ajaxSettings && p.ajaxSettings.traditional),
        p.isArray(e2) || (e2.jquery && !p.isPlainObject(e2)))
      )
        p.each(e2, function () {
          s2(this.name, this.value);
        });
      else for (i2 in e2) bt(i2, e2[i2], t2, s2);
      return n2.join("&").replace(ft, "+");
    }),
      p.fn.extend({
        serialize: function () {
          return p.param(this.serializeArray());
        },
        serializeArray: function () {
          return this.map(function () {
            var e2 = p.prop(this, "elements");
            return e2 ? p.makeArray(e2) : this;
          })
            .filter(function () {
              var e2 = this.type;
              return (
                this.name &&
                !p(this).is(":disabled") &&
                yt.test(this.nodeName) &&
                !gt.test(e2) &&
                (this.checked || !X.test(e2))
              );
            })
            .map(function (e2, t2) {
              var i2 = p(this).val();
              return i2 == null
                ? null
                : p.isArray(i2)
                ? p.map(i2, function (e3) {
                    return {
                      name: t2.name,
                      value: e3.replace(
                        mt,
                        `\r
`
                      ),
                    };
                  })
                : {
                    name: t2.name,
                    value: i2.replace(
                      mt,
                      `\r
`
                    ),
                  };
            })
            .get();
        },
      }),
      (p.ajaxSettings.xhr = function () {
        try {
          return new XMLHttpRequest();
        } catch {}
      });
    var wt = 0,
      St = {},
      xt = { 0: 200, 1223: 204 },
      Ct = p.ajaxSettings.xhr();
    e.attachEvent &&
      e.attachEvent("onunload", function () {
        for (var e2 in St) St[e2]();
      }),
      (u.cors = !!Ct && "withCredentials" in Ct),
      (u.ajax = Ct = !!Ct),
      p.ajaxTransport(function (e2) {
        var t2;
        if (u.cors || (Ct && !e2.crossDomain))
          return {
            send: function (i2, n2) {
              var s2,
                a2 = e2.xhr(),
                r2 = ++wt;
              if (
                (a2.open(e2.type, e2.url, e2.async, e2.username, e2.password),
                e2.xhrFields)
              )
                for (s2 in e2.xhrFields) a2[s2] = e2.xhrFields[s2];
              for (s2 in (e2.mimeType &&
                a2.overrideMimeType &&
                a2.overrideMimeType(e2.mimeType),
              e2.crossDomain ||
                i2["X-Requested-With"] ||
                (i2["X-Requested-With"] = "XMLHttpRequest"),
              i2))
                a2.setRequestHeader(s2, i2[s2]);
              (t2 = function (e3) {
                return function () {
                  t2 &&
                    (delete St[r2],
                    (t2 = a2.onload = a2.onerror = null),
                    e3 === "abort"
                      ? a2.abort()
                      : e3 === "error"
                      ? n2(a2.status, a2.statusText)
                      : n2(
                          xt[a2.status] || a2.status,
                          a2.statusText,
                          typeof a2.responseText == "string"
                            ? { text: a2.responseText }
                            : void 0,
                          a2.getAllResponseHeaders()
                        ));
                };
              }),
                (a2.onload = t2()),
                (a2.onerror = t2("error")),
                (t2 = St[r2] = t2("abort"));
              try {
                a2.send((e2.hasContent && e2.data) || null);
              } catch (e3) {
                if (t2) throw e3;
              }
            },
            abort: function () {
              t2 && t2();
            },
          };
      }),
      p.ajaxSetup({
        accepts: {
          script:
            "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript",
        },
        contents: { script: /(?:java|ecma)script/ },
        converters: {
          "text script": function (e2) {
            return p.globalEval(e2), e2;
          },
        },
      }),
      p.ajaxPrefilter("script", function (e2) {
        e2.cache === void 0 && (e2.cache = !1),
          e2.crossDomain && (e2.type = "GET");
      }),
      p.ajaxTransport("script", function (e2) {
        var t2, i2;
        if (e2.crossDomain)
          return {
            send: function (n2, s2) {
              (t2 = p("<script>")
                .prop({ async: !0, charset: e2.scriptCharset, src: e2.url })
                .on(
                  "load error",
                  (i2 = function (e3) {
                    t2.remove(),
                      (i2 = null),
                      e3 && s2(e3.type === "error" ? 404 : 200, e3.type);
                  })
                )),
                d.head.appendChild(t2[0]);
            },
            abort: function () {
              i2 && i2();
            },
          };
      });
    var kt = [],
      Et = /(=)\?(?=&|$)|\?\?/;
    p.ajaxSetup({
      jsonp: "callback",
      jsonpCallback: function () {
        var e2 = kt.pop() || p.expando + "_" + Ze++;
        return (this[e2] = !0), e2;
      },
    }),
      p.ajaxPrefilter("json jsonp", function (t2, i2, n2) {
        var s2,
          a2,
          r2,
          o2 =
            t2.jsonp !== !1 &&
            (Et.test(t2.url)
              ? "url"
              : typeof t2.data == "string" &&
                !(t2.contentType || "").indexOf(
                  "application/x-www-form-urlencoded"
                ) &&
                Et.test(t2.data) &&
                "data");
        if (o2 || t2.dataTypes[0] === "jsonp")
          return (
            (s2 = t2.jsonpCallback =
              p.isFunction(t2.jsonpCallback)
                ? t2.jsonpCallback()
                : t2.jsonpCallback),
            o2
              ? (t2[o2] = t2[o2].replace(Et, "$1" + s2))
              : t2.jsonp !== !1 &&
                (t2.url += (Je.test(t2.url) ? "&" : "?") + t2.jsonp + "=" + s2),
            (t2.converters["script json"] = function () {
              return r2 || p.error(s2 + " was not called"), r2[0];
            }),
            (t2.dataTypes[0] = "json"),
            (a2 = e[s2]),
            (e[s2] = function () {
              r2 = arguments;
            }),
            n2.always(function () {
              (e[s2] = a2),
                t2[s2] && ((t2.jsonpCallback = i2.jsonpCallback), kt.push(s2)),
                r2 && p.isFunction(a2) && a2(r2[0]),
                (r2 = a2 = void 0);
            }),
            "script"
          );
      }),
      (p.parseHTML = function (e2, t2, i2) {
        if (!e2 || typeof e2 != "string") return null;
        typeof t2 == "boolean" && ((i2 = t2), (t2 = !1)), (t2 = t2 || d);
        var n2 = S.exec(e2),
          s2 = !i2 && [];
        return n2
          ? [t2.createElement(n2[1])]
          : ((n2 = p.buildFragment([e2], t2, s2)),
            s2 && s2.length && p(s2).remove(),
            p.merge([], n2.childNodes));
      });
    var Tt = p.fn.load;
    (p.fn.load = function (e2, t2, i2) {
      if (typeof e2 != "string" && Tt) return Tt.apply(this, arguments);
      var n2,
        s2,
        a2,
        r2 = this,
        o2 = e2.indexOf(" ");
      return (
        o2 >= 0 && ((n2 = p.trim(e2.slice(o2))), (e2 = e2.slice(0, o2))),
        p.isFunction(t2)
          ? ((i2 = t2), (t2 = void 0))
          : t2 && typeof t2 == "object" && (s2 = "POST"),
        r2.length > 0 &&
          p
            .ajax({ url: e2, type: s2, dataType: "html", data: t2 })
            .done(function (e3) {
              (a2 = arguments),
                r2.html(n2 ? p("<div>").append(p.parseHTML(e3)).find(n2) : e3);
            })
            .complete(
              i2 &&
                function (e3, t3) {
                  r2.each(i2, a2 || [e3.responseText, t3, e3]);
                }
            ),
        this
      );
    }),
      p.each(
        [
          "ajaxStart",
          "ajaxStop",
          "ajaxComplete",
          "ajaxError",
          "ajaxSuccess",
          "ajaxSend",
        ],
        function (e2, t2) {
          p.fn[t2] = function (e3) {
            return this.on(t2, e3);
          };
        }
      ),
      (p.expr.filters.animated = function (e2) {
        return p.grep(p.timers, function (t2) {
          return e2 === t2.elem;
        }).length;
      });
    var _t = e.document.documentElement;
    function Mt(e2) {
      return p.isWindow(e2) ? e2 : e2.nodeType === 9 && e2.defaultView;
    }
    (p.offset = {
      setOffset: function (e2, t2, i2) {
        var n2,
          s2,
          a2,
          r2,
          o2,
          l2,
          c2 = p.css(e2, "position"),
          u2 = p(e2),
          d2 = {};
        c2 === "static" && (e2.style.position = "relative"),
          (o2 = u2.offset()),
          (a2 = p.css(e2, "top")),
          (l2 = p.css(e2, "left")),
          (c2 === "absolute" || c2 === "fixed") &&
          (a2 + l2).indexOf("auto") > -1
            ? ((r2 = (n2 = u2.position()).top), (s2 = n2.left))
            : ((r2 = parseFloat(a2) || 0), (s2 = parseFloat(l2) || 0)),
          p.isFunction(t2) && (t2 = t2.call(e2, i2, o2)),
          t2.top != null && (d2.top = t2.top - o2.top + r2),
          t2.left != null && (d2.left = t2.left - o2.left + s2),
          "using" in t2 ? t2.using.call(e2, d2) : u2.css(d2);
      },
    }),
      p.fn.extend({
        offset: function (e2) {
          if (arguments.length)
            return e2 === void 0
              ? this
              : this.each(function (t3) {
                  p.offset.setOffset(this, e2, t3);
                });
          var t2,
            i2,
            n2 = this[0],
            s2 = { top: 0, left: 0 },
            a2 = n2 && n2.ownerDocument;
          return a2
            ? ((t2 = a2.documentElement),
              p.contains(t2, n2)
                ? (typeof n2.getBoundingClientRect !== G &&
                    (s2 = n2.getBoundingClientRect()),
                  (i2 = Mt(a2)),
                  {
                    top: s2.top + i2.pageYOffset - t2.clientTop,
                    left: s2.left + i2.pageXOffset - t2.clientLeft,
                  })
                : s2)
            : void 0;
        },
        position: function () {
          if (this[0]) {
            var e2,
              t2,
              i2 = this[0],
              n2 = { top: 0, left: 0 };
            return (
              p.css(i2, "position") === "fixed"
                ? (t2 = i2.getBoundingClientRect())
                : ((e2 = this.offsetParent()),
                  (t2 = this.offset()),
                  p.nodeName(e2[0], "html") || (n2 = e2.offset()),
                  (n2.top += p.css(e2[0], "borderTopWidth", !0)),
                  (n2.left += p.css(e2[0], "borderLeftWidth", !0))),
              {
                top: t2.top - n2.top - p.css(i2, "marginTop", !0),
                left: t2.left - n2.left - p.css(i2, "marginLeft", !0),
              }
            );
          }
        },
        offsetParent: function () {
          return this.map(function () {
            for (
              var e2 = this.offsetParent || _t;
              e2 &&
              !p.nodeName(e2, "html") &&
              p.css(e2, "position") === "static";

            )
              e2 = e2.offsetParent;
            return e2 || _t;
          });
        },
      }),
      p.each(
        { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" },
        function (t2, i2) {
          var n2 = i2 === "pageYOffset";
          p.fn[t2] = function (s2) {
            return A(
              this,
              function (t3, s3, a2) {
                var r2 = Mt(t3);
                if (a2 === void 0) return r2 ? r2[i2] : t3[s3];
                r2
                  ? r2.scrollTo(
                      n2 ? e.pageXOffset : a2,
                      n2 ? a2 : e.pageYOffset
                    )
                  : (t3[s3] = a2);
              },
              t2,
              s2,
              arguments.length,
              null
            );
          };
        }
      ),
      p.each(["top", "left"], function (e2, t2) {
        p.cssHooks[t2] = Ce(u.pixelPosition, function (e3, i2) {
          if (i2)
            return (
              (i2 = xe(e3, t2)), we.test(i2) ? p(e3).position()[t2] + "px" : i2
            );
        });
      }),
      p.each({ Height: "height", Width: "width" }, function (e2, t2) {
        p.each(
          { padding: "inner" + e2, content: t2, "": "outer" + e2 },
          function (i2, n2) {
            p.fn[n2] = function (n3, s2) {
              var a2 = arguments.length && (i2 || typeof n3 != "boolean"),
                r2 = i2 || (n3 === !0 || s2 === !0 ? "margin" : "border");
              return A(
                this,
                function (t3, i3, n4) {
                  var s3;
                  return p.isWindow(t3)
                    ? t3.document.documentElement["client" + e2]
                    : t3.nodeType === 9
                    ? ((s3 = t3.documentElement),
                      Math.max(
                        t3.body["scroll" + e2],
                        s3["scroll" + e2],
                        t3.body["offset" + e2],
                        s3["offset" + e2],
                        s3["client" + e2]
                      ))
                    : n4 === void 0
                    ? p.css(t3, i3, r2)
                    : p.style(t3, i3, n4, r2);
                },
                t2,
                a2 ? n3 : void 0,
                a2,
                null
              );
            };
          }
        );
      }),
      (p.fn.size = function () {
        return this.length;
      }),
      (p.fn.andSelf = p.fn.addBack),
      typeof define == "function" &&
        define.amd &&
        define("jquery", [], function () {
          return p;
        });
    var Lt = e.jQuery,
      Pt = e.$;
    return (
      (p.noConflict = function (t2) {
        return (
          e.$ === p && (e.$ = Pt), t2 && e.jQuery === p && (e.jQuery = Lt), p
        );
      }),
      typeof t === G && (e.jQuery = e.$ = p),
      p
    );
  }),
  (function (e, t) {
    typeof exports == "object" && typeof module < "u"
      ? (module.exports = t())
      : typeof define == "function" && define.amd
      ? define(t)
      : ((e = e || self).Swiper = t());
  })(this, function () {
    "use strict";
    var e =
        typeof document > "u"
          ? {
              body: {},
              addEventListener: function () {},
              removeEventListener: function () {},
              activeElement: { blur: function () {}, nodeName: "" },
              querySelector: function () {
                return null;
              },
              querySelectorAll: function () {
                return [];
              },
              getElementById: function () {
                return null;
              },
              createEvent: function () {
                return { initEvent: function () {} };
              },
              createElement: function () {
                return {
                  children: [],
                  childNodes: [],
                  style: {},
                  setAttribute: function () {},
                  getElementsByTagName: function () {
                    return [];
                  },
                };
              },
              location: { hash: "" },
            }
          : document,
      t =
        typeof window > "u"
          ? {
              document: e,
              navigator: { userAgent: "" },
              location: {},
              history: {},
              CustomEvent: function () {
                return this;
              },
              addEventListener: function () {},
              removeEventListener: function () {},
              getComputedStyle: function () {
                return {
                  getPropertyValue: function () {
                    return "";
                  },
                };
              },
              Image: function () {},
              Date: function () {},
              screen: {},
              setTimeout: function () {},
              clearTimeout: function () {},
            }
          : window,
      i = function (e2) {
        for (var t2 = 0; t2 < e2.length; t2 += 1) this[t2] = e2[t2];
        return (this.length = e2.length), this;
      };
    function n(n2, s2) {
      var a2 = [],
        r2 = 0;
      if (n2 && !s2 && n2 instanceof i) return n2;
      if (n2) {
        if (typeof n2 == "string") {
          var o2,
            l2,
            c2 = n2.trim();
          if (c2.indexOf("<") >= 0 && c2.indexOf(">") >= 0) {
            var u2 = "div";
            for (
              c2.indexOf("<li") === 0 && (u2 = "ul"),
                c2.indexOf("<tr") === 0 && (u2 = "tbody"),
                (c2.indexOf("<td") !== 0 && c2.indexOf("<th") !== 0) ||
                  (u2 = "tr"),
                c2.indexOf("<tbody") === 0 && (u2 = "table"),
                c2.indexOf("<option") === 0 && (u2 = "select"),
                (l2 = e.createElement(u2)).innerHTML = c2,
                r2 = 0;
              r2 < l2.childNodes.length;
              r2 += 1
            )
              a2.push(l2.childNodes[r2]);
          } else
            for (
              o2 =
                s2 || n2[0] !== "#" || n2.match(/[ .<>:~]/)
                  ? (s2 || e).querySelectorAll(n2.trim())
                  : [e.getElementById(n2.trim().split("#")[1])],
                r2 = 0;
              r2 < o2.length;
              r2 += 1
            )
              o2[r2] && a2.push(o2[r2]);
        } else if (n2.nodeType || n2 === t || n2 === e) a2.push(n2);
        else if (n2.length > 0 && n2[0].nodeType)
          for (r2 = 0; r2 < n2.length; r2 += 1) a2.push(n2[r2]);
      }
      return new i(a2);
    }
    function s(e2) {
      for (var t2 = [], i2 = 0; i2 < e2.length; i2 += 1)
        t2.indexOf(e2[i2]) === -1 && t2.push(e2[i2]);
      return t2;
    }
    (n.fn = i.prototype), (n.Class = i), (n.Dom7 = i);
    var a = {
      addClass: function (e2) {
        if (e2 === void 0) return this;
        for (var t2 = e2.split(" "), i2 = 0; i2 < t2.length; i2 += 1)
          for (var n2 = 0; n2 < this.length; n2 += 1)
            this[n2] !== void 0 &&
              this[n2].classList !== void 0 &&
              this[n2].classList.add(t2[i2]);
        return this;
      },
      removeClass: function (e2) {
        for (var t2 = e2.split(" "), i2 = 0; i2 < t2.length; i2 += 1)
          for (var n2 = 0; n2 < this.length; n2 += 1)
            this[n2] !== void 0 &&
              this[n2].classList !== void 0 &&
              this[n2].classList.remove(t2[i2]);
        return this;
      },
      hasClass: function (e2) {
        return !!this[0] && this[0].classList.contains(e2);
      },
      toggleClass: function (e2) {
        for (var t2 = e2.split(" "), i2 = 0; i2 < t2.length; i2 += 1)
          for (var n2 = 0; n2 < this.length; n2 += 1)
            this[n2] !== void 0 &&
              this[n2].classList !== void 0 &&
              this[n2].classList.toggle(t2[i2]);
        return this;
      },
      attr: function (e2, t2) {
        var i2 = arguments;
        if (arguments.length === 1 && typeof e2 == "string")
          return this[0] ? this[0].getAttribute(e2) : void 0;
        for (var n2 = 0; n2 < this.length; n2 += 1)
          if (i2.length === 2) this[n2].setAttribute(e2, t2);
          else
            for (var s2 in e2)
              (this[n2][s2] = e2[s2]), this[n2].setAttribute(s2, e2[s2]);
        return this;
      },
      removeAttr: function (e2) {
        for (var t2 = 0; t2 < this.length; t2 += 1)
          this[t2].removeAttribute(e2);
        return this;
      },
      data: function (e2, t2) {
        var i2;
        if (t2 !== void 0) {
          for (var n2 = 0; n2 < this.length; n2 += 1)
            (i2 = this[n2]).dom7ElementDataStorage ||
              (i2.dom7ElementDataStorage = {}),
              (i2.dom7ElementDataStorage[e2] = t2);
          return this;
        }
        if ((i2 = this[0]))
          return i2.dom7ElementDataStorage && e2 in i2.dom7ElementDataStorage
            ? i2.dom7ElementDataStorage[e2]
            : i2.getAttribute("data-" + e2) || void 0;
      },
      transform: function (e2) {
        for (var t2 = 0; t2 < this.length; t2 += 1) {
          var i2 = this[t2].style;
          (i2.webkitTransform = e2), (i2.transform = e2);
        }
        return this;
      },
      transition: function (e2) {
        typeof e2 != "string" && (e2 += "ms");
        for (var t2 = 0; t2 < this.length; t2 += 1) {
          var i2 = this[t2].style;
          (i2.webkitTransitionDuration = e2), (i2.transitionDuration = e2);
        }
        return this;
      },
      on: function () {
        for (var e2, t2 = [], i2 = arguments.length; i2--; )
          t2[i2] = arguments[i2];
        var s2 = t2[0],
          a2 = t2[1],
          r2 = t2[2],
          o2 = t2[3];
        function l2(e3) {
          var t3 = e3.target;
          if (t3) {
            var i3 = e3.target.dom7EventData || [];
            if ((i3.indexOf(e3) < 0 && i3.unshift(e3), n(t3).is(a2)))
              r2.apply(t3, i3);
            else
              for (var s3 = n(t3).parents(), o3 = 0; o3 < s3.length; o3 += 1)
                n(s3[o3]).is(a2) && r2.apply(s3[o3], i3);
          }
        }
        function c2(e3) {
          var t3 = (e3 && e3.target && e3.target.dom7EventData) || [];
          t3.indexOf(e3) < 0 && t3.unshift(e3), r2.apply(this, t3);
        }
        typeof t2[1] == "function" &&
          ((s2 = (e2 = t2)[0]), (r2 = e2[1]), (o2 = e2[2]), (a2 = void 0)),
          o2 || (o2 = !1);
        for (var u2, d2 = s2.split(" "), h2 = 0; h2 < this.length; h2 += 1) {
          var p2 = this[h2];
          if (a2)
            for (u2 = 0; u2 < d2.length; u2 += 1) {
              var f2 = d2[u2];
              p2.dom7LiveListeners || (p2.dom7LiveListeners = {}),
                p2.dom7LiveListeners[f2] || (p2.dom7LiveListeners[f2] = []),
                p2.dom7LiveListeners[f2].push({
                  listener: r2,
                  proxyListener: l2,
                }),
                p2.addEventListener(f2, l2, o2);
            }
          else
            for (u2 = 0; u2 < d2.length; u2 += 1) {
              var v2 = d2[u2];
              p2.dom7Listeners || (p2.dom7Listeners = {}),
                p2.dom7Listeners[v2] || (p2.dom7Listeners[v2] = []),
                p2.dom7Listeners[v2].push({ listener: r2, proxyListener: c2 }),
                p2.addEventListener(v2, c2, o2);
            }
        }
        return this;
      },
      off: function () {
        for (var e2, t2 = [], i2 = arguments.length; i2--; )
          t2[i2] = arguments[i2];
        var n2 = t2[0],
          s2 = t2[1],
          a2 = t2[2],
          r2 = t2[3];
        typeof t2[1] == "function" &&
          ((n2 = (e2 = t2)[0]), (a2 = e2[1]), (r2 = e2[2]), (s2 = void 0)),
          r2 || (r2 = !1);
        for (var o2 = n2.split(" "), l2 = 0; l2 < o2.length; l2 += 1)
          for (var c2 = o2[l2], u2 = 0; u2 < this.length; u2 += 1) {
            var d2 = this[u2],
              h2 = void 0;
            if (
              (!s2 && d2.dom7Listeners
                ? (h2 = d2.dom7Listeners[c2])
                : s2 && d2.dom7LiveListeners && (h2 = d2.dom7LiveListeners[c2]),
              h2 && h2.length)
            )
              for (var p2 = h2.length - 1; p2 >= 0; p2 -= 1) {
                var f2 = h2[p2];
                (a2 && f2.listener === a2) ||
                (a2 &&
                  f2.listener &&
                  f2.listener.dom7proxy &&
                  f2.listener.dom7proxy === a2)
                  ? (d2.removeEventListener(c2, f2.proxyListener, r2),
                    h2.splice(p2, 1))
                  : a2 ||
                    (d2.removeEventListener(c2, f2.proxyListener, r2),
                    h2.splice(p2, 1));
              }
          }
        return this;
      },
      trigger: function () {
        for (var i2 = [], n2 = arguments.length; n2--; ) i2[n2] = arguments[n2];
        for (
          var s2 = i2[0].split(" "), a2 = i2[1], r2 = 0;
          r2 < s2.length;
          r2 += 1
        )
          for (var o2 = s2[r2], l2 = 0; l2 < this.length; l2 += 1) {
            var c2 = this[l2],
              u2 = void 0;
            try {
              u2 = new t.CustomEvent(o2, {
                detail: a2,
                bubbles: !0,
                cancelable: !0,
              });
            } catch {
              (u2 = e.createEvent("Event")).initEvent(o2, !0, !0),
                (u2.detail = a2);
            }
            (c2.dom7EventData = i2.filter(function (e2, t2) {
              return t2 > 0;
            })),
              c2.dispatchEvent(u2),
              (c2.dom7EventData = []),
              delete c2.dom7EventData;
          }
        return this;
      },
      transitionEnd: function (e2) {
        var t2,
          i2 = ["webkitTransitionEnd", "transitionend"],
          n2 = this;
        function s2(a2) {
          if (a2.target === this)
            for (e2.call(this, a2), t2 = 0; t2 < i2.length; t2 += 1)
              n2.off(i2[t2], s2);
        }
        if (e2) for (t2 = 0; t2 < i2.length; t2 += 1) n2.on(i2[t2], s2);
        return this;
      },
      outerWidth: function (e2) {
        if (this.length > 0) {
          if (e2) {
            var t2 = this.styles();
            return (
              this[0].offsetWidth +
              parseFloat(t2.getPropertyValue("margin-right")) +
              parseFloat(t2.getPropertyValue("margin-left"))
            );
          }
          return this[0].offsetWidth;
        }
        return null;
      },
      outerHeight: function (e2) {
        if (this.length > 0) {
          if (e2) {
            var t2 = this.styles();
            return (
              this[0].offsetHeight +
              parseFloat(t2.getPropertyValue("margin-top")) +
              parseFloat(t2.getPropertyValue("margin-bottom"))
            );
          }
          return this[0].offsetHeight;
        }
        return null;
      },
      offset: function () {
        if (this.length > 0) {
          var i2 = this[0],
            n2 = i2.getBoundingClientRect(),
            s2 = e.body,
            a2 = i2.clientTop || s2.clientTop || 0,
            r2 = i2.clientLeft || s2.clientLeft || 0,
            o2 = i2 === t ? t.scrollY : i2.scrollTop,
            l2 = i2 === t ? t.scrollX : i2.scrollLeft;
          return { top: n2.top + o2 - a2, left: n2.left + l2 - r2 };
        }
        return null;
      },
      css: function (e2, i2) {
        var n2;
        if (arguments.length === 1) {
          if (typeof e2 != "string") {
            for (n2 = 0; n2 < this.length; n2 += 1)
              for (var s2 in e2) this[n2].style[s2] = e2[s2];
            return this;
          }
          if (this[0])
            return t.getComputedStyle(this[0], null).getPropertyValue(e2);
        }
        if (arguments.length === 2 && typeof e2 == "string") {
          for (n2 = 0; n2 < this.length; n2 += 1) this[n2].style[e2] = i2;
          return this;
        }
        return this;
      },
      each: function (e2) {
        if (!e2) return this;
        for (var t2 = 0; t2 < this.length; t2 += 1)
          if (e2.call(this[t2], t2, this[t2]) === !1) return this;
        return this;
      },
      html: function (e2) {
        if (e2 === void 0) return this[0] ? this[0].innerHTML : void 0;
        for (var t2 = 0; t2 < this.length; t2 += 1) this[t2].innerHTML = e2;
        return this;
      },
      text: function (e2) {
        if (e2 === void 0) return this[0] ? this[0].textContent.trim() : null;
        for (var t2 = 0; t2 < this.length; t2 += 1) this[t2].textContent = e2;
        return this;
      },
      is: function (s2) {
        var a2,
          r2,
          o2 = this[0];
        if (!o2 || s2 === void 0) return !1;
        if (typeof s2 == "string") {
          if (o2.matches) return o2.matches(s2);
          if (o2.webkitMatchesSelector) return o2.webkitMatchesSelector(s2);
          if (o2.msMatchesSelector) return o2.msMatchesSelector(s2);
          for (a2 = n(s2), r2 = 0; r2 < a2.length; r2 += 1)
            if (a2[r2] === o2) return !0;
          return !1;
        }
        if (s2 === e) return o2 === e;
        if (s2 === t) return o2 === t;
        if (s2.nodeType || s2 instanceof i) {
          for (a2 = s2.nodeType ? [s2] : s2, r2 = 0; r2 < a2.length; r2 += 1)
            if (a2[r2] === o2) return !0;
          return !1;
        }
        return !1;
      },
      index: function () {
        var e2,
          t2 = this[0];
        if (t2) {
          for (e2 = 0; (t2 = t2.previousSibling) !== null; )
            t2.nodeType === 1 && (e2 += 1);
          return e2;
        }
      },
      eq: function (e2) {
        if (e2 === void 0) return this;
        var t2,
          n2 = this.length;
        return new i(
          e2 > n2 - 1
            ? []
            : e2 < 0
            ? (t2 = n2 + e2) < 0
              ? []
              : [this[t2]]
            : [this[e2]]
        );
      },
      append: function () {
        for (var t2, n2 = [], s2 = arguments.length; s2--; )
          n2[s2] = arguments[s2];
        for (var a2 = 0; a2 < n2.length; a2 += 1) {
          t2 = n2[a2];
          for (var r2 = 0; r2 < this.length; r2 += 1)
            if (typeof t2 == "string") {
              var o2 = e.createElement("div");
              for (o2.innerHTML = t2; o2.firstChild; )
                this[r2].appendChild(o2.firstChild);
            } else if (t2 instanceof i)
              for (var l2 = 0; l2 < t2.length; l2 += 1)
                this[r2].appendChild(t2[l2]);
            else this[r2].appendChild(t2);
        }
        return this;
      },
      prepend: function (t2) {
        var n2, s2;
        for (n2 = 0; n2 < this.length; n2 += 1)
          if (typeof t2 == "string") {
            var a2 = e.createElement("div");
            for (
              a2.innerHTML = t2, s2 = a2.childNodes.length - 1;
              s2 >= 0;
              s2 -= 1
            )
              this[n2].insertBefore(a2.childNodes[s2], this[n2].childNodes[0]);
          } else if (t2 instanceof i)
            for (s2 = 0; s2 < t2.length; s2 += 1)
              this[n2].insertBefore(t2[s2], this[n2].childNodes[0]);
          else this[n2].insertBefore(t2, this[n2].childNodes[0]);
        return this;
      },
      next: function (e2) {
        return this.length > 0
          ? e2
            ? this[0].nextElementSibling && n(this[0].nextElementSibling).is(e2)
              ? new i([this[0].nextElementSibling])
              : new i([])
            : this[0].nextElementSibling
            ? new i([this[0].nextElementSibling])
            : new i([])
          : new i([]);
      },
      nextAll: function (e2) {
        var t2 = [],
          s2 = this[0];
        if (!s2) return new i([]);
        for (; s2.nextElementSibling; ) {
          var a2 = s2.nextElementSibling;
          e2 ? n(a2).is(e2) && t2.push(a2) : t2.push(a2), (s2 = a2);
        }
        return new i(t2);
      },
      prev: function (e2) {
        if (this.length > 0) {
          var t2 = this[0];
          return e2
            ? t2.previousElementSibling && n(t2.previousElementSibling).is(e2)
              ? new i([t2.previousElementSibling])
              : new i([])
            : t2.previousElementSibling
            ? new i([t2.previousElementSibling])
            : new i([]);
        }
        return new i([]);
      },
      prevAll: function (e2) {
        var t2 = [],
          s2 = this[0];
        if (!s2) return new i([]);
        for (; s2.previousElementSibling; ) {
          var a2 = s2.previousElementSibling;
          e2 ? n(a2).is(e2) && t2.push(a2) : t2.push(a2), (s2 = a2);
        }
        return new i(t2);
      },
      parent: function (e2) {
        for (var t2 = [], i2 = 0; i2 < this.length; i2 += 1)
          this[i2].parentNode !== null &&
            (e2
              ? n(this[i2].parentNode).is(e2) && t2.push(this[i2].parentNode)
              : t2.push(this[i2].parentNode));
        return n(s(t2));
      },
      parents: function (e2) {
        for (var t2 = [], i2 = 0; i2 < this.length; i2 += 1)
          for (var a2 = this[i2].parentNode; a2; )
            e2 ? n(a2).is(e2) && t2.push(a2) : t2.push(a2),
              (a2 = a2.parentNode);
        return n(s(t2));
      },
      closest: function (e2) {
        var t2 = this;
        return e2 === void 0
          ? new i([])
          : (t2.is(e2) || (t2 = t2.parents(e2).eq(0)), t2);
      },
      find: function (e2) {
        for (var t2 = [], n2 = 0; n2 < this.length; n2 += 1)
          for (
            var s2 = this[n2].querySelectorAll(e2), a2 = 0;
            a2 < s2.length;
            a2 += 1
          )
            t2.push(s2[a2]);
        return new i(t2);
      },
      children: function (e2) {
        for (var t2 = [], a2 = 0; a2 < this.length; a2 += 1)
          for (var r2 = this[a2].childNodes, o2 = 0; o2 < r2.length; o2 += 1)
            e2
              ? r2[o2].nodeType === 1 && n(r2[o2]).is(e2) && t2.push(r2[o2])
              : r2[o2].nodeType === 1 && t2.push(r2[o2]);
        return new i(s(t2));
      },
      filter: function (e2) {
        for (var t2 = [], n2 = 0; n2 < this.length; n2 += 1)
          e2.call(this[n2], n2, this[n2]) && t2.push(this[n2]);
        return new i(t2);
      },
      remove: function () {
        for (var e2 = 0; e2 < this.length; e2 += 1)
          this[e2].parentNode && this[e2].parentNode.removeChild(this[e2]);
        return this;
      },
      add: function () {
        for (var e2 = [], t2 = arguments.length; t2--; ) e2[t2] = arguments[t2];
        var i2,
          s2,
          a2 = this;
        for (i2 = 0; i2 < e2.length; i2 += 1) {
          var r2 = n(e2[i2]);
          for (s2 = 0; s2 < r2.length; s2 += 1)
            (a2[a2.length] = r2[s2]), (a2.length += 1);
        }
        return a2;
      },
      styles: function () {
        return this[0] ? t.getComputedStyle(this[0], null) : {};
      },
    };
    Object.keys(a).forEach(function (e2) {
      n.fn[e2] = n.fn[e2] || a[e2];
    });
    var r = {
        deleteProps: function (e2) {
          var t2 = e2;
          Object.keys(t2).forEach(function (e3) {
            try {
              t2[e3] = null;
            } catch {}
            try {
              delete t2[e3];
            } catch {}
          });
        },
        nextTick: function (e2, t2) {
          return t2 === void 0 && (t2 = 0), setTimeout(e2, t2);
        },
        now: function () {
          return Date.now();
        },
        getTranslate: function (e2, i2) {
          var n2, s2, a2;
          i2 === void 0 && (i2 = "x");
          var r2 = t.getComputedStyle(e2, null);
          return (
            t.WebKitCSSMatrix
              ? ((s2 = r2.transform || r2.webkitTransform).split(",").length >
                  6 &&
                  (s2 = s2
                    .split(", ")
                    .map(function (e3) {
                      return e3.replace(",", ".");
                    })
                    .join(", ")),
                (a2 = new t.WebKitCSSMatrix(s2 === "none" ? "" : s2)))
              : (n2 = (a2 =
                  r2.MozTransform ||
                  r2.OTransform ||
                  r2.MsTransform ||
                  r2.msTransform ||
                  r2.transform ||
                  r2
                    .getPropertyValue("transform")
                    .replace("translate(", "matrix(1, 0, 0, 1,"))
                  .toString()
                  .split(",")),
            i2 === "x" &&
              (s2 = t.WebKitCSSMatrix
                ? a2.m41
                : n2.length === 16
                ? parseFloat(n2[12])
                : parseFloat(n2[4])),
            i2 === "y" &&
              (s2 = t.WebKitCSSMatrix
                ? a2.m42
                : n2.length === 16
                ? parseFloat(n2[13])
                : parseFloat(n2[5])),
            s2 || 0
          );
        },
        parseUrlQuery: function (e2) {
          var i2,
            n2,
            s2,
            a2,
            r2 = {},
            o2 = e2 || t.location.href;
          if (typeof o2 == "string" && o2.length)
            for (
              a2 = (n2 = (o2 =
                o2.indexOf("?") > -1 ? o2.replace(/\S*\?/, "") : "")
                .split("&")
                .filter(function (e3) {
                  return e3 !== "";
                })).length,
                i2 = 0;
              i2 < a2;
              i2 += 1
            )
              (s2 = n2[i2].replace(/#\S+/g, "").split("=")),
                (r2[decodeURIComponent(s2[0])] =
                  s2[1] === void 0 ? void 0 : decodeURIComponent(s2[1]) || "");
          return r2;
        },
        isObject: function (e2) {
          return (
            typeof e2 == "object" &&
            e2 !== null &&
            e2.constructor &&
            e2.constructor === Object
          );
        },
        extend: function () {
          for (var e2 = [], t2 = arguments.length; t2--; )
            e2[t2] = arguments[t2];
          for (var i2 = Object(e2[0]), n2 = 1; n2 < e2.length; n2 += 1) {
            var s2 = e2[n2];
            if (s2 != null)
              for (
                var a2 = Object.keys(Object(s2)), o2 = 0, l2 = a2.length;
                o2 < l2;
                o2 += 1
              ) {
                var c2 = a2[o2],
                  u2 = Object.getOwnPropertyDescriptor(s2, c2);
                u2 !== void 0 &&
                  u2.enumerable &&
                  (r.isObject(i2[c2]) && r.isObject(s2[c2])
                    ? r.extend(i2[c2], s2[c2])
                    : !r.isObject(i2[c2]) && r.isObject(s2[c2])
                    ? ((i2[c2] = {}), r.extend(i2[c2], s2[c2]))
                    : (i2[c2] = s2[c2]));
              }
          }
          return i2;
        },
      },
      o = {
        touch:
          (t.Modernizr && t.Modernizr.touch === !0) ||
          !!(
            t.navigator.maxTouchPoints > 0 ||
            "ontouchstart" in t ||
            (t.DocumentTouch && e instanceof t.DocumentTouch)
          ),
        pointerEvents:
          !!t.PointerEvent &&
          "maxTouchPoints" in t.navigator &&
          t.navigator.maxTouchPoints > 0,
        observer: "MutationObserver" in t || "WebkitMutationObserver" in t,
        passiveListener: (function () {
          var e2 = !1;
          try {
            var i2 = Object.defineProperty({}, "passive", {
              get: function () {
                e2 = !0;
              },
            });
            t.addEventListener("testPassiveListener", null, i2);
          } catch {}
          return e2;
        })(),
        gestures: "ongesturestart" in t,
      },
      l = function (e2) {
        e2 === void 0 && (e2 = {});
        var t2 = this;
        (t2.params = e2),
          (t2.eventsListeners = {}),
          t2.params &&
            t2.params.on &&
            Object.keys(t2.params.on).forEach(function (e3) {
              t2.on(e3, t2.params.on[e3]);
            });
      },
      c = { components: { configurable: !0 } };
    (l.prototype.on = function (e2, t2, i2) {
      var n2 = this;
      if (typeof t2 != "function") return n2;
      var s2 = i2 ? "unshift" : "push";
      return (
        e2.split(" ").forEach(function (e3) {
          n2.eventsListeners[e3] || (n2.eventsListeners[e3] = []),
            n2.eventsListeners[e3][s2](t2);
        }),
        n2
      );
    }),
      (l.prototype.once = function (e2, t2, i2) {
        var n2 = this;
        if (typeof t2 != "function") return n2;
        function s2() {
          for (var i3 = [], a2 = arguments.length; a2--; )
            i3[a2] = arguments[a2];
          n2.off(e2, s2), s2.f7proxy && delete s2.f7proxy, t2.apply(n2, i3);
        }
        return (s2.f7proxy = t2), n2.on(e2, s2, i2);
      }),
      (l.prototype.off = function (e2, t2) {
        var i2 = this;
        return (
          i2.eventsListeners &&
            e2.split(" ").forEach(function (e3) {
              t2 === void 0
                ? (i2.eventsListeners[e3] = [])
                : i2.eventsListeners[e3] &&
                  i2.eventsListeners[e3].length &&
                  i2.eventsListeners[e3].forEach(function (n2, s2) {
                    (n2 === t2 || (n2.f7proxy && n2.f7proxy === t2)) &&
                      i2.eventsListeners[e3].splice(s2, 1);
                  });
            }),
          i2
        );
      }),
      (l.prototype.emit = function () {
        for (var e2 = [], t2 = arguments.length; t2--; ) e2[t2] = arguments[t2];
        var i2,
          n2,
          s2,
          a2 = this;
        return (
          a2.eventsListeners &&
            (typeof e2[0] == "string" || Array.isArray(e2[0])
              ? ((i2 = e2[0]), (n2 = e2.slice(1, e2.length)), (s2 = a2))
              : ((i2 = e2[0].events),
                (n2 = e2[0].data),
                (s2 = e2[0].context || a2)),
            (Array.isArray(i2) ? i2 : i2.split(" ")).forEach(function (e3) {
              if (a2.eventsListeners && a2.eventsListeners[e3]) {
                var t3 = [];
                a2.eventsListeners[e3].forEach(function (e4) {
                  t3.push(e4);
                }),
                  t3.forEach(function (e4) {
                    e4.apply(s2, n2);
                  });
              }
            })),
          a2
        );
      }),
      (l.prototype.useModulesParams = function (e2) {
        var t2 = this;
        t2.modules &&
          Object.keys(t2.modules).forEach(function (i2) {
            var n2 = t2.modules[i2];
            n2.params && r.extend(e2, n2.params);
          });
      }),
      (l.prototype.useModules = function (e2) {
        e2 === void 0 && (e2 = {});
        var t2 = this;
        t2.modules &&
          Object.keys(t2.modules).forEach(function (i2) {
            var n2 = t2.modules[i2],
              s2 = e2[i2] || {};
            n2.instance &&
              Object.keys(n2.instance).forEach(function (e3) {
                var i3 = n2.instance[e3];
                t2[e3] = typeof i3 == "function" ? i3.bind(t2) : i3;
              }),
              n2.on &&
                t2.on &&
                Object.keys(n2.on).forEach(function (e3) {
                  t2.on(e3, n2.on[e3]);
                }),
              n2.create && n2.create.bind(t2)(s2);
          });
      }),
      (c.components.set = function (e2) {
        this.use && this.use(e2);
      }),
      (l.installModule = function (e2) {
        for (var t2 = [], i2 = arguments.length - 1; i2-- > 0; )
          t2[i2] = arguments[i2 + 1];
        var n2 = this;
        n2.prototype.modules || (n2.prototype.modules = {});
        var s2 =
          e2.name || Object.keys(n2.prototype.modules).length + "_" + r.now();
        return (
          (n2.prototype.modules[s2] = e2),
          e2.proto &&
            Object.keys(e2.proto).forEach(function (t3) {
              n2.prototype[t3] = e2.proto[t3];
            }),
          e2.static &&
            Object.keys(e2.static).forEach(function (t3) {
              n2[t3] = e2.static[t3];
            }),
          e2.install && e2.install.apply(n2, t2),
          n2
        );
      }),
      (l.use = function (e2) {
        for (var t2 = [], i2 = arguments.length - 1; i2-- > 0; )
          t2[i2] = arguments[i2 + 1];
        var n2 = this;
        return Array.isArray(e2)
          ? (e2.forEach(function (e3) {
              return n2.installModule(e3);
            }),
            n2)
          : n2.installModule.apply(n2, [e2].concat(t2));
      }),
      Object.defineProperties(l, c);
    var u,
      d,
      h,
      p,
      f,
      v,
      m,
      g,
      y,
      b,
      w,
      S,
      x,
      C,
      k,
      E = {
        updateSize: function () {
          var e2,
            t2,
            i2 = this.$el;
          (e2 =
            this.params.width !== void 0
              ? this.params.width
              : i2[0].clientWidth),
            (t2 =
              this.params.height !== void 0
                ? this.params.height
                : i2[0].clientHeight),
            (e2 === 0 && this.isHorizontal()) ||
              (t2 === 0 && this.isVertical()) ||
              ((e2 =
                e2 -
                parseInt(i2.css("padding-left"), 10) -
                parseInt(i2.css("padding-right"), 10)),
              (t2 =
                t2 -
                parseInt(i2.css("padding-top"), 10) -
                parseInt(i2.css("padding-bottom"), 10)),
              r.extend(this, {
                width: e2,
                height: t2,
                size: this.isHorizontal() ? e2 : t2,
              }));
        },
        updateSlides: function () {
          var e2 = this.params,
            i2 = this.$wrapperEl,
            n2 = this.size,
            s2 = this.rtlTranslate,
            a2 = this.wrongRTL,
            o2 = this.virtual && e2.virtual.enabled,
            l2 = o2 ? this.virtual.slides.length : this.slides.length,
            c2 = i2.children("." + this.params.slideClass),
            u2 = o2 ? this.virtual.slides.length : c2.length,
            d2 = [],
            h2 = [],
            p2 = [];
          function f2(t2) {
            return !e2.cssMode || t2 !== c2.length - 1;
          }
          var v2 = e2.slidesOffsetBefore;
          typeof v2 == "function" && (v2 = e2.slidesOffsetBefore.call(this));
          var m2 = e2.slidesOffsetAfter;
          typeof m2 == "function" && (m2 = e2.slidesOffsetAfter.call(this));
          var g2 = this.snapGrid.length,
            y2 = this.snapGrid.length,
            b2 = e2.spaceBetween,
            w2 = -v2,
            S2 = 0,
            x2 = 0;
          if (n2 !== void 0) {
            var C2, k2;
            typeof b2 == "string" &&
              b2.indexOf("%") >= 0 &&
              (b2 = (parseFloat(b2.replace("%", "")) / 100) * n2),
              (this.virtualSize = -b2),
              s2
                ? c2.css({ marginLeft: "", marginTop: "" })
                : c2.css({ marginRight: "", marginBottom: "" }),
              e2.slidesPerColumn > 1 &&
                ((C2 =
                  Math.floor(u2 / e2.slidesPerColumn) ===
                  u2 / this.params.slidesPerColumn
                    ? u2
                    : Math.ceil(u2 / e2.slidesPerColumn) * e2.slidesPerColumn),
                e2.slidesPerView !== "auto" &&
                  e2.slidesPerColumnFill === "row" &&
                  (C2 = Math.max(C2, e2.slidesPerView * e2.slidesPerColumn)));
            for (
              var E2,
                T2 = e2.slidesPerColumn,
                _2 = C2 / T2,
                M2 = Math.floor(u2 / e2.slidesPerColumn),
                L2 = 0;
              L2 < u2;
              L2 += 1
            ) {
              k2 = 0;
              var P2 = c2.eq(L2);
              if (e2.slidesPerColumn > 1) {
                var I2 = void 0,
                  D2 = void 0,
                  A2 = void 0;
                if (e2.slidesPerColumnFill === "row" && e2.slidesPerGroup > 1) {
                  var z2 = Math.floor(
                      L2 / (e2.slidesPerGroup * e2.slidesPerColumn)
                    ),
                    O2 = L2 - e2.slidesPerColumn * e2.slidesPerGroup * z2,
                    B2 =
                      z2 === 0
                        ? e2.slidesPerGroup
                        : Math.min(
                            Math.ceil((u2 - z2 * T2 * e2.slidesPerGroup) / T2),
                            e2.slidesPerGroup
                          );
                  (I2 =
                    (D2 =
                      O2 -
                      (A2 = Math.floor(O2 / B2)) * B2 +
                      z2 * e2.slidesPerGroup) +
                    (A2 * C2) / T2),
                    P2.css({
                      "-webkit-box-ordinal-group": I2,
                      "-moz-box-ordinal-group": I2,
                      "-ms-flex-order": I2,
                      "-webkit-order": I2,
                      order: I2,
                    });
                } else
                  e2.slidesPerColumnFill === "column"
                    ? ((A2 = L2 - (D2 = Math.floor(L2 / T2)) * T2),
                      (D2 > M2 || (D2 === M2 && A2 === T2 - 1)) &&
                        (A2 += 1) >= T2 &&
                        ((A2 = 0), (D2 += 1)))
                    : (D2 = L2 - (A2 = Math.floor(L2 / _2)) * _2);
                P2.css(
                  "margin-" + (this.isHorizontal() ? "top" : "left"),
                  A2 !== 0 && e2.spaceBetween && e2.spaceBetween + "px"
                );
              }
              if (P2.css("display") !== "none") {
                if (e2.slidesPerView === "auto") {
                  var N2 = t.getComputedStyle(P2[0], null),
                    q2 = P2[0].style.transform,
                    $3 = P2[0].style.webkitTransform;
                  if (
                    (q2 && (P2[0].style.transform = "none"),
                    $3 && (P2[0].style.webkitTransform = "none"),
                    e2.roundLengths)
                  )
                    k2 = this.isHorizontal()
                      ? P2.outerWidth(!0)
                      : P2.outerHeight(!0);
                  else if (this.isHorizontal()) {
                    var H2 = parseFloat(N2.getPropertyValue("width")),
                      F2 = parseFloat(N2.getPropertyValue("padding-left")),
                      V2 = parseFloat(N2.getPropertyValue("padding-right")),
                      R2 = parseFloat(N2.getPropertyValue("margin-left")),
                      j2 = parseFloat(N2.getPropertyValue("margin-right")),
                      X2 = N2.getPropertyValue("box-sizing");
                    k2 =
                      X2 && X2 === "border-box"
                        ? H2 + R2 + j2
                        : H2 + F2 + V2 + R2 + j2;
                  } else {
                    var G2 = parseFloat(N2.getPropertyValue("height")),
                      W2 = parseFloat(N2.getPropertyValue("padding-top")),
                      Y2 = parseFloat(N2.getPropertyValue("padding-bottom")),
                      U2 = parseFloat(N2.getPropertyValue("margin-top")),
                      K2 = parseFloat(N2.getPropertyValue("margin-bottom")),
                      Q2 = N2.getPropertyValue("box-sizing");
                    k2 =
                      Q2 && Q2 === "border-box"
                        ? G2 + U2 + K2
                        : G2 + W2 + Y2 + U2 + K2;
                  }
                  q2 && (P2[0].style.transform = q2),
                    $3 && (P2[0].style.webkitTransform = $3),
                    e2.roundLengths && (k2 = Math.floor(k2));
                } else
                  (k2 = (n2 - (e2.slidesPerView - 1) * b2) / e2.slidesPerView),
                    e2.roundLengths && (k2 = Math.floor(k2)),
                    c2[L2] &&
                      (this.isHorizontal()
                        ? (c2[L2].style.width = k2 + "px")
                        : (c2[L2].style.height = k2 + "px"));
                c2[L2] && (c2[L2].swiperSlideSize = k2),
                  p2.push(k2),
                  e2.centeredSlides
                    ? ((w2 = w2 + k2 / 2 + S2 / 2 + b2),
                      S2 === 0 && L2 !== 0 && (w2 = w2 - n2 / 2 - b2),
                      L2 === 0 && (w2 = w2 - n2 / 2 - b2),
                      Math.abs(w2) < 0.001 && (w2 = 0),
                      e2.roundLengths && (w2 = Math.floor(w2)),
                      x2 % e2.slidesPerGroup == 0 && d2.push(w2),
                      h2.push(w2))
                    : (e2.roundLengths && (w2 = Math.floor(w2)),
                      (x2 - Math.min(this.params.slidesPerGroupSkip, x2)) %
                        this.params.slidesPerGroup ==
                        0 && d2.push(w2),
                      h2.push(w2),
                      (w2 = w2 + k2 + b2)),
                  (this.virtualSize += k2 + b2),
                  (S2 = k2),
                  (x2 += 1);
              }
            }
            if (
              ((this.virtualSize = Math.max(this.virtualSize, n2) + m2),
              s2 &&
                a2 &&
                (e2.effect === "slide" || e2.effect === "coverflow") &&
                i2.css({ width: this.virtualSize + e2.spaceBetween + "px" }),
              e2.setWrapperSize &&
                (this.isHorizontal()
                  ? i2.css({ width: this.virtualSize + e2.spaceBetween + "px" })
                  : i2.css({
                      height: this.virtualSize + e2.spaceBetween + "px",
                    })),
              e2.slidesPerColumn > 1 &&
                ((this.virtualSize = (k2 + e2.spaceBetween) * C2),
                (this.virtualSize =
                  Math.ceil(this.virtualSize / e2.slidesPerColumn) -
                  e2.spaceBetween),
                this.isHorizontal()
                  ? i2.css({ width: this.virtualSize + e2.spaceBetween + "px" })
                  : i2.css({
                      height: this.virtualSize + e2.spaceBetween + "px",
                    }),
                e2.centeredSlides))
            ) {
              E2 = [];
              for (var Z2 = 0; Z2 < d2.length; Z2 += 1) {
                var J2 = d2[Z2];
                e2.roundLengths && (J2 = Math.floor(J2)),
                  d2[Z2] < this.virtualSize + d2[0] && E2.push(J2);
              }
              d2 = E2;
            }
            if (!e2.centeredSlides) {
              E2 = [];
              for (var ee2 = 0; ee2 < d2.length; ee2 += 1) {
                var te2 = d2[ee2];
                e2.roundLengths && (te2 = Math.floor(te2)),
                  d2[ee2] <= this.virtualSize - n2 && E2.push(te2);
              }
              (d2 = E2),
                Math.floor(this.virtualSize - n2) -
                  Math.floor(d2[d2.length - 1]) >
                  1 && d2.push(this.virtualSize - n2);
            }
            if (
              (d2.length === 0 && (d2 = [0]),
              e2.spaceBetween !== 0 &&
                (this.isHorizontal()
                  ? s2
                    ? c2.filter(f2).css({ marginLeft: b2 + "px" })
                    : c2.filter(f2).css({ marginRight: b2 + "px" })
                  : c2.filter(f2).css({ marginBottom: b2 + "px" })),
              e2.centeredSlides && e2.centeredSlidesBounds)
            ) {
              var ie2 = 0;
              p2.forEach(function (t2) {
                ie2 += t2 + (e2.spaceBetween ? e2.spaceBetween : 0);
              });
              var ne2 = (ie2 -= e2.spaceBetween) - n2;
              d2 = d2.map(function (e3) {
                return e3 < 0 ? -v2 : e3 > ne2 ? ne2 + m2 : e3;
              });
            }
            if (e2.centerInsufficientSlides) {
              var se2 = 0;
              if (
                (p2.forEach(function (t2) {
                  se2 += t2 + (e2.spaceBetween ? e2.spaceBetween : 0);
                }),
                (se2 -= e2.spaceBetween) < n2)
              ) {
                var ae2 = (n2 - se2) / 2;
                d2.forEach(function (e3, t2) {
                  d2[t2] = e3 - ae2;
                }),
                  h2.forEach(function (e3, t2) {
                    h2[t2] = e3 + ae2;
                  });
              }
            }
            r.extend(this, {
              slides: c2,
              snapGrid: d2,
              slidesGrid: h2,
              slidesSizesGrid: p2,
            }),
              u2 !== l2 && this.emit("slidesLengthChange"),
              d2.length !== g2 &&
                (this.params.watchOverflow && this.checkOverflow(),
                this.emit("snapGridLengthChange")),
              h2.length !== y2 && this.emit("slidesGridLengthChange"),
              (e2.watchSlidesProgress || e2.watchSlidesVisibility) &&
                this.updateSlidesOffset();
          }
        },
        updateAutoHeight: function (e2) {
          var t2,
            i2 = [],
            n2 = 0;
          if (
            (typeof e2 == "number"
              ? this.setTransition(e2)
              : e2 === !0 && this.setTransition(this.params.speed),
            this.params.slidesPerView !== "auto" &&
              this.params.slidesPerView > 1)
          )
            if (this.params.centeredSlides)
              this.visibleSlides.each(function (e3, t3) {
                i2.push(t3);
              });
            else
              for (t2 = 0; t2 < Math.ceil(this.params.slidesPerView); t2 += 1) {
                var s2 = this.activeIndex + t2;
                if (s2 > this.slides.length) break;
                i2.push(this.slides.eq(s2)[0]);
              }
          else i2.push(this.slides.eq(this.activeIndex)[0]);
          for (t2 = 0; t2 < i2.length; t2 += 1)
            if (i2[t2] !== void 0) {
              var a2 = i2[t2].offsetHeight;
              n2 = a2 > n2 ? a2 : n2;
            }
          n2 && this.$wrapperEl.css("height", n2 + "px");
        },
        updateSlidesOffset: function () {
          for (var e2 = this.slides, t2 = 0; t2 < e2.length; t2 += 1)
            e2[t2].swiperSlideOffset = this.isHorizontal()
              ? e2[t2].offsetLeft
              : e2[t2].offsetTop;
        },
        updateSlidesProgress: function (e2) {
          e2 === void 0 && (e2 = (this && this.translate) || 0);
          var t2 = this.params,
            i2 = this.slides,
            s2 = this.rtlTranslate;
          if (i2.length !== 0) {
            i2[0].swiperSlideOffset === void 0 && this.updateSlidesOffset();
            var a2 = -e2;
            s2 && (a2 = e2),
              i2.removeClass(t2.slideVisibleClass),
              (this.visibleSlidesIndexes = []),
              (this.visibleSlides = []);
            for (var r2 = 0; r2 < i2.length; r2 += 1) {
              var o2 = i2[r2],
                l2 =
                  (a2 +
                    (t2.centeredSlides ? this.minTranslate() : 0) -
                    o2.swiperSlideOffset) /
                  (o2.swiperSlideSize + t2.spaceBetween);
              if (
                t2.watchSlidesVisibility ||
                (t2.centeredSlides && t2.autoHeight)
              ) {
                var c2 = -(a2 - o2.swiperSlideOffset),
                  u2 = c2 + this.slidesSizesGrid[r2];
                ((c2 >= 0 && c2 < this.size - 1) ||
                  (u2 > 1 && u2 <= this.size) ||
                  (c2 <= 0 && u2 >= this.size)) &&
                  (this.visibleSlides.push(o2),
                  this.visibleSlidesIndexes.push(r2),
                  i2.eq(r2).addClass(t2.slideVisibleClass));
              }
              o2.progress = s2 ? -l2 : l2;
            }
            this.visibleSlides = n(this.visibleSlides);
          }
        },
        updateProgress: function (e2) {
          if (e2 === void 0) {
            var t2 = this.rtlTranslate ? -1 : 1;
            e2 = (this && this.translate && this.translate * t2) || 0;
          }
          var i2 = this.params,
            n2 = this.maxTranslate() - this.minTranslate(),
            s2 = this.progress,
            a2 = this.isBeginning,
            o2 = this.isEnd,
            l2 = a2,
            c2 = o2;
          n2 === 0
            ? ((s2 = 0), (a2 = !0), (o2 = !0))
            : ((a2 = (s2 = (e2 - this.minTranslate()) / n2) <= 0),
              (o2 = s2 >= 1)),
            r.extend(this, { progress: s2, isBeginning: a2, isEnd: o2 }),
            (i2.watchSlidesProgress ||
              i2.watchSlidesVisibility ||
              (i2.centeredSlides && i2.autoHeight)) &&
              this.updateSlidesProgress(e2),
            a2 && !l2 && this.emit("reachBeginning toEdge"),
            o2 && !c2 && this.emit("reachEnd toEdge"),
            ((l2 && !a2) || (c2 && !o2)) && this.emit("fromEdge"),
            this.emit("progress", s2);
        },
        updateSlidesClasses: function () {
          var e2,
            t2 = this.slides,
            i2 = this.params,
            n2 = this.$wrapperEl,
            s2 = this.activeIndex,
            a2 = this.realIndex,
            r2 = this.virtual && i2.virtual.enabled;
          t2.removeClass(
            i2.slideActiveClass +
              " " +
              i2.slideNextClass +
              " " +
              i2.slidePrevClass +
              " " +
              i2.slideDuplicateActiveClass +
              " " +
              i2.slideDuplicateNextClass +
              " " +
              i2.slideDuplicatePrevClass
          ),
            (e2 = r2
              ? this.$wrapperEl.find(
                  "." + i2.slideClass + '[data-swiper-slide-index="' + s2 + '"]'
                )
              : t2.eq(s2)).addClass(i2.slideActiveClass),
            i2.loop &&
              (e2.hasClass(i2.slideDuplicateClass)
                ? n2
                    .children(
                      "." +
                        i2.slideClass +
                        ":not(." +
                        i2.slideDuplicateClass +
                        ')[data-swiper-slide-index="' +
                        a2 +
                        '"]'
                    )
                    .addClass(i2.slideDuplicateActiveClass)
                : n2
                    .children(
                      "." +
                        i2.slideClass +
                        "." +
                        i2.slideDuplicateClass +
                        '[data-swiper-slide-index="' +
                        a2 +
                        '"]'
                    )
                    .addClass(i2.slideDuplicateActiveClass));
          var o2 = e2
            .nextAll("." + i2.slideClass)
            .eq(0)
            .addClass(i2.slideNextClass);
          i2.loop &&
            o2.length === 0 &&
            (o2 = t2.eq(0)).addClass(i2.slideNextClass);
          var l2 = e2
            .prevAll("." + i2.slideClass)
            .eq(0)
            .addClass(i2.slidePrevClass);
          i2.loop &&
            l2.length === 0 &&
            (l2 = t2.eq(-1)).addClass(i2.slidePrevClass),
            i2.loop &&
              (o2.hasClass(i2.slideDuplicateClass)
                ? n2
                    .children(
                      "." +
                        i2.slideClass +
                        ":not(." +
                        i2.slideDuplicateClass +
                        ')[data-swiper-slide-index="' +
                        o2.attr("data-swiper-slide-index") +
                        '"]'
                    )
                    .addClass(i2.slideDuplicateNextClass)
                : n2
                    .children(
                      "." +
                        i2.slideClass +
                        "." +
                        i2.slideDuplicateClass +
                        '[data-swiper-slide-index="' +
                        o2.attr("data-swiper-slide-index") +
                        '"]'
                    )
                    .addClass(i2.slideDuplicateNextClass),
              l2.hasClass(i2.slideDuplicateClass)
                ? n2
                    .children(
                      "." +
                        i2.slideClass +
                        ":not(." +
                        i2.slideDuplicateClass +
                        ')[data-swiper-slide-index="' +
                        l2.attr("data-swiper-slide-index") +
                        '"]'
                    )
                    .addClass(i2.slideDuplicatePrevClass)
                : n2
                    .children(
                      "." +
                        i2.slideClass +
                        "." +
                        i2.slideDuplicateClass +
                        '[data-swiper-slide-index="' +
                        l2.attr("data-swiper-slide-index") +
                        '"]'
                    )
                    .addClass(i2.slideDuplicatePrevClass));
        },
        updateActiveIndex: function (e2) {
          var t2,
            i2 = this.rtlTranslate ? this.translate : -this.translate,
            n2 = this.slidesGrid,
            s2 = this.snapGrid,
            a2 = this.params,
            o2 = this.activeIndex,
            l2 = this.realIndex,
            c2 = this.snapIndex,
            u2 = e2;
          if (u2 === void 0) {
            for (var d2 = 0; d2 < n2.length; d2 += 1)
              n2[d2 + 1] !== void 0
                ? i2 >= n2[d2] && i2 < n2[d2 + 1] - (n2[d2 + 1] - n2[d2]) / 2
                  ? (u2 = d2)
                  : i2 >= n2[d2] && i2 < n2[d2 + 1] && (u2 = d2 + 1)
                : i2 >= n2[d2] && (u2 = d2);
            a2.normalizeSlideIndex && (u2 < 0 || u2 === void 0) && (u2 = 0);
          }
          if (s2.indexOf(i2) >= 0) t2 = s2.indexOf(i2);
          else {
            var h2 = Math.min(a2.slidesPerGroupSkip, u2);
            t2 = h2 + Math.floor((u2 - h2) / a2.slidesPerGroup);
          }
          if ((t2 >= s2.length && (t2 = s2.length - 1), u2 !== o2)) {
            var p2 = parseInt(
              this.slides.eq(u2).attr("data-swiper-slide-index") || u2,
              10
            );
            r.extend(this, {
              snapIndex: t2,
              realIndex: p2,
              previousIndex: o2,
              activeIndex: u2,
            }),
              this.emit("activeIndexChange"),
              this.emit("snapIndexChange"),
              l2 !== p2 && this.emit("realIndexChange"),
              (this.initialized || this.params.runCallbacksOnInit) &&
                this.emit("slideChange");
          } else
            t2 !== c2 && ((this.snapIndex = t2), this.emit("snapIndexChange"));
        },
        updateClickedSlide: function (e2) {
          var t2 = this.params,
            i2 = n(e2.target).closest("." + t2.slideClass)[0],
            s2 = !1;
          if (i2)
            for (var a2 = 0; a2 < this.slides.length; a2 += 1)
              this.slides[a2] === i2 && (s2 = !0);
          if (!i2 || !s2)
            return (
              (this.clickedSlide = void 0), void (this.clickedIndex = void 0)
            );
          (this.clickedSlide = i2),
            this.virtual && this.params.virtual.enabled
              ? (this.clickedIndex = parseInt(
                  n(i2).attr("data-swiper-slide-index"),
                  10
                ))
              : (this.clickedIndex = n(i2).index()),
            t2.slideToClickedSlide &&
              this.clickedIndex !== void 0 &&
              this.clickedIndex !== this.activeIndex &&
              this.slideToClickedSlide();
        },
      },
      T = {
        getTranslate: function (e2) {
          e2 === void 0 && (e2 = this.isHorizontal() ? "x" : "y");
          var t2 = this.params,
            i2 = this.rtlTranslate,
            n2 = this.translate,
            s2 = this.$wrapperEl;
          if (t2.virtualTranslate) return i2 ? -n2 : n2;
          if (t2.cssMode) return n2;
          var a2 = r.getTranslate(s2[0], e2);
          return i2 && (a2 = -a2), a2 || 0;
        },
        setTranslate: function (e2, t2) {
          var i2 = this.rtlTranslate,
            n2 = this.params,
            s2 = this.$wrapperEl,
            a2 = this.wrapperEl,
            r2 = this.progress,
            o2 = 0,
            l2 = 0;
          this.isHorizontal() ? (o2 = i2 ? -e2 : e2) : (l2 = e2),
            n2.roundLengths && ((o2 = Math.floor(o2)), (l2 = Math.floor(l2))),
            n2.cssMode
              ? (a2[this.isHorizontal() ? "scrollLeft" : "scrollTop"] =
                  this.isHorizontal() ? -o2 : -l2)
              : n2.virtualTranslate ||
                s2.transform("translate3d(" + o2 + "px, " + l2 + "px, 0px)"),
            (this.previousTranslate = this.translate),
            (this.translate = this.isHorizontal() ? o2 : l2);
          var c2 = this.maxTranslate() - this.minTranslate();
          (c2 === 0 ? 0 : (e2 - this.minTranslate()) / c2) !== r2 &&
            this.updateProgress(e2),
            this.emit("setTranslate", this.translate, t2);
        },
        minTranslate: function () {
          return -this.snapGrid[0];
        },
        maxTranslate: function () {
          return -this.snapGrid[this.snapGrid.length - 1];
        },
        translateTo: function (e2, t2, i2, n2, s2) {
          var a2;
          e2 === void 0 && (e2 = 0),
            t2 === void 0 && (t2 = this.params.speed),
            i2 === void 0 && (i2 = !0),
            n2 === void 0 && (n2 = !0);
          var r2 = this,
            o2 = r2.params,
            l2 = r2.wrapperEl;
          if (r2.animating && o2.preventInteractionOnTransition) return !1;
          var c2,
            u2 = r2.minTranslate(),
            d2 = r2.maxTranslate();
          if (
            ((c2 = n2 && e2 > u2 ? u2 : n2 && e2 < d2 ? d2 : e2),
            r2.updateProgress(c2),
            o2.cssMode)
          ) {
            var h2 = r2.isHorizontal();
            return (
              t2 === 0
                ? (l2[h2 ? "scrollLeft" : "scrollTop"] = -c2)
                : l2.scrollTo
                ? l2.scrollTo(
                    (((a2 = {})[h2 ? "left" : "top"] = -c2),
                    (a2.behavior = "smooth"),
                    a2)
                  )
                : (l2[h2 ? "scrollLeft" : "scrollTop"] = -c2),
              !0
            );
          }
          return (
            t2 === 0
              ? (r2.setTransition(0),
                r2.setTranslate(c2),
                i2 &&
                  (r2.emit("beforeTransitionStart", t2, s2),
                  r2.emit("transitionEnd")))
              : (r2.setTransition(t2),
                r2.setTranslate(c2),
                i2 &&
                  (r2.emit("beforeTransitionStart", t2, s2),
                  r2.emit("transitionStart")),
                r2.animating ||
                  ((r2.animating = !0),
                  r2.onTranslateToWrapperTransitionEnd ||
                    (r2.onTranslateToWrapperTransitionEnd = function (e3) {
                      r2 &&
                        !r2.destroyed &&
                        e3.target === this &&
                        (r2.$wrapperEl[0].removeEventListener(
                          "transitionend",
                          r2.onTranslateToWrapperTransitionEnd
                        ),
                        r2.$wrapperEl[0].removeEventListener(
                          "webkitTransitionEnd",
                          r2.onTranslateToWrapperTransitionEnd
                        ),
                        (r2.onTranslateToWrapperTransitionEnd = null),
                        delete r2.onTranslateToWrapperTransitionEnd,
                        i2 && r2.emit("transitionEnd"));
                    }),
                  r2.$wrapperEl[0].addEventListener(
                    "transitionend",
                    r2.onTranslateToWrapperTransitionEnd
                  ),
                  r2.$wrapperEl[0].addEventListener(
                    "webkitTransitionEnd",
                    r2.onTranslateToWrapperTransitionEnd
                  ))),
            !0
          );
        },
      },
      _ = {
        slideTo: function (e2, t2, i2, n2) {
          var s2;
          e2 === void 0 && (e2 = 0),
            t2 === void 0 && (t2 = this.params.speed),
            i2 === void 0 && (i2 = !0);
          var a2 = this,
            r2 = e2;
          r2 < 0 && (r2 = 0);
          var o2 = a2.params,
            l2 = a2.snapGrid,
            c2 = a2.slidesGrid,
            u2 = a2.previousIndex,
            d2 = a2.activeIndex,
            h2 = a2.rtlTranslate,
            p2 = a2.wrapperEl;
          if (a2.animating && o2.preventInteractionOnTransition) return !1;
          var f2 = Math.min(a2.params.slidesPerGroupSkip, r2),
            v2 = f2 + Math.floor((r2 - f2) / a2.params.slidesPerGroup);
          v2 >= l2.length && (v2 = l2.length - 1),
            (d2 || o2.initialSlide || 0) === (u2 || 0) &&
              i2 &&
              a2.emit("beforeSlideChangeStart");
          var m2,
            g2 = -l2[v2];
          if ((a2.updateProgress(g2), o2.normalizeSlideIndex))
            for (var y2 = 0; y2 < c2.length; y2 += 1)
              -Math.floor(100 * g2) >= Math.floor(100 * c2[y2]) && (r2 = y2);
          if (
            a2.initialized &&
            r2 !== d2 &&
            ((!a2.allowSlideNext &&
              g2 < a2.translate &&
              g2 < a2.minTranslate()) ||
              (!a2.allowSlidePrev &&
                g2 > a2.translate &&
                g2 > a2.maxTranslate() &&
                (d2 || 0) !== r2))
          )
            return !1;
          if (
            ((m2 = r2 > d2 ? "next" : r2 < d2 ? "prev" : "reset"),
            (h2 && -g2 === a2.translate) || (!h2 && g2 === a2.translate))
          )
            return (
              a2.updateActiveIndex(r2),
              o2.autoHeight && a2.updateAutoHeight(),
              a2.updateSlidesClasses(),
              o2.effect !== "slide" && a2.setTranslate(g2),
              m2 !== "reset" &&
                (a2.transitionStart(i2, m2), a2.transitionEnd(i2, m2)),
              !1
            );
          if (o2.cssMode) {
            var b2 = a2.isHorizontal(),
              w2 = -g2;
            return (
              h2 && (w2 = p2.scrollWidth - p2.offsetWidth - w2),
              t2 === 0
                ? (p2[b2 ? "scrollLeft" : "scrollTop"] = w2)
                : p2.scrollTo
                ? p2.scrollTo(
                    (((s2 = {})[b2 ? "left" : "top"] = w2),
                    (s2.behavior = "smooth"),
                    s2)
                  )
                : (p2[b2 ? "scrollLeft" : "scrollTop"] = w2),
              !0
            );
          }
          return (
            t2 === 0
              ? (a2.setTransition(0),
                a2.setTranslate(g2),
                a2.updateActiveIndex(r2),
                a2.updateSlidesClasses(),
                a2.emit("beforeTransitionStart", t2, n2),
                a2.transitionStart(i2, m2),
                a2.transitionEnd(i2, m2))
              : (a2.setTransition(t2),
                a2.setTranslate(g2),
                a2.updateActiveIndex(r2),
                a2.updateSlidesClasses(),
                a2.emit("beforeTransitionStart", t2, n2),
                a2.transitionStart(i2, m2),
                a2.animating ||
                  ((a2.animating = !0),
                  a2.onSlideToWrapperTransitionEnd ||
                    (a2.onSlideToWrapperTransitionEnd = function (e3) {
                      a2 &&
                        !a2.destroyed &&
                        e3.target === this &&
                        (a2.$wrapperEl[0].removeEventListener(
                          "transitionend",
                          a2.onSlideToWrapperTransitionEnd
                        ),
                        a2.$wrapperEl[0].removeEventListener(
                          "webkitTransitionEnd",
                          a2.onSlideToWrapperTransitionEnd
                        ),
                        (a2.onSlideToWrapperTransitionEnd = null),
                        delete a2.onSlideToWrapperTransitionEnd,
                        a2.transitionEnd(i2, m2));
                    }),
                  a2.$wrapperEl[0].addEventListener(
                    "transitionend",
                    a2.onSlideToWrapperTransitionEnd
                  ),
                  a2.$wrapperEl[0].addEventListener(
                    "webkitTransitionEnd",
                    a2.onSlideToWrapperTransitionEnd
                  ))),
            !0
          );
        },
        slideToLoop: function (e2, t2, i2, n2) {
          e2 === void 0 && (e2 = 0),
            t2 === void 0 && (t2 = this.params.speed),
            i2 === void 0 && (i2 = !0);
          var s2 = e2;
          return (
            this.params.loop && (s2 += this.loopedSlides),
            this.slideTo(s2, t2, i2, n2)
          );
        },
        slideNext: function (e2, t2, i2) {
          e2 === void 0 && (e2 = this.params.speed), t2 === void 0 && (t2 = !0);
          var n2 = this.params,
            s2 = this.animating,
            a2 =
              this.activeIndex < n2.slidesPerGroupSkip ? 1 : n2.slidesPerGroup;
          if (n2.loop) {
            if (s2) return !1;
            this.loopFix(), (this._clientLeft = this.$wrapperEl[0].clientLeft);
          }
          return this.slideTo(this.activeIndex + a2, e2, t2, i2);
        },
        slidePrev: function (e2, t2, i2) {
          e2 === void 0 && (e2 = this.params.speed), t2 === void 0 && (t2 = !0);
          var n2 = this.params,
            s2 = this.animating,
            a2 = this.snapGrid,
            r2 = this.slidesGrid,
            o2 = this.rtlTranslate;
          if (n2.loop) {
            if (s2) return !1;
            this.loopFix(), (this._clientLeft = this.$wrapperEl[0].clientLeft);
          }
          function l2(e3) {
            return e3 < 0 ? -Math.floor(Math.abs(e3)) : Math.floor(e3);
          }
          var c2,
            u2 = l2(o2 ? this.translate : -this.translate),
            d2 = a2.map(function (e3) {
              return l2(e3);
            }),
            h2 =
              (r2.map(function (e3) {
                return l2(e3);
              }),
              a2[d2.indexOf(u2)],
              a2[d2.indexOf(u2) - 1]);
          return (
            h2 === void 0 &&
              n2.cssMode &&
              a2.forEach(function (e3) {
                !h2 && u2 >= e3 && (h2 = e3);
              }),
            h2 !== void 0 &&
              (c2 = r2.indexOf(h2)) < 0 &&
              (c2 = this.activeIndex - 1),
            this.slideTo(c2, e2, t2, i2)
          );
        },
        slideReset: function (e2, t2, i2) {
          return (
            e2 === void 0 && (e2 = this.params.speed),
            t2 === void 0 && (t2 = !0),
            this.slideTo(this.activeIndex, e2, t2, i2)
          );
        },
        slideToClosest: function (e2, t2, i2, n2) {
          e2 === void 0 && (e2 = this.params.speed),
            t2 === void 0 && (t2 = !0),
            n2 === void 0 && (n2 = 0.5);
          var s2 = this.activeIndex,
            a2 = Math.min(this.params.slidesPerGroupSkip, s2),
            r2 = a2 + Math.floor((s2 - a2) / this.params.slidesPerGroup),
            o2 = this.rtlTranslate ? this.translate : -this.translate;
          if (o2 >= this.snapGrid[r2]) {
            var l2 = this.snapGrid[r2];
            o2 - l2 > (this.snapGrid[r2 + 1] - l2) * n2 &&
              (s2 += this.params.slidesPerGroup);
          } else {
            var c2 = this.snapGrid[r2 - 1];
            o2 - c2 <= (this.snapGrid[r2] - c2) * n2 &&
              (s2 -= this.params.slidesPerGroup);
          }
          return (
            (s2 = Math.max(s2, 0)),
            (s2 = Math.min(s2, this.slidesGrid.length - 1)),
            this.slideTo(s2, e2, t2, i2)
          );
        },
        slideToClickedSlide: function () {
          var e2,
            t2 = this,
            i2 = t2.params,
            s2 = t2.$wrapperEl,
            a2 =
              i2.slidesPerView === "auto"
                ? t2.slidesPerViewDynamic()
                : i2.slidesPerView,
            o2 = t2.clickedIndex;
          if (i2.loop) {
            if (t2.animating) return;
            (e2 = parseInt(
              n(t2.clickedSlide).attr("data-swiper-slide-index"),
              10
            )),
              i2.centeredSlides
                ? o2 < t2.loopedSlides - a2 / 2 ||
                  o2 > t2.slides.length - t2.loopedSlides + a2 / 2
                  ? (t2.loopFix(),
                    (o2 = s2
                      .children(
                        "." +
                          i2.slideClass +
                          '[data-swiper-slide-index="' +
                          e2 +
                          '"]:not(.' +
                          i2.slideDuplicateClass +
                          ")"
                      )
                      .eq(0)
                      .index()),
                    r.nextTick(function () {
                      t2.slideTo(o2);
                    }))
                  : t2.slideTo(o2)
                : o2 > t2.slides.length - a2
                ? (t2.loopFix(),
                  (o2 = s2
                    .children(
                      "." +
                        i2.slideClass +
                        '[data-swiper-slide-index="' +
                        e2 +
                        '"]:not(.' +
                        i2.slideDuplicateClass +
                        ")"
                    )
                    .eq(0)
                    .index()),
                  r.nextTick(function () {
                    t2.slideTo(o2);
                  }))
                : t2.slideTo(o2);
          } else t2.slideTo(o2);
        },
      },
      M = {
        loopCreate: function () {
          var t2 = this,
            i2 = t2.params,
            s2 = t2.$wrapperEl;
          s2.children(
            "." + i2.slideClass + "." + i2.slideDuplicateClass
          ).remove();
          var a2 = s2.children("." + i2.slideClass);
          if (i2.loopFillGroupWithBlank) {
            var r2 = i2.slidesPerGroup - (a2.length % i2.slidesPerGroup);
            if (r2 !== i2.slidesPerGroup) {
              for (var o2 = 0; o2 < r2; o2 += 1) {
                var l2 = n(e.createElement("div")).addClass(
                  i2.slideClass + " " + i2.slideBlankClass
                );
                s2.append(l2);
              }
              a2 = s2.children("." + i2.slideClass);
            }
          }
          i2.slidesPerView !== "auto" ||
            i2.loopedSlides ||
            (i2.loopedSlides = a2.length),
            (t2.loopedSlides = Math.ceil(
              parseFloat(i2.loopedSlides || i2.slidesPerView, 10)
            )),
            (t2.loopedSlides += i2.loopAdditionalSlides),
            t2.loopedSlides > a2.length && (t2.loopedSlides = a2.length);
          var c2 = [],
            u2 = [];
          a2.each(function (e2, i3) {
            var s3 = n(i3);
            e2 < t2.loopedSlides && u2.push(i3),
              e2 < a2.length &&
                e2 >= a2.length - t2.loopedSlides &&
                c2.push(i3),
              s3.attr("data-swiper-slide-index", e2);
          });
          for (var d2 = 0; d2 < u2.length; d2 += 1)
            s2.append(n(u2[d2].cloneNode(!0)).addClass(i2.slideDuplicateClass));
          for (var h2 = c2.length - 1; h2 >= 0; h2 -= 1)
            s2.prepend(
              n(c2[h2].cloneNode(!0)).addClass(i2.slideDuplicateClass)
            );
        },
        loopFix: function () {
          this.emit("beforeLoopFix");
          var e2,
            t2 = this.activeIndex,
            i2 = this.slides,
            n2 = this.loopedSlides,
            s2 = this.allowSlidePrev,
            a2 = this.allowSlideNext,
            r2 = this.snapGrid,
            o2 = this.rtlTranslate;
          (this.allowSlidePrev = !0), (this.allowSlideNext = !0);
          var l2 = -r2[t2] - this.getTranslate();
          t2 < n2
            ? ((e2 = i2.length - 3 * n2 + t2),
              (e2 += n2),
              this.slideTo(e2, 0, !1, !0) &&
                l2 !== 0 &&
                this.setTranslate((o2 ? -this.translate : this.translate) - l2))
            : t2 >= i2.length - n2 &&
              ((e2 = -i2.length + t2 + n2),
              (e2 += n2),
              this.slideTo(e2, 0, !1, !0) &&
                l2 !== 0 &&
                this.setTranslate(
                  (o2 ? -this.translate : this.translate) - l2
                )),
            (this.allowSlidePrev = s2),
            (this.allowSlideNext = a2),
            this.emit("loopFix");
        },
        loopDestroy: function () {
          var e2 = this.$wrapperEl,
            t2 = this.params,
            i2 = this.slides;
          e2
            .children(
              "." +
                t2.slideClass +
                "." +
                t2.slideDuplicateClass +
                ",." +
                t2.slideClass +
                "." +
                t2.slideBlankClass
            )
            .remove(),
            i2.removeAttr("data-swiper-slide-index");
        },
      },
      L = {
        setGrabCursor: function (e2) {
          if (
            !(
              o.touch ||
              !this.params.simulateTouch ||
              (this.params.watchOverflow && this.isLocked) ||
              this.params.cssMode
            )
          ) {
            var t2 = this.el;
            (t2.style.cursor = "move"),
              (t2.style.cursor = e2 ? "-webkit-grabbing" : "-webkit-grab"),
              (t2.style.cursor = e2 ? "-moz-grabbin" : "-moz-grab"),
              (t2.style.cursor = e2 ? "grabbing" : "grab");
          }
        },
        unsetGrabCursor: function () {
          o.touch ||
            (this.params.watchOverflow && this.isLocked) ||
            this.params.cssMode ||
            (this.el.style.cursor = "");
        },
      },
      P = {
        appendSlide: function (e2) {
          var t2 = this.$wrapperEl,
            i2 = this.params;
          if (
            (i2.loop && this.loopDestroy(),
            typeof e2 == "object" && "length" in e2)
          )
            for (var n2 = 0; n2 < e2.length; n2 += 1)
              e2[n2] && t2.append(e2[n2]);
          else t2.append(e2);
          i2.loop && this.loopCreate(),
            (i2.observer && o.observer) || this.update();
        },
        prependSlide: function (e2) {
          var t2 = this.params,
            i2 = this.$wrapperEl,
            n2 = this.activeIndex;
          t2.loop && this.loopDestroy();
          var s2 = n2 + 1;
          if (typeof e2 == "object" && "length" in e2) {
            for (var a2 = 0; a2 < e2.length; a2 += 1)
              e2[a2] && i2.prepend(e2[a2]);
            s2 = n2 + e2.length;
          } else i2.prepend(e2);
          t2.loop && this.loopCreate(),
            (t2.observer && o.observer) || this.update(),
            this.slideTo(s2, 0, !1);
        },
        addSlide: function (e2, t2) {
          var i2 = this.$wrapperEl,
            n2 = this.params,
            s2 = this.activeIndex;
          n2.loop &&
            ((s2 -= this.loopedSlides),
            this.loopDestroy(),
            (this.slides = i2.children("." + n2.slideClass)));
          var a2 = this.slides.length;
          if (e2 <= 0) this.prependSlide(t2);
          else if (e2 >= a2) this.appendSlide(t2);
          else {
            for (
              var r2 = s2 > e2 ? s2 + 1 : s2, l2 = [], c2 = a2 - 1;
              c2 >= e2;
              c2 -= 1
            ) {
              var u2 = this.slides.eq(c2);
              u2.remove(), l2.unshift(u2);
            }
            if (typeof t2 == "object" && "length" in t2) {
              for (var d2 = 0; d2 < t2.length; d2 += 1)
                t2[d2] && i2.append(t2[d2]);
              r2 = s2 > e2 ? s2 + t2.length : s2;
            } else i2.append(t2);
            for (var h2 = 0; h2 < l2.length; h2 += 1) i2.append(l2[h2]);
            n2.loop && this.loopCreate(),
              (n2.observer && o.observer) || this.update(),
              n2.loop
                ? this.slideTo(r2 + this.loopedSlides, 0, !1)
                : this.slideTo(r2, 0, !1);
          }
        },
        removeSlide: function (e2) {
          var t2 = this.params,
            i2 = this.$wrapperEl,
            n2 = this.activeIndex;
          t2.loop &&
            ((n2 -= this.loopedSlides),
            this.loopDestroy(),
            (this.slides = i2.children("." + t2.slideClass)));
          var s2,
            a2 = n2;
          if (typeof e2 == "object" && "length" in e2) {
            for (var r2 = 0; r2 < e2.length; r2 += 1)
              (s2 = e2[r2]),
                this.slides[s2] && this.slides.eq(s2).remove(),
                s2 < a2 && (a2 -= 1);
            a2 = Math.max(a2, 0);
          } else
            (s2 = e2),
              this.slides[s2] && this.slides.eq(s2).remove(),
              s2 < a2 && (a2 -= 1),
              (a2 = Math.max(a2, 0));
          t2.loop && this.loopCreate(),
            (t2.observer && o.observer) || this.update(),
            t2.loop
              ? this.slideTo(a2 + this.loopedSlides, 0, !1)
              : this.slideTo(a2, 0, !1);
        },
        removeAllSlides: function () {
          for (var e2 = [], t2 = 0; t2 < this.slides.length; t2 += 1)
            e2.push(t2);
          this.removeSlide(e2);
        },
      },
      I =
        ((u = t.navigator.platform),
        (d = t.navigator.userAgent),
        (h = {
          ios: !1,
          android: !1,
          androidChrome: !1,
          desktop: !1,
          iphone: !1,
          ipod: !1,
          ipad: !1,
          edge: !1,
          ie: !1,
          firefox: !1,
          macos: !1,
          windows: !1,
          cordova: !(!t.cordova && !t.phonegap),
          phonegap: !(!t.cordova && !t.phonegap),
          electron: !1,
        }),
        (p = t.screen.width),
        (f = t.screen.height),
        (v = d.match(/(Android);?[\s\/]+([\d.]+)?/)),
        (m = d.match(/(iPad).*OS\s([\d_]+)/)),
        (g = d.match(/(iPod)(.*OS\s([\d_]+))?/)),
        (y = !m && d.match(/(iPhone\sOS|iOS)\s([\d_]+)/)),
        (b = d.indexOf("MSIE ") >= 0 || d.indexOf("Trident/") >= 0),
        (w = d.indexOf("Edge/") >= 0),
        (S = d.indexOf("Gecko/") >= 0 && d.indexOf("Firefox/") >= 0),
        (x = u === "Win32"),
        (C = d.toLowerCase().indexOf("electron") >= 0),
        (k = u === "MacIntel"),
        !m &&
          k &&
          o.touch &&
          ((p === 1024 && f === 1366) ||
            (p === 834 && f === 1194) ||
            (p === 834 && f === 1112) ||
            (p === 768 && f === 1024)) &&
          ((m = d.match(/(Version)\/([\d.]+)/)), (k = !1)),
        (h.ie = b),
        (h.edge = w),
        (h.firefox = S),
        v &&
          !x &&
          ((h.os = "android"),
          (h.osVersion = v[2]),
          (h.android = !0),
          (h.androidChrome = d.toLowerCase().indexOf("chrome") >= 0)),
        (m || y || g) && ((h.os = "ios"), (h.ios = !0)),
        y && !g && ((h.osVersion = y[2].replace(/_/g, ".")), (h.iphone = !0)),
        m && ((h.osVersion = m[2].replace(/_/g, ".")), (h.ipad = !0)),
        g &&
          ((h.osVersion = g[3] ? g[3].replace(/_/g, ".") : null),
          (h.ipod = !0)),
        h.ios &&
          h.osVersion &&
          d.indexOf("Version/") >= 0 &&
          h.osVersion.split(".")[0] === "10" &&
          (h.osVersion = d.toLowerCase().split("version/")[1].split(" ")[0]),
        (h.webView =
          !(
            !(y || m || g) ||
            (!d.match(/.*AppleWebKit(?!.*Safari)/i) && !t.navigator.standalone)
          ) ||
          (t.matchMedia && t.matchMedia("(display-mode: standalone)").matches)),
        (h.webview = h.webView),
        (h.standalone = h.webView),
        (h.desktop = !(h.ios || h.android) || C),
        h.desktop &&
          ((h.electron = C),
          (h.macos = k),
          (h.windows = x),
          h.macos && (h.os = "macos"),
          h.windows && (h.os = "windows")),
        (h.pixelRatio = t.devicePixelRatio || 1),
        h);
    function D(i2) {
      var s2 = this.touchEventsData,
        a2 = this.params,
        o2 = this.touches;
      if (!this.animating || !a2.preventInteractionOnTransition) {
        var l2 = i2;
        l2.originalEvent && (l2 = l2.originalEvent);
        var c2 = n(l2.target);
        if (
          (a2.touchEventsTarget !== "wrapper" ||
            c2.closest(this.wrapperEl).length) &&
          ((s2.isTouchEvent = l2.type === "touchstart"),
          (s2.isTouchEvent || !("which" in l2) || l2.which !== 3) &&
            !(
              (!s2.isTouchEvent && "button" in l2 && l2.button > 0) ||
              (s2.isTouched && s2.isMoved)
            ))
        ) {
          if (
            a2.noSwiping &&
            c2.closest(
              a2.noSwipingSelector
                ? a2.noSwipingSelector
                : "." + a2.noSwipingClass
            )[0]
          )
            this.allowClick = !0;
          else if (!a2.swipeHandler || c2.closest(a2.swipeHandler)[0]) {
            (o2.currentX =
              l2.type === "touchstart" ? l2.targetTouches[0].pageX : l2.pageX),
              (o2.currentY =
                l2.type === "touchstart"
                  ? l2.targetTouches[0].pageY
                  : l2.pageY);
            var u2 = o2.currentX,
              d2 = o2.currentY,
              h2 = a2.edgeSwipeDetection || a2.iOSEdgeSwipeDetection,
              p2 = a2.edgeSwipeThreshold || a2.iOSEdgeSwipeThreshold;
            if (!h2 || !(u2 <= p2 || u2 >= t.screen.width - p2)) {
              if (
                (r.extend(s2, {
                  isTouched: !0,
                  isMoved: !1,
                  allowTouchCallbacks: !0,
                  isScrolling: void 0,
                  startMoving: void 0,
                }),
                (o2.startX = u2),
                (o2.startY = d2),
                (s2.touchStartTime = r.now()),
                (this.allowClick = !0),
                this.updateSize(),
                (this.swipeDirection = void 0),
                a2.threshold > 0 && (s2.allowThresholdMove = !1),
                l2.type !== "touchstart")
              ) {
                var f2 = !0;
                c2.is(s2.formElements) && (f2 = !1),
                  e.activeElement &&
                    n(e.activeElement).is(s2.formElements) &&
                    e.activeElement !== c2[0] &&
                    e.activeElement.blur();
                var v2 =
                  f2 && this.allowTouchMove && a2.touchStartPreventDefault;
                (a2.touchStartForcePreventDefault || v2) && l2.preventDefault();
              }
              this.emit("touchStart", l2);
            }
          }
        }
      }
    }
    function A(t2) {
      var i2 = this.touchEventsData,
        s2 = this.params,
        a2 = this.touches,
        o2 = this.rtlTranslate,
        l2 = t2;
      if ((l2.originalEvent && (l2 = l2.originalEvent), i2.isTouched)) {
        if (!i2.isTouchEvent || l2.type !== "mousemove") {
          var c2 =
              l2.type === "touchmove" &&
              l2.targetTouches &&
              (l2.targetTouches[0] || l2.changedTouches[0]),
            u2 = l2.type === "touchmove" ? c2.pageX : l2.pageX,
            d2 = l2.type === "touchmove" ? c2.pageY : l2.pageY;
          if (l2.preventedByNestedSwiper)
            return (a2.startX = u2), void (a2.startY = d2);
          if (!this.allowTouchMove)
            return (
              (this.allowClick = !1),
              void (
                i2.isTouched &&
                (r.extend(a2, {
                  startX: u2,
                  startY: d2,
                  currentX: u2,
                  currentY: d2,
                }),
                (i2.touchStartTime = r.now()))
              )
            );
          if (i2.isTouchEvent && s2.touchReleaseOnEdges && !s2.loop) {
            if (this.isVertical()) {
              if (
                (d2 < a2.startY && this.translate <= this.maxTranslate()) ||
                (d2 > a2.startY && this.translate >= this.minTranslate())
              )
                return (i2.isTouched = !1), void (i2.isMoved = !1);
            } else if (
              (u2 < a2.startX && this.translate <= this.maxTranslate()) ||
              (u2 > a2.startX && this.translate >= this.minTranslate())
            )
              return;
          }
          if (
            i2.isTouchEvent &&
            e.activeElement &&
            l2.target === e.activeElement &&
            n(l2.target).is(i2.formElements)
          )
            return (i2.isMoved = !0), void (this.allowClick = !1);
          if (
            (i2.allowTouchCallbacks && this.emit("touchMove", l2),
            !(l2.targetTouches && l2.targetTouches.length > 1))
          ) {
            (a2.currentX = u2), (a2.currentY = d2);
            var h2,
              p2 = a2.currentX - a2.startX,
              f2 = a2.currentY - a2.startY;
            if (
              !(
                this.params.threshold &&
                Math.sqrt(Math.pow(p2, 2) + Math.pow(f2, 2)) <
                  this.params.threshold
              )
            ) {
              if (
                (i2.isScrolling === void 0 &&
                  ((this.isHorizontal() && a2.currentY === a2.startY) ||
                  (this.isVertical() && a2.currentX === a2.startX)
                    ? (i2.isScrolling = !1)
                    : p2 * p2 + f2 * f2 >= 25 &&
                      ((h2 =
                        (180 * Math.atan2(Math.abs(f2), Math.abs(p2))) /
                        Math.PI),
                      (i2.isScrolling = this.isHorizontal()
                        ? h2 > s2.touchAngle
                        : 90 - h2 > s2.touchAngle))),
                i2.isScrolling && this.emit("touchMoveOpposite", l2),
                i2.startMoving === void 0 &&
                  ((a2.currentX === a2.startX && a2.currentY === a2.startY) ||
                    (i2.startMoving = !0)),
                i2.isScrolling)
              )
                i2.isTouched = !1;
              else if (i2.startMoving) {
                (this.allowClick = !1),
                  s2.cssMode || l2.preventDefault(),
                  s2.touchMoveStopPropagation &&
                    !s2.nested &&
                    l2.stopPropagation(),
                  i2.isMoved ||
                    (s2.loop && this.loopFix(),
                    (i2.startTranslate = this.getTranslate()),
                    this.setTransition(0),
                    this.animating &&
                      this.$wrapperEl.trigger(
                        "webkitTransitionEnd transitionend"
                      ),
                    (i2.allowMomentumBounce = !1),
                    !s2.grabCursor ||
                      (this.allowSlideNext !== !0 &&
                        this.allowSlidePrev !== !0) ||
                      this.setGrabCursor(!0),
                    this.emit("sliderFirstMove", l2)),
                  this.emit("sliderMove", l2),
                  (i2.isMoved = !0);
                var v2 = this.isHorizontal() ? p2 : f2;
                (a2.diff = v2),
                  (v2 *= s2.touchRatio),
                  o2 && (v2 = -v2),
                  (this.swipeDirection = v2 > 0 ? "prev" : "next"),
                  (i2.currentTranslate = v2 + i2.startTranslate);
                var m2 = !0,
                  g2 = s2.resistanceRatio;
                if (
                  (s2.touchReleaseOnEdges && (g2 = 0),
                  v2 > 0 && i2.currentTranslate > this.minTranslate()
                    ? ((m2 = !1),
                      s2.resistance &&
                        (i2.currentTranslate =
                          this.minTranslate() -
                          1 +
                          Math.pow(
                            -this.minTranslate() + i2.startTranslate + v2,
                            g2
                          )))
                    : v2 < 0 &&
                      i2.currentTranslate < this.maxTranslate() &&
                      ((m2 = !1),
                      s2.resistance &&
                        (i2.currentTranslate =
                          this.maxTranslate() +
                          1 -
                          Math.pow(
                            this.maxTranslate() - i2.startTranslate - v2,
                            g2
                          ))),
                  m2 && (l2.preventedByNestedSwiper = !0),
                  !this.allowSlideNext &&
                    this.swipeDirection === "next" &&
                    i2.currentTranslate < i2.startTranslate &&
                    (i2.currentTranslate = i2.startTranslate),
                  !this.allowSlidePrev &&
                    this.swipeDirection === "prev" &&
                    i2.currentTranslate > i2.startTranslate &&
                    (i2.currentTranslate = i2.startTranslate),
                  s2.threshold > 0)
                ) {
                  if (!(Math.abs(v2) > s2.threshold || i2.allowThresholdMove))
                    return void (i2.currentTranslate = i2.startTranslate);
                  if (!i2.allowThresholdMove)
                    return (
                      (i2.allowThresholdMove = !0),
                      (a2.startX = a2.currentX),
                      (a2.startY = a2.currentY),
                      (i2.currentTranslate = i2.startTranslate),
                      void (a2.diff = this.isHorizontal()
                        ? a2.currentX - a2.startX
                        : a2.currentY - a2.startY)
                    );
                }
                s2.followFinger &&
                  !s2.cssMode &&
                  ((s2.freeMode ||
                    s2.watchSlidesProgress ||
                    s2.watchSlidesVisibility) &&
                    (this.updateActiveIndex(), this.updateSlidesClasses()),
                  s2.freeMode &&
                    (i2.velocities.length === 0 &&
                      i2.velocities.push({
                        position: a2[this.isHorizontal() ? "startX" : "startY"],
                        time: i2.touchStartTime,
                      }),
                    i2.velocities.push({
                      position:
                        a2[this.isHorizontal() ? "currentX" : "currentY"],
                      time: r.now(),
                    })),
                  this.updateProgress(i2.currentTranslate),
                  this.setTranslate(i2.currentTranslate));
              }
            }
          }
        }
      } else i2.startMoving && i2.isScrolling && this.emit("touchMoveOpposite", l2);
    }
    function z(e2) {
      var t2 = this,
        i2 = t2.touchEventsData,
        n2 = t2.params,
        s2 = t2.touches,
        a2 = t2.rtlTranslate,
        o2 = t2.$wrapperEl,
        l2 = t2.slidesGrid,
        c2 = t2.snapGrid,
        u2 = e2;
      if (
        (u2.originalEvent && (u2 = u2.originalEvent),
        i2.allowTouchCallbacks && t2.emit("touchEnd", u2),
        (i2.allowTouchCallbacks = !1),
        !i2.isTouched)
      )
        return (
          i2.isMoved && n2.grabCursor && t2.setGrabCursor(!1),
          (i2.isMoved = !1),
          void (i2.startMoving = !1)
        );
      n2.grabCursor &&
        i2.isMoved &&
        i2.isTouched &&
        (t2.allowSlideNext === !0 || t2.allowSlidePrev === !0) &&
        t2.setGrabCursor(!1);
      var d2,
        h2 = r.now(),
        p2 = h2 - i2.touchStartTime;
      if (
        (t2.allowClick &&
          (t2.updateClickedSlide(u2),
          t2.emit("tap click", u2),
          p2 < 300 &&
            h2 - i2.lastClickTime < 300 &&
            t2.emit("doubleTap doubleClick", u2)),
        (i2.lastClickTime = r.now()),
        r.nextTick(function () {
          t2.destroyed || (t2.allowClick = !0);
        }),
        !i2.isTouched ||
          !i2.isMoved ||
          !t2.swipeDirection ||
          s2.diff === 0 ||
          i2.currentTranslate === i2.startTranslate)
      )
        return (
          (i2.isTouched = !1), (i2.isMoved = !1), void (i2.startMoving = !1)
        );
      if (
        ((i2.isTouched = !1),
        (i2.isMoved = !1),
        (i2.startMoving = !1),
        (d2 = n2.followFinger
          ? a2
            ? t2.translate
            : -t2.translate
          : -i2.currentTranslate),
        !n2.cssMode)
      )
        if (n2.freeMode) {
          if (d2 < -t2.minTranslate()) return void t2.slideTo(t2.activeIndex);
          if (d2 > -t2.maxTranslate())
            return void (t2.slides.length < c2.length
              ? t2.slideTo(c2.length - 1)
              : t2.slideTo(t2.slides.length - 1));
          if (n2.freeModeMomentum) {
            if (i2.velocities.length > 1) {
              var f2 = i2.velocities.pop(),
                v2 = i2.velocities.pop(),
                m2 = f2.position - v2.position,
                g2 = f2.time - v2.time;
              (t2.velocity = m2 / g2),
                (t2.velocity /= 2),
                Math.abs(t2.velocity) < n2.freeModeMinimumVelocity &&
                  (t2.velocity = 0),
                (g2 > 150 || r.now() - f2.time > 300) && (t2.velocity = 0);
            } else t2.velocity = 0;
            (t2.velocity *= n2.freeModeMomentumVelocityRatio),
              (i2.velocities.length = 0);
            var y2 = 1e3 * n2.freeModeMomentumRatio,
              b2 = t2.velocity * y2,
              w2 = t2.translate + b2;
            a2 && (w2 = -w2);
            var S2,
              x2,
              C2 = !1,
              k2 = 20 * Math.abs(t2.velocity) * n2.freeModeMomentumBounceRatio;
            if (w2 < t2.maxTranslate())
              n2.freeModeMomentumBounce
                ? (w2 + t2.maxTranslate() < -k2 &&
                    (w2 = t2.maxTranslate() - k2),
                  (S2 = t2.maxTranslate()),
                  (C2 = !0),
                  (i2.allowMomentumBounce = !0))
                : (w2 = t2.maxTranslate()),
                n2.loop && n2.centeredSlides && (x2 = !0);
            else if (w2 > t2.minTranslate())
              n2.freeModeMomentumBounce
                ? (w2 - t2.minTranslate() > k2 && (w2 = t2.minTranslate() + k2),
                  (S2 = t2.minTranslate()),
                  (C2 = !0),
                  (i2.allowMomentumBounce = !0))
                : (w2 = t2.minTranslate()),
                n2.loop && n2.centeredSlides && (x2 = !0);
            else if (n2.freeModeSticky) {
              for (var E2, T2 = 0; T2 < c2.length; T2 += 1)
                if (c2[T2] > -w2) {
                  E2 = T2;
                  break;
                }
              w2 = -(w2 =
                Math.abs(c2[E2] - w2) < Math.abs(c2[E2 - 1] - w2) ||
                t2.swipeDirection === "next"
                  ? c2[E2]
                  : c2[E2 - 1]);
            }
            if (
              (x2 &&
                t2.once("transitionEnd", function () {
                  t2.loopFix();
                }),
              t2.velocity !== 0)
            ) {
              if (
                ((y2 = Math.abs(
                  a2
                    ? (-w2 - t2.translate) / t2.velocity
                    : (w2 - t2.translate) / t2.velocity
                )),
                n2.freeModeSticky)
              ) {
                var _2 = Math.abs((a2 ? -w2 : w2) - t2.translate),
                  M2 = t2.slidesSizesGrid[t2.activeIndex];
                y2 =
                  _2 < M2
                    ? n2.speed
                    : _2 < 2 * M2
                    ? 1.5 * n2.speed
                    : 2.5 * n2.speed;
              }
            } else if (n2.freeModeSticky) return void t2.slideToClosest();
            n2.freeModeMomentumBounce && C2
              ? (t2.updateProgress(S2),
                t2.setTransition(y2),
                t2.setTranslate(w2),
                t2.transitionStart(!0, t2.swipeDirection),
                (t2.animating = !0),
                o2.transitionEnd(function () {
                  t2 &&
                    !t2.destroyed &&
                    i2.allowMomentumBounce &&
                    (t2.emit("momentumBounce"),
                    t2.setTransition(n2.speed),
                    setTimeout(function () {
                      t2.setTranslate(S2),
                        o2.transitionEnd(function () {
                          t2 && !t2.destroyed && t2.transitionEnd();
                        });
                    }, 0));
                }))
              : t2.velocity
              ? (t2.updateProgress(w2),
                t2.setTransition(y2),
                t2.setTranslate(w2),
                t2.transitionStart(!0, t2.swipeDirection),
                t2.animating ||
                  ((t2.animating = !0),
                  o2.transitionEnd(function () {
                    t2 && !t2.destroyed && t2.transitionEnd();
                  })))
              : t2.updateProgress(w2),
              t2.updateActiveIndex(),
              t2.updateSlidesClasses();
          } else if (n2.freeModeSticky) return void t2.slideToClosest();
          (!n2.freeModeMomentum || p2 >= n2.longSwipesMs) &&
            (t2.updateProgress(),
            t2.updateActiveIndex(),
            t2.updateSlidesClasses());
        } else {
          for (
            var L2 = 0, P2 = t2.slidesSizesGrid[0], I2 = 0;
            I2 < l2.length;
            I2 += I2 < n2.slidesPerGroupSkip ? 1 : n2.slidesPerGroup
          ) {
            var D2 = I2 < n2.slidesPerGroupSkip - 1 ? 1 : n2.slidesPerGroup;
            l2[I2 + D2] !== void 0
              ? d2 >= l2[I2] &&
                d2 < l2[I2 + D2] &&
                ((L2 = I2), (P2 = l2[I2 + D2] - l2[I2]))
              : d2 >= l2[I2] &&
                ((L2 = I2), (P2 = l2[l2.length - 1] - l2[l2.length - 2]));
          }
          var A2 = (d2 - l2[L2]) / P2,
            z2 = L2 < n2.slidesPerGroupSkip - 1 ? 1 : n2.slidesPerGroup;
          if (p2 > n2.longSwipesMs) {
            if (!n2.longSwipes) return void t2.slideTo(t2.activeIndex);
            t2.swipeDirection === "next" &&
              (A2 >= n2.longSwipesRatio ? t2.slideTo(L2 + z2) : t2.slideTo(L2)),
              t2.swipeDirection === "prev" &&
                (A2 > 1 - n2.longSwipesRatio
                  ? t2.slideTo(L2 + z2)
                  : t2.slideTo(L2));
          } else {
            if (!n2.shortSwipes) return void t2.slideTo(t2.activeIndex);
            !t2.navigation ||
            (u2.target !== t2.navigation.nextEl &&
              u2.target !== t2.navigation.prevEl)
              ? (t2.swipeDirection === "next" && t2.slideTo(L2 + z2),
                t2.swipeDirection === "prev" && t2.slideTo(L2))
              : u2.target === t2.navigation.nextEl
              ? t2.slideTo(L2 + z2)
              : t2.slideTo(L2);
          }
        }
    }
    function O() {
      var e2 = this.params,
        t2 = this.el;
      if (!t2 || t2.offsetWidth !== 0) {
        e2.breakpoints && this.setBreakpoint();
        var i2 = this.allowSlideNext,
          n2 = this.allowSlidePrev,
          s2 = this.snapGrid;
        (this.allowSlideNext = !0),
          (this.allowSlidePrev = !0),
          this.updateSize(),
          this.updateSlides(),
          this.updateSlidesClasses(),
          (e2.slidesPerView === "auto" || e2.slidesPerView > 1) &&
          this.isEnd &&
          !this.params.centeredSlides
            ? this.slideTo(this.slides.length - 1, 0, !1, !0)
            : this.slideTo(this.activeIndex, 0, !1, !0),
          this.autoplay &&
            this.autoplay.running &&
            this.autoplay.paused &&
            this.autoplay.run(),
          (this.allowSlidePrev = n2),
          (this.allowSlideNext = i2),
          this.params.watchOverflow &&
            s2 !== this.snapGrid &&
            this.checkOverflow();
      }
    }
    function B(e2) {
      this.allowClick ||
        (this.params.preventClicks && e2.preventDefault(),
        this.params.preventClicksPropagation &&
          this.animating &&
          (e2.stopPropagation(), e2.stopImmediatePropagation()));
    }
    function N() {
      var e2 = this.wrapperEl,
        t2 = this.rtlTranslate;
      (this.previousTranslate = this.translate),
        this.isHorizontal()
          ? (this.translate = t2
              ? e2.scrollWidth - e2.offsetWidth - e2.scrollLeft
              : -e2.scrollLeft)
          : (this.translate = -e2.scrollTop),
        this.translate === -0 && (this.translate = 0),
        this.updateActiveIndex(),
        this.updateSlidesClasses();
      var i2 = this.maxTranslate() - this.minTranslate();
      (i2 === 0 ? 0 : (this.translate - this.minTranslate()) / i2) !==
        this.progress &&
        this.updateProgress(t2 ? -this.translate : this.translate),
        this.emit("setTranslate", this.translate, !1);
    }
    var q = !1;
    function $2() {}
    var H = {
        init: !0,
        direction: "horizontal",
        touchEventsTarget: "container",
        initialSlide: 0,
        speed: 300,
        cssMode: !1,
        updateOnWindowResize: !0,
        preventInteractionOnTransition: !1,
        edgeSwipeDetection: !1,
        edgeSwipeThreshold: 20,
        freeMode: !1,
        freeModeMomentum: !0,
        freeModeMomentumRatio: 1,
        freeModeMomentumBounce: !0,
        freeModeMomentumBounceRatio: 1,
        freeModeMomentumVelocityRatio: 1,
        freeModeSticky: !1,
        freeModeMinimumVelocity: 0.02,
        autoHeight: !1,
        setWrapperSize: !1,
        virtualTranslate: !1,
        effect: "slide",
        breakpoints: void 0,
        spaceBetween: 0,
        slidesPerView: 1,
        slidesPerColumn: 1,
        slidesPerColumnFill: "column",
        slidesPerGroup: 1,
        slidesPerGroupSkip: 0,
        centeredSlides: !1,
        centeredSlidesBounds: !1,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        normalizeSlideIndex: !0,
        centerInsufficientSlides: !1,
        watchOverflow: !1,
        roundLengths: !1,
        touchRatio: 1,
        touchAngle: 45,
        simulateTouch: !0,
        shortSwipes: !0,
        longSwipes: !0,
        longSwipesRatio: 0.5,
        longSwipesMs: 300,
        followFinger: !0,
        allowTouchMove: !0,
        threshold: 0,
        touchMoveStopPropagation: !1,
        touchStartPreventDefault: !0,
        touchStartForcePreventDefault: !1,
        touchReleaseOnEdges: !1,
        uniqueNavElements: !0,
        resistance: !0,
        resistanceRatio: 0.85,
        watchSlidesProgress: !1,
        watchSlidesVisibility: !1,
        grabCursor: !1,
        preventClicks: !0,
        preventClicksPropagation: !0,
        slideToClickedSlide: !1,
        preloadImages: !0,
        updateOnImagesReady: !0,
        loop: !1,
        loopAdditionalSlides: 0,
        loopedSlides: null,
        loopFillGroupWithBlank: !1,
        allowSlidePrev: !0,
        allowSlideNext: !0,
        swipeHandler: null,
        noSwiping: !0,
        noSwipingClass: "swiper-no-swiping",
        noSwipingSelector: null,
        passiveListeners: !0,
        containerModifierClass: "swiper-container-",
        slideClass: "swiper-slide",
        slideBlankClass: "swiper-slide-invisible-blank",
        slideActiveClass: "swiper-slide-active",
        slideDuplicateActiveClass: "swiper-slide-duplicate-active",
        slideVisibleClass: "swiper-slide-visible",
        slideDuplicateClass: "swiper-slide-duplicate",
        slideNextClass: "swiper-slide-next",
        slideDuplicateNextClass: "swiper-slide-duplicate-next",
        slidePrevClass: "swiper-slide-prev",
        slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
        wrapperClass: "swiper-wrapper",
        runCallbacksOnInit: !0,
      },
      F = {
        update: E,
        translate: T,
        transition: {
          setTransition: function (e2, t2) {
            this.params.cssMode || this.$wrapperEl.transition(e2),
              this.emit("setTransition", e2, t2);
          },
          transitionStart: function (e2, t2) {
            e2 === void 0 && (e2 = !0);
            var i2 = this.activeIndex,
              n2 = this.params,
              s2 = this.previousIndex;
            if (!n2.cssMode) {
              n2.autoHeight && this.updateAutoHeight();
              var a2 = t2;
              if (
                (a2 || (a2 = i2 > s2 ? "next" : i2 < s2 ? "prev" : "reset"),
                this.emit("transitionStart"),
                e2 && i2 !== s2)
              ) {
                if (a2 === "reset")
                  return void this.emit("slideResetTransitionStart");
                this.emit("slideChangeTransitionStart"),
                  a2 === "next"
                    ? this.emit("slideNextTransitionStart")
                    : this.emit("slidePrevTransitionStart");
              }
            }
          },
          transitionEnd: function (e2, t2) {
            e2 === void 0 && (e2 = !0);
            var i2 = this.activeIndex,
              n2 = this.previousIndex,
              s2 = this.params;
            if (((this.animating = !1), !s2.cssMode)) {
              this.setTransition(0);
              var a2 = t2;
              if (
                (a2 || (a2 = i2 > n2 ? "next" : i2 < n2 ? "prev" : "reset"),
                this.emit("transitionEnd"),
                e2 && i2 !== n2)
              ) {
                if (a2 === "reset")
                  return void this.emit("slideResetTransitionEnd");
                this.emit("slideChangeTransitionEnd"),
                  a2 === "next"
                    ? this.emit("slideNextTransitionEnd")
                    : this.emit("slidePrevTransitionEnd");
              }
            }
          },
        },
        slide: _,
        loop: M,
        grabCursor: L,
        manipulation: P,
        events: {
          attachEvents: function () {
            var t2 = this.params,
              i2 = this.touchEvents,
              n2 = this.el,
              s2 = this.wrapperEl;
            (this.onTouchStart = D.bind(this)),
              (this.onTouchMove = A.bind(this)),
              (this.onTouchEnd = z.bind(this)),
              t2.cssMode && (this.onScroll = N.bind(this)),
              (this.onClick = B.bind(this));
            var a2 = !!t2.nested;
            if (!o.touch && o.pointerEvents)
              n2.addEventListener(i2.start, this.onTouchStart, !1),
                e.addEventListener(i2.move, this.onTouchMove, a2),
                e.addEventListener(i2.end, this.onTouchEnd, !1);
            else {
              if (o.touch) {
                var r2 = !(
                  i2.start !== "touchstart" ||
                  !o.passiveListener ||
                  !t2.passiveListeners
                ) && { passive: !0, capture: !1 };
                n2.addEventListener(i2.start, this.onTouchStart, r2),
                  n2.addEventListener(
                    i2.move,
                    this.onTouchMove,
                    o.passiveListener ? { passive: !1, capture: a2 } : a2
                  ),
                  n2.addEventListener(i2.end, this.onTouchEnd, r2),
                  i2.cancel &&
                    n2.addEventListener(i2.cancel, this.onTouchEnd, r2),
                  q || (e.addEventListener("touchstart", $2), (q = !0));
              }
              ((t2.simulateTouch && !I.ios && !I.android) ||
                (t2.simulateTouch && !o.touch && I.ios)) &&
                (n2.addEventListener("mousedown", this.onTouchStart, !1),
                e.addEventListener("mousemove", this.onTouchMove, a2),
                e.addEventListener("mouseup", this.onTouchEnd, !1));
            }
            (t2.preventClicks || t2.preventClicksPropagation) &&
              n2.addEventListener("click", this.onClick, !0),
              t2.cssMode && s2.addEventListener("scroll", this.onScroll),
              t2.updateOnWindowResize
                ? this.on(
                    I.ios || I.android
                      ? "resize orientationchange observerUpdate"
                      : "resize observerUpdate",
                    O,
                    !0
                  )
                : this.on("observerUpdate", O, !0);
          },
          detachEvents: function () {
            var t2 = this.params,
              i2 = this.touchEvents,
              n2 = this.el,
              s2 = this.wrapperEl,
              a2 = !!t2.nested;
            if (!o.touch && o.pointerEvents)
              n2.removeEventListener(i2.start, this.onTouchStart, !1),
                e.removeEventListener(i2.move, this.onTouchMove, a2),
                e.removeEventListener(i2.end, this.onTouchEnd, !1);
            else {
              if (o.touch) {
                var r2 = !(
                  i2.start !== "onTouchStart" ||
                  !o.passiveListener ||
                  !t2.passiveListeners
                ) && { passive: !0, capture: !1 };
                n2.removeEventListener(i2.start, this.onTouchStart, r2),
                  n2.removeEventListener(i2.move, this.onTouchMove, a2),
                  n2.removeEventListener(i2.end, this.onTouchEnd, r2),
                  i2.cancel &&
                    n2.removeEventListener(i2.cancel, this.onTouchEnd, r2);
              }
              ((t2.simulateTouch && !I.ios && !I.android) ||
                (t2.simulateTouch && !o.touch && I.ios)) &&
                (n2.removeEventListener("mousedown", this.onTouchStart, !1),
                e.removeEventListener("mousemove", this.onTouchMove, a2),
                e.removeEventListener("mouseup", this.onTouchEnd, !1));
            }
            (t2.preventClicks || t2.preventClicksPropagation) &&
              n2.removeEventListener("click", this.onClick, !0),
              t2.cssMode && s2.removeEventListener("scroll", this.onScroll),
              this.off(
                I.ios || I.android
                  ? "resize orientationchange observerUpdate"
                  : "resize observerUpdate",
                O
              );
          },
        },
        breakpoints: {
          setBreakpoint: function () {
            var e2 = this.activeIndex,
              t2 = this.initialized,
              i2 = this.loopedSlides;
            i2 === void 0 && (i2 = 0);
            var n2 = this.params,
              s2 = this.$el,
              a2 = n2.breakpoints;
            if (a2 && (!a2 || Object.keys(a2).length !== 0)) {
              var o2 = this.getBreakpoint(a2);
              if (o2 && this.currentBreakpoint !== o2) {
                var l2 = o2 in a2 ? a2[o2] : void 0;
                l2 &&
                  [
                    "slidesPerView",
                    "spaceBetween",
                    "slidesPerGroup",
                    "slidesPerGroupSkip",
                    "slidesPerColumn",
                  ].forEach(function (e3) {
                    var t3 = l2[e3];
                    t3 !== void 0 &&
                      (l2[e3] =
                        e3 !== "slidesPerView" ||
                        (t3 !== "AUTO" && t3 !== "auto")
                          ? e3 === "slidesPerView"
                            ? parseFloat(t3)
                            : parseInt(t3, 10)
                          : "auto");
                  });
                var c2 = l2 || this.originalParams,
                  u2 = n2.slidesPerColumn > 1,
                  d2 = c2.slidesPerColumn > 1;
                u2 && !d2
                  ? s2.removeClass(
                      n2.containerModifierClass +
                        "multirow " +
                        n2.containerModifierClass +
                        "multirow-column"
                    )
                  : !u2 &&
                    d2 &&
                    (s2.addClass(n2.containerModifierClass + "multirow"),
                    c2.slidesPerColumnFill === "column" &&
                      s2.addClass(
                        n2.containerModifierClass + "multirow-column"
                      ));
                var h2 = c2.direction && c2.direction !== n2.direction,
                  p2 = n2.loop && (c2.slidesPerView !== n2.slidesPerView || h2);
                h2 && t2 && this.changeDirection(),
                  r.extend(this.params, c2),
                  r.extend(this, {
                    allowTouchMove: this.params.allowTouchMove,
                    allowSlideNext: this.params.allowSlideNext,
                    allowSlidePrev: this.params.allowSlidePrev,
                  }),
                  (this.currentBreakpoint = o2),
                  p2 &&
                    t2 &&
                    (this.loopDestroy(),
                    this.loopCreate(),
                    this.updateSlides(),
                    this.slideTo(e2 - i2 + this.loopedSlides, 0, !1)),
                  this.emit("breakpoint", c2);
              }
            }
          },
          getBreakpoint: function (e2) {
            if (e2) {
              var i2 = !1,
                n2 = Object.keys(e2).map(function (e3) {
                  if (typeof e3 == "string" && e3.indexOf("@") === 0) {
                    var i3 = parseFloat(e3.substr(1));
                    return { value: t.innerHeight * i3, point: e3 };
                  }
                  return { value: e3, point: e3 };
                });
              n2.sort(function (e3, t2) {
                return parseInt(e3.value, 10) - parseInt(t2.value, 10);
              });
              for (var s2 = 0; s2 < n2.length; s2 += 1) {
                var a2 = n2[s2],
                  r2 = a2.point;
                a2.value <= t.innerWidth && (i2 = r2);
              }
              return i2 || "max";
            }
          },
        },
        checkOverflow: {
          checkOverflow: function () {
            var e2 = this.params,
              t2 = this.isLocked,
              i2 =
                this.slides.length > 0 &&
                e2.slidesOffsetBefore +
                  e2.spaceBetween * (this.slides.length - 1) +
                  this.slides[0].offsetWidth * this.slides.length;
            e2.slidesOffsetBefore && e2.slidesOffsetAfter && i2
              ? (this.isLocked = i2 <= this.size)
              : (this.isLocked = this.snapGrid.length === 1),
              (this.allowSlideNext = !this.isLocked),
              (this.allowSlidePrev = !this.isLocked),
              t2 !== this.isLocked &&
                this.emit(this.isLocked ? "lock" : "unlock"),
              t2 &&
                t2 !== this.isLocked &&
                ((this.isEnd = !1), this.navigation.update());
          },
        },
        classes: {
          addClasses: function () {
            var e2 = this.classNames,
              t2 = this.params,
              i2 = this.rtl,
              n2 = this.$el,
              s2 = [];
            s2.push("initialized"),
              s2.push(t2.direction),
              t2.freeMode && s2.push("free-mode"),
              t2.autoHeight && s2.push("autoheight"),
              i2 && s2.push("rtl"),
              t2.slidesPerColumn > 1 &&
                (s2.push("multirow"),
                t2.slidesPerColumnFill === "column" &&
                  s2.push("multirow-column")),
              I.android && s2.push("android"),
              I.ios && s2.push("ios"),
              t2.cssMode && s2.push("css-mode"),
              s2.forEach(function (i3) {
                e2.push(t2.containerModifierClass + i3);
              }),
              n2.addClass(e2.join(" "));
          },
          removeClasses: function () {
            var e2 = this.$el,
              t2 = this.classNames;
            e2.removeClass(t2.join(" "));
          },
        },
        images: {
          loadImage: function (e2, i2, n2, s2, a2, r2) {
            var o2;
            function l2() {
              r2 && r2();
            }
            e2.complete && a2
              ? l2()
              : i2
              ? (((o2 = new t.Image()).onload = l2),
                (o2.onerror = l2),
                s2 && (o2.sizes = s2),
                n2 && (o2.srcset = n2),
                i2 && (o2.src = i2))
              : l2();
          },
          preloadImages: function () {
            var e2 = this;
            function t2() {
              e2 != null &&
                e2 &&
                !e2.destroyed &&
                (e2.imagesLoaded !== void 0 && (e2.imagesLoaded += 1),
                e2.imagesLoaded === e2.imagesToLoad.length &&
                  (e2.params.updateOnImagesReady && e2.update(),
                  e2.emit("imagesReady")));
            }
            e2.imagesToLoad = e2.$el.find("img");
            for (var i2 = 0; i2 < e2.imagesToLoad.length; i2 += 1) {
              var n2 = e2.imagesToLoad[i2];
              e2.loadImage(
                n2,
                n2.currentSrc || n2.getAttribute("src"),
                n2.srcset || n2.getAttribute("srcset"),
                n2.sizes || n2.getAttribute("sizes"),
                !0,
                t2
              );
            }
          },
        },
      },
      V = {},
      R = (function (e2) {
        function t2() {
          for (var i3, s2, a2, l2 = [], c2 = arguments.length; c2--; )
            l2[c2] = arguments[c2];
          l2.length === 1 && l2[0].constructor && l2[0].constructor === Object
            ? (a2 = l2[0])
            : ((s2 = (i3 = l2)[0]), (a2 = i3[1])),
            a2 || (a2 = {}),
            (a2 = r.extend({}, a2)),
            s2 && !a2.el && (a2.el = s2),
            e2.call(this, a2),
            Object.keys(F).forEach(function (e3) {
              Object.keys(F[e3]).forEach(function (i4) {
                t2.prototype[i4] || (t2.prototype[i4] = F[e3][i4]);
              });
            });
          var u2 = this;
          u2.modules === void 0 && (u2.modules = {}),
            Object.keys(u2.modules).forEach(function (e3) {
              var t3 = u2.modules[e3];
              if (t3.params) {
                var i4 = Object.keys(t3.params)[0],
                  n2 = t3.params[i4];
                if (
                  typeof n2 != "object" ||
                  n2 === null ||
                  !(i4 in a2) ||
                  !("enabled" in n2)
                )
                  return;
                a2[i4] === !0 && (a2[i4] = { enabled: !0 }),
                  typeof a2[i4] != "object" ||
                    "enabled" in a2[i4] ||
                    (a2[i4].enabled = !0),
                  a2[i4] || (a2[i4] = { enabled: !1 });
              }
            });
          var d2 = r.extend({}, H);
          u2.useModulesParams(d2),
            (u2.params = r.extend({}, d2, V, a2)),
            (u2.originalParams = r.extend({}, u2.params)),
            (u2.passedParams = r.extend({}, a2)),
            (u2.$ = n);
          var h2 = n(u2.params.el);
          if ((s2 = h2[0])) {
            if (h2.length > 1) {
              var p2 = [];
              return (
                h2.each(function (e3, i4) {
                  var n2 = r.extend({}, a2, { el: i4 });
                  p2.push(new t2(n2));
                }),
                p2
              );
            }
            var f2, v2, m2;
            return (
              (s2.swiper = u2),
              h2.data("swiper", u2),
              s2 && s2.shadowRoot && s2.shadowRoot.querySelector
                ? ((f2 = n(
                    s2.shadowRoot.querySelector("." + u2.params.wrapperClass)
                  )).children = function (e3) {
                    return h2.children(e3);
                  })
                : (f2 = h2.children("." + u2.params.wrapperClass)),
              r.extend(u2, {
                $el: h2,
                el: s2,
                $wrapperEl: f2,
                wrapperEl: f2[0],
                classNames: [],
                slides: n(),
                slidesGrid: [],
                snapGrid: [],
                slidesSizesGrid: [],
                isHorizontal: function () {
                  return u2.params.direction === "horizontal";
                },
                isVertical: function () {
                  return u2.params.direction === "vertical";
                },
                rtl:
                  s2.dir.toLowerCase() === "rtl" ||
                  h2.css("direction") === "rtl",
                rtlTranslate:
                  u2.params.direction === "horizontal" &&
                  (s2.dir.toLowerCase() === "rtl" ||
                    h2.css("direction") === "rtl"),
                wrongRTL: f2.css("display") === "-webkit-box",
                activeIndex: 0,
                realIndex: 0,
                isBeginning: !0,
                isEnd: !1,
                translate: 0,
                previousTranslate: 0,
                progress: 0,
                velocity: 0,
                animating: !1,
                allowSlideNext: u2.params.allowSlideNext,
                allowSlidePrev: u2.params.allowSlidePrev,
                touchEvents:
                  ((v2 = [
                    "touchstart",
                    "touchmove",
                    "touchend",
                    "touchcancel",
                  ]),
                  (m2 = ["mousedown", "mousemove", "mouseup"]),
                  o.pointerEvents &&
                    (m2 = ["pointerdown", "pointermove", "pointerup"]),
                  (u2.touchEventsTouch = {
                    start: v2[0],
                    move: v2[1],
                    end: v2[2],
                    cancel: v2[3],
                  }),
                  (u2.touchEventsDesktop = {
                    start: m2[0],
                    move: m2[1],
                    end: m2[2],
                  }),
                  o.touch || !u2.params.simulateTouch
                    ? u2.touchEventsTouch
                    : u2.touchEventsDesktop),
                touchEventsData: {
                  isTouched: void 0,
                  isMoved: void 0,
                  allowTouchCallbacks: void 0,
                  touchStartTime: void 0,
                  isScrolling: void 0,
                  currentTranslate: void 0,
                  startTranslate: void 0,
                  allowThresholdMove: void 0,
                  formElements:
                    "input, select, option, textarea, button, video, label",
                  lastClickTime: r.now(),
                  clickTimeout: void 0,
                  velocities: [],
                  allowMomentumBounce: void 0,
                  isTouchEvent: void 0,
                  startMoving: void 0,
                },
                allowClick: !0,
                allowTouchMove: u2.params.allowTouchMove,
                touches: {
                  startX: 0,
                  startY: 0,
                  currentX: 0,
                  currentY: 0,
                  diff: 0,
                },
                imagesToLoad: [],
                imagesLoaded: 0,
              }),
              u2.useModules(),
              u2.params.init && u2.init(),
              u2
            );
          }
        }
        e2 && (t2.__proto__ = e2),
          (t2.prototype = Object.create(e2 && e2.prototype)),
          (t2.prototype.constructor = t2);
        var i2 = {
          extendedDefaults: { configurable: !0 },
          defaults: { configurable: !0 },
          Class: { configurable: !0 },
          $: { configurable: !0 },
        };
        return (
          (t2.prototype.slidesPerViewDynamic = function () {
            var e3 = this.params,
              t3 = this.slides,
              i3 = this.slidesGrid,
              n2 = this.size,
              s2 = this.activeIndex,
              a2 = 1;
            if (e3.centeredSlides) {
              for (
                var r2, o2 = t3[s2].swiperSlideSize, l2 = s2 + 1;
                l2 < t3.length;
                l2 += 1
              )
                t3[l2] &&
                  !r2 &&
                  ((a2 += 1), (o2 += t3[l2].swiperSlideSize) > n2 && (r2 = !0));
              for (var c2 = s2 - 1; c2 >= 0; c2 -= 1)
                t3[c2] &&
                  !r2 &&
                  ((a2 += 1), (o2 += t3[c2].swiperSlideSize) > n2 && (r2 = !0));
            } else
              for (var u2 = s2 + 1; u2 < t3.length; u2 += 1)
                i3[u2] - i3[s2] < n2 && (a2 += 1);
            return a2;
          }),
          (t2.prototype.update = function () {
            var e3 = this;
            if (e3 && !e3.destroyed) {
              var t3 = e3.snapGrid,
                i3 = e3.params;
              i3.breakpoints && e3.setBreakpoint(),
                e3.updateSize(),
                e3.updateSlides(),
                e3.updateProgress(),
                e3.updateSlidesClasses(),
                e3.params.freeMode
                  ? (n2(), e3.params.autoHeight && e3.updateAutoHeight())
                  : ((e3.params.slidesPerView === "auto" ||
                      e3.params.slidesPerView > 1) &&
                    e3.isEnd &&
                    !e3.params.centeredSlides
                      ? e3.slideTo(e3.slides.length - 1, 0, !1, !0)
                      : e3.slideTo(e3.activeIndex, 0, !1, !0)) || n2(),
                i3.watchOverflow && t3 !== e3.snapGrid && e3.checkOverflow(),
                e3.emit("update");
            }
            function n2() {
              var t4 = e3.rtlTranslate ? -1 * e3.translate : e3.translate,
                i4 = Math.min(
                  Math.max(t4, e3.maxTranslate()),
                  e3.minTranslate()
                );
              e3.setTranslate(i4),
                e3.updateActiveIndex(),
                e3.updateSlidesClasses();
            }
          }),
          (t2.prototype.changeDirection = function (e3, t3) {
            t3 === void 0 && (t3 = !0);
            var i3 = this.params.direction;
            return (
              e3 || (e3 = i3 === "horizontal" ? "vertical" : "horizontal"),
              e3 === i3 ||
                (e3 !== "horizontal" && e3 !== "vertical") ||
                (this.$el
                  .removeClass("" + this.params.containerModifierClass + i3)
                  .addClass("" + this.params.containerModifierClass + e3),
                (this.params.direction = e3),
                this.slides.each(function (t4, i4) {
                  e3 === "vertical"
                    ? (i4.style.width = "")
                    : (i4.style.height = "");
                }),
                this.emit("changeDirection"),
                t3 && this.update()),
              this
            );
          }),
          (t2.prototype.init = function () {
            this.initialized ||
              (this.emit("beforeInit"),
              this.params.breakpoints && this.setBreakpoint(),
              this.addClasses(),
              this.params.loop && this.loopCreate(),
              this.updateSize(),
              this.updateSlides(),
              this.params.watchOverflow && this.checkOverflow(),
              this.params.grabCursor && this.setGrabCursor(),
              this.params.preloadImages && this.preloadImages(),
              this.params.loop
                ? this.slideTo(
                    this.params.initialSlide + this.loopedSlides,
                    0,
                    this.params.runCallbacksOnInit
                  )
                : this.slideTo(
                    this.params.initialSlide,
                    0,
                    this.params.runCallbacksOnInit
                  ),
              this.attachEvents(),
              (this.initialized = !0),
              this.emit("init"));
          }),
          (t2.prototype.destroy = function (e3, t3) {
            e3 === void 0 && (e3 = !0), t3 === void 0 && (t3 = !0);
            var i3 = this,
              n2 = i3.params,
              s2 = i3.$el,
              a2 = i3.$wrapperEl,
              o2 = i3.slides;
            return (
              i3.params === void 0 ||
                i3.destroyed ||
                (i3.emit("beforeDestroy"),
                (i3.initialized = !1),
                i3.detachEvents(),
                n2.loop && i3.loopDestroy(),
                t3 &&
                  (i3.removeClasses(),
                  s2.removeAttr("style"),
                  a2.removeAttr("style"),
                  o2 &&
                    o2.length &&
                    o2
                      .removeClass(
                        [
                          n2.slideVisibleClass,
                          n2.slideActiveClass,
                          n2.slideNextClass,
                          n2.slidePrevClass,
                        ].join(" ")
                      )
                      .removeAttr("style")
                      .removeAttr("data-swiper-slide-index")),
                i3.emit("destroy"),
                Object.keys(i3.eventsListeners).forEach(function (e4) {
                  i3.off(e4);
                }),
                e3 !== !1 &&
                  ((i3.$el[0].swiper = null),
                  i3.$el.data("swiper", null),
                  r.deleteProps(i3)),
                (i3.destroyed = !0)),
              null
            );
          }),
          (t2.extendDefaults = function (e3) {
            r.extend(V, e3);
          }),
          (i2.extendedDefaults.get = function () {
            return V;
          }),
          (i2.defaults.get = function () {
            return H;
          }),
          (i2.Class.get = function () {
            return e2;
          }),
          (i2.$.get = function () {
            return n;
          }),
          Object.defineProperties(t2, i2),
          t2
        );
      })(l),
      j = { name: "device", proto: { device: I }, static: { device: I } },
      X = { name: "support", proto: { support: o }, static: { support: o } },
      G = {
        isEdge: !!t.navigator.userAgent.match(/Edge/g),
        isSafari: (function () {
          var e2 = t.navigator.userAgent.toLowerCase();
          return (
            e2.indexOf("safari") >= 0 &&
            e2.indexOf("chrome") < 0 &&
            e2.indexOf("android") < 0
          );
        })(),
        isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
          t.navigator.userAgent
        ),
      },
      W = { name: "browser", proto: { browser: G }, static: { browser: G } },
      Y = {
        name: "resize",
        create: function () {
          var e2 = this;
          r.extend(e2, {
            resize: {
              resizeHandler: function () {
                e2 &&
                  !e2.destroyed &&
                  e2.initialized &&
                  (e2.emit("beforeResize"), e2.emit("resize"));
              },
              orientationChangeHandler: function () {
                e2 &&
                  !e2.destroyed &&
                  e2.initialized &&
                  e2.emit("orientationchange");
              },
            },
          });
        },
        on: {
          init: function () {
            t.addEventListener("resize", this.resize.resizeHandler),
              t.addEventListener(
                "orientationchange",
                this.resize.orientationChangeHandler
              );
          },
          destroy: function () {
            t.removeEventListener("resize", this.resize.resizeHandler),
              t.removeEventListener(
                "orientationchange",
                this.resize.orientationChangeHandler
              );
          },
        },
      },
      U = {
        func: t.MutationObserver || t.WebkitMutationObserver,
        attach: function (e2, i2) {
          i2 === void 0 && (i2 = {});
          var n2 = this,
            s2 = new U.func(function (e3) {
              if (e3.length !== 1) {
                var i3 = function () {
                  n2.emit("observerUpdate", e3[0]);
                };
                t.requestAnimationFrame
                  ? t.requestAnimationFrame(i3)
                  : t.setTimeout(i3, 0);
              } else n2.emit("observerUpdate", e3[0]);
            });
          s2.observe(e2, {
            attributes: i2.attributes === void 0 || i2.attributes,
            childList: i2.childList === void 0 || i2.childList,
            characterData: i2.characterData === void 0 || i2.characterData,
          }),
            n2.observer.observers.push(s2);
        },
        init: function () {
          if (o.observer && this.params.observer) {
            if (this.params.observeParents)
              for (var e2 = this.$el.parents(), t2 = 0; t2 < e2.length; t2 += 1)
                this.observer.attach(e2[t2]);
            this.observer.attach(this.$el[0], {
              childList: this.params.observeSlideChildren,
            }),
              this.observer.attach(this.$wrapperEl[0], { attributes: !1 });
          }
        },
        destroy: function () {
          this.observer.observers.forEach(function (e2) {
            e2.disconnect();
          }),
            (this.observer.observers = []);
        },
      },
      K = {
        name: "observer",
        params: { observer: !1, observeParents: !1, observeSlideChildren: !1 },
        create: function () {
          r.extend(this, {
            observer: {
              init: U.init.bind(this),
              attach: U.attach.bind(this),
              destroy: U.destroy.bind(this),
              observers: [],
            },
          });
        },
        on: {
          init: function () {
            this.observer.init();
          },
          destroy: function () {
            this.observer.destroy();
          },
        },
      },
      Q = {
        update: function (e2) {
          var t2 = this,
            i2 = t2.params,
            n2 = i2.slidesPerView,
            s2 = i2.slidesPerGroup,
            a2 = i2.centeredSlides,
            o2 = t2.params.virtual,
            l2 = o2.addSlidesBefore,
            c2 = o2.addSlidesAfter,
            u2 = t2.virtual,
            d2 = u2.from,
            h2 = u2.to,
            p2 = u2.slides,
            f2 = u2.slidesGrid,
            v2 = u2.renderSlide,
            m2 = u2.offset;
          t2.updateActiveIndex();
          var g2,
            y2,
            b2,
            w2 = t2.activeIndex || 0;
          (g2 = t2.rtlTranslate ? "right" : t2.isHorizontal() ? "left" : "top"),
            a2
              ? ((y2 = Math.floor(n2 / 2) + s2 + l2),
                (b2 = Math.floor(n2 / 2) + s2 + c2))
              : ((y2 = n2 + (s2 - 1) + l2), (b2 = s2 + c2));
          var S2 = Math.max((w2 || 0) - b2, 0),
            x2 = Math.min((w2 || 0) + y2, p2.length - 1),
            C2 = (t2.slidesGrid[S2] || 0) - (t2.slidesGrid[0] || 0);
          function k2() {
            t2.updateSlides(),
              t2.updateProgress(),
              t2.updateSlidesClasses(),
              t2.lazy && t2.params.lazy.enabled && t2.lazy.load();
          }
          if (
            (r.extend(t2.virtual, {
              from: S2,
              to: x2,
              offset: C2,
              slidesGrid: t2.slidesGrid,
            }),
            d2 === S2 && h2 === x2 && !e2)
          )
            return (
              t2.slidesGrid !== f2 && C2 !== m2 && t2.slides.css(g2, C2 + "px"),
              void t2.updateProgress()
            );
          if (t2.params.virtual.renderExternal)
            return (
              t2.params.virtual.renderExternal.call(t2, {
                offset: C2,
                from: S2,
                to: x2,
                slides: (function () {
                  for (var e3 = [], t3 = S2; t3 <= x2; t3 += 1) e3.push(p2[t3]);
                  return e3;
                })(),
              }),
              void k2()
            );
          var E2 = [],
            T2 = [];
          if (e2) t2.$wrapperEl.find("." + t2.params.slideClass).remove();
          else
            for (var _2 = d2; _2 <= h2; _2 += 1)
              (_2 < S2 || _2 > x2) &&
                t2.$wrapperEl
                  .find(
                    "." +
                      t2.params.slideClass +
                      '[data-swiper-slide-index="' +
                      _2 +
                      '"]'
                  )
                  .remove();
          for (var M2 = 0; M2 < p2.length; M2 += 1)
            M2 >= S2 &&
              M2 <= x2 &&
              (h2 === void 0 || e2
                ? T2.push(M2)
                : (M2 > h2 && T2.push(M2), M2 < d2 && E2.push(M2)));
          T2.forEach(function (e3) {
            t2.$wrapperEl.append(v2(p2[e3], e3));
          }),
            E2.sort(function (e3, t3) {
              return t3 - e3;
            }).forEach(function (e3) {
              t2.$wrapperEl.prepend(v2(p2[e3], e3));
            }),
            t2.$wrapperEl.children(".swiper-slide").css(g2, C2 + "px"),
            k2();
        },
        renderSlide: function (e2, t2) {
          var i2 = this.params.virtual;
          if (i2.cache && this.virtual.cache[t2]) return this.virtual.cache[t2];
          var s2 = i2.renderSlide
            ? n(i2.renderSlide.call(this, e2, t2))
            : n(
                '<div class="' +
                  this.params.slideClass +
                  '" data-swiper-slide-index="' +
                  t2 +
                  '">' +
                  e2 +
                  "</div>"
              );
          return (
            s2.attr("data-swiper-slide-index") ||
              s2.attr("data-swiper-slide-index", t2),
            i2.cache && (this.virtual.cache[t2] = s2),
            s2
          );
        },
        appendSlide: function (e2) {
          if (typeof e2 == "object" && "length" in e2)
            for (var t2 = 0; t2 < e2.length; t2 += 1)
              e2[t2] && this.virtual.slides.push(e2[t2]);
          else this.virtual.slides.push(e2);
          this.virtual.update(!0);
        },
        prependSlide: function (e2) {
          var t2 = this.activeIndex,
            i2 = t2 + 1,
            n2 = 1;
          if (Array.isArray(e2)) {
            for (var s2 = 0; s2 < e2.length; s2 += 1)
              e2[s2] && this.virtual.slides.unshift(e2[s2]);
            (i2 = t2 + e2.length), (n2 = e2.length);
          } else this.virtual.slides.unshift(e2);
          if (this.params.virtual.cache) {
            var a2 = this.virtual.cache,
              r2 = {};
            Object.keys(a2).forEach(function (e3) {
              var t3 = a2[e3],
                i3 = t3.attr("data-swiper-slide-index");
              i3 && t3.attr("data-swiper-slide-index", parseInt(i3, 10) + 1),
                (r2[parseInt(e3, 10) + n2] = t3);
            }),
              (this.virtual.cache = r2);
          }
          this.virtual.update(!0), this.slideTo(i2, 0);
        },
        removeSlide: function (e2) {
          if (e2 != null) {
            var t2 = this.activeIndex;
            if (Array.isArray(e2))
              for (var i2 = e2.length - 1; i2 >= 0; i2 -= 1)
                this.virtual.slides.splice(e2[i2], 1),
                  this.params.virtual.cache &&
                    delete this.virtual.cache[e2[i2]],
                  e2[i2] < t2 && (t2 -= 1),
                  (t2 = Math.max(t2, 0));
            else
              this.virtual.slides.splice(e2, 1),
                this.params.virtual.cache && delete this.virtual.cache[e2],
                e2 < t2 && (t2 -= 1),
                (t2 = Math.max(t2, 0));
            this.virtual.update(!0), this.slideTo(t2, 0);
          }
        },
        removeAllSlides: function () {
          (this.virtual.slides = []),
            this.params.virtual.cache && (this.virtual.cache = {}),
            this.virtual.update(!0),
            this.slideTo(0, 0);
        },
      },
      Z = {
        name: "virtual",
        params: {
          virtual: {
            enabled: !1,
            slides: [],
            cache: !0,
            renderSlide: null,
            renderExternal: null,
            addSlidesBefore: 0,
            addSlidesAfter: 0,
          },
        },
        create: function () {
          r.extend(this, {
            virtual: {
              update: Q.update.bind(this),
              appendSlide: Q.appendSlide.bind(this),
              prependSlide: Q.prependSlide.bind(this),
              removeSlide: Q.removeSlide.bind(this),
              removeAllSlides: Q.removeAllSlides.bind(this),
              renderSlide: Q.renderSlide.bind(this),
              slides: this.params.virtual.slides,
              cache: {},
            },
          });
        },
        on: {
          beforeInit: function () {
            if (this.params.virtual.enabled) {
              this.classNames.push(
                this.params.containerModifierClass + "virtual"
              );
              var e2 = { watchSlidesProgress: !0 };
              r.extend(this.params, e2),
                r.extend(this.originalParams, e2),
                this.params.initialSlide || this.virtual.update();
            }
          },
          setTranslate: function () {
            this.params.virtual.enabled && this.virtual.update();
          },
        },
      },
      J = {
        handle: function (i2) {
          var n2 = this.rtlTranslate,
            s2 = i2;
          s2.originalEvent && (s2 = s2.originalEvent);
          var a2 = s2.keyCode || s2.charCode;
          if (
            (!this.allowSlideNext &&
              ((this.isHorizontal() && a2 === 39) ||
                (this.isVertical() && a2 === 40) ||
                a2 === 34)) ||
            (!this.allowSlidePrev &&
              ((this.isHorizontal() && a2 === 37) ||
                (this.isVertical() && a2 === 38) ||
                a2 === 33))
          )
            return !1;
          if (
            !(
              s2.shiftKey ||
              s2.altKey ||
              s2.ctrlKey ||
              s2.metaKey ||
              (e.activeElement &&
                e.activeElement.nodeName &&
                (e.activeElement.nodeName.toLowerCase() === "input" ||
                  e.activeElement.nodeName.toLowerCase() === "textarea"))
            )
          ) {
            if (
              this.params.keyboard.onlyInViewport &&
              (a2 === 33 ||
                a2 === 34 ||
                a2 === 37 ||
                a2 === 39 ||
                a2 === 38 ||
                a2 === 40)
            ) {
              var r2 = !1;
              if (
                this.$el.parents("." + this.params.slideClass).length > 0 &&
                this.$el.parents("." + this.params.slideActiveClass).length ===
                  0
              )
                return;
              var o2 = t.innerWidth,
                l2 = t.innerHeight,
                c2 = this.$el.offset();
              n2 && (c2.left -= this.$el[0].scrollLeft);
              for (
                var u2 = [
                    [c2.left, c2.top],
                    [c2.left + this.width, c2.top],
                    [c2.left, c2.top + this.height],
                    [c2.left + this.width, c2.top + this.height],
                  ],
                  d2 = 0;
                d2 < u2.length;
                d2 += 1
              ) {
                var h2 = u2[d2];
                h2[0] >= 0 &&
                  h2[0] <= o2 &&
                  h2[1] >= 0 &&
                  h2[1] <= l2 &&
                  (r2 = !0);
              }
              if (!r2) return;
            }
            this.isHorizontal()
              ? ((a2 !== 33 && a2 !== 34 && a2 !== 37 && a2 !== 39) ||
                  (s2.preventDefault
                    ? s2.preventDefault()
                    : (s2.returnValue = !1)),
                (((a2 !== 34 && a2 !== 39) || n2) &&
                  ((a2 !== 33 && a2 !== 37) || !n2)) ||
                  this.slideNext(),
                (((a2 !== 33 && a2 !== 37) || n2) &&
                  ((a2 !== 34 && a2 !== 39) || !n2)) ||
                  this.slidePrev())
              : ((a2 !== 33 && a2 !== 34 && a2 !== 38 && a2 !== 40) ||
                  (s2.preventDefault
                    ? s2.preventDefault()
                    : (s2.returnValue = !1)),
                (a2 !== 34 && a2 !== 40) || this.slideNext(),
                (a2 !== 33 && a2 !== 38) || this.slidePrev()),
              this.emit("keyPress", a2);
          }
        },
        enable: function () {
          this.keyboard.enabled ||
            (n(e).on("keydown", this.keyboard.handle),
            (this.keyboard.enabled = !0));
        },
        disable: function () {
          this.keyboard.enabled &&
            (n(e).off("keydown", this.keyboard.handle),
            (this.keyboard.enabled = !1));
        },
      },
      ee = {
        name: "keyboard",
        params: { keyboard: { enabled: !1, onlyInViewport: !0 } },
        create: function () {
          r.extend(this, {
            keyboard: {
              enabled: !1,
              enable: J.enable.bind(this),
              disable: J.disable.bind(this),
              handle: J.handle.bind(this),
            },
          });
        },
        on: {
          init: function () {
            this.params.keyboard.enabled && this.keyboard.enable();
          },
          destroy: function () {
            this.keyboard.enabled && this.keyboard.disable();
          },
        },
      },
      te = {
        lastScrollTime: r.now(),
        lastEventBeforeSnap: void 0,
        recentWheelEvents: [],
        event: function () {
          return t.navigator.userAgent.indexOf("firefox") > -1
            ? "DOMMouseScroll"
            : (function () {
                var t2 = "onwheel" in e;
                if (!t2) {
                  var i2 = e.createElement("div");
                  i2.setAttribute("onwheel", "return;"),
                    (t2 = typeof i2.onwheel == "function");
                }
                return (
                  !t2 &&
                    e.implementation &&
                    e.implementation.hasFeature &&
                    e.implementation.hasFeature("", "") !== !0 &&
                    (t2 = e.implementation.hasFeature("Events.wheel", "3.0")),
                  t2
                );
              })()
            ? "wheel"
            : "mousewheel";
        },
        normalize: function (e2) {
          var t2 = 0,
            i2 = 0,
            n2 = 0,
            s2 = 0;
          return (
            "detail" in e2 && (i2 = e2.detail),
            "wheelDelta" in e2 && (i2 = -e2.wheelDelta / 120),
            "wheelDeltaY" in e2 && (i2 = -e2.wheelDeltaY / 120),
            "wheelDeltaX" in e2 && (t2 = -e2.wheelDeltaX / 120),
            "axis" in e2 &&
              e2.axis === e2.HORIZONTAL_AXIS &&
              ((t2 = i2), (i2 = 0)),
            (n2 = 10 * t2),
            (s2 = 10 * i2),
            "deltaY" in e2 && (s2 = e2.deltaY),
            "deltaX" in e2 && (n2 = e2.deltaX),
            e2.shiftKey && !n2 && ((n2 = s2), (s2 = 0)),
            (n2 || s2) &&
              e2.deltaMode &&
              (e2.deltaMode === 1
                ? ((n2 *= 40), (s2 *= 40))
                : ((n2 *= 800), (s2 *= 800))),
            n2 && !t2 && (t2 = n2 < 1 ? -1 : 1),
            s2 && !i2 && (i2 = s2 < 1 ? -1 : 1),
            { spinX: t2, spinY: i2, pixelX: n2, pixelY: s2 }
          );
        },
        handleMouseEnter: function () {
          this.mouseEntered = !0;
        },
        handleMouseLeave: function () {
          this.mouseEntered = !1;
        },
        handle: function (e2) {
          var t2 = e2,
            i2 = this,
            s2 = i2.params.mousewheel;
          i2.params.cssMode && t2.preventDefault();
          var a2 = i2.$el;
          if (
            (i2.params.mousewheel.eventsTarged !== "container" &&
              (a2 = n(i2.params.mousewheel.eventsTarged)),
            !i2.mouseEntered &&
              !a2[0].contains(t2.target) &&
              !s2.releaseOnEdges)
          )
            return !0;
          t2.originalEvent && (t2 = t2.originalEvent);
          var o2 = 0,
            l2 = i2.rtlTranslate ? -1 : 1,
            c2 = te.normalize(t2);
          if (s2.forceToAxis)
            if (i2.isHorizontal()) {
              if (!(Math.abs(c2.pixelX) > Math.abs(c2.pixelY))) return !0;
              o2 = c2.pixelX * l2;
            } else {
              if (!(Math.abs(c2.pixelY) > Math.abs(c2.pixelX))) return !0;
              o2 = c2.pixelY;
            }
          else
            o2 =
              Math.abs(c2.pixelX) > Math.abs(c2.pixelY)
                ? -c2.pixelX * l2
                : -c2.pixelY;
          if (o2 === 0) return !0;
          if ((s2.invert && (o2 = -o2), i2.params.freeMode)) {
            var u2 = {
                time: r.now(),
                delta: Math.abs(o2),
                direction: Math.sign(o2),
              },
              d2 = i2.mousewheel.lastEventBeforeSnap,
              h2 =
                d2 &&
                u2.time < d2.time + 500 &&
                u2.delta <= d2.delta &&
                u2.direction === d2.direction;
            if (!h2) {
              (i2.mousewheel.lastEventBeforeSnap = void 0),
                i2.params.loop && i2.loopFix();
              var p2 = i2.getTranslate() + o2 * s2.sensitivity,
                f2 = i2.isBeginning,
                v2 = i2.isEnd;
              if (
                (p2 >= i2.minTranslate() && (p2 = i2.minTranslate()),
                p2 <= i2.maxTranslate() && (p2 = i2.maxTranslate()),
                i2.setTransition(0),
                i2.setTranslate(p2),
                i2.updateProgress(),
                i2.updateActiveIndex(),
                i2.updateSlidesClasses(),
                ((!f2 && i2.isBeginning) || (!v2 && i2.isEnd)) &&
                  i2.updateSlidesClasses(),
                i2.params.freeModeSticky)
              ) {
                clearTimeout(i2.mousewheel.timeout),
                  (i2.mousewheel.timeout = void 0);
                var m2 = i2.mousewheel.recentWheelEvents;
                m2.length >= 15 && m2.shift();
                var g2 = m2.length ? m2[m2.length - 1] : void 0,
                  y2 = m2[0];
                if (
                  (m2.push(u2),
                  g2 && (u2.delta > g2.delta || u2.direction !== g2.direction))
                )
                  m2.splice(0);
                else if (
                  m2.length >= 15 &&
                  u2.time - y2.time < 500 &&
                  y2.delta - u2.delta >= 1 &&
                  u2.delta <= 6
                ) {
                  var b2 = o2 > 0 ? 0.8 : 0.2;
                  (i2.mousewheel.lastEventBeforeSnap = u2),
                    m2.splice(0),
                    (i2.mousewheel.timeout = r.nextTick(function () {
                      i2.slideToClosest(i2.params.speed, !0, void 0, b2);
                    }, 0));
                }
                i2.mousewheel.timeout ||
                  (i2.mousewheel.timeout = r.nextTick(function () {
                    (i2.mousewheel.lastEventBeforeSnap = u2),
                      m2.splice(0),
                      i2.slideToClosest(i2.params.speed, !0, void 0, 0.5);
                  }, 500));
              }
              if (
                (h2 || i2.emit("scroll", t2),
                i2.params.autoplay &&
                  i2.params.autoplayDisableOnInteraction &&
                  i2.autoplay.stop(),
                p2 === i2.minTranslate() || p2 === i2.maxTranslate())
              )
                return !0;
            }
          } else {
            var w2 = {
                time: r.now(),
                delta: Math.abs(o2),
                direction: Math.sign(o2),
                raw: e2,
              },
              S2 = i2.mousewheel.recentWheelEvents;
            S2.length >= 2 && S2.shift();
            var x2 = S2.length ? S2[S2.length - 1] : void 0;
            if (
              (S2.push(w2),
              x2
                ? (w2.direction !== x2.direction || w2.delta > x2.delta) &&
                  i2.mousewheel.animateSlider(w2)
                : i2.mousewheel.animateSlider(w2),
              i2.mousewheel.releaseScroll(w2))
            )
              return !0;
          }
          return (
            t2.preventDefault ? t2.preventDefault() : (t2.returnValue = !1), !1
          );
        },
        animateSlider: function (e2) {
          return (
            (e2.delta >= 6 && r.now() - this.mousewheel.lastScrollTime < 60) ||
            (e2.direction < 0
              ? (this.isEnd && !this.params.loop) ||
                this.animating ||
                (this.slideNext(), this.emit("scroll", e2.raw))
              : (this.isBeginning && !this.params.loop) ||
                this.animating ||
                (this.slidePrev(), this.emit("scroll", e2.raw)),
            (this.mousewheel.lastScrollTime = new t.Date().getTime()),
            !1)
          );
        },
        releaseScroll: function (e2) {
          var t2 = this.params.mousewheel;
          if (e2.direction < 0) {
            if (this.isEnd && !this.params.loop && t2.releaseOnEdges) return !0;
          } else if (this.isBeginning && !this.params.loop && t2.releaseOnEdges)
            return !0;
          return !1;
        },
        enable: function () {
          var e2 = te.event();
          if (this.params.cssMode)
            return (
              this.wrapperEl.removeEventListener(e2, this.mousewheel.handle), !0
            );
          if (!e2 || this.mousewheel.enabled) return !1;
          var t2 = this.$el;
          return (
            this.params.mousewheel.eventsTarged !== "container" &&
              (t2 = n(this.params.mousewheel.eventsTarged)),
            t2.on("mouseenter", this.mousewheel.handleMouseEnter),
            t2.on("mouseleave", this.mousewheel.handleMouseLeave),
            t2.on(e2, this.mousewheel.handle),
            (this.mousewheel.enabled = !0),
            !0
          );
        },
        disable: function () {
          var e2 = te.event();
          if (this.params.cssMode)
            return (
              this.wrapperEl.addEventListener(e2, this.mousewheel.handle), !0
            );
          if (!e2 || !this.mousewheel.enabled) return !1;
          var t2 = this.$el;
          return (
            this.params.mousewheel.eventsTarged !== "container" &&
              (t2 = n(this.params.mousewheel.eventsTarged)),
            t2.off(e2, this.mousewheel.handle),
            (this.mousewheel.enabled = !1),
            !0
          );
        },
      },
      ie = {
        update: function () {
          var e2 = this.params.navigation;
          if (!this.params.loop) {
            var t2 = this.navigation,
              i2 = t2.$nextEl,
              n2 = t2.$prevEl;
            n2 &&
              n2.length > 0 &&
              (this.isBeginning
                ? n2.addClass(e2.disabledClass)
                : n2.removeClass(e2.disabledClass),
              n2[
                this.params.watchOverflow && this.isLocked
                  ? "addClass"
                  : "removeClass"
              ](e2.lockClass)),
              i2 &&
                i2.length > 0 &&
                (this.isEnd
                  ? i2.addClass(e2.disabledClass)
                  : i2.removeClass(e2.disabledClass),
                i2[
                  this.params.watchOverflow && this.isLocked
                    ? "addClass"
                    : "removeClass"
                ](e2.lockClass));
          }
        },
        onPrevClick: function (e2) {
          e2.preventDefault(),
            (this.isBeginning && !this.params.loop) || this.slidePrev();
        },
        onNextClick: function (e2) {
          e2.preventDefault(),
            (this.isEnd && !this.params.loop) || this.slideNext();
        },
        init: function () {
          var e2,
            t2,
            i2 = this.params.navigation;
          (i2.nextEl || i2.prevEl) &&
            (i2.nextEl &&
              ((e2 = n(i2.nextEl)),
              this.params.uniqueNavElements &&
                typeof i2.nextEl == "string" &&
                e2.length > 1 &&
                this.$el.find(i2.nextEl).length === 1 &&
                (e2 = this.$el.find(i2.nextEl))),
            i2.prevEl &&
              ((t2 = n(i2.prevEl)),
              this.params.uniqueNavElements &&
                typeof i2.prevEl == "string" &&
                t2.length > 1 &&
                this.$el.find(i2.prevEl).length === 1 &&
                (t2 = this.$el.find(i2.prevEl))),
            e2 && e2.length > 0 && e2.on("click", this.navigation.onNextClick),
            t2 && t2.length > 0 && t2.on("click", this.navigation.onPrevClick),
            r.extend(this.navigation, {
              $nextEl: e2,
              nextEl: e2 && e2[0],
              $prevEl: t2,
              prevEl: t2 && t2[0],
            }));
        },
        destroy: function () {
          var e2 = this.navigation,
            t2 = e2.$nextEl,
            i2 = e2.$prevEl;
          t2 &&
            t2.length &&
            (t2.off("click", this.navigation.onNextClick),
            t2.removeClass(this.params.navigation.disabledClass)),
            i2 &&
              i2.length &&
              (i2.off("click", this.navigation.onPrevClick),
              i2.removeClass(this.params.navigation.disabledClass));
        },
      },
      ne = {
        update: function () {
          var e2 = this.rtl,
            t2 = this.params.pagination;
          if (
            t2.el &&
            this.pagination.el &&
            this.pagination.$el &&
            this.pagination.$el.length !== 0
          ) {
            var i2,
              s2 =
                this.virtual && this.params.virtual.enabled
                  ? this.virtual.slides.length
                  : this.slides.length,
              a2 = this.pagination.$el,
              r2 = this.params.loop
                ? Math.ceil(
                    (s2 - 2 * this.loopedSlides) / this.params.slidesPerGroup
                  )
                : this.snapGrid.length;
            if (
              (this.params.loop
                ? ((i2 = Math.ceil(
                    (this.activeIndex - this.loopedSlides) /
                      this.params.slidesPerGroup
                  )) >
                    s2 - 1 - 2 * this.loopedSlides &&
                    (i2 -= s2 - 2 * this.loopedSlides),
                  i2 > r2 - 1 && (i2 -= r2),
                  i2 < 0 &&
                    this.params.paginationType !== "bullets" &&
                    (i2 = r2 + i2))
                : (i2 =
                    this.snapIndex !== void 0
                      ? this.snapIndex
                      : this.activeIndex || 0),
              t2.type === "bullets" &&
                this.pagination.bullets &&
                this.pagination.bullets.length > 0)
            ) {
              var o2,
                l2,
                c2,
                u2 = this.pagination.bullets;
              if (
                (t2.dynamicBullets &&
                  ((this.pagination.bulletSize = u2
                    .eq(0)
                    [this.isHorizontal() ? "outerWidth" : "outerHeight"](!0)),
                  a2.css(
                    this.isHorizontal() ? "width" : "height",
                    this.pagination.bulletSize * (t2.dynamicMainBullets + 4) +
                      "px"
                  ),
                  t2.dynamicMainBullets > 1 &&
                    this.previousIndex !== void 0 &&
                    ((this.pagination.dynamicBulletIndex +=
                      i2 - this.previousIndex),
                    this.pagination.dynamicBulletIndex >
                    t2.dynamicMainBullets - 1
                      ? (this.pagination.dynamicBulletIndex =
                          t2.dynamicMainBullets - 1)
                      : this.pagination.dynamicBulletIndex < 0 &&
                        (this.pagination.dynamicBulletIndex = 0)),
                  (o2 = i2 - this.pagination.dynamicBulletIndex),
                  (c2 =
                    ((l2 =
                      o2 + (Math.min(u2.length, t2.dynamicMainBullets) - 1)) +
                      o2) /
                    2)),
                u2.removeClass(
                  t2.bulletActiveClass +
                    " " +
                    t2.bulletActiveClass +
                    "-next " +
                    t2.bulletActiveClass +
                    "-next-next " +
                    t2.bulletActiveClass +
                    "-prev " +
                    t2.bulletActiveClass +
                    "-prev-prev " +
                    t2.bulletActiveClass +
                    "-main"
                ),
                a2.length > 1)
              )
                u2.each(function (e3, s3) {
                  var a3 = n(s3),
                    r3 = a3.index();
                  r3 === i2 && a3.addClass(t2.bulletActiveClass),
                    t2.dynamicBullets &&
                      (r3 >= o2 &&
                        r3 <= l2 &&
                        a3.addClass(t2.bulletActiveClass + "-main"),
                      r3 === o2 &&
                        a3
                          .prev()
                          .addClass(t2.bulletActiveClass + "-prev")
                          .prev()
                          .addClass(t2.bulletActiveClass + "-prev-prev"),
                      r3 === l2 &&
                        a3
                          .next()
                          .addClass(t2.bulletActiveClass + "-next")
                          .next()
                          .addClass(t2.bulletActiveClass + "-next-next"));
                });
              else {
                var d2 = u2.eq(i2),
                  h2 = d2.index();
                if ((d2.addClass(t2.bulletActiveClass), t2.dynamicBullets)) {
                  for (
                    var p2 = u2.eq(o2), f2 = u2.eq(l2), v2 = o2;
                    v2 <= l2;
                    v2 += 1
                  )
                    u2.eq(v2).addClass(t2.bulletActiveClass + "-main");
                  if (this.params.loop)
                    if (h2 >= u2.length - t2.dynamicMainBullets) {
                      for (var m2 = t2.dynamicMainBullets; m2 >= 0; m2 -= 1)
                        u2.eq(u2.length - m2).addClass(
                          t2.bulletActiveClass + "-main"
                        );
                      u2.eq(u2.length - t2.dynamicMainBullets - 1).addClass(
                        t2.bulletActiveClass + "-prev"
                      );
                    } else
                      p2
                        .prev()
                        .addClass(t2.bulletActiveClass + "-prev")
                        .prev()
                        .addClass(t2.bulletActiveClass + "-prev-prev"),
                        f2
                          .next()
                          .addClass(t2.bulletActiveClass + "-next")
                          .next()
                          .addClass(t2.bulletActiveClass + "-next-next");
                  else
                    p2
                      .prev()
                      .addClass(t2.bulletActiveClass + "-prev")
                      .prev()
                      .addClass(t2.bulletActiveClass + "-prev-prev"),
                      f2
                        .next()
                        .addClass(t2.bulletActiveClass + "-next")
                        .next()
                        .addClass(t2.bulletActiveClass + "-next-next");
                }
              }
              if (t2.dynamicBullets) {
                var g2 = Math.min(u2.length, t2.dynamicMainBullets + 4),
                  y2 =
                    (this.pagination.bulletSize * g2 -
                      this.pagination.bulletSize) /
                      2 -
                    c2 * this.pagination.bulletSize,
                  b2 = e2 ? "right" : "left";
                u2.css(this.isHorizontal() ? b2 : "top", y2 + "px");
              }
            }
            if (
              (t2.type === "fraction" &&
                (a2
                  .find("." + t2.currentClass)
                  .text(t2.formatFractionCurrent(i2 + 1)),
                a2.find("." + t2.totalClass).text(t2.formatFractionTotal(r2))),
              t2.type === "progressbar")
            ) {
              var w2;
              w2 = t2.progressbarOpposite
                ? this.isHorizontal()
                  ? "vertical"
                  : "horizontal"
                : this.isHorizontal()
                ? "horizontal"
                : "vertical";
              var S2 = (i2 + 1) / r2,
                x2 = 1,
                C2 = 1;
              w2 === "horizontal" ? (x2 = S2) : (C2 = S2),
                a2
                  .find("." + t2.progressbarFillClass)
                  .transform(
                    "translate3d(0,0,0) scaleX(" + x2 + ") scaleY(" + C2 + ")"
                  )
                  .transition(this.params.speed);
            }
            t2.type === "custom" && t2.renderCustom
              ? (a2.html(t2.renderCustom(this, i2 + 1, r2)),
                this.emit("paginationRender", this, a2[0]))
              : this.emit("paginationUpdate", this, a2[0]),
              a2[
                this.params.watchOverflow && this.isLocked
                  ? "addClass"
                  : "removeClass"
              ](t2.lockClass);
          }
        },
        render: function () {
          var e2 = this.params.pagination;
          if (
            e2.el &&
            this.pagination.el &&
            this.pagination.$el &&
            this.pagination.$el.length !== 0
          ) {
            var t2 =
                this.virtual && this.params.virtual.enabled
                  ? this.virtual.slides.length
                  : this.slides.length,
              i2 = this.pagination.$el,
              n2 = "";
            if (e2.type === "bullets") {
              for (
                var s2 = this.params.loop
                    ? Math.ceil(
                        (t2 - 2 * this.loopedSlides) /
                          this.params.slidesPerGroup
                      )
                    : this.snapGrid.length,
                  a2 = 0;
                a2 < s2;
                a2 += 1
              )
                e2.renderBullet
                  ? (n2 += e2.renderBullet.call(this, a2, e2.bulletClass))
                  : (n2 +=
                      "<" +
                      e2.bulletElement +
                      ' class="' +
                      e2.bulletClass +
                      '"></' +
                      e2.bulletElement +
                      ">");
              i2.html(n2),
                (this.pagination.bullets = i2.find("." + e2.bulletClass));
            }
            e2.type === "fraction" &&
              ((n2 = e2.renderFraction
                ? e2.renderFraction.call(this, e2.currentClass, e2.totalClass)
                : '<span class="' +
                  e2.currentClass +
                  '"></span> / <span class="' +
                  e2.totalClass +
                  '"></span>'),
              i2.html(n2)),
              e2.type === "progressbar" &&
                ((n2 = e2.renderProgressbar
                  ? e2.renderProgressbar.call(this, e2.progressbarFillClass)
                  : '<span class="' + e2.progressbarFillClass + '"></span>'),
                i2.html(n2)),
              e2.type !== "custom" &&
                this.emit("paginationRender", this.pagination.$el[0]);
          }
        },
        init: function () {
          var e2 = this,
            t2 = e2.params.pagination;
          if (t2.el) {
            var i2 = n(t2.el);
            i2.length !== 0 &&
              (e2.params.uniqueNavElements &&
                typeof t2.el == "string" &&
                i2.length > 1 &&
                e2.$el.find(t2.el).length === 1 &&
                (i2 = e2.$el.find(t2.el)),
              t2.type === "bullets" &&
                t2.clickable &&
                i2.addClass(t2.clickableClass),
              i2.addClass(t2.modifierClass + t2.type),
              t2.type === "bullets" &&
                t2.dynamicBullets &&
                (i2.addClass("" + t2.modifierClass + t2.type + "-dynamic"),
                (e2.pagination.dynamicBulletIndex = 0),
                t2.dynamicMainBullets < 1 && (t2.dynamicMainBullets = 1)),
              t2.type === "progressbar" &&
                t2.progressbarOpposite &&
                i2.addClass(t2.progressbarOppositeClass),
              t2.clickable &&
                i2.on("click", "." + t2.bulletClass, function (t3) {
                  t3.preventDefault();
                  var i3 = n(this).index() * e2.params.slidesPerGroup;
                  e2.params.loop && (i3 += e2.loopedSlides), e2.slideTo(i3);
                }),
              r.extend(e2.pagination, { $el: i2, el: i2[0] }));
          }
        },
        destroy: function () {
          var e2 = this.params.pagination;
          if (
            e2.el &&
            this.pagination.el &&
            this.pagination.$el &&
            this.pagination.$el.length !== 0
          ) {
            var t2 = this.pagination.$el;
            t2.removeClass(e2.hiddenClass),
              t2.removeClass(e2.modifierClass + e2.type),
              this.pagination.bullets &&
                this.pagination.bullets.removeClass(e2.bulletActiveClass),
              e2.clickable && t2.off("click", "." + e2.bulletClass);
          }
        },
      },
      se = {
        setTranslate: function () {
          if (this.params.scrollbar.el && this.scrollbar.el) {
            var e2 = this.scrollbar,
              t2 = this.rtlTranslate,
              i2 = this.progress,
              n2 = e2.dragSize,
              s2 = e2.trackSize,
              a2 = e2.$dragEl,
              r2 = e2.$el,
              o2 = this.params.scrollbar,
              l2 = n2,
              c2 = (s2 - n2) * i2;
            t2
              ? (c2 = -c2) > 0
                ? ((l2 = n2 - c2), (c2 = 0))
                : -c2 + n2 > s2 && (l2 = s2 + c2)
              : c2 < 0
              ? ((l2 = n2 + c2), (c2 = 0))
              : c2 + n2 > s2 && (l2 = s2 - c2),
              this.isHorizontal()
                ? (a2.transform("translate3d(" + c2 + "px, 0, 0)"),
                  (a2[0].style.width = l2 + "px"))
                : (a2.transform("translate3d(0px, " + c2 + "px, 0)"),
                  (a2[0].style.height = l2 + "px")),
              o2.hide &&
                (clearTimeout(this.scrollbar.timeout),
                (r2[0].style.opacity = 1),
                (this.scrollbar.timeout = setTimeout(function () {
                  (r2[0].style.opacity = 0), r2.transition(400);
                }, 1e3)));
          }
        },
        setTransition: function (e2) {
          this.params.scrollbar.el &&
            this.scrollbar.el &&
            this.scrollbar.$dragEl.transition(e2);
        },
        updateSize: function () {
          if (this.params.scrollbar.el && this.scrollbar.el) {
            var e2 = this.scrollbar,
              t2 = e2.$dragEl,
              i2 = e2.$el;
            (t2[0].style.width = ""), (t2[0].style.height = "");
            var n2,
              s2 = this.isHorizontal() ? i2[0].offsetWidth : i2[0].offsetHeight,
              a2 = this.size / this.virtualSize,
              o2 = a2 * (s2 / this.size);
            (n2 =
              this.params.scrollbar.dragSize === "auto"
                ? s2 * a2
                : parseInt(this.params.scrollbar.dragSize, 10)),
              this.isHorizontal()
                ? (t2[0].style.width = n2 + "px")
                : (t2[0].style.height = n2 + "px"),
              (i2[0].style.display = a2 >= 1 ? "none" : ""),
              this.params.scrollbar.hide && (i2[0].style.opacity = 0),
              r.extend(e2, {
                trackSize: s2,
                divider: a2,
                moveDivider: o2,
                dragSize: n2,
              }),
              e2.$el[
                this.params.watchOverflow && this.isLocked
                  ? "addClass"
                  : "removeClass"
              ](this.params.scrollbar.lockClass);
          }
        },
        getPointerPosition: function (e2) {
          return this.isHorizontal()
            ? e2.type === "touchstart" || e2.type === "touchmove"
              ? e2.targetTouches[0].clientX
              : e2.clientX
            : e2.type === "touchstart" || e2.type === "touchmove"
            ? e2.targetTouches[0].clientY
            : e2.clientY;
        },
        setDragPosition: function (e2) {
          var t2,
            i2 = this.scrollbar,
            n2 = this.rtlTranslate,
            s2 = i2.$el,
            a2 = i2.dragSize,
            r2 = i2.trackSize,
            o2 = i2.dragStartPos;
          (t2 =
            (i2.getPointerPosition(e2) -
              s2.offset()[this.isHorizontal() ? "left" : "top"] -
              (o2 !== null ? o2 : a2 / 2)) /
            (r2 - a2)),
            (t2 = Math.max(Math.min(t2, 1), 0)),
            n2 && (t2 = 1 - t2);
          var l2 =
            this.minTranslate() +
            (this.maxTranslate() - this.minTranslate()) * t2;
          this.updateProgress(l2),
            this.setTranslate(l2),
            this.updateActiveIndex(),
            this.updateSlidesClasses();
        },
        onDragStart: function (e2) {
          var t2 = this.params.scrollbar,
            i2 = this.scrollbar,
            n2 = this.$wrapperEl,
            s2 = i2.$el,
            a2 = i2.$dragEl;
          (this.scrollbar.isTouched = !0),
            (this.scrollbar.dragStartPos =
              e2.target === a2[0] || e2.target === a2
                ? i2.getPointerPosition(e2) -
                  e2.target.getBoundingClientRect()[
                    this.isHorizontal() ? "left" : "top"
                  ]
                : null),
            e2.preventDefault(),
            e2.stopPropagation(),
            n2.transition(100),
            a2.transition(100),
            i2.setDragPosition(e2),
            clearTimeout(this.scrollbar.dragTimeout),
            s2.transition(0),
            t2.hide && s2.css("opacity", 1),
            this.params.cssMode &&
              this.$wrapperEl.css("scroll-snap-type", "none"),
            this.emit("scrollbarDragStart", e2);
        },
        onDragMove: function (e2) {
          var t2 = this.scrollbar,
            i2 = this.$wrapperEl,
            n2 = t2.$el,
            s2 = t2.$dragEl;
          this.scrollbar.isTouched &&
            (e2.preventDefault ? e2.preventDefault() : (e2.returnValue = !1),
            t2.setDragPosition(e2),
            i2.transition(0),
            n2.transition(0),
            s2.transition(0),
            this.emit("scrollbarDragMove", e2));
        },
        onDragEnd: function (e2) {
          var t2 = this.params.scrollbar,
            i2 = this.scrollbar,
            n2 = this.$wrapperEl,
            s2 = i2.$el;
          this.scrollbar.isTouched &&
            ((this.scrollbar.isTouched = !1),
            this.params.cssMode &&
              (this.$wrapperEl.css("scroll-snap-type", ""), n2.transition("")),
            t2.hide &&
              (clearTimeout(this.scrollbar.dragTimeout),
              (this.scrollbar.dragTimeout = r.nextTick(function () {
                s2.css("opacity", 0), s2.transition(400);
              }, 1e3))),
            this.emit("scrollbarDragEnd", e2),
            t2.snapOnRelease && this.slideToClosest());
        },
        enableDraggable: function () {
          if (this.params.scrollbar.el) {
            var t2 = this.scrollbar,
              i2 = this.touchEventsTouch,
              n2 = this.touchEventsDesktop,
              s2 = this.params,
              a2 = t2.$el[0],
              r2 = !(!o.passiveListener || !s2.passiveListeners) && {
                passive: !1,
                capture: !1,
              },
              l2 = !(!o.passiveListener || !s2.passiveListeners) && {
                passive: !0,
                capture: !1,
              };
            o.touch
              ? (a2.addEventListener(i2.start, this.scrollbar.onDragStart, r2),
                a2.addEventListener(i2.move, this.scrollbar.onDragMove, r2),
                a2.addEventListener(i2.end, this.scrollbar.onDragEnd, l2))
              : (a2.addEventListener(n2.start, this.scrollbar.onDragStart, r2),
                e.addEventListener(n2.move, this.scrollbar.onDragMove, r2),
                e.addEventListener(n2.end, this.scrollbar.onDragEnd, l2));
          }
        },
        disableDraggable: function () {
          if (this.params.scrollbar.el) {
            var t2 = this.scrollbar,
              i2 = this.touchEventsTouch,
              n2 = this.touchEventsDesktop,
              s2 = this.params,
              a2 = t2.$el[0],
              r2 = !(!o.passiveListener || !s2.passiveListeners) && {
                passive: !1,
                capture: !1,
              },
              l2 = !(!o.passiveListener || !s2.passiveListeners) && {
                passive: !0,
                capture: !1,
              };
            o.touch
              ? (a2.removeEventListener(
                  i2.start,
                  this.scrollbar.onDragStart,
                  r2
                ),
                a2.removeEventListener(i2.move, this.scrollbar.onDragMove, r2),
                a2.removeEventListener(i2.end, this.scrollbar.onDragEnd, l2))
              : (a2.removeEventListener(
                  n2.start,
                  this.scrollbar.onDragStart,
                  r2
                ),
                e.removeEventListener(n2.move, this.scrollbar.onDragMove, r2),
                e.removeEventListener(n2.end, this.scrollbar.onDragEnd, l2));
          }
        },
        init: function () {
          if (this.params.scrollbar.el) {
            var e2 = this.scrollbar,
              t2 = this.$el,
              i2 = this.params.scrollbar,
              s2 = n(i2.el);
            this.params.uniqueNavElements &&
              typeof i2.el == "string" &&
              s2.length > 1 &&
              t2.find(i2.el).length === 1 &&
              (s2 = t2.find(i2.el));
            var a2 = s2.find("." + this.params.scrollbar.dragClass);
            a2.length === 0 &&
              ((a2 = n(
                '<div class="' + this.params.scrollbar.dragClass + '"></div>'
              )),
              s2.append(a2)),
              r.extend(e2, { $el: s2, el: s2[0], $dragEl: a2, dragEl: a2[0] }),
              i2.draggable && e2.enableDraggable();
          }
        },
        destroy: function () {
          this.scrollbar.disableDraggable();
        },
      },
      ae = {
        setTransform: function (e2, t2) {
          var i2 = this.rtl,
            s2 = n(e2),
            a2 = i2 ? -1 : 1,
            r2 = s2.attr("data-swiper-parallax") || "0",
            o2 = s2.attr("data-swiper-parallax-x"),
            l2 = s2.attr("data-swiper-parallax-y"),
            c2 = s2.attr("data-swiper-parallax-scale"),
            u2 = s2.attr("data-swiper-parallax-opacity");
          if (
            (o2 || l2
              ? ((o2 = o2 || "0"), (l2 = l2 || "0"))
              : this.isHorizontal()
              ? ((o2 = r2), (l2 = "0"))
              : ((l2 = r2), (o2 = "0")),
            (o2 =
              o2.indexOf("%") >= 0
                ? parseInt(o2, 10) * t2 * a2 + "%"
                : o2 * t2 * a2 + "px"),
            (l2 =
              l2.indexOf("%") >= 0
                ? parseInt(l2, 10) * t2 + "%"
                : l2 * t2 + "px"),
            u2 != null)
          ) {
            var d2 = u2 - (u2 - 1) * (1 - Math.abs(t2));
            s2[0].style.opacity = d2;
          }
          if (c2 == null)
            s2.transform("translate3d(" + o2 + ", " + l2 + ", 0px)");
          else {
            var h2 = c2 - (c2 - 1) * (1 - Math.abs(t2));
            s2.transform(
              "translate3d(" + o2 + ", " + l2 + ", 0px) scale(" + h2 + ")"
            );
          }
        },
        setTranslate: function () {
          var e2 = this,
            t2 = e2.$el,
            i2 = e2.slides,
            s2 = e2.progress,
            a2 = e2.snapGrid;
          t2
            .children(
              "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]"
            )
            .each(function (t3, i3) {
              e2.parallax.setTransform(i3, s2);
            }),
            i2.each(function (t3, i3) {
              var r2 = i3.progress;
              e2.params.slidesPerGroup > 1 &&
                e2.params.slidesPerView !== "auto" &&
                (r2 += Math.ceil(t3 / 2) - s2 * (a2.length - 1)),
                (r2 = Math.min(Math.max(r2, -1), 1)),
                n(i3)
                  .find(
                    "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]"
                  )
                  .each(function (t4, i4) {
                    e2.parallax.setTransform(i4, r2);
                  });
            });
        },
        setTransition: function (e2) {
          e2 === void 0 && (e2 = this.params.speed),
            this.$el
              .find(
                "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]"
              )
              .each(function (t2, i2) {
                var s2 = n(i2),
                  a2 =
                    parseInt(s2.attr("data-swiper-parallax-duration"), 10) ||
                    e2;
                e2 === 0 && (a2 = 0), s2.transition(a2);
              });
        },
      },
      re = {
        getDistanceBetweenTouches: function (e2) {
          if (e2.targetTouches.length < 2) return 1;
          var t2 = e2.targetTouches[0].pageX,
            i2 = e2.targetTouches[0].pageY,
            n2 = e2.targetTouches[1].pageX,
            s2 = e2.targetTouches[1].pageY;
          return Math.sqrt(Math.pow(n2 - t2, 2) + Math.pow(s2 - i2, 2));
        },
        onGestureStart: function (e2) {
          var t2 = this.params.zoom,
            i2 = this.zoom,
            s2 = i2.gesture;
          if (
            ((i2.fakeGestureTouched = !1),
            (i2.fakeGestureMoved = !1),
            !o.gestures)
          ) {
            if (
              e2.type !== "touchstart" ||
              (e2.type === "touchstart" && e2.targetTouches.length < 2)
            )
              return;
            (i2.fakeGestureTouched = !0),
              (s2.scaleStart = re.getDistanceBetweenTouches(e2));
          }
          (s2.$slideEl && s2.$slideEl.length) ||
          ((s2.$slideEl = n(e2.target).closest("." + this.params.slideClass)),
          s2.$slideEl.length === 0 &&
            (s2.$slideEl = this.slides.eq(this.activeIndex)),
          (s2.$imageEl = s2.$slideEl.find(
            "img, svg, canvas, picture, .swiper-zoom-target"
          )),
          (s2.$imageWrapEl = s2.$imageEl.parent("." + t2.containerClass)),
          (s2.maxRatio =
            s2.$imageWrapEl.attr("data-swiper-zoom") || t2.maxRatio),
          s2.$imageWrapEl.length !== 0)
            ? (s2.$imageEl && s2.$imageEl.transition(0),
              (this.zoom.isScaling = !0))
            : (s2.$imageEl = void 0);
        },
        onGestureChange: function (e2) {
          var t2 = this.params.zoom,
            i2 = this.zoom,
            n2 = i2.gesture;
          if (!o.gestures) {
            if (
              e2.type !== "touchmove" ||
              (e2.type === "touchmove" && e2.targetTouches.length < 2)
            )
              return;
            (i2.fakeGestureMoved = !0),
              (n2.scaleMove = re.getDistanceBetweenTouches(e2));
          }
          n2.$imageEl &&
            n2.$imageEl.length !== 0 &&
            ((i2.scale = o.gestures
              ? e2.scale * i2.currentScale
              : (n2.scaleMove / n2.scaleStart) * i2.currentScale),
            i2.scale > n2.maxRatio &&
              (i2.scale =
                n2.maxRatio - 1 + Math.pow(i2.scale - n2.maxRatio + 1, 0.5)),
            i2.scale < t2.minRatio &&
              (i2.scale =
                t2.minRatio + 1 - Math.pow(t2.minRatio - i2.scale + 1, 0.5)),
            n2.$imageEl.transform(
              "translate3d(0,0,0) scale(" + i2.scale + ")"
            ));
        },
        onGestureEnd: function (e2) {
          var t2 = this.params.zoom,
            i2 = this.zoom,
            n2 = i2.gesture;
          if (!o.gestures) {
            if (
              !i2.fakeGestureTouched ||
              !i2.fakeGestureMoved ||
              e2.type !== "touchend" ||
              (e2.type === "touchend" &&
                e2.changedTouches.length < 2 &&
                !I.android)
            )
              return;
            (i2.fakeGestureTouched = !1), (i2.fakeGestureMoved = !1);
          }
          n2.$imageEl &&
            n2.$imageEl.length !== 0 &&
            ((i2.scale = Math.max(
              Math.min(i2.scale, n2.maxRatio),
              t2.minRatio
            )),
            n2.$imageEl
              .transition(this.params.speed)
              .transform("translate3d(0,0,0) scale(" + i2.scale + ")"),
            (i2.currentScale = i2.scale),
            (i2.isScaling = !1),
            i2.scale === 1 && (n2.$slideEl = void 0));
        },
        onTouchStart: function (e2) {
          var t2 = this.zoom,
            i2 = t2.gesture,
            n2 = t2.image;
          i2.$imageEl &&
            i2.$imageEl.length !== 0 &&
            (n2.isTouched ||
              (I.android && e2.preventDefault(),
              (n2.isTouched = !0),
              (n2.touchesStart.x =
                e2.type === "touchstart"
                  ? e2.targetTouches[0].pageX
                  : e2.pageX),
              (n2.touchesStart.y =
                e2.type === "touchstart"
                  ? e2.targetTouches[0].pageY
                  : e2.pageY)));
        },
        onTouchMove: function (e2) {
          var t2 = this.zoom,
            i2 = t2.gesture,
            n2 = t2.image,
            s2 = t2.velocity;
          if (
            i2.$imageEl &&
            i2.$imageEl.length !== 0 &&
            ((this.allowClick = !1), n2.isTouched && i2.$slideEl)
          ) {
            n2.isMoved ||
              ((n2.width = i2.$imageEl[0].offsetWidth),
              (n2.height = i2.$imageEl[0].offsetHeight),
              (n2.startX = r.getTranslate(i2.$imageWrapEl[0], "x") || 0),
              (n2.startY = r.getTranslate(i2.$imageWrapEl[0], "y") || 0),
              (i2.slideWidth = i2.$slideEl[0].offsetWidth),
              (i2.slideHeight = i2.$slideEl[0].offsetHeight),
              i2.$imageWrapEl.transition(0),
              this.rtl && ((n2.startX = -n2.startX), (n2.startY = -n2.startY)));
            var a2 = n2.width * t2.scale,
              o2 = n2.height * t2.scale;
            if (!(a2 < i2.slideWidth && o2 < i2.slideHeight)) {
              if (
                ((n2.minX = Math.min(i2.slideWidth / 2 - a2 / 2, 0)),
                (n2.maxX = -n2.minX),
                (n2.minY = Math.min(i2.slideHeight / 2 - o2 / 2, 0)),
                (n2.maxY = -n2.minY),
                (n2.touchesCurrent.x =
                  e2.type === "touchmove"
                    ? e2.targetTouches[0].pageX
                    : e2.pageX),
                (n2.touchesCurrent.y =
                  e2.type === "touchmove"
                    ? e2.targetTouches[0].pageY
                    : e2.pageY),
                !n2.isMoved &&
                  !t2.isScaling &&
                  ((this.isHorizontal() &&
                    ((Math.floor(n2.minX) === Math.floor(n2.startX) &&
                      n2.touchesCurrent.x < n2.touchesStart.x) ||
                      (Math.floor(n2.maxX) === Math.floor(n2.startX) &&
                        n2.touchesCurrent.x > n2.touchesStart.x))) ||
                    (!this.isHorizontal() &&
                      ((Math.floor(n2.minY) === Math.floor(n2.startY) &&
                        n2.touchesCurrent.y < n2.touchesStart.y) ||
                        (Math.floor(n2.maxY) === Math.floor(n2.startY) &&
                          n2.touchesCurrent.y > n2.touchesStart.y)))))
              )
                return void (n2.isTouched = !1);
              e2.preventDefault(),
                e2.stopPropagation(),
                (n2.isMoved = !0),
                (n2.currentX =
                  n2.touchesCurrent.x - n2.touchesStart.x + n2.startX),
                (n2.currentY =
                  n2.touchesCurrent.y - n2.touchesStart.y + n2.startY),
                n2.currentX < n2.minX &&
                  (n2.currentX =
                    n2.minX + 1 - Math.pow(n2.minX - n2.currentX + 1, 0.8)),
                n2.currentX > n2.maxX &&
                  (n2.currentX =
                    n2.maxX - 1 + Math.pow(n2.currentX - n2.maxX + 1, 0.8)),
                n2.currentY < n2.minY &&
                  (n2.currentY =
                    n2.minY + 1 - Math.pow(n2.minY - n2.currentY + 1, 0.8)),
                n2.currentY > n2.maxY &&
                  (n2.currentY =
                    n2.maxY - 1 + Math.pow(n2.currentY - n2.maxY + 1, 0.8)),
                s2.prevPositionX || (s2.prevPositionX = n2.touchesCurrent.x),
                s2.prevPositionY || (s2.prevPositionY = n2.touchesCurrent.y),
                s2.prevTime || (s2.prevTime = Date.now()),
                (s2.x =
                  (n2.touchesCurrent.x - s2.prevPositionX) /
                  (Date.now() - s2.prevTime) /
                  2),
                (s2.y =
                  (n2.touchesCurrent.y - s2.prevPositionY) /
                  (Date.now() - s2.prevTime) /
                  2),
                Math.abs(n2.touchesCurrent.x - s2.prevPositionX) < 2 &&
                  (s2.x = 0),
                Math.abs(n2.touchesCurrent.y - s2.prevPositionY) < 2 &&
                  (s2.y = 0),
                (s2.prevPositionX = n2.touchesCurrent.x),
                (s2.prevPositionY = n2.touchesCurrent.y),
                (s2.prevTime = Date.now()),
                i2.$imageWrapEl.transform(
                  "translate3d(" + n2.currentX + "px, " + n2.currentY + "px,0)"
                );
            }
          }
        },
        onTouchEnd: function () {
          var e2 = this.zoom,
            t2 = e2.gesture,
            i2 = e2.image,
            n2 = e2.velocity;
          if (t2.$imageEl && t2.$imageEl.length !== 0) {
            if (!i2.isTouched || !i2.isMoved)
              return (i2.isTouched = !1), void (i2.isMoved = !1);
            (i2.isTouched = !1), (i2.isMoved = !1);
            var s2 = 300,
              a2 = 300,
              r2 = n2.x * s2,
              o2 = i2.currentX + r2,
              l2 = n2.y * a2,
              c2 = i2.currentY + l2;
            n2.x !== 0 && (s2 = Math.abs((o2 - i2.currentX) / n2.x)),
              n2.y !== 0 && (a2 = Math.abs((c2 - i2.currentY) / n2.y));
            var u2 = Math.max(s2, a2);
            (i2.currentX = o2), (i2.currentY = c2);
            var d2 = i2.width * e2.scale,
              h2 = i2.height * e2.scale;
            (i2.minX = Math.min(t2.slideWidth / 2 - d2 / 2, 0)),
              (i2.maxX = -i2.minX),
              (i2.minY = Math.min(t2.slideHeight / 2 - h2 / 2, 0)),
              (i2.maxY = -i2.minY),
              (i2.currentX = Math.max(Math.min(i2.currentX, i2.maxX), i2.minX)),
              (i2.currentY = Math.max(Math.min(i2.currentY, i2.maxY), i2.minY)),
              t2.$imageWrapEl
                .transition(u2)
                .transform(
                  "translate3d(" + i2.currentX + "px, " + i2.currentY + "px,0)"
                );
          }
        },
        onTransitionEnd: function () {
          var e2 = this.zoom,
            t2 = e2.gesture;
          t2.$slideEl &&
            this.previousIndex !== this.activeIndex &&
            (t2.$imageEl &&
              t2.$imageEl.transform("translate3d(0,0,0) scale(1)"),
            t2.$imageWrapEl && t2.$imageWrapEl.transform("translate3d(0,0,0)"),
            (e2.scale = 1),
            (e2.currentScale = 1),
            (t2.$slideEl = void 0),
            (t2.$imageEl = void 0),
            (t2.$imageWrapEl = void 0));
        },
        toggle: function (e2) {
          var t2 = this.zoom;
          t2.scale && t2.scale !== 1 ? t2.out() : t2.in(e2);
        },
        in: function (e2) {
          var t2,
            i2,
            n2,
            s2,
            a2,
            r2,
            o2,
            l2,
            c2,
            u2,
            d2,
            h2,
            p2,
            f2,
            v2,
            m2,
            g2 = this.zoom,
            y2 = this.params.zoom,
            b2 = g2.gesture,
            w2 = g2.image;
          b2.$slideEl ||
            (this.params.virtual && this.params.virtual.enabled && this.virtual
              ? (b2.$slideEl = this.$wrapperEl.children(
                  "." + this.params.slideActiveClass
                ))
              : (b2.$slideEl = this.slides.eq(this.activeIndex)),
            (b2.$imageEl = b2.$slideEl.find(
              "img, svg, canvas, picture, .swiper-zoom-target"
            )),
            (b2.$imageWrapEl = b2.$imageEl.parent("." + y2.containerClass))),
            b2.$imageEl &&
              b2.$imageEl.length !== 0 &&
              (b2.$slideEl.addClass("" + y2.zoomedSlideClass),
              w2.touchesStart.x === void 0 && e2
                ? ((t2 =
                    e2.type === "touchend"
                      ? e2.changedTouches[0].pageX
                      : e2.pageX),
                  (i2 =
                    e2.type === "touchend"
                      ? e2.changedTouches[0].pageY
                      : e2.pageY))
                : ((t2 = w2.touchesStart.x), (i2 = w2.touchesStart.y)),
              (g2.scale =
                b2.$imageWrapEl.attr("data-swiper-zoom") || y2.maxRatio),
              (g2.currentScale =
                b2.$imageWrapEl.attr("data-swiper-zoom") || y2.maxRatio),
              e2
                ? ((v2 = b2.$slideEl[0].offsetWidth),
                  (m2 = b2.$slideEl[0].offsetHeight),
                  (n2 = b2.$slideEl.offset().left + v2 / 2 - t2),
                  (s2 = b2.$slideEl.offset().top + m2 / 2 - i2),
                  (o2 = b2.$imageEl[0].offsetWidth),
                  (l2 = b2.$imageEl[0].offsetHeight),
                  (c2 = o2 * g2.scale),
                  (u2 = l2 * g2.scale),
                  (p2 = -(d2 = Math.min(v2 / 2 - c2 / 2, 0))),
                  (f2 = -(h2 = Math.min(m2 / 2 - u2 / 2, 0))),
                  (a2 = n2 * g2.scale) < d2 && (a2 = d2),
                  a2 > p2 && (a2 = p2),
                  (r2 = s2 * g2.scale) < h2 && (r2 = h2),
                  r2 > f2 && (r2 = f2))
                : ((a2 = 0), (r2 = 0)),
              b2.$imageWrapEl
                .transition(300)
                .transform("translate3d(" + a2 + "px, " + r2 + "px,0)"),
              b2.$imageEl
                .transition(300)
                .transform("translate3d(0,0,0) scale(" + g2.scale + ")"));
        },
        out: function () {
          var e2 = this.zoom,
            t2 = this.params.zoom,
            i2 = e2.gesture;
          i2.$slideEl ||
            (this.params.virtual && this.params.virtual.enabled && this.virtual
              ? (i2.$slideEl = this.$wrapperEl.children(
                  "." + this.params.slideActiveClass
                ))
              : (i2.$slideEl = this.slides.eq(this.activeIndex)),
            (i2.$imageEl = i2.$slideEl.find(
              "img, svg, canvas, picture, .swiper-zoom-target"
            )),
            (i2.$imageWrapEl = i2.$imageEl.parent("." + t2.containerClass))),
            i2.$imageEl &&
              i2.$imageEl.length !== 0 &&
              ((e2.scale = 1),
              (e2.currentScale = 1),
              i2.$imageWrapEl.transition(300).transform("translate3d(0,0,0)"),
              i2.$imageEl
                .transition(300)
                .transform("translate3d(0,0,0) scale(1)"),
              i2.$slideEl.removeClass("" + t2.zoomedSlideClass),
              (i2.$slideEl = void 0));
        },
        enable: function () {
          var e2 = this.zoom;
          if (!e2.enabled) {
            e2.enabled = !0;
            var t2 = !(
                this.touchEvents.start !== "touchstart" ||
                !o.passiveListener ||
                !this.params.passiveListeners
              ) && { passive: !0, capture: !1 },
              i2 = !o.passiveListener || { passive: !1, capture: !0 },
              n2 = "." + this.params.slideClass;
            o.gestures
              ? (this.$wrapperEl.on("gesturestart", n2, e2.onGestureStart, t2),
                this.$wrapperEl.on("gesturechange", n2, e2.onGestureChange, t2),
                this.$wrapperEl.on("gestureend", n2, e2.onGestureEnd, t2))
              : this.touchEvents.start === "touchstart" &&
                (this.$wrapperEl.on(
                  this.touchEvents.start,
                  n2,
                  e2.onGestureStart,
                  t2
                ),
                this.$wrapperEl.on(
                  this.touchEvents.move,
                  n2,
                  e2.onGestureChange,
                  i2
                ),
                this.$wrapperEl.on(
                  this.touchEvents.end,
                  n2,
                  e2.onGestureEnd,
                  t2
                ),
                this.touchEvents.cancel &&
                  this.$wrapperEl.on(
                    this.touchEvents.cancel,
                    n2,
                    e2.onGestureEnd,
                    t2
                  )),
              this.$wrapperEl.on(
                this.touchEvents.move,
                "." + this.params.zoom.containerClass,
                e2.onTouchMove,
                i2
              );
          }
        },
        disable: function () {
          var e2 = this.zoom;
          if (e2.enabled) {
            this.zoom.enabled = !1;
            var t2 = !(
                this.touchEvents.start !== "touchstart" ||
                !o.passiveListener ||
                !this.params.passiveListeners
              ) && { passive: !0, capture: !1 },
              i2 = !o.passiveListener || { passive: !1, capture: !0 },
              n2 = "." + this.params.slideClass;
            o.gestures
              ? (this.$wrapperEl.off("gesturestart", n2, e2.onGestureStart, t2),
                this.$wrapperEl.off(
                  "gesturechange",
                  n2,
                  e2.onGestureChange,
                  t2
                ),
                this.$wrapperEl.off("gestureend", n2, e2.onGestureEnd, t2))
              : this.touchEvents.start === "touchstart" &&
                (this.$wrapperEl.off(
                  this.touchEvents.start,
                  n2,
                  e2.onGestureStart,
                  t2
                ),
                this.$wrapperEl.off(
                  this.touchEvents.move,
                  n2,
                  e2.onGestureChange,
                  i2
                ),
                this.$wrapperEl.off(
                  this.touchEvents.end,
                  n2,
                  e2.onGestureEnd,
                  t2
                ),
                this.touchEvents.cancel &&
                  this.$wrapperEl.off(
                    this.touchEvents.cancel,
                    n2,
                    e2.onGestureEnd,
                    t2
                  )),
              this.$wrapperEl.off(
                this.touchEvents.move,
                "." + this.params.zoom.containerClass,
                e2.onTouchMove,
                i2
              );
          }
        },
      },
      oe = {
        loadInSlide: function (e2, t2) {
          t2 === void 0 && (t2 = !0);
          var i2 = this,
            s2 = i2.params.lazy;
          if (e2 !== void 0 && i2.slides.length !== 0) {
            var a2 =
                i2.virtual && i2.params.virtual.enabled
                  ? i2.$wrapperEl.children(
                      "." +
                        i2.params.slideClass +
                        '[data-swiper-slide-index="' +
                        e2 +
                        '"]'
                    )
                  : i2.slides.eq(e2),
              r2 = a2.find(
                "." +
                  s2.elementClass +
                  ":not(." +
                  s2.loadedClass +
                  "):not(." +
                  s2.loadingClass +
                  ")"
              );
            !a2.hasClass(s2.elementClass) ||
              a2.hasClass(s2.loadedClass) ||
              a2.hasClass(s2.loadingClass) ||
              (r2 = r2.add(a2[0])),
              r2.length !== 0 &&
                r2.each(function (e3, r3) {
                  var o2 = n(r3);
                  o2.addClass(s2.loadingClass);
                  var l2 = o2.attr("data-background"),
                    c2 = o2.attr("data-src"),
                    u2 = o2.attr("data-srcset"),
                    d2 = o2.attr("data-sizes");
                  i2.loadImage(o2[0], c2 || l2, u2, d2, !1, function () {
                    if (
                      i2 != null &&
                      i2 &&
                      (!i2 || i2.params) &&
                      !i2.destroyed
                    ) {
                      if (
                        (l2
                          ? (o2.css("background-image", 'url("' + l2 + '")'),
                            o2.removeAttr("data-background"))
                          : (u2 &&
                              (o2.attr("srcset", u2),
                              o2.removeAttr("data-srcset")),
                            d2 &&
                              (o2.attr("sizes", d2),
                              o2.removeAttr("data-sizes")),
                            c2 &&
                              (o2.attr("src", c2), o2.removeAttr("data-src"))),
                        o2
                          .addClass(s2.loadedClass)
                          .removeClass(s2.loadingClass),
                        a2.find("." + s2.preloaderClass).remove(),
                        i2.params.loop && t2)
                      ) {
                        var e4 = a2.attr("data-swiper-slide-index");
                        if (a2.hasClass(i2.params.slideDuplicateClass)) {
                          var n2 = i2.$wrapperEl.children(
                            '[data-swiper-slide-index="' +
                              e4 +
                              '"]:not(.' +
                              i2.params.slideDuplicateClass +
                              ")"
                          );
                          i2.lazy.loadInSlide(n2.index(), !1);
                        } else {
                          var r4 = i2.$wrapperEl.children(
                            "." +
                              i2.params.slideDuplicateClass +
                              '[data-swiper-slide-index="' +
                              e4 +
                              '"]'
                          );
                          i2.lazy.loadInSlide(r4.index(), !1);
                        }
                      }
                      i2.emit("lazyImageReady", a2[0], o2[0]),
                        i2.params.autoHeight && i2.updateAutoHeight();
                    }
                  }),
                    i2.emit("lazyImageLoad", a2[0], o2[0]);
                });
          }
        },
        load: function () {
          var e2 = this,
            t2 = e2.$wrapperEl,
            i2 = e2.params,
            s2 = e2.slides,
            a2 = e2.activeIndex,
            r2 = e2.virtual && i2.virtual.enabled,
            o2 = i2.lazy,
            l2 = i2.slidesPerView;
          function c2(e3) {
            if (r2) {
              if (
                t2.children(
                  "." + i2.slideClass + '[data-swiper-slide-index="' + e3 + '"]'
                ).length
              )
                return !0;
            } else if (s2[e3]) return !0;
            return !1;
          }
          function u2(e3) {
            return r2 ? n(e3).attr("data-swiper-slide-index") : n(e3).index();
          }
          if (
            (l2 === "auto" && (l2 = 0),
            e2.lazy.initialImageLoaded || (e2.lazy.initialImageLoaded = !0),
            e2.params.watchSlidesVisibility)
          )
            t2.children("." + i2.slideVisibleClass).each(function (t3, i3) {
              var s3 = r2
                ? n(i3).attr("data-swiper-slide-index")
                : n(i3).index();
              e2.lazy.loadInSlide(s3);
            });
          else if (l2 > 1)
            for (var d2 = a2; d2 < a2 + l2; d2 += 1)
              c2(d2) && e2.lazy.loadInSlide(d2);
          else e2.lazy.loadInSlide(a2);
          if (o2.loadPrevNext)
            if (
              l2 > 1 ||
              (o2.loadPrevNextAmount && o2.loadPrevNextAmount > 1)
            ) {
              for (
                var h2 = o2.loadPrevNextAmount,
                  p2 = l2,
                  f2 = Math.min(a2 + p2 + Math.max(h2, p2), s2.length),
                  v2 = Math.max(a2 - Math.max(p2, h2), 0),
                  m2 = a2 + l2;
                m2 < f2;
                m2 += 1
              )
                c2(m2) && e2.lazy.loadInSlide(m2);
              for (var g2 = v2; g2 < a2; g2 += 1)
                c2(g2) && e2.lazy.loadInSlide(g2);
            } else {
              var y2 = t2.children("." + i2.slideNextClass);
              y2.length > 0 && e2.lazy.loadInSlide(u2(y2));
              var b2 = t2.children("." + i2.slidePrevClass);
              b2.length > 0 && e2.lazy.loadInSlide(u2(b2));
            }
        },
      },
      le = {
        LinearSpline: function (e2, t2) {
          var i2, n2, s2, a2, r2;
          return (
            (this.x = e2),
            (this.y = t2),
            (this.lastIndex = e2.length - 1),
            (this.interpolate = function (e3) {
              return e3
                ? ((r2 = (function (e4, t3) {
                    for (n2 = -1, i2 = e4.length; i2 - n2 > 1; )
                      e4[(s2 = (i2 + n2) >> 1)] <= t3 ? (n2 = s2) : (i2 = s2);
                    return i2;
                  })(this.x, e3)),
                  (a2 = r2 - 1),
                  ((e3 - this.x[a2]) * (this.y[r2] - this.y[a2])) /
                    (this.x[r2] - this.x[a2]) +
                    this.y[a2])
                : 0;
            }),
            this
          );
        },
        getInterpolateFunction: function (e2) {
          this.controller.spline ||
            (this.controller.spline = this.params.loop
              ? new le.LinearSpline(this.slidesGrid, e2.slidesGrid)
              : new le.LinearSpline(this.snapGrid, e2.snapGrid));
        },
        setTranslate: function (e2, t2) {
          var i2,
            n2,
            s2 = this,
            a2 = s2.controller.control;
          function r2(e3) {
            var t3 = s2.rtlTranslate ? -s2.translate : s2.translate;
            s2.params.controller.by === "slide" &&
              (s2.controller.getInterpolateFunction(e3),
              (n2 = -s2.controller.spline.interpolate(-t3))),
              (n2 && s2.params.controller.by !== "container") ||
                ((i2 =
                  (e3.maxTranslate() - e3.minTranslate()) /
                  (s2.maxTranslate() - s2.minTranslate())),
                (n2 = (t3 - s2.minTranslate()) * i2 + e3.minTranslate())),
              s2.params.controller.inverse && (n2 = e3.maxTranslate() - n2),
              e3.updateProgress(n2),
              e3.setTranslate(n2, s2),
              e3.updateActiveIndex(),
              e3.updateSlidesClasses();
          }
          if (Array.isArray(a2))
            for (var o2 = 0; o2 < a2.length; o2 += 1)
              a2[o2] !== t2 && a2[o2] instanceof R && r2(a2[o2]);
          else a2 instanceof R && t2 !== a2 && r2(a2);
        },
        setTransition: function (e2, t2) {
          var i2,
            n2 = this,
            s2 = n2.controller.control;
          function a2(t3) {
            t3.setTransition(e2, n2),
              e2 !== 0 &&
                (t3.transitionStart(),
                t3.params.autoHeight &&
                  r.nextTick(function () {
                    t3.updateAutoHeight();
                  }),
                t3.$wrapperEl.transitionEnd(function () {
                  s2 &&
                    (t3.params.loop &&
                      n2.params.controller.by === "slide" &&
                      t3.loopFix(),
                    t3.transitionEnd());
                }));
          }
          if (Array.isArray(s2))
            for (i2 = 0; i2 < s2.length; i2 += 1)
              s2[i2] !== t2 && s2[i2] instanceof R && a2(s2[i2]);
          else s2 instanceof R && t2 !== s2 && a2(s2);
        },
      },
      ce = {
        makeElFocusable: function (e2) {
          return e2.attr("tabIndex", "0"), e2;
        },
        addElRole: function (e2, t2) {
          return e2.attr("role", t2), e2;
        },
        addElLabel: function (e2, t2) {
          return e2.attr("aria-label", t2), e2;
        },
        disableEl: function (e2) {
          return e2.attr("aria-disabled", !0), e2;
        },
        enableEl: function (e2) {
          return e2.attr("aria-disabled", !1), e2;
        },
        onEnterKey: function (e2) {
          var t2 = this.params.a11y;
          if (e2.keyCode === 13) {
            var i2 = n(e2.target);
            this.navigation &&
              this.navigation.$nextEl &&
              i2.is(this.navigation.$nextEl) &&
              ((this.isEnd && !this.params.loop) || this.slideNext(),
              this.isEnd
                ? this.a11y.notify(t2.lastSlideMessage)
                : this.a11y.notify(t2.nextSlideMessage)),
              this.navigation &&
                this.navigation.$prevEl &&
                i2.is(this.navigation.$prevEl) &&
                ((this.isBeginning && !this.params.loop) || this.slidePrev(),
                this.isBeginning
                  ? this.a11y.notify(t2.firstSlideMessage)
                  : this.a11y.notify(t2.prevSlideMessage)),
              this.pagination &&
                i2.is("." + this.params.pagination.bulletClass) &&
                i2[0].click();
          }
        },
        notify: function (e2) {
          var t2 = this.a11y.liveRegion;
          t2.length !== 0 && (t2.html(""), t2.html(e2));
        },
        updateNavigation: function () {
          if (!this.params.loop && this.navigation) {
            var e2 = this.navigation,
              t2 = e2.$nextEl,
              i2 = e2.$prevEl;
            i2 &&
              i2.length > 0 &&
              (this.isBeginning
                ? this.a11y.disableEl(i2)
                : this.a11y.enableEl(i2)),
              t2 &&
                t2.length > 0 &&
                (this.isEnd ? this.a11y.disableEl(t2) : this.a11y.enableEl(t2));
          }
        },
        updatePagination: function () {
          var e2 = this,
            t2 = e2.params.a11y;
          e2.pagination &&
            e2.params.pagination.clickable &&
            e2.pagination.bullets &&
            e2.pagination.bullets.length &&
            e2.pagination.bullets.each(function (i2, s2) {
              var a2 = n(s2);
              e2.a11y.makeElFocusable(a2),
                e2.a11y.addElRole(a2, "button"),
                e2.a11y.addElLabel(
                  a2,
                  t2.paginationBulletMessage.replace(
                    /\{\{index\}\}/,
                    a2.index() + 1
                  )
                );
            });
        },
        init: function () {
          this.$el.append(this.a11y.liveRegion);
          var e2,
            t2,
            i2 = this.params.a11y;
          this.navigation &&
            this.navigation.$nextEl &&
            (e2 = this.navigation.$nextEl),
            this.navigation &&
              this.navigation.$prevEl &&
              (t2 = this.navigation.$prevEl),
            e2 &&
              (this.a11y.makeElFocusable(e2),
              this.a11y.addElRole(e2, "button"),
              this.a11y.addElLabel(e2, i2.nextSlideMessage),
              e2.on("keydown", this.a11y.onEnterKey)),
            t2 &&
              (this.a11y.makeElFocusable(t2),
              this.a11y.addElRole(t2, "button"),
              this.a11y.addElLabel(t2, i2.prevSlideMessage),
              t2.on("keydown", this.a11y.onEnterKey)),
            this.pagination &&
              this.params.pagination.clickable &&
              this.pagination.bullets &&
              this.pagination.bullets.length &&
              this.pagination.$el.on(
                "keydown",
                "." + this.params.pagination.bulletClass,
                this.a11y.onEnterKey
              );
        },
        destroy: function () {
          var e2, t2;
          this.a11y.liveRegion &&
            this.a11y.liveRegion.length > 0 &&
            this.a11y.liveRegion.remove(),
            this.navigation &&
              this.navigation.$nextEl &&
              (e2 = this.navigation.$nextEl),
            this.navigation &&
              this.navigation.$prevEl &&
              (t2 = this.navigation.$prevEl),
            e2 && e2.off("keydown", this.a11y.onEnterKey),
            t2 && t2.off("keydown", this.a11y.onEnterKey),
            this.pagination &&
              this.params.pagination.clickable &&
              this.pagination.bullets &&
              this.pagination.bullets.length &&
              this.pagination.$el.off(
                "keydown",
                "." + this.params.pagination.bulletClass,
                this.a11y.onEnterKey
              );
        },
      },
      ue = {
        init: function () {
          if (this.params.history) {
            if (!t.history || !t.history.pushState)
              return (
                (this.params.history.enabled = !1),
                void (this.params.hashNavigation.enabled = !0)
              );
            var e2 = this.history;
            (e2.initialized = !0),
              (e2.paths = ue.getPathValues()),
              (e2.paths.key || e2.paths.value) &&
                (e2.scrollToSlide(
                  0,
                  e2.paths.value,
                  this.params.runCallbacksOnInit
                ),
                this.params.history.replaceState ||
                  t.addEventListener(
                    "popstate",
                    this.history.setHistoryPopState
                  ));
          }
        },
        destroy: function () {
          this.params.history.replaceState ||
            t.removeEventListener("popstate", this.history.setHistoryPopState);
        },
        setHistoryPopState: function () {
          (this.history.paths = ue.getPathValues()),
            this.history.scrollToSlide(
              this.params.speed,
              this.history.paths.value,
              !1
            );
        },
        getPathValues: function () {
          var e2 = t.location.pathname
              .slice(1)
              .split("/")
              .filter(function (e3) {
                return e3 !== "";
              }),
            i2 = e2.length;
          return { key: e2[i2 - 2], value: e2[i2 - 1] };
        },
        setHistory: function (e2, i2) {
          if (this.history.initialized && this.params.history.enabled) {
            var n2 = this.slides.eq(i2),
              s2 = ue.slugify(n2.attr("data-history"));
            t.location.pathname.includes(e2) || (s2 = e2 + "/" + s2);
            var a2 = t.history.state;
            (a2 && a2.value === s2) ||
              (this.params.history.replaceState
                ? t.history.replaceState({ value: s2 }, null, s2)
                : t.history.pushState({ value: s2 }, null, s2));
          }
        },
        slugify: function (e2) {
          return e2
            .toString()
            .replace(/\s+/g, "-")
            .replace(/[^\w-]+/g, "")
            .replace(/--+/g, "-")
            .replace(/^-+/, "")
            .replace(/-+$/, "");
        },
        scrollToSlide: function (e2, t2, i2) {
          if (t2)
            for (var n2 = 0, s2 = this.slides.length; n2 < s2; n2 += 1) {
              var a2 = this.slides.eq(n2);
              if (
                ue.slugify(a2.attr("data-history")) === t2 &&
                !a2.hasClass(this.params.slideDuplicateClass)
              ) {
                var r2 = a2.index();
                this.slideTo(r2, e2, i2);
              }
            }
          else this.slideTo(0, e2, i2);
        },
      },
      de = {
        onHashCange: function () {
          var t2 = e.location.hash.replace("#", "");
          if (t2 !== this.slides.eq(this.activeIndex).attr("data-hash")) {
            var i2 = this.$wrapperEl
              .children(
                "." + this.params.slideClass + '[data-hash="' + t2 + '"]'
              )
              .index();
            if (i2 === void 0) return;
            this.slideTo(i2);
          }
        },
        setHash: function () {
          if (
            this.hashNavigation.initialized &&
            this.params.hashNavigation.enabled
          )
            if (
              this.params.hashNavigation.replaceState &&
              t.history &&
              t.history.replaceState
            )
              t.history.replaceState(
                null,
                null,
                "#" + this.slides.eq(this.activeIndex).attr("data-hash") || ""
              );
            else {
              var i2 = this.slides.eq(this.activeIndex),
                n2 = i2.attr("data-hash") || i2.attr("data-history");
              e.location.hash = n2 || "";
            }
        },
        init: function () {
          if (
            !(
              !this.params.hashNavigation.enabled ||
              (this.params.history && this.params.history.enabled)
            )
          ) {
            this.hashNavigation.initialized = !0;
            var i2 = e.location.hash.replace("#", "");
            if (i2)
              for (var s2 = 0, a2 = this.slides.length; s2 < a2; s2 += 1) {
                var r2 = this.slides.eq(s2);
                if (
                  (r2.attr("data-hash") || r2.attr("data-history")) === i2 &&
                  !r2.hasClass(this.params.slideDuplicateClass)
                ) {
                  var o2 = r2.index();
                  this.slideTo(o2, 0, this.params.runCallbacksOnInit, !0);
                }
              }
            this.params.hashNavigation.watchState &&
              n(t).on("hashchange", this.hashNavigation.onHashCange);
          }
        },
        destroy: function () {
          this.params.hashNavigation.watchState &&
            n(t).off("hashchange", this.hashNavigation.onHashCange);
        },
      },
      he = {
        run: function () {
          var e2 = this,
            t2 = e2.slides.eq(e2.activeIndex),
            i2 = e2.params.autoplay.delay;
          t2.attr("data-swiper-autoplay") &&
            (i2 = t2.attr("data-swiper-autoplay") || e2.params.autoplay.delay),
            clearTimeout(e2.autoplay.timeout),
            (e2.autoplay.timeout = r.nextTick(function () {
              e2.params.autoplay.reverseDirection
                ? e2.params.loop
                  ? (e2.loopFix(),
                    e2.slidePrev(e2.params.speed, !0, !0),
                    e2.emit("autoplay"))
                  : e2.isBeginning
                  ? e2.params.autoplay.stopOnLastSlide
                    ? e2.autoplay.stop()
                    : (e2.slideTo(
                        e2.slides.length - 1,
                        e2.params.speed,
                        !0,
                        !0
                      ),
                      e2.emit("autoplay"))
                  : (e2.slidePrev(e2.params.speed, !0, !0), e2.emit("autoplay"))
                : e2.params.loop
                ? (e2.loopFix(),
                  e2.slideNext(e2.params.speed, !0, !0),
                  e2.emit("autoplay"))
                : e2.isEnd
                ? e2.params.autoplay.stopOnLastSlide
                  ? e2.autoplay.stop()
                  : (e2.slideTo(0, e2.params.speed, !0, !0),
                    e2.emit("autoplay"))
                : (e2.slideNext(e2.params.speed, !0, !0), e2.emit("autoplay")),
                e2.params.cssMode && e2.autoplay.running && e2.autoplay.run();
            }, i2));
        },
        start: function () {
          return (
            this.autoplay.timeout === void 0 &&
            !this.autoplay.running &&
            ((this.autoplay.running = !0),
            this.emit("autoplayStart"),
            this.autoplay.run(),
            !0)
          );
        },
        stop: function () {
          return (
            !!this.autoplay.running &&
            this.autoplay.timeout !== void 0 &&
            (this.autoplay.timeout &&
              (clearTimeout(this.autoplay.timeout),
              (this.autoplay.timeout = void 0)),
            (this.autoplay.running = !1),
            this.emit("autoplayStop"),
            !0)
          );
        },
        pause: function (e2) {
          this.autoplay.running &&
            (this.autoplay.paused ||
              (this.autoplay.timeout && clearTimeout(this.autoplay.timeout),
              (this.autoplay.paused = !0),
              e2 !== 0 && this.params.autoplay.waitForTransition
                ? (this.$wrapperEl[0].addEventListener(
                    "transitionend",
                    this.autoplay.onTransitionEnd
                  ),
                  this.$wrapperEl[0].addEventListener(
                    "webkitTransitionEnd",
                    this.autoplay.onTransitionEnd
                  ))
                : ((this.autoplay.paused = !1), this.autoplay.run())));
        },
      },
      pe = {
        setTranslate: function () {
          for (var e2 = this.slides, t2 = 0; t2 < e2.length; t2 += 1) {
            var i2 = this.slides.eq(t2),
              n2 = -i2[0].swiperSlideOffset;
            this.params.virtualTranslate || (n2 -= this.translate);
            var s2 = 0;
            this.isHorizontal() || ((s2 = n2), (n2 = 0));
            var a2 = this.params.fadeEffect.crossFade
              ? Math.max(1 - Math.abs(i2[0].progress), 0)
              : 1 + Math.min(Math.max(i2[0].progress, -1), 0);
            i2.css({ opacity: a2 }).transform(
              "translate3d(" + n2 + "px, " + s2 + "px, 0px)"
            );
          }
        },
        setTransition: function (e2) {
          var t2 = this,
            i2 = t2.slides,
            n2 = t2.$wrapperEl;
          if ((i2.transition(e2), t2.params.virtualTranslate && e2 !== 0)) {
            var s2 = !1;
            i2.transitionEnd(function () {
              if (!s2 && t2 && !t2.destroyed) {
                (s2 = !0), (t2.animating = !1);
                for (
                  var e3 = ["webkitTransitionEnd", "transitionend"], i3 = 0;
                  i3 < e3.length;
                  i3 += 1
                )
                  n2.trigger(e3[i3]);
              }
            });
          }
        },
      },
      fe = {
        setTranslate: function () {
          var e2,
            t2 = this.$el,
            i2 = this.$wrapperEl,
            s2 = this.slides,
            a2 = this.width,
            r2 = this.height,
            o2 = this.rtlTranslate,
            l2 = this.size,
            c2 = this.params.cubeEffect,
            u2 = this.isHorizontal(),
            d2 = this.virtual && this.params.virtual.enabled,
            h2 = 0;
          c2.shadow &&
            (u2
              ? ((e2 = i2.find(".swiper-cube-shadow")).length === 0 &&
                  ((e2 = n('<div class="swiper-cube-shadow"></div>')),
                  i2.append(e2)),
                e2.css({ height: a2 + "px" }))
              : (e2 = t2.find(".swiper-cube-shadow")).length === 0 &&
                ((e2 = n('<div class="swiper-cube-shadow"></div>')),
                t2.append(e2)));
          for (var p2 = 0; p2 < s2.length; p2 += 1) {
            var f2 = s2.eq(p2),
              v2 = p2;
            d2 && (v2 = parseInt(f2.attr("data-swiper-slide-index"), 10));
            var m2 = 90 * v2,
              g2 = Math.floor(m2 / 360);
            o2 && ((m2 = -m2), (g2 = Math.floor(-m2 / 360)));
            var y2 = Math.max(Math.min(f2[0].progress, 1), -1),
              b2 = 0,
              w2 = 0,
              S2 = 0;
            v2 % 4 == 0
              ? ((b2 = 4 * -g2 * l2), (S2 = 0))
              : (v2 - 1) % 4 == 0
              ? ((b2 = 0), (S2 = 4 * -g2 * l2))
              : (v2 - 2) % 4 == 0
              ? ((b2 = l2 + 4 * g2 * l2), (S2 = l2))
              : (v2 - 3) % 4 == 0 && ((b2 = -l2), (S2 = 3 * l2 + 4 * l2 * g2)),
              o2 && (b2 = -b2),
              u2 || ((w2 = b2), (b2 = 0));
            var x2 =
              "rotateX(" +
              (u2 ? 0 : -m2) +
              "deg) rotateY(" +
              (u2 ? m2 : 0) +
              "deg) translate3d(" +
              b2 +
              "px, " +
              w2 +
              "px, " +
              S2 +
              "px)";
            if (
              (y2 <= 1 &&
                y2 > -1 &&
                ((h2 = 90 * v2 + 90 * y2), o2 && (h2 = 90 * -v2 - 90 * y2)),
              f2.transform(x2),
              c2.slideShadows)
            ) {
              var C2 = u2
                  ? f2.find(".swiper-slide-shadow-left")
                  : f2.find(".swiper-slide-shadow-top"),
                k2 = u2
                  ? f2.find(".swiper-slide-shadow-right")
                  : f2.find(".swiper-slide-shadow-bottom");
              C2.length === 0 &&
                ((C2 = n(
                  '<div class="swiper-slide-shadow-' +
                    (u2 ? "left" : "top") +
                    '"></div>'
                )),
                f2.append(C2)),
                k2.length === 0 &&
                  ((k2 = n(
                    '<div class="swiper-slide-shadow-' +
                      (u2 ? "right" : "bottom") +
                      '"></div>'
                  )),
                  f2.append(k2)),
                C2.length && (C2[0].style.opacity = Math.max(-y2, 0)),
                k2.length && (k2[0].style.opacity = Math.max(y2, 0));
            }
          }
          if (
            (i2.css({
              "-webkit-transform-origin": "50% 50% -" + l2 / 2 + "px",
              "-moz-transform-origin": "50% 50% -" + l2 / 2 + "px",
              "-ms-transform-origin": "50% 50% -" + l2 / 2 + "px",
              "transform-origin": "50% 50% -" + l2 / 2 + "px",
            }),
            c2.shadow)
          )
            if (u2)
              e2.transform(
                "translate3d(0px, " +
                  (a2 / 2 + c2.shadowOffset) +
                  "px, " +
                  -a2 / 2 +
                  "px) rotateX(90deg) rotateZ(0deg) scale(" +
                  c2.shadowScale +
                  ")"
              );
            else {
              var E2 = Math.abs(h2) - 90 * Math.floor(Math.abs(h2) / 90),
                T2 =
                  1.5 -
                  (Math.sin((2 * E2 * Math.PI) / 360) / 2 +
                    Math.cos((2 * E2 * Math.PI) / 360) / 2),
                _2 = c2.shadowScale,
                M2 = c2.shadowScale / T2,
                L2 = c2.shadowOffset;
              e2.transform(
                "scale3d(" +
                  _2 +
                  ", 1, " +
                  M2 +
                  ") translate3d(0px, " +
                  (r2 / 2 + L2) +
                  "px, " +
                  -r2 / 2 / M2 +
                  "px) rotateX(-90deg)"
              );
            }
          var P2 = G.isSafari || G.isUiWebView ? -l2 / 2 : 0;
          i2.transform(
            "translate3d(0px,0," +
              P2 +
              "px) rotateX(" +
              (this.isHorizontal() ? 0 : h2) +
              "deg) rotateY(" +
              (this.isHorizontal() ? -h2 : 0) +
              "deg)"
          );
        },
        setTransition: function (e2) {
          var t2 = this.$el;
          this.slides
            .transition(e2)
            .find(
              ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
            )
            .transition(e2),
            this.params.cubeEffect.shadow &&
              !this.isHorizontal() &&
              t2.find(".swiper-cube-shadow").transition(e2);
        },
      },
      ve = {
        setTranslate: function () {
          for (
            var e2 = this.slides, t2 = this.rtlTranslate, i2 = 0;
            i2 < e2.length;
            i2 += 1
          ) {
            var s2 = e2.eq(i2),
              a2 = s2[0].progress;
            this.params.flipEffect.limitRotation &&
              (a2 = Math.max(Math.min(s2[0].progress, 1), -1));
            var r2 = -180 * a2,
              o2 = 0,
              l2 = -s2[0].swiperSlideOffset,
              c2 = 0;
            if (
              (this.isHorizontal()
                ? t2 && (r2 = -r2)
                : ((c2 = l2), (l2 = 0), (o2 = -r2), (r2 = 0)),
              (s2[0].style.zIndex = -Math.abs(Math.round(a2)) + e2.length),
              this.params.flipEffect.slideShadows)
            ) {
              var u2 = this.isHorizontal()
                  ? s2.find(".swiper-slide-shadow-left")
                  : s2.find(".swiper-slide-shadow-top"),
                d2 = this.isHorizontal()
                  ? s2.find(".swiper-slide-shadow-right")
                  : s2.find(".swiper-slide-shadow-bottom");
              u2.length === 0 &&
                ((u2 = n(
                  '<div class="swiper-slide-shadow-' +
                    (this.isHorizontal() ? "left" : "top") +
                    '"></div>'
                )),
                s2.append(u2)),
                d2.length === 0 &&
                  ((d2 = n(
                    '<div class="swiper-slide-shadow-' +
                      (this.isHorizontal() ? "right" : "bottom") +
                      '"></div>'
                  )),
                  s2.append(d2)),
                u2.length && (u2[0].style.opacity = Math.max(-a2, 0)),
                d2.length && (d2[0].style.opacity = Math.max(a2, 0));
            }
            s2.transform(
              "translate3d(" +
                l2 +
                "px, " +
                c2 +
                "px, 0px) rotateX(" +
                o2 +
                "deg) rotateY(" +
                r2 +
                "deg)"
            );
          }
        },
        setTransition: function (e2) {
          var t2 = this,
            i2 = t2.slides,
            n2 = t2.activeIndex,
            s2 = t2.$wrapperEl;
          if (
            (i2
              .transition(e2)
              .find(
                ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
              )
              .transition(e2),
            t2.params.virtualTranslate && e2 !== 0)
          ) {
            var a2 = !1;
            i2.eq(n2).transitionEnd(function () {
              if (!a2 && t2 && !t2.destroyed) {
                (a2 = !0), (t2.animating = !1);
                for (
                  var e3 = ["webkitTransitionEnd", "transitionend"], i3 = 0;
                  i3 < e3.length;
                  i3 += 1
                )
                  s2.trigger(e3[i3]);
              }
            });
          }
        },
      },
      me = {
        setTranslate: function () {
          for (
            var e2 = this.width,
              t2 = this.height,
              i2 = this.slides,
              s2 = this.$wrapperEl,
              a2 = this.slidesSizesGrid,
              r2 = this.params.coverflowEffect,
              l2 = this.isHorizontal(),
              c2 = this.translate,
              u2 = l2 ? e2 / 2 - c2 : t2 / 2 - c2,
              d2 = l2 ? r2.rotate : -r2.rotate,
              h2 = r2.depth,
              p2 = 0,
              f2 = i2.length;
            p2 < f2;
            p2 += 1
          ) {
            var v2 = i2.eq(p2),
              m2 = a2[p2],
              g2 = ((u2 - v2[0].swiperSlideOffset - m2 / 2) / m2) * r2.modifier,
              y2 = l2 ? d2 * g2 : 0,
              b2 = l2 ? 0 : d2 * g2,
              w2 = -h2 * Math.abs(g2),
              S2 = r2.stretch;
            typeof S2 == "string" &&
              S2.indexOf("%") !== -1 &&
              (S2 = (parseFloat(r2.stretch) / 100) * m2);
            var x2 = l2 ? 0 : S2 * g2,
              C2 = l2 ? S2 * g2 : 0;
            Math.abs(C2) < 0.001 && (C2 = 0),
              Math.abs(x2) < 0.001 && (x2 = 0),
              Math.abs(w2) < 0.001 && (w2 = 0),
              Math.abs(y2) < 0.001 && (y2 = 0),
              Math.abs(b2) < 0.001 && (b2 = 0);
            var k2 =
              "translate3d(" +
              C2 +
              "px," +
              x2 +
              "px," +
              w2 +
              "px)  rotateX(" +
              b2 +
              "deg) rotateY(" +
              y2 +
              "deg)";
            if (
              (v2.transform(k2),
              (v2[0].style.zIndex = 1 - Math.abs(Math.round(g2))),
              r2.slideShadows)
            ) {
              var E2 = l2
                  ? v2.find(".swiper-slide-shadow-left")
                  : v2.find(".swiper-slide-shadow-top"),
                T2 = l2
                  ? v2.find(".swiper-slide-shadow-right")
                  : v2.find(".swiper-slide-shadow-bottom");
              E2.length === 0 &&
                ((E2 = n(
                  '<div class="swiper-slide-shadow-' +
                    (l2 ? "left" : "top") +
                    '"></div>'
                )),
                v2.append(E2)),
                T2.length === 0 &&
                  ((T2 = n(
                    '<div class="swiper-slide-shadow-' +
                      (l2 ? "right" : "bottom") +
                      '"></div>'
                  )),
                  v2.append(T2)),
                E2.length && (E2[0].style.opacity = g2 > 0 ? g2 : 0),
                T2.length && (T2[0].style.opacity = -g2 > 0 ? -g2 : 0);
            }
          }
          (o.pointerEvents || o.prefixedPointerEvents) &&
            (s2[0].style.perspectiveOrigin = u2 + "px 50%");
        },
        setTransition: function (e2) {
          this.slides
            .transition(e2)
            .find(
              ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
            )
            .transition(e2);
        },
      },
      ge = {
        init: function () {
          var e2 = this.params.thumbs,
            t2 = this.constructor;
          e2.swiper instanceof t2
            ? ((this.thumbs.swiper = e2.swiper),
              r.extend(this.thumbs.swiper.originalParams, {
                watchSlidesProgress: !0,
                slideToClickedSlide: !1,
              }),
              r.extend(this.thumbs.swiper.params, {
                watchSlidesProgress: !0,
                slideToClickedSlide: !1,
              }))
            : r.isObject(e2.swiper) &&
              ((this.thumbs.swiper = new t2(
                r.extend({}, e2.swiper, {
                  watchSlidesVisibility: !0,
                  watchSlidesProgress: !0,
                  slideToClickedSlide: !1,
                })
              )),
              (this.thumbs.swiperCreated = !0)),
            this.thumbs.swiper.$el.addClass(
              this.params.thumbs.thumbsContainerClass
            ),
            this.thumbs.swiper.on("tap", this.thumbs.onThumbClick);
        },
        onThumbClick: function () {
          var e2 = this.thumbs.swiper;
          if (e2) {
            var t2 = e2.clickedIndex,
              i2 = e2.clickedSlide;
            if (
              !(
                (i2 &&
                  n(i2).hasClass(this.params.thumbs.slideThumbActiveClass)) ||
                t2 == null
              )
            ) {
              var s2;
              if (
                ((s2 = e2.params.loop
                  ? parseInt(
                      n(e2.clickedSlide).attr("data-swiper-slide-index"),
                      10
                    )
                  : t2),
                this.params.loop)
              ) {
                var a2 = this.activeIndex;
                this.slides.eq(a2).hasClass(this.params.slideDuplicateClass) &&
                  (this.loopFix(),
                  (this._clientLeft = this.$wrapperEl[0].clientLeft),
                  (a2 = this.activeIndex));
                var r2 = this.slides
                    .eq(a2)
                    .prevAll('[data-swiper-slide-index="' + s2 + '"]')
                    .eq(0)
                    .index(),
                  o2 = this.slides
                    .eq(a2)
                    .nextAll('[data-swiper-slide-index="' + s2 + '"]')
                    .eq(0)
                    .index();
                s2 =
                  r2 === void 0
                    ? o2
                    : o2 === void 0
                    ? r2
                    : o2 - a2 < a2 - r2
                    ? o2
                    : r2;
              }
              this.slideTo(s2);
            }
          }
        },
        update: function (e2) {
          var t2 = this.thumbs.swiper;
          if (t2) {
            var i2 =
                t2.params.slidesPerView === "auto"
                  ? t2.slidesPerViewDynamic()
                  : t2.params.slidesPerView,
              n2 = this.params.thumbs.autoScrollOffset,
              s2 = n2 && !t2.params.loop;
            if (this.realIndex !== t2.realIndex || s2) {
              var a2,
                r2,
                o2 = t2.activeIndex;
              if (t2.params.loop) {
                t2.slides.eq(o2).hasClass(t2.params.slideDuplicateClass) &&
                  (t2.loopFix(),
                  (t2._clientLeft = t2.$wrapperEl[0].clientLeft),
                  (o2 = t2.activeIndex));
                var l2 = t2.slides
                    .eq(o2)
                    .prevAll(
                      '[data-swiper-slide-index="' + this.realIndex + '"]'
                    )
                    .eq(0)
                    .index(),
                  c2 = t2.slides
                    .eq(o2)
                    .nextAll(
                      '[data-swiper-slide-index="' + this.realIndex + '"]'
                    )
                    .eq(0)
                    .index();
                (a2 =
                  l2 === void 0
                    ? c2
                    : c2 === void 0
                    ? l2
                    : c2 - o2 == o2 - l2
                    ? o2
                    : c2 - o2 < o2 - l2
                    ? c2
                    : l2),
                  (r2 =
                    this.activeIndex > this.previousIndex ? "next" : "prev");
              } else
                r2 =
                  (a2 = this.realIndex) > this.previousIndex ? "next" : "prev";
              s2 && (a2 += r2 === "next" ? n2 : -1 * n2),
                t2.visibleSlidesIndexes &&
                  t2.visibleSlidesIndexes.indexOf(a2) < 0 &&
                  (t2.params.centeredSlides
                    ? (a2 =
                        a2 > o2
                          ? a2 - Math.floor(i2 / 2) + 1
                          : a2 + Math.floor(i2 / 2) - 1)
                    : a2 > o2 && (a2 = a2 - i2 + 1),
                  t2.slideTo(a2, e2 ? 0 : void 0));
            }
            var u2 = 1,
              d2 = this.params.thumbs.slideThumbActiveClass;
            if (
              (this.params.slidesPerView > 1 &&
                !this.params.centeredSlides &&
                (u2 = this.params.slidesPerView),
              this.params.thumbs.multipleActiveThumbs || (u2 = 1),
              (u2 = Math.floor(u2)),
              t2.slides.removeClass(d2),
              t2.params.loop ||
                (t2.params.virtual && t2.params.virtual.enabled))
            )
              for (var h2 = 0; h2 < u2; h2 += 1)
                t2.$wrapperEl
                  .children(
                    '[data-swiper-slide-index="' + (this.realIndex + h2) + '"]'
                  )
                  .addClass(d2);
            else
              for (var p2 = 0; p2 < u2; p2 += 1)
                t2.slides.eq(this.realIndex + p2).addClass(d2);
          }
        },
      },
      ye = [
        j,
        X,
        W,
        Y,
        K,
        Z,
        ee,
        {
          name: "mousewheel",
          params: {
            mousewheel: {
              enabled: !1,
              releaseOnEdges: !1,
              invert: !1,
              forceToAxis: !1,
              sensitivity: 1,
              eventsTarged: "container",
            },
          },
          create: function () {
            r.extend(this, {
              mousewheel: {
                enabled: !1,
                enable: te.enable.bind(this),
                disable: te.disable.bind(this),
                handle: te.handle.bind(this),
                handleMouseEnter: te.handleMouseEnter.bind(this),
                handleMouseLeave: te.handleMouseLeave.bind(this),
                animateSlider: te.animateSlider.bind(this),
                releaseScroll: te.releaseScroll.bind(this),
                lastScrollTime: r.now(),
                lastEventBeforeSnap: void 0,
                recentWheelEvents: [],
              },
            });
          },
          on: {
            init: function () {
              !this.params.mousewheel.enabled &&
                this.params.cssMode &&
                this.mousewheel.disable(),
                this.params.mousewheel.enabled && this.mousewheel.enable();
            },
            destroy: function () {
              this.params.cssMode && this.mousewheel.enable(),
                this.mousewheel.enabled && this.mousewheel.disable();
            },
          },
        },
        {
          name: "navigation",
          params: {
            navigation: {
              nextEl: null,
              prevEl: null,
              hideOnClick: !1,
              disabledClass: "swiper-button-disabled",
              hiddenClass: "swiper-button-hidden",
              lockClass: "swiper-button-lock",
            },
          },
          create: function () {
            r.extend(this, {
              navigation: {
                init: ie.init.bind(this),
                update: ie.update.bind(this),
                destroy: ie.destroy.bind(this),
                onNextClick: ie.onNextClick.bind(this),
                onPrevClick: ie.onPrevClick.bind(this),
              },
            });
          },
          on: {
            init: function () {
              this.navigation.init(), this.navigation.update();
            },
            toEdge: function () {
              this.navigation.update();
            },
            fromEdge: function () {
              this.navigation.update();
            },
            destroy: function () {
              this.navigation.destroy();
            },
            click: function (e2) {
              var t2,
                i2 = this.navigation,
                s2 = i2.$nextEl,
                a2 = i2.$prevEl;
              !this.params.navigation.hideOnClick ||
                n(e2.target).is(a2) ||
                n(e2.target).is(s2) ||
                (s2
                  ? (t2 = s2.hasClass(this.params.navigation.hiddenClass))
                  : a2 &&
                    (t2 = a2.hasClass(this.params.navigation.hiddenClass)),
                t2 === !0
                  ? this.emit("navigationShow", this)
                  : this.emit("navigationHide", this),
                s2 && s2.toggleClass(this.params.navigation.hiddenClass),
                a2 && a2.toggleClass(this.params.navigation.hiddenClass));
            },
          },
        },
        {
          name: "pagination",
          params: {
            pagination: {
              el: null,
              bulletElement: "span",
              clickable: !1,
              hideOnClick: !1,
              renderBullet: null,
              renderProgressbar: null,
              renderFraction: null,
              renderCustom: null,
              progressbarOpposite: !1,
              type: "bullets",
              dynamicBullets: !1,
              dynamicMainBullets: 1,
              formatFractionCurrent: function (e2) {
                return e2;
              },
              formatFractionTotal: function (e2) {
                return e2;
              },
              bulletClass: "swiper-pagination-bullet",
              bulletActiveClass: "swiper-pagination-bullet-active",
              modifierClass: "swiper-pagination-",
              currentClass: "swiper-pagination-current",
              totalClass: "swiper-pagination-total",
              hiddenClass: "swiper-pagination-hidden",
              progressbarFillClass: "swiper-pagination-progressbar-fill",
              progressbarOppositeClass:
                "swiper-pagination-progressbar-opposite",
              clickableClass: "swiper-pagination-clickable",
              lockClass: "swiper-pagination-lock",
            },
          },
          create: function () {
            r.extend(this, {
              pagination: {
                init: ne.init.bind(this),
                render: ne.render.bind(this),
                update: ne.update.bind(this),
                destroy: ne.destroy.bind(this),
                dynamicBulletIndex: 0,
              },
            });
          },
          on: {
            init: function () {
              this.pagination.init(),
                this.pagination.render(),
                this.pagination.update();
            },
            activeIndexChange: function () {
              (this.params.loop || this.snapIndex === void 0) &&
                this.pagination.update();
            },
            snapIndexChange: function () {
              this.params.loop || this.pagination.update();
            },
            slidesLengthChange: function () {
              this.params.loop &&
                (this.pagination.render(), this.pagination.update());
            },
            snapGridLengthChange: function () {
              this.params.loop ||
                (this.pagination.render(), this.pagination.update());
            },
            destroy: function () {
              this.pagination.destroy();
            },
            click: function (e2) {
              this.params.pagination.el &&
                this.params.pagination.hideOnClick &&
                this.pagination.$el.length > 0 &&
                !n(e2.target).hasClass(this.params.pagination.bulletClass) &&
                (this.pagination.$el.hasClass(
                  this.params.pagination.hiddenClass
                ) === !0
                  ? this.emit("paginationShow", this)
                  : this.emit("paginationHide", this),
                this.pagination.$el.toggleClass(
                  this.params.pagination.hiddenClass
                ));
            },
          },
        },
        {
          name: "scrollbar",
          params: {
            scrollbar: {
              el: null,
              dragSize: "auto",
              hide: !1,
              draggable: !1,
              snapOnRelease: !0,
              lockClass: "swiper-scrollbar-lock",
              dragClass: "swiper-scrollbar-drag",
            },
          },
          create: function () {
            r.extend(this, {
              scrollbar: {
                init: se.init.bind(this),
                destroy: se.destroy.bind(this),
                updateSize: se.updateSize.bind(this),
                setTranslate: se.setTranslate.bind(this),
                setTransition: se.setTransition.bind(this),
                enableDraggable: se.enableDraggable.bind(this),
                disableDraggable: se.disableDraggable.bind(this),
                setDragPosition: se.setDragPosition.bind(this),
                getPointerPosition: se.getPointerPosition.bind(this),
                onDragStart: se.onDragStart.bind(this),
                onDragMove: se.onDragMove.bind(this),
                onDragEnd: se.onDragEnd.bind(this),
                isTouched: !1,
                timeout: null,
                dragTimeout: null,
              },
            });
          },
          on: {
            init: function () {
              this.scrollbar.init(),
                this.scrollbar.updateSize(),
                this.scrollbar.setTranslate();
            },
            update: function () {
              this.scrollbar.updateSize();
            },
            resize: function () {
              this.scrollbar.updateSize();
            },
            observerUpdate: function () {
              this.scrollbar.updateSize();
            },
            setTranslate: function () {
              this.scrollbar.setTranslate();
            },
            setTransition: function (e2) {
              this.scrollbar.setTransition(e2);
            },
            destroy: function () {
              this.scrollbar.destroy();
            },
          },
        },
        {
          name: "parallax",
          params: { parallax: { enabled: !1 } },
          create: function () {
            r.extend(this, {
              parallax: {
                setTransform: ae.setTransform.bind(this),
                setTranslate: ae.setTranslate.bind(this),
                setTransition: ae.setTransition.bind(this),
              },
            });
          },
          on: {
            beforeInit: function () {
              this.params.parallax.enabled &&
                ((this.params.watchSlidesProgress = !0),
                (this.originalParams.watchSlidesProgress = !0));
            },
            init: function () {
              this.params.parallax.enabled && this.parallax.setTranslate();
            },
            setTranslate: function () {
              this.params.parallax.enabled && this.parallax.setTranslate();
            },
            setTransition: function (e2) {
              this.params.parallax.enabled && this.parallax.setTransition(e2);
            },
          },
        },
        {
          name: "zoom",
          params: {
            zoom: {
              enabled: !1,
              maxRatio: 3,
              minRatio: 1,
              toggle: !0,
              containerClass: "swiper-zoom-container",
              zoomedSlideClass: "swiper-slide-zoomed",
            },
          },
          create: function () {
            var e2 = this,
              t2 = {
                enabled: !1,
                scale: 1,
                currentScale: 1,
                isScaling: !1,
                gesture: {
                  $slideEl: void 0,
                  slideWidth: void 0,
                  slideHeight: void 0,
                  $imageEl: void 0,
                  $imageWrapEl: void 0,
                  maxRatio: 3,
                },
                image: {
                  isTouched: void 0,
                  isMoved: void 0,
                  currentX: void 0,
                  currentY: void 0,
                  minX: void 0,
                  minY: void 0,
                  maxX: void 0,
                  maxY: void 0,
                  width: void 0,
                  height: void 0,
                  startX: void 0,
                  startY: void 0,
                  touchesStart: {},
                  touchesCurrent: {},
                },
                velocity: {
                  x: void 0,
                  y: void 0,
                  prevPositionX: void 0,
                  prevPositionY: void 0,
                  prevTime: void 0,
                },
              };
            "onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out"
              .split(" ")
              .forEach(function (i3) {
                t2[i3] = re[i3].bind(e2);
              }),
              r.extend(e2, { zoom: t2 });
            var i2 = 1;
            Object.defineProperty(e2.zoom, "scale", {
              get: function () {
                return i2;
              },
              set: function (t3) {
                if (i2 !== t3) {
                  var n2 = e2.zoom.gesture.$imageEl
                      ? e2.zoom.gesture.$imageEl[0]
                      : void 0,
                    s2 = e2.zoom.gesture.$slideEl
                      ? e2.zoom.gesture.$slideEl[0]
                      : void 0;
                  e2.emit("zoomChange", t3, n2, s2);
                }
                i2 = t3;
              },
            });
          },
          on: {
            init: function () {
              this.params.zoom.enabled && this.zoom.enable();
            },
            destroy: function () {
              this.zoom.disable();
            },
            touchStart: function (e2) {
              this.zoom.enabled && this.zoom.onTouchStart(e2);
            },
            touchEnd: function (e2) {
              this.zoom.enabled && this.zoom.onTouchEnd(e2);
            },
            doubleTap: function (e2) {
              this.params.zoom.enabled &&
                this.zoom.enabled &&
                this.params.zoom.toggle &&
                this.zoom.toggle(e2);
            },
            transitionEnd: function () {
              this.zoom.enabled &&
                this.params.zoom.enabled &&
                this.zoom.onTransitionEnd();
            },
            slideChange: function () {
              this.zoom.enabled &&
                this.params.zoom.enabled &&
                this.params.cssMode &&
                this.zoom.onTransitionEnd();
            },
          },
        },
        {
          name: "lazy",
          params: {
            lazy: {
              enabled: !1,
              loadPrevNext: !1,
              loadPrevNextAmount: 1,
              loadOnTransitionStart: !1,
              elementClass: "swiper-lazy",
              loadingClass: "swiper-lazy-loading",
              loadedClass: "swiper-lazy-loaded",
              preloaderClass: "swiper-lazy-preloader",
            },
          },
          create: function () {
            r.extend(this, {
              lazy: {
                initialImageLoaded: !1,
                load: oe.load.bind(this),
                loadInSlide: oe.loadInSlide.bind(this),
              },
            });
          },
          on: {
            beforeInit: function () {
              this.params.lazy.enabled &&
                this.params.preloadImages &&
                (this.params.preloadImages = !1);
            },
            init: function () {
              this.params.lazy.enabled &&
                !this.params.loop &&
                this.params.initialSlide === 0 &&
                this.lazy.load();
            },
            scroll: function () {
              this.params.freeMode &&
                !this.params.freeModeSticky &&
                this.lazy.load();
            },
            resize: function () {
              this.params.lazy.enabled && this.lazy.load();
            },
            scrollbarDragMove: function () {
              this.params.lazy.enabled && this.lazy.load();
            },
            transitionStart: function () {
              this.params.lazy.enabled &&
                (this.params.lazy.loadOnTransitionStart ||
                  (!this.params.lazy.loadOnTransitionStart &&
                    !this.lazy.initialImageLoaded)) &&
                this.lazy.load();
            },
            transitionEnd: function () {
              this.params.lazy.enabled &&
                !this.params.lazy.loadOnTransitionStart &&
                this.lazy.load();
            },
            slideChange: function () {
              this.params.lazy.enabled &&
                this.params.cssMode &&
                this.lazy.load();
            },
          },
        },
        {
          name: "controller",
          params: { controller: { control: void 0, inverse: !1, by: "slide" } },
          create: function () {
            r.extend(this, {
              controller: {
                control: this.params.controller.control,
                getInterpolateFunction: le.getInterpolateFunction.bind(this),
                setTranslate: le.setTranslate.bind(this),
                setTransition: le.setTransition.bind(this),
              },
            });
          },
          on: {
            update: function () {
              this.controller.control &&
                this.controller.spline &&
                ((this.controller.spline = void 0),
                delete this.controller.spline);
            },
            resize: function () {
              this.controller.control &&
                this.controller.spline &&
                ((this.controller.spline = void 0),
                delete this.controller.spline);
            },
            observerUpdate: function () {
              this.controller.control &&
                this.controller.spline &&
                ((this.controller.spline = void 0),
                delete this.controller.spline);
            },
            setTranslate: function (e2, t2) {
              this.controller.control && this.controller.setTranslate(e2, t2);
            },
            setTransition: function (e2, t2) {
              this.controller.control && this.controller.setTransition(e2, t2);
            },
          },
        },
        {
          name: "a11y",
          params: {
            a11y: {
              enabled: !0,
              notificationClass: "swiper-notification",
              prevSlideMessage: "Previous slide",
              nextSlideMessage: "Next slide",
              firstSlideMessage: "This is the first slide",
              lastSlideMessage: "This is the last slide",
              paginationBulletMessage: "Go to slide {{index}}",
            },
          },
          create: function () {
            var e2 = this;
            r.extend(e2, {
              a11y: {
                liveRegion: n(
                  '<span class="' +
                    e2.params.a11y.notificationClass +
                    '" aria-live="assertive" aria-atomic="true"></span>'
                ),
              },
            }),
              Object.keys(ce).forEach(function (t2) {
                e2.a11y[t2] = ce[t2].bind(e2);
              });
          },
          on: {
            init: function () {
              this.params.a11y.enabled &&
                (this.a11y.init(), this.a11y.updateNavigation());
            },
            toEdge: function () {
              this.params.a11y.enabled && this.a11y.updateNavigation();
            },
            fromEdge: function () {
              this.params.a11y.enabled && this.a11y.updateNavigation();
            },
            paginationUpdate: function () {
              this.params.a11y.enabled && this.a11y.updatePagination();
            },
            destroy: function () {
              this.params.a11y.enabled && this.a11y.destroy();
            },
          },
        },
        {
          name: "history",
          params: { history: { enabled: !1, replaceState: !1, key: "slides" } },
          create: function () {
            r.extend(this, {
              history: {
                init: ue.init.bind(this),
                setHistory: ue.setHistory.bind(this),
                setHistoryPopState: ue.setHistoryPopState.bind(this),
                scrollToSlide: ue.scrollToSlide.bind(this),
                destroy: ue.destroy.bind(this),
              },
            });
          },
          on: {
            init: function () {
              this.params.history.enabled && this.history.init();
            },
            destroy: function () {
              this.params.history.enabled && this.history.destroy();
            },
            transitionEnd: function () {
              this.history.initialized &&
                this.history.setHistory(
                  this.params.history.key,
                  this.activeIndex
                );
            },
            slideChange: function () {
              this.history.initialized &&
                this.params.cssMode &&
                this.history.setHistory(
                  this.params.history.key,
                  this.activeIndex
                );
            },
          },
        },
        {
          name: "hash-navigation",
          params: {
            hashNavigation: { enabled: !1, replaceState: !1, watchState: !1 },
          },
          create: function () {
            r.extend(this, {
              hashNavigation: {
                initialized: !1,
                init: de.init.bind(this),
                destroy: de.destroy.bind(this),
                setHash: de.setHash.bind(this),
                onHashCange: de.onHashCange.bind(this),
              },
            });
          },
          on: {
            init: function () {
              this.params.hashNavigation.enabled && this.hashNavigation.init();
            },
            destroy: function () {
              this.params.hashNavigation.enabled &&
                this.hashNavigation.destroy();
            },
            transitionEnd: function () {
              this.hashNavigation.initialized && this.hashNavigation.setHash();
            },
            slideChange: function () {
              this.hashNavigation.initialized &&
                this.params.cssMode &&
                this.hashNavigation.setHash();
            },
          },
        },
        {
          name: "autoplay",
          params: {
            autoplay: {
              enabled: !1,
              delay: 3e3,
              waitForTransition: !0,
              disableOnInteraction: !0,
              stopOnLastSlide: !1,
              reverseDirection: !1,
            },
          },
          create: function () {
            var e2 = this;
            r.extend(e2, {
              autoplay: {
                running: !1,
                paused: !1,
                run: he.run.bind(e2),
                start: he.start.bind(e2),
                stop: he.stop.bind(e2),
                pause: he.pause.bind(e2),
                onVisibilityChange: function () {
                  document.visibilityState === "hidden" &&
                    e2.autoplay.running &&
                    e2.autoplay.pause(),
                    document.visibilityState === "visible" &&
                      e2.autoplay.paused &&
                      (e2.autoplay.run(), (e2.autoplay.paused = !1));
                },
                onTransitionEnd: function (t2) {
                  e2 &&
                    !e2.destroyed &&
                    e2.$wrapperEl &&
                    t2.target === this &&
                    (e2.$wrapperEl[0].removeEventListener(
                      "transitionend",
                      e2.autoplay.onTransitionEnd
                    ),
                    e2.$wrapperEl[0].removeEventListener(
                      "webkitTransitionEnd",
                      e2.autoplay.onTransitionEnd
                    ),
                    (e2.autoplay.paused = !1),
                    e2.autoplay.running
                      ? e2.autoplay.run()
                      : e2.autoplay.stop());
                },
              },
            });
          },
          on: {
            init: function () {
              this.params.autoplay.enabled &&
                (this.autoplay.start(),
                document.addEventListener(
                  "visibilitychange",
                  this.autoplay.onVisibilityChange
                ));
            },
            beforeTransitionStart: function (e2, t2) {
              this.autoplay.running &&
                (t2 || !this.params.autoplay.disableOnInteraction
                  ? this.autoplay.pause(e2)
                  : this.autoplay.stop());
            },
            sliderFirstMove: function () {
              this.autoplay.running &&
                (this.params.autoplay.disableOnInteraction
                  ? this.autoplay.stop()
                  : this.autoplay.pause());
            },
            touchEnd: function () {
              this.params.cssMode &&
                this.autoplay.paused &&
                !this.params.autoplay.disableOnInteraction &&
                this.autoplay.run();
            },
            destroy: function () {
              this.autoplay.running && this.autoplay.stop(),
                document.removeEventListener(
                  "visibilitychange",
                  this.autoplay.onVisibilityChange
                );
            },
          },
        },
        {
          name: "effect-fade",
          params: { fadeEffect: { crossFade: !1 } },
          create: function () {
            r.extend(this, {
              fadeEffect: {
                setTranslate: pe.setTranslate.bind(this),
                setTransition: pe.setTransition.bind(this),
              },
            });
          },
          on: {
            beforeInit: function () {
              if (this.params.effect === "fade") {
                this.classNames.push(
                  this.params.containerModifierClass + "fade"
                );
                var e2 = {
                  slidesPerView: 1,
                  slidesPerColumn: 1,
                  slidesPerGroup: 1,
                  watchSlidesProgress: !0,
                  spaceBetween: 0,
                  virtualTranslate: !0,
                };
                r.extend(this.params, e2), r.extend(this.originalParams, e2);
              }
            },
            setTranslate: function () {
              this.params.effect === "fade" && this.fadeEffect.setTranslate();
            },
            setTransition: function (e2) {
              this.params.effect === "fade" &&
                this.fadeEffect.setTransition(e2);
            },
          },
        },
        {
          name: "effect-cube",
          params: {
            cubeEffect: {
              slideShadows: !0,
              shadow: !0,
              shadowOffset: 20,
              shadowScale: 0.94,
            },
          },
          create: function () {
            r.extend(this, {
              cubeEffect: {
                setTranslate: fe.setTranslate.bind(this),
                setTransition: fe.setTransition.bind(this),
              },
            });
          },
          on: {
            beforeInit: function () {
              if (this.params.effect === "cube") {
                this.classNames.push(
                  this.params.containerModifierClass + "cube"
                ),
                  this.classNames.push(
                    this.params.containerModifierClass + "3d"
                  );
                var e2 = {
                  slidesPerView: 1,
                  slidesPerColumn: 1,
                  slidesPerGroup: 1,
                  watchSlidesProgress: !0,
                  resistanceRatio: 0,
                  spaceBetween: 0,
                  centeredSlides: !1,
                  virtualTranslate: !0,
                };
                r.extend(this.params, e2), r.extend(this.originalParams, e2);
              }
            },
            setTranslate: function () {
              this.params.effect === "cube" && this.cubeEffect.setTranslate();
            },
            setTransition: function (e2) {
              this.params.effect === "cube" &&
                this.cubeEffect.setTransition(e2);
            },
          },
        },
        {
          name: "effect-flip",
          params: { flipEffect: { slideShadows: !0, limitRotation: !0 } },
          create: function () {
            r.extend(this, {
              flipEffect: {
                setTranslate: ve.setTranslate.bind(this),
                setTransition: ve.setTransition.bind(this),
              },
            });
          },
          on: {
            beforeInit: function () {
              if (this.params.effect === "flip") {
                this.classNames.push(
                  this.params.containerModifierClass + "flip"
                ),
                  this.classNames.push(
                    this.params.containerModifierClass + "3d"
                  );
                var e2 = {
                  slidesPerView: 1,
                  slidesPerColumn: 1,
                  slidesPerGroup: 1,
                  watchSlidesProgress: !0,
                  spaceBetween: 0,
                  virtualTranslate: !0,
                };
                r.extend(this.params, e2), r.extend(this.originalParams, e2);
              }
            },
            setTranslate: function () {
              this.params.effect === "flip" && this.flipEffect.setTranslate();
            },
            setTransition: function (e2) {
              this.params.effect === "flip" &&
                this.flipEffect.setTransition(e2);
            },
          },
        },
        {
          name: "effect-coverflow",
          params: {
            coverflowEffect: {
              rotate: 50,
              stretch: 0,
              depth: 100,
              modifier: 1,
              slideShadows: !0,
            },
          },
          create: function () {
            r.extend(this, {
              coverflowEffect: {
                setTranslate: me.setTranslate.bind(this),
                setTransition: me.setTransition.bind(this),
              },
            });
          },
          on: {
            beforeInit: function () {
              this.params.effect === "coverflow" &&
                (this.classNames.push(
                  this.params.containerModifierClass + "coverflow"
                ),
                this.classNames.push(this.params.containerModifierClass + "3d"),
                (this.params.watchSlidesProgress = !0),
                (this.originalParams.watchSlidesProgress = !0));
            },
            setTranslate: function () {
              this.params.effect === "coverflow" &&
                this.coverflowEffect.setTranslate();
            },
            setTransition: function (e2) {
              this.params.effect === "coverflow" &&
                this.coverflowEffect.setTransition(e2);
            },
          },
        },
        {
          name: "thumbs",
          params: {
            thumbs: {
              swiper: null,
              multipleActiveThumbs: !0,
              autoScrollOffset: 0,
              slideThumbActiveClass: "swiper-slide-thumb-active",
              thumbsContainerClass: "swiper-container-thumbs",
            },
          },
          create: function () {
            r.extend(this, {
              thumbs: {
                swiper: null,
                init: ge.init.bind(this),
                update: ge.update.bind(this),
                onThumbClick: ge.onThumbClick.bind(this),
              },
            });
          },
          on: {
            beforeInit: function () {
              var e2 = this.params.thumbs;
              e2 && e2.swiper && (this.thumbs.init(), this.thumbs.update(!0));
            },
            slideChange: function () {
              this.thumbs.swiper && this.thumbs.update();
            },
            update: function () {
              this.thumbs.swiper && this.thumbs.update();
            },
            resize: function () {
              this.thumbs.swiper && this.thumbs.update();
            },
            observerUpdate: function () {
              this.thumbs.swiper && this.thumbs.update();
            },
            setTransition: function (e2) {
              var t2 = this.thumbs.swiper;
              t2 && t2.setTransition(e2);
            },
            beforeDestroy: function () {
              var e2 = this.thumbs.swiper;
              e2 && this.thumbs.swiperCreated && e2 && e2.destroy();
            },
          },
        },
      ];
    return (
      R.use === void 0 &&
        ((R.use = R.Class.use), (R.installModule = R.Class.installModule)),
      R.use(ye),
      R
    );
  }),
  (function (e, t) {
    typeof exports == "object" && typeof module == "object"
      ? (module.exports = t())
      : typeof define == "function" && define.amd
      ? define([], t)
      : typeof exports == "object"
      ? (exports.Typed = t())
      : (e.Typed = t());
  })(this, function () {
    return (function (e) {
      function t(n) {
        if (i[n]) return i[n].exports;
        var s = (i[n] = { exports: {}, id: n, loaded: !1 });
        return (
          e[n].call(s.exports, s, s.exports, t), (s.loaded = !0), s.exports
        );
      }
      var i = {};
      return (t.m = e), (t.c = i), (t.p = ""), t(0);
    })([
      function (e, t, i) {
        "use strict";
        Object.defineProperty(t, "__esModule", { value: !0 });
        var n = (function () {
            function e2(e3, t2) {
              for (var i2 = 0; i2 < t2.length; i2++) {
                var n2 = t2[i2];
                (n2.enumerable = n2.enumerable || !1),
                  (n2.configurable = !0),
                  "value" in n2 && (n2.writable = !0),
                  Object.defineProperty(e3, n2.key, n2);
              }
            }
            return function (t2, i2, n2) {
              return i2 && e2(t2.prototype, i2), n2 && e2(t2, n2), t2;
            };
          })(),
          s = i(1),
          a = i(3),
          r = (function () {
            function e2(t2, i2) {
              (function (e3, t3) {
                if (!(e3 instanceof t3))
                  throw new TypeError("Cannot call a class as a function");
              })(this, e2),
                s.initializer.load(this, i2, t2),
                this.begin();
            }
            return (
              n(e2, [
                {
                  key: "toggle",
                  value: function () {
                    this.pause.status ? this.start() : this.stop();
                  },
                },
                {
                  key: "stop",
                  value: function () {
                    this.typingComplete ||
                      this.pause.status ||
                      (this.toggleBlinking(!0),
                      (this.pause.status = !0),
                      this.options.onStop(this.arrayPos, this));
                  },
                },
                {
                  key: "start",
                  value: function () {
                    this.typingComplete ||
                      (this.pause.status &&
                        ((this.pause.status = !1),
                        this.pause.typewrite
                          ? this.typewrite(
                              this.pause.curString,
                              this.pause.curStrPos
                            )
                          : this.backspace(
                              this.pause.curString,
                              this.pause.curStrPos
                            ),
                        this.options.onStart(this.arrayPos, this)));
                  },
                },
                {
                  key: "destroy",
                  value: function () {
                    this.reset(!1), this.options.onDestroy(this);
                  },
                },
                {
                  key: "reset",
                  value: function () {
                    var e3 =
                      arguments.length <= 0 ||
                      arguments[0] === void 0 ||
                      arguments[0];
                    clearInterval(this.timeout),
                      this.replaceText(""),
                      this.cursor &&
                        this.cursor.parentNode &&
                        (this.cursor.parentNode.removeChild(this.cursor),
                        (this.cursor = null)),
                      (this.strPos = 0),
                      (this.arrayPos = 0),
                      (this.curLoop = 0),
                      e3 &&
                        (this.insertCursor(),
                        this.options.onReset(this),
                        this.begin());
                  },
                },
                {
                  key: "begin",
                  value: function () {
                    var e3 = this;
                    (this.typingComplete = !1),
                      this.shuffleStringsIfNeeded(this),
                      this.insertCursor(),
                      this.bindInputFocusEvents && this.bindFocusEvents(),
                      (this.timeout = setTimeout(function () {
                        e3.currentElContent && e3.currentElContent.length !== 0
                          ? e3.backspace(
                              e3.currentElContent,
                              e3.currentElContent.length
                            )
                          : e3.typewrite(
                              e3.strings[e3.sequence[e3.arrayPos]],
                              e3.strPos
                            );
                      }, this.startDelay));
                  },
                },
                {
                  key: "typewrite",
                  value: function (e3, t2) {
                    var i2 = this;
                    this.fadeOut &&
                      this.el.classList.contains(this.fadeOutClass) &&
                      (this.el.classList.remove(this.fadeOutClass),
                      this.cursor &&
                        this.cursor.classList.remove(this.fadeOutClass));
                    var n2 = this.humanizer(this.typeSpeed),
                      s2 = 1;
                    return this.pause.status === !0
                      ? void this.setPauseStatus(e3, t2, !0)
                      : void (this.timeout = setTimeout(function () {
                          t2 = a.htmlParser.typeHtmlChars(e3, t2, i2);
                          var n3 = 0,
                            r2 = e3.substr(t2);
                          if (r2.charAt(0) === "^" && /^\^\d+/.test(r2)) {
                            var o = 1;
                            (o += (r2 = /\d+/.exec(r2)[0]).length),
                              (n3 = parseInt(r2)),
                              (i2.temporaryPause = !0),
                              i2.options.onTypingPaused(i2.arrayPos, i2),
                              (e3 = e3.substring(0, t2) + e3.substring(t2 + o)),
                              i2.toggleBlinking(!0);
                          }
                          if (r2.charAt(0) === "`") {
                            for (
                              ;
                              e3.substr(t2 + s2).charAt(0) !== "`" &&
                              (s2++, !(t2 + s2 > e3.length));

                            );
                            var l = e3.substring(0, t2),
                              c = e3.substring(l.length + 1, t2 + s2),
                              u = e3.substring(t2 + s2 + 1);
                            (e3 = l + c + u), s2--;
                          }
                          i2.timeout = setTimeout(function () {
                            i2.toggleBlinking(!1),
                              t2 === e3.length
                                ? i2.doneTyping(e3, t2)
                                : i2.keepTyping(e3, t2, s2),
                              i2.temporaryPause &&
                                ((i2.temporaryPause = !1),
                                i2.options.onTypingResumed(i2.arrayPos, i2));
                          }, n3);
                        }, n2));
                  },
                },
                {
                  key: "keepTyping",
                  value: function (e3, t2, i2) {
                    t2 === 0 &&
                      (this.toggleBlinking(!1),
                      this.options.preStringTyped(this.arrayPos, this)),
                      (t2 += i2);
                    var n2 = e3.substr(0, t2);
                    this.replaceText(n2), this.typewrite(e3, t2);
                  },
                },
                {
                  key: "doneTyping",
                  value: function (e3, t2) {
                    var i2 = this;
                    this.options.onStringTyped(this.arrayPos, this),
                      this.toggleBlinking(!0),
                      (this.arrayPos === this.strings.length - 1 &&
                        (this.complete(),
                        this.loop === !1 || this.curLoop === this.loopCount)) ||
                        (this.timeout = setTimeout(function () {
                          i2.backspace(e3, t2);
                        }, this.backDelay));
                  },
                },
                {
                  key: "backspace",
                  value: function (e3, t2) {
                    var i2 = this;
                    if (this.pause.status !== !0) {
                      if (this.fadeOut) return this.initFadeOut();
                      this.toggleBlinking(!1);
                      var n2 = this.humanizer(this.backSpeed);
                      this.timeout = setTimeout(function () {
                        t2 = a.htmlParser.backSpaceHtmlChars(e3, t2, i2);
                        var n3 = e3.substr(0, t2);
                        if ((i2.replaceText(n3), i2.smartBackspace)) {
                          var s2 = i2.strings[i2.arrayPos + 1];
                          s2 && n3 === s2.substr(0, t2)
                            ? (i2.stopNum = t2)
                            : (i2.stopNum = 0);
                        }
                        t2 > i2.stopNum
                          ? (t2--, i2.backspace(e3, t2))
                          : t2 <= i2.stopNum &&
                            (i2.arrayPos++,
                            i2.arrayPos === i2.strings.length
                              ? ((i2.arrayPos = 0),
                                i2.options.onLastStringBackspaced(),
                                i2.shuffleStringsIfNeeded(),
                                i2.begin())
                              : i2.typewrite(
                                  i2.strings[i2.sequence[i2.arrayPos]],
                                  t2
                                ));
                      }, n2);
                    } else this.setPauseStatus(e3, t2, !0);
                  },
                },
                {
                  key: "complete",
                  value: function () {
                    this.options.onComplete(this),
                      this.loop ? this.curLoop++ : (this.typingComplete = !0);
                  },
                },
                {
                  key: "setPauseStatus",
                  value: function (e3, t2, i2) {
                    (this.pause.typewrite = i2),
                      (this.pause.curString = e3),
                      (this.pause.curStrPos = t2);
                  },
                },
                {
                  key: "toggleBlinking",
                  value: function (e3) {
                    if (
                      this.cursor &&
                      !this.pause.status &&
                      this.cursorBlinking !== e3
                    ) {
                      this.cursorBlinking = e3;
                      var t2 = e3 ? "infinite" : 0;
                      this.cursor.style.animationIterationCount = t2;
                    }
                  },
                },
                {
                  key: "humanizer",
                  value: function (e3) {
                    return Math.round((Math.random() * e3) / 2) + e3;
                  },
                },
                {
                  key: "shuffleStringsIfNeeded",
                  value: function () {
                    this.shuffle &&
                      (this.sequence = this.sequence.sort(function () {
                        return Math.random() - 0.5;
                      }));
                  },
                },
                {
                  key: "initFadeOut",
                  value: function () {
                    var e3 = this;
                    return (
                      (this.el.className += " " + this.fadeOutClass),
                      this.cursor &&
                        (this.cursor.className += " " + this.fadeOutClass),
                      setTimeout(function () {
                        e3.arrayPos++,
                          e3.replaceText(""),
                          e3.strings.length > e3.arrayPos
                            ? e3.typewrite(
                                e3.strings[e3.sequence[e3.arrayPos]],
                                0
                              )
                            : (e3.typewrite(e3.strings[0], 0),
                              (e3.arrayPos = 0));
                      }, this.fadeOutDelay)
                    );
                  },
                },
                {
                  key: "replaceText",
                  value: function (e3) {
                    this.attr
                      ? this.el.setAttribute(this.attr, e3)
                      : this.isInput
                      ? (this.el.value = e3)
                      : this.contentType === "html"
                      ? (this.el.innerHTML = e3)
                      : (this.el.textContent = e3);
                  },
                },
                {
                  key: "bindFocusEvents",
                  value: function () {
                    var e3 = this;
                    this.isInput &&
                      (this.el.addEventListener("focus", function (t2) {
                        e3.stop();
                      }),
                      this.el.addEventListener("blur", function (t2) {
                        (e3.el.value && e3.el.value.length !== 0) || e3.start();
                      }));
                  },
                },
                {
                  key: "insertCursor",
                  value: function () {
                    this.showCursor &&
                      (this.cursor ||
                        ((this.cursor = document.createElement("span")),
                        (this.cursor.className = "typed-cursor"),
                        (this.cursor.innerHTML = this.cursorChar),
                        this.el.parentNode &&
                          this.el.parentNode.insertBefore(
                            this.cursor,
                            this.el.nextSibling
                          )));
                  },
                },
              ]),
              e2
            );
          })();
        (t.default = r), (e.exports = t.default);
      },
      function (e, t, i) {
        "use strict";
        Object.defineProperty(t, "__esModule", { value: !0 });
        var n =
            Object.assign ||
            function (e2) {
              for (var t2 = 1; t2 < arguments.length; t2++) {
                var i2 = arguments[t2];
                for (var n2 in i2)
                  Object.prototype.hasOwnProperty.call(i2, n2) &&
                    (e2[n2] = i2[n2]);
              }
              return e2;
            },
          s = (function () {
            function e2(e3, t2) {
              for (var i2 = 0; i2 < t2.length; i2++) {
                var n2 = t2[i2];
                (n2.enumerable = n2.enumerable || !1),
                  (n2.configurable = !0),
                  "value" in n2 && (n2.writable = !0),
                  Object.defineProperty(e3, n2.key, n2);
              }
            }
            return function (t2, i2, n2) {
              return i2 && e2(t2.prototype, i2), n2 && e2(t2, n2), t2;
            };
          })(),
          a = (function (e2) {
            return e2 && e2.__esModule ? e2 : { default: e2 };
          })(i(2)),
          r = (function () {
            function e2() {
              (function (e3, t2) {
                if (!(e3 instanceof t2))
                  throw new TypeError("Cannot call a class as a function");
              })(this, e2);
            }
            return (
              s(e2, [
                {
                  key: "load",
                  value: function (e3, t2, i2) {
                    if (
                      ((e3.el =
                        typeof i2 == "string"
                          ? document.querySelector(i2)
                          : i2),
                      (e3.options = n({}, a.default, t2)),
                      (e3.isInput = e3.el.tagName.toLowerCase() === "input"),
                      (e3.attr = e3.options.attr),
                      (e3.bindInputFocusEvents =
                        e3.options.bindInputFocusEvents),
                      (e3.showCursor = !e3.isInput && e3.options.showCursor),
                      (e3.cursorChar = e3.options.cursorChar),
                      (e3.cursorBlinking = !0),
                      (e3.elContent = e3.attr
                        ? e3.el.getAttribute(e3.attr)
                        : e3.el.textContent),
                      (e3.contentType = e3.options.contentType),
                      (e3.typeSpeed = e3.options.typeSpeed),
                      (e3.startDelay = e3.options.startDelay),
                      (e3.backSpeed = e3.options.backSpeed),
                      (e3.smartBackspace = e3.options.smartBackspace),
                      (e3.backDelay = e3.options.backDelay),
                      (e3.fadeOut = e3.options.fadeOut),
                      (e3.fadeOutClass = e3.options.fadeOutClass),
                      (e3.fadeOutDelay = e3.options.fadeOutDelay),
                      (e3.isPaused = !1),
                      (e3.strings = e3.options.strings.map(function (e4) {
                        return e4.trim();
                      })),
                      typeof e3.options.stringsElement == "string"
                        ? (e3.stringsElement = document.querySelector(
                            e3.options.stringsElement
                          ))
                        : (e3.stringsElement = e3.options.stringsElement),
                      e3.stringsElement)
                    ) {
                      (e3.strings = []),
                        (e3.stringsElement.style.display = "none");
                      var s2 = Array.prototype.slice.apply(
                          e3.stringsElement.children
                        ),
                        r2 = s2.length;
                      if (r2)
                        for (var o2 = 0; o2 < r2; o2 += 1) {
                          var l = s2[o2];
                          e3.strings.push(l.innerHTML.trim());
                        }
                    }
                    for (var o2 in ((e3.strPos = 0),
                    (e3.arrayPos = 0),
                    (e3.stopNum = 0),
                    (e3.loop = e3.options.loop),
                    (e3.loopCount = e3.options.loopCount),
                    (e3.curLoop = 0),
                    (e3.shuffle = e3.options.shuffle),
                    (e3.sequence = []),
                    (e3.pause = {
                      status: !1,
                      typewrite: !0,
                      curString: "",
                      curStrPos: 0,
                    }),
                    (e3.typingComplete = !1),
                    e3.strings))
                      e3.sequence[o2] = o2;
                    (e3.currentElContent = this.getCurrentElContent(e3)),
                      (e3.autoInsertCss = e3.options.autoInsertCss),
                      this.appendAnimationCss(e3);
                  },
                },
                {
                  key: "getCurrentElContent",
                  value: function (e3) {
                    return e3.attr
                      ? e3.el.getAttribute(e3.attr)
                      : e3.isInput
                      ? e3.el.value
                      : e3.contentType === "html"
                      ? e3.el.innerHTML
                      : e3.el.textContent;
                  },
                },
                {
                  key: "appendAnimationCss",
                  value: function (e3) {
                    if (e3.autoInsertCss && e3.showCursor && e3.fadeOut) {
                      var t2 = document.createElement("style");
                      t2.type = "text/css";
                      var i2 = "";
                      e3.showCursor &&
                        (i2 += `
        .typed-cursor{
          opacity: 1;
          animation: typedjsBlink 0.7s infinite;
          -webkit-animation: typedjsBlink 0.7s infinite;
                  animation: typedjsBlink 0.7s infinite;
        }
        @keyframes typedjsBlink{
          50% { opacity: 0.0; }
        }
        @-webkit-keyframes typedjsBlink{
          0% { opacity: 1; }
          50% { opacity: 0.0; }
          100% { opacity: 1; }
        }
      `),
                        e3.fadeOut &&
                          (i2 += `
        .typed-fade-out{
          opacity: 0;
          transition: opacity .25s;
          -webkit-animation: 0;
                  animation: 0;
        }
      `),
                        t2.length !== 0 &&
                          ((t2.innerHTML = i2), document.head.appendChild(t2));
                    }
                  },
                },
              ]),
              e2
            );
          })();
        t.default = r;
        var o = new r();
        t.initializer = o;
      },
      function (e, t) {
        "use strict";
        Object.defineProperty(t, "__esModule", { value: !0 }),
          (t.default = {
            strings: [
              "These are the default values...",
              "You know what you should do?",
              "Use your own!",
              "Have a great day!",
            ],
            stringsElement: null,
            typeSpeed: 0,
            startDelay: 0,
            backSpeed: 0,
            smartBackspace: !0,
            shuffle: !1,
            backDelay: 700,
            fadeOut: !1,
            fadeOutClass: "typed-fade-out",
            fadeOutDelay: 500,
            loop: !1,
            loopCount: 1 / 0,
            showCursor: !0,
            cursorChar: "|",
            autoInsertCss: !0,
            attr: null,
            bindInputFocusEvents: !1,
            contentType: "html",
            onComplete: function (e2) {},
            preStringTyped: function (e2, t2) {},
            onStringTyped: function (e2, t2) {},
            onLastStringBackspaced: function (e2) {},
            onTypingPaused: function (e2, t2) {},
            onTypingResumed: function (e2, t2) {},
            onReset: function (e2) {},
            onStop: function (e2, t2) {},
            onStart: function (e2, t2) {},
            onDestroy: function (e2) {},
          }),
          (e.exports = t.default);
      },
      function (e, t) {
        "use strict";
        Object.defineProperty(t, "__esModule", { value: !0 });
        var i = (function () {
            function e2(e3, t2) {
              for (var i2 = 0; i2 < t2.length; i2++) {
                var n2 = t2[i2];
                (n2.enumerable = n2.enumerable || !1),
                  (n2.configurable = !0),
                  "value" in n2 && (n2.writable = !0),
                  Object.defineProperty(e3, n2.key, n2);
              }
            }
            return function (t2, i2, n2) {
              return i2 && e2(t2.prototype, i2), n2 && e2(t2, n2), t2;
            };
          })(),
          n = (function () {
            function e2() {
              (function (e3, t2) {
                if (!(e3 instanceof t2))
                  throw new TypeError("Cannot call a class as a function");
              })(this, e2);
            }
            return (
              i(e2, [
                {
                  key: "typeHtmlChars",
                  value: function (e3, t2, i2) {
                    if (i2.contentType !== "html") return t2;
                    var n2 = e3.substr(t2).charAt(0);
                    if (n2 === "<" || n2 === "&") {
                      var s2;
                      for (
                        s2 = n2 === "<" ? ">" : ";";
                        e3.substr(t2 + 1).charAt(0) !== s2 &&
                        !(++t2 + 1 > e3.length);

                      );
                      t2++;
                    }
                    return t2;
                  },
                },
                {
                  key: "backSpaceHtmlChars",
                  value: function (e3, t2, i2) {
                    if (i2.contentType !== "html") return t2;
                    var n2 = e3.substr(t2).charAt(0);
                    if (n2 === ">" || n2 === ";") {
                      var s2;
                      for (
                        s2 = n2 === ">" ? "<" : "&";
                        e3.substr(t2 - 1).charAt(0) !== s2 && !(--t2 < 0);

                      );
                      t2--;
                    }
                    return t2;
                  },
                },
              ]),
              e2
            );
          })();
        t.default = n;
        var s = new n();
        t.htmlParser = s;
      },
    ]);
  }),
  $(document).ready(function () {
    (ysscount = 0),
      $(".ys_custom_gallery_swiper").each(function () {
        ysscount++,
          (this_item = $(this)),
          this_item.addClass("swiper-container customswiper" + ysscount),
          this_item.append('<div class="swiper-pagination"></div>'),
          (desk_item = this_item.attr("data-desktop_items")),
          (mob_item = this_item.attr("data-mobile_items")),
          (ipad_item = this_item.attr("data-ipad_items")),
          (ipad_item_horizontal = this_item.attr("data-ipad_horizontal_items")),
          (ipad_item_vertical = this_item.attr("data-ipad_vertical_items")),
          (slider_mode = this_item.attr("data-mode")),
          (swiper_arrows = this_item.attr("data-swiper-style-arrow")),
          (swiper_style = this_item.attr("data-swiper_style")),
          (slider_autoplay = this_item.attr("data-slider-autoplay")),
          (slider_center = this_item.attr("data-slider-center")),
          (slider_effect = this_item.attr("data-slider-effect")),
          (slider_desktop_padding = this_item.attr("data-desktop-padding")),
          (slider_ipad_horizontal_padding = this_item.attr(
            "data-ipad-horizontal-padding"
          )),
          (slider_ipad_vertical_padding = this_item.attr(
            "data-ipad-vertical-padding"
          )),
          (slider_mobile_padding = this_item.attr("data-mobile-padding")),
          (desktop_offset = this_item.attr("data-desktop-offset")),
          (mobile_offset = this_item.attr("data-mobile-offset")),
          (ipad_vertical_offset = this_item.attr("data-ipad-vertical-offset")),
          (ipad_horizontal_offset = this_item.attr(
            "data-ipad-horizontal-offset"
          )),
          (slider_loop = this_item.attr("data-slider-loop")),
          console.log(swiper_style),
          console.log(slider_center),
          console.log(slider_loop),
          (swiper_navigation = {}),
          (swiper_pagination = {}),
          (slider_autoplay_start = {});
        var is_slider_loop = !0,
          is_slider_center = !1;
        if (
          (slider_loop == "false"
            ? (is_slider_loop = !1)
            : (is_slider_loop = !0),
          slider_center == "false"
            ? (is_slider_center = !1)
            : (is_slider_center = !0),
          swiper_arrows == "true" &&
            (this_item.append(
              '<div class="swiper-button-next swiper_arrows  customswiper_next' +
                ysscount +
                '"></div><div class="swiper-button-prev swiper_arrows  customswiper_prev' +
                ysscount +
                '"></div>'
            ),
            (swiper_navigation = {
              nextEl: ".customswiper_next" + ysscount,
              prevEl: ".customswiper_prev" + ysscount,
            })),
          swiper_style == "donts"
            ? (this_item.append('<div class="swiper-pagination"></div>'),
              (swpier_pagination = {
                el: ".swiper-pagination",
                type: "bullets",
                clickable: !0,
              }))
            : swiper_style == "progress_bar"
            ? (swpier_pagination = {
                el: ".swiper-pagination",
                type: "progressbar",
                clickable: !0,
              })
            : (swpier_pagination = {}),
          slider_autoplay == "true"
            ? (slider_autoplay_start = {
                delay: 3500,
                disableOnInteraction: !1,
              })
            : (slider_autoplay_start = {
                delay: 25e10,
                disableOnInteraction: !0,
              }),
          slider_mode == "normal")
        )
          var partner_swiper = new Swiper(".customswiper" + ysscount, {
            spaceBetween: 0,
            navigation: swiper_navigation,
            effect: slider_effect == "fade" ? "fade" : "",
            pagination: {
              el: ".swiper-pagination",
              type: swiper_style == "progress_bar" ? "progressbar" : "bullets",
              clickable: !0,
            },
            loop: is_slider_loop,
            autoplay: slider_autoplay_start,
            centeredSlides: is_slider_center,
            breakpoints: {
              0: {
                slidesPerView: mob_item,
                spaceBetween: slider_mobile_padding,
                slidesOffsetBefore: mobile_offset,
              },
              481: {
                slidesPerView: ipad_item_vertical,
                spaceBetween: slider_ipad_vertical_padding,
                slidesOffsetBefore: ipad_vertical_offset,
              },
              786: {
                slidesPerView: ipad_item_horizontal,
                spaceBetween: slider_ipad_horizontal_padding,
                slidesOffsetBefore: ipad_horizontal_offset,
              },
              1100: {
                slidesPerView: desk_item,
                spaceBetween: slider_desktop_padding,
                slidesOffsetBefore: desktop_offset,
              },
            },
          });
        else {
          this_item.find(".swiper-wrapper").addClass("swipanim");
          var partner_swiper = new Swiper(".customswiper" + ysscount, {
            spaceBetween: 0,
            navigation: swiper_navigation,
            effect: slider_effect == "fade" ? "fade" : "",
            pagination: swpier_pagination,
            loop: is_slider_loop,
            freeMode: !0,
            spaceBetween: 0,
            grabCursor: !0,
            slidesPerView: 7,
            autoplay: { delay: 1, disableOnInteraction: !0 },
            freeMode: !0,
            speed: 5e3,
            freeModeMomentum: !1,
            breakpoints: {
              0: {
                slidesPerView: mob_item,
                spaceBetween: slider_mobile_padding,
                slidesOffsetBefore: mobile_offset,
              },
              481: {
                slidesPerView: ipad_item_vertical,
                spaceBetween: slider_ipad_vertical_padding,
                slidesOffsetBefore: ipad_vertical_offset,
              },
              786: {
                slidesPerView: ipad_item_horizontal,
                spaceBetween: slider_ipad_horizontal_padding,
                slidesOffsetBefore: ipad_horizontal_offset,
              },
              1100: {
                slidesPerView: desk_item,
                spaceBetween: slider_desktop_padding,
                slidesOffsetBefore: desktop_offset,
              },
            },
          });
        }
      }),
      $(".ys_custom_gallery_swiper_test").each(function () {
        ysscount++,
          (this_item = $(this)),
          this_item.addClass("swiper-container customswiper" + ysscount),
          this_item.wrapInner('<div class="swiper-wrapper"></div>'),
          this_item.find("li").wrap('<div class="swiper-slide"></div>'),
          this_item.append(
            '<div class="swiper-button-next swiper_arrows2  customswiper_next' +
              ysscount +
              '"></div><div class="swiper-button-prev swiper_arrows2  customswiper_prev' +
              ysscount +
              '"></div>'
          ),
          (desk_item = this_item.attr("data-desktop_items")),
          (mob_item = this_item.attr("data-mobile_items")),
          (ipad_item = this_item.attr("data-ipad_items")),
          (slider_mode = this_item.attr("data-mode")),
          slider_mode == "normal"
            ? new Swiper(".customswiper" + ysscount, {
                spaceBetween: 0,
                navigation: {
                  nextEl: ".customswiper_next" + ysscount,
                  prevEl: ".customswiper_prev" + ysscount,
                },
                loop: !0,
                autoplay: { delay: 3500, disableOnInteraction: !1 },
                breakpoints: {
                  0: { slidesPerView: mob_item, spaceBetween: 20 },
                  481: { slidesPerView: ipad_item, spaceBetween: 30 },
                  786: { slidesPerView: ipad_item, spaceBetween: 30 },
                  1100: { slidesPerView: desk_item, spaceBetween: 30 },
                },
              })
            : (this_item.find(".swiper-wrapper").addClass("swipanim"),
              new Swiper(".customswiper" + ysscount, {
                spaceBetween: 0,
                navigation: {
                  nextEl: ".customswiper_next" + ysscount,
                  prevEl: ".customswiper_prev" + ysscount,
                },
                loop: !0,
                freeMode: !0,
                spaceBetween: 0,
                grabCursor: !0,
                slidesPerView: 7,
                loop: !0,
                autoplay: { delay: 1, disableOnInteraction: !0 },
                freeMode: !0,
                speed: 5e3,
                freeModeMomentum: !1,
                breakpoints: {
                  0: { slidesPerView: mob_item, spaceBetween: 0 },
                  481: { slidesPerView: ipad_item, spaceBetween: 0 },
                  786: { slidesPerView: ipad_item, spaceBetween: 0 },
                  1100: { slidesPerView: desk_item, spaceBetween: 0 },
                },
              }));
      });
  }),
  $(document).ready(function () {
    $(".top_slider_texts").length &&
      new Typed(".top_slider_texts", {
        strings: ["Where Strength Meets Style", "Where Style Meets Strength"],
        typeSpeed: 90,
        backSpeed: 40,
        backDelay: 1500,
        contentType: "html",
        loop: !0,
      }),
      $(document).on("click", ".pdp_offers_wrap ul li .code_wrap", function () {
        (this_id = $(this).find("b").text()),
          console.log(this_id),
          copyText(this_id);
      });
  }),
  document.addEventListener("DOMContentLoaded", (e) => {
    sessionStorage.removeItem("popCartRendered");
  }),
  (function (a) {
    "use strict";
    typeof define == "function" && define.amd
      ? define(["jquery"], a)
      : a(jQuery);
  })(function (a) {
    "use strict";
    function b(a2) {
      if (a2 instanceof Date) return a2;
      if (String(a2).match(g))
        return (
          String(a2).match(/^[0-9]*$/) && (a2 = Number(a2)),
          String(a2).match(/\-/) && (a2 = String(a2).replace(/\-/g, "/")),
          new Date(a2)
        );
      throw new Error("Couldn't cast `" + a2 + "` to a date object.");
    }
    function c(a2) {
      var b2 = a2.toString().replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1");
      return new RegExp(b2);
    }
    function d(a2) {
      return function (b2) {
        var d2 = b2.match(/%(-|!)?[A-Z]{1}(:[^;]+;)?/gi);
        if (d2)
          for (var f2 = 0, g2 = d2.length; g2 > f2; ++f2) {
            var h2 = d2[f2].match(/%(-|!)?([a-zA-Z]{1})(:[^;]+;)?/),
              j2 = c(h2[0]),
              k = h2[1] || "",
              l = h2[3] || "",
              m = null;
            (h2 = h2[2]),
              i.hasOwnProperty(h2) && ((m = i[h2]), (m = Number(a2[m]))),
              m !== null &&
                (k === "!" && (m = e(l, m)),
                k === "" && 10 > m && (m = "0" + m.toString()),
                (b2 = b2.replace(j2, m.toString())));
          }
        return (b2 = b2.replace(/%%/, "%"));
      };
    }
    function e(a2, b2) {
      var c2 = "s",
        d2 = "";
      return (
        a2 &&
          ((a2 = a2.replace(/(:|;|\s)/gi, "").split(/\,/)),
          a2.length === 1 ? (c2 = a2[0]) : ((d2 = a2[0]), (c2 = a2[1]))),
        Math.abs(b2) === 1 ? d2 : c2
      );
    }
    var f = [],
      g = [],
      h = { precision: 100, elapse: !1 };
    g.push(/^[0-9]*$/.source),
      g.push(/([0-9]{1,2}\/){2}[0-9]{4}( [0-9]{1,2}(:[0-9]{2}){2})?/.source),
      g.push(
        /[0-9]{4}([\/\-][0-9]{1,2}){2}( [0-9]{1,2}(:[0-9]{2}){2})?/.source
      ),
      (g = new RegExp(g.join("|")));
    var i = {
        Y: "years",
        m: "months",
        n: "daysToMonth",
        w: "weeks",
        d: "daysToWeek",
        D: "totalDays",
        H: "hours",
        M: "minutes",
        S: "seconds",
      },
      j = function (b2, c2, d2) {
        (this.el = b2),
          (this.$el = a(b2)),
          (this.interval = null),
          (this.offset = {}),
          (this.options = a.extend({}, h)),
          (this.instanceNumber = f.length),
          f.push(this),
          this.$el.data("countdown-instance", this.instanceNumber),
          d2 &&
            (typeof d2 == "function"
              ? (this.$el.on("update.countdown", d2),
                this.$el.on("stoped.countdown", d2),
                this.$el.on("finish.countdown", d2))
              : (this.options = a.extend({}, h, d2))),
          this.setFinalDate(c2),
          this.start();
      };
    a.extend(j.prototype, {
      start: function () {
        this.interval !== null && clearInterval(this.interval);
        var a2 = this;
        this.update(),
          (this.interval = setInterval(function () {
            a2.update.call(a2);
          }, this.options.precision));
      },
      stop: function () {
        clearInterval(this.interval),
          (this.interval = null),
          this.dispatchEvent("stoped");
      },
      toggle: function () {
        this.interval ? this.stop() : this.start();
      },
      pause: function () {
        this.stop();
      },
      resume: function () {
        this.start();
      },
      remove: function () {
        this.stop.call(this),
          (f[this.instanceNumber] = null),
          delete this.$el.data().countdownInstance;
      },
      setFinalDate: function (a2) {
        this.finalDate = b(a2);
      },
      update: function () {
        if (this.$el.closest("html").length === 0) return void this.remove();
        var b2,
          c2 = a._data(this.el, "events") !== void 0,
          d2 = new Date();
        (b2 = this.finalDate.getTime() - d2.getTime()),
          (b2 = Math.ceil(b2 / 1e3)),
          (b2 = !this.options.elapse && 0 > b2 ? 0 : Math.abs(b2)),
          this.totalSecsLeft !== b2 &&
            c2 &&
            ((this.totalSecsLeft = b2),
            (this.elapsed = d2 >= this.finalDate),
            (this.offset = {
              seconds: this.totalSecsLeft % 60,
              minutes: Math.floor(this.totalSecsLeft / 60) % 60,
              hours: Math.floor(this.totalSecsLeft / 60 / 60) % 24,
              days: Math.floor(this.totalSecsLeft / 60 / 60 / 24) % 7,
              daysToWeek: Math.floor(this.totalSecsLeft / 60 / 60 / 24) % 7,
              daysToMonth: Math.floor(
                (this.totalSecsLeft / 60 / 60 / 24) % 30.4368
              ),
              totalDays: Math.floor(this.totalSecsLeft / 60 / 60 / 24),
              weeks: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 7),
              months: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 30.4368),
              years: Math.abs(this.finalDate.getFullYear() - d2.getFullYear()),
            }),
            this.options.elapse || this.totalSecsLeft !== 0
              ? this.dispatchEvent("update")
              : (this.stop(), this.dispatchEvent("finish")));
      },
      dispatchEvent: function (b2) {
        var c2 = a.Event(b2 + ".countdown");
        (c2.finalDate = this.finalDate),
          (c2.elapsed = this.elapsed),
          (c2.offset = a.extend({}, this.offset)),
          (c2.strftime = d(this.offset)),
          this.$el.trigger(c2);
      },
    }),
      (a.fn.countdown = function () {
        var b2 = Array.prototype.slice.call(arguments, 0);
        return this.each(function () {
          var c2 = a(this).data("countdown-instance");
          if (c2 !== void 0) {
            var d2 = f[c2],
              e2 = b2[0];
            j.prototype.hasOwnProperty(e2)
              ? d2[e2].apply(d2, b2.slice(1))
              : String(e2).match(/^[$A-Z_][0-9A-Z_$]*$/i) === null
              ? (d2.setFinalDate.call(d2, e2), d2.start())
              : a.error(
                  "Method %s does not exist on jQuery.countdown".replace(
                    /\%s/gi,
                    e2
                  )
                );
          } else new j(this, b2[0], b2[1]);
        });
      });
  }),
  $(document).ready(function () {
    (ys_timer = 0),
      console.log($(".ys_timer").length),
      $(".ys_timer").each(function () {
        (ys_timer = ys_timer + 1),
          $(this).attr("id", "ys_timer" + ys_timer),
          (timer2 = $(this).attr("data-time")),
          console.log(timer2),
          $("#ys_timer" + ys_timer).countdown(timer2, function (event) {
            $(this).html(
              event.strftime(
                ' <span><span class="digit">%H</span><br>Hours</span> <span><span class="digit">%M</span><br>Mins</span> <span><span class="digit">%S</span><br>Sec</span> '
              )
            );
          });
      });
  }),
  $(document).ready(function () {
    (announcement_bar_ys_timer = 0),
      console.log($(".ys_announcement_bar_timer").length),
      $(".ys_announcement_bar_timer").each(function () {
        (announcement_bar_ys_timer = announcement_bar_ys_timer + 1),
          $(this).attr(
            "id",
            "ys_announcement_bar_timer" + announcement_bar_ys_timer
          ),
          (product_timer = $(this).attr("data-time")),
          console.log(product_timer),
          $("#ys_announcement_bar_timer" + announcement_bar_ys_timer).countdown(
            product_timer,
            function (event) {
              $(this).html(
                event.strftime(
                  '<span><span style="margin-right: 5px">Sale Ends In</span><span><span class="digit"><b>%H</b></span> Hours</span> <span><span class="digit"><b>%M</b></span> Mins</span> <span><span class="digit"><b>%S</b></span> Sec</span> '
                )
              );
            }
          );
      });
  }),
  $(document).ready(function () {
    (product_ys_timer = 0),
      console.log($(".product_ys_timer").length),
      $(".product_ys_timer").each(function () {
        (product_ys_timer = product_ys_timer + 1),
          $(this).attr("id", "product_ys_timer" + product_ys_timer),
          (product_timer = $(this).attr("data-time")),
          console.log(product_timer),
          $("#product_ys_timer" + product_ys_timer).countdown(
            product_timer,
            function (event) {
              $(this).html(
                event.strftime(
                  '<span><span style="margin-right: 5px">Sale Ends In</span><span><span class="digit"><b>%H</b></span>hr</span> <span><span class="digit"><b>%M</b></span>m</span> <span><span class="digit"><b>%S</b></span>s</span> '
                )
              );
            }
          );
      });
  }),
  $(document).ready(function () {
    $(".top_slider_texts").length &&
      new Typed(".top_slider_texts", {
        strings: ["Where Strength Meets Style", "Where Style Meets Strength"],
        typeSpeed: 90,
        backSpeed: 40,
        backDelay: 1500,
        contentType: "html",
        loop: !0,
      }),
      $(document).on("click", ".pdp_offers_wrap ul li .code_wrap", function () {
        (this_id = $(this).find("b").text()),
          console.log(this_id),
          copyText(this_id);
      });
  }),
  document.addEventListener("DOMContentLoaded", (e) => {
    sessionStorage.removeItem("popCartRendered");
  });
function qtyChangeCheck() {}
document.addEventListener("DOMContentLoaded", function () {
  var videos = [].slice.call(
    document.querySelectorAll(".has_lazy_video .lazyvideo")
  );
  if (
    ((imagesload = [].slice.call(document.querySelectorAll(".lazyimages"))),
    screen.width > 480)
  )
    var videos2 = [].slice.call(
      document.querySelectorAll(".desktop_ys_banner .lazyvideo")
    );
  else
    var videos2 = [].slice.call(
      document.querySelectorAll(".mobile_ys_banner .lazyvideo")
    );
  if ("IntersectionObserver" in window) {
    var count = 0,
      videoObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (video) {
          if (video.isIntersecting) {
            stype = "image";
            for (var source in video.target.children) {
              var videoSource = video.target.children[source];
              typeof videoSource.tagName == "string" &&
                videoSource.tagName === "SOURCE" &&
                ((videoSource.src = videoSource.dataset.src),
                (stype = "video"));
            }
            stype == "video"
              ? (video.target.load(),
                console.log("video", video),
                video.target.setAttribute("id", "video_lazy_" + count),
                document.getElementById("video_lazy_" + count).play(),
                video.target.classList.remove("lazyvideo"))
              : (console.log(video.target.dataset.src),
                video.target.setAttribute("id", "image_lazy_" + count),
                document
                  .getElementById("image_lazy_" + count)
                  .setAttribute("src", video.target.dataset.src),
                video.target.classList.remove("lazyimages")),
              videoObserver.unobserve(video.target),
              count++;
          }
        });
      });
    videos.forEach(function (video) {
      videoObserver.observe(video);
    }),
      videos2.forEach(function (video) {
        videoObserver.observe(video);
      }),
      imagesload.forEach(function (video) {
        videoObserver.observe(video);
      });
  }
}),
  $(window).load(function () {
    (ysscount2 = 0),
      $(".ys_custom_gallery_swiper_product").each(function () {
        if (!$(this).hasClass("swiper-container-initialized")) {
          ysscount2++,
            (this_item = $(this)),
            this_item.addClass("swiper-container customswiper" + ysscount2),
            this_item.wrapInner('<div class="swiper-wrapper"></div>'),
            this_item.find("li").wrap('<div class="swiper-slide"></div>'),
            (desk_item = this_item.attr("data-desktop_items")),
            (mob_item = this_item.attr("data-mobile_items"));
          var partner_swiper = new Swiper(".customswiper" + ysscount2, {
            spaceBetween: 0,
            pagination: { el: ".swiper-pagination" },
            loop: !0,
            autoplay: { delay: 3500, disableOnInteraction: !1 },
            breakpoints: {
              0: { slidesPerView: mob_item, spaceBetween: 0 },
              481: { slidesPerView: desk_item, spaceBetween: 0 },
              786: { slidesPerView: desk_item, spaceBetween: 0 },
              1100: { slidesPerView: desk_item, spaceBetween: 0 },
            },
          });
        }
      });
  }),
  $(document).ready(function () {
    console.log("Shiv2"),
      $(".menu-tab-link:first-child").addClass("active"),
      $(document).on("click", ".menu-tab-link", function () {
        var tabId = $(this).data("tab");
        console.log(tabId),
          $(".menu-tab-link").removeClass("active"),
          $(this).addClass("active"),
          $(".mobile_menu_tab").hide(),
          $("#" + tabId).show(),
          console.log($("#" + tabId)),
          $(".mobile_menu_tab." + tabId).toggleClass("active");
      }),
      $(document).on("click", ".level1-link", function () {
        var tabId = $(this).data("tab");
        console.log(tabId),
          console.log($(".level1-link." + tabId)),
          $(".level1-link." + tabId).toggleClass("active");
        var $subMenu = $(this).next(".sub-menu");
        $subMenu.slideToggle(300);
      }),
      $(".menu-tab-link:first").click();
  }),
  $(document).ready(function () {
    $(".header__cart-icon,.product-form__btn").on("click", function () {
      (timing = 10),
        $(this).hasClass("product-form__btn") && (timing = 3500),
        setTimeout(function () {
          fetch("/cart.js")
            .then((response) => response.json())
            .then((data) => {
              const cartItems = data.items;
              if (cartItems.length > 0) {
                const productRecommendationsSection = document.querySelector(
                  ".product-recommendations"
                );
                fetch(
                  window.Shopify.routes.root +
                    "recommendations/products?product_id=" +
                    cartItems[0].product_id +
                    "&section_id=product-recommendations&limit=10&intent=complementary"
                )
                  .then((response) => response.text())
                  .then((text) => {
                    const html = document.createElement("div");
                    html.innerHTML = text;
                    const recommendations = html.querySelector(
                      ".product-recommendations"
                    );
                    console.log(recommendations),
                      recommendations &&
                        recommendations.innerHTML.trim().length &&
                        (productRecommendationsSection.innerHTML =
                          recommendations.innerHTML);
                  });
              }
            });
        }, timing);
    });
    var swiper = new Swiper("#ys_menu_gallery_ul", {
        pagination: { el: ".swiper-pagination" },
        breakpoints: {
          0: { slidesPerView: 1, spaceBetween: 0 },
          481: { slidesPerView: 1, spaceBetween: 0 },
          786: { slidesPerView: 1, spaceBetween: 0 },
          1100: { slidesPerView: 1, spaceBetween: 0 },
        },
      }),
      swiper = new Swiper("#ys_menu_gallery_ul_women", {
        pagination: { el: ".swiper-pagination" },
        breakpoints: {
          0: { slidesPerView: 1, spaceBetween: 0 },
          481: { slidesPerView: 1, spaceBetween: 0 },
          786: { slidesPerView: 1, spaceBetween: 0 },
          1100: { slidesPerView: 1, spaceBetween: 0 },
        },
      });
    $(".glitch_logo_loader").length &&
      (setTimeout(function () {
        $(".glitch_logo_loader").fadeOut(600, function () {
          $(".glitch_logo_loader").remove();
        });
      }, 2e3),
      $(".glitch_logo_loader video").attr("muted", "false"));
  });
function darkModeVideoSession() {
  typeof Storage < "u" && localStorage.setItem("dark_logo_visibility", !0);
}
//# sourceMappingURL=/s/files/1/0763/8351/9023/t/12/assets/index.js.map?v=1728628308

if (!localStorage.getItem('userCheckInt2')) {
  $(document).ready(function () {
     const requestOptions = {
        method: "GET",
        redirect: "follow"
      };
    
    // Define the result handler function
      function processResult(result) {
        console.log("Geolocation Data New API:", result); // Log the result or process it further
        localStorage.setItem('userCheckInt2', result.country_code);
        if(result.country_code == "NZ" || result.country_code == "AU"){ window.location="https://www.fuaark.nz/"; }
      }
      
      // Main function to fetch geolocation data
      function fetchGeolocationData() {
        const apiKey = "BZaHsm5qPpmLD1ix";
        const url = `http://ipwhois.pro/?key=${apiKey}`;
      
        fetch(url)
          .then((response) => response.json()) // Process the response
          .then(processResult) // Call the result handler function
          .catch((error) => console.error("Error fetching geolocation data:", error)); // Handle errors
      }
      
      // Example usage
      fetchGeolocationData();
    
  });
}else{
  userint = localStorage.getItem('userCheckInt2');
  if(userint == "NZ" || userint == "AU"){ window.location="https://www.fuaark.nz/"; }
}


/**
 * jQuery.marquee - scrolling text like old marquee element
 * @author Aamir Afridi - aamirafridi(at)gmail(dot)com / http://aamirafridi.com/jquery/jquery-marquee-plugin
 */
(function($){$.fn.marquee=function(options){return this.each(function(){var o=$.extend({},$.fn.marquee.defaults,options),$this=$(this),$marqueeWrapper,containerWidth,animationCss,verticalDir,elWidth,loopCount=3,playState='animation-play-state',css3AnimationIsSupported=!1,_prefixedEvent=function(element,type,callback){var pfx=["webkit","moz","MS","o",""];for(var p=0;p<pfx.length;p++){if(!pfx[p])type=type.toLowerCase();element.addEventListener(pfx[p]+type,callback,!1)}},_objToString=function(obj){var tabjson=[];for(var p in obj){if(obj.hasOwnProperty(p)){tabjson.push(p+':'+obj[p])}}
tabjson.push();return'{'+tabjson.join(',')+'}'},_startAnimationWithDelay=function(){$this.timer=setTimeout(animate,o.delayBeforeStart)},methods={pause:function(){if(css3AnimationIsSupported&&o.allowCss3Support){$marqueeWrapper.css(playState,'paused')}else{if($.fn.pause){$marqueeWrapper.pause()}}
$this.data('runningStatus','paused');$this.trigger('paused')},resume:function(){if(css3AnimationIsSupported&&o.allowCss3Support){$marqueeWrapper.css(playState,'running')}else{if($.fn.resume){$marqueeWrapper.resume()}}
$this.data('runningStatus','resumed');$this.trigger('resumed')},toggle:function(){methods[$this.data('runningStatus')=='resumed'?'pause':'resume']()},destroy:function(){clearTimeout($this.timer);$this.find("*").addBack().off();$this.html($this.find('.js-marquee:first').html())}};if(typeof options==='string'){if($.isFunction(methods[options])){if(!$marqueeWrapper){$marqueeWrapper=$this.find('.js-marquee-wrapper')}
if($this.data('css3AnimationIsSupported')===!0){css3AnimationIsSupported=!0}
methods[options]()}
return}
var dataAttributes={},attr;$.each(o,function(key,value){attr=$this.attr('data-'+key);if(typeof attr!=='undefined'){switch(attr){case 'true':attr=!0;break;case 'false':attr=!1;break}
o[key]=attr}});if(o.speed){o.duration=parseInt($this.width(),10)/o.speed*1000}
verticalDir=o.direction=='up'||o.direction=='down';o.gap=o.duplicated?parseInt(o.gap):0;$this.wrapInner('<div class="js-marquee"></div>');var $el=$this.find('.js-marquee').css({'margin-right':o.gap,'float':'left'});if(o.duplicated){$el.clone(!0).appendTo($this)}
$this.wrapInner('<div style="width:100000px" class="js-marquee-wrapper"></div>');$marqueeWrapper=$this.find('.js-marquee-wrapper');if(verticalDir){var containerHeight=$this.height();$marqueeWrapper.removeAttr('style');$this.height(containerHeight);$this.find('.js-marquee').css({'float':'none','margin-bottom':o.gap,'margin-right':0});if(o.duplicated)$this.find('.js-marquee:last').css({'margin-bottom':0});var elHeight=$this.find('.js-marquee:first').height()+o.gap;if(o.startVisible&&!o.duplicated){o._completeDuration=((parseInt(elHeight,10)+parseInt(containerHeight,10))/parseInt(containerHeight,10))*o.duration;o.duration=(parseInt(elHeight,10)/parseInt(containerHeight,10))*o.duration}else{o.duration=((parseInt(elHeight,10)+parseInt(containerHeight,10))/parseInt(containerHeight,10))*o.duration}}else{elWidth=$this.find('.js-marquee:first').width()+o.gap;containerWidth=$this.width();if(o.startVisible&&!o.duplicated){o._completeDuration=((parseInt(elWidth,10)+parseInt(containerWidth,10))/parseInt(containerWidth,10))*o.duration;o.duration=(parseInt(elWidth,10)/parseInt(containerWidth,10))*o.duration}else{o.duration=((parseInt(elWidth,10)+parseInt(containerWidth,10))/parseInt(containerWidth,10))*o.duration}}
if(o.duplicated){o.duration=o.duration/2}
if(o.allowCss3Support){var
elm=document.body||document.createElement('div'),animationName='marqueeAnimation-'+Math.floor(Math.random()*10000000),domPrefixes='Webkit Moz O ms Khtml'.split(' '),animationString='animation',animationCss3Str='',keyframeString='';if(elm.style.animation!==undefined){keyframeString='@keyframes '+animationName+' ';css3AnimationIsSupported=!0}
if(css3AnimationIsSupported===!1){for(var i=0;i<domPrefixes.length;i++){if(elm.style[domPrefixes[i]+'AnimationName']!==undefined){var prefix='-'+domPrefixes[i].toLowerCase()+'-';animationString=prefix+animationString;playState=prefix+playState;keyframeString='@'+prefix+'keyframes '+animationName+' ';css3AnimationIsSupported=!0;break}}}
if(css3AnimationIsSupported){animationCss3Str=animationName+' '+o.duration/1000+'s '+o.delayBeforeStart/1000+'s infinite '+o.css3easing;$this.data('css3AnimationIsSupported',!0)}}
var _rePositionVertically=function(){$marqueeWrapper.css('transform','translateY('+(o.direction=='up'?containerHeight+'px':'-'+elHeight+'px')+')')},_rePositionHorizontally=function(){$marqueeWrapper.css('transform','translateX('+(o.direction=='left'?containerWidth+'px':'-'+elWidth+'px')+')')};if(o.duplicated){if(verticalDir){if(o.startVisible){$marqueeWrapper.css('transform','translateY(0)')}else{$marqueeWrapper.css('transform','translateY('+(o.direction=='up'?containerHeight+'px':'-'+((elHeight*2)-o.gap)+'px')+')')}}else{if(o.startVisible){$marqueeWrapper.css('transform','translateX(0)')}else{$marqueeWrapper.css('transform','translateX('+(o.direction=='left'?containerWidth+'px':'-'+((elWidth*2)-o.gap)+'px')+')')}}
if(!o.startVisible){loopCount=1}}else if(o.startVisible){loopCount=2}else{if(verticalDir){_rePositionVertically()}else{_rePositionHorizontally()}}
var animate=function(){if(o.duplicated){if(loopCount===1){o._originalDuration=o.duration;if(verticalDir){o.duration=o.direction=='up'?o.duration+(containerHeight/((elHeight)/o.duration)):o.duration*2}else{o.duration=o.direction=='left'?o.duration+(containerWidth/((elWidth)/o.duration)):o.duration*2}
if(animationCss3Str){animationCss3Str=animationName+' '+o.duration/1000+'s '+o.delayBeforeStart/1000+'s '+o.css3easing}
loopCount++}
else if(loopCount===2){o.duration=o._originalDuration;if(animationCss3Str){animationName=animationName+'0';keyframeString=$.trim(keyframeString)+'0 ';animationCss3Str=animationName+' '+o.duration/1000+'s 0s infinite '+o.css3easing}
loopCount++}}
if(verticalDir){if(o.duplicated){if(loopCount>2){$marqueeWrapper.css('transform','translateY('+(o.direction=='up'?0:'-'+elHeight+'px')+')')}
animationCss={'transform':'translateY('+(o.direction=='up'?'-'+elHeight+'px':0)+')'}}else if(o.startVisible){if(loopCount===2){if(animationCss3Str){animationCss3Str=animationName+' '+o.duration/1000+'s '+o.delayBeforeStart/1000+'s '+o.css3easing}
animationCss={'transform':'translateY('+(o.direction=='up'?'-'+elHeight+'px':containerHeight+'px')+')'};loopCount++}else if(loopCount===3){o.duration=o._completeDuration;if(animationCss3Str){animationName=animationName+'0';keyframeString=$.trim(keyframeString)+'0 ';animationCss3Str=animationName+' '+o.duration/1000+'s 0s infinite '+o.css3easing}
_rePositionVertically()}}else{_rePositionVertically();animationCss={'transform':'translateY('+(o.direction=='up'?'-'+($marqueeWrapper.height())+'px':containerHeight+'px')+')'}}}else{if(o.duplicated){if(loopCount>2){$marqueeWrapper.css('transform','translateX('+(o.direction=='left'?0:'-'+elWidth+'px')+')')}
animationCss={'transform':'translateX('+(o.direction=='left'?'-'+elWidth+'px':0)+')'}}else if(o.startVisible){if(loopCount===2){if(animationCss3Str){animationCss3Str=animationName+' '+o.duration/1000+'s '+o.delayBeforeStart/1000+'s '+o.css3easing}
animationCss={'transform':'translateX('+(o.direction=='left'?'-'+elWidth+'px':containerWidth+'px')+')'};loopCount++}else if(loopCount===3){o.duration=o._completeDuration;if(animationCss3Str){animationName=animationName+'0';keyframeString=$.trim(keyframeString)+'0 ';animationCss3Str=animationName+' '+o.duration/1000+'s 0s infinite '+o.css3easing}
_rePositionHorizontally()}}else{_rePositionHorizontally();animationCss={'transform':'translateX('+(o.direction=='left'?'-'+elWidth+'px':containerWidth+'px')+')'}}}
$this.trigger('beforeStarting');if(css3AnimationIsSupported){$marqueeWrapper.css(animationString,animationCss3Str);var keyframeCss=keyframeString+' { 100%  '+_objToString(animationCss)+'}',$styles=$marqueeWrapper.find('style');if($styles.length!==0){$styles.filter(":last").html(keyframeCss)}else{$('head').append('<style>'+keyframeCss+'</style>')}
_prefixedEvent($marqueeWrapper[0],"AnimationIteration",function(){$this.trigger('finished')});_prefixedEvent($marqueeWrapper[0],"AnimationEnd",function(){animate();$this.trigger('finished')})}else{$marqueeWrapper.animate(animationCss,o.duration,o.easing,function(){$this.trigger('finished');if(o.pauseOnCycle){_startAnimationWithDelay()}else{animate()}})}
$this.data('runningStatus','resumed')};$this.on('pause',methods.pause);$this.on('resume',methods.resume);if(o.pauseOnHover){$this.on('mouseenter',methods.pause);$this.on('mouseleave',methods.resume)}
if(css3AnimationIsSupported&&o.allowCss3Support){animate()}else{_startAnimationWithDelay()}})};$.fn.marquee.defaults={allowCss3Support:!0,css3easing:'linear',easing:'linear',delayBeforeStart:1000,direction:'left',duplicated:!1,duration:5000,speed:0,gap:20,pauseOnCycle:!1,pauseOnHover:!1,startVisible:!1}})(jQuery);


$(document).ready(function(){

  if ( $('.rotating_text').length ){
  $('.rotating_text').marquee({
            gap: 100,
            delayBeforeStart: 0,startVisible:true,
            direction: 'left',
            duplicated: true,
    speed: 50,
            pauseOnHover: true
        });;
  }
   if ( $('.rotating_text2').length ){
  $('.rotating_text2').marquee({
     
            gap: 50,
            delayBeforeStart: 0,startVisible:true,
            direction: 'left',
            duplicated: true,
    speed: 50,
            pauseOnHover: true
        });;
}
});

 /* custom filter fit on plp  js starts */
 $(document).ready(function () {
document.addEventListener('click', e=>{
  const btn = e.target.closest('.fit-toggle');
  if(!btn) return;
  const drop = btn.nextElementSibling;
  const expanded = btn.getAttribute('aria-expanded') === 'true';
  btn.setAttribute('aria-expanded', !expanded);
  drop.hidden = expanded;
});
if(document.getElementById('apply-fit-filter')){
document.getElementById('apply-fit-filter').addEventListener('click', function() {
  const checkboxes = document.querySelectorAll('.fit-filter:checked');
  const baseUrl = window.location.pathname; // current collection URL
  const params = new URLSearchParams();

  checkboxes.forEach(checkbox => {
    const value = checkbox.value;
    // Shopify metafield filter param for: custom.fit = filter.m.custom.fit
    params.append('filter.p.m.custom.fit', value);
  });

  const newUrl = baseUrl + '?' + params.toString();
  window.location.href = newUrl; // redirect to the filtered URL
});
}

                   
  });

 /* custom filter fit on plp  js ends */
/* Countdown Starts */
!(function (a) {
  "use strict";
  "function" == typeof define && define.amd ? define(["jquery"], a) : a(jQuery);
})(function (a) {
  "use strict";
  function b(a) {
    if (a instanceof Date) return a;
    if (String(a).match(g))
      return (
        String(a).match(/^[0-9]*$/) && (a = Number(a)),
        String(a).match(/\-/) && (a = String(a).replace(/\-/g, "/")),
        new Date(a)
      );
    throw new Error("Couldn't cast `" + a + "` to a date object.");
  }
  function c(a) {
    var b = a.toString().replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1");
    return new RegExp(b);
  }
  function d(a) {
    return function (b) {
      var d = b.match(/%(-|!)?[A-Z]{1}(:[^;]+;)?/gi);
      if (d)
        for (var f = 0, g = d.length; g > f; ++f) {
          var h = d[f].match(/%(-|!)?([a-zA-Z]{1})(:[^;]+;)?/),
            j = c(h[0]),
            k = h[1] || "",
            l = h[3] || "",
            m = null;
          (h = h[2]),
            i.hasOwnProperty(h) && ((m = i[h]), (m = Number(a[m]))),
            null !== m &&
              ("!" === k && (m = e(l, m)),
              "" === k && 10 > m && (m = "0" + m.toString()),
              (b = b.replace(j, m.toString())));
        }
      return (b = b.replace(/%%/, "%"));
    };
  }
  function e(a, b) {
    var c = "s",
      d = "";
    return (
      a &&
        ((a = a.replace(/(:|;|\s)/gi, "").split(/\,/)),
        1 === a.length ? (c = a[0]) : ((d = a[0]), (c = a[1]))),
      1 === Math.abs(b) ? d : c
    );
  }
  var f = [],
    g = [],
    h = { precision: 100, elapse: !1 };
  g.push(/^[0-9]*$/.source),
    g.push(/([0-9]{1,2}\/){2}[0-9]{4}( [0-9]{1,2}(:[0-9]{2}){2})?/.source),
    g.push(/[0-9]{4}([\/\-][0-9]{1,2}){2}( [0-9]{1,2}(:[0-9]{2}){2})?/.source),
    (g = new RegExp(g.join("|")));
  var i = {
      Y: "years",
      m: "months",
      n: "daysToMonth",
      w: "weeks",
      d: "daysToWeek",
      D: "totalDays",
      H: "hours",
      M: "minutes",
      S: "seconds",
    },
    j = function (b, c, d) {
      (this.el = b),
        (this.$el = a(b)),
        (this.interval = null),
        (this.offset = {}),
        (this.options = a.extend({}, h)),
        (this.instanceNumber = f.length),
        f.push(this),
        this.$el.data("countdown-instance", this.instanceNumber),
        d &&
          ("function" == typeof d
            ? (this.$el.on("update.countdown", d),
              this.$el.on("stoped.countdown", d),
              this.$el.on("finish.countdown", d))
            : (this.options = a.extend({}, h, d))),
        this.setFinalDate(c),
        this.start();
    };
  a.extend(j.prototype, {
    start: function () {
      null !== this.interval && clearInterval(this.interval);
      var a = this;
      this.update(),
        (this.interval = setInterval(function () {
          a.update.call(a);
        }, this.options.precision));
    },
    stop: function () {
      clearInterval(this.interval),
        (this.interval = null),
        this.dispatchEvent("stoped");
    },
    toggle: function () {
      this.interval ? this.stop() : this.start();
    },
    pause: function () {
      this.stop();
    },
    resume: function () {
      this.start();
    },
    remove: function () {
      this.stop.call(this),
        (f[this.instanceNumber] = null),
        delete this.$el.data().countdownInstance;
    },
    setFinalDate: function (a) {
      this.finalDate = b(a);
    },
    update: function () {
      if (0 === this.$el.closest("html").length) return void this.remove();
      var b,
        c = void 0 !== a._data(this.el, "events"),
        d = new Date();
      (b = this.finalDate.getTime() - d.getTime()),
        (b = Math.ceil(b / 1e3)),
        (b = !this.options.elapse && 0 > b ? 0 : Math.abs(b)),
        this.totalSecsLeft !== b &&
          c &&
          ((this.totalSecsLeft = b),
          (this.elapsed = d >= this.finalDate),
          (this.offset = {
            seconds: this.totalSecsLeft % 60,
            minutes: Math.floor(this.totalSecsLeft / 60) % 60,
            hours: Math.floor(this.totalSecsLeft / 60 / 60) % 24,
            days: Math.floor(this.totalSecsLeft / 60 / 60 / 24) % 7,
            daysToWeek: Math.floor(this.totalSecsLeft / 60 / 60 / 24) % 7,
            daysToMonth: Math.floor(
              (this.totalSecsLeft / 60 / 60 / 24) % 30.4368
            ),
            totalDays: Math.floor(this.totalSecsLeft / 60 / 60 / 24),
            weeks: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 7),
            months: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 30.4368),
            years: Math.abs(this.finalDate.getFullYear() - d.getFullYear()),
          }),
          this.options.elapse || 0 !== this.totalSecsLeft
            ? this.dispatchEvent("update")
            : (this.stop(), this.dispatchEvent("finish")));
    },
    dispatchEvent: function (b) {
      var c = a.Event(b + ".countdown");
      (c.finalDate = this.finalDate),
        (c.elapsed = this.elapsed),
        (c.offset = a.extend({}, this.offset)),
        (c.strftime = d(this.offset)),
        this.$el.trigger(c);
    },
  }),
    (a.fn.countdown = function () {
      var b = Array.prototype.slice.call(arguments, 0);
      return this.each(function () {
        var c = a(this).data("countdown-instance");
        if (void 0 !== c) {
          var d = f[c],
            e = b[0];
          j.prototype.hasOwnProperty(e)
            ? d[e].apply(d, b.slice(1))
            : null === String(e).match(/^[$A-Z_][0-9A-Z_$]*$/i)
            ? (d.setFinalDate.call(d, e), d.start())
            : a.error(
                "Method %s does not exist on jQuery.countdown".replace(
                  /\%s/gi,
                  e
                )
              );
        } else new j(this, b[0], b[1]);
      });
    });
});
console.log("countsdown inited");
 $(document).ready(function () {
    let ys_timer2 = 0;
        console.log($(".ys_timer2").length);
        $(".ys_timer2").each(function () {
            ys_timer2 = ys_timer2 + 1;
                $(this).attr("id", "ys_timer2_" + ys_timer2);
                timer2 = $(this).attr("data-time");
                console.log("darsh "+timer2),
                $("#ys_timer2_" + ys_timer2).countdown(timer2, function (event) {
                    $(this).html(event.strftime(' <span><span class="digit">%D</span><br>Days</span> <span><span class="digit">%H</span><br>Hours</span> <span><span class="digit">%M</span><br>Mins</span> <span><span class="digit">%S</span><br>Sec</span> '));
                });
        });
});